
import { dataListsType } from "../shared/type";

export const GoogleStores: dataListsType[] =
[
  {
    "id": 1,
    "title": "Trading Card Shop YK 秋葉原店",
    "urlinform": "trading-card-shop-yk-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/akiba_yk",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnzD9QW-NGGAR_iP_SejV-fs",
    "lat": 35.7005893,
    "lng": 139.7693912,
    "placeId": "ChIJnzD9QW-NGGAR_iP_SejV-fs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2460,
    "district": "Akihabara"
  },
  {
    "id": 2,
    "title": "Poké Town",
    "urlinform": "store-3",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/poketown_akiba",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcZh1pYaNGGARRZ1EKS3Hhao",
    "lat": 35.6974154,
    "lng": 139.7726721,
    "placeId": "ChIJcZh1pYaNGGARRZ1EKS3Hhao",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 4:00 PM, 5:30 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 469,
    "district": "Akihabara"
  },
  {
    "id": 3,
    "title": "Akihabara Pokémon Cards, One Piece & Figure Shop - HOBBY SHOP ANKOU",
    "urlinform": "akihabara-pokmon-cards-one-piece-figure-shop-hobby-shop-ankou",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://online.emeraude.shop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN3WIJACPGGARKBoPgkgT4w4",
    "lat": 35.7020082,
    "lng": 139.7731552,
    "placeId": "ChIJN3WIJACPGGARKBoPgkgT4w4",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3526-2113",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 101,
    "district": "Akihabara"
  },
  {
    "id": 4,
    "title": "PDG collector's shop 秋葉原本店",
    "urlinform": "pdg-collectors-shop-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/PDGcollectors",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJkx7w2meNGGARi1CYkUTn_yw",
    "lat": 35.7017683,
    "lng": 139.7713481,
    "placeId": "ChIJkx7w2meNGGARi1CYkUTn_yw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 356,
    "district": "Akihabara"
  },
  {
    "id": 5,
    "title": "TCG GATE トレカゲート 秋葉原本店｜ポケモンカード専門店",
    "urlinform": "tcg-gate-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.tcg-gate.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsajlOEmNGGARTv_QnuHTuNM",
    "lat": 35.7025971,
    "lng": 139.7720178,
    "placeId": "ChIJsajlOEmNGGARTv_QnuHTuNM",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3525-7548",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 999,
    "district": "Akihabara"
  },
  {
    "id": 6,
    "title": "ポケモンカード専門店MERO 秋葉原",
    "urlinform": "mero-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://x.com/mero_akihabara?s=21&t=n9B3E6XKitvWUt5vivkDxg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhaubiHONGGAREYxKBe8-4Pw",
    "lat": 35.6981581,
    "lng": 139.7708442,
    "placeId": "ChIJhaubiHONGGAREYxKBe8-4Pw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 38,
    "district": "Akihabara"
  },
  {
    "id": 7,
    "title": "シンソク秋葉原本店",
    "urlinform": "store-8",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.cardshop-shinsoku.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxwhrNwiNGGARt0JnfPWFRvk",
    "lat": 35.7025683,
    "lng": 139.7713994,
    "placeId": "ChIJxwhrNwiNGGARt0JnfPWFRvk",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6826-2333",
    "openingHours": [
      "Monday: 12:30 – 8:30 PM",
      "Tuesday: 12:30 – 8:30 PM",
      "Wednesday: 12:30 – 8:30 PM",
      "Thursday: 12:30 – 8:30 PM",
      "Friday: 12:30 – 8:30 PM",
      "Saturday: 12:30 – 8:30 PM",
      "Sunday: 12:30 – 8:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 730,
    "district": "Akihabara"
  },
  {
    "id": 8,
    "title": "VALUABLE CARD TOKYO 秋葉原",
    "urlinform": "valuable-card-tokyo-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.valuablecard.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqxPzELWNGGAR9yrS7MFDp18",
    "lat": 35.6991361,
    "lng": 139.7702929,
    "placeId": "ChIJqxPzELWNGGAR9yrS7MFDp18",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 837,
    "district": "Akihabara"
  },
  {
    "id": 9,
    "title": "TCG LOUNGE 秋葉原",
    "urlinform": "tcg-lounge-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/torecalounge",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7WX8n_uNGGARNhFF5A6yvig",
    "lat": 35.703395,
    "lng": 139.772103,
    "placeId": "ChIJ7WX8n_uNGGARNhFF5A6yvig",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5846-8576",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 819,
    "district": "Akihabara"
  },
  {
    "id": 10,
    "title": "ポケモンカード専門店 ポケ堂 秋葉原店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://x.com/pokedou_akiba?s=21&t=A9ky9NfqfZNqL4e4k9zIUg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ98jSKACNGGAR-N-8zGLOYZg",
    "lat": 35.6981581,
    "lng": 139.7708442,
    "placeId": "ChIJ98jSKACNGGAR-N-8zGLOYZg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 31,
    "district": "Akihabara"
  },
  {
    "id": 11,
    "title": "Torecaru Akihabara Station Store",
    "urlinform": "store-12",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/torecaru_akiba",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpbmpv9GNGGARwdCIP47dyOM",
    "lat": 35.698859,
    "lng": 139.7715223,
    "placeId": "ChIJpbmpv9GNGGARwdCIP47dyOM",
    "businessStatus": "OPERATIONAL",
    "phone": "080-7800-7344",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 408,
    "district": "Akihabara"
  },
  {
    "id": 12,
    "title": "カードコレクト秋葉原 -CHIKA-",
    "urlinform": "store-13",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "WS"
    ],
    "storeWebsite": "https://www.cardcollect.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnX8HaQCNGGARLulZCONu5C4",
    "lat": 35.6981628,
    "lng": 139.7709814,
    "placeId": "ChIJnX8HaQCNGGARLulZCONu5C4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 7:30 PM",
      "Tuesday: 12:00 – 7:30 PM",
      "Wednesday: 12:00 – 7:30 PM",
      "Thursday: 12:00 – 7:30 PM",
      "Friday: 12:00 – 7:30 PM",
      "Saturday: 12:00 – 7:30 PM",
      "Sunday: 12:00 – 7:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 834,
    "district": "Akihabara"
  },
  {
    "id": 13,
    "title": "Trekamall Akihabara 1",
    "urlinform": "1",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/toreca_maall",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE42FKgCNGGARwpTW5HF2asE",
    "lat": 35.6981581,
    "lng": 139.7708442,
    "placeId": "ChIJE42FKgCNGGARwpTW5HF2asE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:30 AM – 7:30 PM",
      "Tuesday: 11:30 AM – 7:30 PM",
      "Wednesday: 11:30 AM – 7:30 PM",
      "Thursday: 11:30 AM – 7:30 PM",
      "Friday: 11:30 AM – 7:30 PM",
      "Saturday: 11:30 AM – 7:30 PM",
      "Sunday: 11:30 AM – 7:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 623,
    "district": "Akihabara"
  },
  {
    "id": 14,
    "title": "SNKRDUNK TCG AKIHABARA(スニダントレカ秋葉原店)",
    "urlinform": "snkrdunk-tcg-akihabara",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Gundam",
      "MTG",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://snkrdunk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXy_sDZmNGGARG7yMIDHDAtU",
    "lat": 35.698336,
    "lng": 139.7715973,
    "placeId": "ChIJXy_sDZmNGGARG7yMIDHDAtU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 1364,
    "district": "Akihabara"
  },
  {
    "id": 15,
    "title": "ポプサン商会-秋葉原店-akihabara,pokemoncard.lorcanaTCG.gandamTCG",
    "urlinform": "-akihabarapokemoncardlorcanatcggandamtcg",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Lorcana",
      "Pokémon"
    ],
    "storeWebsite": "https://twitter.com/popsan_akb?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJO2dnHweNGGARb8u0b3RNNe0",
    "lat": 35.7019471,
    "lng": 139.7731419,
    "placeId": "ChIJO2dnHweNGGARb8u0b3RNNe0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 PM – 12:00 AM",
      "Tuesday: 3:00 PM – 12:00 AM",
      "Wednesday: 3:00 PM – 12:00 AM",
      "Thursday: 3:00 PM – 12:00 AM",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 3:00 PM – 12:00 AM",
      "Sunday: 3:00 PM – 12:00 AM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 37,
    "district": "Akihabara"
  },
  {
    "id": 16,
    "title": "カードコレクト秋葉原 -HANARE-",
    "urlinform": "-hanare-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "WS"
    ],
    "storeWebsite": "https://cardcollect.jp/?srsltid=AfmBOopUAi6TMHa6m2nWOWY2VK4oj-TQFfaKVmYBmOdO--8u0YXLtjsc",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8wLH8mSNGGARaISsrouir4o",
    "lat": 35.7010496,
    "lng": 139.7704123,
    "placeId": "ChIJ8wLH8mSNGGARaISsrouir4o",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1225,
    "district": "Akihabara"
  },
  {
    "id": 17,
    "title": "TCG FULL HOUSE 秋葉原店",
    "urlinform": "tcg-full-house-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/tcg_fullhouse",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7XP1QVGNGGARa-9gtuudAGI",
    "lat": 35.7033838,
    "lng": 139.7711292,
    "placeId": "ChIJ7XP1QVGNGGARa-9gtuudAGI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 143,
    "district": "Akihabara"
  },
  {
    "id": 18,
    "title": "Hareruya 2",
    "urlinform": "2-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.hareruya2.com/pages/store_tower",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2w8GD8uNGGAR_5PysntyJYs",
    "lat": 35.6980483,
    "lng": 139.7707423,
    "placeId": "ChIJ2w8GD8uNGGAR_5PysntyJYs",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6285-2830",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 1023,
    "district": "Akihabara"
  },
  {
    "id": 19,
    "title": "Toreca Himitsukichi",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://www.tcsb.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi7xKMDuNGGARH70WPUomnS4",
    "lat": 35.7020993,
    "lng": 139.7724737,
    "placeId": "ChIJi7xKMDuNGGARH70WPUomnS4",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5296-9081",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 124,
    "district": "Akihabara"
  },
  {
    "id": 20,
    "title": "トレカポケットセンターAKIHABARA",
    "urlinform": "akihabara",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://youtu.be/P5XchHyfBAA",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZUFv3XKNGGAR6eQLoGx02Rc",
    "lat": 35.7022753,
    "lng": 139.7713381,
    "placeId": "ChIJZUFv3XKNGGAR6eQLoGx02Rc",
    "businessStatus": "OPERATIONAL",
    "phone": "050-1808-7913",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 63,
    "district": "Akihabara"
  },
  {
    "id": 21,
    "title": "otachu.akihabara5th trading card game store",
    "urlinform": "5gogo",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://otachu-akiba.com/1gocard/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDbz_KhONGGARa-m7d2QVIbo",
    "lat": 35.7016469,
    "lng": 139.7706651,
    "placeId": "ChIJDbz_KhONGGARa-m7d2QVIbo",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3525-4530",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 430,
    "district": "Akihabara"
  },
  {
    "id": 22,
    "title": "CARD WINGS",
    "urlinform": "card-wings",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Digimon",
      "Gundam",
      "One Piece",
      "Union Arena",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://card-wings.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhbVrTh2MGGARdTGhPnlVq9g",
    "lat": 35.697825,
    "lng": 139.7721578,
    "placeId": "ChIJhbVrTh2MGGARdTGhPnlVq9g",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3526-2340",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 277,
    "district": "Akihabara"
  },
  {
    "id": 23,
    "title": "Card Kingdom",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/ck_akihabara",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJS6eXQB2MGGARuQjhIJg1NPI",
    "lat": 35.6983495,
    "lng": 139.7718269,
    "placeId": "ChIJS6eXQB2MGGARuQjhIJg1NPI",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6206-9232",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 421,
    "district": "Akihabara"
  },
  {
    "id": 24,
    "title": "TORECAMAALL Akihabara 2nd Store",
    "urlinform": "store-26",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTdqEKOKNGGARUWHDT1Re7DQ",
    "lat": 35.6980517,
    "lng": 139.7715378,
    "placeId": "ChIJTdqEKOKNGGARUWHDT1Re7DQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 86,
    "district": "Akihabara"
  },
  {
    "id": 25,
    "title": "福福トレカ秋葉原コレクションカード専門店",
    "urlinform": "store-27",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://fukufukutoreka.com/description_detail_collection_shop",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTekwaB2NGGAR58pIdJowY14",
    "lat": 35.6993045,
    "lng": 139.770439,
    "placeId": "ChIJTekwaB2NGGAR58pIdJowY14",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3527-1210",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 225,
    "district": "Akihabara"
  },
  {
    "id": 26,
    "title": "Grand Panda Canyon Akihabara",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Gundam",
      "One Piece",
      "Shadowverse",
      "Vanguard",
      "WS"
    ],
    "storeWebsite": "http://gurapan.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi89Swx2MGGARuVZFtJ7Ic6g",
    "lat": 35.7011811,
    "lng": 139.7712852,
    "placeId": "ChIJi89Swx2MGGARuVZFtJ7Ic6g",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6206-8689",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 126,
    "district": "Akihabara"
  },
  {
    "id": 27,
    "title": "Trading Card Shop YK 秋葉原2号店",
    "urlinform": "trading-card-shop-yk-2",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/akiba_yk2",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJywadLNqNGGAR6vYL7jR5Zvk",
    "lat": 35.7019757,
    "lng": 139.7720106,
    "placeId": "ChIJywadLNqNGGAR6vYL7jR5Zvk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 531,
    "district": "Akihabara"
  },
  {
    "id": 28,
    "title": "Card Shop Clove Base",
    "urlinform": "-clove-base-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://clovebase.clove.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJRaRGxaPGGARoD3dqDgEarU",
    "lat": 35.6979049,
    "lng": 139.7742137,
    "placeId": "ChIJJRaRGxaPGGARoD3dqDgEarU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 290,
    "district": "Akihabara"
  },
  {
    "id": 29,
    "title": "Card shop spiral",
    "urlinform": "shop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Gundam",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.card-spiral.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE9Xrfx6MGGARv8pL_KJ4N-Q",
    "lat": 35.7015485,
    "lng": 139.7704363,
    "placeId": "ChIJE9Xrfx6MGGARv8pL_KJ4N-Q",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3255-0020",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 172,
    "district": "Akihabara"
  },
  {
    "id": 30,
    "title": "トレカショップOneTies",
    "urlinform": "oneties",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "https://oneties-japan.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8e2CS2-PGGARAXdLfQPb_vE",
    "lat": 35.6960718,
    "lng": 139.7742936,
    "placeId": "ChIJ8e2CS2-PGGARAXdLfQPb_vE",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9206-4676",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 22,
    "district": "Nakasu"
  },
  {
    "id": 31,
    "title": "オリパーク秋葉原店",
    "urlinform": "store-33",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/oripa_toreka",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB3CAlLmNGGARHAAfGE-HOJg",
    "lat": 35.6981581,
    "lng": 139.7708442,
    "placeId": "ChIJB3CAlLmNGGARHAAfGE-HOJg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 104,
    "district": "Akihabara"
  },
  {
    "id": 32,
    "title": "Akiba-Hobby",
    "urlinform": "akiba-hobby-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://shop.akbh.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFTciuB2MGGARPrlTDDFlTUc",
    "lat": 35.7013951,
    "lng": 139.7712522,
    "placeId": "ChIJFTciuB2MGGARPrlTDDFlTUc",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6206-8215",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 409,
    "district": "Akihabara"
  },
  {
    "id": 33,
    "title": "Fukufuku",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "Shadowverse",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://fukufukutoreka.com/description_detail_akihabara_radio",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpT3sDEiNGGARAsutq5oJB9M",
    "lat": 35.6978895,
    "lng": 139.7719412,
    "placeId": "ChIJpT3sDEiNGGARAsutq5oJB9M",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5207-2850",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 388,
    "district": "Akihabara"
  },
  {
    "id": 34,
    "title": "福福トレカ秋葉原店",
    "urlinform": "store-37",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "Shadowverse",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://fukufukutoreka.com/description_detail_akihabara",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQdTm9GeNGGARLjaBMrHC0Po",
    "lat": 35.6988945,
    "lng": 139.7704195,
    "placeId": "ChIJQdTm9GeNGGARLjaBMrHC0Po",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6206-8472",
    "openingHours": [
      "Monday: 1:00 – 8:45 PM",
      "Tuesday: 1:00 – 8:45 PM",
      "Wednesday: 1:00 – 8:45 PM",
      "Thursday: 1:00 – 8:45 PM",
      "Friday: 1:00 – 8:45 PM",
      "Saturday: 10:00 AM – 8:45 PM",
      "Sunday: 10:00 AM – 8:45 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 718,
    "district": "Akihabara"
  },
  {
    "id": 35,
    "title": "BIGMAGIC 秋葉原店",
    "urlinform": "bigmagic-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://mtg.bigweb.co.jp/shop/akihabara",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb9I2Tx2MGGARahqu5ta_r7w",
    "lat": 35.6979149,
    "lng": 139.7719571,
    "placeId": "ChIJb9I2Tx2MGGARahqu5ta_r7w",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3526-2667",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 301,
    "district": "Akihabara"
  },
  {
    "id": 36,
    "title": "Azumaya",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Flesh and Blood",
      "Lorcana",
      "MTG"
    ],
    "storeWebsite": "https://azumayamtg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD48yRxmNGGARDWv0s2hHmCQ",
    "lat": 35.6996847,
    "lng": 139.7694343,
    "placeId": "ChIJD48yRxmNGGARDWv0s2hHmCQ",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6260-8545",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 65,
    "district": "Akihabara"
  },
  {
    "id": 37,
    "title": "福福トレカ秋葉原遊戯王コレクション専門店",
    "urlinform": "store-40",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://fukufukutoreka.com/description_detail_yugioh_collection",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3W1EKHKNGGAR33JMjuilEAQ",
    "lat": 35.6993045,
    "lng": 139.770439,
    "placeId": "ChIJ3W1EKHKNGGAR33JMjuilEAQ",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6206-0085",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 407,
    "district": "Akihabara"
  },
  {
    "id": 38,
    "title": "trading card shop NEO",
    "urlinform": "trading-card-shop-neo",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHdCrB-ONGGARewJnPDgeIBo",
    "lat": 35.7015537,
    "lng": 139.769471,
    "placeId": "ChIJHdCrB-ONGGARewJnPDgeIBo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 258,
    "district": "Akihabara"
  },
  {
    "id": 39,
    "title": "カードショップあるぱか",
    "urlinform": "store-42",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/cardshop_alpaca",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMVjPxHCNGGARWaw9mtdXSbw",
    "lat": 35.6991297,
    "lng": 139.7687952,
    "placeId": "ChIJMVjPxHCNGGARWaw9mtdXSbw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 355,
    "district": "Akihabara"
  },
  {
    "id": 40,
    "title": "カードショップ トレカブレイク 6F",
    "urlinform": "-6f",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/torekabreak?s=11&t=lM9ZWyCxkuUbF-hxu_1qog",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC7ARqRiNGGARNFtW_AuXoVQ",
    "lat": 35.6972918,
    "lng": 139.7727033,
    "placeId": "ChIJC7ARqRiNGGARNFtW_AuXoVQ",
    "businessStatus": "OPERATIONAL",
    "phone": "070-3276-8778",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 57,
    "district": "Akihabara"
  },
  {
    "id": 41,
    "title": "トレカ大明神 秋葉原 ポケモンカード買取店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.tcdaimyoujin.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDwC2zMaNGGARAc6VYbFVXxA",
    "lat": 35.7007815,
    "lng": 139.7686155,
    "placeId": "ChIJDwC2zMaNGGARAc6VYbFVXxA",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3525-7481",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: Closed",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 23,
    "district": "Akihabara"
  },
  {
    "id": 42,
    "title": "Ryusei no Arashi",
    "urlinform": "store-45",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/arashitokyo7",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgWdq_jSNGGARCbwYUBT1SAg",
    "lat": 35.6889823,
    "lng": 139.6986342,
    "placeId": "ChIJgWdq_jSNGGARCbwYUBT1SAg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 9:55 PM",
      "Tuesday: 12:00 – 9:55 PM",
      "Wednesday: 12:00 – 9:55 PM",
      "Thursday: 12:00 – 9:55 PM",
      "Friday: 12:00 – 9:55 PM",
      "Saturday: 10:00 AM – 9:55 PM",
      "Sunday: 10:00 AM – 9:55 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 775,
    "district": "Shinjuku"
  },
  {
    "id": 43,
    "title": "トレカガレージ 新宿南口店｜Trading Card Shop",
    "urlinform": "-trading-card-shop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://toregare.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQ-gSS7WNGGARmBJ2ZO6re4M",
    "lat": 35.6886544,
    "lng": 139.6983524,
    "placeId": "ChIJQ-gSS7WNGGARmBJ2ZO6re4M",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6279-4785",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 218,
    "district": "Shinjuku"
  },
  {
    "id": 44,
    "title": "シンソク新宿店",
    "urlinform": "store-47",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.cardshop-shinsoku.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWS442J-NGGARJQ1-26vbias",
    "lat": 35.6888857,
    "lng": 139.6983466,
    "placeId": "ChIJWS442J-NGGARJQ1-26vbias",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6825-2236",
    "openingHours": [
      "Monday: 12:00 – 8:30 PM",
      "Tuesday: 12:00 – 8:30 PM",
      "Wednesday: 12:00 – 8:30 PM",
      "Thursday: 12:00 – 8:30 PM",
      "Friday: 12:00 – 8:30 PM",
      "Saturday: 12:00 – 8:30 PM",
      "Sunday: 12:00 – 8:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1429,
    "district": "Shinjuku"
  },
  {
    "id": 45,
    "title": "福福トレカ池袋ポケモンカード専門店【本館】",
    "urlinform": "store-48",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://fukufukutoreka.com/user_data/description_detail_ikebukuronew",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7TiOEqONGGARLQdnawTZks8",
    "lat": 35.7296402,
    "lng": 139.7160371,
    "placeId": "ChIJ7TiOEqONGGARLQdnawTZks8",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6912-6602",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 235,
    "district": "Ikebukuro"
  },
  {
    "id": 46,
    "title": "MTG Salon Tokyo",
    "urlinform": "mtg-salon-tokyo",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Digimon",
      "Flesh and Blood",
      "Lorcana",
      "MTG",
      "WS"
    ],
    "storeWebsite": "http://mtgsalon.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBfo-XKuNGGARHZOWVs5ZbN0",
    "lat": 35.6887054,
    "lng": 139.6973098,
    "placeId": "ChIJBfo-XKuNGGARHZOWVs5ZbN0",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6258-1257",
    "openingHours": [
      "Monday: 2:15 – 8:45 PM",
      "Tuesday: 2:15 – 8:45 PM",
      "Wednesday: 2:15 – 8:45 PM",
      "Thursday: 2:15 – 8:45 PM",
      "Friday: 2:15 – 8:45 PM",
      "Saturday: 12:15 – 8:45 PM",
      "Sunday: 12:15 – 7:45 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 394,
    "district": "Shinjuku"
  },
  {
    "id": 47,
    "title": "Amenities Dream Shinjuku",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://amenitydream.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9231tdeMGGARldxEDurJVec",
    "lat": 35.6946664,
    "lng": 139.6990874,
    "placeId": "ChIJ9231tdeMGGARldxEDurJVec",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5330-3033",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 238,
    "district": "Shinjuku"
  },
  {
    "id": 48,
    "title": "Torecaru Shibuya Store",
    "urlinform": "store-52",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/torecaru_SBY",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJe4SRobeNGGARoytVMv2N-9s",
    "lat": 35.6600291,
    "lng": 139.6995593,
    "placeId": "ChIJe4SRobeNGGARoytVMv2N-9s",
    "businessStatus": "OPERATIONAL",
    "phone": "070-8458-6496",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 438,
    "district": "Shibuya"
  },
  {
    "id": 49,
    "title": "トレカマーケットオンリーワン新宿東南口店TAX FREE treca market only one",
    "urlinform": "tax-free-treca-market-only-one",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.torecaonlyone-shop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUS6Z1y-NGGARPRgeWNBCxBQ",
    "lat": 35.6897786,
    "lng": 139.7023954,
    "placeId": "ChIJUS6Z1y-NGGARPRgeWNBCxBQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 108,
    "district": "Shinjuku"
  },
  {
    "id": 50,
    "title": "トレカアビス新宿店",
    "urlinform": "store-54",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo9jr9nqNGGARG31Gm4I0D40",
    "lat": 35.6944776,
    "lng": 139.6990748,
    "placeId": "ChIJo9jr9nqNGGARG31Gm4I0D40",
    "businessStatus": "CLOSED_TEMPORARILY",
    "phone": "",
    "openingHours": [],
    "rating": 4.8,
    "userRatingsTotal": 206,
    "district": "Shinjuku"
  },
  {
    "id": 51,
    "title": "magi",
    "urlinform": "magi-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardshopmagi.com/shop/magi-shinjukuwest/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh0XnDaKNGGARLjWi9gctqpU",
    "lat": 35.6882637,
    "lng": 139.6989312,
    "placeId": "ChIJh0XnDaKNGGARLjWi9gctqpU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 61,
    "district": "Shinjuku"
  },
  {
    "id": 52,
    "title": "PDG collector's shop 池袋",
    "urlinform": "pdg-collectors-shop-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpROiMO-NGGAR5BBpT7Cl5h4",
    "lat": 35.7297874,
    "lng": 139.7160179,
    "placeId": "ChIJpROiMO-NGGAR5BBpT7Cl5h4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 446,
    "district": "Ikebukuro"
  },
  {
    "id": 53,
    "title": "MINT SHINJUKU Sports cards & Card games shop",
    "urlinform": "mint-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://www.mint-web.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJH2PYJ9qMGGARcUrrMku1LjU",
    "lat": 35.6902193,
    "lng": 139.7058373,
    "placeId": "ChIJH2PYJ9qMGGARcUrrMku1LjU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3356-7500",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 10:30 AM – 8:00 PM",
      "Sunday: 10:30 AM – 8:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 136,
    "district": "Shinjuku"
  },
  {
    "id": 54,
    "title": "トレカCROWN",
    "urlinform": "crown",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/tcg_shopCROWN",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJp0bNhy2NGGARP5Imy7xHJac",
    "lat": 35.6989614,
    "lng": 139.6970106,
    "placeId": "ChIJp0bNhy2NGGARP5Imy7xHJac",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 106
  },
  {
    "id": 55,
    "title": "Hareruya Tournament Center Tokyo",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://www.hareruyamtg.com/jp/store/tc_top.aspx",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJV072iDeNGGARHWXbvXN9Jzw",
    "lat": 35.7133344,
    "lng": 139.7012289,
    "placeId": "ChIJV072iDeNGGARHWXbvXN9Jzw",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5332-7544",
    "openingHours": [
      "Monday: 9:00 AM – 11:00 PM",
      "Tuesday: 9:00 AM – 11:00 PM",
      "Wednesday: 9:00 AM – 11:00 PM",
      "Thursday: 9:00 AM – 11:00 PM",
      "Friday: 9:00 AM – 11:00 PM",
      "Saturday: 9:00 AM – 11:00 PM",
      "Sunday: 9:00 AM – 11:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 882
  },
  {
    "id": 56,
    "title": "わくわくトレカ",
    "urlinform": "store-61",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/wakuwaku_toreka?s=21",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrciJSqaNGGARCkFRF318A2c",
    "lat": 35.6899677,
    "lng": 139.7101927,
    "placeId": "ChIJrciJSqaNGGARCkFRF318A2c",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 7:00 PM",
      "Wednesday: 2:00 – 7:00 PM",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: 2:00 – 7:00 PM",
      "Sunday: 2:00 – 7:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 32,
    "district": "Shinjuku"
  },
  {
    "id": 57,
    "title": "Pokemon Center Shibuya",
    "urlinform": "store-62",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/shibuya/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ313pNISNGGARmnrx-nT6xR4",
    "lat": 35.6619557,
    "lng": 139.6984408,
    "placeId": "ChIJ313pNISNGGARmnrx-nT6xR4",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5422-3522",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 2967,
    "district": "Shibuya"
  },
  {
    "id": 58,
    "title": "ラッキートレカ渋谷本店",
    "urlinform": "store-63",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://luckytoreca.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrZFxQsOLGGAR_BPzPgdxGlw",
    "lat": 35.662543,
    "lng": 139.6976189,
    "placeId": "ChIJrZFxQsOLGGAR_BPzPgdxGlw",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6824-2009",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 276,
    "district": "Shibuya"
  },
  {
    "id": 59,
    "title": "Full Comp",
    "urlinform": "store-64",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://inspire-jp.net/fc-shinjuku/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJI_w8qNGMGGARGBd5q1dAn1E",
    "lat": 35.6886103,
    "lng": 139.6982487,
    "placeId": "ChIJI_w8qNGMGGARGBd5q1dAn1E",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5320-2652",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 2.4,
    "userRatingsTotal": 160,
    "district": "Shinjuku"
  },
  {
    "id": 60,
    "title": "ONE PIECE BASE SHOP（ワンピースベースショップ）",
    "urlinform": "one-piece-base-shop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "https://baseshop.onepiece-base.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD_gmddmNGGARxEm6P0VtVBY",
    "lat": 35.6909029,
    "lng": 139.7040704,
    "placeId": "ChIJD_gmddmNGGARxEm6P0VtVBY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.4,
    "userRatingsTotal": 276,
    "district": "Shinjuku"
  },
  {
    "id": 61,
    "title": "Nukenin",
    "urlinform": "store-67",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://nukeninmtg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHZUAGfyNGGARhRmi_9xJc88",
    "lat": 35.7131989,
    "lng": 139.7015554,
    "placeId": "ChIJHZUAGfyNGGARhRmi_9xJc88",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6279-1453",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 59
  },
  {
    "id": 62,
    "title": "Onehappy",
    "urlinform": "store-68",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Union Arena",
      "Vanguard"
    ],
    "storeWebsite": "http://www.onehappy.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDZNKrlONGGARaKCMDWF3jxw",
    "lat": 35.7139479,
    "lng": 139.7036024,
    "placeId": "ChIJDZNKrlONGGARaKCMDWF3jxw",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5937-6123",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 20
  },
  {
    "id": 63,
    "title": "ONE PIECE MUGIWARA STORE HARAJUKU",
    "urlinform": "one-piece-mugiwara-store-harajuku",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "https://www.mugiwara-store.com/store/9131",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-w0OPQCNGGAR4dU3sC7KHtc",
    "lat": 35.66836929999999,
    "lng": 139.7049141,
    "placeId": "ChIJ-w0OPQCNGGAR4dU3sC7KHtc",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5962-7231",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 195
  },
  {
    "id": 64,
    "title": "JAPAN MART Ureshii",
    "urlinform": "japan-mart-ureshii",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP-H660iNGGARc-jrU5sA5-U",
    "lat": 35.6948108,
    "lng": 139.689912,
    "placeId": "ChIJP-H660iNGGARc-jrU5sA5-U",
    "businessStatus": "OPERATIONAL",
    "phone": "090-9242-0110",
    "openingHours": [
      "Monday: 11:00 AM – 5:00 PM",
      "Tuesday: 11:00 AM – 5:00 PM",
      "Wednesday: 11:00 AM – 5:00 PM",
      "Thursday: 11:00 AM – 5:00 PM",
      "Friday: 11:00 AM – 5:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4,
    "userRatingsTotal": 23
  },
  {
    "id": 65,
    "title": "トレカビンクス池袋店",
    "urlinform": "tcg-binks",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "https://torecabinks.ocnk.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpcDZQQSNGGAR0C2scykHdLU",
    "lat": 35.7291008,
    "lng": 139.7154512,
    "placeId": "ChIJpcDZQQSNGGAR0C2scykHdLU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6161-6330",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 730,
    "district": "Ikebukuro"
  },
  {
    "id": 66,
    "title": "コーギーアール池袋店",
    "urlinform": "corgi-r-ikebukuro",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.corgi-r-holdings.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSQMEBiqNGGARV7yrWtSCaiE",
    "lat": 35.7318427,
    "lng": 139.7146935,
    "placeId": "ChIJSQMEBiqNGGARV7yrWtSCaiE",
    "businessStatus": "OPERATIONAL",
    "phone": "070-1519-0024",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 949,
    "district": "Ikebukuro"
  },
  {
    "id": 67,
    "title": "ポケモンカード専門店 MERO 渋谷",
    "urlinform": "-mero-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://x.com/mero_sibuya?s=21",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEePyzyqNGGARgda5pDU7wBE",
    "lat": 35.6626376,
    "lng": 139.7010189,
    "placeId": "ChIJEePyzyqNGGARgda5pDU7wBE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 7:00 PM",
      "Tuesday: 10:30 AM – 7:00 PM",
      "Wednesday: 10:30 AM – 7:00 PM",
      "Thursday: 10:30 AM – 7:00 PM",
      "Friday: 10:30 AM – 7:00 PM",
      "Saturday: 10:30 AM – 7:00 PM",
      "Sunday: 10:30 AM – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 218,
    "district": "Shibuya"
  },
  {
    "id": 68,
    "title": "LAMB",
    "urlinform": "store-74",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.lamb-pokemon.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMYRKWQyNGGARg2zBljx_hGQ",
    "lat": 35.7305199,
    "lng": 139.7134747,
    "placeId": "ChIJMYRKWQyNGGARg2zBljx_hGQ",
    "businessStatus": "OPERATIONAL",
    "phone": "03-4500-5397",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 395,
    "district": "Ikebukuro"
  },
  {
    "id": 69,
    "title": "Batoloco Tournament Center Takadanobaba",
    "urlinform": "store-75",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://bato-loco.com/1804info",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVVW5MziNGGARznaS7RVda-M",
    "lat": 35.7133282,
    "lng": 139.7022076,
    "placeId": "ChIJVVW5MziNGGARznaS7RVda-M",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6894-6100",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 1771
  },
  {
    "id": 70,
    "title": "トレカ３９買取専門店",
    "urlinform": "store-79",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.miyusei.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqZFlweCNGGARehjIqW4pvqo",
    "lat": 35.7126886,
    "lng": 139.7066443,
    "placeId": "ChIJqZFlweCNGGARehjIqW4pvqo",
    "businessStatus": "OPERATIONAL",
    "phone": "050-1725-8064",
    "openingHours": [
      "Monday: 1:30 – 8:30 PM",
      "Tuesday: 1:30 – 8:30 PM",
      "Wednesday: 1:30 – 8:30 PM",
      "Thursday: 1:30 – 8:30 PM",
      "Friday: 1:30 – 8:30 PM",
      "Saturday: 1:30 – 8:30 PM",
      "Sunday: 1:30 – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3
  },
  {
    "id": 71,
    "title": "ぴのらんど",
    "urlinform": "store-82",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/pinoland2023",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfTB5aaaNGGARMOT-ON44TM0",
    "lat": 35.6956574,
    "lng": 139.6981215,
    "placeId": "ChIJfTB5aaaNGGARMOT-ON44TM0",
    "businessStatus": "OPERATIONAL",
    "phone": "080-7584-7639",
    "openingHours": [
      "Monday: 10:00 AM – 5:30 PM",
      "Tuesday: 10:00 AM – 5:30 PM",
      "Wednesday: 10:00 AM – 5:30 PM",
      "Thursday: 10:00 AM – 5:30 PM",
      "Friday: 10:00 AM – 5:30 PM",
      "Saturday: 10:00 AM – 5:30 PM",
      "Sunday: Closed"
    ],
    "rating": 3.6,
    "userRatingsTotal": 5,
    "district": "Shinjuku"
  },
  {
    "id": 72,
    "title": "レッドゾーン池袋店【ポケモンカード・ドールショップ】",
    "urlinform": "store-84",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.twitter.com/Redzone_Ike",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_ZlciniNGGARxWo35yv1GPA",
    "lat": 35.7299511,
    "lng": 139.7160501,
    "placeId": "ChIJ_ZlciniNGGARxWo35yv1GPA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 5:00 PM",
      "Wednesday: 11:00 AM – 5:00 PM",
      "Thursday: Closed",
      "Friday: 11:00 AM – 5:00 PM",
      "Saturday: 11:00 AM – 5:00 PM",
      "Sunday: 11:00 AM – 5:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 139,
    "district": "Ikebukuro"
  },
  {
    "id": 73,
    "title": "Shogun City Stars Shibuya",
    "urlinform": "shogun-city-stars-shibuya",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/ShogunCityStars",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRaG1bwKNGGARrGPhIlk21os",
    "lat": 35.6616654,
    "lng": 139.6978577,
    "placeId": "ChIJRaG1bwKNGGARrGPhIlk21os",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 6:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 202,
    "district": "Shibuya"
  },
  {
    "id": 74,
    "title": "トレカアビス渋谷店",
    "urlinform": "store-86",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqWO2SDeNGGARBio7Gd-eftE",
    "lat": 35.6621203,
    "lng": 139.6972624,
    "placeId": "ChIJqWO2SDeNGGARBio7Gd-eftE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 168,
    "district": "Shibuya"
  },
  {
    "id": 75,
    "title": "Hareruya Shibuya",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://www.hareruyamtg.com/ja/user_data/shop_shibuya?shop=27",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbfk8n0OLGGARoWr6oipSCvk",
    "lat": 35.6568854,
    "lng": 139.7049588,
    "placeId": "ChIJbfk8n0OLGGARoWr6oipSCvk",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6419-7783",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 96,
    "district": "Shibuya"
  },
  {
    "id": 76,
    "title": "ＭＩＮＴ−ＳＨＩＢＵＹＡ",
    "urlinform": "mint-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://mint-web.jp/?pid=39086084",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG79RuamMGGARjYIBdHHscWc",
    "lat": 35.6618711,
    "lng": 139.6985989,
    "placeId": "ChIJG79RuamMGGARjYIBdHHscWc",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6277-5205",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 206,
    "district": "Shibuya"
  },
  {
    "id": 77,
    "title": "Card Kingdom Shibuya",
    "urlinform": "-card-shop-shibuya",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://cardkingdom.jp/shibuya/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW9E7u9GLGGARSK6f2zSN6lo",
    "lat": 35.6583848,
    "lng": 139.7036843,
    "placeId": "ChIJW9E7u9GLGGARSK6f2zSN6lo",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6419-7382",
    "openingHours": [
      "Monday: 5:00 – 11:00 PM",
      "Tuesday: 5:00 – 11:00 PM",
      "Wednesday: 5:00 – 11:00 PM",
      "Thursday: 5:00 – 11:00 PM",
      "Friday: 12:00 – 11:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 59,
    "district": "Shibuya"
  },
  {
    "id": 78,
    "title": "Shibuya TCG card shop ASOBULAND",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.asobuland-tcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6dY3kwyLGGARpAl_U2_M9lM",
    "lat": 35.6578342,
    "lng": 139.7043901,
    "placeId": "ChIJ6dY3kwyLGGARpAl_U2_M9lM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 67,
    "district": "Shibuya"
  },
  {
    "id": 79,
    "title": "Tournament Center Bato-loco Shibuya Center St.",
    "urlinform": "store-91",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://bato-loco.com/1825info/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrWImYEyNGGARJlu3M3zmh4o",
    "lat": 35.6613322,
    "lng": 139.6978341,
    "placeId": "ChIJrWImYEyNGGARJlu3M3zmh4o",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6416-1151",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 189,
    "district": "Shibuya"
  },
  {
    "id": 80,
    "title": "POKÉMON CARD LOUNGE",
    "urlinform": "store-94",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://x.com/pcgl_shibuya?s=11",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv9PRf02NGGARfGTp2cHoODA",
    "lat": 35.6598578,
    "lng": 139.7003513,
    "placeId": "ChIJv9PRf02NGGARfGTp2cHoODA",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6837-3000",
    "openingHours": [
      "Monday: 10:00 AM – 10:30 PM",
      "Tuesday: 10:00 AM – 10:30 PM",
      "Wednesday: 10:00 AM – 10:30 PM",
      "Thursday: 10:00 AM – 10:30 PM",
      "Friday: 10:00 AM – 10:30 PM",
      "Saturday: 10:00 AM – 10:30 PM",
      "Sunday: 10:00 AM – 10:30 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 107,
    "district": "Shibuya"
  },
  {
    "id": 81,
    "title": "FullComp Shibuya east exit shop",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.fullcomp.jp/shibuya/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR-KxslmLGGARnbu4mFF8ITE",
    "lat": 35.65844,
    "lng": 139.703207,
    "placeId": "ChIJR-KxslmLGGARnbu4mFF8ITE",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5468-2652",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 236,
    "district": "Shibuya"
  },
  {
    "id": 82,
    "title": "Batoroko satellite Shibuya Ekimae",
    "urlinform": "satellite",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://bato-loco.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVTNWC3uLGGARnz1udlhMMEQ",
    "lat": 35.6597574,
    "lng": 139.7009471,
    "placeId": "ChIJVTNWC3uLGGARnz1udlhMMEQ",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6455-1528",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 199,
    "district": "Shibuya"
  },
  {
    "id": 83,
    "title": "Card Fanatic",
    "urlinform": "store-99",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://www.cardfanatic.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6dmC11uLGGARG5RxjCdVeTU",
    "lat": 35.656584,
    "lng": 139.704509,
    "placeId": "ChIJ6dmC11uLGGARG5RxjCdVeTU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5485-2777",
    "openingHours": [
      "Monday: 3:00 – 8:00 PM",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 3:00 – 8:00 PM",
      "Sunday: 3:00 – 7:00 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 70,
    "district": "Shibuya"
  },
  {
    "id": 84,
    "title": "Tier One Shibuya",
    "urlinform": "store-100",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/tieroneshibuya",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-3K87kGNGGARFafx9L-W9T4",
    "lat": 35.6624213,
    "lng": 139.7010926,
    "placeId": "ChIJ-3K87kGNGGARFafx9L-W9T4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 74,
    "district": "Shibuya"
  },
  {
    "id": 85,
    "title": "ONE PIECEカードゲーム 公式ショップ 東京渋谷店",
    "urlinform": "one-piece-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY9VDeQCNGGAR2pXg0JRS3ck",
    "lat": 35.6599585,
    "lng": 139.7008699,
    "placeId": "ChIJY9VDeQCNGGAR2pXg0JRS3ck",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 3,
    "userRatingsTotal": 3,
    "district": "Shibuya"
  },
  {
    "id": 86,
    "title": "ONE PIECE Straw Hat Store - Shibuya Main Store",
    "urlinform": "one-piece-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "http://www.mugiwara-store.com/store/5153",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZWRyXhuLGGARjWs-xuvcOxQ",
    "lat": 35.6597665,
    "lng": 139.7008258,
    "placeId": "ChIJZWRyXhuLGGARjWs-xuvcOxQ",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6416-9222",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 818,
    "district": "Shibuya"
  },
  {
    "id": 87,
    "title": "Kansai Card Supply",
    "urlinform": "kansai-card-supply",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/kansaicardsupplyjp",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7dqYGjDzGGAR_u2kGfov03o",
    "lat": 35.6645944,
    "lng": 139.6870269,
    "placeId": "ChIJ7dqYGjDzGGAR_u2kGfov03o",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 0,
    "userRatingsTotal": 0
  },
  {
    "id": 88,
    "title": "ドラゴンボーン(DRAGONBONE) 池袋店",
    "urlinform": "dragonbone-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTRssJgCNGGARd9dUHOl0xZM",
    "lat": 35.729456,
    "lng": 139.7130181,
    "placeId": "ChIJTRssJgCNGGARd9dUHOl0xZM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 241,
    "district": "Ikebukuro"
  },
  {
    "id": 89,
    "title": "Fukufuku",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://fukufukutoreka.com/description_detail_ikebukuro",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJO9Wpq_WNGGARUaKg2uMZkMA",
    "lat": 35.7312375,
    "lng": 139.7143244,
    "placeId": "ChIJO9Wpq_WNGGARUaKg2uMZkMA",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5904-8840",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 481,
    "district": "Ikebukuro"
  },
  {
    "id": 90,
    "title": "BIGMAGIC Ikebukuro",
    "urlinform": "big-magic-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.bigmagic.net/ikebukuro.htm",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt4uZ62eNGGARptYR28mcE0E",
    "lat": 35.7297856,
    "lng": 139.7160213,
    "placeId": "ChIJt4uZ62eNGGARptYR28mcE0E",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5944-8023",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 232,
    "district": "Ikebukuro"
  },
  {
    "id": 91,
    "title": "シンソク池袋店",
    "urlinform": "store-110",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.cardshop-shinsoku.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJUbFMZaNGGARd8HwImqa1LU",
    "lat": 35.7309403,
    "lng": 139.7152122,
    "placeId": "ChIJJUbFMZaNGGARd8HwImqa1LU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6825-2236",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 748,
    "district": "Ikebukuro"
  },
  {
    "id": 92,
    "title": "Card Secret",
    "urlinform": "store-111",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/card_secret",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6cY_YwaNGGAR6CntCYhnyYU",
    "lat": 35.72925,
    "lng": 139.7159794,
    "placeId": "ChIJ6cY_YwaNGGAR6CntCYhnyYU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5843-3778",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 330,
    "district": "Ikebukuro"
  },
  {
    "id": 93,
    "title": "Trickstar Ikebukuro",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJH0MwrmiNGGARYllcFCgNzaM",
    "lat": 35.729687,
    "lng": 139.716224,
    "placeId": "ChIJH0MwrmiNGGARYllcFCgNzaM",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5952-7337",
    "openingHours": [
      "Monday: 12:30 – 7:00 PM",
      "Tuesday: 12:30 – 7:00 PM",
      "Wednesday: 12:30 – 7:00 PM",
      "Thursday: 12:30 – 7:00 PM",
      "Friday: 12:30 – 7:00 PM",
      "Saturday: 11:30 AM – 6:00 PM",
      "Sunday: 11:30 AM – 6:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 82,
    "district": "Ikebukuro"
  },
  {
    "id": 94,
    "title": "Ninnin ikebukuro",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://nin-nin-pokeka.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ4K4Ql6NGGARL2PVL3D4gtc",
    "lat": 35.7289355,
    "lng": 139.7159304,
    "placeId": "ChIJZ4K4Ql6NGGARL2PVL3D4gtc",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6907-2134",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 62,
    "district": "Ikebukuro"
  },
  {
    "id": 95,
    "title": "カードショップ TopStox 池袋店",
    "urlinform": "-topstox-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://topstox.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB7jwm7yNGGARxvllidBxc60",
    "lat": 35.7297918,
    "lng": 139.7160102,
    "placeId": "ChIJB7jwm7yNGGARxvllidBxc60",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6709-0991",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 37,
    "district": "Ikebukuro"
  },
  {
    "id": 96,
    "title": "Mint Games Ikebukuro",
    "urlinform": "mint-games-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://mint-web.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg7qz3sqNGGARpd2bIZ38iiw",
    "lat": 35.7316999,
    "lng": 139.7124441,
    "placeId": "ChIJg7qz3sqNGGARpd2bIZ38iiw",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6907-3308",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 84,
    "district": "Ikebukuro"
  },
  {
    "id": 97,
    "title": "無双 池袋カードショップ",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://muso-cardshop.ocnk.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG6Hc5WaNGGARCQyvsSgiNEw",
    "lat": 35.7282282,
    "lng": 139.7134566,
    "placeId": "ChIJG6Hc5WaNGGARCQyvsSgiNEw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 119,
    "district": "Ikebukuro"
  },
  {
    "id": 98,
    "title": "ボクらのカードショップ 池袋店",
    "urlinform": "-bokurano-card-shop-tokyo",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://bokuranocardshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJV1D2lVuNGGARyNT8o50nA_M",
    "lat": 35.7296647,
    "lng": 139.7138707,
    "placeId": "ChIJV1D2lVuNGGARyNT8o50nA_M",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 9:30 PM",
      "Tuesday: 12:00 – 9:30 PM",
      "Wednesday: 12:00 – 9:30 PM",
      "Thursday: 12:00 – 9:30 PM",
      "Friday: 12:00 – 9:30 PM",
      "Saturday: 12:00 – 9:30 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 54,
    "district": "Ikebukuro"
  },
  {
    "id": 99,
    "title": "Doragonsutaikebukuroten",
    "urlinform": "store-119",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://dorasuta.jp/?utm_source=GBP&utm_medium=GBP&utm_term=GBP&utm_content=GBP&utm_campaign=GBP002",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG5AbZoONGGAR4Gktfzan9es",
    "lat": 35.7314349,
    "lng": 139.7163094,
    "placeId": "ChIJG5AbZoONGGAR4Gktfzan9es",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6907-3307",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 198,
    "district": "Ikebukuro"
  },
  {
    "id": 100,
    "title": "Toreca Chase",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/chase_toreca1",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgU1zcs6NGGAR6PEvCfj-ZDo",
    "lat": 35.7303409,
    "lng": 139.7151997,
    "placeId": "ChIJgU1zcs6NGGAR6PEvCfj-ZDo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 82,
    "district": "Ikebukuro"
  },
  {
    "id": 101,
    "title": "Amenity Dream Ikebukuro",
    "urlinform": "store-121",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://amenitydream.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqYQvdGaNGGARj-uJHP65H_8",
    "lat": 35.731745,
    "lng": 139.716449,
    "placeId": "ChIJqYQvdGaNGGARj-uJHP65H_8",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5985-1065",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 182,
    "district": "Ikebukuro"
  },
  {
    "id": 102,
    "title": "トレカキャンプ DM 池袋店 【デュエマ専門店】",
    "urlinform": "store-122",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJy70pAQCNGGARe8c5khWJFsM",
    "lat": 35.7290439,
    "lng": 139.7135461,
    "placeId": "ChIJy70pAQCNGGARe8c5khWJFsM",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9277-7281",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 23,
    "district": "Ikebukuro"
  },
  {
    "id": 103,
    "title": "Hobby Station Ikebukuro",
    "urlinform": "store-124",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.hbst.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUSYAo2iNGGARS6PHQFVcJ6o",
    "lat": 35.729511,
    "lng": 139.715552,
    "placeId": "ChIJUSYAo2iNGGARS6PHQFVcJ6o",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5391-1930",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 209,
    "district": "Ikebukuro"
  },
  {
    "id": 104,
    "title": "Fullcomp Ikebukuroten",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.fullcomp.jp/ikebukuro/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCXpLAmaNGGARn42_51CCIYs",
    "lat": 35.730365,
    "lng": 139.716252,
    "placeId": "ChIJCXpLAmaNGGARn42_51CCIYs",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5951-2652",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 2.4,
    "userRatingsTotal": 164,
    "district": "Ikebukuro"
  },
  {
    "id": 105,
    "title": "カードラッシュ 池袋店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.cardrush.jp/page/57",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJq6qun2iNGGAR41jvBY9DjVE",
    "lat": 35.7297107,
    "lng": 139.7152573,
    "placeId": "ChIJq6qun2iNGGAR41jvBY9DjVE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 230,
    "district": "Ikebukuro"
  },
  {
    "id": 106,
    "title": "ONE PIECE mugiwara store Ikebukuro",
    "urlinform": "one-piece-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "http://www.mugiwara-store.com/store/1426",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbQtQVW6NGGARcZDcUOEA-h4",
    "lat": 35.72940639999999,
    "lng": 139.7187059,
    "placeId": "ChIJbQtQVW6NGGARcZDcUOEA-h4",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6903-1557",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 285,
    "district": "Ikebukuro"
  },
  {
    "id": 107,
    "title": "ワンピースカードショップ ラムセカンド／LAMB2nd",
    "urlinform": "-lamb2nd",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.lamb-pokemon.jp/products/category/onepiece",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB7qG-VONGGARUmtJ2rozS1U",
    "lat": 35.7304862,
    "lng": 139.7134704,
    "placeId": "ChIJB7qG-VONGGARUmtJ2rozS1U",
    "businessStatus": "OPERATIONAL",
    "phone": "03-4500-5397",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 26,
    "district": "Ikebukuro"
  },
  {
    "id": 108,
    "title": "トレカ道楽",
    "urlinform": "store-129",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.douraku.info/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJI2Ksk66NGGARHO-Knpre8GI",
    "lat": 35.7318349,
    "lng": 139.7143843,
    "placeId": "ChIJI2Ksk66NGGARHO-Knpre8GI",
    "businessStatus": "OPERATIONAL",
    "phone": "080-4002-9933",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 229,
    "district": "Ikebukuro"
  },
  {
    "id": 109,
    "title": "カーデリア（cardéria）池袋店",
    "urlinform": "cardria",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "https://carderia-online.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_RTW8GGNGGARv4KYHQBM4fE",
    "lat": 35.7322063,
    "lng": 139.7159104,
    "placeId": "ChIJ_RTW8GGNGGARv4KYHQBM4fE",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6912-8811",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 126,
    "district": "Ikebukuro"
  },
  {
    "id": 110,
    "title": "TorekaZamurai Main Branch",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.torezamunet.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJq6qNrGeNGGAR0sVkLLzqglI",
    "lat": 35.7312625,
    "lng": 139.7139853,
    "placeId": "ChIJq6qNrGeNGGAR0sVkLLzqglI",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5927-1519",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 138,
    "district": "Ikebukuro"
  },
  {
    "id": 111,
    "title": "MINT 池袋店 スポーツカード＆カードゲーム",
    "urlinform": "mint",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://mint-web.jp/?pid=4245271",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJu0t1s2iNGGARcJmZ4bopDKw",
    "lat": 35.729673,
    "lng": 139.7162496,
    "placeId": "ChIJu0t1s2iNGGARcJmZ4bopDKw",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3981-4770",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 122,
    "district": "Ikebukuro"
  },
  {
    "id": 112,
    "title": "Super Potato Ikebukuro Game Yokocho",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.superpotato.com/shop/ikebukuro/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqabux2iNGGARaBarFeNnfK8",
    "lat": 35.7289195,
    "lng": 139.7159715,
    "placeId": "ChIJqabux2iNGGARaBarFeNnfK8",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6912-5378",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 478,
    "district": "Ikebukuro"
  },
  {
    "id": 113,
    "title": "Card Box Ikebukuro",
    "urlinform": "store-135",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Battle Spirits",
      "MTG",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardbox.online/shop/detail/5054/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2UIo8Z6NGGARFNHRoP0rEMU",
    "lat": 35.7317042,
    "lng": 139.716489,
    "placeId": "ChIJ2UIo8Z6NGGARFNHRoP0rEMU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5843-3836",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 52,
    "district": "Ikebukuro"
  },
  {
    "id": 114,
    "title": "Pokemon Shop Ninnin Nakano",
    "urlinform": "store-136",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://x.com/nin_nin_toreca2",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo37czRbzGGARiK0uDCyowok",
    "lat": 35.7070373,
    "lng": 139.6658366,
    "placeId": "ChIJo37czRbzGGARiK0uDCyowok",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5942-5569",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 68,
    "district": "Nakano"
  },
  {
    "id": 115,
    "title": "ナタデココ 中野店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/coco_nakanoten",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMZKvJNHzGGAR7VU3TeBh894",
    "lat": 35.7073836,
    "lng": 139.6655807,
    "placeId": "ChIJMZKvJNHzGGAR7VU3TeBh894",
    "businessStatus": "OPERATIONAL",
    "phone": "080-4027-9821",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 56,
    "district": "Nakano"
  },
  {
    "id": 116,
    "title": "カードショップメガトンパンチ/CARD SHOP MEGAPUNCH",
    "urlinform": "card-shop-megapunch",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/Card_MEGAPUNCH",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsS9-tVHzGGARxxI7bUS4wfc",
    "lat": 35.7089299,
    "lng": 139.6657768,
    "placeId": "ChIJsS9-tVHzGGARxxI7bUS4wfc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 10,
    "district": "Nakano"
  },
  {
    "id": 117,
    "title": "Ryusei no PAO Nakano Store",
    "urlinform": "pao",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.az-zone.com/toreka/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaaaZqhzzGGARfHXCElzF75w",
    "lat": 35.7101152,
    "lng": 139.6658067,
    "placeId": "ChIJaaaZqhzzGGARfHXCElzF75w",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5942-4680",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 121,
    "district": "Nakano"
  },
  {
    "id": 118,
    "title": "タグサイド（TAGSIDE）中野店",
    "urlinform": "tagside",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://tagside.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVZj71cPzGGARWNbWp-IaDQs",
    "lat": 35.7085569,
    "lng": 139.6655177,
    "placeId": "ChIJVZj71cPzGGARWNbWp-IaDQs",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6454-0229",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 28,
    "district": "Nakano"
  },
  {
    "id": 119,
    "title": "遊Ｖｉｃ中野店",
    "urlinform": "store-143",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://youvic.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHWhy1JDyGGARCQCY2Gmqa6c",
    "lat": 35.7044784,
    "lng": 139.6652,
    "placeId": "ChIJHWhy1JDyGGARCQCY2Gmqa6c",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3388-4278",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 115,
    "district": "Nakano"
  },
  {
    "id": 120,
    "title": "Amenitidorimunakanoten",
    "urlinform": "store-144",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://amenitydream.co.jp/shop/tokyo-nakano/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0RKdB7XzGGARfT6ytp2CAto",
    "lat": 35.7089299,
    "lng": 139.6657768,
    "placeId": "ChIJ0RKdB7XzGGARfT6ytp2CAto",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5380-3811",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 2.5,
    "userRatingsTotal": 38,
    "district": "Nakano"
  },
  {
    "id": 121,
    "title": "カードショップトレジャー 中野ブロードウェイ店",
    "urlinform": "store-145",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.teleca.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0Zw0SZfyGGARtHwH-7a3mf0",
    "lat": 35.7090257,
    "lng": 139.6659002,
    "placeId": "ChIJ0Zw0SZfyGGARtHwH-7a3mf0",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3389-2222",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 57,
    "district": "Nakano"
  },
  {
    "id": 122,
    "title": "Lashinbang Nakano Puchase Counter (Kaitori)",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lashinbang.com/store/14/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIf6hTZfyGGARGzcI71qS6AE",
    "lat": 35.7089299,
    "lng": 139.6657768,
    "placeId": "ChIJIf6hTZfyGGARGzcI71qS6AE",
    "businessStatus": "OPERATIONAL",
    "phone": "0570-008-620",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 125,
    "district": "Nakano"
  },
  {
    "id": 123,
    "title": "Lashinbang Nakano Figure Specialty Store",
    "urlinform": "store-147",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lashinbang.com/store/15/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJkR08UpfyGGARNfacB-5oxDU",
    "lat": 35.7089299,
    "lng": 139.6657768,
    "placeId": "ChIJkR08UpfyGGARNfacB-5oxDU",
    "businessStatus": "OPERATIONAL",
    "phone": "0570-008-620",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 121,
    "district": "Nakano"
  },
  {
    "id": 124,
    "title": "Game Station",
    "urlinform": "store-148",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://gamestation.ocnk.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0Zw0SZfyGGARkb8qNjinFBI",
    "lat": 35.7094024,
    "lng": 139.6657448,
    "placeId": "ChIJ0Zw0SZfyGGARkb8qNjinFBI",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5942-9713",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 38,
    "district": "Nakano"
  },
  {
    "id": 125,
    "title": "F1 Signass",
    "urlinform": "f1",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://ameblo.jp/signass/entry-12750995714.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ72aGiZ7zGGAR_OGVraKyfM4",
    "lat": 35.7113507,
    "lng": 139.6672492,
    "placeId": "ChIJ72aGiZ7zGGAR_OGVraKyfM4",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3388-0262",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 139,
    "district": "Nakano"
  },
  {
    "id": 126,
    "title": "環七ホビー 中野本店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Gundam"
    ],
    "storeWebsite": "https://kan7hobby.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJkdz34YTtGGAR1Fo63BXPxio",
    "lat": 35.7247881,
    "lng": 139.6541161,
    "placeId": "ChIJkdz34YTtGGAR1Fo63BXPxio",
    "businessStatus": "OPERATIONAL",
    "phone": "0120-747-774",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 304
  },
  {
    "id": 127,
    "title": "バトンストア中野ブロードウェイ店",
    "urlinform": "store-151",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Digimon"
    ],
    "storeWebsite": "https://baton-net.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW2e-QQbzGGAR6gsY955Qwvw",
    "lat": 35.7092359,
    "lng": 139.6657738,
    "placeId": "ChIJW2e-QQbzGGAR6gsY955Qwvw",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5942-6846",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 21,
    "district": "Nakano"
  },
  {
    "id": 128,
    "title": "TCG Shop MAGIC PLANET",
    "urlinform": "tcg-shop-magic-planet",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lit.link/MagicPlanetLab",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzytouliPGGARmruMxJdZKZQ",
    "lat": 35.7124255,
    "lng": 139.7938473,
    "placeId": "ChIJzytouliPGGARmruMxJdZKZQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:30 AM – 9:00 PM",
      "Tuesday: 11:30 AM – 9:00 PM",
      "Wednesday: 11:30 AM – 9:00 PM",
      "Thursday: 11:30 AM – 9:00 PM",
      "Friday: 11:30 AM – 9:00 PM",
      "Saturday: 11:30 AM – 9:00 PM",
      "Sunday: 11:30 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1040,
    "district": "Asakusa"
  },
  {
    "id": 129,
    "title": "Card Pot",
    "urlinform": "card-pot",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://sites.google.com/view/cardpot",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-d-vNI-NGGARQwnKqThVT6k",
    "lat": 35.7091568,
    "lng": 139.7700509,
    "placeId": "ChIJ-d-vNI-NGGARQwnKqThVT6k",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6803-2540",
    "openingHours": [
      "Monday: 5:00 – 11:00 PM",
      "Tuesday: 5:00 – 11:00 PM",
      "Wednesday: 5:00 – 11:00 PM",
      "Thursday: 5:00 – 11:00 PM",
      "Friday: 5:00 – 11:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 16
  },
  {
    "id": 130,
    "title": "ディスカウント二木",
    "urlinform": "store-155",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS"
    ],
    "storeWebsite": "https://www.target.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo6QRkZ-OGGARHX-cL4TUss8",
    "lat": 35.7082992,
    "lng": 139.7746231,
    "placeId": "ChIJo6QRkZ-OGGARHX-cL4TUss8",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3831-4460",
    "openingHours": [
      "Monday: 10:30 AM – 7:30 PM",
      "Tuesday: 10:30 AM – 7:30 PM",
      "Wednesday: 10:30 AM – 7:30 PM",
      "Thursday: 10:30 AM – 7:30 PM",
      "Friday: 10:30 AM – 7:30 PM",
      "Saturday: 10:30 AM – 7:30 PM",
      "Sunday: 10:30 AM – 7:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 1623
  },
  {
    "id": 131,
    "title": "OVERSEAS【オーバーシーズ】",
    "urlinform": "overseas",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/overseas_ueno",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJr6vkZaKPGGARAEQBJB_b8zA",
    "lat": 35.712912,
    "lng": 139.7781119,
    "placeId": "ChIJr6vkZaKPGGARAEQBJB_b8zA",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6231-6371",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 108
  },
  {
    "id": 132,
    "title": "INFINITE JOY Akihabara",
    "urlinform": "infinite-joy-akihabara",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://store.infinitejoy.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIRFUDQCNGGARA4mAQu0B0Mw",
    "lat": 35.7003928,
    "lng": 139.7711204,
    "placeId": "ChIJIRFUDQCNGGARA4mAQu0B0Mw",
    "businessStatus": "OPERATIONAL",
    "phone": "0800-805-5088",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 209,
    "district": "Akihabara"
  },
  {
    "id": 133,
    "title": "シンソク秋葉原3号店",
    "urlinform": "3",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.cardshop-shinsoku.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-8Ox5EqNGGARP1mjnE8F7IQ",
    "lat": 35.7012267,
    "lng": 139.7718565,
    "placeId": "ChIJ-8Ox5EqNGGARP1mjnE8F7IQ",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6826-2333",
    "openingHours": [
      "Monday: 11:00 AM – 8:30 PM",
      "Tuesday: 11:00 AM – 8:30 PM",
      "Wednesday: 11:00 AM – 8:30 PM",
      "Thursday: 11:00 AM – 8:30 PM",
      "Friday: 11:00 AM – 8:30 PM",
      "Saturday: 11:00 AM – 8:30 PM",
      "Sunday: 11:00 AM – 8:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 320,
    "district": "Akihabara"
  },
  {
    "id": 134,
    "title": "トレカBH秋葉原",
    "urlinform": "bh",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/toreka_besthigh",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJa2OVMACPGGARJDjJnP9RWtE",
    "lat": 35.7025971,
    "lng": 139.7720178,
    "placeId": "ChIJa2OVMACPGGARJDjJnP9RWtE",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6285-2707",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 283,
    "district": "Akihabara"
  },
  {
    "id": 135,
    "title": "トレジャーハンター",
    "urlinform": "store-160",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/akibakado12345",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJq9UPbWeNGGAR56ADUpi3lpw",
    "lat": 35.7016553,
    "lng": 139.7708648,
    "placeId": "ChIJq9UPbWeNGGAR56ADUpi3lpw",
    "businessStatus": "OPERATIONAL",
    "phone": "070-1245-6013",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 9,
    "district": "Akihabara"
  },
  {
    "id": 136,
    "title": "Yamashiroya Ueno",
    "urlinform": "store-161",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "One Piece"
    ],
    "storeWebsite": "https://e-yamashiroya.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP9deX56OGGAR8cyyp62_EJc",
    "lat": 35.711328,
    "lng": 139.7753067,
    "placeId": "ChIJP9deX56OGGAR8cyyp62_EJc",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3831-2320",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 2951
  },
  {
    "id": 137,
    "title": "BRAND COLLECT UENO-OKACHIMACHI",
    "urlinform": "brand-collect-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://brandcollect.com/shop/471/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtaRUCQCPGGARORz8hrKPMxI",
    "lat": 35.7079729,
    "lng": 139.7745383,
    "placeId": "ChIJtaRUCQCPGGARORz8hrKPMxI",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6694-2945",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1214
  },
  {
    "id": 138,
    "title": "Shinsoku",
    "urlinform": "2",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.cardshop-shinsoku.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYz5jhF6NGGARYbhV-vkMfA8",
    "lat": 35.6981602,
    "lng": 139.7708224,
    "placeId": "ChIJYz5jhF6NGGARYbhV-vkMfA8",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6826-2333",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 517,
    "district": "Akihabara"
  },
  {
    "id": 139,
    "title": "Cherumo Akihabara",
    "urlinform": "store-164",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://cherumo-akihabara.jimdo.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSZPQ3h2MGGAR_jH1gwUG6vs",
    "lat": 35.7080888,
    "lng": 139.7752242,
    "placeId": "ChIJSZPQ3h2MGGAR_jH1gwUG6vs",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6284-3009",
    "openingHours": [
      "Monday: 11:00 AM – 8:30 PM",
      "Tuesday: 11:00 AM – 8:30 PM",
      "Wednesday: 11:00 AM – 8:30 PM",
      "Thursday: 11:00 AM – 8:30 PM",
      "Friday: 11:00 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 2.7,
    "userRatingsTotal": 258
  },
  {
    "id": 140,
    "title": "Card Shop Tracaverse",
    "urlinform": "-6f",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Lorcana",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.torecabirth.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJp8I1TfCNGGARJ7O8Q_jsyUs",
    "lat": 35.7018012,
    "lng": 139.7712265,
    "placeId": "ChIJp8I1TfCNGGARJ7O8Q_jsyUs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 8:00 PM",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 137,
    "district": "Akihabara"
  },
  {
    "id": 141,
    "title": "TCG / BOARD GAME Cafe & Bar FUN",
    "urlinform": "tcg-board-game-cafe-bar-fun",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hotpepper.jp/strJ003432725/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuQl27zKPGGARFD9SmbPmJks",
    "lat": 35.7064602,
    "lng": 139.7757761,
    "placeId": "ChIJuQl27zKPGGARFD9SmbPmJks",
    "businessStatus": "OPERATIONAL",
    "phone": "090-5456-1641",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 5:00 – 11:30 PM",
      "Thursday: 5:00 – 11:30 PM",
      "Friday: 5:00 – 11:30 PM",
      "Saturday: 2:00 – 11:30 PM",
      "Sunday: 2:00 – 11:30 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 146
  },
  {
    "id": 142,
    "title": "Card Shop Hanjō",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.cardshop-hanjou.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJccyb5u2NGGARQYuW2gNEd-M",
    "lat": 35.6983558,
    "lng": 139.7715294,
    "placeId": "ChIJccyb5u2NGGARQYuW2gNEd-M",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 3.2,
    "userRatingsTotal": 364,
    "district": "Akihabara"
  },
  {
    "id": 143,
    "title": "上野上さま",
    "urlinform": "store-169",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://uesama.games/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQdh-lx-MGGARKtcqUdXEays",
    "lat": 35.7053749,
    "lng": 139.7710186,
    "placeId": "ChIJQdh-lx-MGGARKtcqUdXEays",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3836-1869",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 6:00 – 11:00 PM",
      "Wednesday: 6:00 – 11:00 PM",
      "Thursday: 12:00 – 11:00 PM",
      "Friday: 12:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 48
  },
  {
    "id": 144,
    "title": "カードショップ トレキング 秋葉原店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://toreking.ocnk.net/page/info",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPavU0niNGGARm7wNf8O_ruU",
    "lat": 35.701149,
    "lng": 139.7718255,
    "placeId": "ChIJPavU0niNGGARm7wNf8O_ruU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 102,
    "district": "Akihabara"
  },
  {
    "id": 145,
    "title": "Hareruya",
    "urlinform": "mtg-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://www.hareruyamtg.com/ja/user_data/shop_akihabara?shop=8",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJezUWu9ONGGAR5yvJDDHBH2g",
    "lat": 35.6984,
    "lng": 139.7707291,
    "placeId": "ChIJezUWu9ONGGAR5yvJDDHBH2g",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5244-4899",
    "openingHours": [
      "Monday: 10:00 AM – 11:00 PM",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 326,
    "district": "Akihabara"
  },
  {
    "id": 146,
    "title": "Pokémon store Asakusa",
    "urlinform": "anime-figures-pokemon-cards-one-piece-cards-japanese-collectibles-in-asakusa-tokyo-hobby-base-wtj",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJp4dNrmCPGGAR21j_IT8JFiI",
    "lat": 35.716178,
    "lng": 139.7959192,
    "placeId": "ChIJp4dNrmCPGGAR21j_IT8JFiI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 18,
    "district": "Asakusa"
  },
  {
    "id": 147,
    "title": "BE POP",
    "urlinform": "bepop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbb3-nL-OGGARyw8LJBd_Brg",
    "lat": 35.712832,
    "lng": 139.7927978,
    "placeId": "ChIJbb3-nL-OGGARyw8LJBd_Brg",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6324-3386",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 57,
    "district": "Asakusa"
  },
  {
    "id": 148,
    "title": "TOKYO POKE",
    "urlinform": "tokyo-poke",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn1lb5I-PGGAR5f7S3ZWZNkk",
    "lat": 35.71141290000001,
    "lng": 139.7953758,
    "placeId": "ChIJn1lb5I-PGGAR5f7S3ZWZNkk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 55,
    "district": "Asakusa"
  },
  {
    "id": 149,
    "title": "エムアンドルポ浅草店",
    "urlinform": "store-177",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece"
    ],
    "storeWebsite": "https://www.kyokatrading.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTWG-Zs2PGGARw-ZVxcAIKrY",
    "lat": 35.7117895,
    "lng": 139.7960647,
    "placeId": "ChIJTWG-Zs2PGGARw-ZVxcAIKrY",
    "businessStatus": "OPERATIONAL",
    "phone": "080-3485-8428",
    "openingHours": [
      "Monday: 9:00 AM – 10:30 PM",
      "Tuesday: 9:00 AM – 10:30 PM",
      "Wednesday: 9:00 AM – 10:30 PM",
      "Thursday: 9:00 AM – 10:30 PM",
      "Friday: 9:00 AM – 10:30 PM",
      "Saturday: 9:00 AM – 10:30 PM",
      "Sunday: 9:00 AM – 10:30 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 19,
    "district": "Asakusa"
  },
  {
    "id": 150,
    "title": "魂 雷門店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJM9BDr0WPGGARCd6cT43eBBI",
    "lat": 35.7116117,
    "lng": 139.7974527,
    "placeId": "ChIJM9BDr0WPGGARCd6cT43eBBI",
    "businessStatus": "OPERATIONAL",
    "phone": "080-2485-8428",
    "openingHours": [
      "Monday: 9:00 AM – 10:30 PM",
      "Tuesday: 9:00 AM – 10:30 PM",
      "Wednesday: 9:00 AM – 10:30 PM",
      "Thursday: 9:00 AM – 10:30 PM",
      "Friday: 9:00 AM – 10:30 PM",
      "Saturday: 9:00 AM – 10:30 PM",
      "Sunday: 9:00 AM – 10:30 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 9,
    "district": "Asakusa"
  },
  {
    "id": 151,
    "title": "ホビーオフ浅草店",
    "urlinform": "store-179",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.hardoff.co.jp/shop/detail/?p=208137",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd0vaUtCPGGARMJ_xYdDihuw",
    "lat": 35.7170473,
    "lng": 139.7945065,
    "placeId": "ChIJd0vaUtCPGGARMJ_xYdDihuw",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6802-4230",
    "openingHours": [
      "Monday: 10:30 AM – 8:00 PM",
      "Tuesday: 10:30 AM – 8:00 PM",
      "Wednesday: 10:30 AM – 8:00 PM",
      "Thursday: 10:30 AM – 8:00 PM",
      "Friday: 10:30 AM – 8:00 PM",
      "Saturday: 10:30 AM – 8:00 PM",
      "Sunday: 10:30 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 67,
    "district": "Asakusa"
  },
  {
    "id": 152,
    "title": "Japanzon",
    "urlinform": "store-180",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Gundam",
      "Pokémon"
    ],
    "storeWebsite": "https://japanzon.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjzGmmvKPGGARZkB7TdUNEPU",
    "lat": 35.7125653,
    "lng": 139.7948326,
    "placeId": "ChIJjzGmmvKPGGARZkB7TdUNEPU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5830-3421",
    "openingHours": [
      "Monday: 10:00 AM – 5:00 PM",
      "Tuesday: 10:00 AM – 5:00 PM",
      "Wednesday: 12:00 – 5:00 PM",
      "Thursday: 10:00 AM – 5:00 PM",
      "Friday: 10:00 AM – 5:00 PM",
      "Saturday: 10:00 AM – 5:00 PM",
      "Sunday: 12:00 – 5:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 116,
    "district": "Asakusa"
  },
  {
    "id": 153,
    "title": "Pokémon Center Skytree",
    "urlinform": "store-181",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/skytreetown/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt6u9QtaOGGARHbxorE1IKXw",
    "lat": 35.7103448,
    "lng": 139.8126119,
    "placeId": "ChIJt6u9QtaOGGARHbxorE1IKXw",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6456-1221",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 3495
  },
  {
    "id": 154,
    "title": "Nakazawa Tawaramachi",
    "urlinform": "nakazawa-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://nattyzone.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQbTHPb-OGGARlipwg82p4dU",
    "lat": 35.7111057,
    "lng": 139.7916923,
    "placeId": "ChIJQbTHPb-OGGARlipwg82p4dU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3841-7866",
    "openingHours": [
      "Monday: 10:00 AM – 6:30 PM",
      "Tuesday: 10:00 AM – 6:30 PM",
      "Wednesday: Closed",
      "Thursday: 10:00 AM – 6:30 PM",
      "Friday: 10:00 AM – 6:30 PM",
      "Saturday: 10:00 AM – 6:30 PM",
      "Sunday: 10:00 AM – 6:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 127,
    "district": "Asakusa"
  },
  {
    "id": 155,
    "title": "TOKYO HOBBY CENTER ASAKUSA",
    "urlinform": "store-183",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn-erReaPGGARxjy0jWVBVEI",
    "lat": 35.7133811,
    "lng": 139.7939024,
    "placeId": "ChIJn-erReaPGGARxjy0jWVBVEI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 25,
    "district": "Asakusa"
  },
  {
    "id": 156,
    "title": "東京ホビーベース浅草 TOKYO HOBBY BASE WTJ",
    "urlinform": "-tokyo-hobby-base-wtj",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://tokyohobbybase.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJySNuve2PGGAR-p_sGn1U3MA",
    "lat": 35.716178,
    "lng": 139.7959192,
    "placeId": "ChIJySNuve2PGGAR-p_sGn1U3MA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 109,
    "district": "Asakusa"
  },
  {
    "id": 157,
    "title": "Pokémon Center DX",
    "urlinform": "dx",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/tokyodx/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCVAO3leJGGARvCoZ_hJkye4",
    "lat": 35.6802902,
    "lng": 139.7742695,
    "placeId": "ChIJCVAO3leJGGARvCoZ_hJkye4",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6262-6452",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 4177
  },
  {
    "id": 158,
    "title": "Hobby center",
    "urlinform": "hobby-center",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXcHLMQCPGGARoaPxda6GAvM",
    "lat": 35.7132015,
    "lng": 139.7938313,
    "placeId": "ChIJXcHLMQCPGGARoaPxda6GAvM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 1,
    "district": "Asakusa"
  },
  {
    "id": 159,
    "title": "ANIME TREASURES ASAKUSA",
    "urlinform": "anime-treasures-asakusa",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://duty-free-shops.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC6lglkqPGGARq3CeI0_sB-A",
    "lat": 35.7104163,
    "lng": 139.7978527,
    "placeId": "ChIJC6lglkqPGGARq3CeI0_sB-A",
    "businessStatus": "OPERATIONAL",
    "phone": "080-3574-4728",
    "openingHours": [
      "Monday: 9:00 AM – 10:30 PM",
      "Tuesday: 9:00 AM – 10:30 PM",
      "Wednesday: 9:00 AM – 10:30 PM",
      "Thursday: 9:00 AM – 10:30 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 10:30 PM",
      "Sunday: 9:00 AM – 10:30 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 12,
    "district": "Asakusa"
  },
  {
    "id": 160,
    "title": "Hot Goblin",
    "urlinform": "hot-goblin",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hotgoblin.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh30wvE2PGGARYaKDp62QIqA",
    "lat": 35.7123373,
    "lng": 139.794554,
    "placeId": "ChIJh30wvE2PGGARYaKDp62QIqA",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6802-8395",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 24,
    "district": "Asakusa"
  },
  {
    "id": 161,
    "title": "Furuichi Toreka Park",
    "urlinform": "akiba",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.furu1.net/shop/shop0128.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJL4oeTB2MGGARWQByCycfYXg",
    "lat": 35.6979149,
    "lng": 139.7719571,
    "placeId": "ChIJL4oeTB2MGGARWQByCycfYXg",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3526-6601",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 229,
    "district": "Akihabara"
  },
  {
    "id": 162,
    "title": "Super Potato",
    "urlinform": "store-190",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://superpotatoakiba.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcUJuHqeOGGARd-7iN1Ijt2k",
    "lat": 35.6993585,
    "lng": 139.7707015,
    "placeId": "ChIJcUJuHqeOGGARd-7iN1Ijt2k",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5289-9933",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 3939,
    "district": "Akihabara"
  },
  {
    "id": 163,
    "title": "シャカシャカトレカ",
    "urlinform": "store-191",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://shakashakatoreka.myshopify.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVZW_Dh6MGGAR6jhiwbuukPs",
    "lat": 35.7024792,
    "lng": 139.7719921,
    "placeId": "ChIJVZW_Dh6MGGAR6jhiwbuukPs",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5289-3125",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 41,
    "district": "Akihabara"
  },
  {
    "id": 164,
    "title": "トレカショップサーカス",
    "urlinform": "store-194",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://toreca-shop-circus.square.site/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOXNu2LCPGGARx2OydYsgDdw",
    "lat": 35.750959,
    "lng": 139.7977023,
    "placeId": "ChIJOXNu2LCPGGARx2OydYsgDdw",
    "businessStatus": "OPERATIONAL",
    "phone": "080-9397-9529",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 125
  },
  {
    "id": 165,
    "title": "ANIME TREASURES ASAKUSA",
    "urlinform": "anime-treasures-asakusa",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJy1TBZACPGGARFsq3uvTLFWA",
    "lat": 35.710408,
    "lng": 139.7978802,
    "placeId": "ChIJy1TBZACPGGARFsq3uvTLFWA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 3.8,
    "userRatingsTotal": 6,
    "district": "Asakusa"
  },
  {
    "id": 166,
    "title": "Otakaraya Asakusaten",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.otakaraya-shop.jp/asakusa/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB69vX8GOGGARIqjCaV93h34",
    "lat": 35.713685,
    "lng": 139.7982682,
    "placeId": "ChIJB69vX8GOGGARIqjCaV93h34",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6231-6175",
    "openingHours": [
      "Monday: 10:30 AM – 6:30 PM",
      "Tuesday: 10:30 AM – 6:30 PM",
      "Wednesday: 10:30 AM – 6:30 PM",
      "Thursday: 10:30 AM – 6:30 PM",
      "Friday: 10:30 AM – 6:30 PM",
      "Saturday: 10:30 AM – 6:30 PM",
      "Sunday: 10:30 AM – 6:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 13,
    "district": "Asakusa"
  },
  {
    "id": 167,
    "title": "Daikokuya",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://shop.e-daikoku.com/info/spot/detail?code=0000000109",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWwvAsMaOGGARM8BK7uL7SN8",
    "lat": 35.7117696,
    "lng": 139.7976604,
    "placeId": "ChIJWwvAsMaOGGARM8BK7uL7SN8",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5826-0871",
    "openingHours": [
      "Monday: 10:30 AM – 7:00 PM",
      "Tuesday: 10:30 AM – 7:00 PM",
      "Wednesday: Closed",
      "Thursday: 10:30 AM – 7:00 PM",
      "Friday: 10:30 AM – 7:00 PM",
      "Saturday: 10:30 AM – 6:00 PM",
      "Sunday: 10:30 AM – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 109,
    "district": "Asakusa"
  },
  {
    "id": 168,
    "title": "Kamekore",
    "urlinform": "store-202",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "WS"
    ],
    "storeWebsite": "http://kamecolle.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJj8gH-ZiJGGARNFsPHONDwNY",
    "lat": 35.7003918,
    "lng": 139.8110495,
    "placeId": "ChIJj8gH-ZiJGGARNFsPHONDwNY",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6284-1395",
    "openingHours": [
      "Monday: 12:00 – 6:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 12:00 – 6:00 PM",
      "Friday: 12:00 – 6:00 PM",
      "Saturday: 11:00 AM – 5:00 PM",
      "Sunday: 11:00 AM – 5:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 68
  },
  {
    "id": 169,
    "title": "TSUTAYA Trading Card 錦糸町",
    "urlinform": "tsutaya-trading-card-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://store-tsutaya.tsite.jp/store/detail?storeId=2140",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGz5UIrCJGGARKFE9LOu4h-0",
    "lat": 35.6963119,
    "lng": 139.8156604,
    "placeId": "ChIJGz5UIrCJGGARKFE9LOu4h-0",
    "businessStatus": "OPERATIONAL",
    "phone": "080-5875-9392",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 9:00 PM"
    ],
    "rating": 2.4,
    "userRatingsTotal": 40
  },
  {
    "id": 170,
    "title": "Asakusa ROX",
    "urlinform": "rox",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.rox.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJeZhke7-OGGARZ4VBW5HhfZE",
    "lat": 35.7129393,
    "lng": 139.7928288,
    "placeId": "ChIJeZhke7-OGGARZ4VBW5HhfZE",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3845-7700",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 9:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 7370,
    "district": "Asakusa"
  },
  {
    "id": 171,
    "title": "100万ボルト トレカ専門店 / 100 Million Volts Pokémon & TCG Shop",
    "urlinform": "100-100-million-volts-pokmon-tcg-shop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://x.com/100man_bolt",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJl-gcVxzvGGAR7qJFn1PFD9M",
    "lat": 35.7023375,
    "lng": 139.5797416,
    "placeId": "ChIJl-gcVxzvGGAR7qJFn1PFD9M",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:30 – 10:30 PM",
      "Tuesday: 12:30 – 10:00 PM",
      "Wednesday: 12:30 – 10:00 PM",
      "Thursday: 12:30 – 10:00 PM",
      "Friday: 12:30 – 10:00 PM",
      "Saturday: 12:30 – 10:00 PM",
      "Sunday: 12:30 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 39,
    "district": "Kichijoji"
  },
  {
    "id": 172,
    "title": "トーナメントセンターバトロコ吉祥寺駅前",
    "urlinform": "store-206",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://bato-loco.com/1827info/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwWc2n9jvGGARYx2wylI-NHQ",
    "lat": 35.705206,
    "lng": 139.5788868,
    "placeId": "ChIJwWc2n9jvGGARYx2wylI-NHQ",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-27-5140",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 564,
    "district": "Kichijoji"
  },
  {
    "id": 173,
    "title": "トレカリオン",
    "urlinform": "store-207",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://tracarion.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_TDHVivvGGARpStuw5NRBek",
    "lat": 35.703919,
    "lng": 139.5817182,
    "placeId": "ChIJ_TDHVivvGGARpStuw5NRBek",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 62,
    "district": "Kichijoji"
  },
  {
    "id": 174,
    "title": "Full Comp",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.fullcomp.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTe0fxEfuGGARMGn2PpvFu6g",
    "lat": 35.7043588,
    "lng": 139.5798926,
    "placeId": "ChIJTe0fxEfuGGARMGn2PpvFu6g",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-23-2652",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 146,
    "district": "Kichijoji"
  },
  {
    "id": 175,
    "title": "Japan TCG Center 吉祥寺駅北口店",
    "urlinform": "japan-tcg-center-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.bookoff.co.jp/sell/hobby/shop/shop40401.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE90pM4nvGGAR2DMDLCvQBY8",
    "lat": 35.7048518,
    "lng": 139.5807738,
    "placeId": "ChIJE90pM4nvGGAR2DMDLCvQBY8",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-23-8260",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 2.7,
    "userRatingsTotal": 72,
    "district": "Kichijoji"
  },
  {
    "id": 176,
    "title": "MINT KICHIJOJI",
    "urlinform": "mint-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://mint-web.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjbS5aEjuGGARmxIIYh0-OGA",
    "lat": 35.7038191,
    "lng": 139.5778225,
    "placeId": "ChIJjbS5aEjuGGARmxIIYh0-OGA",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-27-6180",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 46,
    "district": "Kichijoji"
  },
  {
    "id": 177,
    "title": "Amenitidorimu Kichijojiten",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://amenitydream.co.jp/shop/tokyo-kichijoji/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd3dDskfuGGARH2xCyT2zvnI",
    "lat": 35.705278,
    "lng": 139.580745,
    "placeId": "ChIJd3dDskfuGGARH2xCyT2zvnI",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-22-9862",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 91,
    "district": "Kichijoji"
  },
  {
    "id": 178,
    "title": "Hareruya Kichijoji",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://www.hareruyamtg.com/ja/user_data/shop_kichijoji?shop=17",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt-PwfjLvGGARtIFhv8ijgu4",
    "lat": 35.7054601,
    "lng": 139.5756475,
    "placeId": "ChIJt-PwfjLvGGARtIFhv8ijgu4",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-27-6190",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 40,
    "district": "Kichijoji"
  },
  {
    "id": 179,
    "title": "Board game shop Sugorokuya Kichijoji branch",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://sugorokuya.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt14Jjnq7JhUR-0mf-sB7joU",
    "lat": 35.70509699999999,
    "lng": 139.5766518,
    "placeId": "ChIJt14Jjnq7JhUR-0mf-sB7joU",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-27-2570",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 240,
    "district": "Kichijoji"
  },
  {
    "id": 180,
    "title": "Billboard",
    "urlinform": "billboard",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.billboard-kj.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHY24s07uGGARVthZVl9Dl2s",
    "lat": 35.7055911,
    "lng": 139.5746277,
    "placeId": "ChIJHY24s07uGGARVthZVl9Dl2s",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-22-8119",
    "openingHours": [
      "Monday: 10:30 AM – 7:00 PM",
      "Tuesday: Closed",
      "Wednesday: 10:30 AM – 7:00 PM",
      "Thursday: 10:30 AM – 7:00 PM",
      "Friday: 10:30 AM – 7:00 PM",
      "Saturday: 10:30 AM – 7:00 PM",
      "Sunday: 10:30 AM – 7:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 77,
    "district": "Kichijoji"
  },
  {
    "id": 181,
    "title": "Kaitoridaikichi Kopisukichijojiten",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.kaitori-daikichi.jp/store/coppice-kichijoji/?utm_source=google&utm_medium=my_business&utm_campaign=top",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRcM08vnvGGAR8xzy90ybAF8",
    "lat": 35.7048164,
    "lng": 139.5793296,
    "placeId": "ChIJRcM08vnvGGAR8xzy90ybAF8",
    "businessStatus": "OPERATIONAL",
    "phone": "0120-537-001",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 499,
    "district": "Kichijoji"
  },
  {
    "id": 182,
    "title": "B-SIDE LABEL 吉祥寺店",
    "urlinform": "b-side-label-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Vanguard"
    ],
    "storeWebsite": "http://www.bside-label.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs6M09DfuGGARsFdhsPkeJi0",
    "lat": 35.7014559,
    "lng": 139.578768,
    "placeId": "ChIJs6M09DfuGGARsFdhsPkeJi0",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-24-8494",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 198,
    "district": "Kichijoji"
  },
  {
    "id": 183,
    "title": "キャラパーク吉祥寺",
    "urlinform": "store-219",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ__wyK0buGGARFeGGVmAZEE0",
    "lat": 35.7048704,
    "lng": 139.579227,
    "placeId": "ChIJ__wyK0buGGARFeGGVmAZEE0",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-29-2150",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 47,
    "district": "Kichijoji"
  },
  {
    "id": 184,
    "title": "カードショップクラクラ",
    "urlinform": "store-225",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXX-ot2TvGGARa3rBy9rv7kE",
    "lat": 35.7045882,
    "lng": 139.57719,
    "placeId": "ChIJXX-ot2TvGGARa3rBy9rv7kE",
    "businessStatus": "OPERATIONAL",
    "phone": "090-3456-2628",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 11,
    "district": "Kichijoji"
  },
  {
    "id": 185,
    "title": "London",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://london-game.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVVXWH0buGGARHeaoD3AiWEI",
    "lat": 35.7060013,
    "lng": 139.5789614,
    "placeId": "ChIJVVXWH0buGGARHeaoD3AiWEI",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-22-9225",
    "openingHours": [
      "Monday: 9:00 AM – 11:00 PM",
      "Tuesday: 9:00 AM – 11:00 PM",
      "Wednesday: 9:00 AM – 11:00 PM",
      "Thursday: 9:00 AM – 11:00 PM",
      "Friday: 9:00 AM – 10:30 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 105,
    "district": "Kichijoji"
  },
  {
    "id": 186,
    "title": "Caravan's Base（きゃらべ）",
    "urlinform": "caravans-base",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://caravansbase.com/kichijoji",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ693TrEjuGGARVCbJ51yUrQ0",
    "lat": 35.7068028,
    "lng": 139.5784638,
    "placeId": "ChIJ693TrEjuGGARVCbJ51yUrQ0",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-27-2720",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 11:00 PM",
      "Wednesday: 1:00 – 11:00 PM",
      "Thursday: 1:00 – 11:00 PM",
      "Friday: 1:00 – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 28,
    "district": "Kichijoji"
  },
  {
    "id": 187,
    "title": "Kaitoridaikichi Kichijojiten",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.kaitori-daikichi.jp/store/kichijoji/?utm_source=google&utm_medium=my_business&utm_campaign=top",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1aDJP0juGGARM0EcL9Al3z8",
    "lat": 35.7029614,
    "lng": 139.5777664,
    "placeId": "ChIJ1aDJP0juGGARM0EcL9Al3z8",
    "businessStatus": "OPERATIONAL",
    "phone": "0120-537-001",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 447,
    "district": "Kichijoji"
  },
  {
    "id": 188,
    "title": "ドラゴンスター町田店",
    "urlinform": "store-231",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://dorasuta.jp/?utm_source=GBP&utm_medium=GBP&utm_term=GBP&utm_content=GBP&utm_campaign=GBP015",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4zIkpcj5GGARHEyToabkYgI",
    "lat": 35.5418015,
    "lng": 139.4487921,
    "placeId": "ChIJ4zIkpcj5GGARHEyToabkYgI",
    "businessStatus": "OPERATIONAL",
    "phone": "042-850-8066",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 61,
    "district": "Machida"
  },
  {
    "id": 189,
    "title": "ホロカード町田店",
    "urlinform": "store-232",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "WS"
    ],
    "storeWebsite": "https://holocard.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4x5DeQD_GGARG9dCy1dm7jw",
    "lat": 35.5437796,
    "lng": 139.4462801,
    "placeId": "ChIJ4x5DeQD_GGARG9dCy1dm7jw",
    "businessStatus": "OPERATIONAL",
    "phone": "042-794-7790",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 19,
    "district": "Machida"
  },
  {
    "id": 190,
    "title": "ナタデココ 町田店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/coco_machidaten",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCeXdmbz_GGARjlKeCOkZSD8",
    "lat": 35.5433323,
    "lng": 139.4465161,
    "placeId": "ChIJCeXdmbz_GGARjlKeCOkZSD8",
    "businessStatus": "OPERATIONAL",
    "phone": "090-9493-1847",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 40,
    "district": "Machida"
  },
  {
    "id": 191,
    "title": "Hobby Station",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.hbst.net/shop/13/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJwDcVbP-GGARwTYy49ihoRo",
    "lat": 35.5443463,
    "lng": 139.4467005,
    "placeId": "ChIJJwDcVbP-GGARwTYy49ihoRo",
    "businessStatus": "OPERATIONAL",
    "phone": "042-726-7581",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 128,
    "district": "Machida"
  },
  {
    "id": 192,
    "title": "The TCG Shop MACHIDA",
    "urlinform": "the-tcg-shop-machida",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/TheTCGShopMD",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ13ozaen_GGAR9LvBpEwj6R0",
    "lat": 35.5465496,
    "lng": 139.4446856,
    "placeId": "ChIJ13ozaen_GGAR9LvBpEwj6R0",
    "businessStatus": "OPERATIONAL",
    "phone": "042-860-7031",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 113,
    "district": "Machida"
  },
  {
    "id": 193,
    "title": "トレカライザス町田店",
    "urlinform": "store-236",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://torecarises.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAR78T4D_GGARu0jI2pDag6o",
    "lat": 35.5437796,
    "lng": 139.4462801,
    "placeId": "ChIJAR78T4D_GGARu0jI2pDag6o",
    "businessStatus": "OPERATIONAL",
    "phone": "042-794-7790",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 55,
    "district": "Machida"
  },
  {
    "id": 194,
    "title": "Amenity Dream Machida",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://amenitydream.co.jp/shop/tokyo-machida/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaaNkYEv5GGARpSI_d_q_vlU",
    "lat": 35.5438998,
    "lng": 139.4480142,
    "placeId": "ChIJaaNkYEv5GGARpSI_d_q_vlU",
    "businessStatus": "OPERATIONAL",
    "phone": "042-851-7796",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 121,
    "district": "Machida"
  },
  {
    "id": 195,
    "title": "Full Comp Machida",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.fullcomp.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjUFORkv5GGARfCpkzaP6K-U",
    "lat": 35.5430217,
    "lng": 139.447273,
    "placeId": "ChIJjUFORkv5GGARfCpkzaP6K-U",
    "businessStatus": "OPERATIONAL",
    "phone": "042-727-3330",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 2.1,
    "userRatingsTotal": 204,
    "district": "Machida"
  },
  {
    "id": 196,
    "title": "Ryusei no PAO Machida Store",
    "urlinform": "pao",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.az-zone.com/toreka/access/machida/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg2ExcOz_GGAR6yoQUC3jG7k",
    "lat": 35.5422264,
    "lng": 139.4471637,
    "placeId": "ChIJg2ExcOz_GGAR6yoQUC3jG7k",
    "businessStatus": "OPERATIONAL",
    "phone": "042-709-4780",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 229,
    "district": "Machida"
  },
  {
    "id": 197,
    "title": "カードショップADO",
    "urlinform": "ado",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/ado_tcg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJH8GKOgD_GGAR0BAgQfZ3l6o",
    "lat": 35.5435427,
    "lng": 139.4460307,
    "placeId": "ChIJH8GKOgD_GGAR0BAgQfZ3l6o",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 7:30 PM",
      "Tuesday: 1:00 – 7:30 PM",
      "Wednesday: 1:00 – 7:30 PM",
      "Thursday: 1:00 – 7:30 PM",
      "Friday: 1:00 – 7:30 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 75,
    "district": "Machida"
  },
  {
    "id": 198,
    "title": "カードショップ CowCowLuca 町田店",
    "urlinform": "poker-room-g3-cowcowluca-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cowcowluca.official.ec/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7_EGuEj5GGAR0HGaeBT5Xlc",
    "lat": 35.541106,
    "lng": 139.4490233,
    "placeId": "ChIJ7_EGuEj5GGAR0HGaeBT5Xlc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 4:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 41,
    "district": "Machida"
  },
  {
    "id": 199,
    "title": "Otakaraatto Market Machi Daten",
    "urlinform": "store-242",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "One Piece"
    ],
    "storeWebsite": "http://www.e-otakara.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVeN5Ylr8GGARyftj7Mw_pSo",
    "lat": 35.575088,
    "lng": 139.4169431,
    "placeId": "ChIJVeN5Ylr8GGARyftj7Mw_pSo",
    "businessStatus": "OPERATIONAL",
    "phone": "042-791-8121",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 366
  },
  {
    "id": 200,
    "title": "Yellow Submarine Machida card shop",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.yellowsubmarine.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxcropUz5GGARZSGyTe-Jo8o",
    "lat": 35.5440712,
    "lng": 139.4472558,
    "placeId": "ChIJxcropUz5GGARZSGyTe-Jo8o",
    "businessStatus": "OPERATIONAL",
    "phone": "042-739-6966",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 106,
    "district": "Machida"
  },
  {
    "id": 201,
    "title": "Hareruya Machida",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://shops.hareruyamtg.com/machida/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_WIlHcb_GGAR383xPgVKDGY",
    "lat": 35.545677,
    "lng": 139.4457366,
    "placeId": "ChIJ_WIlHcb_GGAR383xPgVKDGY",
    "businessStatus": "OPERATIONAL",
    "phone": "042-816-3292",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 41,
    "district": "Machida"
  },
  {
    "id": 202,
    "title": "カードショップVISTA",
    "urlinform": "vista",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmw9g5_f5GGAR41SXioChS1U",
    "lat": 35.5417099,
    "lng": 139.4474842,
    "placeId": "ChIJmw9g5_f5GGAR41SXioChS1U",
    "businessStatus": "OPERATIONAL",
    "phone": "080-7128-1615",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 31,
    "district": "Machida"
  },
  {
    "id": 203,
    "title": "Ryusei no PAO Tama Sakai Store",
    "urlinform": "pao-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/PAOtoreka_tama",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhbj5yKrjGGARDn8rCS0Ta_0",
    "lat": 35.6026335,
    "lng": 139.3727071,
    "placeId": "ChIJhbj5yKrjGGARDn8rCS0Ta_0",
    "businessStatus": "OPERATIONAL",
    "phone": "042-860-1380",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 53
  },
  {
    "id": 204,
    "title": "Treasure Factory Machida",
    "urlinform": "store-250",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.treasure-f.com/shop/18/?utm_source=google&utm_medium=maps",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJ7bjpqn-GGARkQTqES_lbKo",
    "lat": 35.5524457,
    "lng": 139.4398604,
    "placeId": "ChIJJ7bjpqn-GGARkQTqES_lbKo",
    "businessStatus": "OPERATIONAL",
    "phone": "042-710-7133",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 627,
    "district": "Machida"
  },
  {
    "id": 205,
    "title": "トレカ専門店 CANTRIP（キャントリップ）",
    "urlinform": "-cantrip",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Flesh and Blood",
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://cantripmtg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnwNmHKcdGWAR303One3CBTA",
    "lat": 35.6576259,
    "lng": 139.3371696,
    "placeId": "ChIJnwNmHKcdGWAR303One3CBTA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 16
  },
  {
    "id": 206,
    "title": "TreFacStyle Machida-Naruse",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.tf-style.com/shop/40/?utm_source=google&utm_medium=maps",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVzlrwRv5GGARon-320wHRZw",
    "lat": 35.537124,
    "lng": 139.4730342,
    "placeId": "ChIJVzlrwRv5GGARon-320wHRZw",
    "businessStatus": "OPERATIONAL",
    "phone": "042-732-2277",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 621
  },
  {
    "id": 207,
    "title": "magi八王子オクトーレ店",
    "urlinform": "magi",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/magi_hachioji",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE_ZG8UQdGWARFnlvkDeoZZg",
    "lat": 35.6574381,
    "lng": 139.3386299,
    "placeId": "ChIJE_ZG8UQdGWARFnlvkDeoZZg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 70
  },
  {
    "id": 208,
    "title": "トレカマスター 銀座本店【LPC JAPAN STUDIO】",
    "urlinform": "-lpc-japan-studio",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lpc-japan-studio.tokyo/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4Qf02OuLGGARZ03vaX30fSM",
    "lat": 35.6698314,
    "lng": 139.7650283,
    "placeId": "ChIJ4Qf02OuLGGARZ03vaX30fSM",
    "businessStatus": "OPERATIONAL",
    "phone": "080-4950-1355",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 40,
    "district": "Ginza"
  },
  {
    "id": 209,
    "title": "HAKUHINKAN TOY PARK",
    "urlinform": "-toy-park-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hakuhinkan.co.jp/toypark/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3YrfXuiLGGARBY7VHh2WK9g",
    "lat": 35.6677914,
    "lng": 139.7611249,
    "placeId": "ChIJ3YrfXuiLGGARBY7VHh2WK9g",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3571-8008",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 4080,
    "district": "Ginza"
  },
  {
    "id": 210,
    "title": "Tokyo Hobby Center anime store",
    "urlinform": "store-260",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/baymaxmochi2?t=_7q-Fgsb-_Ntotr_9mjqpw&s=09",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbyaHUpGNGGARkPFegVqy5YU",
    "lat": 35.7030702,
    "lng": 139.7721498,
    "placeId": "ChIJbyaHUpGNGGARkPFegVqy5YU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 324,
    "district": "Akihabara"
  },
  {
    "id": 211,
    "title": "TokyoMTG",
    "urlinform": "mtg",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://tokyomtg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmahpf0CMGGARcOSJyj78VrM",
    "lat": 35.6961509,
    "lng": 139.7750724,
    "placeId": "ChIJmahpf0CMGGARcOSJyj78VrM",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5207-2697",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 513,
    "district": "Nakasu"
  },
  {
    "id": 212,
    "title": "Chopsticks Studio Ginza",
    "urlinform": "chopsticks-studio-ginza",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://s.klook.com/c/JwQ9ojPJX2",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWbAa0p-LGGARUovWP5hMvjk",
    "lat": 35.6731184,
    "lng": 139.7694118,
    "placeId": "ChIJWbAa0p-LGGARUovWP5hMvjk",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5915-4155",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 7:00 PM",
      "Friday: 9:00 AM – 7:00 PM",
      "Saturday: 9:00 AM – 7:00 PM",
      "Sunday: 9:00 AM – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1703,
    "district": "Ginza"
  },
  {
    "id": 213,
    "title": "STOCK +",
    "urlinform": "store-266",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://stock-plus.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJu3vKVOeLGGARYFA8502GXtE",
    "lat": 35.6685479,
    "lng": 139.7679873,
    "placeId": "ChIJu3vKVOeLGGARYFA8502GXtE",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5148-5525",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.6,
    "userRatingsTotal": 62,
    "district": "Ginza"
  },
  {
    "id": 214,
    "title": "Ms.Vintage",
    "urlinform": "msvintage",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.bighit.co.jp/index.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJz_wmo0mLGGAR6dyuIoWyxgk",
    "lat": 35.6720136,
    "lng": 139.7683837,
    "placeId": "ChIJz_wmo0mLGGAR6dyuIoWyxgk",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6228-4017",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 285,
    "district": "Ginza"
  },
  {
    "id": 215,
    "title": "アキバカードショップ メルカード1号店",
    "urlinform": "-1",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://akihabara-cardshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-TTCrtCNGGARF-FEcABTPxE",
    "lat": 35.6993045,
    "lng": 139.770439,
    "placeId": "ChIJ-TTCrtCNGGARF-FEcABTPxE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.1,
    "userRatingsTotal": 173,
    "district": "Akihabara"
  },
  {
    "id": 216,
    "title": "TRADER Headquarters",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.e-trader.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQf-fxR2MGGAR9xsIA9YXSfQ",
    "lat": 35.7001591,
    "lng": 139.7716623,
    "placeId": "ChIJQf-fxR2MGGAR9xsIA9YXSfQ",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3255-3493",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 945,
    "district": "Akihabara"
  },
  {
    "id": 217,
    "title": "ポケモンカード専門店 MERO 東京・日本橋",
    "urlinform": "-mero-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://x.com/mero_nihonbasi?s=21&t=n9B3E6XKitvWUt5vivkDxg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJdw9TF-uJGGARSrA3eqbxU-E",
    "lat": 35.6812898,
    "lng": 139.7751065,
    "placeId": "ChIJdw9TF-uJGGARSrA3eqbxU-E",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 7:00 PM",
      "Tuesday: 10:30 AM – 7:00 PM",
      "Wednesday: 10:30 AM – 7:00 PM",
      "Thursday: 10:30 AM – 7:00 PM",
      "Friday: 10:30 AM – 7:00 PM",
      "Saturday: 10:30 AM – 7:00 PM",
      "Sunday: 10:30 AM – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 210
  },
  {
    "id": 218,
    "title": "POKEMON-TCG-SUPPLY",
    "urlinform": "pokemon-tcg-supply",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLXPQiMaFImAR2rV2Khld4Io",
    "lat": 35.6070484,
    "lng": 140.1126749,
    "placeId": "ChIJLXPQiMaFImAR2rV2Khld4Io",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9323-1507",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3.1,
    "userRatingsTotal": 8,
    "district": "Chiba"
  },
  {
    "id": 219,
    "title": "Hareruya Chiba",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://www.hareruyamtg.com/ja/user_data/shop_chiba?shop=26",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqYhYB1mFImARIwnvYZthaKY",
    "lat": 35.6120613,
    "lng": 140.1159329,
    "placeId": "ChIJqYhYB1mFImARIwnvYZthaKY",
    "businessStatus": "OPERATIONAL",
    "phone": "043-216-3770",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 40,
    "district": "Chiba"
  },
  {
    "id": 220,
    "title": "Pokémon Center Tokyo Bay",
    "urlinform": "store-276",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/tokyobay/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc69mrMd_GGARqyFzb4LUWp4",
    "lat": 35.6866032,
    "lng": 139.9890362,
    "placeId": "ChIJc69mrMd_GGARqyFzb4LUWp4",
    "businessStatus": "OPERATIONAL",
    "phone": "047-404-8461",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 1499
  },
  {
    "id": 221,
    "title": "Ryusei no PAO Chiba Chuo Store",
    "urlinform": "pao",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.az-zone.com/toreka/access/chiba/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOQIO69uFImARtW2VwGPvXik",
    "lat": 35.6082546,
    "lng": 140.1185042,
    "placeId": "ChIJOQIO69uFImARtW2VwGPvXik",
    "businessStatus": "OPERATIONAL",
    "phone": "043-205-4680",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 2.7,
    "userRatingsTotal": 153,
    "district": "Chiba"
  },
  {
    "id": 222,
    "title": "Japan TCG Center 千葉駅前店",
    "urlinform": "japan-tcg-center-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/JTC_CHIBA",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcYukq8uFImARuome2npV4X4",
    "lat": 35.6118242,
    "lng": 140.1167788,
    "placeId": "ChIJcYukq8uFImARuome2npV4X4",
    "businessStatus": "OPERATIONAL",
    "phone": "070-5073-5567",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 2.5,
    "userRatingsTotal": 38,
    "district": "Chiba"
  },
  {
    "id": 223,
    "title": "Hobisuteshonchibaten",
    "urlinform": "store-279",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.hbst.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxV050LCEImARwUuuXQG4vJA",
    "lat": 35.6094866,
    "lng": 140.1173451,
    "placeId": "ChIJxV050LCEImARwUuuXQG4vJA",
    "businessStatus": "OPERATIONAL",
    "phone": "043-224-1717",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 107,
    "district": "Chiba"
  },
  {
    "id": 224,
    "title": "C-Labo Chiba Chuo",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.c-labo.jp/shop/chibatyuuou.shtml",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgVTtHrWEImARcZwYiQUSnJQ",
    "lat": 35.6071339,
    "lng": 140.1192899,
    "placeId": "ChIJgVTtHrWEImARcZwYiQUSnJQ",
    "businessStatus": "OPERATIONAL",
    "phone": "043-306-5090",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 2.9,
    "userRatingsTotal": 171,
    "district": "Chiba"
  },
  {
    "id": 225,
    "title": "MINT 千葉店 スポーツカード＆カードゲーム",
    "urlinform": "-mint-chiba-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://mint-web.jp/?pid=4244751",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsbm_1baEImARQy7hXuKNJ3k",
    "lat": 35.6115809,
    "lng": 140.1166454,
    "placeId": "ChIJsbm_1baEImARQy7hXuKNJ3k",
    "businessStatus": "OPERATIONAL",
    "phone": "043-221-4733",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 42,
    "district": "Chiba"
  },
  {
    "id": 226,
    "title": "JOKER TCG",
    "urlinform": "joker-tcg",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/joker_tcg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVTfOQJmdGGARrLzacocUfLk",
    "lat": 35.8718723,
    "lng": 140.0130278,
    "placeId": "ChIJVTfOQJmdGGARrLzacocUfLk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 136
  },
  {
    "id": 227,
    "title": "カードショップ イブ千葉中央店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/cardshop_eve_ch",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVzAMtzGFImARSx3qF_vvmwI",
    "lat": 35.6072568,
    "lng": 140.1190823,
    "placeId": "ChIJVzAMtzGFImARSx3qF_vvmwI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 119,
    "district": "Chiba"
  },
  {
    "id": 228,
    "title": "ホビーステーション GLOBO蘇我店",
    "urlinform": "-globo",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://www.hbst.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJr6qbvA2bImARp2b2m7VL_h0",
    "lat": 35.579098,
    "lng": 140.1252702,
    "placeId": "ChIJr6qbvA2bImARp2b2m7VL_h0",
    "businessStatus": "OPERATIONAL",
    "phone": "043-261-2137",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 119
  },
  {
    "id": 229,
    "title": "Card shop EDEN",
    "urlinform": "card-shop-eden",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbyfCzWSFImARa5YEQ-LNTdc",
    "lat": 35.6039477,
    "lng": 140.1244985,
    "placeId": "ChIJbyfCzWSFImARa5YEQ-LNTdc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 12
  },
  {
    "id": 230,
    "title": "『LOTUS』SELECT SHOP 八千代台 買取 スニーカー 古着 千葉 津田沼 船橋 ポケカ ポケモン カード",
    "urlinform": "lotusselect-shop-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://lotusnet.theshop.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi1niQQSBImARPriFERj4frM",
    "lat": 35.6992953,
    "lng": 140.0888961,
    "placeId": "ChIJi1niQQSBImARPriFERj4frM",
    "businessStatus": "OPERATIONAL",
    "phone": "090-1390-5468",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: Closed",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 282
  },
  {
    "id": 231,
    "title": "カードショップEDEN 千葉中央店",
    "urlinform": "eden-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJV4aXdLaFImARY7CzIpBsSq8",
    "lat": 35.6067724,
    "lng": 140.1189282,
    "placeId": "ChIJV4aXdLaFImARY7CzIpBsSq8",
    "businessStatus": "OPERATIONAL",
    "phone": "070-5268-3973",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 1:00 PM – 12:00 AM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 34,
    "district": "Chiba"
  },
  {
    "id": 232,
    "title": "カードショップNEM 千葉店",
    "urlinform": "-nem-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.nemcard.com/view/page/chiba",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi-g9YUeFImAR7stIR0nW50A",
    "lat": 35.6124092,
    "lng": 140.1182631,
    "placeId": "ChIJi-g9YUeFImAR7stIR0nW50A",
    "businessStatus": "OPERATIONAL",
    "phone": "043-400-2455",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 12,
    "district": "Chiba"
  },
  {
    "id": 233,
    "title": "フルコンプ 千葉店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.fullcomp.jp/chiba/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHSo0EwCFImAR6GcVu8_H69w",
    "lat": 35.6120613,
    "lng": 140.1159329,
    "placeId": "ChIJHSo0EwCFImAR6GcVu8_H69w",
    "businessStatus": "OPERATIONAL",
    "phone": "043-221-2652",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 53,
    "district": "Chiba"
  },
  {
    "id": 234,
    "title": "ホビーショップDICE",
    "urlinform": "dice",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/hobbyshopdice",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKWI4Bu6fImARglyrP_E1xm4",
    "lat": 35.5139367,
    "lng": 140.0889523,
    "placeId": "ChIJKWI4Bu6fImARglyrP_E1xm4",
    "businessStatus": "OPERATIONAL",
    "phone": "0436-98-3978",
    "openingHours": [
      "Monday: 12:30 – 9:00 PM",
      "Tuesday: 12:30 – 9:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:30 – 9:00 PM",
      "Friday: 12:30 – 9:00 PM",
      "Saturday: 12:30 – 9:00 PM",
      "Sunday: 12:30 – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 35
  },
  {
    "id": 235,
    "title": "カードショップ BIBIT (ビビット) 千葉中央駅前店",
    "urlinform": "-bibit-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/bibit_tcg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtagYfwCFImAR5l3twasSSxg",
    "lat": 35.6068909,
    "lng": 140.1188794,
    "placeId": "ChIJtagYfwCFImAR5l3twasSSxg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: Closed",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 37,
    "district": "Chiba"
  },
  {
    "id": 236,
    "title": "Lashinbang Chiba Store",
    "urlinform": "store-297",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lashinbang.com/store/30/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB2uoHrWEImARNrZ-dHxGkmk",
    "lat": 35.607212,
    "lng": 140.1190871,
    "placeId": "ChIJB2uoHrWEImARNrZ-dHxGkmk",
    "businessStatus": "OPERATIONAL",
    "phone": "0570-008-620",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 98,
    "district": "Chiba"
  },
  {
    "id": 237,
    "title": "ナタデココ 千葉中央店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/coco_chibachuo",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ11YKGgCFImARJdnQHj8oSOQ",
    "lat": 35.60727,
    "lng": 140.1188389,
    "placeId": "ChIJ11YKGgCFImARJdnQHj8oSOQ",
    "businessStatus": "OPERATIONAL",
    "phone": "070-3278-3935",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 28,
    "district": "Chiba"
  },
  {
    "id": 238,
    "title": "Pokémon Center Yokohama",
    "urlinform": "store-299",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/yokohama/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmUq8Dl1cGGAR-BxAyWCKE04",
    "lat": 35.4645717,
    "lng": 139.6244898,
    "placeId": "ChIJmUq8Dl1cGGAR-BxAyWCKE04",
    "businessStatus": "OPERATIONAL",
    "phone": "045-453-3051",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 2163,
    "district": "Yokohama"
  },
  {
    "id": 239,
    "title": "Toreca Top Yokohama | TCG Specialty Store",
    "urlinform": "tcg-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/torecatop_ykhm",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJj_nsPTpdGGAR26QMF4R485o",
    "lat": 35.4618125,
    "lng": 139.6168641,
    "placeId": "ChIJj_nsPTpdGGAR26QMF4R485o",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 6:30 PM",
      "Thursday: 1:00 – 6:30 PM",
      "Friday: 1:00 – 6:30 PM",
      "Saturday: 1:00 – 6:30 PM",
      "Sunday: 1:00 – 6:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 123,
    "district": "Yokohama"
  },
  {
    "id": 240,
    "title": "ニンニン横浜店",
    "urlinform": "store-301",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://nin-nin-pokeka.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxTWTDdxdGGARyqVIWMX_9I0",
    "lat": 35.463957,
    "lng": 139.6196786,
    "placeId": "ChIJxTWTDdxdGGARyqVIWMX_9I0",
    "businessStatus": "OPERATIONAL",
    "phone": "045-534-3178",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 7,
    "district": "Yokohama"
  },
  {
    "id": 241,
    "title": "Pokémon Center Yokohama Satellite",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://shop.pokemon.co.jp/ja/shop/pokemoncenter-yokohama-satellite/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWWzkegBdGGARROpvGzvvQUk",
    "lat": 35.4668023,
    "lng": 139.6213024,
    "placeId": "ChIJWWzkegBdGGARROpvGzvvQUk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 35,
    "district": "Yokohama"
  },
  {
    "id": 242,
    "title": "Poke Tcg Japan",
    "urlinform": "poke-tcg-japan",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://englishpokemoncards.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY8Gcd5BdGGAR93LwJJHkLts",
    "lat": 35.4618125,
    "lng": 139.6168641,
    "placeId": "ChIJY8Gcd5BdGGAR93LwJJHkLts",
    "businessStatus": "OPERATIONAL",
    "phone": "080-2420-4898",
    "openingHours": [
      "Monday: 7:30 AM – 6:00 PM",
      "Tuesday: 7:30 AM – 6:00 PM",
      "Wednesday: 7:30 AM – 6:00 PM",
      "Thursday: 8:00 AM – 6:00 PM",
      "Friday: 7:30 AM – 6:00 PM",
      "Saturday: 10:00 AM – 5:00 PM",
      "Sunday: Closed"
    ],
    "rating": 2.4,
    "userRatingsTotal": 8,
    "district": "Yokohama"
  },
  {
    "id": 243,
    "title": "MINT YOKOHAMA",
    "urlinform": "mint-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://mint-web.jp/?pid=4245019",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY6oIqhFcGGAR-hp2WKmn0ss",
    "lat": 35.4645561,
    "lng": 139.6246488,
    "placeId": "ChIJY6oIqhFcGGAR-hp2WKmn0ss",
    "businessStatus": "OPERATIONAL",
    "phone": "045-594-9800",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 156,
    "district": "Yokohama"
  },
  {
    "id": 244,
    "title": "カードショップアシスト 横浜店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/assist_poke_op",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXes3AKVdGGARs4DaObjwgKY",
    "lat": 35.4641648,
    "lng": 139.6196172,
    "placeId": "ChIJXes3AKVdGGARs4DaObjwgKY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 1074,
    "district": "Yokohama"
  },
  {
    "id": 245,
    "title": "Traca Park Yokohama Nishiguchi",
    "urlinform": "store-306",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.furu1.net/shop/shop0140.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcZvDaAxcGGAR_OeTrtR2pms",
    "lat": 35.4631345,
    "lng": 139.6157056,
    "placeId": "ChIJcZvDaAxcGGAR_OeTrtR2pms",
    "businessStatus": "OPERATIONAL",
    "phone": "045-316-4605",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 94,
    "district": "Yokohama"
  },
  {
    "id": 246,
    "title": "TCG専門店 トレカSOUL 横浜店",
    "urlinform": "tcg-soul-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2bcMBwBdGGARrostf4PhInU",
    "lat": 35.4629454,
    "lng": 139.616084,
    "placeId": "ChIJ2bcMBwBdGGARrostf4PhInU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 171,
    "district": "Yokohama"
  },
  {
    "id": 247,
    "title": "Card Box Yokohama Nishiguchi",
    "urlinform": "store-309",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardbox.online/shop/detail/5003/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK4Esyg1cGGARPNP7SE7zrqY",
    "lat": 35.4633625,
    "lng": 139.6161836,
    "placeId": "ChIJK4Esyg1cGGARPNP7SE7zrqY",
    "businessStatus": "OPERATIONAL",
    "phone": "045-620-6225",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 125,
    "district": "Yokohama"
  },
  {
    "id": 248,
    "title": "magi横浜西口店",
    "urlinform": "magi",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Digimon",
      "MTG",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardshopmagi.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCY0Ar5JdGGARsEdEwkRBnY0",
    "lat": 35.4629546,
    "lng": 139.6178268,
    "placeId": "ChIJCY0Ar5JdGGARsEdEwkRBnY0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 51,
    "district": "Yokohama"
  },
  {
    "id": 249,
    "title": "Ryusei no PAO Yokohama Store",
    "urlinform": "pao",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.az-zone.com/toreka/access/yokohama/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-SGNxSJdGGAR51OAS7v6R8g",
    "lat": 35.4639264,
    "lng": 139.6198462,
    "placeId": "ChIJ-SGNxSJdGGAR51OAS7v6R8g",
    "businessStatus": "OPERATIONAL",
    "phone": "045-577-4380",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 2.9,
    "userRatingsTotal": 132,
    "district": "Yokohama"
  },
  {
    "id": 250,
    "title": "Card Box Yokohama Main Store",
    "urlinform": "store-312",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardbox.online/shop/detail/5034/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3ZvNcxtdGGARmCdCsQmyVMM",
    "lat": 35.463289,
    "lng": 139.6164027,
    "placeId": "ChIJ3ZvNcxtdGGARmCdCsQmyVMM",
    "businessStatus": "OPERATIONAL",
    "phone": "045-620-3347",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 126,
    "district": "Yokohama"
  },
  {
    "id": 251,
    "title": "Furukonpu Yokohamaten",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.fullcomp.jp/yokohama/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXaHtpg1cGGARDsDt0PSkAco",
    "lat": 35.4637139,
    "lng": 139.6179961,
    "placeId": "ChIJXaHtpg1cGGARDsDt0PSkAco",
    "businessStatus": "OPERATIONAL",
    "phone": "045-314-2652",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 202,
    "district": "Yokohama"
  },
  {
    "id": 252,
    "title": "ポケモンカードゲーム",
    "urlinform": "store-314",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmzSebABbGGARFX6TxrSXR1c",
    "lat": 35.4587007,
    "lng": 139.5946525,
    "placeId": "ChIJmzSebABbGGARFX6TxrSXR1c",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 5:00 AM – 12:00 AM",
      "Tuesday: 5:00 AM – 12:00 AM",
      "Wednesday: 5:00 AM – 12:00 AM",
      "Thursday: 5:00 AM – 12:00 AM",
      "Friday: 5:00 AM – 12:00 AM",
      "Saturday: 5:00 AM – 12:00 AM",
      "Sunday: 5:00 AM – 12:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 2
  },
  {
    "id": 253,
    "title": "Trading Card Game Shop AMENITY DREAM",
    "urlinform": "store-316",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://amenitydream.co.jp/shop/kanagawa-yokohama/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7VhEMgxcGGAR6mvKtiGEdQ8",
    "lat": 35.4639521,
    "lng": 139.619821,
    "placeId": "ChIJ7VhEMgxcGGAR6mvKtiGEdQ8",
    "businessStatus": "OPERATIONAL",
    "phone": "045-324-4077",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.1,
    "userRatingsTotal": 168,
    "district": "Yokohama"
  },
  {
    "id": 254,
    "title": "Hareruya Yokohama",
    "urlinform": "mtg-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://www.hareruyamtg.com/ja/user_data/shop_yokohama?shop=10",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_1RcQ5tdGGARSXeCz6k5wOo",
    "lat": 35.4697167,
    "lng": 139.6243101,
    "placeId": "ChIJ_1RcQ5tdGGARSXeCz6k5wOo",
    "businessStatus": "OPERATIONAL",
    "phone": "045-534-5466",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 93,
    "district": "Yokohama"
  },
  {
    "id": 255,
    "title": "Card Box Yokohama West 2nd",
    "urlinform": "2",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardbox.online/shop/detail/5023/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb6l1ALFdGGARIbXLt6ATFCs",
    "lat": 35.464085,
    "lng": 139.6164625,
    "placeId": "ChIJb6l1ALFdGGARIbXLt6ATFCs",
    "businessStatus": "OPERATIONAL",
    "phone": "045-620-9977",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 2.9,
    "userRatingsTotal": 97,
    "district": "Yokohama"
  },
  {
    "id": 256,
    "title": "Timunakayamaten",
    "urlinform": "store-321",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://tim-tcg.com/archives/storeinfo/nakayama/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ-EumwVYGGARvkebztbRy_8",
    "lat": 35.5147748,
    "lng": 139.5366463,
    "placeId": "ChIJZ-EumwVYGGARvkebztbRy_8",
    "businessStatus": "OPERATIONAL",
    "phone": "045-937-5160",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 1:00 – 8:30 PM",
      "Sunday: 1:00 – 8:30 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 60
  },
  {
    "id": 257,
    "title": "Batoloco Yokohama Isezakicho",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://bato-loco.com/1808info",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSZBKXIFdGGARsn-2TFjfS-E",
    "lat": 35.4428039,
    "lng": 139.6299915,
    "placeId": "ChIJSZBKXIFdGGARsn-2TFjfS-E",
    "businessStatus": "OPERATIONAL",
    "phone": "045-308-8631",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 2.5,
    "userRatingsTotal": 101
  },
  {
    "id": 258,
    "title": "ANIBASE YOKOHAMA",
    "urlinform": "anibase-yokohama",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://anibase-yokohama.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ525LFMldGGARbOFDptdki4Y",
    "lat": 35.4413983,
    "lng": 139.6461922,
    "placeId": "ChIJ525LFMldGGARbOFDptdki4Y",
    "businessStatus": "OPERATIONAL",
    "phone": "045-264-6573",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 53
  },
  {
    "id": 259,
    "title": "Bandai Namco Cross Store Yokohama",
    "urlinform": "-cross-store-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Gundam",
      "Pokémon"
    ],
    "storeWebsite": "https://bandainamco-am.co.jp/game_center/loc/yokohama-wp2/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ849q3E5dGGARXMsFEnofIM0",
    "lat": 35.45436,
    "lng": 139.638114,
    "placeId": "ChIJ849q3E5dGGARXMsFEnofIM0",
    "businessStatus": "OPERATIONAL",
    "phone": "0570-076-561",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 608
  },
  {
    "id": 260,
    "title": "Lashinbang Yokohama Store",
    "urlinform": "store-327",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lashinbang.com/store/28/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFRUAOBNcGGARXiemWpjeJ6I",
    "lat": 35.464299,
    "lng": 139.6199878,
    "placeId": "ChIJFRUAOBNcGGARXiemWpjeJ6I",
    "businessStatus": "OPERATIONAL",
    "phone": "0570-008-620",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 193,
    "district": "Yokohama"
  },
  {
    "id": 261,
    "title": "ナタデココ 横浜店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/coco_yocohama",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc-OIDdFdGGAR1w1feXFgf78",
    "lat": 35.4648994,
    "lng": 139.618027,
    "placeId": "ChIJc-OIDdFdGGAR1w1feXFgf78",
    "businessStatus": "OPERATIONAL",
    "phone": "070-6643-5411",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 111,
    "district": "Yokohama"
  },
  {
    "id": 262,
    "title": "TCG Force",
    "urlinform": "store-332",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJU8fmTRFdGGARLGgDGpeq0mw",
    "lat": 35.4631947,
    "lng": 139.6175977,
    "placeId": "ChIJU8fmTRFdGGARLGgDGpeq0mw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 200,
    "district": "Yokohama"
  },
  {
    "id": 263,
    "title": "ポケカ専門店WonderOnce鶴見店",
    "urlinform": "wonderonce",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.instagram.com/pokemon_alicen/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-a5iiWtfGGAR6-up0ODlC7Q",
    "lat": 35.5139418,
    "lng": 139.6740996,
    "placeId": "ChIJ-a5iiWtfGGAR6-up0ODlC7Q",
    "businessStatus": "OPERATIONAL",
    "phone": "080-6627-3344",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 51
  },
  {
    "title": "TCG Shop MAGIC PLANET 千日前店",
    "urlinform": "tcg-shop-magic-planet-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpyEmLnbnAGARct4p_ulR4g4",
    "lat": 34.6677769,
    "lng": 135.5030403,
    "placeId": "ChIJpyEmLnbnAGARct4p_ulR4g4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 615,
    "id": 264,
    "district": "Namba"
  },
  {
    "title": "cardshop Gotcha!",
    "urlinform": "-gotcha",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://cardshop-gotcha.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_-Yqn47nAGAR4jYTMSVUYGc",
    "lat": 34.6623394,
    "lng": 135.5039016,
    "placeId": "ChIJ_-Yqn47nAGAR4jYTMSVUYGc",
    "businessStatus": "OPERATIONAL",
    "phone": "070-4807-7059",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1161,
    "id": 265,
    "district": "Namba"
  },
  {
    "title": "Anime Figures & Pokémon Cards",
    "urlinform": "anime-figures-pokmon-cards",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://hrtomo.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJA3vBzOnnAGARzrZb1Ey2tFE",
    "lat": 34.669686,
    "lng": 135.5014534,
    "placeId": "ChIJA3vBzOnnAGARzrZb1Ey2tFE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 10:30 PM",
      "Tuesday: 10:30 AM – 10:30 PM",
      "Wednesday: 10:30 AM – 10:30 PM",
      "Thursday: 10:30 AM – 10:30 PM",
      "Friday: 10:30 AM – 10:30 PM",
      "Saturday: 10:30 AM – 10:30 PM",
      "Sunday: 10:30 AM – 10:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 44,
    "id": 266,
    "district": "Shinsaibashi"
  },
  {
    "title": "CHAMPION Collectibles 大阪日本橋店",
    "urlinform": "champion-collectibles-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://animestorechampion.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwabXobTnAGARZjkYIjSqDKc",
    "lat": 34.6656456,
    "lng": 135.5064029,
    "placeId": "ChIJwabXobTnAGARZjkYIjSqDKc",
    "businessStatus": "OPERATIONAL",
    "phone": "070-5478-8633",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 853,
    "id": 267,
    "district": "Namba"
  },
  {
    "title": "トレカパイク TCG shop TorecaPike",
    "urlinform": "-tcg-shop-torecapike",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/toreca_pike?s=21",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLyt9A_7nAGARvywUf0ryPF4",
    "lat": 34.6625469,
    "lng": 135.5048591,
    "placeId": "ChIJLyt9A_7nAGARvywUf0ryPF4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 63,
    "id": 268,
    "district": "Namba"
  },
  {
    "title": "Hareruya 2 Namba Pokémon Card Shop",
    "urlinform": "2-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.hareruya2.com/pages/store_namba",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6c6qFRLnAGARIBD134un08g",
    "lat": 34.6632883,
    "lng": 135.5044056,
    "placeId": "ChIJ6c6qFRLnAGARIBD134un08g",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6568-9988",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 212,
    "id": 269,
    "district": "Namba"
  },
  {
    "title": "playze namba",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.preyz.com/category/shop/preyz_namba/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVVqRfmnnAGARd4_3hKMW7dY",
    "lat": 34.6629208,
    "lng": 135.5037493,
    "placeId": "ChIJVVqRfmnnAGARd4_3hKMW7dY",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6641-1005",
    "openingHours": [
      "Monday: 12:00 – 9:30 PM",
      "Tuesday: 12:00 – 9:30 PM",
      "Wednesday: 12:00 – 9:30 PM",
      "Thursday: 12:00 – 9:30 PM",
      "Friday: 12:00 – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 225,
    "id": 270,
    "district": "Namba"
  },
  {
    "title": "Big magic Namba",
    "urlinform": "bigmagic",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.bigmagic.net/nanba.htm",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhUO0nGnnAGAROba6HzyslsU",
    "lat": 34.6627735,
    "lng": 135.5042174,
    "placeId": "ChIJhUO0nGnnAGAROba6HzyslsU",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6633-7338",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 188,
    "id": 271,
    "district": "Namba"
  },
  {
    "title": "Card Shop Allium",
    "urlinform": "allium-card-shopwholesaledisplay-sales",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/cardshop_allium",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJdc5L3bXnAGARRDhGh8-lQo8",
    "lat": 34.6601915,
    "lng": 135.5045345,
    "placeId": "ChIJdc5L3bXnAGARRDhGh8-lQo8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 424,
    "id": 272,
    "district": "Namba"
  },
  {
    "title": "竜星の嵐 日本橋店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/arashi_nippon_",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ62taTADnAGARQEpRCtcR8JM",
    "lat": 34.6630473,
    "lng": 135.5054234,
    "placeId": "ChIJ62taTADnAGARQEpRCtcR8JM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 709,
    "id": 273,
    "district": "Namba"
  },
  {
    "title": "Hareruya Nipponbashi",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://shop.hareruyamtg.com/nipponbashi/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGzM3YCDnAGARH6ufPBfVSqA",
    "lat": 34.6630547,
    "lng": 135.5032219,
    "placeId": "ChIJGzM3YCDnAGARH6ufPBfVSqA",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6585-9600",
    "openingHours": [
      "Monday: 12:00 – 11:00 PM",
      "Tuesday: 12:00 – 11:00 PM",
      "Wednesday: 12:00 – 11:00 PM",
      "Thursday: 12:00 – 11:00 PM",
      "Friday: 12:00 – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 234,
    "id": 274,
    "district": "Namba"
  },
  {
    "title": "LHUB大阪",
    "urlinform": "lhub",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF2ccSF_nAGAR-psWLHq98Hs",
    "lat": 34.6607655,
    "lng": 135.5068613,
    "placeId": "ChIJF2ccSF_nAGAR-psWLHq98Hs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 57,
    "id": 275,
    "district": "Namba"
  },
  {
    "title": "SHARK TCG Osaka",
    "urlinform": "shark-tcg-osaka",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJO_UASdTnAGARdZGLkB_Z-lM",
    "lat": 34.6630546,
    "lng": 135.5032219,
    "placeId": "ChIJO_UASdTnAGARdZGLkB_Z-lM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 3:00 – 8:00 PM",
      "Sunday: 3:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3,
    "id": 276,
    "district": "Namba"
  },
  {
    "title": "Bee本舗バトルタワー",
    "urlinform": "bee",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://battletower.hp.peraichi.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJS82JJCjnAGARY1I0QYEdOcM",
    "lat": 34.6629849,
    "lng": 135.5047464,
    "placeId": "ChIJS82JJCjnAGARY1I0QYEdOcM",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6684-8887",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 377,
    "id": 277,
    "district": "Namba"
  },
  {
    "title": "トレカの森",
    "urlinform": "store-15",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Digimon",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.torekanomori.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ42CscnvnAGARWVsyW2OC8Kc",
    "lat": 34.671599,
    "lng": 135.4983745,
    "placeId": "ChIJ42CscnvnAGARWVsyW2OC8Kc",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6241-0070",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 131,
    "id": 278,
    "district": "Shinsaibashi"
  },
  {
    "title": "CARDHUNTER",
    "urlinform": "cardhunter",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/@cardhunter01/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJS-HMtkjnAGARE9KYLDLhzYE",
    "lat": 34.6623625,
    "lng": 135.5037335,
    "placeId": "ChIJS-HMtkjnAGARE9KYLDLhzYE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 18,
    "id": 279,
    "district": "Namba"
  },
  {
    "title": "Pureizu Osakanipponbashi Honten",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.preyz.com/category/shop/preyz_osaka_nihonbashi_headquarters/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMQCpu9TnAGARdcVXciSim5M",
    "lat": 34.6616744,
    "lng": 135.5056577,
    "placeId": "ChIJMQCpu9TnAGARdcVXciSim5M",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6684-8444",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 571,
    "id": 280,
    "district": "Namba"
  },
  {
    "title": "magi大阪なんばマルイ店",
    "urlinform": "magi",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/magi_OsakaNamba",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ63wiEnLnAGARWKySwb9UU9o",
    "lat": 34.6654555,
    "lng": 135.5011037,
    "placeId": "ChIJ63wiEnLnAGARWKySwb9UU9o",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 166,
    "id": 281,
    "district": "Namba"
  },
  {
    "title": "チャンピオン 日本橋オタロード店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://championtoreca.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY_yR_LvnAGARVIsYp8COEnA",
    "lat": 34.665644,
    "lng": 135.506431,
    "placeId": "ChIJY_yR_LvnAGARVIsYp8COEnA",
    "businessStatus": "OPERATIONAL",
    "phone": "070-5478-8633",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 270,
    "id": 282,
    "district": "Namba"
  },
  {
    "title": "Treca Capital EDION NAMBA Main Store",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Battle Spirits",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.edion.com/ito/contents/special/lp/trecacapital_edion/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVaS3fAznAGAR4V2p958B3p4",
    "lat": 34.6657456,
    "lng": 135.5018128,
    "placeId": "ChIJVaS3fAznAGAR4V2p958B3p4",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6630-6733",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 56,
    "id": 283,
    "district": "Namba"
  },
  {
    "title": "Adorenaline",
    "urlinform": "adorenaline",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/Ado_renalinemax",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKRQDMAXnAGARkf_keKExhmk",
    "lat": 34.6666525,
    "lng": 135.5057435,
    "placeId": "ChIJKRQDMAXnAGARkf_keKExhmk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 9:30 PM",
      "Tuesday: 12:00 – 9:30 PM",
      "Wednesday: 12:00 – 9:30 PM",
      "Thursday: 12:00 – 9:30 PM",
      "Friday: 12:00 – 9:30 PM",
      "Saturday: 11:00 AM – 9:30 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 284,
    "district": "Namba"
  },
  {
    "title": "PDG Collector’s Shop 大阪オタロード店",
    "urlinform": "pdg-collectors-shop-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/PDG_osaka",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcUr1w-vnAGARpvOyn93l13Q",
    "lat": 34.6611302,
    "lng": 135.5050779,
    "placeId": "ChIJcUr1w-vnAGARpvOyn93l13Q",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 33,
    "id": 285,
    "district": "Namba"
  },
  {
    "title": "TCG専門店 蓮屋",
    "urlinform": "tcg-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Flesh and Blood",
      "Lorcana",
      "MTG"
    ],
    "storeWebsite": "https://hasuya.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTfUOCJHnAGARdfVwcFOWwH0",
    "lat": 34.6630346,
    "lng": 135.5032398,
    "placeId": "ChIJTfUOCJHnAGARdfVwcFOWwH0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 5:00 – 11:00 PM",
      "Tuesday: Closed",
      "Wednesday: 5:00 – 11:00 PM",
      "Thursday: 5:00 – 11:00 PM",
      "Friday: 5:00 – 11:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 39,
    "id": 286,
    "district": "Namba"
  },
  {
    "title": "GIRAFULL なんば店",
    "urlinform": "girafull-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/girafull_namba?s=21&t=AawF1HuVO-DX_PHTQuS4EA",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc15jdmHnAGARakIdEsbiKMU",
    "lat": 34.6641786,
    "lng": 135.502638,
    "placeId": "ChIJc15jdmHnAGARakIdEsbiKMU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 154,
    "id": 287,
    "district": "Namba"
  },
  {
    "title": "playze nippombashi-otaroad",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.preyz.com/category/shop/preyz_nihonbashi_otaroad/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIbzqvWnnAGAR90977Afwmjw",
    "lat": 34.6624105,
    "lng": 135.504817,
    "placeId": "ChIJIbzqvWnnAGAR90977Afwmjw",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6641-1222",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 243,
    "id": 288,
    "district": "Namba"
  },
  {
    "title": "Trading Card-Oh Shinsaibashi",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Shadowverse",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.card-oh.jp/shop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5-eQrRHnAGARQuQkYqdwVaM",
    "lat": 34.6717041,
    "lng": 135.4987805,
    "placeId": "ChIJ5-eQrRHnAGARQuQkYqdwVaM",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6599-8805",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 102,
    "id": 289,
    "district": "Shinsaibashi"
  },
  {
    "title": "Toreka Douraku Osaka Umeda",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/torekadouraku",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1-2GOF3nAGARUeDv_rMgBT0",
    "lat": 34.6611578,
    "lng": 135.5038532,
    "placeId": "ChIJ1-2GOF3nAGARUeDv_rMgBT0",
    "businessStatus": "OPERATIONAL",
    "phone": "080-4647-7492",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 145,
    "id": 290,
    "district": "Namba"
  },
  {
    "title": "TCG Shop BEAST",
    "urlinform": "tcg-shop-beast",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/TCGShop_BEAST",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJH7gJP7jnAGAR-FJRok6hwNw",
    "lat": 34.66090980000001,
    "lng": 135.5038257,
    "placeId": "ChIJH7gJP7jnAGAR-FJRok6hwNw",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6616-9337",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 23,
    "id": 291,
    "district": "Namba"
  },
  {
    "title": "MINT GAMES SHINSAIBASHI",
    "urlinform": "mint-games-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://mint-web.jp/?pid=182458297",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfRbGCdvnAGARvC7XLTj3gB8",
    "lat": 34.6721494,
    "lng": 135.4990099,
    "placeId": "ChIJfRbGCdvnAGARvC7XLTj3gB8",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6755-8456",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 156,
    "id": 292,
    "district": "Shinsaibashi"
  },
  {
    "title": "トレカ専門店 ポップタウン",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/pop_town_namba",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJkRC7KHfnAGAR4TD30RhnSO0",
    "lat": 34.6608491,
    "lng": 135.5063574,
    "placeId": "ChIJkRC7KHfnAGAR4TD30RhnSO0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 93,
    "id": 293,
    "district": "Namba"
  },
  {
    "title": "トレカSunrise大阪日本橋本店",
    "urlinform": "sunrise",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://tcgsunrise.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJdyqqWaHnAGARqwoZRHgfVTs",
    "lat": 34.6623723,
    "lng": 135.5036415,
    "placeId": "ChIJdyqqWaHnAGARqwoZRHgfVTs",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6568-9344",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 132,
    "id": 294,
    "district": "Namba"
  },
  {
    "title": "トレカアイランド 大阪店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/tcgailand_osaka?s=21&t=klohxGwroefMc1FrvDW-5w",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRebtmMfnAGARTTj2i-bzlPY",
    "lat": 34.6622071,
    "lng": 135.5034654,
    "placeId": "ChIJRebtmMfnAGARTTj2i-bzlPY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: Closed",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 5,
    "id": 295,
    "district": "Namba"
  },
  {
    "title": "トレカライン難波駅前店",
    "urlinform": "store-35",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/torecaline1",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJf_NKInPnAGARbVBygjecN6M",
    "lat": 34.6635878,
    "lng": 135.502638,
    "placeId": "ChIJf_NKInPnAGARbVBygjecN6M",
    "businessStatus": "OPERATIONAL",
    "phone": "070-6510-2558",
    "openingHours": [
      "Monday: 12:00 – 8:30 PM",
      "Tuesday: 12:00 – 8:30 PM",
      "Wednesday: 12:00 – 8:30 PM",
      "Thursday: 12:00 – 8:30 PM",
      "Friday: 12:00 – 8:30 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 25,
    "id": 296,
    "district": "Namba"
  },
  {
    "title": "トレカドリーム 難波店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJw0f8mFfnAGARlvERO1q7cN8",
    "lat": 34.6634698,
    "lng": 135.5027024,
    "placeId": "ChIJw0f8mFfnAGARlvERO1q7cN8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 1,
    "userRatingsTotal": 8,
    "id": 297,
    "district": "Namba"
  },
  {
    "title": "Card labo Namba",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.c-labo.jp/shop/namba.shtml",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZVh2tmnnAGAR_s7teHBuTjc",
    "lat": 34.661696,
    "lng": 135.5050524,
    "placeId": "ChIJZVh2tmnnAGAR_s7teHBuTjc",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6563-9647",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 115,
    "id": 298,
    "district": "Namba"
  },
  {
    "title": "カードショップGOTCHA!梅田店",
    "urlinform": "gotcha",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://cardshop-gotcha.com/pages/takuhai-how-to",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcxjmgwbnAGARoO126HyUq_M",
    "lat": 34.7052043,
    "lng": 135.4957524,
    "placeId": "ChIJcxjmgwbnAGARoO126HyUq_M",
    "businessStatus": "OPERATIONAL",
    "phone": "080-5712-9454",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 878,
    "id": 299,
    "district": "Umeda"
  },
  {
    "title": "Pokémon Center Osaka",
    "urlinform": "store-39",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/osaka/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCSi8eY3mAGARo2VDRJYlY74",
    "lat": 34.7018579,
    "lng": 135.4964699,
    "placeId": "ChIJCSi8eY3mAGARo2VDRJYlY74",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6346-6002",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 2922,
    "id": 300,
    "district": "Umeda"
  },
  {
    "title": "Hareruya Tournament Center Osaka",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://www.hareruyamtg.com/jp/store/osaka_top.aspx",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG8_yrO3mAGARLqW3BHDinc8",
    "lat": 34.6996218,
    "lng": 135.4994311,
    "placeId": "ChIJG8_yrO3mAGARLqW3BHDinc8",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6147-9088",
    "openingHours": [
      "Monday: 10:00 AM – 11:00 PM",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 266,
    "id": 301,
    "district": "Umeda"
  },
  {
    "title": "Pokémon Card Station Osaka",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon-card.com/info/2000/20000101_001097.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVb-GGOvnAGARTciHc9-hu8k",
    "lat": 34.7018269,
    "lng": 135.4965097,
    "placeId": "ChIJVb-GGOvnAGARTciHc9-hu8k",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6346-6002",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 21,
    "id": 302,
    "district": "Umeda"
  },
  {
    "title": "Ryu no Shippo Trading Cards - Osaka Umeda branch",
    "urlinform": "store-43",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.ryuunoshippo.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAQBkP47mAGAR8e27l28z6P8",
    "lat": 34.7052043,
    "lng": 135.4957524,
    "placeId": "ChIJAQBkP47mAGAR8e27l28z6P8",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6136-6246",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 469,
    "id": 303,
    "district": "Umeda"
  },
  {
    "title": "Card Box Osaka",
    "urlinform": "4f",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "MTG",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardbox.online/shop/detail/5027/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJr3QEt_bnAGAR6sYnKtT0OhY",
    "lat": 34.69866470000001,
    "lng": 135.4938654,
    "placeId": "ChIJr3QEt_bnAGAR6sYnKtT0OhY",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6131-6403",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 119,
    "id": 304,
    "district": "Umeda"
  },
  {
    "title": "Toy Comp",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/toycomp5",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVVVVVezmAGARGGGwLjDvl5k",
    "lat": 34.6990586,
    "lng": 135.4990371,
    "placeId": "ChIJVVVVVezmAGARGGGwLjDvl5k",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4796-8688",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 190,
    "id": 305,
    "district": "Umeda"
  },
  {
    "title": "TCG SHOP Bluve 大阪梅田店",
    "urlinform": "tcg-shop-bluve-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://tcgshop-bluve.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrxtCFsLnAGARjpcBqRdlS6s",
    "lat": 34.704465,
    "lng": 135.5049044,
    "placeId": "ChIJrxtCFsLnAGARjpcBqRdlS6s",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6755-4460",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: 2:00 – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4,
    "userRatingsTotal": 25,
    "id": 306,
    "district": "Umeda"
  },
  {
    "title": "Pokemon Stand",
    "urlinform": "store-48",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcfKUVADnAGARJ9iLZa8MjAc",
    "lat": 34.7019121,
    "lng": 135.4956935,
    "placeId": "ChIJcfKUVADnAGARJ9iLZa8MjAc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3.9,
    "userRatingsTotal": 12,
    "id": 307,
    "district": "Umeda"
  },
  {
    "title": "Pokemon Center Osaka DX",
    "urlinform": "dx",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/osakadx/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiZ8OQInnAGART2BGEGqySKk",
    "lat": 34.6731719,
    "lng": 135.5007545,
    "placeId": "ChIJiZ8OQInnAGART2BGEGqySKk",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4256-1125",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 2434,
    "id": 308,
    "district": "Shinsaibashi"
  },
  {
    "title": "Card Shop Kizuna",
    "urlinform": "store-50",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ50iqMSfnAGARiXAmqwqVE6s",
    "lat": 34.6998973,
    "lng": 135.4988268,
    "placeId": "ChIJ50iqMSfnAGARiXAmqwqVE6s",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 6:00 PM",
      "Tuesday: 1:00 – 6:00 PM",
      "Wednesday: 1:00 – 6:00 PM",
      "Thursday: 1:00 – 6:00 PM",
      "Friday: 1:00 – 6:00 PM",
      "Saturday: 1:00 – 6:00 PM",
      "Sunday: 1:00 – 6:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 12,
    "id": 309,
    "district": "Umeda"
  },
  {
    "title": "MINT UMEDA",
    "urlinform": "mint-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://mint-web.jp/?pid=4246343",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSc8KyZHmAGAROi_6fp90OO8",
    "lat": 34.70567279999999,
    "lng": 135.4986234,
    "placeId": "ChIJSc8KyZHmAGAROi_6fp90OO8",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6136-6611",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 106,
    "id": 310,
    "district": "Umeda"
  },
  {
    "title": "Card shop flat",
    "urlinform": "store-53",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://www.cs-flat.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVVWZQIXmAGARREOuZkneDUg",
    "lat": 34.70955259999999,
    "lng": 135.4960087,
    "placeId": "ChIJVVWZQIXmAGARREOuZkneDUg",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6147-7855",
    "openingHours": [
      "Monday: 5:00 – 11:00 PM",
      "Tuesday: 5:00 – 11:00 PM",
      "Wednesday: 5:00 – 11:00 PM",
      "Thursday: 5:00 – 11:00 PM",
      "Friday: 5:00 – 11:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 40,
    "id": 311,
    "district": "Umeda"
  },
  {
    "title": "ONE PIECE Mugiwara-store Umeda",
    "urlinform": "one-piece-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "http://www.mugiwara-store.com/store/6149",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJycX1wsXnAGAR73RalTPq4L4",
    "lat": 34.7015251,
    "lng": 135.4965319,
    "placeId": "ChIJycX1wsXnAGAR73RalTPq4L4",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6147-6361",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 190,
    "id": 312,
    "district": "Umeda"
  },
  {
    "title": "Bandai Namco Cross Store Osaka Umeda",
    "urlinform": "-cross-store-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Gundam",
      "Pokémon"
    ],
    "storeWebsite": "https://bandainamco-am.co.jp/game_center/loc/hepfive/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqw43opPmAGARjNmee6J8Tqs",
    "lat": 34.704144,
    "lng": 135.500436,
    "placeId": "ChIJqw43opPmAGARjNmee6J8Tqs",
    "businessStatus": "OPERATIONAL",
    "phone": "0570-076-563",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 318,
    "id": 313,
    "district": "Umeda"
  },
  {
    "title": "ONE PIECE 麦わらストア あべの店",
    "urlinform": "one-piece-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "http://www.mugiwara-store.com/store/1253",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJf7da8PHdAGARPYLRyvoAJJg",
    "lat": 34.6453435,
    "lng": 135.5114004,
    "placeId": "ChIJf7da8PHdAGARPYLRyvoAJJg",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4393-8441",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 511,
    "id": 314,
    "district": "Tennoji"
  },
  {
    "title": "Toreka park Nippombashi",
    "urlinform": "store-60",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.furu1.net/shop/shop0122.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEzx9mWnnAGARWAPTDS9tqoM",
    "lat": 34.662463,
    "lng": 135.5043872,
    "placeId": "ChIJEzx9mWnnAGARWAPTDS9tqoM",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6635-5512",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 193,
    "id": 315,
    "district": "Namba"
  },
  {
    "title": "竜のしっぽNU茶屋町店",
    "urlinform": "nu",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/ryuunoshippo_nu?s=21&t=SZj9pClxkaEWwFveQBPE1A",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsd2WIwDnAGARFkwLIl1vpz8",
    "lat": 34.7069014,
    "lng": 135.499169,
    "placeId": "ChIJsd2WIwDnAGARFkwLIl1vpz8",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4300-6690",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 34,
    "id": 316,
    "district": "Umeda"
  },
  {
    "title": "Hiki Shoten TCG - Kibe store",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/hikicardosaka",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGwUdjtvnAGARdLcr3n4Ei0E",
    "lat": 34.6605463,
    "lng": 135.5050086,
    "placeId": "ChIJGwUdjtvnAGARdLcr3n4Ei0E",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 7:30 PM",
      "Wednesday: 12:00 – 7:30 PM",
      "Thursday: 12:00 – 7:30 PM",
      "Friday: 12:00 – 7:30 PM",
      "Saturday: 11:00 AM – 7:30 PM",
      "Sunday: 11:00 AM – 7:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 78,
    "id": 317,
    "district": "Namba"
  },
  {
    "title": "CLEVER 大阪日本橋",
    "urlinform": "clever-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/clever_osaka",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJ6mr7arnAGAR1F59wW915kY",
    "lat": 34.6611302,
    "lng": 135.5050779,
    "placeId": "ChIJJ6mr7arnAGAR1F59wW915kY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 3:00 – 8:00 PM",
      "Sunday: 3:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 42,
    "id": 318,
    "district": "Namba"
  },
  {
    "title": "Vault（ヴォルト） 大阪",
    "urlinform": "vault-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/Vaultosaka",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8c5h0tHnAGARlNiSSSutlak",
    "lat": 34.660359,
    "lng": 135.504608,
    "placeId": "ChIJ8c5h0tHnAGARlNiSSSutlak",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 219,
    "id": 319,
    "district": "Namba"
  },
  {
    "title": "Pokemon Cards Nihonbashi AMTAF",
    "urlinform": "pokemon-cards-nihonbashi-amtaf",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://amtaf-tcg.web.app/lp/ja/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJm0uugwfnAGARFNDrniIB8l8",
    "lat": 34.6613086,
    "lng": 135.5053723,
    "placeId": "ChIJm0uugwfnAGARFNDrniIB8l8",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4393-8668",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 155,
    "id": 320,
    "district": "Namba"
  },
  {
    "title": "CARDBOOM 日本橋店",
    "urlinform": "cardboom",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzYSj8l_nAGARQ0kd6IT8vR8",
    "lat": 34.6674054,
    "lng": 135.5059091,
    "placeId": "ChIJzYSj8l_nAGARQ0kd6IT8vR8",
    "businessStatus": "CLOSED_TEMPORARILY",
    "phone": "06-6121-6756",
    "openingHours": [],
    "rating": 4.8,
    "userRatingsTotal": 29,
    "id": 321,
    "district": "Namba"
  },
  {
    "title": "トレカショップIRON",
    "urlinform": "iron",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.google.com/url?q=https://www.instagram.com/torekashopiron/&sa=U&ved=2ahUKEwi3s4WaipqUAxX7qFYBHcJNDxoQFnoECCoQAQ&usg=AOvVaw1IqOnArj829M6bnnUK2-RX",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx8uTGQDnAGARZKMNatU6au0",
    "lat": 34.6574656,
    "lng": 135.5055049,
    "placeId": "ChIJx8uTGQDnAGARZKMNatU6au0",
    "businessStatus": "OPERATIONAL",
    "phone": "080-7743-4698",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 17,
    "id": 322,
    "district": "Nipponbashi"
  },
  {
    "title": "DragonStar Nipponbashi Main Store",
    "urlinform": "store-69",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://dorasuta.jp/?utm_source=GBP&utm_medium=GBP&utm_term=GBP&utm_content=GBP&utm_campaign=GBP003",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOU_rTGjnAGARd2KY6UU-ZTk",
    "lat": 34.6612825,
    "lng": 135.5048091,
    "placeId": "ChIJOU_rTGjnAGARd2KY6UU-ZTk",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6632-3131",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 10:30 AM – 8:00 PM",
      "Sunday: 10:30 AM – 8:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 282,
    "id": 323,
    "district": "Namba"
  },
  {
    "title": "Vintage Garage Sale",
    "urlinform": "zero-one-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/zero_one_2025",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6SIeZQDnAGARy49NeqXrg9I",
    "lat": 34.6604215,
    "lng": 135.5040772,
    "placeId": "ChIJ6SIeZQDnAGARy49NeqXrg9I",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 61,
    "id": 324,
    "district": "Namba"
  },
  {
    "title": "とれじゃらす別館",
    "urlinform": "store-72",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Dragon Ball",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "http://www.torejaras.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJea_hSADnAGARHdFXbZ1o6LY",
    "lat": 34.6607992,
    "lng": 135.5055428,
    "placeId": "ChIJea_hSADnAGARHdFXbZ1o6LY",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4394-7533",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 116,
    "id": 325,
    "district": "Namba"
  },
  {
    "title": "CHAMPION MEGA 大阪日本橋店",
    "urlinform": "champion-mega-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEzaO9KjnAGARfOsM6_4dZWs",
    "lat": 34.6611844,
    "lng": 135.5071097,
    "placeId": "ChIJEzaO9KjnAGARfOsM6_4dZWs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 298,
    "id": 326,
    "district": "Namba"
  },
  {
    "title": "カードショップあーと 大阪日本橋店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/art_card_",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB1VSrZ7nAGARgL5XcsJMB8U",
    "lat": 34.6608924,
    "lng": 135.5053657,
    "placeId": "ChIJB1VSrZ7nAGARgL5XcsJMB8U",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6567-9836",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 50,
    "id": 327,
    "district": "Namba"
  },
  {
    "title": "フルアヘッド大阪日本橋店",
    "urlinform": "store-75",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/fullaheadosaka",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJw6u8e57nAGARhn7ocO8l_I8",
    "lat": 34.659861,
    "lng": 135.5057362,
    "placeId": "ChIJw6u8e57nAGARhn7ocO8l_I8",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6978-8789",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 221,
    "id": 328,
    "district": "Nipponbashi"
  },
  {
    "title": "magi大阪日本橋店",
    "urlinform": "magi",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardshopmagi.com/shop/magi-osakanipponbashi/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjfr05TLnAGAROHXY3Vho420",
    "lat": 34.6627548,
    "lng": 135.5057589,
    "placeId": "ChIJjfr05TLnAGAROHXY3Vho420",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 7:30 PM",
      "Tuesday: 2:00 – 7:30 PM",
      "Wednesday: 2:00 – 7:30 PM",
      "Thursday: 2:00 – 7:30 PM",
      "Friday: 2:00 – 7:30 PM",
      "Saturday: 2:00 – 7:30 PM",
      "Sunday: 2:00 – 7:30 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 70,
    "id": 329,
    "district": "Namba"
  },
  {
    "title": "トレカ屋JINstudio",
    "urlinform": "jinstudio",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/torekayaJIN",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyeXwcADnAGARpQ9gomxRqkg",
    "lat": 34.6602143,
    "lng": 135.5044628,
    "placeId": "ChIJyeXwcADnAGARpQ9gomxRqkg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 46,
    "id": 330,
    "district": "Namba"
  },
  {
    "title": "Hobby Station Nippombashi honten",
    "urlinform": "store-78",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hbst.net/shop/11/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJO8wTMmjnAGARlqYxRfLoWCI",
    "lat": 34.6615003,
    "lng": 135.5050822,
    "placeId": "ChIJO8wTMmjnAGARlqYxRfLoWCI",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6631-7820",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 86,
    "id": 331,
    "district": "Namba"
  },
  {
    "title": "トレカショップKURO",
    "urlinform": "kuro",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVzgMFwDnAGARmV2223gJEtI",
    "lat": 34.6567328,
    "lng": 135.5058928,
    "placeId": "ChIJVzgMFwDnAGARmV2223gJEtI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 31,
    "id": 332,
    "district": "Nipponbashi"
  },
  {
    "title": "カードショップとんとん大阪日本橋店",
    "urlinform": "store-80",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg2KOG_DnAGARsNye6quyqBI",
    "lat": 34.6598581,
    "lng": 135.5040955,
    "placeId": "ChIJg2KOG_DnAGARsNye6quyqBI",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6567-9292",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: Closed",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 9,
    "id": 333,
    "district": "Nipponbashi"
  },
  {
    "title": "Cardbox Nippombashi",
    "urlinform": "store-81",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardbox.online/shop/detail/4273/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfz74TGjnAGARIJ2Rf4LwZ8g",
    "lat": 34.66119,
    "lng": 135.5047804,
    "placeId": "ChIJfz74TGjnAGARIJ2Rf4LwZ8g",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6556-6167",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 2.5,
    "userRatingsTotal": 139,
    "id": 334,
    "district": "Namba"
  },
  {
    "title": "TCG DREAM 大阪 日本橋",
    "urlinform": "tcg-dream-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/dream_osaka_?s=21&t=fwzkoXnGcvvqljbJf_Kk9g",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJl2LILgDnAGARBZtG-osfvbw",
    "lat": 34.6609078,
    "lng": 135.5053077,
    "placeId": "ChIJl2LILgDnAGARBZtG-osfvbw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 16,
    "id": 335,
    "district": "Namba"
  },
  {
    "title": "Card Labo Tennoji",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.c-labo.jp/shop/tennouji/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtSySoPHdAGARHwNpNWuql-8",
    "lat": 34.6470443,
    "lng": 135.5123868,
    "placeId": "ChIJtSySoPHdAGARHwNpNWuql-8",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4394-7828",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.6,
    "userRatingsTotal": 142,
    "id": 336,
    "district": "Tennoji"
  },
  {
    "title": "Card Shop Cat Momodani",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/cardshopcat3",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBSyIrLDfAGARamlQdEJ5b4Y",
    "lat": 34.6600857,
    "lng": 135.5277527,
    "placeId": "ChIJBSyIrLDfAGARamlQdEJ5b4Y",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 4,
    "userRatingsTotal": 20,
    "id": 337
  },
  {
    "title": "Project Core Abeno",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.projectcore.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvXveZeHdAGARCizN0SVpko4",
    "lat": 34.6442014,
    "lng": 135.5220053,
    "placeId": "ChIJvXveZeHdAGARCizN0SVpko4",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6713-9700",
    "openingHours": [
      "Monday: 3:00 – 8:00 PM",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 2.1,
    "userRatingsTotal": 48,
    "id": 338,
    "district": "Tennoji"
  },
  {
    "title": "Gee Store Osaka",
    "urlinform": "store-86",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.geestore.com/geenet/geestore/osaka",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR-OvSWjnAGARgVi0W7tGk5A",
    "lat": 34.6632801,
    "lng": 135.5046948,
    "placeId": "ChIJR-OvSWjnAGARgVi0W7tGk5A",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6630-7655",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 681,
    "id": 339,
    "district": "Namba"
  },
  {
    "title": "Lashinbang Tennoji Store",
    "urlinform": "store-91",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lashinbang.com/store/44/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJf3m3CvHdAGARHx_Uc_m_zYE",
    "lat": 34.6470443,
    "lng": 135.5123868,
    "placeId": "ChIJf3m3CvHdAGARHx_Uc_m_zYE",
    "businessStatus": "OPERATIONAL",
    "phone": "0570-008-620",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 214,
    "id": 340,
    "district": "Tennoji"
  },
  {
    "title": "ポケカ専門店ポズケット",
    "urlinform": "store-92",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://x.com/Pozcket_Ptc?t=gauI9c1ejzqagGPqUrOo0A&s=09",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1c0DbGnnAGARpceUPRNcsTk",
    "lat": 34.6592404,
    "lng": 135.5046438,
    "placeId": "ChIJ1c0DbGnnAGARpceUPRNcsTk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 22,
    "id": 341,
    "district": "Nipponbashi"
  },
  {
    "title": "#C-pla 天王寺MIO店",
    "urlinform": "c-pla-mio",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://toshin.jpn.com/shop/%E5%A4%A9%E7%8E%8B%E5%AF%BAmio%E5%BA%97/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnaecFQDdAGARdaWre4fPygA",
    "lat": 34.6468059,
    "lng": 135.514085,
    "placeId": "ChIJnaecFQDdAGARdaWre4fPygA",
    "businessStatus": "OPERATIONAL",
    "phone": "070-1366-7103",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 2,
    "id": 342,
    "district": "Tennoji"
  },
  {
    "title": "Torecachance Nippombashi",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.torecachance.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhSQh62nnAGARsTChvTpuvgg",
    "lat": 34.6628212,
    "lng": 135.5052191,
    "placeId": "ChIJhSQh62nnAGARsTChvTpuvgg",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4395-5155",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 105,
    "id": 343,
    "district": "Namba"
  },
  {
    "title": "トレカライン オタロード店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://mobile.twitter.com/torecaline2",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJT8vGJDHnAGARCN5b7xTW9SY",
    "lat": 34.661696,
    "lng": 135.5050524,
    "placeId": "ChIJT8vGJDHnAGARCN5b7xTW9SY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:30 PM",
      "Tuesday: 12:00 – 8:30 PM",
      "Wednesday: 12:00 – 8:30 PM",
      "Thursday: 12:00 – 8:30 PM",
      "Friday: 12:00 – 8:30 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 47,
    "id": 344,
    "district": "Namba"
  },
  {
    "title": "MINT Daimaru Shinsaibashi",
    "urlinform": "mint-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://mint-web.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYfncEbXnAGARQaZV2I6uswg",
    "lat": 34.6730816,
    "lng": 135.5010135,
    "placeId": "ChIJYfncEbXnAGARQaZV2I6uswg",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4256-3803",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 79,
    "id": 345,
    "district": "Shinsaibashi"
  },
  {
    "title": "Osaka TCG Supply",
    "urlinform": "osaka-tcg-supply",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://wa.me//+819090943489",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1eGmYZjnAGARsuL7MEgbIKo",
    "lat": 34.6717981,
    "lng": 135.5007474,
    "placeId": "ChIJ1eGmYZjnAGARsuL7MEgbIKo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 3.7,
    "userRatingsTotal": 3,
    "id": 346,
    "district": "Shinsaibashi"
  },
  {
    "title": "ロータス大阪ミナミ店",
    "urlinform": "store-99",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/lotus_minamiten",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCW6T1mnnAGARnFnW0XF-HUI",
    "lat": 34.6712031,
    "lng": 135.5044104,
    "placeId": "ChIJCW6T1mnnAGARnFnW0XF-HUI",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4256-1459",
    "openingHours": [
      "Monday: 6:00 PM – 3:00 AM",
      "Tuesday: 6:00 PM – 3:00 AM",
      "Wednesday: 6:00 PM – 3:00 AM",
      "Thursday: 6:00 PM – 3:00 AM",
      "Friday: 6:00 PM – 3:00 AM",
      "Saturday: 6:00 PM – 3:00 AM",
      "Sunday: 6:00 PM – 3:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 10,
    "id": 347,
    "district": "Shinsaibashi"
  },
  {
    "title": "CardHobby",
    "urlinform": "cardhobby",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cardhobby.com/#/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvRaoXADnAGAROpDbuIqqQdg",
    "lat": 34.6726426,
    "lng": 135.4984678,
    "placeId": "ChIJvRaoXADnAGAROpDbuIqqQdg",
    "businessStatus": "OPERATIONAL",
    "phone": "06-7222-2822",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 14,
    "id": 348,
    "district": "Shinsaibashi"
  },
  {
    "title": "Pokémon Cafe Osaka Shinsaibashi",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon-cafe.jp/ja/cafe/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ97lN2RDnAGARxxH5he8b6KQ",
    "lat": 34.6733012,
    "lng": 135.5007844,
    "placeId": "ChIJ97lN2RDnAGARxxH5he8b6KQ",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4256-1160",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 1429,
    "id": 349,
    "district": "Shinsaibashi"
  },
  {
    "title": "Pokémon Center Nagoya",
    "urlinform": "store-2",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/nagoya/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMdy8Ac5wA2ARTTSg2YV8tsI",
    "lat": 35.1635667,
    "lng": 136.9080676,
    "placeId": "ChIJMdy8Ac5wA2ARTTSg2YV8tsI",
    "businessStatus": "OPERATIONAL",
    "phone": "052-746-9951",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 2566,
    "id": 350,
    "district": "Osu"
  },
  {
    "title": "買取チャンピオン 名古屋大須店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://championtoreca.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjeVkxp5xA2ARz-17rZPuWM8",
    "lat": 35.1617745,
    "lng": 136.9068685,
    "placeId": "ChIJjeVkxp5xA2ARz-17rZPuWM8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 62,
    "id": 351,
    "district": "Osu"
  },
  {
    "title": "Vault（ボルト）名古屋",
    "urlinform": "vault",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/vault_nagoya?s=21&t=Bz3HnuV3em3My1mZJal6ug",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0wpNRud3A2ARk-UZPf7JHb8",
    "lat": 35.1605422,
    "lng": 136.904746,
    "placeId": "ChIJ0wpNRud3A2ARk-UZPf7JHb8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 231,
    "id": 352,
    "district": "Osu"
  },
  {
    "title": "Top Card Nagoya Osu",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://top-card.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaek8G55xA2AR2nN08jbIZx8",
    "lat": 35.1604175,
    "lng": 136.9057367,
    "placeId": "ChIJaek8G55xA2AR2nN08jbIZx8",
    "businessStatus": "OPERATIONAL",
    "phone": "052-212-8989",
    "openingHours": [
      "Monday: 11:00 AM – 8:30 PM",
      "Tuesday: 11:00 AM – 8:30 PM",
      "Wednesday: 11:00 AM – 8:30 PM",
      "Thursday: 11:00 AM – 8:30 PM",
      "Friday: 11:00 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 206,
    "id": 353,
    "district": "Osu"
  },
  {
    "title": "トレカウィッシュ_名古屋店",
    "urlinform": "_",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/torekawish_ng?s=21&t=uJp_7qGeV7lbmmqaVnPNPg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpbIRdPVxA2ARTXgrRzHkr70",
    "lat": 35.1616061,
    "lng": 136.9045433,
    "placeId": "ChIJpbIRdPVxA2ARTXgrRzHkr70",
    "businessStatus": "OPERATIONAL",
    "phone": "070-6986-0088",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: Closed",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 22,
    "id": 354,
    "district": "Osu"
  },
  {
    "title": "Bee本舗名古屋大須店",
    "urlinform": "bee",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://bee-osu.hp.peraichi.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7_EoU9VxA2AR2AdWpPRKyck",
    "lat": 35.1605731,
    "lng": 136.9045408,
    "placeId": "ChIJ7_EoU9VxA2AR2AdWpPRKyck",
    "businessStatus": "OPERATIONAL",
    "phone": "052-253-6647",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 203,
    "id": 355,
    "district": "Osu"
  },
  {
    "title": "magi Nagoya PARCO",
    "urlinform": "magiparco",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardshopmagi.com/shop/magi-nagoya/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ2hzKblxA2ARrLM191Bn1L8",
    "lat": 35.1636011,
    "lng": 136.9081504,
    "placeId": "ChIJZ2hzKblxA2ARrLM191Bn1L8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 48,
    "id": 356,
    "district": "Osu"
  },
  {
    "title": "Mint Nagoya",
    "urlinform": "mint",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://mint-web.jp/?pid=180872518",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNSNmc0BxA2AR5s82JkGP06c",
    "lat": 35.1654084,
    "lng": 136.9057178,
    "placeId": "ChIJNSNmc0BxA2AR5s82JkGP06c",
    "businessStatus": "OPERATIONAL",
    "phone": "052-684-7733",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 85,
    "id": 357,
    "district": "Sakae"
  },
  {
    "title": "フルアヘッド大須2号店",
    "urlinform": "2",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/fullahead_osu2",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFaSPE-ZxA2ARM0miVjZ95iU",
    "lat": 35.1603963,
    "lng": 136.9058613,
    "placeId": "ChIJFaSPE-ZxA2ARM0miVjZ95iU",
    "businessStatus": "OPERATIONAL",
    "phone": "052-228-9878",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 392,
    "id": 358,
    "district": "Osu"
  },
  {
    "title": "トレカ海賊団 大須本店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1byS5zpxA2AROcHNCQYCdMM",
    "lat": 35.1584582,
    "lng": 136.9049993,
    "placeId": "ChIJ1byS5zpxA2AROcHNCQYCdMM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 179,
    "id": 359,
    "district": "Osu"
  },
  {
    "title": "Match Up",
    "urlinform": "store-12",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.matchup-nagoya.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwz6ig85wA2ARBhTUr6FTeME",
    "lat": 35.1626304,
    "lng": 136.9079009,
    "placeId": "ChIJwz6ig85wA2ARBhTUr6FTeME",
    "businessStatus": "OPERATIONAL",
    "phone": "052-238-2677",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 35,
    "id": 360,
    "district": "Osu"
  },
  {
    "title": "Biggumajikku Nagoyaten",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://mtg.bigweb.co.jp/shop/nagoya",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJq48UPMxwA2ARbaHI_8IyPMw",
    "lat": 35.161788,
    "lng": 136.906843,
    "placeId": "ChIJq48UPMxwA2ARbaHI_8IyPMw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: Closed",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 75,
    "id": 361,
    "district": "Osu"
  },
  {
    "title": "Hobby station Nagoya",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hbst.net/shop/16/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEQf27MxwA2ARRDdnUFjpE3o",
    "lat": 35.158351,
    "lng": 136.9048031,
    "placeId": "ChIJEQf27MxwA2ARRDdnUFjpE3o",
    "businessStatus": "OPERATIONAL",
    "phone": "052-242-5252",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 121,
    "id": 362,
    "district": "Osu"
  },
  {
    "title": "カードパーティー大須本店",
    "urlinform": "store-15",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/cardparty202509?s=11&t=GYFwV9PndnGQazQz96TBKg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTXhn8R9xA2ARm-aqWCnnboU",
    "lat": 35.1613137,
    "lng": 136.9067427,
    "placeId": "ChIJTXhn8R9xA2ARm-aqWCnnboU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 30,
    "id": 363,
    "district": "Osu"
  },
  {
    "title": "aNueNuE -アヌエ-",
    "urlinform": "anuenue-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://anuenue-a1.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrQNIC79xA2ARujNB2B_QI1E",
    "lat": 35.1617619,
    "lng": 136.905822,
    "placeId": "ChIJrQNIC79xA2ARujNB2B_QI1E",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9022-7955",
    "openingHours": [
      "Monday: 1:00 – 8:30 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:30 PM",
      "Thursday: 1:00 – 8:30 PM",
      "Friday: 1:00 – 8:30 PM",
      "Saturday: 12:00 – 8:30 PM",
      "Sunday: 12:00 – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 27,
    "id": 364,
    "district": "Osu"
  },
  {
    "title": "193 Osu",
    "urlinform": "tcgshop193",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://193tcg.com/user_data/shopinfo.php#osu",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ479tr8xwA2ARa_cJh7HPgCo",
    "lat": 35.1593354,
    "lng": 136.9033701,
    "placeId": "ChIJ479tr8xwA2ARa_cJh7HPgCo",
    "businessStatus": "OPERATIONAL",
    "phone": "052-242-0193",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 165,
    "id": 365,
    "district": "Osu"
  },
  {
    "title": "トレカショップ バズーカ 名古屋店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/bazuka_nagoya",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJU_lmZ_J3A2ARQImxqpas4GA",
    "lat": 35.1704495,
    "lng": 136.8875248,
    "placeId": "ChIJU_lmZ_J3A2ARQImxqpas4GA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 141,
    "id": 366,
    "district": "Nagoya Station"
  },
  {
    "title": "王の洞窟jr. 名古屋店",
    "urlinform": "jr-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Battle Spirits",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://ounodoukutsu.jp/zeroshiki/shop/nagoya/?utm_source=google&utm_medium=map",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAQe8_Sx3A2AR4N94kku1ywA",
    "lat": 35.1685392,
    "lng": 136.8803885,
    "placeId": "ChIJAQe8_Sx3A2AR4N94kku1ywA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 119,
    "id": 367,
    "district": "Nagoya Station"
  },
  {
    "title": "トレカキャンプ 大須店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://torecacamp-pokemon.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ37oXnNxxA2ARLVy7CqGgrxA",
    "lat": 35.1570601,
    "lng": 136.9064379,
    "placeId": "ChIJ37oXnNxxA2ARLVy7CqGgrxA",
    "businessStatus": "OPERATIONAL",
    "phone": "052-265-8916",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 151,
    "id": 368,
    "district": "Osu"
  },
  {
    "title": "TCG SHOP 4x4",
    "urlinform": "tcg-shop-4x4",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/four_by_4?s=11&t=pt29ASWlb6wl9YlvoMKNXw",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaU32ZolxA2AR5RbEDbQdkiw",
    "lat": 35.1584638,
    "lng": 136.9054349,
    "placeId": "ChIJaU32ZolxA2AR5RbEDbQdkiw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:30 PM",
      "Tuesday: 1:00 – 8:30 PM",
      "Wednesday: 1:00 – 8:30 PM",
      "Thursday: Closed",
      "Friday: 1:00 – 8:30 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 23,
    "id": 369,
    "district": "Osu"
  },
  {
    "title": "Hareruya Nagoya",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://www.hareruyamtg.com/jp/store/nagoya_top.aspx",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx84wkOZ2A2AR-BhEbEbgzww",
    "lat": 35.167892,
    "lng": 136.879315,
    "placeId": "ChIJx84wkOZ2A2AR-BhEbEbgzww",
    "businessStatus": "OPERATIONAL",
    "phone": "052-451-7855",
    "openingHours": [
      "Monday: 12:00 – 11:00 PM",
      "Tuesday: 12:00 – 11:00 PM",
      "Wednesday: 12:00 – 11:00 PM",
      "Thursday: 12:00 – 11:00 PM",
      "Friday: 12:00 – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 138,
    "id": 370,
    "district": "Nagoya Station"
  },
  {
    "title": "Hobby Station Osu Banshojitori",
    "urlinform": "store-23",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hbst.net/shop/48/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVVWZCstwA2ARvn8uBadr-Ck",
    "lat": 35.1586539,
    "lng": 136.905264,
    "placeId": "ChIJVVWZCstwA2ARvn8uBadr-Ck",
    "businessStatus": "OPERATIONAL",
    "phone": "052-228-0322",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 150,
    "id": 371,
    "district": "Osu"
  },
  {
    "title": "Card lab Nagoya Osu shop",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.c-labo.jp/shop/nagoyaoosu.shtml",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaTcdnctwA2ARfzpEOMuMFDg",
    "lat": 35.159381,
    "lng": 136.9054146,
    "placeId": "ChIJaTcdnctwA2ARfzpEOMuMFDg",
    "businessStatus": "OPERATIONAL",
    "phone": "052-263-0601",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.5,
    "userRatingsTotal": 193,
    "id": 372,
    "district": "Osu"
  },
  {
    "title": "Hareruya Osu",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hareruyamtg.com/ja/user_data/lp_osu",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6S9MxIJxA2ARPLlMsciGFFE",
    "lat": 35.1583932,
    "lng": 136.9063025,
    "placeId": "ChIJ6S9MxIJxA2ARPLlMsciGFFE",
    "businessStatus": "OPERATIONAL",
    "phone": "052-228-0355",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 65,
    "id": 373,
    "district": "Osu"
  },
  {
    "title": "Advantage",
    "urlinform": "store-26",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.advantagetcg.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0eZQfcxwA2ARFziVifoIdpc",
    "lat": 35.1602798,
    "lng": 136.9052874,
    "placeId": "ChIJ0eZQfcxwA2ARFziVifoIdpc",
    "businessStatus": "OPERATIONAL",
    "phone": "052-253-7769",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.5,
    "userRatingsTotal": 86,
    "id": 374,
    "district": "Osu"
  },
  {
    "title": "カードショップ【ディライト】",
    "urlinform": "store-28",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ_GWhCZxA2ARj3YL6uYTPzE",
    "lat": 35.1603147,
    "lng": 136.9064319,
    "placeId": "ChIJZ_GWhCZxA2ARj3YL6uYTPzE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 2.6,
    "userRatingsTotal": 5,
    "id": 375,
    "district": "Osu"
  },
  {
    "title": "ＴＣＧショップ１９３名駅店",
    "urlinform": "193-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://193tcg.com/user_data/shopinfo.php#meieki",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ__8jLOR2A2ARTGw8FHjSFm4",
    "lat": 35.1677098,
    "lng": 136.8781338,
    "placeId": "ChIJ__8jLOR2A2ARTGw8FHjSFm4",
    "businessStatus": "OPERATIONAL",
    "phone": "052-451-0193",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 121,
    "id": 376,
    "district": "Nagoya Station"
  },
  {
    "title": "PDG collector's shop 名古屋駅前店",
    "urlinform": "pdg-collectors-shop-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEbRED0p3A2ARFYwxf_rqu0Q",
    "lat": 35.1685392,
    "lng": 136.8803885,
    "placeId": "ChIJEbRED0p3A2ARFYwxf_rqu0Q",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 156,
    "id": 377,
    "district": "Nagoya Station"
  },
  {
    "title": "Furuichi Nagoya Osu",
    "urlinform": "store-33",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Gundam",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.furu1.net/shop/shop0163.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsTsLH1BxA2ARCzFUfGIzCwY",
    "lat": 35.1603337,
    "lng": 136.9049528,
    "placeId": "ChIJsTsLH1BxA2ARCzFUfGIzCwY",
    "businessStatus": "OPERATIONAL",
    "phone": "052-263-3866",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 156,
    "id": 378,
    "district": "Osu"
  },
  {
    "title": "カードショップ OCEAN",
    "urlinform": "-ocean",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/cardshop__ocean",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJa-VtMgtxA2ARMPOkh9P_8Ac",
    "lat": 35.1593833,
    "lng": 136.9048737,
    "placeId": "ChIJa-VtMgtxA2ARMPOkh9P_8Ac",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: Closed",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 9,
    "id": 379,
    "district": "Osu"
  },
  {
    "title": "TCG/ボードゲームCafe＆Bar【TOM】名古屋新栄店",
    "urlinform": "tcgcafebartom",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://hobbyshoptom.com/pages/nagoya-shinsakae",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJ2fMBFFxA2ARjsRA2JNYWRE",
    "lat": 35.1669457,
    "lng": 136.9153036,
    "placeId": "ChIJJ2fMBFFxA2ARjsRA2JNYWRE",
    "businessStatus": "OPERATIONAL",
    "phone": "090-1864-9602",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 6:00 PM – 3:00 AM",
      "Wednesday: 6:00 PM – 3:00 AM",
      "Thursday: 6:00 PM – 3:00 AM",
      "Friday: 6:00 PM – 3:00 AM",
      "Saturday: 3:00 PM – 3:00 AM",
      "Sunday: 3:00 PM – 3:00 AM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 24,
    "id": 380,
    "district": "Sakae"
  },
  {
    "title": "TCGショップKAMIBIKI",
    "urlinform": "tcgkamibiki",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/kamibiki295203?s=21",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXeBIP0hxA2ARp2PzDwXO3-U",
    "lat": 35.1613137,
    "lng": 136.9067427,
    "placeId": "ChIJXeBIP0hxA2ARp2PzDwXO3-U",
    "businessStatus": "OPERATIONAL",
    "phone": "090-3324-0708",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 3,
    "id": 381,
    "district": "Osu"
  },
  {
    "title": "トレカプラザ55 名古屋駅前店",
    "urlinform": "55-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "https://torecaplaza55.com/?mode=f1#meieki",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVRha9OV3A2ARFh85hREDJrI",
    "lat": 35.170752,
    "lng": 136.8794415,
    "placeId": "ChIJVRha9OV3A2ARFh85hREDJrI",
    "businessStatus": "OPERATIONAL",
    "phone": "052-526-0538",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 26,
    "id": 382,
    "district": "Nagoya Station"
  },
  {
    "title": "トレカミライ名古屋大須店",
    "urlinform": "store-38",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/torekamirai?s=21",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJT4JtGQBxA2ARCT3oT6DjpNQ",
    "lat": 35.1600112,
    "lng": 136.9041933,
    "placeId": "ChIJT4JtGQBxA2ARCT3oT6DjpNQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 3.7,
    "userRatingsTotal": 32,
    "id": 383,
    "district": "Osu"
  },
  {
    "title": "Treca Plaza 55 Kamimaezu",
    "urlinform": "55-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "https://torecaplaza55.com/?mode=f1#kamimaezu",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMeXiB8twA2ARyTTg2y78dtU",
    "lat": 35.1579971,
    "lng": 136.9052214,
    "placeId": "ChIJMeXiB8twA2ARyTTg2y78dtU",
    "businessStatus": "OPERATIONAL",
    "phone": "052-684-8354",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 109,
    "id": 384,
    "district": "Osu"
  },
  {
    "title": "playze meieki",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.preyz.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2fYMXgB3A2ARwyxbJAio6GA",
    "lat": 35.1685392,
    "lng": 136.8803885,
    "placeId": "ChIJ2fYMXgB3A2ARwyxbJAio6GA",
    "businessStatus": "OPERATIONAL",
    "phone": "052-526-0456",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 83,
    "id": 385,
    "district": "Nagoya Station"
  },
  {
    "title": "フルアヘッド大須１号店",
    "urlinform": "store-41",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/fullahead_osu",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJdzuG6mlxA2AR_oXqcokIKwc",
    "lat": 35.159381,
    "lng": 136.9054146,
    "placeId": "ChIJdzuG6mlxA2AR_oXqcokIKwc",
    "businessStatus": "OPERATIONAL",
    "phone": "052-228-1884",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 197,
    "id": 386,
    "district": "Osu"
  },
  {
    "title": "トレカキャンプ 名古屋駅前店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3Ve-ed53A2ARMN7alZLe5qQ",
    "lat": 35.1696231,
    "lng": 136.8792074,
    "placeId": "ChIJ3Ve-ed53A2ARMN7alZLe5qQ",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9273-8997",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 21,
    "id": 387,
    "district": "Nagoya Station"
  },
  {
    "title": "Card Labo. Satellite",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.c-labo.jp/shop/nagoyaekimae/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJve-98OZ2A2AReo0MyY0z7Ls",
    "lat": 35.1688106,
    "lng": 136.8812029,
    "placeId": "ChIJve-98OZ2A2AReo0MyY0z7Ls",
    "businessStatus": "OPERATIONAL",
    "phone": "052-433-5138",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 104,
    "id": 388,
    "district": "Nagoya Station"
  },
  {
    "title": "Hobby Station Meieki",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hbst.net/shop/18/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJj8B-jeZ2A2ARJrVbSgCrZ3w",
    "lat": 35.168132,
    "lng": 136.879603,
    "placeId": "ChIJj8B-jeZ2A2ARJrVbSgCrZ3w",
    "businessStatus": "OPERATIONAL",
    "phone": "052-452-8577",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 70,
    "id": 389,
    "district": "Nagoya Station"
  },
  {
    "title": "トレーディングカードショップ193名駅椿店",
    "urlinform": "193",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://193tcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJeRVlfgB3A2ARbTRSqtoZ18I",
    "lat": 35.1691554,
    "lng": 136.8793822,
    "placeId": "ChIJeRVlfgB3A2ARbTRSqtoZ18I",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 13,
    "id": 390,
    "district": "Nagoya Station"
  },
  {
    "title": "トレカチャンピオン名駅店",
    "urlinform": "store-46",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.trading-card-champion.com/concept10.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJa3BlRDV3A2AR_agaN5e_roI",
    "lat": 35.1678422,
    "lng": 136.8796114,
    "placeId": "ChIJa3BlRDV3A2AR_agaN5e_roI",
    "businessStatus": "OPERATIONAL",
    "phone": "052-433-3830",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 1.9,
    "userRatingsTotal": 49,
    "id": 391,
    "district": "Nagoya Station"
  },
  {
    "title": "JR Nagoya Takashimaya",
    "urlinform": "store-48",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.jr-takashimaya.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_zIUlSd3A2ARsDK_g3Ov14M",
    "lat": 35.170914,
    "lng": 136.8831799,
    "placeId": "ChIJ_zIUlSd3A2ARsDK_g3Ov14M",
    "businessStatus": "OPERATIONAL",
    "phone": "052-566-1101",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 11343,
    "id": 392,
    "district": "Nagoya Station"
  },
  {
    "title": "Hands Nagoya",
    "urlinform": "store-50",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://nagoya.hands.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJI_dLked2A2ARdWDFWTnntxs",
    "lat": 35.1708422,
    "lng": 136.8829306,
    "placeId": "ChIJI_dLked2A2ARdWDFWTnntxs",
    "businessStatus": "OPERATIONAL",
    "phone": "052-566-0109",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 922,
    "id": 393,
    "district": "Nagoya Station"
  },
  {
    "title": "Gee Store Nagoya",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.geestore.com/geenet/geestore/nagoya",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCWIh7cxwA2ARc5Bt55Hmrng",
    "lat": 35.1604867,
    "lng": 136.904534,
    "placeId": "ChIJCWIh7cxwA2ARc5Bt55Hmrng",
    "businessStatus": "OPERATIONAL",
    "phone": "052-242-3181",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 270,
    "id": 394,
    "district": "Osu"
  },
  {
    "title": "Wonder Liz",
    "urlinform": "wonder-liz-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://wonderliz.theshop.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEd1-LkZxA2AR2AEALh3G7yw",
    "lat": 35.1582261,
    "lng": 136.9057104,
    "placeId": "ChIJEd1-LkZxA2AR2AEALh3G7yw",
    "businessStatus": "OPERATIONAL",
    "phone": "052-265-5680",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 50,
    "id": 395,
    "district": "Osu"
  },
  {
    "title": "ワンピースカードゲーム公式ショップ愛知大高店",
    "urlinform": "store-53",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJk3J3PgB9A2ARG1EpzFdKi7Q",
    "lat": 35.0528766,
    "lng": 136.9476559,
    "placeId": "ChIJk3J3PgB9A2ARG1EpzFdKi7Q",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 396
  },
  {
    "title": "Hobby Station Meieki Shop 2",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hbst.net/shop/24/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvWwuZ4N3A2AR_3Df7WKr9cQ",
    "lat": 35.16758660000001,
    "lng": 136.8798349,
    "placeId": "ChIJvWwuZ4N3A2AR_3Df7WKr9cQ",
    "businessStatus": "OPERATIONAL",
    "phone": "052-485-7337",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 42,
    "id": 397,
    "district": "Nagoya Station"
  },
  {
    "title": "コーギーアール名古屋店",
    "urlinform": "store-58",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/corgi_nagoya",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcYyBhi13A2ARlhYEREKNEj8",
    "lat": 35.1689121,
    "lng": 136.8800077,
    "placeId": "ChIJcYyBhi13A2ARlhYEREKNEj8",
    "businessStatus": "OPERATIONAL",
    "phone": "070-5337-1099",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 256,
    "id": 398,
    "district": "Nagoya Station"
  },
  {
    "title": "Amenity Dream Osu",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://amenitydream.co.jp/shop/aichi-osu/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0aw5nstwA2ARow8l4wwg8sM",
    "lat": 35.1588146,
    "lng": 136.9051515,
    "placeId": "ChIJ0aw5nstwA2ARow8l4wwg8sM",
    "businessStatus": "OPERATIONAL",
    "phone": "052-265-8848",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 1.9,
    "userRatingsTotal": 131,
    "id": 399,
    "district": "Osu"
  },
  {
    "title": "大須お宝市場 アイドルグッズ専門店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://twitter.com/otakaraichiba",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJdQnchstwA2ARvMLq_GG55Ww",
    "lat": 35.1597222,
    "lng": 136.9054118,
    "placeId": "ChIJdQnchstwA2ARvMLq_GG55Ww",
    "businessStatus": "OPERATIONAL",
    "phone": "052-261-3051",
    "openingHours": [
      "Monday: 11:30 AM – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 11:30 AM – 8:00 PM",
      "Thursday: 11:30 AM – 8:00 PM",
      "Friday: 11:30 AM – 8:00 PM",
      "Saturday: 11:30 AM – 8:00 PM",
      "Sunday: 11:30 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 117,
    "id": 400,
    "district": "Osu"
  },
  {
    "title": "Next Pro Nagoya Osu",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://nextpro.shop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaxHoi8xwA2ARt9mxvgNHuiA",
    "lat": 35.1605532,
    "lng": 136.9050036,
    "placeId": "ChIJaxHoi8xwA2ARt9mxvgNHuiA",
    "businessStatus": "OPERATIONAL",
    "phone": "052-263-8772",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 179,
    "id": 401,
    "district": "Osu"
  },
  {
    "title": "トレカプラザ55 大須店",
    "urlinform": "55-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "https://torecaplaza55.com/?mode=f1#oosu",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg3zhfcxwA2AR3fItZ3jEBB0",
    "lat": 35.1600293,
    "lng": 136.9053638,
    "placeId": "ChIJg3zhfcxwA2AR3fItZ3jEBB0",
    "businessStatus": "OPERATIONAL",
    "phone": "052-265-9583",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 2.2,
    "userRatingsTotal": 33,
    "id": 402,
    "district": "Osu"
  },
  {
    "title": "トレカプラザ55 大須アメ横店",
    "urlinform": "55-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "https://torecaplaza55.com/?mode=f1#ameyoko",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ83EHPn9xA2AROEA2dw0VeFs",
    "lat": 35.1597464,
    "lng": 136.9054476,
    "placeId": "ChIJ83EHPn9xA2AROEA2dw0VeFs",
    "businessStatus": "OPERATIONAL",
    "phone": "052-211-7522",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 2.7,
    "userRatingsTotal": 68,
    "id": 403,
    "district": "Osu"
  },
  {
    "title": "Card Branch Kanayama",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ070P0LJwA2ARLdkh8T7JeUI",
    "lat": 35.1471943,
    "lng": 136.9033678,
    "placeId": "ChIJ070P0LJwA2ARLdkh8T7JeUI",
    "businessStatus": "OPERATIONAL",
    "phone": "052-331-5907",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 79,
    "id": 404,
    "district": "Kanayama"
  },
  {
    "title": "Misteria",
    "urlinform": "misteria",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/misteriafab/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo52vkT9xA2ARVwnlTlTqM-I",
    "lat": 35.1639253,
    "lng": 136.9083235,
    "placeId": "ChIJo52vkT9xA2ARVwnlTlTqM-I",
    "businessStatus": "OPERATIONAL",
    "phone": "052-211-8840",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 20,
    "id": 405,
    "district": "Osu"
  },
  {
    "title": "カードブランチ",
    "urlinform": "store-68",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx_V3RApwA2ARTOADdyo_W6M",
    "lat": 35.1646827,
    "lng": 136.9643048,
    "placeId": "ChIJx_V3RApwA2ARTOADdyo_W6M",
    "businessStatus": "OPERATIONAL",
    "phone": "052-752-0415",
    "openingHours": [
      "Monday: 5:00 – 9:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 35,
    "id": 406
  },
  {
    "title": "PDG collector’s shop 福岡天神店",
    "urlinform": "pdg-collectors-shop-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvUAISgCRQTURVIwNIBQvk3Q",
    "lat": 33.5863641,
    "lng": 130.3966779,
    "placeId": "ChIJvUAISgCRQTURVIwNIBQvk3Q",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 42,
    "id": 407,
    "district": "Tenjin"
  },
  {
    "title": "トレカマフィア 福岡店 (旧無限トレカ)",
    "urlinform": "tcg-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn4FbKwCRQTURfxTmoeVbYYs",
    "lat": 33.591994,
    "lng": 130.3956034,
    "placeId": "ChIJn4FbKwCRQTURfxTmoeVbYYs",
    "businessStatus": "OPERATIONAL",
    "phone": "092-600-1340",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 6:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 140,
    "id": 408,
    "district": "Tenjin"
  },
  {
    "title": "トレカウィッシュ -TOREKA WISH- 本店",
    "urlinform": "-toreka-wish-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ511TsGCRQTURBz_Bi_A6LAI",
    "lat": 33.589809,
    "lng": 130.3961534,
    "placeId": "ChIJ511TsGCRQTURBz_Bi_A6LAI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 753,
    "id": 409,
    "district": "Tenjin"
  },
  {
    "title": "COLLECTOR'S SHOP LIT（リット）",
    "urlinform": "collectors-shop-lit",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://collectors-shop-lit.myshopify.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs8wsBmGRQTURInJNHqpReGM",
    "lat": 33.5930537,
    "lng": 130.397445,
    "placeId": "ChIJs8wsBmGRQTURInJNHqpReGM",
    "businessStatus": "OPERATIONAL",
    "phone": "070-3205-7331",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 6:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 498,
    "id": 410,
    "district": "Tenjin"
  },
  {
    "title": "トレカライザス福岡天神店",
    "urlinform": "store-5",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://torecarises.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzaADLjSRQTURcWh3px_OtEA",
    "lat": 33.5923978,
    "lng": 130.3976966,
    "placeId": "ChIJzaADLjSRQTURcWh3px_OtEA",
    "businessStatus": "OPERATIONAL",
    "phone": "092-791-3755",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 213,
    "id": 411,
    "district": "Tenjin"
  },
  {
    "title": "トレカSunrise 福岡天神店",
    "urlinform": "sunrise-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://tcgsunrise.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKWIMmnORQTURmbQAqG162_0",
    "lat": 33.591493,
    "lng": 130.3952754,
    "placeId": "ChIJKWIMmnORQTURmbQAqG162_0",
    "businessStatus": "OPERATIONAL",
    "phone": "092-401-3633",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: Closed",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 297,
    "id": 412,
    "district": "Tenjin"
  },
  {
    "title": "TCG専門店 トレカブルー (旧BIGトレカ 福岡店)",
    "urlinform": "tcg-big-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://x.com/torekablue",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR3ba5LCRQTURYPCS7K7FK8E",
    "lat": 33.5946095,
    "lng": 130.4075671,
    "placeId": "ChIJR3ba5LCRQTURYPCS7K7FK8E",
    "businessStatus": "OPERATIONAL",
    "phone": "092-600-2610",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1174,
    "id": 413,
    "district": "Nakasu"
  },
  {
    "title": "トレカ道楽 福岡天神店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/dourakuhukuoka",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrfQyUVqRQTURpFFCSGT3a6A",
    "lat": 33.585932,
    "lng": 130.3966811,
    "placeId": "ChIJrfQyUVqRQTURpFFCSGT3a6A",
    "businessStatus": "OPERATIONAL",
    "phone": "080-9108-4514",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 271,
    "id": 414,
    "district": "Tenjin"
  },
  {
    "title": "Hareruya Fukuoka",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://www.hareruyamtg.com/jp/store/fukuoka_top.aspx",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJO45D-4WRQTURKJoyzRHZZfE",
    "lat": 33.5889008,
    "lng": 130.3959765,
    "placeId": "ChIJO45D-4WRQTURKJoyzRHZZfE",
    "businessStatus": "OPERATIONAL",
    "phone": "092-707-3232",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 101,
    "id": 415,
    "district": "Tenjin"
  },
  {
    "title": "Bee本舗福岡天神店",
    "urlinform": "bee",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://y874j.hp.peraichi.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4YAqTOmRQTURW1AEoZBnxd4",
    "lat": 33.59010680000001,
    "lng": 130.394045,
    "placeId": "ChIJ4YAqTOmRQTURW1AEoZBnxd4",
    "businessStatus": "OPERATIONAL",
    "phone": "092-791-3991",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 361,
    "id": 416,
    "district": "Tenjin"
  },
  {
    "title": "C-labo",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.c-labo.jp/shop/fukuokatenjin.shtml",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVVUV6ZGRQTURDcAn4maM-J8",
    "lat": 33.5903166,
    "lng": 130.3960401,
    "placeId": "ChIJVVUV6ZGRQTURDcAn4maM-J8",
    "businessStatus": "OPERATIONAL",
    "phone": "092-791-2646",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 2.6,
    "userRatingsTotal": 217,
    "id": 417,
    "district": "Tenjin"
  },
  {
    "title": "フルコンプ 福岡天神店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://inspire-jp.net/fc-tenjin/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYfKuSKmRQTURUQCDZrF0qwg",
    "lat": 33.5916727,
    "lng": 130.3957651,
    "placeId": "ChIJYfKuSKmRQTURUQCDZrF0qwg",
    "businessStatus": "OPERATIONAL",
    "phone": "092-752-2652",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 68,
    "id": 418,
    "district": "Tenjin"
  },
  {
    "title": "オレタン福岡天神店",
    "urlinform": "store-14",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://oretan.jp/shop/#oretan_fukuoka_tenjin",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB8Hir_eRQTURytdmf33yLCc",
    "lat": 33.5926851,
    "lng": 130.3971571,
    "placeId": "ChIJB8Hir_eRQTURytdmf33yLCc",
    "businessStatus": "OPERATIONAL",
    "phone": "092-791-8587",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 178,
    "id": 419,
    "district": "Tenjin"
  },
  {
    "title": "Card KINGDOM Hakata Sumiyoshi shop",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/DGsumiyoshi",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvUrmAb6RQTURckJccqr7jaY",
    "lat": 33.5878174,
    "lng": 130.4101168,
    "placeId": "ChIJvUrmAb6RQTURckJccqr7jaY",
    "businessStatus": "OPERATIONAL",
    "phone": "092-292-3082",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 470,
    "id": 420,
    "district": "Nakasu"
  },
  {
    "title": "MINT FUKUOKA PARCO",
    "urlinform": "mint-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://mint-web.jp/?pid=162699308",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc0HMXYORQTURm_IxYcbHNxA",
    "lat": 33.590874,
    "lng": 130.39855,
    "placeId": "ChIJc0HMXYORQTURm_IxYcbHNxA",
    "businessStatus": "OPERATIONAL",
    "phone": "092-406-8030",
    "openingHours": [
      "Monday: 10:00 AM – 8:30 PM",
      "Tuesday: 10:00 AM – 8:30 PM",
      "Wednesday: 10:00 AM – 8:30 PM",
      "Thursday: 10:00 AM – 8:30 PM",
      "Friday: 10:00 AM – 8:30 PM",
      "Saturday: 10:00 AM – 8:30 PM",
      "Sunday: 10:00 AM – 8:30 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 28,
    "id": 421,
    "district": "Tenjin"
  },
  {
    "title": "Pokémon Center FUKUOKA",
    "urlinform": "store-19",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/fukuoka/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ74LQjMeRQTURouWqGzzDgF8",
    "lat": 33.5890033,
    "lng": 130.4192564,
    "placeId": "ChIJ74LQjMeRQTURouWqGzzDgF8",
    "businessStatus": "OPERATIONAL",
    "phone": "092-413-5185",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 2116,
    "id": 422,
    "district": "Hakata"
  },
  {
    "title": "晴れる屋2 福岡店",
    "urlinform": "2-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.hareruya2.com/pages/store_fukuoka",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEfTe_36RQTUR60yRt7CcWKA",
    "lat": 33.5889008,
    "lng": 130.3959765,
    "placeId": "ChIJEfTe_36RQTUR60yRt7CcWKA",
    "businessStatus": "OPERATIONAL",
    "phone": "092-753-7999",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 32,
    "id": 423,
    "district": "Tenjin"
  },
  {
    "title": "Culture Arts",
    "urlinform": "store-21",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/fukuoka_game",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHxo0s-6RQTURj6GMgQXB7xc",
    "lat": 33.5932722,
    "lng": 130.395327,
    "placeId": "ChIJHxo0s-6RQTURj6GMgQXB7xc",
    "businessStatus": "OPERATIONAL",
    "phone": "092-409-0193",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: Closed",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 188,
    "id": 424,
    "district": "Tenjin"
  },
  {
    "title": "カードショップ NEM 天神店",
    "urlinform": "-nem-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.nemcard.com/view/page/tenjin",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJe84_SW6RQTUR-7qmzLorlGg",
    "lat": 33.5923889,
    "lng": 130.3976694,
    "placeId": "ChIJe84_SW6RQTUR-7qmzLorlGg",
    "businessStatus": "OPERATIONAL",
    "phone": "092-600-9648",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 16,
    "id": 425,
    "district": "Tenjin"
  },
  {
    "title": "カードショップLotus（ロータス 福岡中洲店）",
    "urlinform": "lotus-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.cslotus.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNaeowYWRQTURZX6q96O4fM8",
    "lat": 33.5935114,
    "lng": 130.4068656,
    "placeId": "ChIJNaeowYWRQTURZX6q96O4fM8",
    "businessStatus": "OPERATIONAL",
    "phone": "092-409-4222",
    "openingHours": [
      "Monday: 5:00 PM – 3:00 AM",
      "Tuesday: 5:00 PM – 3:00 AM",
      "Wednesday: 5:00 PM – 3:00 AM",
      "Thursday: 5:00 PM – 3:00 AM",
      "Friday: 3:00 PM – 3:00 AM",
      "Saturday: 3:00 PM – 3:00 AM",
      "Sunday: Closed"
    ],
    "rating": 3.2,
    "userRatingsTotal": 93,
    "id": 426,
    "district": "Nakasu"
  },
  {
    "title": "トレカボール 天神店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/toreca_ball",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP-cEbnmRQTURzMzuJ7UAPZs",
    "lat": 33.59347,
    "lng": 130.3959957,
    "placeId": "ChIJP-cEbnmRQTURzMzuJ7UAPZs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 2.9,
    "userRatingsTotal": 61,
    "id": 427,
    "district": "Tenjin"
  },
  {
    "title": "MINT FUKUOKA",
    "urlinform": "mint-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://mint-web.jp/?pid=4246614",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC5PrzY2RQTUR87_XUMfEhNo",
    "lat": 33.5871792,
    "lng": 130.3939026,
    "placeId": "ChIJC5PrzY2RQTUR87_XUMfEhNo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 51,
    "id": 428,
    "district": "Tenjin"
  },
  {
    "title": "One Piece Mugiwara Store Fukuoka",
    "urlinform": "one-piece-mugiwara-store-fukuoka",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "http://www.mugiwara-store.com/store/1256",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUb55ro-RQTURoE9G9x5ro3k",
    "lat": 33.5909928,
    "lng": 130.3987121,
    "placeId": "ChIJUb55ro-RQTURoE9G9x5ro3k",
    "businessStatus": "OPERATIONAL",
    "phone": "092-235-7428",
    "openingHours": [
      "Monday: 10:00 AM – 8:30 PM",
      "Tuesday: 10:00 AM – 8:30 PM",
      "Wednesday: 10:00 AM – 8:30 PM",
      "Thursday: 10:00 AM – 8:30 PM",
      "Friday: 10:00 AM – 8:30 PM",
      "Saturday: 10:00 AM – 8:30 PM",
      "Sunday: 10:00 AM – 8:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 254,
    "id": 429,
    "district": "Tenjin"
  },
  {
    "title": "ONE PIECEカードゲーム 公式ショップ 博多店",
    "urlinform": "one-piece-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Gundam",
      "One Piece"
    ],
    "storeWebsite": "https://bandainamco-am.co.jp/official_shop/onepiece-cardgame/index.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJedK_ER2RQTUR54UW0Lb2xv4",
    "lat": 33.5885076,
    "lng": 130.4109059,
    "placeId": "ChIJedK_ER2RQTUR54UW0Lb2xv4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 5,
    "id": 430,
    "district": "Nakasu"
  },
  {
    "title": "TCG専門店 KISEKI7",
    "urlinform": "tcg-kiseki7",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyYTmUY2TQTURQULDlB8kpNE",
    "lat": 33.5834964,
    "lng": 130.3895487,
    "placeId": "ChIJyYTmUY2TQTURQULDlB8kpNE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 17,
    "id": 431
  },
  {
    "title": "Dora-goon Hakata",
    "urlinform": "store-29",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://koplus-dragoon.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK7CzixCRQTURIoJBhZsnk04",
    "lat": 33.5925871,
    "lng": 130.4175055,
    "placeId": "ChIJK7CzixCRQTURIoJBhZsnk04",
    "businessStatus": "OPERATIONAL",
    "phone": "092-710-2292",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 586,
    "id": 432,
    "district": "Hakata"
  },
  {
    "title": "Surugaya Shintencho Treka-kan (Trading Card Shop)",
    "urlinform": "store-30",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.suruga-ya.jp/feature/realstore/shintencho/index.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8_hFa6CRQTURaglw0iOhfWc",
    "lat": 33.5902166,
    "lng": 130.3978275,
    "placeId": "ChIJ8_hFa6CRQTURaglw0iOhfWc",
    "businessStatus": "OPERATIONAL",
    "phone": "092-791-9343",
    "openingHours": [
      "Monday: 2:00 – 8:30 PM",
      "Tuesday: 2:00 – 8:30 PM",
      "Wednesday: 2:00 – 8:30 PM",
      "Thursday: 2:00 – 8:30 PM",
      "Friday: 12:00 – 8:30 PM",
      "Saturday: 12:00 – 8:30 PM",
      "Sunday: 12:00 – 8:30 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 7,
    "id": 433,
    "district": "Tenjin"
  },
  {
    "title": "トレカX",
    "urlinform": "x",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/X_TCG1",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo_VIZHyRQTURJuboTt0Y708",
    "lat": 33.5955396,
    "lng": 130.4080753,
    "placeId": "ChIJo_VIZHyRQTURJuboTt0Y708",
    "businessStatus": "OPERATIONAL",
    "phone": "080-7518-5717",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 3:00 – 9:00 PM",
      "Sunday: 3:00 – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 112,
    "id": 434,
    "district": "Nakasu"
  },
  {
    "title": "天神お宝市場",
    "urlinform": "store-33",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/otakaraichiba",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgwxYhI6RQTURKcD1e63kAJs",
    "lat": 33.593084,
    "lng": 130.3976557,
    "placeId": "ChIJgwxYhI6RQTURKcD1e63kAJs",
    "businessStatus": "OPERATIONAL",
    "phone": "080-9860-8147",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 67,
    "id": 435,
    "district": "Tenjin"
  },
  {
    "title": "トレカウィッシュ キャナルシティ博多店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrXKHvRiRQTURNNnOaM-X1Rw",
    "lat": 33.5898838,
    "lng": 130.4110545,
    "placeId": "ChIJrXKHvRiRQTURNNnOaM-X1Rw",
    "businessStatus": "OPERATIONAL",
    "phone": "080-6387-3763",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 676,
    "id": 436,
    "district": "Nakasu"
  },
  {
    "title": "C-labo Hakata Marui",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.c-labo.jp/shop/hakatamarui/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE3L-NiqRQTURVrTd-QZHmRg",
    "lat": 33.588902,
    "lng": 130.4197025,
    "placeId": "ChIJE3L-NiqRQTURVrTd-QZHmRg",
    "businessStatus": "OPERATIONAL",
    "phone": "092-710-5655",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 120,
    "id": 437,
    "district": "Hakata"
  },
  {
    "title": "遊INGコマーシャルモール博多店",
    "urlinform": "ing",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://youing.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoVMG76WRQTURMRXu6c9s33E",
    "lat": 33.5767414,
    "lng": 130.4361935,
    "placeId": "ChIJoVMG76WRQTURMRXu6c9s33E",
    "businessStatus": "OPERATIONAL",
    "phone": "092-688-1009",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 2.5,
    "userRatingsTotal": 61,
    "id": 438
  },
  {
    "title": "Supotsukadomintohakataekimaeten",
    "urlinform": "store-39",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://mint-hakata.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv2PnMbmRQTURPbUrTptTlpo",
    "lat": 33.5878377,
    "lng": 130.4164107,
    "placeId": "ChIJv2PnMbmRQTURPbUrTptTlpo",
    "businessStatus": "OPERATIONAL",
    "phone": "092-414-7715",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 15,
    "id": 439,
    "district": "Hakata"
  },
  {
    "title": "Card Shop Toreka-oh",
    "urlinform": "store-40",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://torekaoh.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRfuT53CPQTURWN-oKhz14y4",
    "lat": 33.6358537,
    "lng": 130.4598101,
    "placeId": "ChIJRfuT53CPQTURWN-oKhz14y4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 6:00 PM",
      "Wednesday: Closed",
      "Thursday: 2:00 – 6:00 PM",
      "Friday: 2:00 – 6:00 PM",
      "Saturday: 2:00 – 6:00 PM",
      "Sunday: 2:00 – 7:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 25,
    "id": 440
  },
  {
    "title": "福岡買取コレクター店",
    "urlinform": "store-42",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://ryollc6868.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoVu1TqCRQTURB6di33o0nrE",
    "lat": 33.5903479,
    "lng": 130.4100605,
    "placeId": "ChIJoVu1TqCRQTURB6di33o0nrE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 7,
    "id": 441,
    "district": "Nakasu"
  },
  {
    "title": "Good トレカショップ 博多ポケモンカード専門店",
    "urlinform": "good-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDZM3QqaPQTURV2CtjZ8-Gds",
    "lat": 33.6013255,
    "lng": 130.4490904,
    "placeId": "ChIJDZM3QqaPQTURV2CtjZ8-Gds",
    "businessStatus": "OPERATIONAL",
    "phone": "080-2772-2701",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: Closed",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 442
  },
  {
    "title": "Tom Sawyer",
    "urlinform": "store-45",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGaIipJqRQTURigRoBRBmewU",
    "lat": 33.586955,
    "lng": 130.401588,
    "placeId": "ChIJGaIipJqRQTURigRoBRBmewU",
    "businessStatus": "OPERATIONAL",
    "phone": "092-732-0007",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 205,
    "id": 443,
    "district": "Tenjin"
  },
  {
    "title": "CANAL CITY HAKATA",
    "urlinform": "store-46",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://canalcity.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYcOBiZWRQTUR0Rl0ehe67eA",
    "lat": 33.5896305,
    "lng": 130.4109478,
    "placeId": "ChIJYcOBiZWRQTUR0Rl0ehe67eA",
    "businessStatus": "OPERATIONAL",
    "phone": "092-282-2525",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 55781,
    "id": 444,
    "district": "Nakasu"
  },
  {
    "title": "NAHA BASE Pokemon Card Shop Okinawa",
    "urlinform": "naha-base-pokemon-card-shop-okinawa",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://x.com/oknwpokemon?s=21",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs04LfLNp5TQRzI_6jl-WWKA",
    "lat": 26.2129802,
    "lng": 127.6765052,
    "placeId": "ChIJs04LfLNp5TQRzI_6jl-WWKA",
    "businessStatus": "OPERATIONAL",
    "phone": "080-2771-4602",
    "openingHours": [
      "Monday: 10:00 AM – 11:00 PM",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 4:00 PM",
      "Friday: 10:00 AM – 12:00 AM",
      "Saturday: 10:00 AM – 12:00 AM",
      "Sunday: 10:00 AM – 12:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 324,
    "id": 445,
    "district": "Naha"
  },
  {
    "title": "POKEMON CARD SHOP Ａny ポケモンカード専門店",
    "urlinform": "pokemon-card-shop-ny-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://twitter.com/any___oki",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPYk3SRFp5TQRaKNqVizPHlQ",
    "lat": 26.2027051,
    "lng": 127.7013703,
    "placeId": "ChIJPYk3SRFp5TQRaKNqVizPHlQ",
    "businessStatus": "OPERATIONAL",
    "phone": "090-8643-8648",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 105,
    "id": 446
  },
  {
    "title": "ポケカ沖縄トレカクラブPOKEMON CARD SHOP ポケモンカード専門店",
    "urlinform": "pokemon-card-shop-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://x.com/okinawa_toreca?s=21&t=YE1mtRcA8G_PGrfIty164g",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyy9Ax31t5TQRc3Bb6ii_VY4",
    "lat": 26.2154961,
    "lng": 127.7251319,
    "placeId": "ChIJyy9Ax31t5TQRc3Bb6ii_VY4",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9188-8380",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 8,
    "id": 447
  },
  {
    "title": "TCG SHOP FiRST",
    "urlinform": "tcg-shop-first",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://mobile.twitter.com/first_tcg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyecNPYBp5TQR7MY-4tS7DRE",
    "lat": 26.1981804,
    "lng": 127.6759688,
    "placeId": "ChIJyecNPYBp5TQR7MY-4tS7DRE",
    "businessStatus": "OPERATIONAL",
    "phone": "070-8300-3286",
    "openingHours": [
      "Monday: 4:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 4:00 – 10:00 PM",
      "Thursday: 4:00 – 10:00 PM",
      "Friday: 4:00 – 10:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 21,
    "id": 448
  },
  {
    "title": "Japan TCG Center 那覇沖映通り店",
    "urlinform": "japan-tcg-center-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.bookoff.co.jp/shop/shop68002.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgbAwBABp5TQR7eAbxDmkY5g",
    "lat": 26.2185905,
    "lng": 127.6857859,
    "placeId": "ChIJgbAwBABp5TQR7eAbxDmkY5g",
    "businessStatus": "OPERATIONAL",
    "phone": "050-1726-7463",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 37,
    "id": 449,
    "district": "Kokusai Street"
  },
  {
    "title": "Ocean",
    "urlinform": "ocean",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGS9pEBlp5TQRzI8qL41R4OE",
    "lat": 26.1976905,
    "lng": 127.6688081,
    "placeId": "ChIJGS9pEBlp5TQRzI8qL41R4OE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 46,
    "id": 450
  },
  {
    "title": "ABSOLUTE ZERO",
    "urlinform": "absolute-zero",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://islandwalker.akazunoma.com/index.htm",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJH-FydgNt5TQRGf-xZDqXiXk",
    "lat": 26.2476952,
    "lng": 127.7706259,
    "placeId": "ChIJH-FydgNt5TQRGf-xZDqXiXk",
    "businessStatus": "OPERATIONAL",
    "phone": "098-895-7090",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: Closed",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 66,
    "id": 451
  },
  {
    "title": "ONE PIECEカードゲーム 公式ショップ 沖縄店",
    "urlinform": "one-piece-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Gundam",
      "One Piece"
    ],
    "storeWebsite": "https://bandainamco-am.co.jp/official_shop/onepiece-cardgame/index.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJe6eudvRr5TQR9E8-RcGAwLE",
    "lat": 26.2256596,
    "lng": 127.6950574,
    "placeId": "ChIJe6eudvRr5TQR9E8-RcGAwLE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 10:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 10:00 PM",
      "Sunday: 9:00 AM – 10:00 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 13,
    "id": 452
  },
  {
    "title": "Shima",
    "urlinform": "-ocean",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/OceanUrasoe",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8Vmbgh1r5TQRsmOXco50o7k",
    "lat": 26.2580966,
    "lng": 127.7125387,
    "placeId": "ChIJ8Vmbgh1r5TQRsmOXco50o7k",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 33,
    "id": 453
  },
  {
    "title": "Table Dog",
    "urlinform": "table-dog",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/tabledog3104",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhxcGgcYT5TQRN49TMxhpm2Q",
    "lat": 26.3113981,
    "lng": 127.7966102,
    "placeId": "ChIJhxcGgcYT5TQRN49TMxhpm2Q",
    "businessStatus": "OPERATIONAL",
    "phone": "098-979-7168",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 31,
    "id": 454
  },
  {
    "title": "Japan TCG Centerイオンモール沖縄ライカム店",
    "urlinform": "japan-tcg-center",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.bookoff.co.jp/shop/shop68001.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE_Jm7bgT5TQR1cUcDlEZfgU",
    "lat": 26.3147684,
    "lng": 127.795254,
    "placeId": "ChIJE_Jm7bgT5TQR1cUcDlEZfgU",
    "businessStatus": "OPERATIONAL",
    "phone": "050-1726-5547",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 2.7,
    "userRatingsTotal": 43,
    "id": 455
  },
  {
    "title": "カードショップ ひまわり",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ65Jp52hp5TQRc-w1J_bjoAw",
    "lat": 26.209785,
    "lng": 127.698558,
    "placeId": "ChIJ65Jp52hp5TQRc-w1J_bjoAw",
    "businessStatus": "OPERATIONAL",
    "phone": "098-834-7528",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 20,
    "id": 456
  },
  {
    "title": "Manga Souko Naha",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://mangasouko-okinawa.com/naha/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD_hoYDVo5TQRo2-NLy_AqCU",
    "lat": 26.1920809,
    "lng": 127.6598652,
    "placeId": "ChIJD_hoYDVo5TQRo2-NLy_AqCU",
    "businessStatus": "OPERATIONAL",
    "phone": "098-891-8181",
    "openingHours": [
      "Monday: 9:00 AM – 12:00 AM",
      "Tuesday: 9:00 AM – 12:00 AM",
      "Wednesday: 9:00 AM – 12:00 AM",
      "Thursday: 9:00 AM – 12:00 AM",
      "Friday: 9:00 AM – 12:00 AM",
      "Saturday: 9:00 AM – 12:00 AM",
      "Sunday: 9:00 AM – 12:00 AM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 4274,
    "id": 457
  },
  {
    "title": "デュエル・マスターズ専門店 FAIRY",
    "urlinform": "-fairy",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://youtube.com/@FAIRY-gu1ni?si=zUW0Rq06ORlujj7D",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJq6u_WSlt5TQRwf5zAhNN2KY",
    "lat": 26.2300953,
    "lng": 127.7536959,
    "placeId": "ChIJq6u_WSlt5TQRwf5zAhNN2KY",
    "businessStatus": "OPERATIONAL",
    "phone": "098-943-8832",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 4:00 – 11:00 PM",
      "Wednesday: 4:00 – 11:00 PM",
      "Thursday: 4:00 – 11:00 PM",
      "Friday: 4:00 – 11:00 PM",
      "Saturday: 4:00 – 11:00 PM",
      "Sunday: 4:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 458
  },
  {
    "title": "GEO Naha Oroku",
    "urlinform": "store-19",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://geo-online.co.jp/store/02360/?utm_source=google&utm_medium=map&utm_campaign=02360",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyVzZKLVp5TQRZTQB9C_6trs",
    "lat": 26.1932707,
    "lng": 127.6623866,
    "placeId": "ChIJyVzZKLVp5TQRZTQB9C_6trs",
    "businessStatus": "OPERATIONAL",
    "phone": "098-859-7025",
    "openingHours": [
      "Monday: 9:00 AM – 11:00 PM",
      "Tuesday: 9:00 AM – 11:00 PM",
      "Wednesday: 9:00 AM – 11:00 PM",
      "Thursday: 9:00 AM – 11:00 PM",
      "Friday: 9:00 AM – 11:00 PM",
      "Saturday: 9:00 AM – 11:00 PM",
      "Sunday: 9:00 AM – 11:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 310,
    "id": 459
  },
  {
    "title": "GEO Naha Shintoshin",
    "urlinform": "store-21",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://geo-online.co.jp/store/02251/?utm_source=google&utm_medium=map&utm_campaign=02251",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZes6zNhr5TQRmaT3NcXKUvk",
    "lat": 26.22415,
    "lng": 127.696889,
    "placeId": "ChIJZes6zNhr5TQRmaT3NcXKUvk",
    "businessStatus": "OPERATIONAL",
    "phone": "098-941-3830",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3.8,
    "userRatingsTotal": 835,
    "id": 460
  },
  {
    "title": "Family Books",
    "urlinform": "store-22",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC5lr_HBp5TQRZRQWS97X7eo",
    "lat": 26.212716,
    "lng": 127.6887367,
    "placeId": "ChIJC5lr_HBp5TQRZRQWS97X7eo",
    "businessStatus": "OPERATIONAL",
    "phone": "098-869-7126",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 20,
    "id": 461,
    "district": "Kokusai Street"
  },
  {
    "title": "トレカアイル",
    "urlinform": "store-23",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/TCGSHOP_AIRU",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJO_a3BgBr5TQRAU8W6fj-r08",
    "lat": 26.2305279,
    "lng": 127.702665,
    "placeId": "ChIJO_a3BgBr5TQRAU8W6fj-r08",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 8,
    "id": 462
  },
  {
    "title": "TCGSHOP STAR",
    "urlinform": "tcgshop-star",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linktr.ee/tcgshop.star",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6zOmn2xn5TQRW23nPyIXzjs",
    "lat": 26.1440249,
    "lng": 127.669019,
    "placeId": "ChIJ6zOmn2xn5TQRW23nPyIXzjs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 4:00 – 9:00 PM",
      "Tuesday: 4:00 – 9:00 PM",
      "Wednesday: 4:00 – 9:00 PM",
      "Thursday: Closed",
      "Friday: 4:00 – 9:00 PM",
      "Saturday: 3:00 – 9:00 PM",
      "Sunday: 3:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 76,
    "id": 463
  },
  {
    "title": "ポケモンカード専門店Ocean泡瀬店",
    "urlinform": "ocean",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://twitter.com/OceanAwase",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC71XcQYN5TQR_zzMJIbCnkQ",
    "lat": 26.3210572,
    "lng": 127.8277409,
    "placeId": "ChIJC71XcQYN5TQR_zzMJIbCnkQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 22,
    "id": 464
  },
  {
    "title": "Saikorodo",
    "urlinform": "store-26",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/saikorodo?igsh=M2YxcXhhbWw4bXYz&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNe5D6mhp5TQRFOYxWyF9MVA",
    "lat": 26.210422,
    "lng": 127.698614,
    "placeId": "ChIJNe5D6mhp5TQRFOYxWyF9MVA",
    "businessStatus": "OPERATIONAL",
    "phone": "050-3579-1105",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 3:00 PM – 1:00 AM",
      "Saturday: 1:00 PM – 1:00 AM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 66,
    "id": 465
  },
  {
    "title": "Pokemon Center Okinawa",
    "urlinform": "store-27",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/okinawa/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUdDigOQT5TQRRBJQh6HpZUk",
    "lat": 26.313199,
    "lng": 127.796159,
    "placeId": "ChIJUdDigOQT5TQRRBJQh6HpZUk",
    "businessStatus": "OPERATIONAL",
    "phone": "098-987-8063",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 1443,
    "id": 466
  },
  {
    "title": "TCG shop POCOP",
    "urlinform": "-pocop-tcg-shop",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJy-O4RQAP5TQR-L6n2-l2wwo",
    "lat": 26.3769308,
    "lng": 127.8580162,
    "placeId": "ChIJy-O4RQAP5TQR-L6n2-l2wwo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: Closed",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 8,
    "id": 467
  },
  {
    "title": "ポケカ SUNRISE",
    "urlinform": "-sunrise",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJreIL_1wT5TQRVgghJqXUWBI",
    "lat": 26.3237028,
    "lng": 127.7500334,
    "placeId": "ChIJreIL_1wT5TQRVgghJqXUWBI",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9190-4477",
    "openingHours": [
      "Monday: 3:00 – 7:00 PM",
      "Tuesday: 3:00 – 7:00 PM",
      "Wednesday: 3:00 – 7:00 PM",
      "Thursday: 3:00 – 7:00 PM",
      "Friday: 3:00 – 7:00 PM",
      "Saturday: 3:00 – 7:00 PM",
      "Sunday: 3:00 – 7:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 8,
    "id": 468,
    "district": "Chatan"
  },
  {
    "title": "LIVE Print Now PeRo OKINAWA 国際通り店",
    "urlinform": "live-print-now-pero-okinawa-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://pero-okinawa-kokusai.jimdofree.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD2MRfwZp5TQRddOzHenG7AY",
    "lat": 26.2171087,
    "lng": 127.6909892,
    "placeId": "ChIJD2MRfwZp5TQRddOzHenG7AY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 5:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 9:00 AM – 8:00 PM",
      "Friday: 9:00 AM – 8:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 9:00 AM – 5:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 50,
    "id": 469,
    "district": "Kokusai Street"
  },
  {
    "title": "GiGO那覇国際通り",
    "urlinform": "gigo",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.gigo.co.jp/shops/naha-kokusaidori/?utm_campaign=mov&utm_medium=GBP&utm_source=website-button",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJS5UYw1Zp5TQRvHuOx3oLUPE",
    "lat": 26.2144145,
    "lng": 127.6821469,
    "placeId": "ChIJS5UYw1Zp5TQRvHuOx3oLUPE",
    "businessStatus": "OPERATIONAL",
    "phone": "070-1547-7507",
    "openingHours": [
      "Monday: 10:00 AM – 12:00 AM",
      "Tuesday: 10:00 AM – 12:00 AM",
      "Wednesday: 10:00 AM – 12:00 AM",
      "Thursday: 10:00 AM – 12:00 AM",
      "Friday: 10:00 AM – 12:00 AM",
      "Saturday: 10:00 AM – 12:00 AM",
      "Sunday: 10:00 AM – 12:00 AM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 152,
    "id": 470,
    "district": "Naha"
  },
  {
    "title": "Naha Kokusai Dori Shopping Street",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://naha-kokusaidori.okinawa/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-w8fcHdp5TQR_PlKZmQhehM",
    "lat": 26.2161433,
    "lng": 127.6880667,
    "placeId": "ChIJ-w8fcHdp5TQR_PlKZmQhehM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 5:00 PM",
      "Tuesday: 10:00 AM – 5:00 PM",
      "Wednesday: 10:00 AM – 5:00 PM",
      "Thursday: 10:00 AM – 5:00 PM",
      "Friday: 10:00 AM – 5:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.2,
    "userRatingsTotal": 22558,
    "id": 471,
    "district": "Kokusai Street"
  },
  {
    "title": "K-POP MUSIC STORE SHINOKUBO NAHA",
    "urlinform": "k-pop-music-store-shinokubo-naha",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://instagram.com/shinokubonaha",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1-Yz9Vlp5TQRfY3XL5GY-kk",
    "lat": 26.2177421,
    "lng": 127.6916946,
    "placeId": "ChIJ1-Yz9Vlp5TQRfY3XL5GY-kk",
    "businessStatus": "OPERATIONAL",
    "phone": "098-988-3565",
    "openingHours": [
      "Monday: 9:30 AM – 9:00 PM",
      "Tuesday: 9:30 AM – 9:00 PM",
      "Wednesday: 9:30 AM – 9:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 9:00 PM",
      "Saturday: 9:30 AM – 9:00 PM",
      "Sunday: 9:30 AM – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 191,
    "id": 472,
    "district": "Kokusai Street"
  },
  {
    "title": "Mi-ja（ミージャ） 国際通り2号店",
    "urlinform": "mi-ja-2",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJU87fBXpp5TQRC_xXW_qumVQ",
    "lat": 26.2158967,
    "lng": 127.6875463,
    "placeId": "ChIJU87fBXpp5TQRC_xXW_qumVQ",
    "businessStatus": "OPERATIONAL",
    "phone": "098-866-3413",
    "openingHours": [
      "Monday: 9:00 AM – 10:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 10:00 PM",
      "Sunday: 9:00 AM – 10:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 11,
    "id": 473,
    "district": "Kokusai Street"
  },
  {
    "title": "キッドハウス3号店",
    "urlinform": "3",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.kidsouthwing.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ93R63Gtp5TQRk3WxfBGscXU",
    "lat": 26.2172136,
    "lng": 127.6905788,
    "placeId": "ChIJ93R63Gtp5TQRk3WxfBGscXU",
    "businessStatus": "OPERATIONAL",
    "phone": "098-863-0210",
    "openingHours": [
      "Monday: 9:00 AM – 11:00 PM",
      "Tuesday: 9:00 AM – 11:00 PM",
      "Wednesday: 9:00 AM – 11:00 PM",
      "Thursday: 9:00 AM – 11:00 PM",
      "Friday: 9:00 AM – 11:00 PM",
      "Saturday: 9:00 AM – 11:00 PM",
      "Sunday: 9:00 AM – 11:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 22,
    "id": 474,
    "district": "Kokusai Street"
  },
  {
    "title": "CARDBOX 北谷店",
    "urlinform": "cardbox-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardbox.online/shop/detail/4226",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPW2cgh8T5TQRYHOK4XWL3nY",
    "lat": 26.3167416,
    "lng": 127.7555489,
    "placeId": "ChIJPW2cgh8T5TQRYHOK4XWL3nY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 34,
    "id": 475,
    "district": "Chatan"
  },
  {
    "title": "トレーディングカード専門店Pical",
    "urlinform": "pical",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPzI5UKQP5TQRG5hnkbljoyg",
    "lat": 26.3571767,
    "lng": 127.836164,
    "placeId": "ChIJPzI5UKQP5TQRG5hnkbljoyg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: Closed",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 20,
    "id": 476
  },
  {
    "title": "Kappa Castle カッパのお城",
    "urlinform": "store-41",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/kappacastlegame",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJO2pqRZlr5TQRrWa3BwdwXZQ",
    "lat": 26.3102463,
    "lng": 127.7622348,
    "placeId": "ChIJO2pqRZlr5TQRrWa3BwdwXZQ",
    "businessStatus": "OPERATIONAL",
    "phone": "098-955-2343",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: Closed",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 180,
    "id": 477,
    "district": "American Village"
  },
  {
    "title": "サイコロ堂シーサイド",
    "urlinform": "store-42",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://saikorodo.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuaViXIAT5TQRcJOHLn2t86s",
    "lat": 26.317437,
    "lng": 127.7545431,
    "placeId": "ChIJuaViXIAT5TQRcJOHLn2t86s",
    "businessStatus": "OPERATIONAL",
    "phone": "050-3091-3156",
    "openingHours": [
      "Monday: 10:00 AM – 1:00 AM",
      "Tuesday: 10:00 AM – 1:00 AM",
      "Wednesday: 10:00 AM – 1:00 AM",
      "Thursday: 10:00 AM – 1:00 AM",
      "Friday: 10:00 AM – 1:00 AM",
      "Saturday: 10:00 AM – 1:00 AM",
      "Sunday: 10:00 AM – 1:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 104,
    "id": 478,
    "district": "Chatan"
  },
  {
    "title": "Ghost Village Action Figure Shop",
    "urlinform": "ghost-village-action-figure-shop",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ29ZsIPwR5TQRr7F-5oW2SOk",
    "lat": 26.3552085,
    "lng": 127.804998,
    "placeId": "ChIJ29ZsIPwR5TQRr7F-5oW2SOk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 4:00 PM – 12:00 AM",
      "Tuesday: 4:00 PM – 12:00 AM",
      "Wednesday: 4:00 PM – 12:00 AM",
      "Thursday: 4:00 PM – 12:00 AM",
      "Friday: 4:00 PM – 12:00 AM",
      "Saturday: 4:00 PM – 12:00 AM",
      "Sunday: 4:00 PM – 12:00 AM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 36,
    "id": 479
  },
  {
    "title": "Okinawa-ya",
    "urlinform": "store-44",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.okinawaya.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKwkPaQUT5TQRr1SbNlNMNpc",
    "lat": 26.316371,
    "lng": 127.756832,
    "placeId": "ChIJKwkPaQUT5TQRr1SbNlNMNpc",
    "businessStatus": "OPERATIONAL",
    "phone": "098-936-7494",
    "openingHours": [
      "Monday: 10:30 AM – 9:30 PM",
      "Tuesday: 10:30 AM – 9:30 PM",
      "Wednesday: 10:30 AM – 9:30 PM",
      "Thursday: 10:30 AM – 9:30 PM",
      "Friday: 10:30 AM – 9:30 PM",
      "Saturday: 10:30 AM – 9:30 PM",
      "Sunday: 10:30 AM – 9:30 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 27,
    "id": 480,
    "district": "Chatan"
  },
  {
    "title": "MINT沖縄店 スポーツカード＆カードゲーム",
    "urlinform": "mint-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://mint-web.jp/?pid=184738985",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-1n_4KoT5TQRXxgKsI2z8DE",
    "lat": 26.3144102,
    "lng": 127.7952664,
    "placeId": "ChIJ-1n_4KoT5TQRXxgKsI2z8DE",
    "businessStatus": "OPERATIONAL",
    "phone": "098-923-1501",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 22,
    "id": 481
  },
  {
    "title": "OKINAWA MARKET",
    "urlinform": "t-okinawa-market",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.okinawamarket.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJw6383g8T5TQR9fvnumin6vg",
    "lat": 26.3156052,
    "lng": 127.7540844,
    "placeId": "ChIJw6383g8T5TQR9fvnumin6vg",
    "businessStatus": "OPERATIONAL",
    "phone": "098-926-0288",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 41,
    "id": 482,
    "district": "Chatan"
  },
  {
    "title": "American Depot B",
    "urlinform": "b",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.depot-abc.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFbL5awUT5TQRqbKPe9alF6c",
    "lat": 26.316254,
    "lng": 127.7565624,
    "placeId": "ChIJFbL5awUT5TQRqbKPe9alF6c",
    "businessStatus": "OPERATIONAL",
    "phone": "098-926-3322",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 148,
    "id": 483,
    "district": "Chatan"
  },
  {
    "title": "美浜アメリカンビレッジ ポケジェニック2",
    "urlinform": "-2",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo_QAjGoT5TQRWELZJKA10KI",
    "lat": 26.3157877,
    "lng": 127.7566124,
    "placeId": "ChIJo_QAjGoT5TQRWELZJKA10KI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 4,
    "userRatingsTotal": 51,
    "id": 484,
    "district": "American Village"
  },
  {
    "title": "American Village",
    "urlinform": "store-49",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.okinawa-americanvillage.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzZoVCAUT5TQRzIueHYt83hs",
    "lat": 26.3158799,
    "lng": 127.7540077,
    "placeId": "ChIJzZoVCAUT5TQRzIueHYt83hs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 28239,
    "id": 485,
    "district": "Chatan"
  },
  {
    "title": "American Depot C",
    "urlinform": "c",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.depot-abc.com/shop/american-depot",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMdLPLGwT5TQRrn8e9CalRPM",
    "lat": 26.3160813,
    "lng": 127.7563794,
    "placeId": "ChIJMdLPLGwT5TQRrn8e9CalRPM",
    "businessStatus": "OPERATIONAL",
    "phone": "098-926-0888",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 48,
    "id": 486,
    "district": "Chatan"
  },
  {
    "title": "AEON MALL Okinawa Rycom",
    "urlinform": "store-51",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://okinawarycom.aeonmall.jp/?utm_source=google_maps&utm_medium=organic&utm_campaign=website",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJ_TSFGIS5TQRa_HkdjGALss",
    "lat": 26.313778,
    "lng": 127.7966041,
    "placeId": "ChIJJ_TSFGIS5TQRa_HkdjGALss",
    "businessStatus": "OPERATIONAL",
    "phone": "098-930-0425",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 16513,
    "id": 487
  },
  {
    "title": "Long Softcream Okinawa",
    "urlinform": "store-52",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://longsoftcream.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8QdEymwT5TQROeU3xjakYBM",
    "lat": 26.3160227,
    "lng": 127.7548901,
    "placeId": "ChIJ8QdEymwT5TQROeU3xjakYBM",
    "businessStatus": "OPERATIONAL",
    "phone": "090-2198-5958",
    "openingHours": [
      "Monday: 12:00 – 9:30 PM",
      "Tuesday: 12:00 – 9:30 PM",
      "Wednesday: 12:00 – 9:30 PM",
      "Thursday: 12:00 – 9:30 PM",
      "Friday: 12:00 – 9:30 PM",
      "Saturday: 12:00 – 9:30 PM",
      "Sunday: 12:00 – 9:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 138,
    "id": 488,
    "district": "Chatan"
  },
  {
    "title": "Yamachu Honpo",
    "urlinform": "yamachu-honpo",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://yamachu-honpo.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN70H5A8T5TQR7nE5sqDaAdA",
    "lat": 26.3156762,
    "lng": 127.7548406,
    "placeId": "ChIJN70H5A8T5TQR7nE5sqDaAdA",
    "businessStatus": "OPERATIONAL",
    "phone": "098-936-8430",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 17,
    "id": 489,
    "district": "Chatan"
  },
  {
    "title": "Splash okinawa Mihama market",
    "urlinform": "splash-okinawa-mihama-market-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://splashokinawa.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv6qqeQUT5TQRwtnbnPplY58",
    "lat": 26.3161274,
    "lng": 127.7548317,
    "placeId": "ChIJv6qqeQUT5TQRwtnbnPplY58",
    "businessStatus": "OPERATIONAL",
    "phone": "098-923-0333",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 14,
    "id": 490,
    "district": "Chatan"
  },
  {
    "title": "Royal Okinawan",
    "urlinform": "store-55",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.depot-island.co.jp/shop/royal-okinawan/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn8QM2A8T5TQRIFXKW1oaPVc",
    "lat": 26.3156986,
    "lng": 127.7548126,
    "placeId": "ChIJn8QM2A8T5TQRIFXKW1oaPVc",
    "businessStatus": "OPERATIONAL",
    "phone": "098-923-0326",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 16,
    "id": 491,
    "district": "Chatan"
  },
  {
    "title": "RYUSION Art Gallery Depot Island",
    "urlinform": "ryusion-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://ryusion.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoVUhepcT5TQRAN6MZ-5xY3E",
    "lat": 26.3162019,
    "lng": 127.754047,
    "placeId": "ChIJoVUhepcT5TQRAN6MZ-5xY3E",
    "businessStatus": "OPERATIONAL",
    "phone": "098-989-7424",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 8,
    "id": 492,
    "district": "Chatan"
  },
  {
    "title": "KAIGANSOUKO 21 Mihama",
    "urlinform": "store-57",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://ks-variety.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJReXHeAUT5TQR6L1KWieAw2I",
    "lat": 26.3159632,
    "lng": 127.7544613,
    "placeId": "ChIJReXHeAUT5TQR6L1KWieAw2I",
    "businessStatus": "OPERATIONAL",
    "phone": "098-926-3138",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 9:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 9,
    "id": 493,
    "district": "Chatan"
  },
  {
    "title": "RUN OKI",
    "urlinform": "run-oki",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjdRf6A8T5TQRQlFPSii8MrQ",
    "lat": 26.3160669,
    "lng": 127.7544834,
    "placeId": "ChIJjdRf6A8T5TQRQlFPSii8MrQ",
    "businessStatus": "OPERATIONAL",
    "phone": "098-979-8098",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 24,
    "id": 494,
    "district": "Chatan"
  },
  {
    "title": "OKINAWAPOP.JP 海神店",
    "urlinform": "okinawapopjp-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cosmic-okinawa.com/business/okinawapop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJteJTpiIT5TQRaX6OR4Xv6NY",
    "lat": 26.3160005,
    "lng": 127.7547795,
    "placeId": "ChIJteJTpiIT5TQRaX6OR4Xv6NY",
    "businessStatus": "OPERATIONAL",
    "phone": "070-3800-6508",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 15,
    "id": 495,
    "district": "Chatan"
  },
  {
    "title": "Okinawan Jewelry Chohichiya",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "http://www.chouhichi.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJlcVa4Q8T5TQRsus6nH1M5QY",
    "lat": 26.3155855,
    "lng": 127.7546207,
    "placeId": "ChIJlcVa4Q8T5TQRsus6nH1M5QY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 17,
    "id": 496,
    "district": "Chatan"
  },
  {
    "title": "トイパラダイスBANBAN21具志川店",
    "urlinform": "banban21",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/banban21_tcg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGTEXbgEP5TQR-6v_2NwP9Qs",
    "lat": 26.3728556,
    "lng": 127.8587263,
    "placeId": "ChIJGTEXbgEP5TQR-6v_2NwP9Qs",
    "businessStatus": "OPERATIONAL",
    "phone": "098-974-1117",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 108,
    "id": 497
  },
  {
    "title": "Dragon Palace",
    "urlinform": "store-62",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://okinawa-chatan.com/doragomparesu/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_W8XoQUT5TQRG8vPiBMM9fA",
    "lat": 26.3173399,
    "lng": 127.7573,
    "placeId": "ChIJ_W8XoQUT5TQRG8vPiBMM9fA",
    "businessStatus": "OPERATIONAL",
    "phone": "090-6867-8505",
    "openingHours": [
      "Monday: 10:00 AM – 11:59 PM",
      "Tuesday: 10:00 AM – 11:59 PM",
      "Wednesday: 10:00 AM – 11:59 PM",
      "Thursday: 10:00 AM – 11:59 PM",
      "Friday: 10:00 AM – 11:59 PM",
      "Saturday: 10:00 AM – 11:59 PM",
      "Sunday: 10:00 AM – 11:59 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 627,
    "id": 498,
    "district": "Chatan"
  },
  {
    "title": "Seaside Square",
    "urlinform": "store-63",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.okinawa-americanvillage.com/?shoparea=en-seaside_square&lang=en",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFYl1iA8T5TQRmp-L1mr_2Po",
    "lat": 26.3167611,
    "lng": 127.7555493,
    "placeId": "ChIJFYl1iA8T5TQRmp-L1mr_2Po",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 336,
    "id": 499,
    "district": "Chatan"
  },
  {
    "title": "Depot Central",
    "urlinform": "store-64",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.depot-island.co.jp/areamap/areamap_central/#areamapview",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ86TSmIcT5TQRRFfOaMPhKZw",
    "lat": 26.3172533,
    "lng": 127.7546438,
    "placeId": "ChIJ86TSmIcT5TQRRFfOaMPhKZw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 58,
    "id": 500,
    "district": "Chatan"
  },
  {
    "title": "American Depot",
    "urlinform": "store-66",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.depot-abc.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwWEqbQUT5TQR97dVzU_IItU",
    "lat": 26.3163928,
    "lng": 127.7569503,
    "placeId": "ChIJwWEqbQUT5TQR97dVzU_IItU",
    "businessStatus": "OPERATIONAL",
    "phone": "098-926-0888",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 419,
    "id": 501,
    "district": "American Village"
  },
  {
    "title": "新垣瓦工場 北谷アメリカンビレッジ店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.arakakikawarafactory.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcdwCbPYT5TQR29WlgUkoUqM",
    "lat": 26.3161884,
    "lng": 127.7546726,
    "placeId": "ChIJcdwCbPYT5TQR29WlgUkoUqM",
    "businessStatus": "OPERATIONAL",
    "phone": "098-917-4365",
    "openingHours": [
      "Monday: 10:00 AM – 8:50 PM",
      "Tuesday: 10:00 AM – 8:50 PM",
      "Wednesday: 10:00 AM – 8:50 PM",
      "Thursday: 10:00 AM – 8:50 PM",
      "Friday: 10:00 AM – 8:50 PM",
      "Saturday: 10:00 AM – 8:50 PM",
      "Sunday: 10:00 AM – 8:50 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 29,
    "id": 502,
    "district": "Chatan"
  },
  {
    "title": "【沖縄Tシャツ】Lovalot（ラバロット） アメリカンビレッジ店",
    "urlinform": "tlovalot-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lovalot.stores.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBwePM0cT5TQRQyT7CI1WQS4",
    "lat": 26.3159439,
    "lng": 127.7539668,
    "placeId": "ChIJBwePM0cT5TQRQyT7CI1WQS4",
    "businessStatus": "OPERATIONAL",
    "phone": "098-988-5422",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 15,
    "id": 503,
    "district": "Chatan"
  },
  {
    "title": "VILLAGE VANGUARD Aeon Chatan",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Pokémon",
      "Vanguard"
    ],
    "storeWebsite": "https://www.village-v.co.jp/shop-list/000421/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8SEEyxoT5TQR64Y771Zxqko",
    "lat": 26.314886,
    "lng": 127.7574401,
    "placeId": "ChIJ8SEEyxoT5TQR64Y771Zxqko",
    "businessStatus": "OPERATIONAL",
    "phone": "098-983-7345",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 134,
    "id": 504,
    "district": "American Village"
  },
  {
    "title": "HobbyX (Grading Submission Center)",
    "urlinform": "hobbyx-grading-submission-center",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://hobbyxstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrx6M3Z0BBDQR55mAUIMo96Y",
    "lat": 22.3164209,
    "lng": 114.1702704,
    "placeId": "ChIJrx6M3Z0BBDQR55mAUIMo96Y",
    "businessStatus": "OPERATIONAL",
    "phone": "6298 0425",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 42,
    "id": 505,
    "district": "Mong Kok"
  },
  {
    "title": "Collector's Dream TCG",
    "urlinform": "collectors-dream-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.collectorsdreamtcg.xyz/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrwDhOxwBBDQR_oYMIaYNhUE",
    "lat": 22.3038402,
    "lng": 114.1719415,
    "placeId": "ChIJrwDhOxwBBDQR_oYMIaYNhUE",
    "businessStatus": "OPERATIONAL",
    "phone": "5510 1350",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 155,
    "id": 506,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "MadMaxToys.Sino103",
    "urlinform": "madmaxtoyssino103",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://madmaxtoys.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuzCZF_gBBDQRPMol2vTb9C4",
    "lat": 22.3160575,
    "lng": 114.1703633,
    "placeId": "ChIJuzCZF_gBBDQRPMol2vTb9C4",
    "businessStatus": "OPERATIONAL",
    "phone": "9191 3299",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 52,
    "id": 507,
    "district": "Mong Kok"
  },
  {
    "title": "Basicland Card Game Shop (MK)",
    "urlinform": "basicland-card-game-shop-mk",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF4J4_cAABDQRJ4ErQ-L_ETc",
    "lat": 22.3164209,
    "lng": 114.1702704,
    "placeId": "ChIJF4J4_cAABDQRJ4ErQ-L_ETc",
    "businessStatus": "OPERATIONAL",
    "phone": "9300 0421",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 59,
    "id": 508,
    "district": "Mong Kok"
  },
  {
    "title": "Moonroad Card Shop Mong Kok",
    "urlinform": "moonroad-card-shop-mong-kok",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://moonroadhk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpb53O3EFBDQRSLo446vmgAE",
    "lat": 22.3160575,
    "lng": 114.1703633,
    "placeId": "ChIJpb53O3EFBDQRSLo446vmgAE",
    "businessStatus": "OPERATIONAL",
    "phone": "6915 7469",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 48,
    "id": 509,
    "district": "Mong Kok"
  },
  {
    "title": "MAD MAX TOYS MOKO",
    "urlinform": "mad-max-toys-moko",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://madmaxtoys.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2cC-QAABBDQRvMa1dAMl_f8",
    "lat": 22.3233229,
    "lng": 114.1722813,
    "placeId": "ChIJ2cC-QAABBDQRvMa1dAMl_f8",
    "businessStatus": "OPERATIONAL",
    "phone": "6655 9913",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 35,
    "id": 510,
    "district": "Mong Kok"
  },
  {
    "title": "MAD MAX TOYS",
    "urlinform": "mad-max-toys",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://madmaxtoys.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJac7xUiUBBDQRtCuTRn92M_U",
    "lat": 22.280336,
    "lng": 114.186742,
    "placeId": "ChIJac7xUiUBBDQRtCuTRn92M_U",
    "businessStatus": "OPERATIONAL",
    "phone": "6655 6529",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 371,
    "id": 511,
    "district": "Causeway Bay"
  },
  {
    "title": "Mad Max Toys",
    "urlinform": "mad-max-toys",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://madmaxtoys.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNauNc8MBBDQRYkJftHMnxtI",
    "lat": 22.3146879,
    "lng": 114.170511,
    "placeId": "ChIJNauNc8MBBDQRYkJftHMnxtI",
    "businessStatus": "OPERATIONAL",
    "phone": "6892 9138",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 12:30 – 9:00 PM",
      "Sunday: 12:30 – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 69,
    "id": 512,
    "district": "Mong Kok"
  },
  {
    "title": "League Castle Company (Mong Kok Shop)",
    "urlinform": "league-castle-company-mong-kok-shop",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/LeagueCastleHK/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsUNyG8cABDQRFSmDFnb0WbE",
    "lat": 22.3210432,
    "lng": 114.1665315,
    "placeId": "ChIJsUNyG8cABDQRFSmDFnb0WbE",
    "businessStatus": "OPERATIONAL",
    "phone": "2380 0316",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: Closed",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 58,
    "id": 513,
    "district": "Mong Kok"
  },
  {
    "title": "ONE OF ONE CARD STORE",
    "urlinform": "one-of-one-card-store",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXV-8rLUBBDQRzVXcLaEPT7M",
    "lat": 22.3147189,
    "lng": 114.170467,
    "placeId": "ChIJXV-8rLUBBDQRzVXcLaEPT7M",
    "businessStatus": "OPERATIONAL",
    "phone": "4402 7455",
    "openingHours": [
      "Monday: 2:30 – 10:30 PM",
      "Tuesday: 2:30 – 10:30 PM",
      "Wednesday: 2:30 – 10:30 PM",
      "Thursday: 2:30 – 10:30 PM",
      "Friday: 2:30 – 10:30 PM",
      "Saturday: 2:30 – 10:30 PM",
      "Sunday: 2:30 – 10:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 10,
    "id": 514,
    "district": "Mong Kok"
  },
  {
    "title": "MadMaxToys.Sino M4",
    "urlinform": "madmaxtoyssino-m4",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://madmaxtoys.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvRTD5CUBBDQRdy9_mAugPOg",
    "lat": 22.3160575,
    "lng": 114.1703633,
    "placeId": "ChIJvRTD5CUBBDQRdy9_mAugPOg",
    "businessStatus": "OPERATIONAL",
    "phone": "6752 4438",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 82,
    "id": 515,
    "district": "Mong Kok"
  },
  {
    "title": "Perfect10 Entertainment",
    "urlinform": "perfect10-entertainment",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://perfect10sino.boutir.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcWtEWnUBBDQRFtF88DaQ3s4",
    "lat": 22.3160575,
    "lng": 114.1703633,
    "placeId": "ChIJcWtEWnUBBDQRFtF88DaQ3s4",
    "businessStatus": "OPERATIONAL",
    "phone": "6513 1412",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 1:30 – 8:30 PM",
      "Sunday: 1:30 – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "id": 516,
    "district": "Mong Kok"
  },
  {
    "title": "CardKingdomHK",
    "urlinform": "cardkingdomhk",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/ptcg_cardkingdom/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqXWN4W0BBDQRCjqNqsAsqpg",
    "lat": 22.3161657,
    "lng": 114.1707929,
    "placeId": "ChIJqXWN4W0BBDQRCjqNqsAsqpg",
    "businessStatus": "OPERATIONAL",
    "phone": "9402 6974",
    "openingHours": [
      "Monday: 4:00 – 11:00 PM",
      "Tuesday: 4:00 – 11:00 PM",
      "Wednesday: 4:00 – 11:00 PM",
      "Thursday: 4:00 – 11:00 PM",
      "Friday: 4:00 – 11:00 PM",
      "Saturday: 4:00 – 11:00 PM",
      "Sunday: 4:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3,
    "id": 517,
    "district": "Mong Kok"
  },
  {
    "title": "Poke Mart Hong Kong",
    "urlinform": "poke-mart-hong-kong",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd-PoOtQBBDQRo78wu4aTYRY",
    "lat": 22.3144694,
    "lng": 114.1706187,
    "placeId": "ChIJd-PoOtQBBDQRo78wu4aTYRY",
    "businessStatus": "OPERATIONAL",
    "phone": "6281 2223",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 2:00 – 8:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 518,
    "district": "Mong Kok"
  },
  {
    "title": "MadMaxToys. Metroplaza",
    "urlinform": "madmaxtoys-metroplaza",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://madmaxtoys.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJeeqmndf5AzQR_5Cp3ntuoA0",
    "lat": 22.3574364,
    "lng": 114.1266565,
    "placeId": "ChIJeeqmndf5AzQR_5Cp3ntuoA0",
    "businessStatus": "OPERATIONAL",
    "phone": "6655 8869",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 230,
    "id": 519
  },
  {
    "title": "樓上咭店 Have Card",
    "urlinform": "-have-card",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF4p6tn4BBDQRW7cHz6EIzBo",
    "lat": 22.3223691,
    "lng": 114.1697363,
    "placeId": "ChIJF4p6tn4BBDQRW7cHz6EIzBo",
    "businessStatus": "OPERATIONAL",
    "phone": "5191 9238",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 2:00 – 8:30 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3,
    "id": 520,
    "district": "Mong Kok"
  },
  {
    "title": "HobbyX Plus",
    "urlinform": "hobbyx-plus",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://hobbyxstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJV7aJ0I4BBDQR-HqQBJ63ySc",
    "lat": 22.2972778,
    "lng": 114.1733357,
    "placeId": "ChIJV7aJ0I4BBDQR-HqQBJ63ySc",
    "businessStatus": "OPERATIONAL",
    "phone": "5473 7843",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 27,
    "id": 521,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "Toyeki",
    "urlinform": "toyeki",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg26Vw5oBBDQR2Y8tIvZgqCM",
    "lat": 22.3206,
    "lng": 114.1694808,
    "placeId": "ChIJg26Vw5oBBDQR2Y8tIvZgqCM",
    "businessStatus": "OPERATIONAL",
    "phone": "3619 0086",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 13,
    "id": 522,
    "district": "Mong Kok"
  },
  {
    "title": "Battleground 卡牌遊戲及桌遊專門店",
    "urlinform": "battleground-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://bgtcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP6mY6VQHBDQR_Biog_F40eU",
    "lat": 22.3362418,
    "lng": 114.1479763,
    "placeId": "ChIJP6mY6VQHBDQR_Biog_F40eU",
    "businessStatus": "OPERATIONAL",
    "phone": "9529 5720",
    "openingHours": [
      "Monday: 11:00 AM – 11:00 PM",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 64,
    "id": 523
  },
  {
    "title": "Moonroad Card Shop Kwun Tong",
    "urlinform": "moonroad-card-shop-kwun-tong",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://moonroadhk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh5UPM_QBBDQRVIct_3r1XO4",
    "lat": 22.3095471,
    "lng": 114.2252452,
    "placeId": "ChIJh5UPM_QBBDQRVIct_3r1XO4",
    "businessStatus": "OPERATIONAL",
    "phone": "6915 7469",
    "openingHours": [
      "Monday: 2:00 – 11:00 PM",
      "Tuesday: 2:00 – 11:00 PM",
      "Wednesday: 2:00 – 11:00 PM",
      "Thursday: 2:00 – 11:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 283,
    "id": 524,
    "district": "Kwun Tong"
  },
  {
    "title": "Yu GI Card Center",
    "urlinform": "yu-gi-card-center",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://yugicardcenter.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3UoNb9j6AzQRuJ79LFyi0-Y",
    "lat": 22.3351383,
    "lng": 114.1598247,
    "placeId": "ChIJ3UoNb9j6AzQRuJ79LFyi0-Y",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 18,
    "id": 525,
    "district": "Sham Shui Po"
  },
  {
    "title": "Home-run FABulous card shop",
    "urlinform": "home-run-fabulous-card-shop",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCRA3BRABBDQROvEBBFJQ5Z4",
    "lat": 22.3236062,
    "lng": 114.16825,
    "placeId": "ChIJCRA3BRABBDQROvEBBFJQ5Z4",
    "businessStatus": "OPERATIONAL",
    "phone": "9777 5494",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 6:00 PM",
      "Sunday: 1:00 – 6:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 6,
    "id": 526,
    "district": "Mong Kok"
  },
  {
    "title": "Beehive Trading Card Shop",
    "urlinform": "beehive-trading-card-shop",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.beehivetcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJI4mjEVsBBDQR6endmbDM0JY",
    "lat": 22.313121,
    "lng": 114.2232143,
    "placeId": "ChIJI4mjEVsBBDQR6endmbDM0JY",
    "businessStatus": "OPERATIONAL",
    "phone": "2367 8086",
    "openingHours": [
      "Monday: 1:30 – 9:00 PM",
      "Tuesday: 1:30 – 9:00 PM",
      "Wednesday: 1:30 – 9:00 PM",
      "Thursday: 1:30 – 9:00 PM",
      "Friday: 1:30 – 9:00 PM",
      "Saturday: 1:30 – 9:00 PM",
      "Sunday: 1:30 – 9:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 116,
    "id": 527,
    "district": "Kwun Tong"
  },
  {
    "title": "新手桌遊",
    "urlinform": "store-25",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://bgstore.com.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtTW838kABDQR1LNRr3mX3Us",
    "lat": 22.317373,
    "lng": 114.170038,
    "placeId": "ChIJtTW838kABDQR1LNRr3mX3Us",
    "businessStatus": "OPERATIONAL",
    "phone": "3954 5967",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 63,
    "id": 528,
    "district": "Mong Kok"
  },
  {
    "title": "BANTYO TCG HK 番長連合",
    "urlinform": "bantyo-tcg-hk-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://bantyo.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7cSbqLUBBDQR9dp1Wx05cTY",
    "lat": 22.3125034,
    "lng": 114.2186178,
    "placeId": "ChIJ7cSbqLUBBDQR9dp1Wx05cTY",
    "businessStatus": "OPERATIONAL",
    "phone": "6382 6651",
    "openingHours": [
      "Monday: 4:00 – 11:00 PM",
      "Tuesday: 4:00 – 11:00 PM",
      "Wednesday: 4:00 – 11:00 PM",
      "Thursday: 4:00 – 11:00 PM",
      "Friday: 4:00 – 11:00 PM",
      "Saturday: 3:00 – 11:00 PM",
      "Sunday: 3:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 10,
    "id": 529,
    "district": "Kwun Tong"
  },
  {
    "title": "TcgStore.HK",
    "urlinform": "tcgstorehk",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfXcagP4BBDQRNUnHpvWPAvc",
    "lat": 22.2790433,
    "lng": 114.1833676,
    "placeId": "ChIJfXcagP4BBDQRNUnHpvWPAvc",
    "businessStatus": "OPERATIONAL",
    "phone": "5505 0077",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.7,
    "userRatingsTotal": 48,
    "id": 530,
    "district": "Causeway Bay"
  },
  {
    "title": "Players’Club TCG",
    "urlinform": "playersclub-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/playersclub751",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG3BAVlIHBDQRW2Gec6_nSn4",
    "lat": 22.297025,
    "lng": 114.1718959,
    "placeId": "ChIJG3BAVlIHBDQRW2Gec6_nSn4",
    "businessStatus": "OPERATIONAL",
    "phone": "5406 7569",
    "openingHours": [
      "Monday: 2:30 – 9:30 PM",
      "Tuesday: 2:30 – 9:30 PM",
      "Wednesday: 2:30 – 9:30 PM",
      "Thursday: 2:30 – 9:30 PM",
      "Friday: 2:30 – 9:30 PM",
      "Saturday: 2:30 – 9:30 PM",
      "Sunday: 2:30 – 9:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 13,
    "id": 531,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "惰囉 DORO TCG",
    "urlinform": "-doro-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://carousell.app.link/YP34KQ0VuNb",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ29EcCvkBBDQRIOBiQ4muci4",
    "lat": 22.3133429,
    "lng": 114.1708509,
    "placeId": "ChIJ29EcCvkBBDQRIOBiQ4muci4",
    "businessStatus": "OPERATIONAL",
    "phone": "5288 0017",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 3:00 – 9:00 PM",
      "Sunday: 3:00 – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 15,
    "id": 532,
    "district": "Mong Kok"
  },
  {
    "title": "Mikawish TCG & Plush store",
    "urlinform": "mikawish-tcg-plush-store",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Lorcana",
      "Pokémon"
    ],
    "storeWebsite": "https://mikawish.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsb3XVgABBDQRf_XQIjr7rC4",
    "lat": 22.3190982,
    "lng": 114.1689526,
    "placeId": "ChIJsb3XVgABBDQRf_XQIjr7rC4",
    "businessStatus": "OPERATIONAL",
    "phone": "9244 8068",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 2:00 – 8:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 3,
    "id": 533,
    "district": "Mong Kok"
  },
  {
    "title": "Card Hobby HK (CWB)",
    "urlinform": "card-hobby-hk-cwb",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNfbdZQABBDQRbgHScx-0lPo",
    "lat": 22.279069,
    "lng": 114.1843056,
    "placeId": "ChIJNfbdZQABBDQRbgHScx-0lPo",
    "businessStatus": "OPERATIONAL",
    "phone": "9038 1840",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 15,
    "id": 534,
    "district": "Causeway Bay"
  },
  {
    "title": "CardBay",
    "urlinform": "cardbay",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.cardbayhk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDXwrTgABBDQRNORDSJllpL0",
    "lat": 22.2791723,
    "lng": 114.1842008,
    "placeId": "ChIJDXwrTgABBDQRNORDSJllpL0",
    "businessStatus": "OPERATIONAL",
    "phone": "6757 1008",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 92,
    "id": 535,
    "district": "Causeway Bay"
  },
  {
    "title": "KOSU CARD",
    "urlinform": "kosu-card",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_38N_eYBBDQR0Gr2_Jn-MZI",
    "lat": 22.2805216,
    "lng": 114.1836683,
    "placeId": "ChIJ_38N_eYBBDQR0Gr2_Jn-MZI",
    "businessStatus": "OPERATIONAL",
    "phone": "5590 8508",
    "openingHours": [
      "Monday: 12:00 – 11:30 PM",
      "Tuesday: 12:00 – 11:30 PM",
      "Wednesday: 12:00 – 11:30 PM",
      "Thursday: 12:00 – 11:30 PM",
      "Friday: 12:00 – 11:30 PM",
      "Saturday: 12:00 – 11:30 PM",
      "Sunday: 12:00 – 11:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 89,
    "id": 536,
    "district": "Causeway Bay"
  },
  {
    "title": "Carddesu",
    "urlinform": "carddesu",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/carddesu?igsh=emNiMGlzcG9wczlm",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7SNQVG8BBDQRJQWByZtKuC4",
    "lat": 22.2788161,
    "lng": 114.1834365,
    "placeId": "ChIJ7SNQVG8BBDQRJQWByZtKuC4",
    "businessStatus": "OPERATIONAL",
    "phone": "6316 1928",
    "openingHours": [
      "Monday: 1:00 – 11:00 PM",
      "Tuesday: 1:00 – 11:00 PM",
      "Wednesday: 1:00 – 11:00 PM",
      "Thursday: 1:00 – 11:00 PM",
      "Friday: 1:00 – 11:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 152,
    "id": 537,
    "district": "Causeway Bay"
  },
  {
    "title": "The pokekado PTCG Shop",
    "urlinform": "the-pokekado-ptcg-shop",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Lorcana",
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokekado.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJz5rE35gBBDQR4vqavilFRLw",
    "lat": 22.3103719,
    "lng": 114.187739,
    "placeId": "ChIJz5rE35gBBDQR4vqavilFRLw",
    "businessStatus": "OPERATIONAL",
    "phone": "6558 1545",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 22,
    "id": 538
  },
  {
    "title": "Cardland 卡之島 | 香港卡鋪專門店",
    "urlinform": "cardland-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cardland.com.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ30YfpjYBBDQRIlT7vc3VS2k",
    "lat": 22.3104568,
    "lng": 114.2242607,
    "placeId": "ChIJ30YfpjYBBDQRIlT7vc3VS2k",
    "businessStatus": "OPERATIONAL",
    "phone": "9457 7992",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 13,
    "id": 539,
    "district": "Kwun Tong"
  },
  {
    "title": "異次元桌游社 Different Dimension TCG",
    "urlinform": "-different-dimension-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/differentdimension.tcg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJr9geSCQBBDQRWnCqW6WI1fc",
    "lat": 22.284617,
    "lng": 114.1921221,
    "placeId": "ChIJr9geSCQBBDQRWnCqW6WI1fc",
    "businessStatus": "OPERATIONAL",
    "phone": "6654 0922",
    "openingHours": [
      "Monday: 4:00 – 11:00 PM",
      "Tuesday: 4:00 – 11:00 PM",
      "Wednesday: 4:00 – 11:00 PM",
      "Thursday: 4:00 – 11:00 PM",
      "Friday: 4:00 – 11:00 PM",
      "Saturday: 4:00 – 11:00 PM",
      "Sunday: 4:00 – 11:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 15,
    "id": 540,
    "district": "Causeway Bay"
  },
  {
    "title": "KaBoom TCG Store",
    "urlinform": "kaboom-tcg-store",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ967LfJ4BBDQR8nbhfHMyeac",
    "lat": 22.3122298,
    "lng": 114.224027,
    "placeId": "ChIJ967LfJ4BBDQR8nbhfHMyeac",
    "businessStatus": "OPERATIONAL",
    "phone": "6279 3289",
    "openingHours": [
      "Monday: 2:30 PM – 12:30 AM",
      "Tuesday: 2:30 PM – 12:30 AM",
      "Wednesday: 2:30 PM – 12:30 AM",
      "Thursday: 2:30 PM – 12:30 AM",
      "Friday: 2:30 PM – 12:30 AM",
      "Saturday: 2:30 PM – 12:30 AM",
      "Sunday: 2:30 PM – 12:30 AM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 42,
    "id": 541,
    "district": "Kwun Tong"
  },
  {
    "title": "YulaYula TCG",
    "urlinform": "yulayula-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.yulayulatcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPScGVMEBBDQRsCtAtb9d-4E",
    "lat": 22.2788161,
    "lng": 114.1834365,
    "placeId": "ChIJPScGVMEBBDQRsCtAtb9d-4E",
    "businessStatus": "OPERATIONAL",
    "phone": "9026 8890",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 7,
    "id": 542,
    "district": "Causeway Bay"
  },
  {
    "title": "TCG MART",
    "urlinform": "tcg-mart",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/tcgmarthk",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_ROJOyEBBDQRW_zt_jtzuIE",
    "lat": 22.2788334,
    "lng": 114.1859452,
    "placeId": "ChIJ_ROJOyEBBDQRW_zt_jtzuIE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:30 – 7:30 PM",
      "Wednesday: 1:30 – 7:30 PM",
      "Thursday: 1:30 – 7:30 PM",
      "Friday: 1:30 – 7:30 PM",
      "Saturday: 1:30 – 8:30 PM",
      "Sunday: 1:30 – 7:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 5,
    "id": 543,
    "district": "Causeway Bay"
  },
  {
    "title": "Capstone Boardgame 桌上遊戲專門店",
    "urlinform": "capstone-boardgame-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://shop.capstone.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyVF2MVEABDQRAyQdDSoLrwU",
    "lat": 22.2793249,
    "lng": 114.1817189,
    "placeId": "ChIJyVF2MVEABDQRAyQdDSoLrwU",
    "businessStatus": "OPERATIONAL",
    "phone": "2577 5388",
    "openingHours": [
      "Monday: 2:00 – 11:00 PM",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 11:00 PM",
      "Thursday: 2:00 – 11:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 11:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 139,
    "id": 544,
    "district": "Causeway Bay"
  },
  {
    "title": "Pika Card TCG",
    "urlinform": "pika-card-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://pikacard.omniwe.site/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJk2IiqooBBDQR9q_7kyN_etw",
    "lat": 22.2788161,
    "lng": 114.1834365,
    "placeId": "ChIJk2IiqooBBDQR9q_7kyN_etw",
    "businessStatus": "OPERATIONAL",
    "phone": "6095 9111",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 19,
    "id": 545,
    "district": "Causeway Bay"
  },
  {
    "title": "Champion Hall 冠軍殿堂",
    "urlinform": "champion-hall-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.championhalltcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPzuuM4wBBDQR51kSlEjiCT0",
    "lat": 22.2800677,
    "lng": 114.1866883,
    "placeId": "ChIJPzuuM4wBBDQR51kSlEjiCT0",
    "businessStatus": "OPERATIONAL",
    "phone": "9242 6164",
    "openingHours": [
      "Monday: 12:30 – 10:30 PM",
      "Tuesday: 12:30 – 10:30 PM",
      "Wednesday: 12:30 – 10:30 PM",
      "Thursday: 12:30 – 10:30 PM",
      "Friday: 12:30 – 10:30 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 90,
    "id": 546,
    "district": "Causeway Bay"
  },
  {
    "title": "NEXUSFORGE (NF) TCG",
    "urlinform": "nexusforge-nf-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3Y-mxqIBBDQRPwKo7m3yilY",
    "lat": 22.2812311,
    "lng": 114.1831476,
    "placeId": "ChIJ3Y-mxqIBBDQRPwKo7m3yilY",
    "businessStatus": "OPERATIONAL",
    "phone": "5248 8825",
    "openingHours": [
      "Monday: 2:00 – 8:30 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:30 PM",
      "Thursday: 1:00 – 8:30 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "id": 547,
    "district": "Causeway Bay"
  },
  {
    "title": "Card Galleria",
    "urlinform": "card-galleria",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.card-galleria.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJm8LhDDcBBDQRby93FXm5X6w",
    "lat": 22.2783159,
    "lng": 114.1841107,
    "placeId": "ChIJm8LhDDcBBDQRby93FXm5X6w",
    "businessStatus": "OPERATIONAL",
    "phone": "9541 7751",
    "openingHours": [
      "Monday: 12:00 – 5:00 PM",
      "Tuesday: 12:00 – 5:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:00 – 6:00 PM",
      "Friday: 12:00 – 6:00 PM",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 9,
    "id": 548,
    "district": "Causeway Bay"
  },
  {
    "title": "CardChill",
    "urlinform": "cardchill",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/cardchill_hk?utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTyM0BbUBBDQR2Jwi49LU5JM",
    "lat": 22.2807411,
    "lng": 114.1832884,
    "placeId": "ChIJTyM0BbUBBDQR2Jwi49LU5JM",
    "businessStatus": "OPERATIONAL",
    "phone": "5471 2159",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 9:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 56,
    "id": 549,
    "district": "Causeway Bay"
  },
  {
    "title": "Battlefield Hobby Card and TCG Shop",
    "urlinform": "battlefield-hobby-card-and-tcg-shop",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDT0Ap6oBBDQR4nhGwDgVKE8",
    "lat": 22.2488571,
    "lng": 114.1527247,
    "placeId": "ChIJDT0Ap6oBBDQR4nhGwDgVKE8",
    "businessStatus": "OPERATIONAL",
    "phone": "6711 0599",
    "openingHours": [
      "Monday: 7:00 – 11:00 PM",
      "Tuesday: 7:00 – 11:00 PM",
      "Wednesday: 7:00 – 11:00 PM",
      "Thursday: 7:00 – 11:00 PM",
      "Friday: 7:00 – 11:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 5,
    "id": 550
  },
  {
    "title": "Moonroad Card Shop Causeway Bay",
    "urlinform": "moonroad-card-shop-causeway-bay",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://moonroadhk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCztyHJMBBDQRkTCvNK4v-eE",
    "lat": 22.2797624,
    "lng": 114.1837259,
    "placeId": "ChIJCztyHJMBBDQRkTCvNK4v-eE",
    "businessStatus": "OPERATIONAL",
    "phone": "6915 7469",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 7,
    "id": 551,
    "district": "Causeway Bay"
  },
  {
    "title": "Ace Card Company Hong Kong",
    "urlinform": "ace-card-company-hong-kong",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ662rDmoBBDQRupaT0Ulf9UI",
    "lat": 22.2810908,
    "lng": 114.1847609,
    "placeId": "ChIJ662rDmoBBDQRupaT0Ulf9UI",
    "businessStatus": "OPERATIONAL",
    "phone": "6296 9692",
    "openingHours": [
      "Monday: 2:00 – 7:00 PM",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 9,
    "id": 552,
    "district": "Causeway Bay"
  },
  {
    "title": "Hallmark",
    "urlinform": "hallmark",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/hallmarkhongkong/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY2kcl1YABDQR_m6JyC3dwyc",
    "lat": 22.280516,
    "lng": 114.1842526,
    "placeId": "ChIJY2kcl1YABDQR_m6JyC3dwyc",
    "businessStatus": "OPERATIONAL",
    "phone": "2831 8545",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 4,
    "id": 553,
    "district": "Causeway Bay"
  },
  {
    "title": "Journalize",
    "urlinform": "journalize",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/journalize_store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD6HV9VQABDQRUtmVjHjpXzs",
    "lat": 22.2795895,
    "lng": 114.188755,
    "placeId": "ChIJD6HV9VQABDQRUtmVjHjpXzs",
    "businessStatus": "OPERATIONAL",
    "phone": "3565 6455",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: Closed",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 119,
    "id": 554,
    "district": "Causeway Bay"
  },
  {
    "title": "Hallmark",
    "urlinform": "hallmark",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/hallmarkhongkong/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn4zbGJ0BBDQRoVvXacZ26sE",
    "lat": 22.2803141,
    "lng": 114.1865368,
    "placeId": "ChIJn4zbGJ0BBDQRoVvXacZ26sE",
    "businessStatus": "OPERATIONAL",
    "phone": "2562 7312",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 4,
    "id": 555,
    "district": "Causeway Bay"
  },
  {
    "title": "Card Hobby HK (Sheung Wan)",
    "urlinform": "card-hobby-hk-sheung-wan",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtZAsJgABBDQRb1TIXFpsGiE",
    "lat": 22.28439,
    "lng": 114.1520196,
    "placeId": "ChIJtZAsJgABBDQRb1TIXFpsGiE",
    "businessStatus": "OPERATIONAL",
    "phone": "9038 3840",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 89,
    "id": 556
  },
  {
    "title": "Favour",
    "urlinform": "favour",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/favourshop.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd5JInlYABDQRsAp_yO0n2Dg",
    "lat": 22.28008,
    "lng": 114.1853367,
    "placeId": "ChIJd5JInlYABDQRsAp_yO0n2Dg",
    "businessStatus": "OPERATIONAL",
    "phone": "9208 8372",
    "openingHours": [
      "Monday: 1:30 – 10:30 PM",
      "Tuesday: 1:30 – 10:30 PM",
      "Wednesday: 1:30 – 10:30 PM",
      "Thursday: 1:30 – 10:30 PM",
      "Friday: 1:30 – 10:30 PM",
      "Saturday: 1:30 – 10:30 PM",
      "Sunday: 1:30 – 10:30 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 557,
    "district": "Causeway Bay"
  },
  {
    "title": "HKTCG",
    "urlinform": "hktcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.hktcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAUPVgSQBBDQRVimWVjW1MuQ",
    "lat": 22.297025,
    "lng": 114.1718959,
    "placeId": "ChIJAUPVgSQBBDQRVimWVjW1MuQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:30 AM – 11:30 PM",
      "Tuesday: 11:30 AM – 11:30 PM",
      "Wednesday: 11:30 AM – 11:30 PM",
      "Thursday: 11:30 AM – 11:30 PM",
      "Friday: 11:30 AM – 11:30 PM",
      "Saturday: 11:30 AM – 11:30 PM",
      "Sunday: 11:30 AM – 11:30 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 29,
    "id": 558,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "Light TCG",
    "urlinform": "light-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/light_tcg?igsh=MWhmdXhpaGMxZTIwdA%3D%3D&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmXQbbt4BBDQRHH518dYla80",
    "lat": 22.3002663,
    "lng": 114.1747058,
    "placeId": "ChIJmXQbbt4BBDQRHH518dYla80",
    "businessStatus": "OPERATIONAL",
    "phone": "5119 8182",
    "openingHours": [
      "Monday: 2:00 – 8:30 PM",
      "Tuesday: 2:00 – 8:30 PM",
      "Wednesday: Closed",
      "Thursday: 2:00 – 8:30 PM",
      "Friday: 2:00 – 8:30 PM",
      "Saturday: 2:00 – 8:30 PM",
      "Sunday: 2:00 – 8:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 184,
    "id": 559,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "Mikaeru Tcg",
    "urlinform": "mikaeru-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh4a6eRObFK0RahLy8de1oeA",
    "lat": 22.297025,
    "lng": 114.1718959,
    "placeId": "ChIJh4a6eRObFK0RahLy8de1oeA",
    "businessStatus": "OPERATIONAL",
    "phone": "6077 9995",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 5,
    "id": 560,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "Sportscard Gems Limited",
    "urlinform": "sportscard-gems-limited",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJceN9LgMBBDQRxiMn17I5ayM",
    "lat": 22.300416,
    "lng": 114.1675301,
    "placeId": "ChIJceN9LgMBBDQRxiMn17I5ayM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 561,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "nsew 任天堂正規商品販賣店 (K11 MUSEA)",
    "urlinform": "nsew-k11-musea",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://www.nsewstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ17CZjZMBBDQRm3oapNhdZMA",
    "lat": 22.2945182,
    "lng": 114.1740537,
    "placeId": "ChIJ17CZjZMBBDQRm3oapNhdZMA",
    "businessStatus": "OPERATIONAL",
    "phone": "2473 6698",
    "openingHours": [
      "Monday: 11:00 AM – 8:30 PM",
      "Tuesday: 11:00 AM – 8:30 PM",
      "Wednesday: 11:00 AM – 8:30 PM",
      "Thursday: 11:00 AM – 8:30 PM",
      "Friday: 11:00 AM – 8:30 PM",
      "Saturday: 11:00 AM – 8:30 PM",
      "Sunday: 11:00 AM – 8:30 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 46,
    "id": 562,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "香港魔術專門店Cube Magic HK",
    "urlinform": "cube-magic-hk",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.cubemagic.com.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfX4Ug1YABDQRM3x67WU2lLE",
    "lat": 22.2975261,
    "lng": 114.1739708,
    "placeId": "ChIJfX4Ug1YABDQRM3x67WU2lLE",
    "businessStatus": "OPERATIONAL",
    "phone": "5169 5717",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 29,
    "id": 563,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "通用卡店 General Card Shop",
    "urlinform": "-general-card-shop",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=100063862970687",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7wEPUO34AzQRJVKc9l5g1kM",
    "lat": 22.372059,
    "lng": 114.119444,
    "placeId": "ChIJ7wEPUO34AzQRJVKc9l5g1kM",
    "businessStatus": "OPERATIONAL",
    "phone": "2493 2660",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 97,
    "id": 564
  },
  {
    "title": "One Chance",
    "urlinform": "one-chance",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/OneChanceTCG",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn3e0y_gBBDQR52UZ5qvrz_o",
    "lat": 22.3095123,
    "lng": 114.2267437,
    "placeId": "ChIJn3e0y_gBBDQR52UZ5qvrz_o",
    "businessStatus": "OPERATIONAL",
    "phone": "5544 2771",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.5,
    "userRatingsTotal": 4,
    "id": 565,
    "district": "Kwun Tong"
  },
  {
    "title": "Miniso (isquare)",
    "urlinform": "miniso-isquare",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEySdIwABBDQR-E5DmHliZjw",
    "lat": 22.2973233,
    "lng": 114.1720515,
    "placeId": "ChIJEySdIwABBDQR-E5DmHliZjw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 49,
    "id": 566,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "Elegant Tang Dynasty",
    "urlinform": "store-66",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.tripadvisor.com/Attraction_Review-g294217-d32811255-Reviews-Elegant_Tang_Dynasty-Hong_Kong.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6xGEwO0ABDQRX7buqExIXwU",
    "lat": 22.2963853,
    "lng": 114.1719298,
    "placeId": "ChIJ6xGEwO0ABDQRX7buqExIXwU",
    "businessStatus": "OPERATIONAL",
    "phone": "3188 5177",
    "openingHours": [
      "Monday: 8:30 AM – 11:00 PM",
      "Tuesday: 8:30 AM – 11:00 PM",
      "Wednesday: 8:30 AM – 11:00 PM",
      "Thursday: 8:30 AM – 11:00 PM",
      "Friday: 8:30 AM – 11:00 PM",
      "Saturday: 8:30 AM – 11:00 PM",
      "Sunday: 8:30 AM – 11:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 248,
    "id": 567,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "buyway.hk",
    "urlinform": "buywayhk",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://buyway.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPxAAl8cABDQRWG28EZw2LuA",
    "lat": 22.3186032,
    "lng": 114.1697711,
    "placeId": "ChIJPxAAl8cABDQRWG28EZw2LuA",
    "businessStatus": "OPERATIONAL",
    "phone": "6082 6622",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 7:30 PM",
      "Wednesday: 1:00 – 7:30 PM",
      "Thursday: 1:00 – 7:30 PM",
      "Friday: 1:00 – 7:30 PM",
      "Saturday: 1:00 – 7:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.1,
    "userRatingsTotal": 97,
    "id": 568,
    "district": "Mong Kok"
  },
  {
    "title": "Sports Card Hong Kong Store",
    "urlinform": "sports-card-hong-kong-store",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.schkstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_RdFEu8HBDQR_KQKWTRq860",
    "lat": 22.3365336,
    "lng": 114.1594021,
    "placeId": "ChIJ_RdFEu8HBDQR_KQKWTRq860",
    "businessStatus": "OPERATIONAL",
    "phone": "9088 8708",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 35,
    "id": 569,
    "district": "Sham Shui Po"
  },
  {
    "title": "Fotomax",
    "urlinform": "fotomax",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.fotomax.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt0w3zO0ABDQRAaQf8AUKh-0",
    "lat": 22.2998384,
    "lng": 114.1726583,
    "placeId": "ChIJt0w3zO0ABDQRAaQf8AUKh-0",
    "businessStatus": "OPERATIONAL",
    "phone": "2353 1108",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 147,
    "id": 570,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "Painkiller Boardgame 棋艦店",
    "urlinform": "painkiller-boardgame-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.painkillerboardgame.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsXpgnrkBBDQR1HucH9Iclxo",
    "lat": 22.2996621,
    "lng": 114.172845,
    "placeId": "ChIJsXpgnrkBBDQR1HucH9Iclxo",
    "businessStatus": "OPERATIONAL",
    "phone": "3568 3227",
    "openingHours": [
      "Monday: 2:00 – 11:00 PM",
      "Tuesday: 2:00 – 11:00 PM",
      "Wednesday: 2:00 – 11:00 PM",
      "Thursday: 2:00 – 11:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 14,
    "id": 571,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "Card Lab",
    "urlinform": "card-lab",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/cardlabstore",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs8DzPnwBBDQRw-MZliQi_64",
    "lat": 22.3087817,
    "lng": 114.1882078,
    "placeId": "ChIJs8DzPnwBBDQRw-MZliQi_64",
    "businessStatus": "OPERATIONAL",
    "phone": "6461 2153",
    "openingHours": [
      "Monday: 6:30 – 11:00 PM",
      "Tuesday: 6:30 – 11:00 PM",
      "Wednesday: 6:30 – 11:00 PM",
      "Thursday: 6:30 – 11:00 PM",
      "Friday: 6:30 – 11:00 PM",
      "Saturday: 3:00 – 11:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 8,
    "id": 572
  },
  {
    "title": "Mox Saga 集換式卡牌遊戲專門店",
    "urlinform": "mox-saga-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVfy2OIIBBDQRGhaNvA4nv6k",
    "lat": 22.3069775,
    "lng": 114.1676695,
    "placeId": "ChIJVfy2OIIBBDQRGhaNvA4nv6k",
    "businessStatus": "OPERATIONAL",
    "phone": "9616 5023",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 18,
    "id": 573
  },
  {
    "title": "Scribbles HK 運動卡-寶可夢卡-TCG card-專門店",
    "urlinform": "scribbles-hk-tcg-card-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.scribbleshk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLz2CjlQBBDQRKuL8tAStFsA",
    "lat": 22.2987287,
    "lng": 114.1733066,
    "placeId": "ChIJLz2CjlQBBDQRKuL8tAStFsA",
    "businessStatus": "OPERATIONAL",
    "phone": "6718 2338",
    "openingHours": [
      "Monday: 11:30 AM – 7:30 PM",
      "Tuesday: 11:30 AM – 7:30 PM",
      "Wednesday: 12:00 – 6:00 PM",
      "Thursday: 11:30 AM – 7:30 PM",
      "Friday: 11:30 AM – 7:30 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 1:00 – 6:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "id": 574,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "Rico.Tcg",
    "urlinform": "ricotcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://ricotcg.boutir.com/p/hompage?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAdGRleAQKtx5leHRuA2FlbQIxMQBzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAafiUG8XoK6YbkBWx4sLpZGr2A4KOfQQE7F1cm5oaO3fPzZ7t4WQMZvyRA9Jcg_aem_Vdvyk49sI8ftlrwqblzyqA",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJH0ISIQABBDQR47C05__52FM",
    "lat": 22.3110155,
    "lng": 114.1883557,
    "placeId": "ChIJH0ISIQABBDQR47C05__52FM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 3:00 – 8:00 PM",
      "Sunday: 3:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 575
  },
  {
    "title": "Smiling Heart",
    "urlinform": "smiling-heart",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://smilingheart.tungwahcsd.org/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzbKih1ABBDQRhTYqmm9GNsA",
    "lat": 22.2934835,
    "lng": 114.1689672,
    "placeId": "ChIJzbKih1ABBDQRhTYqmm9GNsA",
    "businessStatus": "OPERATIONAL",
    "phone": "2366 9109",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 576,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "The Commercial Press Tsim Sha Tsui",
    "urlinform": "the-commercial-press-tsim-sha-tsui",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.supretail.com.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJz3_iSewABDQRx8GoTNXoL9w",
    "lat": 22.2977226,
    "lng": 114.1718959,
    "placeId": "ChIJz3_iSewABDQRx8GoTNXoL9w",
    "businessStatus": "OPERATIONAL",
    "phone": "2904 1988",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 1695,
    "id": 577,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "GALA 旮旯｜桌遊 Board Games",
    "urlinform": "gala-board-games",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://galainhk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt_F-3C4BBDQRqa2RcIMvWGk",
    "lat": 22.29953,
    "lng": 114.173385,
    "placeId": "ChIJt_F-3C4BBDQRqa2RcIMvWGk",
    "businessStatus": "OPERATIONAL",
    "phone": "5534 1996",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 12:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 11:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 47,
    "id": 578,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "Precious Thots",
    "urlinform": "precious-thots",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJp7lccvIABDQRUI1tHMgkpYE",
    "lat": 22.2969933,
    "lng": 114.1718923,
    "placeId": "ChIJp7lccvIABDQRUI1tHMgkpYE",
    "businessStatus": "OPERATIONAL",
    "phone": "2886 8280",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 6,
    "id": 579,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "Bakehouse",
    "urlinform": "bakehouse",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.bakehouse.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBQQXwrUBBDQRuF7yIgthafA",
    "lat": 22.2978445,
    "lng": 114.1711359,
    "placeId": "ChIJBQQXwrUBBDQRuF7yIgthafA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 8:00 AM – 9:00 PM",
      "Tuesday: 8:00 AM – 9:00 PM",
      "Wednesday: 8:00 AM – 9:00 PM",
      "Thursday: 8:00 AM – 9:00 PM",
      "Friday: 8:00 AM – 9:00 PM",
      "Saturday: 8:00 AM – 9:00 PM",
      "Sunday: 8:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 2790,
    "id": 580,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "WAKE Concept Store",
    "urlinform": "wake-concept-store",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.wake.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK0gplSsBBDQRRiA_aol10Bs",
    "lat": 22.2958686,
    "lng": 114.1728713,
    "placeId": "ChIJK0gplSsBBDQRRiA_aol10Bs",
    "businessStatus": "OPERATIONAL",
    "phone": "2813 1393",
    "openingHours": [
      "Monday: 10:00 AM – 7:30 PM",
      "Tuesday: 10:00 AM – 7:30 PM",
      "Wednesday: 10:00 AM – 7:30 PM",
      "Thursday: 10:00 AM – 7:30 PM",
      "Friday: 10:00 AM – 7:30 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.2,
    "userRatingsTotal": 40,
    "id": 581,
    "district": "Tsim Sha Tsui"
  },
  {
    "title": "夯品集凱撒門市 PS5/SWITCH/XBOX主機&軟體販售預購.二手主機/遊戲買賣.主機檢測&送修.寶可夢卡牌",
    "urlinform": "-ps5switchxbox",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.fadmart.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLYTCwdapQjQRuXxDNgQVd30",
    "lat": 25.0460991,
    "lng": 121.5162582,
    "placeId": "ChIJLYTCwdapQjQRuXxDNgQVd30",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2756 6738",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 294,
    "id": 582,
    "district": "Taipei Station"
  },
  {
    "title": "Pokémon Center Taipei",
    "urlinform": "store-2",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/taipei/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgUcOXwCrQjQRri-8c4B9TWM",
    "lat": 25.0363578,
    "lng": 121.5672924,
    "placeId": "ChIJgUcOXwCrQjQRri-8c4B9TWM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 2650,
    "id": 583
  },
  {
    "title": "卡片商店Magi台北西門店",
    "urlinform": "magi",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOfrd65SpQjQRCLznBOYUFxM",
    "lat": 25.0434132,
    "lng": 121.5067811,
    "placeId": "ChIJOfrd65SpQjQRCLznBOYUFxM",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2381 5066",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 496,
    "id": 584,
    "district": "Ximending"
  },
  {
    "title": "AS電玩旗艦館(台北大同門市)",
    "urlinform": "as",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/asgame108",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjTOl0WupQjQRyYmUxMvk6us",
    "lat": 25.056157,
    "lng": 121.5115265,
    "placeId": "ChIJjTOl0WupQjQRyYmUxMvk6us",
    "businessStatus": "OPERATIONAL",
    "phone": "0981 329 190",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 136,
    "id": 585,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "Shin Kong Mitsukoshi Taipei Station Store",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.skm.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcwMa3HKpQjQRDEzzZzYIn-M",
    "lat": 25.0459441,
    "lng": 121.5153112,
    "placeId": "ChIJcwMa3HKpQjQRDEzzZzYIn-M",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2388 5552",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 19226,
    "id": 586,
    "district": "Taipei Station"
  },
  {
    "title": "優格米總店古亭電玩專賣店 #uugame 任天堂SWITCH｜PS5｜販售二手 ｜維修｜盲盒｜娃娃｜完整設定擴充SSD服務｜代購",
    "urlinform": "-uugame-switchps5-ssd",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linktr.ee/uugame",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTWOYmHOpQjQRflR_pigorns",
    "lat": 25.0241925,
    "lng": 121.5249003,
    "placeId": "ChIJTWOYmHOpQjQRflR_pigorns",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2362 3344",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:30 PM",
      "Saturday: 1:00 – 9:30 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1702,
    "id": 587
  },
  {
    "title": "玩具\"反\"斗城 - 西門誠品武昌店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.toysrus.com.tw/zh-tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx1rT-yipQjQRTlDdsm06FDQ",
    "lat": 25.045153,
    "lng": 121.5056864,
    "placeId": "ChIJx1rT-yipQjQRTlDdsm06FDQ",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2381 2815",
    "openingHours": [
      "Monday: 11:30 AM – 10:00 PM",
      "Tuesday: 11:30 AM – 10:00 PM",
      "Wednesday: 11:30 AM – 10:00 PM",
      "Thursday: 11:30 AM – 10:00 PM",
      "Friday: 11:30 AM – 10:00 PM",
      "Saturday: 11:30 AM – 10:00 PM",
      "Sunday: 11:30 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 338,
    "id": 588,
    "district": "Ximending"
  },
  {
    "title": "Guang Hua Digital Plaza",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.gh3c.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfc45RGOpQjQRh_HHWVA41kw",
    "lat": 25.0452719,
    "lng": 121.5320331,
    "placeId": "ChIJfc45RGOpQjQRh_HHWVA41kw",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2391 7105",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 55954,
    "id": 589
  },
  {
    "title": "Sunny Boardgame (Ximen Store)",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/sunnybgximen/?modal=admin_todo_tour",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZZ_ugfWpQjQRETJSvlGyJEA",
    "lat": 25.0419922,
    "lng": 121.5076843,
    "placeId": "ChIJZZ_ugfWpQjQRETJSvlGyJEA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2361 5183",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 2011,
    "id": 590,
    "district": "Ximending"
  },
  {
    "title": "DD Toy Town",
    "urlinform": "store-11",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.ddtoytown.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBYcnIW2pQjQRbTdM9GsgwHE",
    "lat": 25.0510652,
    "lng": 121.5153032,
    "placeId": "ChIJBYcnIW2pQjQRbTdM9GsgwHE",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2556 1661",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 1759,
    "id": 591,
    "district": "Taipei Station"
  },
  {
    "title": "Shin Kong Mitsukoshi Xinyi Place A11",
    "urlinform": "-a11",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.skm.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQcKOdbqrQjQROgrX00ZQqmo",
    "lat": 25.0365955,
    "lng": 121.5673381,
    "placeId": "ChIJQcKOdbqrQjQROgrX00ZQqmo",
    "businessStatus": "OPERATIONAL",
    "phone": "02 8780 1000",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 27768,
    "id": 592
  },
  {
    "title": "地下街軟體世界一店",
    "urlinform": "store-15",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/sgmk2",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ__-AlxKpQjQRmeUkvnka-ZI",
    "lat": 25.0487796,
    "lng": 121.5148878,
    "placeId": "ChIJ__-AlxKpQjQRmeUkvnka-ZI",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2559 4855",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 9:30 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 989,
    "id": 593,
    "district": "Taipei Station"
  },
  {
    "title": "優格米電玩專賣店(民生三民店)任天堂SWITCH & PS4 / PS5 & XBOX /維修/客製化改殼 電玩專賣店",
    "urlinform": "switch-ps4-ps5-xbox-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61554511291154&mibextid=LQQJ4d",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYwAOeOWrQjQRjhRHa3xDj2E",
    "lat": 25.0588826,
    "lng": 121.5613711,
    "placeId": "ChIJYwAOeOWrQjQRjhRHa3xDj2E",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2761 2177",
    "openingHours": [
      "Monday: 1:30 – 9:30 PM",
      "Tuesday: 1:30 – 9:30 PM",
      "Wednesday: 1:30 – 9:30 PM",
      "Thursday: 1:30 – 9:30 PM",
      "Friday: 1:30 – 9:30 PM",
      "Saturday: 1:30 – 9:30 PM",
      "Sunday: 1:30 – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 881,
    "id": 594
  },
  {
    "title": "奧特狐桌遊店（未訂位彈性開關門30分鐘）",
    "urlinform": "30",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/twoutfox/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnyFWxwmpQjQRPWubRoGYDXY",
    "lat": 25.041532,
    "lng": 121.50553,
    "placeId": "ChIJnyFWxwmpQjQRPWubRoGYDXY",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2381 5869",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 311,
    "id": 595,
    "district": "Ximending"
  },
  {
    "title": "普雷伊電視遊樂專賣店",
    "urlinform": "store-18",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.tvgame.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4SixhW2pQjQRu2GJf9GjId0",
    "lat": 25.0488382,
    "lng": 121.5142475,
    "placeId": "ChIJ4SixhW2pQjQRu2GJf9GjId0",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2556 6882",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 437,
    "id": 596,
    "district": "Taipei Station"
  },
  {
    "title": "創Q space ATT4FUN 信義店",
    "urlinform": "q-space-att4fun-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.qspace.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJETTbGUGrQjQRzoHrzDHqjJo",
    "lat": 25.0353886,
    "lng": 121.5660759,
    "placeId": "ChIJETTbGUGrQjQRzoHrzDHqjJo",
    "businessStatus": "OPERATIONAL",
    "phone": "02 7745 3366",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 54,
    "id": 597
  },
  {
    "title": "Shin Kong Mitsukoshi Taipei Xinyi Place A8",
    "urlinform": "-a8",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.skm.com.tw/BranchPages/BranchPagesInfo?UUID=4e76109e-f0db-4198-ab3e-63264964844e&dShopUUID=75be7381-fc2a-4ad7-979d-b5ae7716070c",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJj9UJtrurQjQRSvkXdnrzyeI",
    "lat": 25.0382241,
    "lng": 121.5667909,
    "placeId": "ChIJj9UJtrurQjQRSvkXdnrzyeI",
    "businessStatus": "OPERATIONAL",
    "phone": "02 8780 9966",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 13184,
    "id": 598
  },
  {
    "title": "新航玩具 Shin Hang (遊戲王.遊戲卡片)",
    "urlinform": "-shin-hang-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUYS3JS2qQjQRxNGor_477Zs",
    "lat": 25.0298242,
    "lng": 121.5458685,
    "placeId": "ChIJUYS3JS2qQjQRxNGor_477Zs",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2702 7020",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: Closed",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 176,
    "id": 599
  },
  {
    "title": "Board Game Hut (Taipei Branch)",
    "urlinform": "store-23",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "https://bghut.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcaLV2XKpQjQRV90mcrxH1SE",
    "lat": 25.0449711,
    "lng": 121.5133762,
    "placeId": "ChIJcaLV2XKpQjQRV90mcrxH1SE",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2311 2981",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 557,
    "id": 600,
    "district": "Taipei Station"
  },
  {
    "title": "LAI HAO",
    "urlinform": "-lai-hao-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.laihao.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcQs8RYKpQjQR9TIAoiWqJoU",
    "lat": 25.032756,
    "lng": 121.529218,
    "placeId": "ChIJcQs8RYKpQjQR9TIAoiWqJoU",
    "businessStatus": "OPERATIONAL",
    "phone": "02 3322 6136",
    "openingHours": [
      "Monday: 9:30 AM – 9:30 PM",
      "Tuesday: 9:30 AM – 9:30 PM",
      "Wednesday: 9:30 AM – 9:30 PM",
      "Thursday: 9:30 AM – 9:30 PM",
      "Friday: 9:30 AM – 9:30 PM",
      "Saturday: 9:30 AM – 9:30 PM",
      "Sunday: 9:30 AM – 9:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 2409,
    "id": 601
  },
  {
    "title": "瑪爾斯卡片專賣店",
    "urlinform": "store-25",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/marscardshop",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJz6nX7UypQjQRW7wnptq8MUs",
    "lat": 25.0480958,
    "lng": 121.5176946,
    "placeId": "ChIJz6nX7UypQjQRW7wnptq8MUs",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2555 6253",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 1.3,
    "userRatingsTotal": 38,
    "id": 602,
    "district": "Taipei Station"
  },
  {
    "title": "Grow Life",
    "urlinform": "store-26",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/GrowLife-%E9%9D%A0%E9%81%8E%E4%BE%86-1414718015264803/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ33MxVX6pQjQRRD957u4F5IU",
    "lat": 25.0345369,
    "lng": 121.5307933,
    "placeId": "ChIJ33MxVX6pQjQRRD957u4F5IU",
    "businessStatus": "OPERATIONAL",
    "phone": "0905 428 741",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1378,
    "id": 603
  },
  {
    "title": "HOT DOG TOYZ",
    "urlinform": "hot-dog-toyz",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRVCxPMWrQjQRzRps10rySd0",
    "lat": 25.0423966,
    "lng": 121.5494894,
    "placeId": "ChIJRVCxPMWrQjQRzRps10rySd0",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2741 4899",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 261,
    "id": 604
  },
  {
    "title": "Taipei City Mall",
    "urlinform": "store-28",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.taipeimall.com.tw/zh-TW",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6cxPB22pQjQRLik_97hS8Ow",
    "lat": 25.0495574,
    "lng": 121.5136552,
    "placeId": "ChIJ6cxPB22pQjQRLik_97hS8Ow",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2559 4566",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 22442,
    "id": 605,
    "district": "Taipei Station"
  },
  {
    "title": "Station Front Metro Mall",
    "urlinform": "z",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.sfmm.org.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB6owJvupQjQRbT3NIAzie18",
    "lat": 25.046999,
    "lng": 121.5143479,
    "placeId": "ChIJB6owJvupQjQRbT3NIAzie18",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2375 1567",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 61,
    "id": 606,
    "district": "Taipei Station"
  },
  {
    "title": "貓腳印-東門店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/CatFootPrintDongMen.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPbRdzLOpQjQR1YbG4Xhqf-Q",
    "lat": 25.0346715,
    "lng": 121.5253249,
    "placeId": "ChIJPbRdzLOpQjQR1YbG4Xhqf-Q",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2358 7751",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 147,
    "id": 607
  },
  {
    "title": "幻想遊戲世界 (Fantasy Cards shop) MTG, PTCG",
    "urlinform": "-fantasy-cards-shop-mtg-ptcg",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://www.facebook.com/mtgfantasy/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ71xU3IupQjQRR2dzXLNYZco",
    "lat": 25.0173537,
    "lng": 121.5328827,
    "placeId": "ChIJ71xU3IupQjQRR2dzXLNYZco",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2362 1455",
    "openingHours": [
      "Monday: 3:00 – 10:30 PM",
      "Tuesday: 3:00 – 10:30 PM",
      "Wednesday: 3:00 – 10:30 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 10:30 PM",
      "Saturday: 3:00 – 11:00 PM",
      "Sunday: 3:00 – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 134,
    "id": 608
  },
  {
    "title": "牌塔",
    "urlinform": "-tower-of-tcg",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/totarmory/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcfdyUBipQjQRiGaCII8MeCo",
    "lat": 25.0277465,
    "lng": 121.520156,
    "placeId": "ChIJcfdyUBipQjQRiGaCII8MeCo",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2343 2452",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 146,
    "id": 609
  },
  {
    "title": "崇文社 CW Cardshop",
    "urlinform": "-cw-cardshop",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/CWcardshop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKY4Dp_KvQjQRlw3WWezNg08",
    "lat": 25.056615,
    "lng": 121.5152615,
    "placeId": "ChIJKY4Dp_KvQjQRlw3WWezNg08",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2595 6158",
    "openingHours": [
      "Monday: 3:30 – 10:00 PM",
      "Tuesday: 3:30 – 10:00 PM",
      "Wednesday: 3:30 – 10:00 PM",
      "Thursday: 3:30 – 10:00 PM",
      "Friday: 3:30 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 236,
    "id": 610,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "Card Master Games",
    "urlinform": "card-master-games",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/cardmaster.tw",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDwzW1ZipQjQRHY1Y3_Gt82g",
    "lat": 25.0277465,
    "lng": 121.520156,
    "placeId": "ChIJDwzW1ZipQjQRHY1Y3_Gt82g",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2396 2767",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 10:30 PM",
      "Wednesday: 2:00 – 10:30 PM",
      "Thursday: 2:00 – 10:30 PM",
      "Friday: 2:00 – 10:30 PM",
      "Saturday: 2:00 – 10:30 PM",
      "Sunday: 2:00 – 10:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 335,
    "id": 611
  },
  {
    "title": "玩聚 西門店 PTCG OPCG TCG 一番賞 卡牌 GK",
    "urlinform": "-ptcg-opcg-tcg-gk",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/wanju_toys/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4TRZTKOpQjQR1lMhh_NhV30",
    "lat": 25.0439474,
    "lng": 121.5067661,
    "placeId": "ChIJ4TRZTKOpQjQR1lMhh_NhV30",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 11:00 PM",
      "Tuesday: 2:00 – 11:00 PM",
      "Wednesday: 2:00 – 11:00 PM",
      "Thursday: 2:00 – 11:00 PM",
      "Friday: 1:00 PM – 12:00 AM",
      "Saturday: 1:00 PM – 12:00 AM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 18,
    "id": 612,
    "district": "Ximending"
  },
  {
    "title": "Cat Footprints Playground",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/cfpsongjiang",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgewKR12pQjQR4sz-lIIyNPs",
    "lat": 25.0523277,
    "lng": 121.5323364,
    "placeId": "ChIJgewKR12pQjQR4sz-lIIyNPs",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2542 9969",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 153,
    "id": 613
  },
  {
    "title": "JJ卡舖 - JJ Cards Shop",
    "urlinform": "jj-jj-cards-shop",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.jjcs.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBaR2W8urQjQR-Smsq8QbV7E",
    "lat": 25.0295831,
    "lng": 121.5546757,
    "placeId": "ChIJBaR2W8urQjQR-Smsq8QbV7E",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2736 3152",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 7:00 PM – 1:00 AM",
      "Wednesday: 7:00 PM – 1:00 AM",
      "Thursday: 7:00 PM – 1:00 AM",
      "Friday: 7:00 PM – 1:00 AM",
      "Saturday: 7:00 PM – 1:00 AM",
      "Sunday: Closed"
    ],
    "rating": 4.5,
    "userRatingsTotal": 130,
    "id": 614
  },
  {
    "title": "大聯盟電腦遊戲",
    "urlinform": "thrustmastert300rsgtqboss2",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.gh3c.com.tw/index.php?app=store&id=27",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfc45RGOpQjQRKlhLmWRakVA",
    "lat": 25.0450357,
    "lng": 121.5319312,
    "placeId": "ChIJfc45RGOpQjQRKlhLmWRakVA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2391 4191",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 46,
    "id": 615
  },
  {
    "title": "桌遊老爹",
    "urlinform": "store-39",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/tgsbg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4b4QFaapQjQRWSHCoAipq4s",
    "lat": 25.0364541,
    "lng": 121.5040108,
    "placeId": "ChIJ4b4QFaapQjQRWSHCoAipq4s",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2308 8972",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 355,
    "id": 616
  },
  {
    "title": "台北地下街67 時光屋",
    "urlinform": "67-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqapfrxKpQjQRVhuZ0V9xk-4",
    "lat": 25.0493585,
    "lng": 121.5134588,
    "placeId": "ChIJqapfrxKpQjQRVhuZ0V9xk-4",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2559 5950",
    "openingHours": [
      "Monday: 2:00 – 9:30 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 2:00 – 9:30 PM",
      "Friday: 2:00 – 9:30 PM",
      "Saturday: 2:00 – 9:30 PM",
      "Sunday: 2:00 – 9:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 135,
    "id": 617,
    "district": "Taipei Station"
  },
  {
    "title": "暖角落 卡牌遊戲專賣店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/CornerTcgPlayground",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1eW-PPGrQjQRlmtEnoJXIBA",
    "lat": 25.0489008,
    "lng": 121.562188,
    "placeId": "ChIJ1eW-PPGrQjQRlmtEnoJXIBA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2748 3156",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 5:00 – 11:00 PM",
      "Wednesday: 5:00 – 11:00 PM",
      "Thursday: 5:00 – 11:00 PM",
      "Friday: 5:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 49,
    "id": 618
  },
  {
    "title": "Eslite Spectrum Taipei Station Store",
    "urlinform": "store-45",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://meet.eslite.com/tw/tc/store/202408270001",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD2MIQ3KpQjQRUZmTgssWj1Q",
    "lat": 25.0460925,
    "lng": 121.5169826,
    "placeId": "ChIJD2MIQ3KpQjQRUZmTgssWj1Q",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2389 1168",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 9:30 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 5221,
    "id": 619,
    "district": "Taipei Station"
  },
  {
    "title": "Shin Kong Mitsukoshi Taipei Station",
    "urlinform": "store-46",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.skm.com.tw/page/taipeistation?gad_source=1&gad_campaignid=24063400532&gbraid=0AAAAA-8SasuuvUcO3X7ju2X5xDcuu7p5S&gclid=CjwKCAjw7KvTBhA6EiwAWnutYQCJDgKj6e093iqvNhgOCT8i2-OzrjRS8ySjviKHF6IXfkPtRFVSKhoCobYQAvD_BwE",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6TDRgW2pQjQRwbnruR2zF2E",
    "lat": 25.0478356,
    "lng": 121.5163623,
    "placeId": "ChIJ6TDRgW2pQjQRwbnruR2zF2E",
    "businessStatus": "OPERATIONAL",
    "phone": "02 6632 8999",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 17572,
    "id": 620,
    "district": "Taipei Station"
  },
  {
    "title": "CREMIA Hokkaido Ice-cream - Taipei Main Station",
    "urlinform": "cremia-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/CremiaTaiwan",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJlV18hoipQjQRtq6ll1T0UMs",
    "lat": 25.0460037,
    "lng": 121.5172377,
    "placeId": "ChIJlV18hoipQjQRtq6ll1T0UMs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 286,
    "id": 621,
    "district": "Taipei Station"
  },
  {
    "title": "Bao maison寶物 \\ A gift store in Taipei /獨立風格禮物店",
    "urlinform": "bao-maison-a-gift-store-in-taipei-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/baomaison_/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMZ-SWoKpQjQRdirqWTQ_n8k",
    "lat": 25.0326978,
    "lng": 121.5295697,
    "placeId": "ChIJMZ-SWoKpQjQRdirqWTQ_n8k",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 983,
    "id": 622
  },
  {
    "title": "Calorie Heathy Box Taipei Main Station",
    "urlinform": "_",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD798c4SpQjQRKCqSG4VJPLs",
    "lat": 25.0450731,
    "lng": 121.5165218,
    "placeId": "ChIJD798c4SpQjQRKCqSG4VJPLs",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2388 8168",
    "openingHours": [
      "Monday: 10:30 AM – 2:00 PM, 3:00 – 7:00 PM",
      "Tuesday: 10:30 AM – 2:00 PM, 3:00 – 7:00 PM",
      "Wednesday: 10:30 AM – 2:00 PM, 3:00 – 7:00 PM",
      "Thursday: 10:30 AM – 2:00 PM, 3:00 – 7:00 PM",
      "Friday: 10:30 AM – 2:00 PM, 3:00 – 7:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.5,
    "userRatingsTotal": 491,
    "id": 623,
    "district": "Taipei Station"
  },
  {
    "title": "ATT 4 FUN Xinyi Store",
    "urlinform": "att-4-fun-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.att4fun.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjfzEsLCrQjQRsd6k1mO2-WA",
    "lat": 25.0353558,
    "lng": 121.5659995,
    "placeId": "ChIJjfzEsLCrQjQRsd6k1mO2-WA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 8780 8111",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 26587,
    "id": 624
  },
  {
    "title": "貳家桌遊北車店24H",
    "urlinform": "24h",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lin.ee/grOxFJ9",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXzF6y6WpQjQRicCDKDRwJs0",
    "lat": 25.0451415,
    "lng": 121.516481,
    "placeId": "ChIJXzF6y6WpQjQRicCDKDRwJs0",
    "businessStatus": "OPERATIONAL",
    "phone": "0960 506 474",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.8,
    "userRatingsTotal": 1689,
    "id": 625,
    "district": "Taipei Station"
  },
  {
    "title": "幽靈屋 YuReiHouse 親子 寶可夢卡牌 桌遊 出租空間",
    "urlinform": "-yureihouse-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/YuReiHouse",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJI_MuRm6rQjQRkZl5d8yw8EU",
    "lat": 25.0540141,
    "lng": 121.6158168,
    "placeId": "ChIJI_MuRm6rQjQRkZl5d8yw8EU",
    "businessStatus": "OPERATIONAL",
    "phone": "0936 288 853",
    "openingHours": [
      "Monday: 3:30 – 9:30 PM",
      "Tuesday: Closed",
      "Wednesday: 3:30 – 9:30 PM",
      "Thursday: Closed",
      "Friday: 3:30 – 9:30 PM",
      "Saturday: 1:30 – 10:30 PM",
      "Sunday: 1:30 – 10:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 98,
    "id": 626
  },
  {
    "title": "ETtoday Plaza – K Zone Underground Mall",
    "urlinform": "-k",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/EHSKZone",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9cfBUs-pQjQRvHQoJpfUGF8",
    "lat": 25.0474322,
    "lng": 121.5162386,
    "placeId": "ChIJ9cfBUs-pQjQRvHQoJpfUGF8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 2015,
    "id": 627,
    "district": "Taipei Station"
  },
  {
    "title": "MEZASTAR Station TAIPEI",
    "urlinform": "mezastar-station-taipei",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemonmezastar.com.tw/cassette/7",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyWnaYwCpQjQRLIv0CtfZ5yY",
    "lat": 25.0474322,
    "lng": 121.5162386,
    "placeId": "ChIJyWnaYwCpQjQRLIv0CtfZ5yY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:40 PM",
      "Tuesday: 11:00 AM – 9:40 PM",
      "Wednesday: 11:00 AM – 9:40 PM",
      "Thursday: 11:00 AM – 9:40 PM",
      "Friday: 11:00 AM – 9:40 PM",
      "Saturday: 11:00 AM – 9:40 PM",
      "Sunday: 11:00 AM – 9:40 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 9,
    "id": 628,
    "district": "Taipei Station"
  },
  {
    "title": "K區地下街",
    "urlinform": "-k",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjfvY7HKpQjQRlXeAMl8tTk4",
    "lat": 25.0476024,
    "lng": 121.5162965,
    "placeId": "ChIJjfvY7HKpQjQRlXeAMl8tTk4",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2381 2766",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 1627,
    "id": 629,
    "district": "Taipei Station"
  },
  {
    "title": "鬧鬧TCG桌遊",
    "urlinform": "tcg",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/NowNowTCG/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE0yRLW2pQjQR52_wpCEwieY",
    "lat": 25.0542221,
    "lng": 121.5132232,
    "placeId": "ChIJE0yRLW2pQjQR52_wpCEwieY",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2552 3648",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:30 – 11:00 PM",
      "Wednesday: 1:30 – 11:00 PM",
      "Thursday: 1:30 – 11:00 PM",
      "Friday: 1:30 – 11:00 PM",
      "Saturday: 10:30 AM – 11:00 PM",
      "Sunday: 10:30 AM – 11:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 176,
    "id": 630,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "【桌遊地下城】| 深夜遊玩需求請先來電 | 桌遊推薦、玩買租學、聚會活動 | 70人大空間 | Team Building團隊建立",
    "urlinform": "-70-team-building",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.bungeon.com/aboutus",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt1bhhtqrQjQR9AVkMdc5sDg",
    "lat": 25.0419062,
    "lng": 121.5460543,
    "placeId": "ChIJt1bhhtqrQjQR9AVkMdc5sDg",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2711 9570",
    "openingHours": [
      "Monday: 2:00 – 10:30 PM",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 10:30 PM",
      "Thursday: 2:00 – 10:30 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 10:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 4689,
    "id": 631
  },
  {
    "title": "桌友之地：西門店 （台北西門桌遊店、24小時營業、桌遊玩樂、租借遊戲、包場派對）*文化幣適用",
    "urlinform": "-24",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/share/1GFy4i8Jke/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_bCrCFKpQjQRPa_kct0uBJ0",
    "lat": 25.0447062,
    "lng": 121.5105479,
    "placeId": "ChIJ_bCrCFKpQjQRPa_kct0uBJ0",
    "businessStatus": "OPERATIONAL",
    "phone": "0921 608 262",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 855,
    "id": 632,
    "district": "Ximending"
  },
  {
    "title": "Game Square 遊戲平方桌遊店 | 中山捷運站舒適桌遊店｜超過七百款桌遊可以玩 ｜ 台北推薦 |",
    "urlinform": "game-square-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/game_square",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_QsCLG-pQjQRRypsgxVp9So",
    "lat": 25.0516593,
    "lng": 121.5231102,
    "placeId": "ChIJ_QsCLG-pQjQRRypsgxVp9So",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2581 1191",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 2389,
    "id": 633,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "桌遊天空城",
    "urlinform": "store-61",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/laputaBG",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJde9FSf2rQjQR1ixvLNH9PLM",
    "lat": 25.048801,
    "lng": 121.525604,
    "placeId": "ChIJde9FSf2rQjQR1ixvLNH9PLM",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2593 1307",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1504,
    "id": 634,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "貳家桌遊東區店(預約請加LINE @218ajoas)",
    "urlinform": "line-218ajoas",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.oursecondhome12.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtUAXblCpQjQRBxL6npgDVe8",
    "lat": 25.0511885,
    "lng": 121.562777,
    "placeId": "ChIJtUAXblCpQjQRBxL6npgDVe8",
    "businessStatus": "OPERATIONAL",
    "phone": "0960 506 474",
    "openingHours": [
      "Monday: 7:00 AM – 10:00 PM",
      "Tuesday: 7:00 AM – 10:00 PM",
      "Wednesday: 7:00 AM – 10:00 PM",
      "Thursday: 7:00 AM – 10:00 PM",
      "Friday: 7:00 AM – 10:00 PM",
      "Saturday: 7:00 AM – 10:00 PM",
      "Sunday: 7:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 688,
    "id": 635
  },
  {
    "title": "布萊梅桌遊專賣店 Bremen Boardgame丨文化幣✅丨販售、租借、遊玩丨活動、企業包場丨百人大空間、獨立包廂",
    "urlinform": "-bremen-boardgame",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://bgbremen.simplybook.asia/v2/#book",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgei-umGpQjQRyGlNAhKrNiA",
    "lat": 25.0511246,
    "lng": 121.5349439,
    "placeId": "ChIJgei-umGpQjQRyGlNAhKrNiA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2501 2601",
    "openingHours": [
      "Monday: 1:00 – 11:00 PM",
      "Tuesday: 1:00 – 11:00 PM",
      "Wednesday: 1:00 – 11:00 PM",
      "Thursday: 1:00 – 11:00 PM",
      "Friday: 1:00 – 11:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 762,
    "id": 636
  },
  {
    "title": "桌遊地下城 延吉店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.bungeon.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBS6gc8arQjQRqslMGwELz-A",
    "lat": 25.041861,
    "lng": 121.545892,
    "placeId": "ChIJBS6gc8arQjQRqslMGwELz-A",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2778 7947",
    "openingHours": [
      "Monday: 2:30 – 10:30 PM",
      "Tuesday: Closed",
      "Wednesday: 2:30 – 10:30 PM",
      "Thursday: 2:30 – 10:30 PM",
      "Friday: 2:30 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 10:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 2980,
    "id": 637
  },
  {
    "title": "町台玩24h自助桌遊-中正桌遊租借|麻將會館|棋牌會館|麻將館首選|桌遊店推薦|棋牌休閒館",
    "urlinform": "24h-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://vip.hengfu-i.com/index.php?dr_idno=00548150",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ26hBsFKpQjQRvs__OufViZ4",
    "lat": 25.0167433,
    "lng": 121.5319703,
    "placeId": "ChIJ26hBsFKpQjQRvs__OufViZ4",
    "businessStatus": "OPERATIONAL",
    "phone": "0906 932 920",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.7,
    "userRatingsTotal": 40,
    "id": 638
  },
  {
    "title": "No.9聚會空間(９號聚會空間)",
    "urlinform": "no9",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/no9space",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTz-54oqpQjQR1n00bZGTHOY",
    "lat": 25.014172,
    "lng": 121.534218,
    "placeId": "ChIJTz-54oqpQjQR1n00bZGTHOY",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2369 1808",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1061,
    "id": 639
  },
  {
    "title": "卡卡城 桌上遊戲-台北-（文化幣使用）（平日可於兩天前預約遊玩時間）（桌游店/桌遊租借/場地出租/桌遊販售) 北車(桌遊包場/場地租借/桌遊包場)",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.cacacity.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4UUatQypQjQRWAPPTO0vq_c",
    "lat": 25.0447982,
    "lng": 121.5140503,
    "placeId": "ChIJ4UUatQypQjQRWAPPTO0vq_c",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2388 0938",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 7:00 – 10:00 PM",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 232,
    "id": 640,
    "district": "Taipei Station"
  },
  {
    "title": "貳家桌遊內湖成功店",
    "urlinform": "24hline-218ajoas",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.oursecondhome12.com/product-category/%E8%B2%B3%E5%AE%B6%E5%85%A7%E6%B9%96%E6%88%90%E5%8A%9F%E5%BA%97/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJYFvjDmtQjQRmXZ4iI1d-II",
    "lat": 25.081986,
    "lng": 121.5928836,
    "placeId": "ChIJJYFvjDmtQjQRmXZ4iI1d-II",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 12,
    "id": 641
  },
  {
    "title": "LOST Taiwan 站前店",
    "urlinform": "lost-taiwan-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.losttw.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv6_XQfepQjQRjhlaS_bSCmo",
    "lat": 25.0454166,
    "lng": 121.5158347,
    "placeId": "ChIJv6_XQfepQjQRjhlaS_bSCmo",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2371 0826",
    "openingHours": [
      "Monday: 1:00 – 8:30 PM",
      "Tuesday: 1:00 – 8:30 PM",
      "Wednesday: 1:00 – 8:30 PM",
      "Thursday: 1:00 – 8:30 PM",
      "Friday: 1:00 – 8:30 PM",
      "Saturday: 11:45 AM – 8:30 PM",
      "Sunday: 11:45 AM – 8:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 535,
    "id": 642,
    "district": "Taipei Station"
  },
  {
    "title": "瘋桌遊益智遊戲專賣店大安店",
    "urlinform": "store-70",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/PHDAAN02",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXYQDgcyrQjQRFFh_yKfOnKE",
    "lat": 25.0312652,
    "lng": 121.5537868,
    "placeId": "ChIJXYQDgcyrQjQRFFh_yKfOnKE",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2703 6003",
    "openingHours": [
      "Monday: 6:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 6:00 – 10:00 PM",
      "Thursday: Closed",
      "Friday: 6:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 489,
    "id": 643
  },
  {
    "title": "KEVINLOVECARD 球員卡店",
    "urlinform": "kevinlovecard-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/kevinlovecard/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzzz4j6ypQjQR6j1Y1yQ8oxA",
    "lat": 25.043508,
    "lng": 121.5058859,
    "placeId": "ChIJzzz4j6ypQjQR6j1Y1yQ8oxA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 3:00 – 9:00 PM",
      "Sunday: 3:00 – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 4,
    "id": 644,
    "district": "Ximending"
  },
  {
    "title": "電玩國度 (西門店)",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.tvgameworld.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKYhSg8apQjQRtKltw6uZMRc",
    "lat": 25.0469491,
    "lng": 121.5050494,
    "placeId": "ChIJKYhSg8apQjQRtKltw6uZMRc",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2381 7846",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 248,
    "id": 645,
    "district": "Ximending"
  },
  {
    "title": "Maru Cuber Shop",
    "urlinform": "-3f",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://maru.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoS6iaeGpQjQRVYsdIddEKXM",
    "lat": 25.0451617,
    "lng": 121.5055717,
    "placeId": "ChIJoS6iaeGpQjQRVYsdIddEKXM",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2381 3838#1309",
    "openingHours": [
      "Monday: 11:30 AM – 10:00 PM",
      "Tuesday: 11:30 AM – 10:00 PM",
      "Wednesday: 11:30 AM – 10:00 PM",
      "Thursday: 11:30 AM – 10:00 PM",
      "Friday: 11:30 AM – 10:00 PM",
      "Saturday: 11:30 AM – 10:00 PM",
      "Sunday: 11:30 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 153,
    "id": 646,
    "district": "Ximending"
  },
  {
    "title": "玩具時光屋 TCG Card卡牌",
    "urlinform": "-tcg-card",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuzFkbWEDaDQR-E3_r3rtUUk",
    "lat": 25.0438483,
    "lng": 121.5075677,
    "placeId": "ChIJuzFkbWEDaDQR-E3_r3rtUUk",
    "businessStatus": "OPERATIONAL",
    "phone": "0903 022 352",
    "openingHours": [
      "Monday: 3:30 – 11:00 PM",
      "Tuesday: 3:30 – 11:00 PM",
      "Wednesday: 3:30 – 11:00 PM",
      "Thursday: 3:30 – 11:00 PM",
      "Friday: 3:30 AM – 11:00 PM",
      "Saturday: 3:30 – 11:00 PM",
      "Sunday: 3:30 – 11:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 53,
    "id": 647,
    "district": "Ximending"
  },
  {
    "title": "BEETLE",
    "urlinform": "beetle-plus",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.beetleplus.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDfOP3g6pQjQRAonbENJKzO4",
    "lat": 25.0466424,
    "lng": 121.5059677,
    "placeId": "ChIJDfOP3g6pQjQRAonbENJKzO4",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2311 8355",
    "openingHours": [
      "Monday: 3:00 – 9:30 PM",
      "Tuesday: 3:00 – 9:30 PM",
      "Wednesday: 3:00 – 9:30 PM",
      "Thursday: 3:00 – 9:30 PM",
      "Friday: 3:00 – 9:30 PM",
      "Saturday: 3:00 – 9:30 PM",
      "Sunday: 3:00 – 9:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 113,
    "id": 648,
    "district": "Ximending"
  },
  {
    "title": "LAI HAO – Ximen Branch",
    "urlinform": "-lai-hao-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.laihao.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGf29RwCpQjQRoyZCznK9P24",
    "lat": 25.0430495,
    "lng": 121.5061337,
    "placeId": "ChIJGf29RwCpQjQRoyZCznK9P24",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2361 1996",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 379,
    "id": 649,
    "district": "Ximending"
  },
  {
    "title": "MagFreak Taipei",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.magfreak.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_ch7VgmpQjQRs4oNqMt8Q1Y",
    "lat": 25.0445137,
    "lng": 121.5082108,
    "placeId": "ChIJ_ch7VgmpQjQRs4oNqMt8Q1Y",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2389 6728",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 2391,
    "id": 650,
    "district": "Ximending"
  },
  {
    "title": "AToMic（桌遊/電玩/餐酒/場租）",
    "urlinform": "atomic-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://facebook.com/profile.php?id=349985535174083&_rdr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP24HckKpQjQRVeoIRrFcevI",
    "lat": 25.0397922,
    "lng": 121.5046176,
    "placeId": "ChIJP24HckKpQjQRVeoIRrFcevI",
    "businessStatus": "OPERATIONAL",
    "phone": "0975 169 159",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 967,
    "id": 651,
    "district": "Ximending"
  },
  {
    "title": "普雷伊萬年二店",
    "urlinform": "store-80",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/%E6%99%AE%E9%9B%B7%E4%BC%8A%E8%90%AC%E5%B9%B4%E4%BA%8C%E5%BA%97-389572814995014/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPSwubnapQjQRXE0MUZZWuCE",
    "lat": 25.0435135,
    "lng": 121.5058942,
    "placeId": "ChIJPSwubnapQjQRXE0MUZZWuCE",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2370 8755",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 11:30 AM – 10:00 PM",
      "Wednesday: 11:30 AM – 10:00 PM",
      "Thursday: 11:30 AM – 10:00 PM",
      "Friday: 11:30 AM – 10:00 PM",
      "Saturday: 11:30 AM – 10:00 PM",
      "Sunday: 11:30 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 40,
    "id": 652,
    "district": "Ximending"
  },
  {
    "title": "卡竅 CardChill｜寶可夢卡牌專門店｜hololive Official Card Game 專門店｜武士道卡牌｜集換式卡牌｜PTCG｜hOCG｜WS｜VG｜ポケカ/ホロカ トレカ専門店",
    "urlinform": "-cardchillhololive-official-card-game-ptcghocgwsvg-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://cardchill.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJozbOKdurQjQRRRGQnKx3h3c",
    "lat": 25.0402393,
    "lng": 121.5742139,
    "placeId": "ChIJozbOKdurQjQRRRGQnKx3h3c",
    "businessStatus": "OPERATIONAL",
    "phone": "02 6634 7414",
    "openingHours": [
      "Monday: 3:30 – 11:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:30 – 11:00 PM",
      "Thursday: 3:30 – 11:00 PM",
      "Friday: 3:30 PM – 2:00 AM",
      "Saturday: 3:30 PM – 2:00 AM",
      "Sunday: 3:30 – 11:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 56,
    "id": 653
  },
  {
    "title": "新金手指帝國-電玩影音專售",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.par.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqeQavkCpQjQR0OoeC2nOjgI",
    "lat": 25.0631802,
    "lng": 121.5154006,
    "placeId": "ChIJqeQavkCpQjQR0OoeC2nOjgI",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2597 4206",
    "openingHours": [
      "Monday: 2:00 – 10:30 PM",
      "Tuesday: 2:00 – 10:30 PM",
      "Wednesday: 2:00 – 10:30 PM",
      "Thursday: 2:00 – 10:30 PM",
      "Friday: 2:00 – 10:30 PM",
      "Saturday: 2:00 – 10:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 96,
    "id": 654
  },
  {
    "title": "Mr. Ho’s Shop",
    "urlinform": "mr-hos-shop",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK-fCPkipQjQRoS2lfMoSHzg",
    "lat": 25.0451127,
    "lng": 121.5077678,
    "placeId": "ChIJK-fCPkipQjQRoS2lfMoSHzg",
    "businessStatus": "OPERATIONAL",
    "phone": "0915 032 992",
    "openingHours": [
      "Monday: 9:30 AM – 11:30 PM",
      "Tuesday: 9:30 AM – 11:30 PM",
      "Wednesday: 9:30 AM – 11:30 PM",
      "Thursday: 9:30 AM – 11:30 PM",
      "Friday: 9:30 AM – 11:30 PM",
      "Saturday: 9:30 AM – 11:30 PM",
      "Sunday: 9:30 AM – 11:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 146,
    "id": 655,
    "district": "Ximending"
  },
  {
    "title": "E-Hobby",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ehobby.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_Za-HAmpQjQRFu_cF0z6Eq0",
    "lat": 25.0435135,
    "lng": 121.5058942,
    "placeId": "ChIJ_Za-HAmpQjQRFu_cF0z6Eq0",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2331 5666",
    "openingHours": [
      "Monday: 2:00 – 9:30 PM",
      "Tuesday: 12:00 – 9:30 PM",
      "Wednesday: 12:00 – 9:30 PM",
      "Thursday: 12:00 – 9:30 PM",
      "Friday: 12:00 – 9:30 PM",
      "Saturday: 12:00 – 9:30 PM",
      "Sunday: 12:00 – 9:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 1062,
    "id": 656,
    "district": "Ximending"
  },
  {
    "title": "泡泡瑪特 西門町旗艦店",
    "urlinform": "pop-mart-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/profile.php/?id=100084288187341",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi42aajKpQjQRldwNdRG1a3o",
    "lat": 25.0433984,
    "lng": 121.5071218,
    "placeId": "ChIJi42aajKpQjQRldwNdRG1a3o",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2370 2225",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:30 PM",
      "Saturday: 11:00 AM – 10:30 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 1826,
    "id": 657,
    "district": "Ximending"
  },
  {
    "title": "Mag Freak 雜誌瘋 永華店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.magfreak.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7YedGwmpQjQRMAQfn4CIUqM",
    "lat": 25.0435808,
    "lng": 121.5059763,
    "placeId": "ChIJ7YedGwmpQjQRMAQfn4CIUqM",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2375 2114",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 98,
    "id": 658,
    "district": "Ximending"
  },
  {
    "title": "金萬年玩具行",
    "urlinform": "store-88",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5fe2HAmpQjQRxqtbBAvTSCs",
    "lat": 25.0434704,
    "lng": 121.5058748,
    "placeId": "ChIJ5fe2HAmpQjQRxqtbBAvTSCs",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2312 1581",
    "openingHours": [
      "Monday: 12:30 – 9:30 PM",
      "Tuesday: 12:30 – 9:30 PM",
      "Wednesday: 12:30 – 9:30 PM",
      "Thursday: 12:30 – 9:30 PM",
      "Friday: 12:30 – 9:30 PM",
      "Saturday: 12:30 – 9:30 PM",
      "Sunday: 12:30 – 9:30 PM"
    ],
    "rating": 2.9,
    "userRatingsTotal": 82,
    "id": 659,
    "district": "Ximending"
  },
  {
    "title": "恩恩玩機3C通訊行 專業維修 手機 電腦 平板買賣 資料轉移 世界各國旅遊卡 無卡分期",
    "urlinform": "3c-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/yiyu3c",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF-hGMYSpQjQR3kpoQpezGQQ",
    "lat": 25.04514,
    "lng": 121.506455,
    "placeId": "ChIJF-hGMYSpQjQR3kpoQpezGQQ",
    "businessStatus": "OPERATIONAL",
    "phone": "0909 601 104",
    "openingHours": [
      "Monday: 1:00 – 10:30 PM",
      "Tuesday: 1:00 – 10:30 PM",
      "Wednesday: 1:00 – 10:30 PM",
      "Thursday: 1:00 – 10:30 PM",
      "Friday: 1:00 – 10:30 PM",
      "Saturday: 1:00 – 10:30 PM",
      "Sunday: 1:00 – 10:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 51,
    "id": 660,
    "district": "Ximending"
  },
  {
    "title": "烏龍院藝術館",
    "urlinform": "store-90",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/pages/%E8%A5%BF%E9%96%80%E7%94%BA%E7%83%8F%E9%BE%8D%E9%99%A2/195635780531031",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJa_f5SQmpQjQRjk_zYnGV2vg",
    "lat": 25.0448008,
    "lng": 121.5070633,
    "placeId": "ChIJa_f5SQmpQjQRjk_zYnGV2vg",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2388 2919",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 127,
    "id": 661,
    "district": "Ximending"
  },
  {
    "title": "台灣姓名貼紙&連續印章專賣店西門町-Name Sticker",
    "urlinform": "-name-sticker",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/me1314168f/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJlZcRSAmpQjQR6bpkS0oGLvI",
    "lat": 25.0441531,
    "lng": 121.5070938,
    "placeId": "ChIJlZcRSAmpQjQR6bpkS0oGLvI",
    "businessStatus": "OPERATIONAL",
    "phone": "0982 858 156",
    "openingHours": [
      "Monday: 12:30 – 9:30 PM",
      "Tuesday: 12:30 – 9:30 PM",
      "Wednesday: 12:30 – 9:30 PM",
      "Thursday: 12:30 – 9:30 PM",
      "Friday: 12:30 – 10:00 PM",
      "Saturday: 12:30 – 10:00 PM",
      "Sunday: 12:30 – 9:30 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 155,
    "id": 662,
    "district": "Ximending"
  },
  {
    "title": "浩克電通3C",
    "urlinform": "3c-iphone17-iphone-ipad-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lin.ee/7Pjxj1f",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgRr5DP-pQjQRHZbqGrhKjGs",
    "lat": 25.0456905,
    "lng": 121.5064063,
    "placeId": "ChIJgRr5DP-pQjQRHZbqGrhKjGs",
    "businessStatus": "OPERATIONAL",
    "phone": "0908 640 079",
    "openingHours": [
      "Monday: 12:30 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 12:30 – 10:00 PM",
      "Thursday: 12:30 – 10:00 PM",
      "Friday: 12:30 – 10:00 PM",
      "Saturday: 12:30 – 10:00 PM",
      "Sunday: 12:30 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 568,
    "id": 663,
    "district": "Ximending"
  },
  {
    "title": "CAHO 卡好屋｜台北客製化印T恤急件專門店",
    "urlinform": "caho-t",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.caho.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUw3g7gipQjQRByyIIMHXrNk",
    "lat": 25.043965,
    "lng": 121.504698,
    "placeId": "ChIJUw3g7gipQjQRByyIIMHXrNk",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2388 2560",
    "openingHours": [
      "Monday: 10:00 AM – 6:30 PM",
      "Tuesday: 10:00 AM – 6:30 PM",
      "Wednesday: 10:00 AM – 6:30 PM",
      "Thursday: 10:00 AM – 6:30 PM",
      "Friday: 10:00 AM – 6:30 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 440,
    "id": 664,
    "district": "Ximending"
  },
  {
    "title": "Ks卡司3C彤彤手機店",
    "urlinform": "ks3c",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/one999168",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnWfMTwqpQjQR81D6AQCBXD8",
    "lat": 25.0453512,
    "lng": 121.5063617,
    "placeId": "ChIJnWfMTwqpQjQR81D6AQCBXD8",
    "businessStatus": "OPERATIONAL",
    "phone": "0971 652 622",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 201,
    "id": 665,
    "district": "Ximending"
  },
  {
    "title": "上帝骰桌遊",
    "urlinform": "store-96",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.god-dice.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRcwBOpepQjQRMyDBkXOg-vw",
    "lat": 25.0457064,
    "lng": 121.5050514,
    "placeId": "ChIJRcwBOpepQjQRMyDBkXOg-vw",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2632 4269",
    "openingHours": [
      "Monday: 2:00 PM – 3:00 AM",
      "Tuesday: 2:00 PM – 3:00 AM",
      "Wednesday: 2:00 PM – 3:00 AM",
      "Thursday: 2:00 PM – 3:00 AM",
      "Friday: 2:00 PM – 3:00 AM",
      "Saturday: 12:00 PM – 3:00 AM",
      "Sunday: 12:00 PM – 3:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 3465,
    "id": 666,
    "district": "Ximending"
  },
  {
    "title": "普雷伊西門概念店",
    "urlinform": "store-97",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.ruten.com.tw/class/store_list.php?s=i-tvgame",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsyC8HAmpQjQRJhaM2lCAO80",
    "lat": 25.0435135,
    "lng": 121.5058942,
    "placeId": "ChIJsyC8HAmpQjQRJhaM2lCAO80",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2375 4942",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 11:30 AM – 10:00 PM",
      "Wednesday: 11:30 AM – 10:00 PM",
      "Thursday: 11:30 AM – 10:00 PM",
      "Friday: 11:30 AM – 10:00 PM",
      "Saturday: 11:30 AM – 10:00 PM",
      "Sunday: 11:30 AM – 10:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 165,
    "id": 667,
    "district": "Ximending"
  },
  {
    "title": "萬年馬如龍 佳和模型玩具",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/%E8%90%AC%E5%B9%B4%E9%A6%AC%E5%A6%82%E9%BE%8D-%E4%BD%B3%E5%92%8C%E6%A8%A1%E5%9E%8B%E7%8E%A9%E5%85%B7-131080510394814/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsyC8HAmpQjQRh8vM-tTfeJQ",
    "lat": 25.0435422,
    "lng": 121.5058794,
    "placeId": "ChIJsyC8HAmpQjQRh8vM-tTfeJQ",
    "businessStatus": "OPERATIONAL",
    "phone": "0961 518 580",
    "openingHours": [
      "Monday: 1:00 – 9:41 PM",
      "Tuesday: 1:00 – 9:41 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 9:41 PM",
      "Friday: 1:00 – 9:41 PM",
      "Saturday: 1:00 – 9:41 PM",
      "Sunday: 1:00 – 9:41 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 156,
    "id": 668,
    "district": "Ximending"
  },
  {
    "title": "法蘭德Friends 卡牌桌遊",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/CatFootPrintShilin.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEWc3uJOuQjQRHIAZJowRUUo",
    "lat": 25.0912946,
    "lng": 121.5247564,
    "placeId": "ChIJEWc3uJOuQjQRHIAZJowRUUo",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2883 5322",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 197,
    "id": 669
  },
  {
    "title": "Eslite Bookstore Ximen Store",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://meet.eslite.com/tw/tc/store/20180220015",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7V214wipQjQRid9xlDhmOa8",
    "lat": 25.0437117,
    "lng": 121.5053975,
    "placeId": "ChIJ7V214wipQjQRid9xlDhmOa8",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2388 6588",
    "openingHours": [
      "Monday: 11:30 AM – 10:00 PM",
      "Tuesday: 11:30 AM – 10:00 PM",
      "Wednesday: 11:30 AM – 10:00 PM",
      "Thursday: 11:30 AM – 10:00 PM",
      "Friday: 11:30 AM – 10:00 PM",
      "Saturday: 11:30 AM – 10:00 PM",
      "Sunday: 11:30 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 2567,
    "id": 670,
    "district": "Ximending"
  },
  {
    "title": "貳柒一番屋—萬年店（一番賞/GK雕像/卡牌）",
    "urlinform": "gk",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/27_ichibanhouse?igsh=MWFoZ2tpM2t1dTAyaA==&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJndbFJY2pQjQRJczGVAD0AWg",
    "lat": 25.043364,
    "lng": 121.5059182,
    "placeId": "ChIJndbFJY2pQjQRJczGVAD0AWg",
    "businessStatus": "OPERATIONAL",
    "phone": "0930 939 488",
    "openingHours": [],
    "rating": 4.6,
    "userRatingsTotal": 21,
    "id": 671,
    "district": "Ximending"
  },
  {
    "title": "咖波屋Capoo House（台北西門店Taipei）",
    "urlinform": "capoo-housetaipei",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.carterislandtw.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAQt1AgCpQjQRt72e07EaiCQ",
    "lat": 25.0439942,
    "lng": 121.5045391,
    "placeId": "ChIJAQt1AgCpQjQRt72e07EaiCQ",
    "businessStatus": "OPERATIONAL",
    "phone": "0965 705 077",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 295,
    "id": 672,
    "district": "Ximending"
  },
  {
    "title": "SUGOI潮流專賣店",
    "urlinform": "sugoi",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpwt93g6pQjQR043xLglsWYg",
    "lat": 25.0465881,
    "lng": 121.5059183,
    "placeId": "ChIJpwt93g6pQjQR043xLglsWYg",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2388 7776",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 110,
    "id": 673,
    "district": "Ximending"
  },
  {
    "title": "西門-小心機桌遊",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/cunningg_ximen?igsh=MXRieXAxbG1oNjVy",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD4aTyrypQjQRtM2dgjHbDyA",
    "lat": 25.0421819,
    "lng": 121.505585,
    "placeId": "ChIJD4aTyrypQjQRtM2dgjHbDyA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 7751 5137",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:30 PM",
      "Sunday: 2:00 – 10:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 278,
    "id": 674,
    "district": "Ximending"
  },
  {
    "title": "貳家桌遊台北西門店-優惠預約LINE @218ajoas",
    "urlinform": "-line-218ajoas",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.oursecondhome12.com/product-category/%E8%B2%B3%E5%AE%B6%E6%A1%8C%E9%81%8A%E8%A5%BF%E9%96%80%E5%BA%97/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBarfBYqrQjQRIf15QieOC1Y",
    "lat": 25.041532,
    "lng": 121.50553,
    "placeId": "ChIJBarfBYqrQjQRIf15QieOC1Y",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 35,
    "id": 675,
    "district": "Ximending"
  },
  {
    "title": "小船故事館Ｉ桌遊咖啡廳（桌遊教學、獨立包廂、辦公空間）",
    "urlinform": "store-106",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://paperboat-storyhouse.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF7lrSvypQjQRsMaVPJ1hw1M",
    "lat": 25.0407381,
    "lng": 121.5066444,
    "placeId": "ChIJF7lrSvypQjQRsMaVPJ1hw1M",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2331 0566",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3320,
    "id": 676,
    "district": "Ximending"
  },
  {
    "title": "原紹(遊戲王) Vangard Card",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNb1Wio2rQjQR2hFNjJXnlEQ",
    "lat": 25.0582568,
    "lng": 121.5638494,
    "placeId": "ChIJNb1Wio2rQjQR2hFNjJXnlEQ",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2762 7240",
    "openingHours": [
      "Monday: 1:30 – 10:00 PM",
      "Tuesday: 1:30 – 10:00 PM",
      "Wednesday: 1:30 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 1:30 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 72,
    "id": 677
  },
  {
    "title": "精靈寶鑽戰棋遊戲專賣店",
    "urlinform": "store-108",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/ElfsDiamond",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJayFT2ZGpQjQROSa92F_uWKA",
    "lat": 25.0462868,
    "lng": 121.5501525,
    "placeId": "ChIJayFT2ZGpQjQROSa92F_uWKA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2515 8950",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 243,
    "id": 678
  },
  {
    "title": "牌牌戰 TCG專賣",
    "urlinform": "-tcg",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/%E7%89%8C%E7%89%8C%E6%88%B0-1911800715727165/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJa-AC8Bk9aTQRzcoob_HKrcg",
    "lat": 24.1463534,
    "lng": 120.6761363,
    "placeId": "ChIJa-AC8Bk9aTQRzcoob_HKrcg",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2224 7650",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 342,
    "id": 679,
    "district": "Taichung"
  },
  {
    "title": "芃芃玩具",
    "urlinform": "store-111",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ruten.com.tw/user/index00.php?s=wang99999990",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc-hIlWypQjQRuojwYYuErX0",
    "lat": 25.0524295,
    "lng": 121.5156513,
    "placeId": "ChIJc-hIlWypQjQRuojwYYuErX0",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2556 5505",
    "openingHours": [
      "Monday: 11:20 AM – 8:40 PM",
      "Tuesday: 11:20 AM – 8:40 PM",
      "Wednesday: 11:20 AM – 8:40 PM",
      "Thursday: 11:20 AM – 8:40 PM",
      "Friday: 11:20 AM – 8:40 PM",
      "Saturday: 11:20 AM – 8:40 PM",
      "Sunday: 11:20 AM – 8:40 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 902,
    "id": 680,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "卡士多遊戲屋",
    "urlinform": "store-112",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://reurl.cc/2gM28X",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0ygfoCipQjQRRk34jF7iIoE",
    "lat": 25.0645897,
    "lng": 121.518066,
    "placeId": "ChIJ0ygfoCipQjQRRk34jF7iIoE",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2595 5055",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 4:30 – 10:00 PM",
      "Thursday: 4:30 – 10:00 PM",
      "Friday: 4:30 – 10:00 PM",
      "Saturday: 2:30 – 10:00 PM",
      "Sunday: 2:30 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 51,
    "id": 681
  },
  {
    "title": "鬥樂 一中店 | Dou Le Trading Card Games",
    "urlinform": "-dou-le-trading-card-games",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Flesh and Blood",
      "Lorcana",
      "MTG",
      "One Piece",
      "Union Arena"
    ],
    "storeWebsite": "https://www.douletcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqQhdZHM9aTQRjH9P6y1QyGQ",
    "lat": 24.148663,
    "lng": 120.6856027,
    "placeId": "ChIJqQhdZHM9aTQRjH9P6y1QyGQ",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2221 6875",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 176,
    "id": 682,
    "district": "Taichung Yizhong"
  },
  {
    "title": "Funbox Toys-忠孝SOGO",
    "urlinform": "funbox-toys-sogo",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/funboxsogo",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD4s_wVqrQjQRoV_ghZ-6VrE",
    "lat": 25.0419311,
    "lng": 121.5446558,
    "placeId": "ChIJD4s_wVqrQjQRoV_ghZ-6VrE",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2752 4111",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 29,
    "id": 683
  },
  {
    "title": "Words",
    "urlinform": "store-118",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.words.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJk_5At_KrQjQRD0FvyC451og",
    "lat": 25.060451,
    "lng": 121.559133,
    "placeId": "ChIJk_5At_KrQjQRD0FvyC451og",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2528 0003",
    "openingHours": [
      "Monday: 3:30 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 3:30 – 8:00 PM",
      "Friday: 3:30 – 8:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 360,
    "id": 684
  },
  {
    "title": "SCC玩具屋《GK模型｜無展示》",
    "urlinform": "sccgk",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.scctoys.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY4oFaYmpQjQRlIhERwOpIt4",
    "lat": 25.0523798,
    "lng": 121.4896819,
    "placeId": "ChIJY4oFaYmpQjQRlIhERwOpIt4",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2974 8408",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 709,
    "id": 685
  },
  {
    "title": "One Paper Institute （僅預約制）",
    "urlinform": "one-paper-institute-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://onepaper.cards/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsdz-25Y9aTQRn3OWrg19adw",
    "lat": 24.1543729,
    "lng": 120.6608165,
    "placeId": "ChIJsdz-25Y9aTQRn3OWrg19adw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 16,
    "id": 686,
    "district": "Taichung"
  },
  {
    "title": "元氣滿屋 (主要經營:寶可夢PTCG/航海王TCG/UNION ARENA)",
    "urlinform": "-ptcgtcgunion-arena",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Union Arena"
    ],
    "storeWebsite": "https://www.facebook.com/%E5%85%83%E6%B0%A3%E6%BB%BF%E5%B1%8B-%E5%B0%88%E5%94%AE%E5%8F%B0%E6%97%A5%E7%89%88%E9%81%8A%E6%88%B2%E5%8D%A1%E7%89%87-100543221732343/?modal=admin_todo_tour",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-5kTU4upQjQRlcDZa6Emt2Q",
    "lat": 25.0219409,
    "lng": 121.46276,
    "placeId": "ChIJ-5kTU4upQjQRlcDZa6Emt2Q",
    "businessStatus": "OPERATIONAL",
    "phone": "0908 066 086",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 115,
    "id": 687
  },
  {
    "title": "玩具魔法堂",
    "urlinform": "store-122",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://toymahodo.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJeZnrWHI9aTQRmcHCrIDrblU",
    "lat": 24.1457167,
    "lng": 120.6756071,
    "placeId": "ChIJeZnrWHI9aTQRmcHCrIDrblU",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2227 5362",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 99,
    "id": 688,
    "district": "Taichung"
  },
  {
    "title": "電玩戰場",
    "urlinform": "store-126",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/gamebattlefield.gb.fb",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJ31QAkipQjQRJS0bYM423Fs",
    "lat": 25.0450357,
    "lng": 121.5319312,
    "placeId": "ChIJJ31QAkipQjQRJS0bYM423Fs",
    "businessStatus": "OPERATIONAL",
    "phone": "0908 087 983",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 459,
    "id": 689
  },
  {
    "title": "玩具有毒addictedtoys2020 台北中山店",
    "urlinform": "addictedtoys2020-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Gundam"
    ],
    "storeWebsite": "https://www.addictedtoys2020.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrXbSL--pQjQRmoiIaFgR-48",
    "lat": 25.066619,
    "lng": 121.5247622,
    "placeId": "ChIJrXbSL--pQjQRmoiIaFgR-48",
    "businessStatus": "OPERATIONAL",
    "phone": "0981 797 166",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1684,
    "id": 690
  },
  {
    "title": "台中黑殿 |集換式卡牌 |卡片專賣店| 台中 卡店 |TCG|扭蛋|遊戲王|寶可夢|數碼寶貝|先導者|海賊王",
    "urlinform": "-tcg",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/BTS-%E9%BB%91%E6%AE%BF-822638444603588/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDb1mOBY9aTQR704zI7BWjX0",
    "lat": 24.1606524,
    "lng": 120.6773436,
    "placeId": "ChIJDb1mOBY9aTQR704zI7BWjX0",
    "businessStatus": "OPERATIONAL",
    "phone": "0988 056 964",
    "openingHours": [
      "Monday: 2:00 – 7:00 PM",
      "Tuesday: 2:00 – 7:00 PM",
      "Wednesday: 2:00 – 7:00 PM",
      "Thursday: 2:00 – 7:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 55,
    "id": 691,
    "district": "Taichung"
  },
  {
    "title": "ALG－Academy Legacy Games集換式卡片專門店｜魔法風雲會｜寶可夢卡牌｜集換式紙牌｜MITQ系列賽｜MTGA｜PTCG｜JMP｜FAB｜DMU｜台北卡牌桌遊店 推薦",
    "urlinform": "algacademy-legacy-gamesmitqmtgaptcgjmpfabdmu-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Flesh and Blood"
    ],
    "storeWebsite": "https://www.facebook.com/ALGTW/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJL1jzlbirQjQRdTlCPByzQfM",
    "lat": 25.054424,
    "lng": 121.542664,
    "placeId": "ChIJL1jzlbirQjQRdTlCPByzQfM",
    "businessStatus": "OPERATIONAL",
    "phone": "0933 098 866",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 222,
    "id": 692
  },
  {
    "title": "兔坦卡門桌遊館（歡迎用IG/LINE或致電預約）",
    "urlinform": "igline",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://shop1688.com.tw/aom20211126013/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEWSBlx49aTQRU_enNqHQVW4",
    "lat": 24.1504741,
    "lng": 120.6683058,
    "placeId": "ChIJEWSBlx49aTQRU_enNqHQVW4",
    "businessStatus": "OPERATIONAL",
    "phone": "0979 604 128",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 192,
    "id": 693,
    "district": "Taichung"
  },
  {
    "title": "貓局棋牌麻將桌遊（台中、人氣評價貓咪陪伴桌遊店）KTV麻將包廂－西區桌遊租借|麻將會館|麻將館首選|桌遊店推薦|熱門麻將館|桌遊教學|電動麻將館|健康娛樂",
    "urlinform": "ktv",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCR54Njg9aTQRJ-uXPxpUK7A",
    "lat": 24.1483933,
    "lng": 120.6731085,
    "placeId": "ChIJCR54Njg9aTQRJ-uXPxpUK7A",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2323 0050",
    "openingHours": [
      "Monday: 4:00 PM – 4:00 AM",
      "Tuesday: 4:00 PM – 4:00 AM",
      "Wednesday: 4:00 PM – 4:00 AM",
      "Thursday: 3:30 PM – 12:00 AM",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 103,
    "id": 694,
    "district": "Taichung"
  },
  {
    "title": "ONE桌遊 台北汀州店 I 24H自助包廂",
    "urlinform": "one-i-24h",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://one.onegame.tw/#/pages/shop_details/shop_details?id=166",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaR203SGpQjQRamuFqJNeco8",
    "lat": 25.0271917,
    "lng": 121.5104585,
    "placeId": "ChIJaR203SGpQjQRamuFqJNeco8",
    "businessStatus": "OPERATIONAL",
    "phone": "0930 908 448",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 84,
    "id": 695
  },
  {
    "title": "遊聚棋牌桌遊店（博館麻將館） 台中人氣平價桌遊店 交流與教學的好地方-北區桌遊租借|麻將會館|麻將館首選|桌遊店推薦|熱門麻將館|桌遊教學|電動麻將館|健康娛樂",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/mahj.ong717?igsh=ejY5dmt1ejVod2No",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDa1hsEU9aTQR32wT-Z6PcB0",
    "lat": 24.1534737,
    "lng": 120.6670151,
    "placeId": "ChIJDa1hsEU9aTQR32wT-Z6PcB0",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2323 0050",
    "openingHours": [
      "Monday: 2:00 PM – 8:00 AM",
      "Tuesday: 2:00 PM – 8:00 AM",
      "Wednesday: 2:00 PM – 8:00 AM",
      "Thursday: 2:00 PM – 8:00 AM",
      "Friday: 2:00 PM – 8:30 AM",
      "Saturday: 2:00 PM – 8:00 AM",
      "Sunday: 2:00 PM – 8:00 AM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 83,
    "id": 696,
    "district": "Taichung"
  },
  {
    "title": "阿卡姆圖書館主題桌遊店－桌上遊戲｜遊戲空間｜派對空間出租｜活動場地出租｜近台中科博館｜勤美",
    "urlinform": "store-142",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/ArkhamLibraryBG/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJARTP5JQ9aTQRoOHLwfm7efQ",
    "lat": 24.1542513,
    "lng": 120.6667256,
    "placeId": "ChIJARTP5JQ9aTQRoOHLwfm7efQ",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2321 4309",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 249,
    "id": 697,
    "district": "Taichung"
  },
  {
    "title": "BGL",
    "urlinform": "bgl",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJETcRqm09aTQRyB4dwywmDZU",
    "lat": 24.1446907,
    "lng": 120.6798804,
    "placeId": "ChIJETcRqm09aTQRyB4dwywmDZU",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2225 0952",
    "openingHours": [
      "Monday: 1:30 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:30 – 10:00 PM",
      "Thursday: 1:30 – 10:00 PM",
      "Friday: 1:30 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 894,
    "id": 698,
    "district": "Taichung Yizhong"
  },
  {
    "title": "SeeChillSoul 嘻憩所聚會空間",
    "urlinform": "seechillsoul-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.seechillsoul.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPei82UU9aTQR5EuVO3MXp3E",
    "lat": 24.1519164,
    "lng": 120.667554,
    "placeId": "ChIJPei82UU9aTQR5EuVO3MXp3E",
    "businessStatus": "OPERATIONAL",
    "phone": "0971 703 379",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 502,
    "id": 699,
    "district": "Taichung"
  },
  {
    "title": "貳家桌遊台中科博館店(優惠預約加line @218ajoas)",
    "urlinform": "line-218ajoas",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.oursecondhome12.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxxw3DxI9aTQRH1doffwhysk",
    "lat": 24.1540693,
    "lng": 120.6647047,
    "placeId": "ChIJxxw3DxI9aTQRH1doffwhysk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 8:00 AM – 7:00 PM",
      "Tuesday: 8:00 AM – 7:00 PM",
      "Wednesday: 8:00 AM – 7:00 PM",
      "Thursday: 8:00 AM – 7:00 PM",
      "Friday: 8:00 AM – 7:00 PM",
      "Saturday: 8:00 AM – 7:00 PM",
      "Sunday: 8:00 AM – 7:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 6,
    "id": 700,
    "district": "Taichung"
  },
  {
    "title": "Card Nyang",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "Flesh and Blood"
    ],
    "storeWebsite": "https://cardnyang.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8Qri2lyhfDURi5HBW5a_oNg",
    "lat": 37.4967915,
    "lng": 127.037714,
    "placeId": "ChIJ8Qri2lyhfDURi5HBW5a_oNg",
    "businessStatus": "OPERATIONAL",
    "phone": "02-568-3778",
    "openingHours": [
      "Monday: 3:00 – 10:30 PM",
      "Tuesday: 3:00 – 10:30 PM",
      "Wednesday: 3:00 – 10:30 PM",
      "Thursday: 3:00 – 10:30 PM",
      "Friday: 3:00 – 10:30 PM",
      "Saturday: 1:00 – 10:30 PM",
      "Sunday: 1:00 – 10:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 62,
    "id": 701,
    "district": "Gangnam"
  },
  {
    "title": "카드하비 Cardhobby",
    "urlinform": "-cardhobby",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://smartstore.naver.com/cardhobby",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJU8F0hWClfDURGUT_SxIot3o",
    "lat": 37.5059521,
    "lng": 127.0579187,
    "placeId": "ChIJU8F0hWClfDURGUT_SxIot3o",
    "businessStatus": "OPERATIONAL",
    "phone": "02-3452-0120",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 83,
    "id": 702
  },
  {
    "title": "Pokemon Card Shop",
    "urlinform": "pokemon-card-shop",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://pokemoncenter.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD-TTJwCjfDURK5vgmnrtccs",
    "lat": 37.529398,
    "lng": 126.9654523,
    "placeId": "ChIJD-TTJwCjfDURK5vgmnrtccs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Open 24 hours",
      "Saturday: Closed",
      "Sunday: Open 24 hours"
    ],
    "rating": 2.1,
    "userRatingsTotal": 58,
    "id": 703,
    "district": "Kukje Electronics Center"
  },
  {
    "title": "Dogok Dual Shop",
    "urlinform": "store-5",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNdEsSLKmfDURgBw9HtvUIJI",
    "lat": 37.4851248,
    "lng": 127.0440291,
    "placeId": "ChIJNdEsSLKmfDURgBw9HtvUIJI",
    "businessStatus": "OPERATIONAL",
    "phone": "02-574-6086",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 62,
    "id": 704
  },
  {
    "title": "HOBBY KOREA",
    "urlinform": "-hobby-korea",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.hobbykorea.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPZyZkqyhfDURfWAVb9t-F4w",
    "lat": 37.5022359,
    "lng": 127.0242722,
    "placeId": "ChIJPZyZkqyhfDURfWAVb9t-F4w",
    "businessStatus": "OPERATIONAL",
    "phone": "02-6368-1120",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 59,
    "id": 705,
    "district": "Gangnam"
  },
  {
    "title": "Card Kingdom",
    "urlinform": "card-kingdom",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiZhLKp2YfDURHsVqrVmLPr8",
    "lat": 37.5570246,
    "lng": 126.9539695,
    "placeId": "ChIJiZhLKp2YfDURHsVqrVmLPr8",
    "businessStatus": "OPERATIONAL",
    "phone": "02-365-6279",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 145,
    "id": 706
  },
  {
    "title": "Rolling Dice",
    "urlinform": "store-8",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.mtgrollingdice.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJseT_x8KYfDURamho37y6Lqo",
    "lat": 37.557656,
    "lng": 126.9225209,
    "placeId": "ChIJseT_x8KYfDURamho37y6Lqo",
    "businessStatus": "OPERATIONAL",
    "phone": "02-323-7455",
    "openingHours": [
      "Monday: 3:00 – 10:30 PM",
      "Tuesday: 3:00 – 10:30 PM",
      "Wednesday: 3:00 – 10:30 PM",
      "Thursday: 3:00 – 10:30 PM",
      "Friday: 3:00 – 10:30 PM",
      "Saturday: 2:00 – 10:30 PM",
      "Sunday: 2:00 – 10:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 163,
    "id": 707,
    "district": "Hongdae"
  },
  {
    "title": "포카드 스포츠카드 (Four Card Sports Store)",
    "urlinform": "-four-card-sports-store",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://4cards.net/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF5vMX6OjfDURmzS-DpWuJLg",
    "lat": 37.5227814,
    "lng": 127.0217505,
    "placeId": "ChIJF5vMX6OjfDURmzS-DpWuJLg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:30 – 9:00 PM",
      "Tuesday: 1:30 – 9:00 PM",
      "Wednesday: 1:30 – 9:00 PM",
      "Thursday: 1:30 – 9:00 PM",
      "Friday: 1:30 – 9:00 PM",
      "Saturday: 1:30 – 9:00 PM",
      "Sunday: 1:30 – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 11,
    "id": 708
  },
  {
    "title": "카드 스퀘어",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJeZg5ih2jfDURvRfJhu3C3nA",
    "lat": 37.5633995,
    "lng": 127.0189676,
    "placeId": "ChIJeZg5ih2jfDURvRfJhu3C3nA",
    "businessStatus": "OPERATIONAL",
    "phone": "02-6015-5689",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 83,
    "id": 709
  },
  {
    "title": "Collecto TCG",
    "urlinform": "collecto-tcg",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://collectotcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ65GuHAGZfDURVmuQSL0v11I",
    "lat": 37.5914129,
    "lng": 126.9471499,
    "placeId": "ChIJ65GuHAGZfDURVmuQSL0v11I",
    "businessStatus": "OPERATIONAL",
    "phone": "010-7522-2379",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 70,
    "id": 710
  },
  {
    "title": "TCG labo",
    "urlinform": "tcg-labo",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.youtube.com/channel/UC1KKG_05Yb1uQztlBt6NEFg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPxjhrEOZfDUR3RSX4bb3rd8",
    "lat": 37.5914186,
    "lng": 126.9151403,
    "placeId": "ChIJPxjhrEOZfDUR3RSX4bb3rd8",
    "businessStatus": "OPERATIONAL",
    "phone": "010-7751-1067",
    "openingHours": [
      "Monday: 1:30 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:30 – 8:00 PM",
      "Thursday: 1:30 – 8:00 PM",
      "Friday: 1:30 – 8:00 PM",
      "Saturday: 12:30 – 9:00 PM",
      "Sunday: 12:30 – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 22,
    "id": 711
  },
  {
    "title": "역삼 토너먼트센터",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "Flesh and Blood"
    ],
    "storeWebsite": "http://cardnyang.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJafHdEwCjfDURs2wrXXyqGeQ",
    "lat": 37.4968042,
    "lng": 127.0377311,
    "placeId": "ChIJafHdEwCjfDURs2wrXXyqGeQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 10:30 PM",
      "Tuesday: 3:00 – 10:30 PM",
      "Wednesday: 3:00 – 10:30 PM",
      "Thursday: 3:00 – 10:30 PM",
      "Friday: 3:00 – 10:30 PM",
      "Saturday: 1:00 – 10:30 PM",
      "Sunday: 1:00 – 10:30 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 712,
    "district": "Gangnam"
  },
  {
    "title": "미카엘 TCG Shop",
    "urlinform": "-tcg-shop",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgV3QkjulfDURhxE-FKCS-TE",
    "lat": 37.5353347,
    "lng": 127.0921941,
    "placeId": "ChIJgV3QkjulfDURhxE-FKCS-TE",
    "businessStatus": "OPERATIONAL",
    "phone": "02-447-6279",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 12,
    "id": 713
  },
  {
    "title": "Dyueoljon",
    "urlinform": "store-17",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://duelzone.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKYpGjhW5fDURt5nKI2EdhwI",
    "lat": 37.6587315,
    "lng": 127.0620696,
    "placeId": "ChIJKYpGjhW5fDURt5nKI2EdhwI",
    "businessStatus": "OPERATIONAL",
    "phone": "02-939-6625",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 21,
    "id": 714
  },
  {
    "title": "Universe Gacha",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://wouldyougacha.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMyFGb-KjfDURaFXSRccPJEs",
    "lat": 37.5036062,
    "lng": 127.0258921,
    "placeId": "ChIJMyFGb-KjfDURaFXSRccPJEs",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71363-9825",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 185,
    "id": 715,
    "district": "Gangnam"
  },
  {
    "title": "Game Woori",
    "urlinform": "store-20",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.gamewoori.com/m/index.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUfhjmxWhfDUR1vdkyqCeWKM",
    "lat": 37.4847094,
    "lng": 127.0177836,
    "placeId": "ChIJUfhjmxWhfDUR1vdkyqCeWKM",
    "businessStatus": "OPERATIONAL",
    "phone": "02-3465-0048",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.4,
    "userRatingsTotal": 1084,
    "id": 716
  },
  {
    "title": "Strike Pang",
    "urlinform": "strike-pang",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRUGaQ5SYfDURTnU4pE7AUXk",
    "lat": 37.5571148,
    "lng": 126.9362198,
    "placeId": "ChIJRUGaQ5SYfDURTnU4pE7AUXk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 4.2,
    "userRatingsTotal": 27,
    "id": 717,
    "district": "Sinchon"
  },
  {
    "title": "TT GAME",
    "urlinform": "store-23",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://ttgame.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ1As_gSifDURo9qm3VAXS60",
    "lat": 37.5328161,
    "lng": 126.9594833,
    "placeId": "ChIJZ1As_gSifDURo9qm3VAXS60",
    "businessStatus": "OPERATIONAL",
    "phone": "010-2665-3814",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.4,
    "userRatingsTotal": 11,
    "id": 718,
    "district": "Yongsan"
  },
  {
    "title": "Starfield Coex Mall",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.starfield.co.kr/coexmall/main.do",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIRVdC6pFezUR02aa2I7i57A",
    "lat": 37.5118346,
    "lng": 127.0597871,
    "placeId": "ChIJIRVdC6pFezUR02aa2I7i57A",
    "businessStatus": "OPERATIONAL",
    "phone": "02-6002-5300",
    "openingHours": [
      "Monday: 10:30 AM – 10:00 PM",
      "Tuesday: 10:30 AM – 10:00 PM",
      "Wednesday: 10:30 AM – 10:00 PM",
      "Thursday: 10:30 AM – 10:00 PM",
      "Friday: 10:30 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 24796,
    "id": 719
  },
  {
    "title": "Ktown4u Coex",
    "urlinform": "ktown4u-coex",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ktown4u.com/stores",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD1OxhWWlfDUR4GTCcRuGvpE",
    "lat": 37.5100538,
    "lng": 127.061476,
    "placeId": "ChIJD1OxhWWlfDUR4GTCcRuGvpE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 594,
    "id": 720
  },
  {
    "title": "Kyobo Book Centre Gangnam",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.kyobobook.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQ00IAeKjfDURmbV1IAjPOJ0",
    "lat": 37.50377539999999,
    "lng": 127.0240711,
    "placeId": "ChIJQ00IAeKjfDURmbV1IAjPOJ0",
    "businessStatus": "OPERATIONAL",
    "phone": "1544-1900",
    "openingHours": [
      "Monday: 9:30 AM – 10:00 PM",
      "Tuesday: 9:30 AM – 10:00 PM",
      "Wednesday: 9:30 AM – 10:00 PM",
      "Thursday: 9:30 AM – 10:00 PM",
      "Friday: 9:30 AM – 10:00 PM",
      "Saturday: 9:30 AM – 10:00 PM",
      "Sunday: 9:30 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 14397,
    "id": 721,
    "district": "Gangnam"
  },
  {
    "title": "와이제이럭스 강남본점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://smartstore.naver.com/wiclist",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuSb6yDSjfDURvctGMOPJi2E",
    "lat": 37.5273802,
    "lng": 127.038364,
    "placeId": "ChIJuSb6yDSjfDURvctGMOPJi2E",
    "businessStatus": "OPERATIONAL",
    "phone": "02-3443-1231",
    "openingHours": [
      "Monday: 12:30 – 7:00 PM",
      "Tuesday: 12:30 – 7:00 PM",
      "Wednesday: 12:30 – 7:00 PM",
      "Thursday: 12:30 – 7:00 PM",
      "Friday: 12:30 – 7:00 PM",
      "Saturday: 2:00 – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 94,
    "id": 722
  },
  {
    "title": "Dalmuti Gyodae",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linktr.ee/Dalmuti",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQZTs22ihfDUREbAEg7SCFQE",
    "lat": 37.4939509,
    "lng": 127.0177964,
    "placeId": "ChIJQZTs22ihfDUREbAEg7SCFQE",
    "businessStatus": "OPERATIONAL",
    "phone": "02-3478-5080",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.4,
    "userRatingsTotal": 98,
    "id": 723,
    "district": "Gangnam"
  },
  {
    "title": "카드랩 CARD LAB",
    "urlinform": "-card-lab",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/CardLabKR",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfx3DJAChfDURWPOEQPYbe38",
    "lat": 37.4772255,
    "lng": 126.9798469,
    "placeId": "ChIJfx3DJAChfDURWPOEQPYbe38",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71301-2379",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 2.6,
    "userRatingsTotal": 16,
    "id": 724
  },
  {
    "title": "MUJI Gangnam",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.muji.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx3p6VlihfDURPsjn2fxjyIc",
    "lat": 37.4997752,
    "lng": 127.0263109,
    "placeId": "ChIJx3p6VlihfDURPsjn2fxjyIc",
    "businessStatus": "OPERATIONAL",
    "phone": "02-6203-7046",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 945,
    "id": 725,
    "district": "Gangnam"
  },
  {
    "title": "포켓몬카드숍 아이파크몰점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE0eORQCjfDUREEfJAfOSF3A",
    "lat": 37.5297133,
    "lng": 126.9647528,
    "placeId": "ChIJE0eORQCjfDUREEfJAfOSF3A",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3.9,
    "userRatingsTotal": 16,
    "id": 726,
    "district": "Kukje Electronics Center"
  },
  {
    "title": "Gundam Base Coex Mall",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "Gundam"
    ],
    "storeWebsite": "https://kr.gundam.info/sp/main.gun",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7f05cWqkfDURo0HOEyJ8mUI",
    "lat": 37.51157630000001,
    "lng": 127.06111,
    "placeId": "ChIJ7f05cWqkfDURo0HOEyJ8mUI",
    "businessStatus": "OPERATIONAL",
    "phone": "02-551-2805",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 227,
    "id": 727
  },
  {
    "title": "Artbox Gangnam",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.poom.co.kr/dispctg/initArtboxMain.action",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqbxPwCKhfDURA-eDLt9O41w",
    "lat": 37.5011057,
    "lng": 127.0271591,
    "placeId": "ChIJqbxPwCKhfDURA-eDLt9O41w",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71376-0789",
    "openingHours": [
      "Monday: 11:00 AM – 10:30 PM",
      "Tuesday: 11:00 AM – 10:30 PM",
      "Wednesday: 11:00 AM – 10:30 PM",
      "Thursday: 11:00 AM – 10:30 PM",
      "Friday: 11:00 AM – 10:30 PM",
      "Saturday: 11:00 AM – 10:30 PM",
      "Sunday: 11:00 AM – 10:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 179,
    "id": 728,
    "district": "Gangnam"
  },
  {
    "title": "Aladin Used Bookstore Gangnam",
    "urlinform": "-7",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://off.aladin.co.kr/usedstore/wgate.aspx",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZxa79FihfDURp5yhEwR4phU",
    "lat": 37.4967849,
    "lng": 127.0276423,
    "placeId": "ChIJZxa79FihfDURp5yhEwR4phU",
    "businessStatus": "OPERATIONAL",
    "phone": "1544-2514",
    "openingHours": [
      "Monday: 9:30 AM – 10:00 PM",
      "Tuesday: 9:30 AM – 10:00 PM",
      "Wednesday: 9:30 AM – 10:00 PM",
      "Thursday: 9:30 AM – 10:00 PM",
      "Friday: 9:30 AM – 10:00 PM",
      "Saturday: 9:30 AM – 10:00 PM",
      "Sunday: 9:30 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 3772,
    "id": 729,
    "district": "Gangnam"
  },
  {
    "title": "KPOP 앨범 및 굿즈 매장",
    "urlinform": "hallyustorm-kpop-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSa2aqdiZfDURygRcYPXURyE",
    "lat": 37.5520028,
    "lng": 126.9183617,
    "placeId": "ChIJSa2aqdiZfDURygRcYPXURyE",
    "businessStatus": "OPERATIONAL",
    "phone": "010-9288-3337",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 394,
    "id": 730,
    "district": "Hongdae"
  },
  {
    "title": "Figure Friends",
    "urlinform": "store-39",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://figurefriends.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4-MqsMSYfDURdbMlub1IS0w",
    "lat": 37.5566069,
    "lng": 126.9250454,
    "placeId": "ChIJ4-MqsMSYfDURdbMlub1IS0w",
    "businessStatus": "OPERATIONAL",
    "phone": "010-8223-7922",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 77,
    "id": 731,
    "district": "Hongdae"
  },
  {
    "title": "POCA SPOT Myeong-dong",
    "urlinform": "poca-spot-myeong-dong",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://pocaspot.com/myeongdong",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuXbaWa6jfDURi1SSQZAl794",
    "lat": 37.56118410000001,
    "lng": 126.9830623,
    "placeId": "ChIJuXbaWa6jfDURi1SSQZAl794",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 10:30 PM",
      "Tuesday: 10:30 AM – 10:30 PM",
      "Wednesday: 10:30 AM – 10:30 PM",
      "Thursday: 10:30 AM – 10:30 PM",
      "Friday: 10:30 AM – 10:30 PM",
      "Saturday: 10:30 AM – 10:30 PM",
      "Sunday: 10:30 AM – 10:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 446,
    "id": 732,
    "district": "Myeongdong"
  },
  {
    "title": "The Pollalla Toy Museum",
    "urlinform": "store-41",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_QlTl8GYfDURXLB59_SlXoU",
    "lat": 37.5550631,
    "lng": 126.928308,
    "placeId": "ChIJ_QlTl8GYfDURXLB59_SlXoU",
    "businessStatus": "OPERATIONAL",
    "phone": "02-3143-3392",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 128,
    "id": 733,
    "district": "Hongdae"
  },
  {
    "title": "DUCKY WORLD",
    "urlinform": "store-42",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.duckyworld.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqUb3MPaZfDURLa1yYopuE3U",
    "lat": 37.556163,
    "lng": 126.9270205,
    "placeId": "ChIJqUb3MPaZfDURLa1yYopuE3U",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 11:00 PM",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 44,
    "id": 734,
    "district": "Hongdae"
  },
  {
    "title": "Play ONE PIECE",
    "urlinform": "play-one-piece",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_1JpdkOZfDURphzsownGUcw",
    "lat": 37.557643,
    "lng": 126.926422,
    "placeId": "ChIJ_1JpdkOZfDURphzsownGUcw",
    "businessStatus": "OPERATIONAL",
    "phone": "02-322-2176",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 15,
    "id": 735,
    "district": "Hongdae"
  },
  {
    "title": "ANI PLAZA",
    "urlinform": "store-44",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.aniplaza.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB2jyQeWZfDURNpQ0vapvd6w",
    "lat": 37.5554267,
    "lng": 126.9273662,
    "placeId": "ChIJB2jyQeWZfDURNpQ0vapvd6w",
    "businessStatus": "OPERATIONAL",
    "phone": "070-4007-1999",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 39,
    "id": 736,
    "district": "Hongdae"
  },
  {
    "title": "OPPAcard",
    "urlinform": "store-45",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHcjwyNiZfDURxUnNiKFB0_w",
    "lat": 37.558111,
    "lng": 126.9257341,
    "placeId": "ChIJHcjwyNiZfDURxUnNiKFB0_w",
    "businessStatus": "OPERATIONAL",
    "phone": "010-7135-8812",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3,
    "userRatingsTotal": 2,
    "id": 737,
    "district": "Hongdae"
  },
  {
    "title": "One Figure",
    "urlinform": "one-figure",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://smartstore.naver.com/onefigure",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1SCBkbaZfDURhF9_deseC0U",
    "lat": 37.5551974,
    "lng": 126.9228966,
    "placeId": "ChIJ1SCBkbaZfDURhF9_deseC0U",
    "businessStatus": "OPERATIONAL",
    "phone": "010-3403-9856",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 3,
    "id": 738,
    "district": "Hongdae"
  },
  {
    "title": "Hongzzang | Gift Shop | souvenirs",
    "urlinform": "-hongdae-gift-shop-phone-case-tcg-shop-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://hongzzangshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTWH0EPeZfDURIpt9TJ09JiA",
    "lat": 37.55415139999999,
    "lng": 126.9223929,
    "placeId": "ChIJTWH0EPeZfDURIpt9TJ09JiA",
    "businessStatus": "OPERATIONAL",
    "phone": "010-2697-5916",
    "openingHours": [
      "Monday: 11:00 AM – 11:00 PM",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 10:40 AM – 11:00 PM",
      "Saturday: 10:40 AM – 11:00 PM",
      "Sunday: 10:40 AM – 11:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 138,
    "id": 739,
    "district": "Hongdae"
  },
  {
    "title": "포카스팟",
    "urlinform": "poca-spot-hong-dae",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://pocaspot.com/hongdae",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4U85q2yZfDUR4GzQS5eip50",
    "lat": 37.5559974,
    "lng": 126.9278006,
    "placeId": "ChIJ4U85q2yZfDUR4GzQS5eip50",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 729,
    "id": 740,
    "district": "Hongdae"
  },
  {
    "title": "K-POP SQUARE Hongdae",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linefriendssquare.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMab5ceCZfDURCM79FzMHgh8",
    "lat": 37.5555491,
    "lng": 126.9216216,
    "placeId": "ChIJMab5ceCZfDURCM79FzMHgh8",
    "businessStatus": "OPERATIONAL",
    "phone": "02-322-9631",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 1301,
    "id": 741,
    "district": "Hongdae"
  },
  {
    "title": "Hello Sumiko",
    "urlinform": "store-53",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://m.hellosumiko.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCegohs-YfDURebf7PKoLM2o",
    "lat": 37.5549457,
    "lng": 126.9191563,
    "placeId": "ChIJCegohs-YfDURebf7PKoLM2o",
    "businessStatus": "OPERATIONAL",
    "phone": "02-322-5622",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 61,
    "id": 742,
    "district": "Hongdae"
  },
  {
    "title": "AK PLAZA Hongdae",
    "urlinform": "ak-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.akplaza.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9avx9x2ZfDUREadm9Rtyl2A",
    "lat": 37.55782500000001,
    "lng": 126.9263745,
    "placeId": "ChIJ9avx9x2ZfDUREadm9Rtyl2A",
    "businessStatus": "OPERATIONAL",
    "phone": "02-789-9800",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 2384,
    "id": 743,
    "district": "Hongdae"
  },
  {
    "title": "Kinko's Hongdae Center",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.kinkos.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvzM4VtuYfDURWePmcvnO7UU",
    "lat": 37.5549134,
    "lng": 126.9206648,
    "placeId": "ChIJvzM4VtuYfDURWePmcvnO7UU",
    "businessStatus": "OPERATIONAL",
    "phone": "02-3141-9997",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.1,
    "userRatingsTotal": 83,
    "id": 744,
    "district": "Hongdae"
  },
  {
    "title": "Activemode-Hongdae",
    "urlinform": "activemode-hongdae",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjb7qSQqZfDURgKkBkh6kUGU",
    "lat": 37.5517298,
    "lng": 126.9209712,
    "placeId": "ChIJjb7qSQqZfDURgKkBkh6kUGU",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71368-4829",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 706,
    "id": 745,
    "district": "Hongdae"
  },
  {
    "title": "카드킹덤 마린포드(Card Kingdom - Marineford)",
    "urlinform": "-card-kingdom-marineford",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.smartstore.naver.com/cardkingdom",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJadwqfOG7fDURw2Hi5mHnw5U",
    "lat": 37.5646435,
    "lng": 127.0663662,
    "placeId": "ChIJadwqfOG7fDURw2Hi5mHnw5U",
    "businessStatus": "OPERATIONAL",
    "phone": "070-4402-7770",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 7,
    "id": 746
  },
  {
    "title": "더쿠 홍대입구점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.smartstore.naver.com/the_ku",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGxucP1yZfDURURQI06f4j_c",
    "lat": 37.5558912,
    "lng": 126.9237765,
    "placeId": "ChIJGxucP1yZfDURURQI06f4j_c",
    "businessStatus": "OPERATIONAL",
    "phone": "010-8950-8869",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 13,
    "id": 747,
    "district": "Hongdae"
  },
  {
    "title": "Anseodang",
    "urlinform": "store-60",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.smartstore.naver.com/toykeyring",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmYNLh-qYfDUR7MO8hyGtzEk",
    "lat": 37.5565162,
    "lng": 126.9300143,
    "placeId": "ChIJmYNLh-qYfDUR7MO8hyGtzEk",
    "businessStatus": "OPERATIONAL",
    "phone": "010-7403-1816",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 244,
    "id": 748,
    "district": "Sinchon"
  },
  {
    "title": "WithMuu",
    "urlinform": "-ak",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.withmuu.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhW9b346ZfDURnt6iccBFuww",
    "lat": 37.5580134,
    "lng": 126.9262356,
    "placeId": "ChIJhW9b346ZfDURnt6iccBFuww",
    "businessStatus": "OPERATIONAL",
    "phone": "02-332-0429",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 124,
    "id": 749,
    "district": "Hongdae"
  },
  {
    "title": "Object",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://insideobject.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv417zcGYfDURQdy-jxdhacI",
    "lat": 37.5557157,
    "lng": 126.9297943,
    "placeId": "ChIJv417zcGYfDURQdy-jxdhacI",
    "businessStatus": "OPERATIONAL",
    "phone": "02-3144-7738",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 570,
    "id": 750,
    "district": "Sinchon"
  },
  {
    "title": "Tarot and gallery",
    "urlinform": "tarot-and-gallery",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJieUB1J6jfDURktIcGuXcIHM",
    "lat": 37.5345858,
    "lng": 126.9881434,
    "placeId": "ChIJieUB1J6jfDURktIcGuXcIHM",
    "businessStatus": "OPERATIONAL",
    "phone": "02-749-4142",
    "openingHours": [
      "Monday: 11:00 AM – 3:00 AM",
      "Tuesday: 11:00 AM – 3:00 AM",
      "Wednesday: 11:00 AM – 3:00 AM",
      "Thursday: 11:00 AM – 3:00 AM",
      "Friday: 11:00 AM – 3:00 AM",
      "Saturday: 11:00 AM – 3:00 AM",
      "Sunday: 11:00 AM – 3:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 751
  },
  {
    "title": "I'Park Mall",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hdc-iparkmall.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIyhMk2yjfDUR0NshJiURF5w",
    "lat": 37.52939,
    "lng": 126.9650925,
    "placeId": "ChIJIyhMk2yjfDUR0NshJiURF5w",
    "businessStatus": "OPERATIONAL",
    "phone": "02-2012-0101",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 2549,
    "id": 752,
    "district": "Kukje Electronics Center"
  },
  {
    "title": "해방촌콤콤오락실",
    "urlinform": "store-65",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKzpQBf-jfDURMSvw1fzRgSs",
    "lat": 37.5449773,
    "lng": 126.9852972,
    "placeId": "ChIJKzpQBf-jfDURMSvw1fzRgSs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 4,
    "userRatingsTotal": 2,
    "id": 753
  },
  {
    "title": "Gundam Base I'Park Mall",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "Gundam"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsy3gRAOifDURebjIT7RAG-g",
    "lat": 37.5297133,
    "lng": 126.9647528,
    "placeId": "ChIJsy3gRAOifDURebjIT7RAG-g",
    "businessStatus": "OPERATIONAL",
    "phone": "02-2012-2700",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 1022,
    "id": 754,
    "district": "Kukje Electronics Center"
  },
  {
    "title": "나나피어싱 명동",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://nanapierxing.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOzieG96jfDUR2FDJTSasiVA",
    "lat": 37.5614105,
    "lng": 126.9833439,
    "placeId": "ChIJOzieG96jfDUR2FDJTSasiVA",
    "businessStatus": "OPERATIONAL",
    "phone": "070-7778-3132",
    "openingHours": [
      "Monday: 11:30 AM – 10:30 PM",
      "Tuesday: 11:30 AM – 10:30 PM",
      "Wednesday: 11:30 AM – 10:30 PM",
      "Thursday: 11:30 AM – 10:30 PM",
      "Friday: 11:30 AM – 10:30 PM",
      "Saturday: 11:30 AM – 10:30 PM",
      "Sunday: 11:30 AM – 10:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 36,
    "id": 755,
    "district": "Myeongdong"
  },
  {
    "title": "플라넷비 (PLANETB) 용산 아이파크몰점",
    "urlinform": "-planetb-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://planetbstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMVJt7H-jfDURPXEhLXvTfkE",
    "lat": 37.5289645,
    "lng": 126.964034,
    "placeId": "ChIJMVJt7H-jfDURPXEhLXvTfkE",
    "businessStatus": "OPERATIONAL",
    "phone": "02-2012-4560",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 756,
    "district": "Kukje Electronics Center"
  },
  {
    "title": "Elves & Espresso",
    "urlinform": "elves-espresso",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "MTG",
      "One Piece"
    ],
    "storeWebsite": "https://www.elvesandespresso.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv1jjXYmjfDURMKnBWA61vj8",
    "lat": 37.5374536,
    "lng": 126.9872659,
    "placeId": "ChIJv1jjXYmjfDURMKnBWA61vj8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 11:30 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 54,
    "id": 757
  },
  {
    "title": "Trader",
    "urlinform": "store-72",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3WwkCdejfDURSoLmSmKCoLA",
    "lat": 37.5334007,
    "lng": 126.9605958,
    "placeId": "ChIJ3WwkCdejfDURSoLmSmKCoLA",
    "businessStatus": "OPERATIONAL",
    "phone": "02-714-3425",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 23,
    "id": 758,
    "district": "Yongsan"
  },
  {
    "title": "KSTORM MYEONGDONG",
    "urlinform": "kstorm-myeongdong",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/kstorm_hongdae/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJseHFw7WjfDURuko0PPoQwTY",
    "lat": 37.5605158,
    "lng": 126.9856726,
    "placeId": "ChIJseHFw7WjfDURuko0PPoQwTY",
    "businessStatus": "OPERATIONAL",
    "phone": "010-9288-3337",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 175,
    "id": 759,
    "district": "Myeongdong"
  },
  {
    "title": "Alpha",
    "urlinform": "store-74",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.alpha.co.kr/customer/chain/chainSearchList.do?searchWord=%EB%82%A8%EC%98%81",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn1B5wGuifDURU6GcggmY2nI",
    "lat": 37.54455919999999,
    "lng": 126.9718155,
    "placeId": "ChIJn1B5wGuifDURU6GcggmY2nI",
    "businessStatus": "OPERATIONAL",
    "phone": "02-701-3720",
    "openingHours": [
      "Monday: 9:00 AM – 10:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 24,
    "id": 760
  },
  {
    "title": "(주) 즐카 (Enjoy Camera)",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.fu-gall.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ680tVAOifDURZ3RC4N5PKd0",
    "lat": 37.5327346,
    "lng": 126.9596107,
    "placeId": "ChIJ680tVAOifDURZ3RC4N5PKd0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 5:30 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 2173,
    "id": 761,
    "district": "Yongsan"
  },
  {
    "title": "더세임 명동 (theSameE Myeongdong) K-POP Store",
    "urlinform": "-thesamee-myeongdong-k-pop-store",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/thesamee_myeongdong/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0_mJOUOjfDURmMT9IFNTCY8",
    "lat": 37.5637201,
    "lng": 126.9857874,
    "placeId": "ChIJ0_mJOUOjfDURmMT9IFNTCY8",
    "businessStatus": "OPERATIONAL",
    "phone": "02-318-5102",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 231,
    "id": 762,
    "district": "Myeongdong"
  },
  {
    "title": "Alpha",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.alpha.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG5HR2PSifDURYEw2aB5Uqso",
    "lat": 37.5601221,
    "lng": 126.9765898,
    "placeId": "ChIJG5HR2PSifDURYEw2aB5Uqso",
    "businessStatus": "OPERATIONAL",
    "phone": "02-752-0096",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 7:00 PM",
      "Friday: 9:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 6:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.2,
    "userRatingsTotal": 965,
    "id": 763
  },
  {
    "title": "Buruttrak",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/buruttrak_official/#",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7Y8MJWKjfDURkdcoGL4zxhA",
    "lat": 37.5611297,
    "lng": 126.9828737,
    "placeId": "ChIJ7Y8MJWKjfDURkdcoGL4zxhA",
    "businessStatus": "OPERATIONAL",
    "phone": "02-776-6353",
    "openingHours": [
      "Monday: 10:00 AM – 10:30 PM",
      "Tuesday: 10:00 AM – 10:30 PM",
      "Wednesday: 10:00 AM – 10:30 PM",
      "Thursday: 10:00 AM – 10:30 PM",
      "Friday: 10:00 AM – 10:30 PM",
      "Saturday: 10:00 AM – 10:30 PM",
      "Sunday: 10:00 AM – 10:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 186,
    "id": 764,
    "district": "Myeongdong"
  },
  {
    "title": "Olive Young Myeongdong Boulevard Branch",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.oliveyoung.co.kr/store/store/store-detail.do?strNm=%EB%AA%85%EB%8F%99%EB%8C%80%EB%A1%9C%EC%A0%90&utm_source=google_map&utm_medium=sharing&utm_campaign=o2op_google_map&searchType=strNm",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4yIhlfCifDURGyOg4eBOcPA",
    "lat": 37.560576,
    "lng": 126.9851417,
    "placeId": "ChIJ4yIhlfCifDURGyOg4eBOcPA",
    "businessStatus": "OPERATIONAL",
    "phone": "1577-4887",
    "openingHours": [
      "Monday: 10:00 AM – 10:30 PM",
      "Tuesday: 10:00 AM – 10:30 PM",
      "Wednesday: 10:00 AM – 10:30 PM",
      "Thursday: 10:00 AM – 10:30 PM",
      "Friday: 10:00 AM – 10:30 PM",
      "Saturday: 10:00 AM – 10:30 PM",
      "Sunday: 10:00 AM – 10:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 207,
    "id": 765,
    "district": "Myeongdong"
  },
  {
    "title": "Youngpoong Bookstore Jongno Main Branch",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.ypbooks.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJedDgSumifDURnOlaQDnoZMs",
    "lat": 37.5697869,
    "lng": 126.9823161,
    "placeId": "ChIJedDgSumifDURnOlaQDnoZMs",
    "businessStatus": "OPERATIONAL",
    "phone": "02-399-5600",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 7709,
    "id": 766,
    "district": "Myeongdong"
  },
  {
    "title": "리모와 롯데백화점 본점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.rimowa.com/kr/ko/home?utm_source=yext-gmb&utm_medium=referral",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLVdUVsOjfDURJlp8MWVAZtg",
    "lat": 37.5647036,
    "lng": 126.9815378,
    "placeId": "ChIJLVdUVsOjfDURJlp8MWVAZtg",
    "businessStatus": "OPERATIONAL",
    "phone": "02-2118-6140",
    "openingHours": [
      "Monday: 10:30 AM – 8:00 PM",
      "Tuesday: 10:30 AM – 8:00 PM",
      "Wednesday: 10:30 AM – 8:00 PM",
      "Thursday: 10:30 AM – 8:00 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 14,
    "id": 767,
    "district": "Myeongdong"
  },
  {
    "title": "CU 을지로비즈센터점",
    "urlinform": "cu-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cu.bgfretail.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJlay2SOSifDURQpYur1iBAD4",
    "lat": 37.5654528,
    "lng": 126.9896783,
    "placeId": "ChIJlay2SOSifDURQpYur1iBAD4",
    "businessStatus": "OPERATIONAL",
    "phone": "02-3406-9440",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.5,
    "userRatingsTotal": 4,
    "id": 768,
    "district": "Myeongdong"
  },
  {
    "title": "Artbox Myeongdong Jungang",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.poom.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJf5wVXJ2jfDURCmJHU55zDbA",
    "lat": 37.56215720000001,
    "lng": 126.9855973,
    "placeId": "ChIJf5wVXJ2jfDURCmJHU55zDbA",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71333-0765",
    "openingHours": [
      "Monday: 10:00 AM – 11:00 PM",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 12:00 AM",
      "Saturday: 10:00 AM – 12:00 AM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 71,
    "id": 769,
    "district": "Myeongdong"
  },
  {
    "title": "Wiggle wiggle Myeongdong",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.wiggle-wiggle.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJM-4RlhGjfDURPHyCGRphIZk",
    "lat": 37.5615935,
    "lng": 126.9863564,
    "placeId": "ChIJM-4RlhGjfDURPHyCGRphIZk",
    "businessStatus": "OPERATIONAL",
    "phone": "070-4149-0111",
    "openingHours": [
      "Monday: 10:00 AM – 11:00 PM",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3350,
    "id": 770,
    "district": "Myeongdong"
  },
  {
    "title": "DJI 롯데백화점 본점",
    "urlinform": "dji-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.gatevision.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ82wVewCjfDUR3xz-JLQiSMM",
    "lat": 37.56470729999999,
    "lng": 126.9816637,
    "placeId": "ChIJ82wVewCjfDUR3xz-JLQiSMM",
    "businessStatus": "OPERATIONAL",
    "phone": "02-772-3808",
    "openingHours": [
      "Monday: 10:30 AM – 8:00 PM",
      "Tuesday: 10:30 AM – 8:00 PM",
      "Wednesday: 10:30 AM – 8:00 PM",
      "Thursday: 10:30 AM – 8:00 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 165,
    "id": 771,
    "district": "Myeongdong"
  },
  {
    "title": "Myeongdong Underground Shopping Center",
    "urlinform": "store-97",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ61qvjvCifDURsgRneJ9Fsg0",
    "lat": 37.5608222,
    "lng": 126.9853555,
    "placeId": "ChIJ61qvjvCifDURsgRneJ9Fsg0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 11:00 PM",
      "Tuesday: 9:00 AM – 11:00 PM",
      "Wednesday: 9:00 AM – 11:00 PM",
      "Thursday: 9:00 AM – 11:00 PM",
      "Friday: 9:00 AM – 11:00 PM",
      "Saturday: 9:00 AM – 11:00 PM",
      "Sunday: 9:00 AM – 11:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 4723,
    "id": 772,
    "district": "Myeongdong"
  },
  {
    "title": "Line Friends Square",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://linefriendssquare.com/en",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ15NKIfGjfDUR0-rdsKjd8o8",
    "lat": 37.5638443,
    "lng": 126.9845975,
    "placeId": "ChIJ15NKIfGjfDUR0-rdsKjd8o8",
    "businessStatus": "OPERATIONAL",
    "phone": "914578231",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 3240,
    "id": 773,
    "district": "Myeongdong"
  },
  {
    "title": "Myeongdong Night Market",
    "urlinform": "store-100",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqb-ne_CifDURR-yH8a3sjXM",
    "lat": 37.5616685,
    "lng": 126.9858438,
    "placeId": "ChIJqb-ne_CifDURR-yH8a3sjXM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 5:00 PM – 1:00 AM",
      "Tuesday: 5:00 PM – 1:00 AM",
      "Wednesday: 5:00 PM – 1:00 AM",
      "Thursday: 5:00 PM – 1:00 AM",
      "Friday: 5:00 PM – 1:00 AM",
      "Saturday: 5:00 PM – 1:00 AM",
      "Sunday: 5:00 PM – 1:00 AM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 6919,
    "id": 774,
    "district": "Myeongdong"
  },
  {
    "title": "Monster Manmulsang",
    "urlinform": "store-101",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://smartstore.naver.com/monshop",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaYznn7WhfDURnD208ihMNtY",
    "lat": 37.47558,
    "lng": 127.0420949,
    "placeId": "ChIJaYznn7WhfDURnD208ihMNtY",
    "businessStatus": "OPERATIONAL",
    "phone": "010-2969-3790",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 6:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 81,
    "id": 775
  },
  {
    "title": "LOTTE MART ZETTAPLEX Seoul Station",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://map.naver.com/p/search/%EC%A0%9C%ED%83%80%ED%94%8C%EB%A0%89%EC%8A%A4%20%EC%84%9C%EC%9A%B8%EC%97%AD%EC%A0%90/place/11625327?placePath=%3Fentry%3Dpll%26from%3Dnx%26fromNxList%3Dtrue&placeSearchOption=entry%3Dpll%26fromNxList%3Dtrue%26x%3D126.768429%26y%3D37.694331&searchType=place",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ624QV2GifDURQ02O7lEcqys",
    "lat": 37.555809,
    "lng": 126.9704828,
    "placeId": "ChIJ624QV2GifDURQ02O7lEcqys",
    "businessStatus": "OPERATIONAL",
    "phone": "1899-3000",
    "openingHours": [
      "Monday: 10:00 AM – 12:00 AM",
      "Tuesday: 10:00 AM – 12:00 AM",
      "Wednesday: 10:00 AM – 12:00 AM",
      "Thursday: 10:00 AM – 12:00 AM",
      "Friday: 10:00 AM – 12:00 AM",
      "Saturday: 10:00 AM – 12:00 AM",
      "Sunday: 10:00 AM – 12:00 AM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 9934,
    "id": 776
  },
  {
    "title": "Office Depot",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.officedepot.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJL-IDMn2jfDURrwnuNSfF62k",
    "lat": 37.5640071,
    "lng": 126.9758269,
    "placeId": "ChIJL-IDMn2jfDURrwnuNSfF62k",
    "businessStatus": "OPERATIONAL",
    "phone": "02-779-7478",
    "openingHours": [
      "Monday: 8:30 AM – 8:00 PM",
      "Tuesday: 8:30 AM – 8:00 PM",
      "Wednesday: 8:30 AM – 8:00 PM",
      "Thursday: 8:30 AM – 8:00 PM",
      "Friday: 8:30 AM – 8:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4,
    "userRatingsTotal": 68,
    "id": 777
  },
  {
    "title": "Aladdin Used Bookstore Jongno",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://off.aladin.co.kr/usedstore/wgate.aspx",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQRWFw9yifDURUlelSZv68mM",
    "lat": 37.5699551,
    "lng": 126.987265,
    "placeId": "ChIJQRWFw9yifDURUlelSZv68mM",
    "businessStatus": "OPERATIONAL",
    "phone": "1544-2514",
    "openingHours": [
      "Monday: 9:30 AM – 10:00 PM",
      "Tuesday: 9:30 AM – 10:00 PM",
      "Wednesday: 9:30 AM – 10:00 PM",
      "Thursday: 9:30 AM – 10:00 PM",
      "Friday: 9:30 AM – 10:00 PM",
      "Saturday: 9:30 AM – 10:00 PM",
      "Sunday: 9:30 AM – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 2459,
    "id": 778,
    "district": "Myeongdong"
  },
  {
    "title": "edge card",
    "urlinform": "store-105",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.edgecard.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR9CRt-OifDURb9BCoHjmwjA",
    "lat": 37.5640625,
    "lng": 126.9937707,
    "placeId": "ChIJR9CRt-OifDURb9BCoHjmwjA",
    "businessStatus": "OPERATIONAL",
    "phone": "02-2278-4671",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 6:00 PM",
      "Wednesday: 9:00 AM – 6:00 PM",
      "Thursday: 9:00 AM – 6:00 PM",
      "Friday: 9:00 AM – 6:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 779,
    "district": "Myeongdong"
  },
  {
    "title": "케이메카(K-MECCA)",
    "urlinform": "k-mecca",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.kmecca.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi22HkdqjfDURg1py7VtjpVw",
    "lat": 37.5613224,
    "lng": 126.9846802,
    "placeId": "ChIJi22HkdqjfDURg1py7VtjpVw",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71317-2558",
    "openingHours": [
      "Monday: 10:00 AM – 11:00 PM",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 417,
    "id": 780,
    "district": "Myeongdong"
  },
  {
    "title": "Myeongdong CD Shop",
    "urlinform": "cd",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/cddvd_kpopholic/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmfjzkfCifDURi5M9kC1qxmU",
    "lat": 37.5607922,
    "lng": 126.9854867,
    "placeId": "ChIJmfjzkfCifDURi5M9kC1qxmU",
    "businessStatus": "OPERATIONAL",
    "phone": "070-8808-7264",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 10:30 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 137,
    "id": 781,
    "district": "Myeongdong"
  },
  {
    "title": "nyunyu myeongdong",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ112QXgCjfDURzhOvVXrUYbA",
    "lat": 37.5626654,
    "lng": 126.9837376,
    "placeId": "ChIJ112QXgCjfDURzhOvVXrUYbA",
    "businessStatus": "OPERATIONAL",
    "phone": "010-9884-6925",
    "openingHours": [
      "Monday: 9:00 AM – 11:00 PM",
      "Tuesday: 9:00 AM – 11:00 PM",
      "Wednesday: 9:00 AM – 11:00 PM",
      "Thursday: 9:00 AM – 11:00 PM",
      "Friday: 9:00 AM – 11:00 PM",
      "Saturday: 9:00 AM – 11:00 PM",
      "Sunday: 9:00 AM – 11:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 224,
    "id": 782,
    "district": "Myeongdong"
  },
  {
    "title": "Popmart Myeongdong",
    "urlinform": "store-111",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://popmart.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD_uFZQCjfDUR9ZhRdAFwNUM",
    "lat": 37.5620974,
    "lng": 126.9847156,
    "placeId": "ChIJD_uFZQCjfDUR9ZhRdAFwNUM",
    "businessStatus": "OPERATIONAL",
    "phone": "02-319-9967",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 246,
    "id": 783,
    "district": "Myeongdong"
  },
  {
    "title": "Daiso (Myeongdong Station Branch)",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.daiso.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB3adfvqifDURG5y_RMiTup8",
    "lat": 37.56075070000001,
    "lng": 126.9866775,
    "placeId": "ChIJB3adfvqifDURG5y_RMiTup8",
    "businessStatus": "OPERATIONAL",
    "phone": "1522-4400",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 3672,
    "id": 784,
    "district": "Myeongdong"
  },
  {
    "title": "La Nueva No.1",
    "urlinform": "lazy-derma",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJa2sTAtKjfDURaX8FEC4BmQg",
    "lat": 37.562167,
    "lng": 126.9839984,
    "placeId": "ChIJa2sTAtKjfDURaX8FEC4BmQg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 11:00 PM",
      "Tuesday: 9:00 AM – 11:00 PM",
      "Wednesday: 9:00 AM – 11:00 PM",
      "Thursday: 9:00 AM – 11:00 PM",
      "Friday: 9:00 AM – 11:00 PM",
      "Saturday: 9:00 AM – 11:00 PM",
      "Sunday: 9:00 AM – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1711,
    "id": 785,
    "district": "Myeongdong"
  },
  {
    "title": "Wantt - Thrift!",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/wantt.myeongdong/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJS6TiIfCifDUR33VgWl0qC7I",
    "lat": 37.5636186,
    "lng": 126.9849967,
    "placeId": "ChIJS6TiIfCifDUR33VgWl0qC7I",
    "businessStatus": "OPERATIONAL",
    "phone": "02-6377-0288",
    "openingHours": [
      "Monday: 11:00 AM – 11:00 PM",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 218,
    "id": 786,
    "district": "Myeongdong"
  },
  {
    "title": "poca poca tcg(Pokemon card)",
    "urlinform": "poca-poca-tcgpokemon-card",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://cawd7d-fy.myshopify.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJA1TS9krpaDURxR5Q1DsvldQ",
    "lat": 35.098658,
    "lng": 129.0321684,
    "placeId": "ChIJA1TS9krpaDURxR5Q1DsvldQ",
    "businessStatus": "OPERATIONAL",
    "phone": "010-2563-1772",
    "openingHours": [
      "Monday: 2:30 – 8:00 PM",
      "Tuesday: 2:30 – 8:00 PM",
      "Wednesday: 2:30 – 8:00 PM",
      "Thursday: 2:30 – 8:00 PM",
      "Friday: 2:30 – 8:00 PM",
      "Saturday: 9:00 AM – 5:00 PM",
      "Sunday: 2:30 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 32,
    "id": 787,
    "district": "Nampo"
  },
  {
    "title": "Pokemon Card Shop BUSAN",
    "urlinform": "pokemon-card-shop-busan-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://naver.me/GmtYNKK2",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ903zE2GTaDURiNXPg_sqzoE",
    "lat": 35.2054284,
    "lng": 129.0792775,
    "placeId": "ChIJ903zE2GTaDURiNXPg_sqzoE",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71491-9697",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 18,
    "id": 788
  },
  {
    "title": "Seomyeon GACHA SHOP",
    "urlinform": "store-3",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcQkx9G_raDUR7BP7D5-5ZwE",
    "lat": 35.1554386,
    "lng": 129.0604515,
    "placeId": "ChIJcQkx9G_raDUR7BP7D5-5ZwE",
    "businessStatus": "OPERATIONAL",
    "phone": "051-802-6577",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3.9,
    "userRatingsTotal": 18,
    "id": 789,
    "district": "Seomyeon"
  },
  {
    "title": "Shuffle TCG Shop",
    "urlinform": "shuffle-tcg-shop",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJr32ZdQCTaDURkqz3ND_g9us",
    "lat": 35.2053786,
    "lng": 129.0750156,
    "placeId": "ChIJr32ZdQCTaDURkqz3ND_g9us",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 24,
    "id": 790
  },
  {
    "title": "Kadeupam board game café",
    "urlinform": "store-5",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK9Bh2grpaDURW8zejDcQMtY",
    "lat": 35.1546362,
    "lng": 129.0610924,
    "placeId": "ChIJK9Bh2grpaDURW8zejDcQMtY",
    "businessStatus": "OPERATIONAL",
    "phone": "070-7799-2818",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 35,
    "id": 791,
    "district": "Seomyeon"
  },
  {
    "title": "J-Goods Busan Seomyeon",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1Ye4r3jraDUR6eNPGucUPu8",
    "lat": 35.1536727,
    "lng": 129.0598036,
    "placeId": "ChIJ1Ye4r3jraDUR6eNPGucUPu8",
    "businessStatus": "OPERATIONAL",
    "phone": "051-804-2248",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 63,
    "id": 792,
    "district": "Seomyeon"
  },
  {
    "title": "ANIME CLUB Busan",
    "urlinform": "store-7",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://smartstore.naver.com/mojimoji",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ89ayinPraDURDl40hNoRp5A",
    "lat": 35.1536447,
    "lng": 129.0595202,
    "placeId": "ChIJ89ayinPraDURDl40hNoRp5A",
    "businessStatus": "OPERATIONAL",
    "phone": "070-8880-8033",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 46,
    "id": 793,
    "district": "Seomyeon"
  },
  {
    "title": "보드게임카페 미니빌 서면점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://linktr.ee/minivillekr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtQCQJH_raDURMyTiRFerTn0",
    "lat": 35.15466,
    "lng": 129.061075,
    "placeId": "ChIJtQCQJH_raDURMyTiRFerTn0",
    "businessStatus": "OPERATIONAL",
    "phone": "070-4149-8228",
    "openingHours": [
      "Monday: 1:00 – 11:00 PM",
      "Tuesday: 1:00 – 11:00 PM",
      "Wednesday: 1:00 – 11:00 PM",
      "Thursday: 1:00 – 11:00 PM",
      "Friday: 1:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 11:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 39,
    "id": 794,
    "district": "Seomyeon"
  },
  {
    "title": "아트박스 부산서면점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.poom.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNWU8TmXraDUR8vrr1mMoJ6c",
    "lat": 35.1545621,
    "lng": 129.0613605,
    "placeId": "ChIJNWU8TmXraDUR8vrr1mMoJ6c",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71414-5657",
    "openingHours": [
      "Monday: 11:00 AM – 11:00 PM",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 323,
    "id": 795,
    "district": "Seomyeon"
  },
  {
    "title": "ANIPLUS SHOP Busan Seomyeon Store",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.aniplustv.com/store",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn9drUfDraDURbKq1ObEx-mI",
    "lat": 35.1529425,
    "lng": 129.0595638,
    "placeId": "ChIJn9drUfDraDURbKq1ObEx-mI",
    "businessStatus": "OPERATIONAL",
    "phone": "070-7162-7048",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 22,
    "id": 796,
    "district": "Seomyeon"
  },
  {
    "title": "Gundam Base, Seomyeon",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "Gundam"
    ],
    "storeWebsite": "https://kr.gundam.info/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPXOfZy_raDURoVheo8e6F3o",
    "lat": 35.1529425,
    "lng": 129.0595638,
    "placeId": "ChIJPXOfZy_raDURoVheo8e6F3o",
    "businessStatus": "OPERATIONAL",
    "phone": "051-818-3440",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:30 PM",
      "Saturday: 11:00 AM – 10:30 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 61,
    "id": 797,
    "district": "Seomyeon"
  },
  {
    "title": "브라더굿즈",
    "urlinform": "store-14",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/_KING_TAKU_",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTd0GIm_raDURa7hsrz4OaJw",
    "lat": 35.1535845,
    "lng": 129.0593794,
    "placeId": "ChIJTd0GIm_raDURa7hsrz4OaJw",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71308-4290",
    "openingHours": [
      "Monday: 12:00 AM – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 10,
    "id": 798,
    "district": "Seomyeon"
  },
  {
    "title": "Seomyeon Market",
    "urlinform": "store-16",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG7Fv02_raDUROnWS49QEK1o",
    "lat": 35.1557374,
    "lng": 129.0581664,
    "placeId": "ChIJG7Fv02_raDUROnWS49QEK1o",
    "businessStatus": "OPERATIONAL",
    "phone": "051-806-5025",
    "openingHours": [
      "Monday: 7:00 AM – 9:00 PM",
      "Tuesday: 7:00 AM – 9:00 PM",
      "Wednesday: 7:00 AM – 9:00 PM",
      "Thursday: 7:00 AM – 9:00 PM",
      "Friday: 7:00 AM – 9:00 PM",
      "Saturday: 9:00 AM – 9:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.1,
    "userRatingsTotal": 2777,
    "id": 799,
    "district": "Seomyeon"
  },
  {
    "title": "트레이더스 홀세일 클럽 서면점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.traders.co.kr/index.jsp",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAxODCGvraDURtTQPURHHlYQ",
    "lat": 35.1639096,
    "lng": 129.0525986,
    "placeId": "ChIJAxODCGvraDURtTQPURHHlYQ",
    "businessStatus": "OPERATIONAL",
    "phone": "051-718-1234",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 7055,
    "id": 800,
    "district": "Seomyeon"
  },
  {
    "title": "Kyobo Book Centre Busan",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.kyobobook.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-apJlHDraDURWfSu_Nl550Y",
    "lat": 35.1515345,
    "lng": 129.0596306,
    "placeId": "ChIJ-apJlHDraDURWfSu_Nl550Y",
    "businessStatus": "OPERATIONAL",
    "phone": "051-806-3501",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 9:30 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 4750,
    "id": 801,
    "district": "Seomyeon"
  },
  {
    "title": "Object Seomyeon",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://insideobject.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwapY9WTraDURPwpOB54LJ_o",
    "lat": 35.1553121,
    "lng": 129.0644697,
    "placeId": "ChIJwapY9WTraDURPwpOB54LJ_o",
    "businessStatus": "OPERATIONAL",
    "phone": "051-808-7747",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 98,
    "id": 802,
    "district": "Seomyeon"
  },
  {
    "title": "아트박스 서면역사점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.poom.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLc6TTQDraDURGegIbSvdAi8",
    "lat": 35.1577552,
    "lng": 129.0589805,
    "placeId": "ChIJLc6TTQDraDURGegIbSvdAi8",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71386-0782",
    "openingHours": [
      "Monday: 10:30 AM – 11:00 PM",
      "Tuesday: 10:30 AM – 11:00 PM",
      "Wednesday: 10:30 AM – 11:00 PM",
      "Thursday: 10:30 AM – 11:00 PM",
      "Friday: 10:30 AM – 11:00 PM",
      "Saturday: 10:30 AM – 11:00 PM",
      "Sunday: 10:30 AM – 11:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 7,
    "id": 803,
    "district": "Seomyeon"
  },
  {
    "title": "TAMIYA Seomyen store",
    "urlinform": "-tamiya-seomyeon-store",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://smartstore.naver.com/smtamiya",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpeKxMozraDURzB7MxXClee4",
    "lat": 35.1530115,
    "lng": 129.0596058,
    "placeId": "ChIJpeKxMozraDURzB7MxXClee4",
    "businessStatus": "OPERATIONAL",
    "phone": "070-7776-1172",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:30 PM",
      "Saturday: 11:00 AM – 10:30 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 7,
    "id": 804,
    "district": "Seomyeon"
  },
  {
    "title": "Lotte Duty Free Store",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.lottedfs.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJX67REG7raDUROHJJBSrvvIY",
    "lat": 35.1567319,
    "lng": 129.056651,
    "placeId": "ChIJX67REG7raDUROHJJBSrvvIY",
    "businessStatus": "OPERATIONAL",
    "phone": "051-810-3880",
    "openingHours": [
      "Monday: 10:30 AM – 7:30 PM",
      "Tuesday: 10:30 AM – 7:30 PM",
      "Wednesday: 10:30 AM – 7:30 PM",
      "Thursday: 10:30 AM – 7:30 PM",
      "Friday: 10:30 AM – 7:30 PM",
      "Saturday: 10:30 AM – 7:30 PM",
      "Sunday: 10:30 AM – 7:30 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 1339,
    "id": 805,
    "district": "Seomyeon"
  },
  {
    "title": "영광도서",
    "urlinform": "store-23",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ykbook.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcbiF5m7raDURw_Aj7u0inS8",
    "lat": 35.1587732,
    "lng": 129.0576897,
    "placeId": "ChIJcbiF5m7raDURw_Aj7u0inS8",
    "businessStatus": "OPERATIONAL",
    "phone": "051-816-9500",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 2907,
    "id": 806,
    "district": "Seomyeon"
  },
  {
    "title": "Daiso",
    "urlinform": "-1",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.daiso.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRVnYbmXraDURAUkigLR6dXE",
    "lat": 35.1556561,
    "lng": 129.061482,
    "placeId": "ChIJRVnYbmXraDURAUkigLR6dXE",
    "businessStatus": "OPERATIONAL",
    "phone": "1522-4400",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 1051,
    "id": 807,
    "district": "Seomyeon"
  },
  {
    "title": "하비코리아 부산점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://mkt.shopping.naver.com/link/686dd581b202c219c6e4aa4f",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvfqcABrraDURlGl9Vg3bKKo",
    "lat": 35.1539316,
    "lng": 129.0621866,
    "placeId": "ChIJvfqcABrraDURlGl9Vg3bKKo",
    "businessStatus": "OPERATIONAL",
    "phone": "051-807-3861",
    "openingHours": [
      "Monday: 11:30 AM – 9:00 PM",
      "Tuesday: 11:30 AM – 9:00 PM",
      "Wednesday: 11:30 AM – 9:00 PM",
      "Thursday: 11:30 AM – 9:00 PM",
      "Friday: 11:30 AM – 9:00 PM",
      "Saturday: 11:30 AM – 9:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.6,
    "userRatingsTotal": 5,
    "id": 808,
    "district": "Seomyeon"
  },
  {
    "title": "부산더락",
    "urlinform": "store-26",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "MTG",
      "One Piece",
      "Vanguard"
    ],
    "storeWebsite": "http://tcgkorea.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJM1ctCI2TaDURBLJhx2NHF1g",
    "lat": 35.1682189,
    "lng": 129.1170416,
    "placeId": "ChIJM1ctCI2TaDURBLJhx2NHF1g",
    "businessStatus": "OPERATIONAL",
    "phone": "051-907-8074",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 33,
    "id": 809
  },
  {
    "title": "티씨지드로우",
    "urlinform": "store-27",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://cafe.naver.com/tcgdraw",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbcK7nvDtaDURIpapxOWkCBA",
    "lat": 35.13531020000001,
    "lng": 129.0999156,
    "placeId": "ChIJbcK7nvDtaDURIpapxOWkCBA",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71331-3065",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 18,
    "id": 810
  },
  {
    "title": "GAME D (게임 D)",
    "urlinform": "game-d-d",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://gamed.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDWkRtg7taDURB6SWimpNZzs",
    "lat": 35.1366642,
    "lng": 129.1008581,
    "placeId": "ChIJDWkRtg7taDURB6SWimpNZzs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 12:00 AM",
      "Tuesday: 9:00 AM – 12:00 AM",
      "Wednesday: 9:00 AM – 12:00 AM",
      "Thursday: 9:00 AM – 12:00 AM",
      "Friday: 9:00 AM – 12:00 AM",
      "Saturday: 9:00 AM – 5:00 AM",
      "Sunday: 9:00 AM – 12:00 AM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 214,
    "id": 811
  },
  {
    "title": "Artbox Busan Gwangbok 1st store",
    "urlinform": "-1",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.poom.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJU4kqjaDpaDURuiOD6rvzdUU",
    "lat": 35.0985434,
    "lng": 129.0282307,
    "placeId": "ChIJU4kqjaDpaDURuiOD6rvzdUU",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71418-7013",
    "openingHours": [
      "Monday: 11:00 AM – 10:30 PM",
      "Tuesday: 11:00 AM – 10:30 PM",
      "Wednesday: 11:00 AM – 10:30 PM",
      "Thursday: 11:00 AM – 10:30 PM",
      "Friday: 11:00 AM – 10:30 PM",
      "Saturday: 11:00 AM – 10:30 PM",
      "Sunday: 11:00 AM – 10:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 335,
    "id": 812,
    "district": "Nampo"
  },
  {
    "title": "Artbox Busan Gwangbok 2nd store",
    "urlinform": "-2",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.poom.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxwHCpnPpaDURZRWclHC0tbo",
    "lat": 35.0988245,
    "lng": 129.0330195,
    "placeId": "ChIJxwHCpnPpaDURZRWclHC0tbo",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71403-2200",
    "openingHours": [
      "Monday: 11:00 AM – 10:30 PM",
      "Tuesday: 11:00 AM – 10:30 PM",
      "Wednesday: 11:00 AM – 10:30 PM",
      "Thursday: 11:00 AM – 10:30 PM",
      "Friday: 11:00 AM – 10:30 PM",
      "Saturday: 11:00 AM – 10:30 PM",
      "Sunday: 11:00 AM – 10:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 80,
    "id": 813,
    "district": "Nampodong"
  },
  {
    "title": "DAISO Nampo",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.daiso.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGUMJ8wrpaDURVUHDADsOa-c",
    "lat": 35.0984681,
    "lng": 129.0309443,
    "placeId": "ChIJGUMJ8wrpaDURVUHDADsOa-c",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 1076,
    "id": 814,
    "district": "Nampo"
  },
  {
    "title": "Nampo Underground Shopping Center",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://namposhop.fortour.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb4ybzqDpaDUR8DVxVgVYqu4",
    "lat": 35.0981969,
    "lng": 129.0306289,
    "placeId": "ChIJb4ybzqDpaDUR8DVxVgVYqu4",
    "businessStatus": "OPERATIONAL",
    "phone": "051-713-8200",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 1086,
    "id": 815,
    "district": "Nampo"
  },
  {
    "title": "아이러브뮤직",
    "urlinform": "store-34",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ilovemusic.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0e_vOArpaDURPfcQDPsBaWo",
    "lat": 35.098008,
    "lng": 129.028537,
    "placeId": "ChIJ0e_vOArpaDURPfcQDPsBaWo",
    "businessStatus": "OPERATIONAL",
    "phone": "051-254-1072",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 146,
    "id": 816,
    "district": "Nampo"
  },
  {
    "title": "SONY Center Busan",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/sonybusan/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVyEILtDpaDURcyh3aNCYJqc",
    "lat": 35.0988355,
    "lng": 129.0354862,
    "placeId": "ChIJVyEILtDpaDURcyh3aNCYJqc",
    "businessStatus": "OPERATIONAL",
    "phone": "051-244-5500",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 7:00 PM",
      "Friday: 9:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 79,
    "id": 817,
    "district": "Nampodong"
  },
  {
    "title": "씨네샵 부산광복점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://hilightbrands-kodak.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFZ-GOyrpaDURSfi0V0jmQlU",
    "lat": 35.0991464,
    "lng": 129.0313862,
    "placeId": "ChIJFZ-GOyrpaDURSfi0V0jmQlU",
    "businessStatus": "OPERATIONAL",
    "phone": "051-231-1126",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 818,
    "district": "Nampo"
  },
  {
    "title": "Nampo Bookstore",
    "urlinform": "store-38",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo2_Y5ArpaDUR3chxojJV_N8",
    "lat": 35.0990017,
    "lng": 129.0275373,
    "placeId": "ChIJo2_Y5ArpaDUR3chxojJV_N8",
    "businessStatus": "OPERATIONAL",
    "phone": "051-245-8911",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 742,
    "id": 819,
    "district": "Nampo"
  },
  {
    "title": "MONEYBOX NAMPO , 머니박스 남포점 [ Currency Exchange ]",
    "urlinform": "moneybox-nampo-currency-exchange-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.nampomoneybox.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJkbHcsknpaDURs2shr2eGfmQ",
    "lat": 35.0992577,
    "lng": 129.029153,
    "placeId": "ChIJkbHcsknpaDURs2shr2eGfmQ",
    "businessStatus": "OPERATIONAL",
    "phone": "051-245-9998",
    "openingHours": [
      "Monday: 9:00 AM – 8:00 PM",
      "Tuesday: 9:00 AM – 8:00 PM",
      "Wednesday: 9:00 AM – 8:00 PM",
      "Thursday: 9:00 AM – 8:00 PM",
      "Friday: 9:00 AM – 1:00 AM",
      "Saturday: 9:00 AM – 8:00 PM",
      "Sunday: 9:00 AM – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 152,
    "id": 820,
    "district": "Nampo"
  },
  {
    "title": "Nampo-dong Dried Fish Wholesale Market",
    "urlinform": "store-40",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJncqwewvpaDURyOcqg0m85K8",
    "lat": 35.0977306,
    "lng": 129.0349149,
    "placeId": "ChIJncqwewvpaDURyOcqg0m85K8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 8:30 AM – 7:00 PM",
      "Tuesday: 8:30 AM – 7:00 PM",
      "Wednesday: 8:30 AM – 7:00 PM",
      "Thursday: 8:30 AM – 7:00 PM",
      "Friday: 8:30 AM – 7:00 PM",
      "Saturday: 8:30 AM – 7:00 PM",
      "Sunday: 8:30 AM – 7:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 462,
    "id": 821,
    "district": "Nampodong"
  },
  {
    "title": "Olive Young Busan Nampo",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.oliveyoung.co.kr/store/store/store-detail.do?strNm=%EB%B6%80%EC%82%B0%EB%82%A8%ED%8F%AC%EC%A0%90&utm_source=google_map&utm_medium=sharing&utm_campaign=o2op_google_map&searchType=strNm",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsQzu3wrpaDURJTW5HOLns4Q",
    "lat": 35.0989067,
    "lng": 129.0319489,
    "placeId": "ChIJsQzu3wrpaDURJTW5HOLns4Q",
    "businessStatus": "OPERATIONAL",
    "phone": "1577-4887",
    "openingHours": [
      "Monday: 10:00 AM – 10:30 PM",
      "Tuesday: 10:00 AM – 10:30 PM",
      "Wednesday: 10:00 AM – 10:30 PM",
      "Thursday: 10:00 AM – 10:30 PM",
      "Friday: 10:00 AM – 10:30 PM",
      "Saturday: 10:00 AM – 10:30 PM",
      "Sunday: 10:00 AM – 10:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 229,
    "id": 822,
    "district": "Nampo"
  },
  {
    "title": "엠픽(MPEAK)부산광복점",
    "urlinform": "mpeak",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m-peak.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSbP2pWTpaDURFzJzps3GiCo",
    "lat": 35.0984294,
    "lng": 129.0299087,
    "placeId": "ChIJSbP2pWTpaDURFzJzps3GiCo",
    "businessStatus": "OPERATIONAL",
    "phone": "051-231-9838",
    "openingHours": [
      "Monday: 11:00 AM – 10:30 PM",
      "Tuesday: 11:00 AM – 10:30 PM",
      "Wednesday: 11:00 AM – 10:30 PM",
      "Thursday: 11:00 AM – 10:30 PM",
      "Friday: 11:00 AM – 10:30 PM",
      "Saturday: 11:00 AM – 10:30 PM",
      "Sunday: 11:00 AM – 10:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 823,
    "district": "Nampo"
  },
  {
    "title": "빽다방 부산자갈치시장점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbagUK-vpaDURRYCfDRe2UUU",
    "lat": 35.09722259999999,
    "lng": 129.0283175,
    "placeId": "ChIJbagUK-vpaDURRYCfDRe2UUU",
    "businessStatus": "OPERATIONAL",
    "phone": "051-248-7778",
    "openingHours": [
      "Monday: 8:00 AM – 6:00 PM",
      "Tuesday: 8:00 AM – 6:00 PM",
      "Wednesday: 8:00 AM – 6:00 PM",
      "Thursday: 8:00 AM – 6:00 PM",
      "Friday: 8:00 AM – 6:00 PM",
      "Saturday: 8:00 AM – 6:00 PM",
      "Sunday: 8:00 AM – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 23,
    "id": 824,
    "district": "Nampo"
  },
  {
    "title": "Gukje Market",
    "urlinform": "store-44",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://gukjemarket6.modoo.at/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfYLMelSTaDURFlCRfk5W1PA",
    "lat": 35.1013575,
    "lng": 129.0281978,
    "placeId": "ChIJfYLMelSTaDURFlCRfk5W1PA",
    "businessStatus": "OPERATIONAL",
    "phone": "051-245-7389",
    "openingHours": [],
    "rating": 4.2,
    "userRatingsTotal": 13053,
    "id": 825,
    "district": "Nampo"
  },
  {
    "title": "Home base",
    "urlinform": "store-45",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJral1iwrpaDURywzFhWHSqvc",
    "lat": 35.0984522,
    "lng": 129.0305369,
    "placeId": "ChIJral1iwrpaDURywzFhWHSqvc",
    "businessStatus": "OPERATIONAL",
    "phone": "051-246-6781",
    "openingHours": [
      "Monday: 11:00 AM – 8:30 PM",
      "Tuesday: 11:00 AM – 8:30 PM",
      "Wednesday: 11:00 AM – 8:30 PM",
      "Thursday: 11:00 AM – 8:30 PM",
      "Friday: 11:00 AM – 8:30 PM",
      "Saturday: 11:00 AM – 8:30 PM",
      "Sunday: 11:00 AM – 8:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 36,
    "id": 826,
    "district": "Nampo"
  },
  {
    "title": "Nampo-dong Game D",
    "urlinform": "-d",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ119TnHzpaDURybCGrnKJSQw",
    "lat": 35.0984959,
    "lng": 129.027286,
    "placeId": "ChIJ119TnHzpaDURybCGrnKJSQw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 11:40 PM",
      "Tuesday: 10:00 AM – 11:40 PM",
      "Wednesday: 10:00 AM – 11:40 PM",
      "Thursday: 10:00 AM – 11:40 PM",
      "Friday: 10:00 AM – 11:40 PM",
      "Saturday: 10:00 AM – 11:40 PM",
      "Sunday: 10:00 AM – 11:40 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 63,
    "id": 827,
    "district": "Nampo"
  },
  {
    "title": "KPOP FRIENDS 케이팝프렌즈 남포점",
    "urlinform": "kpop-friends-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_yXyWQDpaDURY7d8Mu_vqCU",
    "lat": 35.0990045,
    "lng": 129.0293447,
    "placeId": "ChIJ_yXyWQDpaDURY7d8Mu_vqCU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 4.3,
    "userRatingsTotal": 37,
    "id": 828,
    "district": "Nampo"
  },
  {
    "title": "아브라함커피 남포점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://abrahamcoffee.com/?a2hs=1",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN8yJSADpaDURgAnEgi7RGL0",
    "lat": 35.0989099,
    "lng": 129.0313234,
    "placeId": "ChIJN8yJSADpaDURgAnEgi7RGL0",
    "businessStatus": "OPERATIONAL",
    "phone": "051-242-9402",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 107,
    "id": 829,
    "district": "Nampo"
  },
  {
    "title": "남포동 프리마켓",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://blog.naver.com/nampofree2",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-__PV3XpaDURDSpzGORd4AQ",
    "lat": 35.1014844,
    "lng": 129.0293862,
    "placeId": "ChIJ-__PV3XpaDURDSpzGORd4AQ",
    "businessStatus": "OPERATIONAL",
    "phone": "051-231-6730",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 63,
    "id": 830,
    "district": "Nampo"
  },
  {
    "title": "Zoomin",
    "urlinform": "store-57",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.zoomin.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_TFGTXPpaDURMwfuauymwxg",
    "lat": 35.0988847,
    "lng": 129.0352543,
    "placeId": "ChIJ_TFGTXPpaDURMwfuauymwxg",
    "businessStatus": "OPERATIONAL",
    "phone": "051-255-0300",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 7:00 PM",
      "Friday: 9:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 77,
    "id": 831,
    "district": "Nampodong"
  },
  {
    "title": "토이친구",
    "urlinform": "store-58",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://smartstore.naver.com/toyfriend",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7zNj0fDsaDURUMchu3DNl54",
    "lat": 35.1621695,
    "lng": 129.1796487,
    "placeId": "ChIJ7zNj0fDsaDURUMchu3DNl54",
    "businessStatus": "OPERATIONAL",
    "phone": "070-7543-2508",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 14,
    "id": 832
  },
  {
    "title": "아트박스 부산해운대점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.poom.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi17L16KNaDURUtQCSQaC9RY",
    "lat": 35.1623989,
    "lng": 129.1596086,
    "placeId": "ChIJi17L16KNaDURUtQCSQaC9RY",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71424-0338",
    "openingHours": [
      "Monday: 11:00 AM – 10:30 PM",
      "Tuesday: 11:00 AM – 10:30 PM",
      "Wednesday: 11:00 AM – 10:30 PM",
      "Thursday: 11:00 AM – 10:30 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 10:30 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 55,
    "id": 833,
    "district": "Haeundae"
  },
  {
    "title": "고래서이뻐 해운대구남 (Pretty Whale Gift Shop Haeundae Gunam)",
    "urlinform": "-pretty-whale-gift-shop-haeundae-gunam",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtezgAZiNaDURHcEmEynzheU",
    "lat": 35.1625284,
    "lng": 129.1605567,
    "placeId": "ChIJtezgAZiNaDURHcEmEynzheU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 17,
    "id": 834,
    "district": "Haeundae"
  },
  {
    "title": "도토리캐리커쳐 부산해운대점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ669C2n6NaDURhv873OI9og8",
    "lat": 35.1617075,
    "lng": 129.1626152,
    "placeId": "ChIJ669C2n6NaDURhv873OI9og8",
    "businessStatus": "OPERATIONAL",
    "phone": "010-2178-5524",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 259,
    "id": 835,
    "district": "Haeundae"
  },
  {
    "title": "Over Cloud Souvenir Shop, Busan Haeundae",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/cloud.shop._.busan/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxf0_IWaNaDURcRD1SsMcIcM",
    "lat": 35.1591466,
    "lng": 129.1603847,
    "placeId": "ChIJxf0_IWaNaDURcRD1SsMcIcM",
    "businessStatus": "OPERATIONAL",
    "phone": "051-744-4451",
    "openingHours": [
      "Monday: 9:00 AM – 10:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 10:00 PM",
      "Sunday: 9:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 9,
    "id": 836,
    "district": "Haeundae"
  },
  {
    "title": "다이소 부산해운대장산본점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.daiso.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ81Id1VqNaDURgd_qfajtvEM",
    "lat": 35.1690134,
    "lng": 129.174654,
    "placeId": "ChIJ81Id1VqNaDURgd_qfajtvEM",
    "businessStatus": "OPERATIONAL",
    "phone": "051-703-6015",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 1000,
    "id": 837
  },
  {
    "title": "Busan Souvenir Heaundae Gift Shop",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/busan._.souvenir/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBZdRViyNaDUR6m-6lb-LjXk",
    "lat": 35.1590395,
    "lng": 129.160183,
    "placeId": "ChIJBZdRViyNaDUR6m-6lb-LjXk",
    "businessStatus": "OPERATIONAL",
    "phone": "051-731-1204",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 17,
    "id": 838,
    "district": "Haeundae"
  },
  {
    "title": "DAISO",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.daiso.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwzv0_l2NaDUR2WmPATHufew",
    "lat": 35.1629553,
    "lng": 129.159743,
    "placeId": "ChIJwzv0_l2NaDUR2WmPATHufew",
    "businessStatus": "OPERATIONAL",
    "phone": "1522-4400",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 392,
    "id": 839,
    "district": "Haeundae"
  },
  {
    "title": "NC백화점 해운대점",
    "urlinform": "nc-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.elandretail.com/store01.do?branchID=00110040",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYZhXssKNaDURiQTM_8Jp1XM",
    "lat": 35.1705843,
    "lng": 129.1770927,
    "placeId": "ChIJYZhXssKNaDURiQTM_8Jp1XM",
    "businessStatus": "OPERATIONAL",
    "phone": "051-862-2001",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 425,
    "id": 840
  },
  {
    "title": "아트박스 해운대NC점",
    "urlinform": "-nc",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.poom.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQyiA3ZiNaDUR97iLNmXPJxE",
    "lat": 35.1705853,
    "lng": 129.177049,
    "placeId": "ChIJQyiA3ZiNaDUR97iLNmXPJxE",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71309-0784",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 2,
    "id": 841
  },
  {
    "title": "CASA BUSANO Haeundae",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://instagram.com/casabusano",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmVcT316NaDUREDvrqjcFI_4",
    "lat": 35.1624635,
    "lng": 129.1601466,
    "placeId": "ChIJmVcT316NaDUREDvrqjcFI_4",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71321-6349",
    "openingHours": [
      "Monday: 8:30 AM – 2:00 AM",
      "Tuesday: 8:30 AM – 2:00 AM",
      "Wednesday: 8:30 AM – 2:00 AM",
      "Thursday: 8:30 AM – 2:00 AM",
      "Friday: 8:30 AM – 2:00 AM",
      "Saturday: 8:30 AM – 2:00 AM",
      "Sunday: 8:30 AM – 2:00 AM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 195,
    "id": 842,
    "district": "Haeundae"
  },
  {
    "title": "DUPLIT",
    "urlinform": "-duplit-stylish-caf-in-haeundae-duplit-duplit-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://duplit.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJizZDCgSNaDURZq9q8PxyGO0",
    "lat": 35.1643054,
    "lng": 129.1576309,
    "placeId": "ChIJizZDCgSNaDURZq9q8PxyGO0",
    "businessStatus": "OPERATIONAL",
    "phone": "051-746-2876",
    "openingHours": [
      "Monday: 9:00 AM – 10:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 10:00 PM",
      "Sunday: 9:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 419,
    "id": 843,
    "district": "Haeundae"
  },
  {
    "title": "TIDE Coffee Roasters",
    "urlinform": "store-70",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://instagram.com/tide_coffee_roasters",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4Q1rYnSNaDURPjAJeCysT_w",
    "lat": 35.157617,
    "lng": 129.1729163,
    "placeId": "ChIJ4Q1rYnSNaDURPjAJeCysT_w",
    "businessStatus": "OPERATIONAL",
    "phone": "051-715-3884",
    "openingHours": [
      "Monday: 9:30 AM – 6:30 PM",
      "Tuesday: Closed",
      "Wednesday: 9:30 AM – 6:30 PM",
      "Thursday: 9:30 AM – 6:30 PM",
      "Friday: 9:30 AM – 6:30 PM",
      "Saturday: 9:30 AM – 6:30 PM",
      "Sunday: 9:30 AM – 6:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 202,
    "id": 844,
    "district": "Haeundae"
  },
  {
    "title": "OLIVE YOUNG Haeundae",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtevkyEiNaDUR5uMkqBvKo-k",
    "lat": 35.1616828,
    "lng": 129.1608199,
    "placeId": "ChIJtevkyEiNaDUR5uMkqBvKo-k",
    "businessStatus": "OPERATIONAL",
    "phone": "051-747-5720",
    "openingHours": [
      "Monday: 10:00 AM – 11:00 PM",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 61,
    "id": 845,
    "district": "Haeundae"
  },
  {
    "title": "울트라레어",
    "urlinform": "store-72",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0Tcgx9uTaDUR_0EOYq7CBzM",
    "lat": 35.2369032,
    "lng": 129.0879159,
    "placeId": "ChIJ0Tcgx9uTaDUR_0EOYq7CBzM",
    "businessStatus": "OPERATIONAL",
    "phone": "051-515-5608",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 8,
    "id": 846
  },
  {
    "title": "The Gundam Base",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "Gundam"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_ZTNSNKTaDUR_QkG5L4ZyGA",
    "lat": 35.1701301,
    "lng": 129.1284282,
    "placeId": "ChIJ_ZTNSNKTaDUR_QkG5L4ZyGA",
    "businessStatus": "OPERATIONAL",
    "phone": "051-745-1468",
    "openingHours": [
      "Monday: 10:30 AM – 8:00 PM",
      "Tuesday: 10:30 AM – 8:00 PM",
      "Wednesday: 10:30 AM – 8:00 PM",
      "Thursday: 10:30 AM – 8:00 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 46,
    "id": 847
  },
  {
    "title": "CARDWORLD BKK",
    "urlinform": "cardworld-bkk",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/cardworld.bkk",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPzYX4NqZ4jAR42XsnKWtHi0",
    "lat": 13.7345399,
    "lng": 100.52708,
    "placeId": "ChIJPzYX4NqZ4jAR42XsnKWtHi0",
    "businessStatus": "OPERATIONAL",
    "phone": "080 051 6725",
    "openingHours": [
      "Monday: 10:30 AM – 8:00 PM",
      "Tuesday: 10:30 AM – 8:00 PM",
      "Wednesday: 10:30 AM – 8:00 PM",
      "Thursday: 10:30 AM – 8:00 PM",
      "Friday: 10:30 AM – 8:00 PM",
      "Saturday: 10:30 AM – 8:00 PM",
      "Sunday: 10:30 AM – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 319,
    "id": 848
  },
  {
    "title": "WUWAM CARD SHOP",
    "urlinform": "wuwam-card-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/wuwamcardshop",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTWd1VACZ4jARs8wQHLakH5g",
    "lat": 13.7452187,
    "lng": 100.5024664,
    "placeId": "ChIJTWd1VACZ4jARs8wQHLakH5g",
    "businessStatus": "CLOSED_TEMPORARILY",
    "phone": "",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 82,
    "id": 849,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Pro card",
    "urlinform": "pro-card",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/ProcardTCG",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJU7Swfb2f4jARDTxiLjPDzCo",
    "lat": 13.7437417,
    "lng": 100.5298648,
    "placeId": "ChIJU7Swfb2f4jARDTxiLjPDzCo",
    "businessStatus": "OPERATIONAL",
    "phone": "063 456 4426",
    "openingHours": [
      "Monday: 11:00 AM – 7:30 PM",
      "Tuesday: 11:00 AM – 7:30 PM",
      "Wednesday: 11:00 AM – 7:30 PM",
      "Thursday: 11:00 AM – 7:30 PM",
      "Friday: 11:00 AM – 7:30 PM",
      "Saturday: 11:00 AM – 7:30 PM",
      "Sunday: 11:00 AM – 7:30 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 50,
    "id": 850,
    "district": "Siam"
  },
  {
    "title": "GL Card Game",
    "urlinform": "gl-card-game",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Vanguard"
    ],
    "storeWebsite": "https://glcardgame.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxztnGnCf4jARxtDKD-JcXRs",
    "lat": 13.7160894,
    "lng": 100.5275578,
    "placeId": "ChIJxztnGnCf4jARxtDKD-JcXRs",
    "businessStatus": "OPERATIONAL",
    "phone": "091 804 4990",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:30 AM – 7:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 22,
    "id": 851
  },
  {
    "title": "Artifax",
    "urlinform": "artifax",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/artifaxbkk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqycuHBOf4jARltd7PJ2wM2U",
    "lat": 13.7244537,
    "lng": 100.5306282,
    "placeId": "ChIJqycuHBOf4jARltd7PJ2wM2U",
    "businessStatus": "OPERATIONAL",
    "phone": "083 062 5266",
    "openingHours": [
      "Monday: 10:30 AM – 5:30 PM",
      "Tuesday: 10:30 AM – 5:30 PM",
      "Wednesday: 10:30 AM – 5:30 PM",
      "Thursday: 10:30 AM – 5:30 PM",
      "Friday: 10:30 AM – 5:30 PM",
      "Saturday: 10:30 AM – 5:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.4,
    "userRatingsTotal": 72,
    "id": 852
  },
  {
    "title": "Pokémon PLAYLAB @B2S CENTRAL WORLD",
    "urlinform": "pokmon-playlab-b2s-central-world",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb6099oaf4jARjzZjLz5ru6k",
    "lat": 13.7467916,
    "lng": 100.5392377,
    "placeId": "ChIJb6099oaf4jARjzZjLz5ru6k",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 48,
    "id": 853,
    "district": "Siam"
  },
  {
    "title": "DAILY​ ​RARE​ CARD GAME MBK",
    "urlinform": "daily-rare-card-game-mbk",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs-AMOQCf4jAR2qYUo6tKCa0",
    "lat": 13.7447542,
    "lng": 100.529956,
    "placeId": "ChIJs-AMOQCf4jAR2qYUo6tKCa0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 3,
    "id": 854,
    "district": "Siam"
  },
  {
    "title": "TCG Nexus",
    "urlinform": "tcg-nexus",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/tcgnexus",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEbmAaUCc4jARUK0NPWDGDJU",
    "lat": 13.8076689,
    "lng": 100.5755117,
    "placeId": "ChIJEbmAaUCc4jARUK0NPWDGDJU",
    "businessStatus": "OPERATIONAL",
    "phone": "081 301 6679",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 55,
    "id": 855
  },
  {
    "title": "VG card shop",
    "urlinform": "vg-card-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://vgcardshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ68TqAWqZ4jAR9dNrj6YgkRE",
    "lat": 13.7457736,
    "lng": 100.5002608,
    "placeId": "ChIJ68TqAWqZ4jAR9dNrj6YgkRE",
    "businessStatus": "OPERATIONAL",
    "phone": "090 279 7603",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 11:00 AM – 5:30 PM",
      "Thursday: 11:00 AM – 5:30 PM",
      "Friday: 11:00 AM – 5:30 PM",
      "Saturday: 11:00 AM – 5:30 PM",
      "Sunday: 11:00 AM – 5:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 67,
    "id": 856
  },
  {
    "title": "Sabaicards",
    "urlinform": "sabaicards",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.sabaicards.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3dK-jS6f4jARtgQ7Pzyo0NY",
    "lat": 13.7463764,
    "lng": 100.5625858,
    "placeId": "ChIJ3dK-jS6f4jARtgQ7Pzyo0NY",
    "businessStatus": "OPERATIONAL",
    "phone": "099 443 4378",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 28,
    "id": 857,
    "district": "Sukhumvit"
  },
  {
    "title": "โอโซนแลนด์ Centerpoint Siam Square (OZoneland เซ็นเตอร์พอยท์ สยามสแควร์) ร้านคีบตุ๊กตา",
    "urlinform": "-centerpoint-siam-square-ozoneland-",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/OZonelandTH/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0XBIubOf4jARDcECtojMT30",
    "lat": 13.7452519,
    "lng": 100.5331429,
    "placeId": "ChIJ0XBIubOf4jARDcECtojMT30",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 9:30 PM",
      "Tuesday: 10:30 AM – 9:30 PM",
      "Wednesday: 10:30 AM – 9:30 PM",
      "Thursday: 10:30 AM – 9:30 PM",
      "Friday: 10:30 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 211,
    "id": 858,
    "district": "Siam"
  },
  {
    "title": "Bob Card",
    "urlinform": "bob-card",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/BobCardShop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ71QBfSqZ4jARqdGI_i83Q40",
    "lat": 13.735076,
    "lng": 100.5267399,
    "placeId": "ChIJ71QBfSqZ4jARqdGI_i83Q40",
    "businessStatus": "OPERATIONAL",
    "phone": "086 334 7348",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.6,
    "userRatingsTotal": 29,
    "id": 859
  },
  {
    "title": "Midnight card game",
    "urlinform": "midnight-card-game",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJ_b8LamZ4jARzeUwZNqLM68",
    "lat": 13.7399802,
    "lng": 100.5251128,
    "placeId": "ChIJJ_b8LamZ4jARzeUwZNqLM68",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "id": 860
  },
  {
    "title": "Yannick The Gathering",
    "urlinform": "yannick-the-gathering",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://yannickthegathering.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ58Ej2mf4jAR4fqvU8MqjPQ",
    "lat": 13.7182142,
    "lng": 100.5771106,
    "placeId": "ChIJZ58Ej2mf4jAR4fqvU8MqjPQ",
    "businessStatus": "OPERATIONAL",
    "phone": "092 257 5154",
    "openingHours": [
      "Monday: 11:00 AM – 11:00 PM",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 114,
    "id": 861
  },
  {
    "title": "CARD STATIONxBKK",
    "urlinform": "card-stationxbkk",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61589116387781",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9dJ6JQCd4jARpkMwLJZGokk",
    "lat": 13.8134628,
    "lng": 100.5618657,
    "placeId": "ChIJ9dJ6JQCd4jARpkMwLJZGokk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 9:30 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 69,
    "id": 862
  },
  {
    "title": "Hit Effect Board Game and TCG store",
    "urlinform": "hit-effect-board-game-and-tcg-store",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61574427309925",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjahQKoaf4jARR3mFEgvXa5U",
    "lat": 13.7700405,
    "lng": 100.5718652,
    "placeId": "ChIJjahQKoaf4jARR3mFEgvXa5U",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 12:00 AM",
      "Tuesday: 11:00 AM – 12:00 AM",
      "Wednesday: 11:00 AM – 12:00 AM",
      "Thursday: 11:00 AM – 12:00 AM",
      "Friday: 11:00 AM – 2:00 AM",
      "Saturday: 11:00 AM – 2:00 AM",
      "Sunday: 11:00 AM – 12:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 70,
    "id": 863
  },
  {
    "title": "Modern Cards",
    "urlinform": "modern-cards",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Moderncards.th/?fb_dtsg_ag=Adx5rV05TBnOIravu0XU78-FkF-9JNKNMElxFtmod-m4lA:AdxDuaLQF5J_gC9T_YC2yzmOJw9giSihvvfHJcATqBfGnw",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnV_vqquZ4jARKxwu8_a28js",
    "lat": 13.7453692,
    "lng": 100.5031707,
    "placeId": "ChIJnV_vqquZ4jARKxwu8_a28js",
    "businessStatus": "OPERATIONAL",
    "phone": "086 392 1449",
    "openingHours": [
      "Monday: 11:30 AM – 6:00 PM",
      "Tuesday: 11:30 AM – 6:00 PM",
      "Wednesday: 11:30 AM – 6:00 PM",
      "Thursday: 11:30 AM – 6:00 PM",
      "Friday: 11:30 AM – 6:00 PM",
      "Saturday: 11:30 AM – 6:00 PM",
      "Sunday: 11:30 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 95,
    "id": 864,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "ตู้จุ่มการ์ด iCardz - Banthatthong Bkk.",
    "urlinform": "-icardz-banthatthong-bkk",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://facebook.com/icardz2025",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJp782bbmZ4jARH5-0Sd_zzwE",
    "lat": 13.7524303,
    "lng": 100.5260181,
    "placeId": "ChIJp782bbmZ4jARH5-0Sd_zzwE",
    "businessStatus": "OPERATIONAL",
    "phone": "095 505 2390",
    "openingHours": [
      "Monday: 10:30 AM – 3:00 AM",
      "Tuesday: 10:30 AM – 3:00 AM",
      "Wednesday: 10:30 AM – 3:00 AM",
      "Thursday: 10:30 AM – 3:00 AM",
      "Friday: 10:30 AM – 3:00 AM",
      "Saturday: 10:30 AM – 3:00 AM",
      "Sunday: 10:30 AM – 3:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 865,
    "district": "Siam"
  },
  {
    "title": "Kinoko Card Game Shop",
    "urlinform": "kinoko-card-game-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://www.kinokocards.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJV679lkGd4jAR4eeyoZR7wNM",
    "lat": 13.7886284,
    "lng": 100.5865085,
    "placeId": "ChIJV679lkGd4jAR4eeyoZR7wNM",
    "businessStatus": "OPERATIONAL",
    "phone": "095 283 7795",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 159,
    "id": 866
  },
  {
    "title": "Cardify ร้านการ์ด TCG & Collectibles พุทธมณฑลสาย 1",
    "urlinform": "cardify-tcg-collectibles-1",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61583706120286",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt-GHcgCX4jARlY2jEj1KDVI",
    "lat": 13.7205133,
    "lng": 100.4283179,
    "placeId": "ChIJt-GHcgCX4jARlY2jEj1KDVI",
    "businessStatus": "OPERATIONAL",
    "phone": "092 447 6464",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 139,
    "id": 867
  },
  {
    "title": "Jakarade",
    "urlinform": "jakarade",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.jakarade.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmVrtnuOe4jAR6aULKB6vjJM",
    "lat": 13.7376747,
    "lng": 100.5606384,
    "placeId": "ChIJmVrtnuOe4jAR6aULKB6vjJM",
    "businessStatus": "OPERATIONAL",
    "phone": "085 483 5483",
    "openingHours": [
      "Monday: 10:15 AM – 10:00 PM",
      "Tuesday: 10:15 AM – 10:00 PM",
      "Wednesday: 10:15 AM – 10:00 PM",
      "Thursday: 10:15 AM – 10:00 PM",
      "Friday: 10:15 AM – 10:00 PM",
      "Saturday: 10:15 AM – 10:00 PM",
      "Sunday: 10:15 AM – 10:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 155,
    "id": 868,
    "district": "Sukhumvit"
  },
  {
    "title": "OjamaCard",
    "urlinform": "ojamacard",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://ojamacard.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN8vKYR-j4jARDNBHGmOaHxs",
    "lat": 13.6511587,
    "lng": 100.4969631,
    "placeId": "ChIJN8vKYR-j4jARDNBHGmOaHxs",
    "businessStatus": "OPERATIONAL",
    "phone": "084 751 0766",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:30 – 5:00 PM",
      "Wednesday: 12:30 – 5:00 PM",
      "Thursday: 12:30 – 5:00 PM",
      "Friday: 12:30 – 5:00 PM",
      "Saturday: 12:30 – 5:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.4,
    "userRatingsTotal": 7,
    "id": 869
  },
  {
    "title": "Tong Duel",
    "urlinform": "tong-duel",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/tongduel/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJT1JhzmOd4jARo5ZcvhlzGQ4",
    "lat": 13.8380382,
    "lng": 100.5750767,
    "placeId": "ChIJT1JhzmOd4jARo5ZcvhlzGQ4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 8:00 PM",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 2:00 – 8:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 9,
    "id": 870
  },
  {
    "title": "Jakarade HQ",
    "urlinform": "jakarade-hq",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.jakarade.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIa7KjkWf4jARY-dLqOi8paI",
    "lat": 13.7764288,
    "lng": 100.6063409,
    "placeId": "ChIJIa7KjkWf4jARY-dLqOi8paI",
    "businessStatus": "OPERATIONAL",
    "phone": "085 483 5483",
    "openingHours": [
      "Monday: 10:15 AM – 8:00 PM",
      "Tuesday: 10:15 AM – 8:00 PM",
      "Wednesday: 10:15 AM – 8:00 PM",
      "Thursday: 10:15 AM – 8:00 PM",
      "Friday: 10:15 AM – 8:00 PM",
      "Saturday: 10:15 AM – 8:00 PM",
      "Sunday: 10:15 AM – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 4,
    "id": 871
  },
  {
    "title": "Big Bear Cards and Hobby",
    "urlinform": "big-bear-cards-and-hobby",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Digimon",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "https://bigbearcards.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD6Vl8mphHTER7bSM73KZ2ng",
    "lat": 13.7258395,
    "lng": 100.643077,
    "placeId": "ChIJD6Vl8mphHTER7bSM73KZ2ng",
    "businessStatus": "OPERATIONAL",
    "phone": "095 731 3536",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 7:30 PM",
      "Wednesday: 2:00 – 7:30 PM",
      "Thursday: 2:00 – 7:30 PM",
      "Friday: 2:00 – 7:30 PM",
      "Saturday: 1:00 – 8:30 PM",
      "Sunday: 1:00 – 8:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 18,
    "id": 872
  },
  {
    "title": "Power9 Card Store",
    "urlinform": "power9-card-store",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://power9cardstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJef0mdI-Z4jARDkn8TW8LT20",
    "lat": 13.7455769,
    "lng": 100.5030437,
    "placeId": "ChIJef0mdI-Z4jARDkn8TW8LT20",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 3:20 PM",
      "Wednesday: 12:00 – 3:20 PM",
      "Thursday: 12:00 – 3:20 PM",
      "Friday: 12:00 – 3:20 PM",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 8,
    "id": 873,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "iPlay card shop",
    "urlinform": "iplay-card-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/iplaycard/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgxCDcUCc4jARBpIKZr6ISMM",
    "lat": 13.7829297,
    "lng": 100.5462578,
    "placeId": "ChIJgxCDcUCc4jARBpIKZr6ISMM",
    "businessStatus": "OPERATIONAL",
    "phone": "088 242 6669",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: Closed",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.5,
    "userRatingsTotal": 34,
    "id": 874
  },
  {
    "title": "The CardZ Shop",
    "urlinform": "the-cardz-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.thecardzshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP7zOiL2f4jARtY6oMT5l29Y",
    "lat": 13.7438373,
    "lng": 100.5298647,
    "placeId": "ChIJP7zOiL2f4jARtY6oMT5l29Y",
    "businessStatus": "OPERATIONAL",
    "phone": "065 456 4749",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 2.6,
    "userRatingsTotal": 18,
    "id": 875,
    "district": "Siam"
  },
  {
    "title": "Middle Earth Wargame",
    "urlinform": "middle-earth-wargame",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/middleearthwargame/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFZl4sXOZ4jAR0M5Ks9_tkcQ",
    "lat": 13.7343459,
    "lng": 100.5266173,
    "placeId": "ChIJFZl4sXOZ4jAR0M5Ks9_tkcQ",
    "businessStatus": "OPERATIONAL",
    "phone": "096 849 0432",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 43,
    "id": 876
  },
  {
    "title": "Nut card",
    "urlinform": "nut-card",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9S70JySZ4jARy1sqaMrgxys",
    "lat": 13.7454818,
    "lng": 100.5023959,
    "placeId": "ChIJ9S70JySZ4jARy1sqaMrgxys",
    "businessStatus": "OPERATIONAL",
    "phone": "084 668 6541",
    "openingHours": [
      "Monday: 10:30 AM – 6:00 PM",
      "Tuesday: 10:30 AM – 6:00 PM",
      "Wednesday: 10:30 AM – 6:00 PM",
      "Thursday: 10:30 AM – 6:00 PM",
      "Friday: 10:30 AM – 6:00 PM",
      "Saturday: 10:30 AM – 6:00 PM",
      "Sunday: 10:30 AM – 6:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 355,
    "id": 877,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Legend Heroes Sports Siam Discovery",
    "urlinform": "legend-heroes-sports-siam-discovery",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcUBWDwCf4jARVAo_jwtMSRI",
    "lat": 13.7468056,
    "lng": 100.5313591,
    "placeId": "ChIJcUBWDwCf4jARVAo_jwtMSRI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 62,
    "id": 878,
    "district": "Siam"
  },
  {
    "title": "Cardster",
    "urlinform": "the-cardster-sports-cards",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://thecardster.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUcJUxRyZ4jAROZZAz6ChDeg",
    "lat": 13.7453275,
    "lng": 100.5024932,
    "placeId": "ChIJUcJUxRyZ4jAROZZAz6ChDeg",
    "businessStatus": "OPERATIONAL",
    "phone": "065 649 9996",
    "openingHours": [
      "Monday: 10:30 AM – 6:30 PM",
      "Tuesday: 10:30 AM – 6:30 PM",
      "Wednesday: 10:30 AM – 6:30 PM",
      "Thursday: 10:30 AM – 6:30 PM",
      "Friday: 10:30 AM – 6:30 PM",
      "Saturday: 10:30 AM – 6:30 PM",
      "Sunday: 10:30 AM – 6:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 228,
    "id": 879,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Delfin TCG",
    "urlinform": "delfin-tcg",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/DelfinTCG",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNWwTGX6b4jARfoN_tGtfXEk",
    "lat": 13.7833685,
    "lng": 100.4933932,
    "placeId": "ChIJNWwTGX6b4jARfoN_tGtfXEk",
    "businessStatus": "OPERATIONAL",
    "phone": "085 768 9669",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 880
  },
  {
    "title": "Siam Gameshop - Playstation Concept Store",
    "urlinform": "siam-gameshop-playstation-concept-store",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.siamgameshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJU8VjHdKe4jARvesDWNsXFSw",
    "lat": 13.7451098,
    "lng": 100.5327572,
    "placeId": "ChIJU8VjHdKe4jARvesDWNsXFSw",
    "businessStatus": "OPERATIONAL",
    "phone": "081 869 2989",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 90,
    "id": 881,
    "district": "Siam"
  },
  {
    "title": "Winning Zone",
    "urlinform": "winning-zone",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/winningzone",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJdWGikLaf4jARpwnLuX1XLcM",
    "lat": 13.7450703,
    "lng": 100.5326711,
    "placeId": "ChIJdWGikLaf4jARpwnLuX1XLcM",
    "businessStatus": "OPERATIONAL",
    "phone": "081 869 2989",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 882,
    "district": "Siam"
  },
  {
    "title": "TopLoad TCG",
    "urlinform": "topload-tcg",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/share/1BWhyfp6h9/?mibextid=wwXIfr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc4ynLQCf4jAR98HtMwwHcmY",
    "lat": 13.7005465,
    "lng": 100.6136821,
    "placeId": "ChIJc4ynLQCf4jAR98HtMwwHcmY",
    "businessStatus": "OPERATIONAL",
    "phone": "089 824 1163",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 148,
    "id": 883
  },
  {
    "title": "Castle Black TCG",
    "urlinform": "castle-black-tcg",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Lorcana",
      "MTG",
      "Pokémon"
    ],
    "storeWebsite": "https://www.castleblacktcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbc15eiCf4jARl9D460HvgTo",
    "lat": 13.7582944,
    "lng": 100.5409694,
    "placeId": "ChIJbc15eiCf4jARl9D460HvgTo",
    "businessStatus": "OPERATIONAL",
    "phone": "095 908 0514",
    "openingHours": [
      "Monday: 5:00 PM – 1:00 AM",
      "Tuesday: 5:00 PM – 1:00 AM",
      "Wednesday: Closed",
      "Thursday: 5:00 PM – 1:00 AM",
      "Friday: 5:00 PM – 1:00 AM",
      "Saturday: 5:00 PM – 1:00 AM",
      "Sunday: 5:00 PM – 1:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 23,
    "id": 884
  },
  {
    "title": "High Score TCG",
    "urlinform": "high-score-tcg",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://highscoretcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJR97JwBfHTERm0oYt5g1AxY",
    "lat": 13.6720761,
    "lng": 100.6436535,
    "placeId": "ChIJJR97JwBfHTERm0oYt5g1AxY",
    "businessStatus": "OPERATIONAL",
    "phone": "096 921 0366",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 3:00 – 11:00 PM",
      "Sunday: 3:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 274,
    "id": 885
  },
  {
    "title": "Fortunata TCG Cafe & Store",
    "urlinform": "fortunata-tcg-cafe-store",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/fortunatatcg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSdcY_UGZ4jARRsB9W-5dJxU",
    "lat": 13.6948676,
    "lng": 100.4952994,
    "placeId": "ChIJSdcY_UGZ4jARRsB9W-5dJxU",
    "businessStatus": "OPERATIONAL",
    "phone": "098 970 5332",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 886
  },
  {
    "title": "Smile TCG การ์ดเกม",
    "urlinform": "smile-tcg-",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVaml3RWX4jARINg4F3DJDhA",
    "lat": 13.7130878,
    "lng": 100.3778162,
    "placeId": "ChIJVaml3RWX4jARINg4F3DJDhA",
    "businessStatus": "OPERATIONAL",
    "phone": "081 147 4888",
    "openingHours": [
      "Monday: 4:00 PM – 4:00 AM",
      "Tuesday: 4:00 PM – 4:00 AM",
      "Wednesday: 4:00 PM – 4:00 AM",
      "Thursday: 4:00 PM – 4:00 AM",
      "Friday: 4:00 PM – 4:00 AM",
      "Saturday: 4:00 PM – 4:00 AM",
      "Sunday: 4:00 PM – 4:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "id": 887
  },
  {
    "title": "Stickerland",
    "urlinform": "stickerland",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi4eV6kWf4jAR8TsGD36Lh7s",
    "lat": 13.7452769,
    "lng": 100.5321886,
    "placeId": "ChIJi4eV6kWf4jAR8TsGD36Lh7s",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 41,
    "id": 888,
    "district": "Siam"
  },
  {
    "title": "Quest Board Game Café",
    "urlinform": "quest-board-game-caf",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/QuestBoardgame",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYfhd2cSf4jARzxkJYCN8A8o",
    "lat": 13.7435021,
    "lng": 100.5295168,
    "placeId": "ChIJYfhd2cSf4jARzxkJYCN8A8o",
    "businessStatus": "OPERATIONAL",
    "phone": "095 387 0346",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 934,
    "id": 889,
    "district": "Siam"
  },
  {
    "title": "Siam Center",
    "urlinform": "siam-center",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.siamcenter.co.th/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKxtCgc2e4jARLGP1pTT8r6E",
    "lat": 13.7462793,
    "lng": 100.5326779,
    "placeId": "ChIJKxtCgc2e4jARLGP1pTT8r6E",
    "businessStatus": "OPERATIONAL",
    "phone": "02 658 1000",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 8596,
    "id": 890,
    "district": "Siam"
  },
  {
    "title": "Smart by DHAS",
    "urlinform": "smart-by-dhas",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/smartofficialTH",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ02crD8mZ4jARYpjAiOz9n88",
    "lat": 13.7282254,
    "lng": 100.525261,
    "placeId": "ChIJ02crD8mZ4jARYpjAiOz9n88",
    "businessStatus": "OPERATIONAL",
    "phone": "02 668 0123",
    "openingHours": [
      "Monday: 9:00 AM – 5:00 PM",
      "Tuesday: 9:00 AM – 5:00 PM",
      "Wednesday: 9:00 AM – 5:00 PM",
      "Thursday: 9:00 AM – 5:00 PM",
      "Friday: 9:00 AM – 5:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.6,
    "userRatingsTotal": 11,
    "id": 891
  },
  {
    "title": "MBK CENTER",
    "urlinform": "mbk-center",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.mbk-center.co.th/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7TZ3I5Of4jAR3lZ2lx-zXkA",
    "lat": 13.7447542,
    "lng": 100.529956,
    "placeId": "ChIJ7TZ3I5Of4jAR3lZ2lx-zXkA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 853 9000",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 64814,
    "id": 892,
    "district": "Siam"
  },
  {
    "title": "The Old Siam Plaza",
    "urlinform": "the-old-siam-plaza",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://theoldsiam.co.th/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ--JkFRqZ4jARIs3bti0zBBg",
    "lat": 13.7456817,
    "lng": 100.5000172,
    "placeId": "ChIJ--JkFRqZ4jARIs3bti0zBBg",
    "businessStatus": "OPERATIONAL",
    "phone": "02 226 0156",
    "openingHours": [
      "Monday: 9:00 AM – 8:00 PM",
      "Tuesday: 9:00 AM – 8:00 PM",
      "Wednesday: 9:00 AM – 8:00 PM",
      "Thursday: 9:00 AM – 8:00 PM",
      "Friday: 9:00 AM – 8:00 PM",
      "Saturday: 9:00 AM – 8:00 PM",
      "Sunday: 9:00 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 12552,
    "id": 893
  },
  {
    "title": "The CardZ Shop Cabinet",
    "urlinform": "the-cardz-shop-cabinet",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.thecardzshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW9dF_Mud4jARNL6Lj-012v0",
    "lat": 13.8018571,
    "lng": 100.5508782,
    "placeId": "ChIJW9dF_Mud4jARNL6Lj-012v0",
    "businessStatus": "OPERATIONAL",
    "phone": "065 456 4749",
    "openingHours": [
      "Monday: 10:00 AM – 7:30 PM",
      "Tuesday: 10:00 AM – 7:30 PM",
      "Wednesday: 10:00 AM – 7:30 PM",
      "Thursday: 10:00 AM – 7:30 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 2,
    "id": 894,
    "district": "Chatuchak"
  },
  {
    "title": "Siam Square",
    "urlinform": "siam-square",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://pmcu.co.th/?page_id=9374",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-eVRBSqf4jAROZPeOeJOhqg",
    "lat": 13.7446395,
    "lng": 100.5329147,
    "placeId": "ChIJ-eVRBSqf4jAROZPeOeJOhqg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 2942,
    "id": 895,
    "district": "Siam"
  },
  {
    "title": "Jakarade Card Shop",
    "urlinform": "jakarade-card-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJubUVJgCf4jARW0M16NLqPQs",
    "lat": 13.7455824,
    "lng": 100.5338277,
    "placeId": "ChIJubUVJgCf4jARW0M16NLqPQs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 1.5,
    "userRatingsTotal": 2,
    "id": 896,
    "district": "Siam"
  },
  {
    "title": "Wappen Friends",
    "urlinform": "wappen-friends",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs0ACPQCf4jARH97N1XXCg3Q",
    "lat": 13.7452346,
    "lng": 100.534055,
    "placeId": "ChIJs0ACPQCf4jARH97N1XXCg3Q",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 181,
    "id": 897,
    "district": "Siam"
  },
  {
    "title": "The CardZ Shop",
    "urlinform": "the-cardz-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.thecardzshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ61JpQiGZ4jARF-khLv42lj8",
    "lat": 13.7452223,
    "lng": 100.5024221,
    "placeId": "ChIJ61JpQiGZ4jARF-khLv42lj8",
    "businessStatus": "OPERATIONAL",
    "phone": "065 456 4749",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 4,
    "id": 898,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "MINISO LAND Siam Square",
    "urlinform": "miniso-land-siam-square",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNVClGgCf4jAREUs09FQNBnI",
    "lat": 13.7440366,
    "lng": 100.5341712,
    "placeId": "ChIJNVClGgCf4jAREUs09FQNBnI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 118,
    "id": 899,
    "district": "Siam"
  },
  {
    "title": "Jupigale Shop",
    "urlinform": "jupigale-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTZJ8CwCd4jAR1FXdusFo04o",
    "lat": 13.7985893,
    "lng": 100.5480585,
    "placeId": "ChIJTZJ8CwCd4jAR1FXdusFo04o",
    "businessStatus": "OPERATIONAL",
    "phone": "080 519 5164",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 900,
    "district": "Chatuchak"
  },
  {
    "title": "PKCardGame",
    "urlinform": "pkcardgame",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/PKCardGame/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJkexTyVqc4jARHTqQmROMH9A",
    "lat": 13.832948,
    "lng": 100.5707933,
    "placeId": "ChIJkexTyVqc4jARHTqQmROMH9A",
    "businessStatus": "OPERATIONAL",
    "phone": "062 765 9750",
    "openingHours": [
      "Monday: 2:00 – 7:30 PM",
      "Tuesday: 2:00 – 7:30 PM",
      "Wednesday: 2:00 – 7:30 PM",
      "Thursday: 2:00 – 7:30 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 17,
    "id": 901
  },
  {
    "title": "Kitty's Card MTG",
    "urlinform": "kittys-card-mtg",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOZ1p8D-c4jARgNvh6ZHSPNc",
    "lat": 13.7989321,
    "lng": 100.5480022,
    "placeId": "ChIJOZ1p8D-c4jARgNvh6ZHSPNc",
    "businessStatus": "OPERATIONAL",
    "phone": "099 425 4445",
    "openingHours": [
      "Monday: 2:00 – 9:30 PM",
      "Tuesday: 2:00 – 9:30 PM",
      "Wednesday: 2:00 – 9:30 PM",
      "Thursday: 2:00 – 9:30 PM",
      "Friday: 2:00 – 9:30 PM",
      "Saturday: 2:00 – 9:30 PM",
      "Sunday: 2:00 – 9:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 6,
    "id": 902,
    "district": "Chatuchak"
  },
  {
    "title": "The CardZ Shop Cabinet",
    "urlinform": "the-cardz-shop-cabinet",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.thecardzshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx32eByWd4jARMjpYI3rj-8g",
    "lat": 13.8173176,
    "lng": 100.5619022,
    "placeId": "ChIJx32eByWd4jARMjpYI3rj-8g",
    "businessStatus": "OPERATIONAL",
    "phone": "065 456 4749",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 903
  },
  {
    "title": "UPA FORGE ตู้กดการ์ด",
    "urlinform": "-",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx6FjJACd4jAR_vhcIC37804",
    "lat": 13.8134997,
    "lng": 100.5618672,
    "placeId": "ChIJx6FjJACd4jAR_vhcIC37804",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 904
  },
  {
    "title": "Haven TCG @Ari",
    "urlinform": "haven-tcg-ari",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/share/1E8fmNKnyD/?mibextid=wwXIfr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2wyFGFud4jAREkww6KeVWi8",
    "lat": 13.7887334,
    "lng": 100.5402345,
    "placeId": "ChIJ2wyFGFud4jAREkww6KeVWi8",
    "businessStatus": "OPERATIONAL",
    "phone": "092 542 5469",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 905
  },
  {
    "title": "T-Toy Game(TheMixt)",
    "urlinform": "t-toy-gamethemixt",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE2M02dWd4jARa50Qz-agjww",
    "lat": 13.8019904,
    "lng": 100.5509773,
    "placeId": "ChIJE2M02dWd4jARa50Qz-agjww",
    "businessStatus": "OPERATIONAL",
    "phone": "097 165 8915",
    "openingHours": [
      "Monday: 10:30 AM – 7:30 PM",
      "Tuesday: 10:30 AM – 7:30 PM",
      "Wednesday: 10:30 AM – 7:30 PM",
      "Thursday: 10:30 AM – 7:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:00 AM – 8:30 PM",
      "Sunday: 10:00 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 13,
    "id": 906,
    "district": "Chatuchak"
  },
  {
    "title": "Mono Loop",
    "urlinform": "mono-loop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/p/MONO-LOOP-100083915884613/?locale=de_DE",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6aAoZvCd4jARAZwBTiAdm6Q",
    "lat": 13.8019886,
    "lng": 100.5510027,
    "placeId": "ChIJ6aAoZvCd4jARAZwBTiAdm6Q",
    "businessStatus": "OPERATIONAL",
    "phone": "080 080 1599",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 71,
    "id": 907,
    "district": "Chatuchak"
  },
  {
    "title": "Gameshop Concept Store",
    "urlinform": "gameshop-concept-store",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.gameshopconceptstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZz1441qc4jARd-sFH1Kril0",
    "lat": 13.8159302,
    "lng": 100.5611421,
    "placeId": "ChIJZz1441qc4jARd-sFH1Kril0",
    "businessStatus": "OPERATIONAL",
    "phone": "080 608 3883",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 127,
    "id": 908
  },
  {
    "title": "Nx Gallery - Card Game & Board Game Cafe",
    "urlinform": "nx-gallery-card-game-board-game-cafe",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/NxGallery",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmw5C9-Wd4jARL4qSuBJ7sTc",
    "lat": 13.788399,
    "lng": 100.603531,
    "placeId": "ChIJmw5C9-Wd4jARL4qSuBJ7sTc",
    "businessStatus": "OPERATIONAL",
    "phone": "061 617 9263",
    "openingHours": [
      "Monday: 3:00 PM – 12:00 AM",
      "Tuesday: 3:00 PM – 12:00 AM",
      "Wednesday: Closed",
      "Thursday: 3:00 PM – 12:00 AM",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 548,
    "id": 909
  },
  {
    "title": "OnPlay",
    "urlinform": "onplay",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://shop.onplay.in.th/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8ZPOgR2c4jARYblEtnv-sTI",
    "lat": 13.7801817,
    "lng": 100.5436294,
    "placeId": "ChIJ8ZPOgR2c4jARYblEtnv-sTI",
    "businessStatus": "OPERATIONAL",
    "phone": "083 603 6041",
    "openingHours": [
      "Monday: 2:00 PM – 12:00 AM",
      "Tuesday: 2:00 PM – 12:00 AM",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 2:00 PM – 12:00 AM",
      "Saturday: 2:00 PM – 12:00 AM",
      "Sunday: 2:00 PM – 12:00 AM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 32,
    "id": 910
  },
  {
    "title": "1st Pick Hobby Store",
    "urlinform": "1st-pick-hobby-store",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Flesh and Blood",
      "MTG"
    ],
    "storeWebsite": "http://1stpickhs-onlineshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ12RvyJuf4jARLFFWrsu_U24",
    "lat": 13.7605051,
    "lng": 100.565596,
    "placeId": "ChIJ12RvyJuf4jARLFFWrsu_U24",
    "businessStatus": "OPERATIONAL",
    "phone": "066 154 1959",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: Closed",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 3:00 – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 8,
    "id": 911
  },
  {
    "title": "ร้าน Secret One",
    "urlinform": "-secret-one",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/secretone2011?mibextid=LQQJ4d",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP3zx8D6d4jARcE0s144fkCE",
    "lat": 13.8023732,
    "lng": 100.5513581,
    "placeId": "ChIJP3zx8D6d4jARcE0s144fkCE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 7:30 PM",
      "Tuesday: 10:30 AM – 7:30 PM",
      "Wednesday: 10:30 AM – 7:30 PM",
      "Thursday: 10:30 AM – 7:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 912,
    "district": "Chatuchak"
  },
  {
    "title": "Box Shop | ร้านการ์ด Pokemon, One piece",
    "urlinform": "box-shop-pokemon-one-piece",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.facebook.com/boxshopbox",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBdSbuy2d4jARyN3CD7UjYZg",
    "lat": 13.8059685,
    "lng": 100.5676771,
    "placeId": "ChIJBdSbuy2d4jARyN3CD7UjYZg",
    "businessStatus": "OPERATIONAL",
    "phone": "081 651 1172",
    "openingHours": [
      "Monday: 10:30 AM – 6:30 PM",
      "Tuesday: 10:30 AM – 6:30 PM",
      "Wednesday: 10:30 AM – 6:30 PM",
      "Thursday: 10:30 AM – 6:30 PM",
      "Friday: 10:30 AM – 6:30 PM",
      "Saturday: 11:00 AM – 1:00 PM",
      "Sunday: 11:00 AM – 1:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 913
  },
  {
    "title": "On Stack Board Game & TCG",
    "urlinform": "on-stack-board-game-tcg",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/share/1NcUCfusWc/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcQeGHC6d4jARCWDhfQLj7LQ",
    "lat": 13.828299,
    "lng": 100.5691707,
    "placeId": "ChIJcQeGHC6d4jARCWDhfQLj7LQ",
    "businessStatus": "OPERATIONAL",
    "phone": "094 541 6419",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 72,
    "id": 914
  },
  {
    "title": "Z.A. Zeal Arena",
    "urlinform": "za-zeal-arena",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/share/1CpDXPk3Hw/?mibextid=wwXIfr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfywyDHid4jARtXXA33hJDQk",
    "lat": 13.8397156,
    "lng": 100.5745259,
    "placeId": "ChIJfywyDHid4jARtXXA33hJDQk",
    "businessStatus": "OPERATIONAL",
    "phone": "095 537 3385",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 3:00 – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 9,
    "id": 915
  },
  {
    "title": "Weekend Card Shop",
    "urlinform": "weekend-card-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://shopee.co.th/weekendcardshop",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWScc4dyd4jAR4WQjnzBvDKs",
    "lat": 13.8298244,
    "lng": 100.5703642,
    "placeId": "ChIJWScc4dyd4jAR4WQjnzBvDKs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 916
  },
  {
    "title": "BearCave Cards @ Mixt Chatuchak",
    "urlinform": "bearcave-cards-mixt-chatuchak",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2wc_XQCd4jARt-uStdIQ9rI",
    "lat": 13.8025664,
    "lng": 100.5512336,
    "placeId": "ChIJ2wc_XQCd4jARt-uStdIQ9rI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 8:00 AM",
      "Tuesday: 9:00 AM – 8:00 PM",
      "Wednesday: 9:00 AM – 8:00 PM",
      "Thursday: 9:00 AM – 8:00 PM",
      "Friday: 9:00 AM – 9:00 PM",
      "Saturday: 9:00 AM – 9:00 PM",
      "Sunday: 9:00 AM – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 917,
    "district": "Chatuchak"
  },
  {
    "title": "Hobby Bugong",
    "urlinform": "hobby-bugong",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://hobbybugong.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ8eIHoSZ4jAR6BoBx0poRsg",
    "lat": 13.7806614,
    "lng": 100.4787871,
    "placeId": "ChIJZ8eIHoSZ4jAR6BoBx0poRsg",
    "businessStatus": "OPERATIONAL",
    "phone": "095 497 6260",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 83,
    "id": 918
  },
  {
    "title": "เบียว การ์ดเกม",
    "urlinform": "-",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61559428954030",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9zv45ymd4jARf-qRa5tyY0Y",
    "lat": 13.8505692,
    "lng": 100.5818185,
    "placeId": "ChIJ9zv45ymd4jARf-qRa5tyY0Y",
    "businessStatus": "OPERATIONAL",
    "phone": "094 661 7636",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 7:00 PM",
      "Wednesday: 2:00 – 7:00 PM",
      "Thursday: Closed",
      "Friday: 2:00 – 7:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 7,
    "id": 919
  },
  {
    "title": "Nx Gallery - Century Sukhumvit",
    "urlinform": "nx-gallery-century-sukhumvit",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/NxGallery/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhbpEgcyf4jARcRKSXdwrMYs",
    "lat": 13.7058789,
    "lng": 100.6022156,
    "placeId": "ChIJhbpEgcyf4jARcRKSXdwrMYs",
    "businessStatus": "OPERATIONAL",
    "phone": "082 108 2253",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 83,
    "id": 920
  },
  {
    "title": "Anubis Cards and Craft",
    "urlinform": "anubis-cards-and-craft",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/AnubisCardsandCraft",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNVhBOACf4jARk_W5dc8yVtY",
    "lat": 13.7394812,
    "lng": 100.5599004,
    "placeId": "ChIJNVhBOACf4jARk_W5dc8yVtY",
    "businessStatus": "OPERATIONAL",
    "phone": "092 895 0359",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 38,
    "id": 921,
    "district": "Sukhumvit"
  },
  {
    "title": "TM CARD SHOP",
    "urlinform": "tm-card-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.tmcardshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuenWT66f4jAREqQV5pB4wWA",
    "lat": 13.6972183,
    "lng": 100.6011133,
    "placeId": "ChIJuenWT66f4jAREqQV5pB4wWA",
    "businessStatus": "OPERATIONAL",
    "phone": "093 252 4443",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 10:30 AM – 5:00 PM",
      "Thursday: 10:30 AM – 5:00 PM",
      "Friday: 10:30 AM – 5:00 PM",
      "Saturday: 10:30 AM – 5:00 PM",
      "Sunday: 10:30 AM – 5:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 19,
    "id": 922
  },
  {
    "title": "Opensource Gameshop Terminal21",
    "urlinform": "opensource-gameshop-terminal21",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.opensource-game.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqQVcxU2f4jARWLuhXz3gPAo",
    "lat": 13.7381452,
    "lng": 100.5606699,
    "placeId": "ChIJqQVcxU2f4jARWLuhXz3gPAo",
    "businessStatus": "OPERATIONAL",
    "phone": "094 910 5887",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 39,
    "id": 923,
    "district": "Sukhumvit"
  },
  {
    "title": "Pokémon Trading Card Game Arts and Learning Gallery",
    "urlinform": "pokmon-trading-card-game-arts-and-learning-gallery",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt39SQACZ4jARe57URLVUmhI",
    "lat": 13.7303835,
    "lng": 100.5133967,
    "placeId": "ChIJt39SQACZ4jARe57URLVUmhI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 19,
    "id": 924
  },
  {
    "title": "Terminal 21 Asok",
    "urlinform": "terminal-21-asok",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.terminal21.co.th/asok/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuWuZbh6f4jAReZMEm2xxgzM",
    "lat": 13.7379635,
    "lng": 100.5604058,
    "placeId": "ChIJuWuZbh6f4jAReZMEm2xxgzM",
    "businessStatus": "OPERATIONAL",
    "phone": "02 108 0888",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 21326,
    "id": 925,
    "district": "Sukhumvit"
  },
  {
    "title": "Battlefield Bangkok",
    "urlinform": "battlefield-bangkok",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.battlefieldbangkok.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrafIEwKg4jARaUuZR1DFhqY",
    "lat": 13.6844661,
    "lng": 100.6128826,
    "placeId": "ChIJrafIEwKg4jARaUuZR1DFhqY",
    "businessStatus": "OPERATIONAL",
    "phone": "063 884 3864",
    "openingHours": [
      "Monday: 12:00 – 11:00 PM",
      "Tuesday: 12:00 – 11:00 PM",
      "Wednesday: 12:00 – 11:00 PM",
      "Thursday: 12:00 – 11:00 PM",
      "Friday: 12:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 307,
    "id": 926
  },
  {
    "title": "Nostramo Bangkok Board games Sukhumvit 39",
    "urlinform": "nostramo-bangkok-board-games-sukhumvit-39",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/NostramoBKK",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJm2I0dh2d4jARQuq1fXOHx_4",
    "lat": 13.7440215,
    "lng": 100.5724386,
    "placeId": "ChIJm2I0dh2d4jARQuq1fXOHx_4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 25,
    "id": 927,
    "district": "Sukhumvit"
  },
  {
    "title": "Masaru Japan Anime Shop",
    "urlinform": "masaru-japan-anime-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/masarujapanstore",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-3pFvt5dHTER81Y_RbeqslQ",
    "lat": 13.7156606,
    "lng": 100.5922871,
    "placeId": "ChIJ-3pFvt5dHTER81Y_RbeqslQ",
    "businessStatus": "OPERATIONAL",
    "phone": "063 969 7999",
    "openingHours": [
      "Monday: 10:00 AM – 7:30 PM",
      "Tuesday: 10:00 AM – 7:30 PM",
      "Wednesday: 10:00 AM – 7:30 PM",
      "Thursday: 10:00 AM – 7:30 PM",
      "Friday: 10:00 AM – 7:30 PM",
      "Saturday: 10:00 AM – 7:30 PM",
      "Sunday: 10:00 AM – 7:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 2559,
    "id": 928
  },
  {
    "title": "Fat Buds Weed Shop​​ Ekkamai",
    "urlinform": "fat-buds-weed-shop-ekkamai",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://fatbudsweedshop.com/fat-buds-weed-shop-ekkamai/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF6ZCxj2f4jARry9ErcaIPco",
    "lat": 13.7188561,
    "lng": 100.5886108,
    "placeId": "ChIJF6ZCxj2f4jARry9ErcaIPco",
    "businessStatus": "OPERATIONAL",
    "phone": "080 391 6417",
    "openingHours": [
      "Monday: 2:00 – 11:00 PM",
      "Tuesday: 2:00 – 11:00 PM",
      "Wednesday: 2:00 – 11:00 PM",
      "Thursday: 2:00 – 11:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1152,
    "id": 929
  },
  {
    "title": "Total VR Arcade",
    "urlinform": "total-vr-arcade",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://totalvr.co/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbV4oLqWf4jAR3_0nWI-E_Zk",
    "lat": 13.718713,
    "lng": 100.585389,
    "placeId": "ChIJbV4oLqWf4jAR3_0nWI-E_Zk",
    "businessStatus": "OPERATIONAL",
    "phone": "095 948 8968",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 775,
    "id": 930
  },
  {
    "title": "GH cardgames",
    "urlinform": "gh-cardgames",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://gh-cardgame.lnwshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSx1Yfh6Z4jARriN4z2Imv78",
    "lat": 13.74539,
    "lng": 100.5031643,
    "placeId": "ChIJSx1Yfh6Z4jARriN4z2Imv78",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 931,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "UrbanFlowers",
    "urlinform": "urbanflowers",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.urbanflowers.co.th/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7f1TAD6f4jARBRZuPbwx-00",
    "lat": 13.7454704,
    "lng": 100.5726405,
    "placeId": "ChIJ7f1TAD6f4jARBRZuPbwx-00",
    "businessStatus": "OPERATIONAL",
    "phone": "062 195 9586",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.8,
    "userRatingsTotal": 607,
    "id": 932,
    "district": "Sukhumvit"
  },
  {
    "title": "Nx Gallery - Esplanade",
    "urlinform": "nx-gallery-esplanade",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/NxGallery/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK0hxSBGf4jARlwrUyHN1JhM",
    "lat": 13.7670695,
    "lng": 100.5695769,
    "placeId": "ChIJK0hxSBGf4jARlwrUyHN1JhM",
    "businessStatus": "OPERATIONAL",
    "phone": "080 078 9665",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 206,
    "id": 933
  },
  {
    "title": "B.D Trading (2017) Bangkok",
    "urlinform": "bd-trading-2017-bangkok",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://bdtradingthailand.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjdQ-Bcif4jARcoN8aOt9SZ4",
    "lat": 13.7416017,
    "lng": 100.5567222,
    "placeId": "ChIJjdQ-Bcif4jARcoN8aOt9SZ4",
    "businessStatus": "OPERATIONAL",
    "phone": "094 424 2953",
    "openingHours": [
      "Monday: 9:00 AM – 1:00 AM",
      "Tuesday: 9:00 AM – 1:00 AM",
      "Wednesday: 9:00 AM – 1:00 AM",
      "Thursday: 9:00 AM – 1:00 AM",
      "Friday: 9:00 AM – 1:00 AM",
      "Saturday: 9:00 AM – 1:00 AM",
      "Sunday: 9:00 AM – 1:00 AM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 7,
    "id": 934,
    "district": "Sukhumvit"
  },
  {
    "title": "Wonderland Bangkok",
    "urlinform": "wonderland-bangkok",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://wonderlandbangkok.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYXGT11Cf4jAR0GdMJyZwyAU",
    "lat": 13.7415841,
    "lng": 100.5542138,
    "placeId": "ChIJYXGT11Cf4jAR0GdMJyZwyAU",
    "businessStatus": "OPERATIONAL",
    "phone": "063 192 0420",
    "openingHours": [
      "Monday: 11:00 AM – 2:30 AM",
      "Tuesday: 11:00 AM – 2:30 AM",
      "Wednesday: 11:00 AM – 2:30 AM",
      "Thursday: 11:00 AM – 2:30 AM",
      "Friday: 11:00 AM – 2:30 AM",
      "Saturday: 11:00 AM – 2:30 AM",
      "Sunday: 11:00 AM – 2:30 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1956,
    "id": 935,
    "district": "Sukhumvit"
  },
  {
    "title": "Nx Gallery - SC Plaza",
    "urlinform": "nx-gallery-sc-plaza",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://fb.com/NxGallery",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnZC-BNmX4jARxjgtuSLs2RU",
    "lat": 13.7808016,
    "lng": 100.422494,
    "placeId": "ChIJnZC-BNmX4jARxjgtuSLs2RU",
    "businessStatus": "OPERATIONAL",
    "phone": "082 527 7887",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: Closed",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 152,
    "id": 936
  },
  {
    "title": "Miidear Wedding Invitation",
    "urlinform": "miidear-wedding-invitation",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPVDcrgif4jAR_9zrnLx_puM",
    "lat": 13.721324,
    "lng": 100.569557,
    "placeId": "ChIJPVDcrgif4jAR_9zrnLx_puM",
    "businessStatus": "OPERATIONAL",
    "phone": "098 987 7965",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 9,
    "id": 937
  },
  {
    "title": "ร้านการ์ดเกมส์พี่เต๋า ENIGMAGIC",
    "urlinform": "-enigmagic",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/cardgamesenigmagic",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY71Z3led4jAR5Rgt9rAKp8o",
    "lat": 13.8572387,
    "lng": 100.5417064,
    "placeId": "ChIJY71Z3led4jAR5Rgt9rAKp8o",
    "businessStatus": "OPERATIONAL",
    "phone": "065 923 6359",
    "openingHours": [
      "Monday: 12:00 – 7:30 PM",
      "Tuesday: 12:00 – 7:30 PM",
      "Wednesday: 12:00 – 7:30 PM",
      "Thursday: 12:00 – 7:30 PM",
      "Friday: 12:00 – 7:30 PM",
      "Saturday: 10:30 AM – 7:30 PM",
      "Sunday: 10:30 AM – 7:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 26,
    "id": 938
  },
  {
    "title": "Kuro Yotsuba",
    "urlinform": "kuro-yotsuba",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61553246457381",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJX9He_Aqh4jARHi5xnhpA6AE",
    "lat": 13.594565,
    "lng": 100.6177726,
    "placeId": "ChIJX9He_Aqh4jARHi5xnhpA6AE",
    "businessStatus": "OPERATIONAL",
    "phone": "085 991 9560",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 17,
    "id": 939
  },
  {
    "title": "Monnymon Shop",
    "urlinform": "monnymon-shop",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Monnymon-Shop-257313710953489/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuUoKA5w62jARsHbZCosVr04",
    "lat": 18.786406,
    "lng": 98.98504059999999,
    "placeId": "ChIJuUoKA5w62jARsHbZCosVr04",
    "businessStatus": "OPERATIONAL",
    "phone": "086 656 1435",
    "openingHours": [
      "Monday: 3:00 – 10:30 PM",
      "Tuesday: 3:00 – 7:30 PM",
      "Wednesday: 3:00 – 7:30 PM",
      "Thursday: 3:00 – 7:30 PM",
      "Friday: 3:00 – 7:30 PM",
      "Saturday: 3:00 – 7:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 102,
    "id": 940,
    "district": "Old City"
  },
  {
    "title": "จั่ว Card Game & Hobby",
    "urlinform": "-card-game-hobby",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/JuaCardCM/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD2mNR0072jARXyCpPfFlV2s",
    "lat": 18.8012729,
    "lng": 98.960336,
    "placeId": "ChIJD2mNR0072jARXyCpPfFlV2s",
    "businessStatus": "OPERATIONAL",
    "phone": "096 831 0129",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 6:00 PM",
      "Thursday: 2:00 – 6:00 PM",
      "Friday: 2:00 – 6:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 23,
    "id": 941,
    "district": "Nimman"
  },
  {
    "title": "P'N Card Games",
    "urlinform": "pn-card-games",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWaAkiXE62jARDwLItoSTqq0",
    "lat": 18.7924435,
    "lng": 98.9524165,
    "placeId": "ChIJWaAkiXE62jARDwLItoSTqq0",
    "businessStatus": "OPERATIONAL",
    "phone": "081 952 7416",
    "openingHours": [
      "Monday: 2:00 – 7:30 PM",
      "Tuesday: 2:00 – 7:30 PM",
      "Wednesday: 2:00 – 7:30 PM",
      "Thursday: 2:00 – 7:30 PM",
      "Friday: 2:00 – 7:30 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.4,
    "userRatingsTotal": 35,
    "id": 942,
    "district": "Chiang Mai University"
  },
  {
    "title": "Fizzy Game & Hobby Store",
    "urlinform": "fizzy-game-hobby-store",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "Flesh and Blood",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "https://www.fizzyhobbystore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi2VoF8E62jARPh93xnmY2L0",
    "lat": 18.8292825,
    "lng": 99.0139647,
    "placeId": "ChIJi2VoF8E62jARPh93xnmY2L0",
    "businessStatus": "OPERATIONAL",
    "phone": "093 189 8333",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 11:30 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 47,
    "id": 943
  },
  {
    "title": "P’N Card Game2",
    "urlinform": "pn-card-game2",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/share/1FxnSP1LTq/?mibextid=wwXIfr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbSRWewA72jAROpd4imErV6w",
    "lat": 18.802474,
    "lng": 98.9671659,
    "placeId": "ChIJbSRWewA72jAROpd4imErV6w",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 16,
    "id": 944,
    "district": "Nimman"
  },
  {
    "title": "CNX Toy & Card Game",
    "urlinform": "cnx-toy-card-game",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYytaWgA72jARrs4jpZNoEvQ",
    "lat": 18.7917578,
    "lng": 99.0089337,
    "placeId": "ChIJYytaWgA72jARrs4jpZNoEvQ",
    "businessStatus": "OPERATIONAL",
    "phone": "093 130 4774",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 17,
    "id": 945
  },
  {
    "title": "A Journey in Posters / Old Town",
    "urlinform": "a-journey-in-posters-old-town",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY5ERhIcx2jARAhhuZQ3eofI",
    "lat": 18.7923359,
    "lng": 98.9906164,
    "placeId": "ChIJY5ERhIcx2jARAhhuZQ3eofI",
    "businessStatus": "OPERATIONAL",
    "phone": "097 989 3594",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 6:00 PM",
      "Wednesday: Closed",
      "Thursday: 9:00 AM – 6:00 PM",
      "Friday: 9:00 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 9:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 287,
    "id": 946,
    "district": "Old City"
  },
  {
    "title": "A journey in Posters / Shop & studio",
    "urlinform": "a-journey-in-posters-shop-studio",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://ajourneyinposters.etsy.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt7cul6U62jARUCI2b4eviM0",
    "lat": 18.788095,
    "lng": 99.0007097,
    "placeId": "ChIJt7cul6U62jARUCI2b4eviM0",
    "businessStatus": "OPERATIONAL",
    "phone": "097 989 3594",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 624,
    "id": 947,
    "district": "Night Bazaar"
  },
  {
    "title": "Rojana Art & Souvenirs",
    "urlinform": "rojana-art-souvenirs",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx5Hxzos72jARMwBibOZ5Os8",
    "lat": 18.7858317,
    "lng": 98.98299899999999,
    "placeId": "ChIJx5Hxzos72jARMwBibOZ5Os8",
    "businessStatus": "OPERATIONAL",
    "phone": "081 998 3048",
    "openingHours": [
      "Monday: 9:00 AM – 5:00 PM",
      "Tuesday: 9:00 AM – 5:00 PM",
      "Wednesday: 9:00 AM – 5:00 PM",
      "Thursday: 9:00 AM – 5:00 PM",
      "Friday: 9:00 AM – 5:00 PM",
      "Saturday: 9:00 AM – 5:00 PM",
      "Sunday: 9:00 AM – 5:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 105,
    "id": 948,
    "district": "Old City"
  },
  {
    "title": "Den Souvenir",
    "urlinform": "den-souvenir",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.densouvenir.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJESym6qI72jARZO89cxvl5DU",
    "lat": 18.7904678,
    "lng": 98.99128160000001,
    "placeId": "ChIJESym6qI72jARZO89cxvl5DU",
    "businessStatus": "OPERATIONAL",
    "phone": "086 456 9641",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 598,
    "id": 949,
    "district": "Old City"
  },
  {
    "title": "yindee",
    "urlinform": "yindee",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ799W_gU72jARfg8pJGBTBUI",
    "lat": 18.7868114,
    "lng": 98.98237650000002,
    "placeId": "ChIJ799W_gU72jARfg8pJGBTBUI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 35,
    "id": 950,
    "district": "Old City"
  },
  {
    "title": "Chunya Art & Craft",
    "urlinform": "chunya-art-craft",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJL1HSHgA72jAR9PCHxPU7d5g",
    "lat": 18.7907335,
    "lng": 98.990033,
    "placeId": "ChIJL1HSHgA72jAR9PCHxPU7d5g",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 6:00 PM",
      "Tuesday: 10:30 AM – 6:00 PM",
      "Wednesday: 10:30 AM – 6:00 PM",
      "Thursday: 10:30 AM – 6:00 PM",
      "Friday: 10:30 AM – 6:00 PM",
      "Saturday: 10:30 AM – 6:00 PM",
      "Sunday: 10:30 AM – 6:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 26,
    "id": 951,
    "district": "Old City"
  },
  {
    "title": "the Elephant POOPOOPAPER Store @ One Nimman",
    "urlinform": "the-elephant-poopoopaper-store-one-nimman",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.poopoopaperpark.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRaznHlg72jAR1nHDkk0aN6U",
    "lat": 18.8003204,
    "lng": 98.9676684,
    "placeId": "ChIJRaznHlg72jAR1nHDkk0aN6U",
    "businessStatus": "OPERATIONAL",
    "phone": "094 338 9969",
    "openingHours": [
      "Monday: 10:30 AM – 10:00 PM",
      "Tuesday: 10:30 AM – 10:00 PM",
      "Wednesday: 10:30 AM – 10:00 PM",
      "Thursday: 10:30 AM – 10:00 PM",
      "Friday: 10:30 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 13,
    "id": 952,
    "district": "Nimman"
  },
  {
    "title": "Needle and Clay",
    "urlinform": "needle-and-clay",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://instagram.com/needleandclay?utm_medium=copy_link",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJdYABmQ472jARhsNmYr6fKb8",
    "lat": 18.7815197,
    "lng": 98.9895799,
    "placeId": "ChIJdYABmQ472jARhsNmYr6fKb8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 9:00 AM – 5:00 PM",
      "Wednesday: 9:00 AM – 5:00 PM",
      "Thursday: 9:00 AM – 5:00 PM",
      "Friday: 9:00 AM – 5:00 PM",
      "Saturday: 9:00 AM – 5:00 PM",
      "Sunday: 9:00 AM – 5:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 37,
    "id": 953,
    "district": "Old City"
  },
  {
    "title": "Collectors Store",
    "urlinform": "collectors-store",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/collectors.vtg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEWZePuI92jARoo46BY4gA7A",
    "lat": 18.7931343,
    "lng": 98.9842911,
    "placeId": "ChIJEWZePuI92jARoo46BY4gA7A",
    "businessStatus": "OPERATIONAL",
    "phone": "062 338 8116",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:30 PM",
      "Sunday: 11:00 AM – 7:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 59,
    "id": 954,
    "district": "Old City"
  },
  {
    "title": "Golden Goblin Games",
    "urlinform": "golden-goblin-games",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://www.goldengoblingames.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXQUIoMg82jARJQGqckQ1dGM",
    "lat": 18.8293059,
    "lng": 99.0147796,
    "placeId": "ChIJXQUIoMg82jARJQGqckQ1dGM",
    "businessStatus": "OPERATIONAL",
    "phone": "080 065 9946",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 2:00 – 8:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 104,
    "id": 955
  },
  {
    "title": "Chanya Shops and Gallery",
    "urlinform": "chanya-shops-and-gallery",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb7LWzwg72jARkY7KZJP0sXw",
    "lat": 18.7881571,
    "lng": 98.98620539999999,
    "placeId": "ChIJb7LWzwg72jARkY7KZJP0sXw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 9:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 91,
    "id": 956,
    "district": "Old City"
  },
  {
    "title": "Dibdee & Objects",
    "urlinform": "dibdee-objects",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJa5umlqU62jARQFHJkHFEnu8",
    "lat": 18.7921778,
    "lng": 98.991001,
    "placeId": "ChIJa5umlqU62jARQFHJkHFEnu8",
    "businessStatus": "OPERATIONAL",
    "phone": "091 655 9299",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 123,
    "id": 957,
    "district": "Old City"
  },
  {
    "title": "F Shop Gaming",
    "urlinform": "f-shop-gaming",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY72bZM072jAR3qBJlsKTeUw",
    "lat": 18.7983132,
    "lng": 98.9938913,
    "placeId": "ChIJY72bZM072jAR3qBJlsKTeUw",
    "businessStatus": "OPERATIONAL",
    "phone": "085 521 5636",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 80,
    "id": 958
  },
  {
    "title": "Strawberry Club สินค้าน่ารักทุกชิ้น 10 บาท สาขาเชียงใหม่ หน้าโรงเรียนยุพราช 10 baht store",
    "urlinform": "strawberry-club-10-10-baht-store",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ6GEzDY72jARwWD-K9jy9TM",
    "lat": 18.790653,
    "lng": 98.98895519999999,
    "placeId": "ChIJZ6GEzDY72jARwWD-K9jy9TM",
    "businessStatus": "OPERATIONAL",
    "phone": "089 553 3628",
    "openingHours": [
      "Monday: 9:00 AM – 7:30 PM",
      "Tuesday: 9:00 AM – 7:30 PM",
      "Wednesday: 9:00 AM – 7:30 PM",
      "Thursday: 9:00 AM – 7:30 PM",
      "Friday: 9:00 AM – 7:30 PM",
      "Saturday: 9:00 AM – 7:30 PM",
      "Sunday: 9:00 AM – 7:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 53,
    "id": 959,
    "district": "Old City"
  },
  {
    "title": "ร้านสารพันสรรหา การ์ดแต่งงาน ของชำร่วย ของรับไหว้",
    "urlinform": "-",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://saraphan-sanha.vercel.app/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK5dOoIk62jARAUewTtztH6M",
    "lat": 18.7972778,
    "lng": 98.9715076,
    "placeId": "ChIJK5dOoIk62jARAUewTtztH6M",
    "businessStatus": "OPERATIONAL",
    "phone": "084 654 9694",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: Closed",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 4:00 PM",
      "Sunday: 10:00 AM – 4:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 5,
    "id": 960,
    "district": "Nimman"
  },
  {
    "title": "คีย์การ์ด เครื่องบันทึกเวลาทำงาน กล้องวงจรปิด และสินค้าไอทีเชียงใหม่ Success it Center",
    "urlinform": "-success-it-center",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJu9ASaWI72jAR7Oagi1VPNeU",
    "lat": 18.7961444,
    "lng": 98.97938099999999,
    "placeId": "ChIJu9ASaWI72jAR7Oagi1VPNeU",
    "businessStatus": "OPERATIONAL",
    "phone": "053 404 769",
    "openingHours": [
      "Monday: 8:30 AM – 5:30 PM",
      "Tuesday: 8:30 AM – 5:30 PM",
      "Wednesday: 8:30 AM – 5:30 PM",
      "Thursday: 8:30 AM – 5:30 PM",
      "Friday: 8:30 AM – 5:30 PM",
      "Saturday: 9:30 AM – 5:30 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 33,
    "id": 961,
    "district": "Old City"
  },
  {
    "title": "Game Mezz",
    "urlinform": "game-mezz",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrSV12tg72jARxGLcDn9-Efk",
    "lat": 18.7917012,
    "lng": 98.97855849999999,
    "placeId": "ChIJrSV12tg72jARxGLcDn9-Efk",
    "businessStatus": "OPERATIONAL",
    "phone": "086 654 2228",
    "openingHours": [
      "Monday: 10:30 AM – 10:00 PM",
      "Tuesday: 10:30 AM – 10:00 PM",
      "Wednesday: 10:30 AM – 10:00 PM",
      "Thursday: 10:30 AM – 10:00 PM",
      "Friday: 10:30 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 334,
    "id": 962,
    "district": "Old City"
  },
  {
    "title": "One Nimman",
    "urlinform": "one-nimman",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.onenimman.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8QdNKPU72jARtz_iHmA6_zk",
    "lat": 18.8000644,
    "lng": 98.96762989999999,
    "placeId": "ChIJ8QdNKPU72jARtz_iHmA6_zk",
    "businessStatus": "OPERATIONAL",
    "phone": "052 080 900",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 13580,
    "id": 963,
    "district": "Nimman"
  },
  {
    "title": "Kalare Night Bazaar",
    "urlinform": "kalare-night-bazaar",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0ZTQEaY62jARu9YIRjPgkcA",
    "lat": 18.7851935,
    "lng": 99.0006926,
    "placeId": "ChIJ0ZTQEaY62jARu9YIRjPgkcA",
    "businessStatus": "OPERATIONAL",
    "phone": "062 592 3447",
    "openingHours": [
      "Monday: 4:00 – 11:30 PM",
      "Tuesday: 4:00 – 11:30 PM",
      "Wednesday: 4:00 – 11:30 PM",
      "Thursday: 4:00 – 11:30 PM",
      "Friday: 4:00 – 11:30 PM",
      "Saturday: 4:00 – 11:30 PM",
      "Sunday: 4:00 – 11:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 979,
    "id": 964,
    "district": "Night Bazaar"
  },
  {
    "title": "Night Bazaar Chiang Mai",
    "urlinform": "night-bazaar-chiang-mai",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW0qnDKY62jARHbAmfwD1Lgs",
    "lat": 18.7852244,
    "lng": 99.0002986,
    "placeId": "ChIJW0qnDKY62jARHbAmfwD1Lgs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 5:00 PM – 12:00 AM",
      "Tuesday: 5:00 PM – 12:00 AM",
      "Wednesday: 5:00 PM – 12:00 AM",
      "Thursday: 5:00 PM – 12:00 AM",
      "Friday: 5:00 PM – 12:00 AM",
      "Saturday: 5:00 PM – 12:00 AM",
      "Sunday: 5:00 PM – 12:00 AM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 27430,
    "id": 965,
    "district": "Night Bazaar"
  },
  {
    "title": "Night Bazaar Shopping Street",
    "urlinform": "night-bazaar-shopping-street",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB2LGAX472jARPHJhTJYObZ4",
    "lat": 18.786084,
    "lng": 99.0006808,
    "placeId": "ChIJB2LGAX472jARPHJhTJYObZ4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 4.3,
    "userRatingsTotal": 566,
    "id": 966,
    "district": "Night Bazaar"
  },
  {
    "title": "Anusarn Market",
    "urlinform": "anusarn-market",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/anusarnmarket?mibextid=ZbWKwL",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzxRIQ-A72jARolHkcSkgzAc",
    "lat": 18.7827769,
    "lng": 99.00023279999999,
    "placeId": "ChIJzxRIQ-A72jARolHkcSkgzAc",
    "businessStatus": "OPERATIONAL",
    "phone": "086 429 4792",
    "openingHours": [
      "Monday: 5:00 – 11:00 PM",
      "Tuesday: 5:00 – 11:00 PM",
      "Wednesday: 5:00 – 11:00 PM",
      "Thursday: 5:00 – 11:00 PM",
      "Friday: 5:00 – 11:00 PM",
      "Saturday: 5:00 – 11:00 PM",
      "Sunday: 5:00 – 11:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 4552,
    "id": 967,
    "district": "Night Bazaar"
  },
  {
    "title": "Jing Jai Market Chiang Mai",
    "urlinform": "jing-jai-market-chiang-mai",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.jingjaicentralchiangmai.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzfxey8A62jARBouRzNKxv58",
    "lat": 18.8062295,
    "lng": 98.995325,
    "placeId": "ChIJzfxey8A62jARBouRzNKxv58",
    "businessStatus": "OPERATIONAL",
    "phone": "053 231 520",
    "openingHours": [
      "Monday: 9:00 AM – 9:00 PM",
      "Tuesday: 9:00 AM – 9:00 PM",
      "Wednesday: 9:00 AM – 9:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 9:00 PM",
      "Saturday: 6:30 AM – 9:00 PM",
      "Sunday: 6:30 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 12266,
    "id": 968
  },
  {
    "title": "Chiang Mai Gate Market",
    "urlinform": "chiang-mai-gate-market",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/groups/517337015876054/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJczgL0Z862jARSHxf7Vv4QMk",
    "lat": 18.7815359,
    "lng": 98.9884853,
    "placeId": "ChIJczgL0Z862jARSHxf7Vv4QMk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.5,
    "userRatingsTotal": 10242,
    "id": 969,
    "district": "Old City"
  },
  {
    "title": "Chiang Mai Night Market",
    "urlinform": "chiang-mai-night-market",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_RgETBE72jARDqkA1awFQdI",
    "lat": 18.78818,
    "lng": 98.98810019999999,
    "placeId": "ChIJ_RgETBE72jARDqkA1awFQdI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: Closed",
      "Sunday: 5:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 2605,
    "id": 970,
    "district": "Old City"
  },
  {
    "title": "Pavilion Night Bazaar Chiang Mai",
    "urlinform": "pavilion-night-bazaar-chiang-mai",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6TOsSaY62jAR4Ts8NFvdLek",
    "lat": 18.7836277,
    "lng": 99.0004256,
    "placeId": "ChIJ6TOsSaY62jAR4Ts8NFvdLek",
    "businessStatus": "OPERATIONAL",
    "phone": "053 818 500",
    "openingHours": [
      "Monday: 8:00 AM – 11:00 PM",
      "Tuesday: 8:00 AM – 11:00 PM",
      "Wednesday: 8:00 AM – 11:00 PM",
      "Thursday: 8:00 AM – 11:00 PM",
      "Friday: 8:00 AM – 11:00 PM",
      "Saturday: 8:00 AM – 11:00 PM",
      "Sunday: 8:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 170,
    "id": 971,
    "district": "Night Bazaar"
  },
  {
    "title": "Chinatown Night Bazaar",
    "urlinform": "chinatown-night-bazaar",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7cYwaKU62jAR5yJo_muEN9o",
    "lat": 18.7905481,
    "lng": 99.00101599999999,
    "placeId": "ChIJ7cYwaKU62jAR5yJo_muEN9o",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 4.1,
    "userRatingsTotal": 175,
    "id": 972,
    "district": "Night Bazaar"
  },
  {
    "title": "Rincome night market",
    "urlinform": "rincome-night-market",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-3aioUM72jARSYZcBo6bZ0U",
    "lat": 18.8027187,
    "lng": 98.9663944,
    "placeId": "ChIJ-3aioUM72jARSYZcBo6bZ0U",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 10:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 10:00 PM",
      "Sunday: 9:00 AM – 10:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 1370,
    "id": 973,
    "district": "Nimman"
  },
  {
    "title": "Collection O Night Bazaar Chiangmai",
    "urlinform": "collection-o-night-bazaar-chiangmai",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4btnNa862jARKDLJNpD8UP8",
    "lat": 18.7861849,
    "lng": 99.0032564,
    "placeId": "ChIJ4btnNa862jARKDLJNpD8UP8",
    "businessStatus": "OPERATIONAL",
    "phone": "063 225 4641",
    "openingHours": [],
    "rating": 4.2,
    "userRatingsTotal": 39,
    "id": 974,
    "district": "Night Bazaar"
  },
  {
    "title": "Tha Phae Walking Street",
    "urlinform": "tha-phae-walking-street",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs_Isopg62jARSxmmZpK66tw",
    "lat": 18.7878089,
    "lng": 98.9927387,
    "placeId": "ChIJs_Isopg62jARSxmmZpK66tw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: Closed",
      "Sunday: 5:00 – 10:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 6850,
    "id": 975,
    "district": "Night Bazaar"
  },
  {
    "title": "Wua Lai Walking Street Saturday Market",
    "urlinform": "wua-lai-walking-street-saturday-market",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_5-9gHUw2jARGOGQoIf_O4Q",
    "lat": 18.7808949,
    "lng": 98.9877676,
    "placeId": "ChIJ_5-9gHUw2jARGOGQoIf_O4Q",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: 5:00 – 11:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.5,
    "userRatingsTotal": 8126,
    "id": 976,
    "district": "Old City"
  },
  {
    "title": "Chiang Mai University Night Market",
    "urlinform": "chiang-mai-university-night-market",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVWfOV0I62jAR2JDs6dzRx6Y",
    "lat": 18.8087026,
    "lng": 98.95495609999999,
    "placeId": "ChIJVWfOV0I62jAR2JDs6dzRx6Y",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 5:00 – 11:00 PM",
      "Tuesday: 5:00 – 11:00 PM",
      "Wednesday: 5:00 – 11:00 PM",
      "Thursday: 5:00 – 11:00 PM",
      "Friday: 5:00 – 11:00 PM",
      "Saturday: 5:00 – 11:00 PM",
      "Sunday: 5:00 – 11:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 1971,
    "id": 977
  },
  {
    "title": "Lanna Square",
    "urlinform": "lanna-square",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJf_T5CQQ72jARYee4iSJSuA4",
    "lat": 18.7911084,
    "lng": 98.99114519999999,
    "placeId": "ChIJf_T5CQQ72jARYee4iSJSuA4",
    "businessStatus": "OPERATIONAL",
    "phone": "081 409 0000",
    "openingHours": [
      "Monday: 5:00 PM – 12:00 AM",
      "Tuesday: 5:00 PM – 12:00 AM",
      "Wednesday: 5:00 PM – 12:00 AM",
      "Thursday: 5:00 PM – 12:00 AM",
      "Friday: 5:00 PM – 12:00 AM",
      "Saturday: 5:00 PM – 12:00 AM",
      "Sunday: 5:00 PM – 12:00 AM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 900,
    "id": 978,
    "district": "Old City"
  },
  {
    "title": "Chang Phuak Market",
    "urlinform": "chang-phuak-market",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjYX8KZE62jARGVvq4D7Txm8",
    "lat": 18.7966457,
    "lng": 98.9871259,
    "placeId": "ChIJjYX8KZE62jARGVvq4D7Txm8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 5:00 PM – 12:00 AM",
      "Tuesday: 5:00 PM – 12:00 AM",
      "Wednesday: 5:00 PM – 12:00 AM",
      "Thursday: 5:00 PM – 12:00 AM",
      "Friday: 5:00 PM – 12:00 AM",
      "Saturday: 5:00 PM – 12:00 AM",
      "Sunday: 5:00 PM – 12:00 AM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 1411,
    "id": 979,
    "district": "Old City"
  },
  {
    "title": "Saturday Evening Flea Market - Keha Nong Hoi",
    "urlinform": "saturday-evening-flea-market-keha-nong-hoi",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs4Oa5EYx2jARBwZwuKuYYnA",
    "lat": 18.7599216,
    "lng": 99.0080776,
    "placeId": "ChIJs4Oa5EYx2jARBwZwuKuYYnA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: 3:30 – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.5,
    "userRatingsTotal": 68,
    "id": 980
  },
  {
    "title": "Chiang Mai Walking Street",
    "urlinform": "chiang-mai-walking-street",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcw-RKNA72jARFqCee_2Hr7E",
    "lat": 18.7883329,
    "lng": 98.98529289999999,
    "placeId": "ChIJcw-RKNA72jARFqCee_2Hr7E",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: Closed",
      "Sunday: 5:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 266,
    "id": 981,
    "district": "Old City"
  },
  {
    "title": "The Story Lifestyle Shop, Night Bazaar Branch",
    "urlinform": "the-story-lifestyle-shop-night-bazaar-branch",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.thestorylifestyle.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD74AAQA72jARjpTySfkDB-8",
    "lat": 18.7864817,
    "lng": 99.0003964,
    "placeId": "ChIJD74AAQA72jARjpTySfkDB-8",
    "businessStatus": "OPERATIONAL",
    "phone": "092 904 2409",
    "openingHours": [
      "Monday: 2:00 – 11:00 PM",
      "Tuesday: 2:00 – 11:00 PM",
      "Wednesday: 2:00 – 11:00 PM",
      "Thursday: 2:00 – 11:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 11:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 59,
    "id": 982,
    "district": "Night Bazaar"
  },
  {
    "title": "KANA PURE Cannabis Dispensary – Night Bazaar Chiang Mai | Weed Shop Bangkok | カンナビスショップ | 曼谷大麻店",
    "urlinform": "kana-pure-cannabis-dispensary-night-bazaar-chiang-mai-weed-shop-bangkok-",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://kanathailand.com/kanapure",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJSlCDwA72jARPaj0azgfjDM",
    "lat": 18.7840782,
    "lng": 99.0006555,
    "placeId": "ChIJJSlCDwA72jARPaj0azgfjDM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 4:00 PM – 1:00 AM",
      "Tuesday: 4:00 PM – 1:00 AM",
      "Wednesday: 4:00 PM – 1:00 AM",
      "Thursday: 4:00 PM – 1:00 AM",
      "Friday: 4:00 PM – 1:00 AM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 55,
    "id": 983,
    "district": "Night Bazaar"
  },
  {
    "title": "สปีดดารา",
    "urlinform": "store-50",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-RUK39El2jARjIgA3UVOo4U",
    "lat": 18.7983193,
    "lng": 99.0139932,
    "placeId": "ChIJ-RUK39El2jARjIgA3UVOo4U",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 7:45 AM – 6:00 PM",
      "Tuesday: 7:45 AM – 6:00 PM",
      "Wednesday: 7:45 AM – 6:00 PM",
      "Thursday: 7:45 AM – 6:00 PM",
      "Friday: 7:45 AM – 6:00 PM",
      "Saturday: 7:45 AM – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 984
  },
  {
    "title": "Kad Na Mor Market",
    "urlinform": "kad-na-mor-market",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.chiangmaimaster.com/place/kad-na-mor-cmu-night-market",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJk_JF_0I62jAR3cmwGLpSmd4",
    "lat": 18.8087495,
    "lng": 98.95537089999999,
    "placeId": "ChIJk_JF_0I62jAR3cmwGLpSmd4",
    "businessStatus": "OPERATIONAL",
    "phone": "087 190 5949",
    "openingHours": [
      "Monday: 5:00 – 10:30 PM",
      "Tuesday: 5:00 – 10:30 PM",
      "Wednesday: 5:00 – 10:30 PM",
      "Thursday: 5:00 – 10:30 PM",
      "Friday: 5:00 – 10:30 PM",
      "Saturday: 5:00 – 10:30 PM",
      "Sunday: 5:00 – 10:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 3418,
    "id": 985
  },
  {
    "title": "Rowell TCG",
    "urlinform": "rowell-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9SgaDAAZ2jERrbjujmYhgG4",
    "lat": 1.3009473,
    "lng": 103.8355231,
    "placeId": "ChIJ9SgaDAAZ2jERrbjujmYhgG4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 33,
    "id": 986,
    "district": "Orchard"
  },
  {
    "title": "SNORE HOUSE",
    "urlinform": "snore-house",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.tiktok.com/@snorlaxhousee?_t=ZS-8v0JUWg1V3w&_r=1",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_wKqBfgZ2jERnSX4t1Rw-84",
    "lat": 1.3045795,
    "lng": 103.8340621,
    "placeId": "ChIJ_wKqBfgZ2jERnSX4t1Rw-84",
    "businessStatus": "OPERATIONAL",
    "phone": "8338 7896",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 495,
    "id": 987,
    "district": "Orchard"
  },
  {
    "title": "Jeux Kingdom",
    "urlinform": "jeux-kingdom",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Flesh and Blood",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.jeuxkingdom.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2ef7ZSsZ2jERsbAuQbjl-us",
    "lat": 1.3009768,
    "lng": 103.8410562,
    "placeId": "ChIJ2ef7ZSsZ2jERsbAuQbjl-us",
    "businessStatus": "OPERATIONAL",
    "phone": "8833 9669",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:30 – 7:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 100,
    "id": 988,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Cardboard Collectible",
    "urlinform": "cardboard-collectible",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://cardboardcollectible.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh97J4BMZ2jERBHCjybRWZsA",
    "lat": 1.3006701,
    "lng": 103.8392993,
    "placeId": "ChIJh97J4BMZ2jERBHCjybRWZsA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 123,
    "id": 989,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "CARD COLLECTOR CORNER",
    "urlinform": "card-collector-corner",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0_10NwMZ2jERTZ0A5JRrI4s",
    "lat": 1.3008438,
    "lng": 103.8495947,
    "placeId": "ChIJ0_10NwMZ2jERTZ0A5JRrI4s",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 65,
    "id": 990,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Play United",
    "urlinform": "play-united",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lnk.bio/PlayUnitedSG?fbclid=IwZnRzaAOKXYlleHRuA2FlbQIxMQBzcnRjBmFwcF9pZAo2NjI4NTY4Mzc5AAEeq9Bin39h7cjFunRMKu6eRAQ1RXozmmseZ34DwaXoU9uSMsNY4-pf2doZesA_aem_HNU_zgyv0j31vrmM3P4Upw",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPRXYOgAZ2jER3ukkmVYhv1U",
    "lat": 1.3019805,
    "lng": 103.839695,
    "placeId": "ChIJPRXYOgAZ2jER3ukkmVYhv1U",
    "businessStatus": "OPERATIONAL",
    "phone": "9082 5039",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 177,
    "id": 991,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "1Collectibles - Queensway",
    "urlinform": "1collectibles-queensway",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "WS"
    ],
    "storeWebsite": "https://www.1collectibles.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiUliNBgb2jERy9LOjD23fl0",
    "lat": 1.287426,
    "lng": 103.8034629,
    "placeId": "ChIJiUliNBgb2jERy9LOjD23fl0",
    "businessStatus": "OPERATIONAL",
    "phone": "8226 1701",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 282,
    "id": 992
  },
  {
    "title": "Shane Collectibles (Pokemon & One Piece TCG)",
    "urlinform": "shane-collectibles-consignment-pokemon-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.instagram.com/shanecollectibles/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJifJygaUZ2jERKOPfzvkXbo4",
    "lat": 1.2918776,
    "lng": 103.8500267,
    "placeId": "ChIJifJygaUZ2jERKOPfzvkXbo4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:30 – 9:00 PM",
      "Tuesday: 12:30 – 9:00 PM",
      "Wednesday: 12:30 – 9:00 PM",
      "Thursday: 12:30 – 9:00 PM",
      "Friday: 12:30 – 9:00 PM",
      "Saturday: 12:30 – 9:00 PM",
      "Sunday: 12:30 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 322,
    "id": 993
  },
  {
    "title": "PI - Games",
    "urlinform": "pi-games",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://www.pi.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE76FM5EZ2jERiugDqPSe17E",
    "lat": 1.3016539,
    "lng": 103.8386341,
    "placeId": "ChIJE76FM5EZ2jERiugDqPSe17E",
    "businessStatus": "OPERATIONAL",
    "phone": "8189 3050",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 290,
    "id": 994,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Monster Collectibles",
    "urlinform": "monster-collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.tiktok.com/@monstercollectibles?_t=ZS-8tNoYBQUF4H&_r=1",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9QmW0OQX2jER7sP4-lTsO1w",
    "lat": 1.3073922,
    "lng": 103.8333246,
    "placeId": "ChIJ9QmW0OQX2jER7sP4-lTsO1w",
    "businessStatus": "OPERATIONAL",
    "phone": "9626 4099",
    "openingHours": [
      "Monday: 1:30 – 9:30 PM",
      "Tuesday: 11:30 AM – 8:30 PM",
      "Wednesday: 12:30 – 8:30 PM",
      "Thursday: 11:30 AM – 8:30 PM",
      "Friday: 11:30 AM – 9:30 PM",
      "Saturday: 11:30 AM – 9:30 PM",
      "Sunday: 11:30 AM – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 94,
    "id": 995,
    "district": "Orchard"
  },
  {
    "title": "SC Collection",
    "urlinform": "sc-collection",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.sc-collection.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJl4Dv838Z2jERuCIBbdwZbkk",
    "lat": 1.3069439,
    "lng": 103.8291434,
    "placeId": "ChIJl4Dv838Z2jERuCIBbdwZbkk",
    "businessStatus": "OPERATIONAL",
    "phone": "8388 2200",
    "openingHours": [
      "Monday: 2:00 – 5:30 PM, 6:30 – 10:00 PM",
      "Tuesday: 2:00 – 5:30 PM, 6:30 – 10:00 PM",
      "Wednesday: 2:00 – 5:30 PM, 6:30 – 10:00 PM",
      "Thursday: Closed",
      "Friday: 2:00 – 5:30 PM, 6:30 – 10:00 PM",
      "Saturday: 2:00 – 5:30 PM, 6:30 – 10:00 PM",
      "Sunday: 2:00 – 6:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 45,
    "id": 996,
    "district": "Orchard"
  },
  {
    "title": "Inferno Gaming",
    "urlinform": "inferno-gaming",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://infernogamingsg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ09c1GVQX2jERsa7Wh5ZcXm4",
    "lat": 1.3378263,
    "lng": 103.8566871,
    "placeId": "ChIJ09c1GVQX2jERsa7Wh5ZcXm4",
    "businessStatus": "OPERATIONAL",
    "phone": "8198 8112",
    "openingHours": [
      "Monday: 12:00 PM – 12:00 AM",
      "Tuesday: 12:00 PM – 12:00 AM",
      "Wednesday: 12:00 PM – 12:00 AM",
      "Thursday: 12:00 PM – 12:00 AM",
      "Friday: 12:00 PM – 12:00 AM",
      "Saturday: 2:00 PM – 12:00 AM",
      "Sunday: 2:00 PM – 12:00 AM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 190,
    "id": 997
  },
  {
    "title": "DXCOLLECTION",
    "urlinform": "dxcollection",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://t.me/DXCOLLECTIONTCG",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh_-8UOSF_6IRe_vARozUmH0",
    "lat": 1.3005689,
    "lng": 103.8493227,
    "placeId": "ChIJh_-8UOSF_6IRe_vARozUmH0",
    "businessStatus": "OPERATIONAL",
    "phone": "8870 8257",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 615,
    "id": 998,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Dek TCG Shop",
    "urlinform": "dek-tcg-shop",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://dektcgshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1zom_GEZ2jERCGNHeMKN3uE",
    "lat": 1.3227672,
    "lng": 103.851969,
    "placeId": "ChIJ1zom_GEZ2jERCGNHeMKN3uE",
    "businessStatus": "OPERATIONAL",
    "phone": "8642 0288",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 69,
    "id": 999
  },
  {
    "title": "Cardboard Crack Games",
    "urlinform": "cardboard-crack-games",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.cardboardcrackgames.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJk9t21iAZ2jERUnval7iYsuc",
    "lat": 1.3423741,
    "lng": 103.7762593,
    "placeId": "ChIJk9t21iAZ2jERUnval7iYsuc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 5:00 – 10:00 PM",
      "Tuesday: 5:00 – 10:00 PM",
      "Wednesday: 5:00 – 10:00 PM",
      "Thursday: 5:00 – 10:00 PM",
      "Friday: 5:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 5:00 – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 51,
    "id": 1000
  },
  {
    "title": "LetsPlaySG",
    "urlinform": "letsplaysg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.tiktok.com/@letsplaysg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMZihVMcZ2jERV31MjGrykDA",
    "lat": 1.3257027,
    "lng": 103.8503421,
    "placeId": "ChIJMZihVMcZ2jERV31MjGrykDA",
    "businessStatus": "OPERATIONAL",
    "phone": "9022 9270",
    "openingHours": [
      "Monday: 1:00 – 9:30 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 9:30 PM",
      "Thursday: 1:00 – 9:30 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 9:30 PM",
      "Sunday: 1:00 – 9:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 119,
    "id": 1001
  },
  {
    "title": "Utopia Games",
    "urlinform": "utopia-games",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/utopiagamesSG",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJl8H2-IUX2jER7GIGzzbaB4Q",
    "lat": 1.36191,
    "lng": 103.8430174,
    "placeId": "ChIJl8H2-IUX2jER7GIGzzbaB4Q",
    "businessStatus": "OPERATIONAL",
    "phone": "9617 9275",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 96,
    "id": 1002
  },
  {
    "title": "Concept City",
    "urlinform": "concept-city",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHyg97WQZ2jERFDnbH68TNBY",
    "lat": 1.3068369,
    "lng": 103.8561207,
    "placeId": "ChIJHyg97WQZ2jERFDnbH68TNBY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 11:00 PM",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 1100,
    "id": 1003,
    "district": "Bugis"
  },
  {
    "title": "1Collectibles - Paya Lebar",
    "urlinform": "1collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "WS"
    ],
    "storeWebsite": "http://www.1collectibles.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJER3rlI4Z2jER7LXMO_Fwup0",
    "lat": 1.3145196,
    "lng": 103.8917013,
    "placeId": "ChIJER3rlI4Z2jER7LXMO_Fwup0",
    "businessStatus": "OPERATIONAL",
    "phone": "9022 2301",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1033,
    "id": 1004
  },
  {
    "title": "Zoomies Gaming",
    "urlinform": "zoomies-gaming",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://linktr.ee/ZoomiesGaming",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn46eHjwX2jERmUKU_rb-rbs",
    "lat": 1.3496931,
    "lng": 103.841902,
    "placeId": "ChIJn46eHjwX2jERmUKU_rb-rbs",
    "businessStatus": "OPERATIONAL",
    "phone": "8083 9192",
    "openingHours": [
      "Monday: 2:00 – 6:00 PM, 7:30 – 9:00 PM",
      "Tuesday: 2:00 – 6:00 PM, 7:30 – 10:00 PM",
      "Wednesday: Closed",
      "Thursday: 2:00 – 6:00 PM, 7:30 – 10:00 PM",
      "Friday: 2:00 – 6:00 PM, 7:30 – 10:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 207,
    "id": 1005
  },
  {
    "title": "Chase Collectibles",
    "urlinform": "chase-collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/chasecollectiblessg?igsh=b3BwN3F5NHowcGkx&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY5svTyEP2jEROyBnH9-BeIA",
    "lat": 1.3474876,
    "lng": 103.7099733,
    "placeId": "ChIJY5svTyEP2jEROyBnH9-BeIA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 11:00 PM",
      "Tuesday: 2:00 – 11:00 PM",
      "Wednesday: 2:00 – 11:00 PM",
      "Thursday: 2:00 – 11:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 11:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 148,
    "id": 1006
  },
  {
    "title": "N2 Toys TCG",
    "urlinform": "n2-toys-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://n2tcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP5I-9DIR2jERse6xCxXUJSc",
    "lat": 1.3423741,
    "lng": 103.7762593,
    "placeId": "ChIJP5I-9DIR2jERse6xCxXUJSc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:30 – 10:00 PM",
      "Tuesday: 12:30 – 10:00 PM",
      "Wednesday: 12:30 – 10:00 PM",
      "Thursday: 12:30 – 10:00 PM",
      "Friday: 12:30 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 290,
    "id": 1007
  },
  {
    "title": "Agora Hobby",
    "urlinform": "agora-hobby",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://agorahobby.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTffX98kZ2jER1rzU922moeo",
    "lat": 1.3084036,
    "lng": 103.8622518,
    "placeId": "ChIJTffX98kZ2jER1rzU922moeo",
    "businessStatus": "OPERATIONAL",
    "phone": "9876 7183",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 6:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 171,
    "id": 1008
  },
  {
    "title": "Dimension Gaming",
    "urlinform": "dimension-gaming",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Gundam",
      "Lorcana",
      "Pokémon"
    ],
    "storeWebsite": "https://linktr.ee/Dimensiongamingsg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ55k8q1cZ2jER0oP6lPKVKxs",
    "lat": 1.3250644,
    "lng": 103.8912437,
    "placeId": "ChIJ55k8q1cZ2jER0oP6lPKVKxs",
    "businessStatus": "OPERATIONAL",
    "phone": "8908 8971",
    "openingHours": [
      "Monday: 6:00 – 11:00 PM",
      "Tuesday: 6:00 – 11:00 PM",
      "Wednesday: 6:00 – 11:00 PM",
      "Thursday: 6:00 – 11:00 PM",
      "Friday: 6:00 – 11:00 PM",
      "Saturday: 3:00 – 11:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.6,
    "userRatingsTotal": 125,
    "id": 1009,
    "district": "Tai Seng MacPherson"
  },
  {
    "title": "Bricks Play",
    "urlinform": "bricks-play",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Bricksplay",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-eEQXGYX2jER9WU7cnoN4Mw",
    "lat": 1.3333603,
    "lng": 103.8488455,
    "placeId": "ChIJ-eEQXGYX2jER9WU7cnoN4Mw",
    "businessStatus": "OPERATIONAL",
    "phone": "8370 8652",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 137,
    "id": 1010
  },
  {
    "title": "Clash Collectibles TCG. POKEMON. ONE PIECE",
    "urlinform": "clash-collectibles-tcg-pokemon-one-piece",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://clashcollectibles.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK_fhIeAZ2jER4r7m_m5Lt1c",
    "lat": 1.2841948,
    "lng": 103.8414279,
    "placeId": "ChIJK_fhIeAZ2jER4r7m_m5Lt1c",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 7:00 – 11:30 PM",
      "Tuesday: 7:00 – 11:30 PM",
      "Wednesday: 7:00 – 11:30 PM",
      "Thursday: 7:00 – 11:30 PM",
      "Friday: 7:00 – 11:30 PM",
      "Saturday: 1:30 – 11:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 19,
    "id": 1011
  },
  {
    "title": "Happyland Collectibles",
    "urlinform": "happyland-collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://facebook.com/HappylandCollectibles/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGQHxgysZ2jER-pTQEYwcZ30",
    "lat": 1.2920098,
    "lng": 103.8499319,
    "placeId": "ChIJGQHxgysZ2jER-pTQEYwcZ30",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 6:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 50,
    "id": 1012
  },
  {
    "title": "Cardvolution - Cardvo Singapore",
    "urlinform": "cardvolution-cardvo-singapore",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cardvo.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJp31ff70Z2jERdNsgNnD-fjM",
    "lat": 1.3006954,
    "lng": 103.84475,
    "placeId": "ChIJp31ff70Z2jERdNsgNnD-fjM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 9:30 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 9:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 60,
    "id": 1013,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Concept Grading (Flagship)",
    "urlinform": "concept-grading-flagship",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.conceptgrading.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8f4nMgwZ2jER_sKyuPijvEc",
    "lat": 1.2866513,
    "lng": 103.8480738,
    "placeId": "ChIJ8f4nMgwZ2jER_sKyuPijvEc",
    "businessStatus": "OPERATIONAL",
    "phone": "8972 7769",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1761,
    "id": 1014
  },
  {
    "title": "Oxley Grading",
    "urlinform": "oxley-grading",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.oxleygrading.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVVVx5zoX2jERaTb-hc0peiU",
    "lat": 1.2981622,
    "lng": 103.844132,
    "placeId": "ChIJVVVx5zoX2jERaTb-hc0peiU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 335,
    "id": 1015,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Toynado Collectibles",
    "urlinform": "toynado-collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6eHfSVgZ2jERREmOMUWpXCo",
    "lat": 1.3005314,
    "lng": 103.8508826,
    "placeId": "ChIJ6eHfSVgZ2jERREmOMUWpXCo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:30 – 8:30 PM",
      "Tuesday: 12:30 – 8:30 PM",
      "Wednesday: 12:30 – 8:30 PM",
      "Thursday: Closed",
      "Friday: 12:30 – 8:30 PM",
      "Saturday: 12:30 – 9:00 PM",
      "Sunday: 12:30 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 89,
    "id": 1016,
    "district": "Bugis"
  },
  {
    "title": "TCG Card Supply",
    "urlinform": "tcg-card-supply",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://wa.me/+818026382190",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMZgsq1AZ2jERqn6PhzzMa6o",
    "lat": 1.3027133,
    "lng": 103.8384638,
    "placeId": "ChIJMZgsq1AZ2jERqn6PhzzMa6o",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4,
    "userRatingsTotal": 1,
    "id": 1017,
    "district": "Orchard"
  },
  {
    "title": "Card Arena by MyRepublic (Suntec City)",
    "urlinform": "card-arena-by-myrepublic",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Flesh and Blood",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Vanguard",
      "WS"
    ],
    "storeWebsite": "https://cardarena.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5WWoSwAZ2jERjj9L-X-q5vA",
    "lat": 1.2939965,
    "lng": 103.8572564,
    "placeId": "ChIJ5WWoSwAZ2jERjj9L-X-q5vA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 105,
    "id": 1018,
    "district": "Bugis"
  },
  {
    "title": "Genie TCG",
    "urlinform": "genie-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://genie-tcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQS1kedgb2jERaDJSSqi8ks0",
    "lat": 1.2829346,
    "lng": 103.8206082,
    "placeId": "ChIJQS1kedgb2jERaDJSSqi8ks0",
    "businessStatus": "OPERATIONAL",
    "phone": "9126 1304",
    "openingHours": [
      "Monday: 2:00 PM – 2:00 AM",
      "Tuesday: 2:00 PM – 2:00 AM",
      "Wednesday: 2:00 PM – 2:00 AM",
      "Thursday: 2:00 PM – 2:00 AM",
      "Friday: 2:00 PM – 2:00 AM",
      "Saturday: Closed",
      "Sunday: 11:00 PM – 3:00 AM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 39,
    "id": 1019
  },
  {
    "title": "OBO Collectibles",
    "urlinform": "obo-collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVYau8jAZ2jER_usZ0e_iiYI",
    "lat": 1.2989163,
    "lng": 103.8519697,
    "placeId": "ChIJVYau8jAZ2jER_usZ0e_iiYI",
    "businessStatus": "OPERATIONAL",
    "phone": "8756 7606",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1346,
    "id": 1020,
    "district": "Bugis"
  },
  {
    "title": "Mova Collectibles",
    "urlinform": "mova-collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJy256NCcb2jERwcSxzhSqlfw",
    "lat": 1.2864619,
    "lng": 103.8042002,
    "placeId": "ChIJy256NCcb2jERwcSxzhSqlfw",
    "businessStatus": "OPERATIONAL",
    "phone": "9680 2978",
    "openingHours": [
      "Monday: 12:00 – 8:30 PM",
      "Tuesday: 12:00 – 8:30 PM",
      "Wednesday: 12:00 – 8:30 PM",
      "Thursday: 12:00 – 8:30 PM",
      "Friday: 12:00 – 8:30 PM",
      "Saturday: 12:00 – 4:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 47,
    "id": 1021
  },
  {
    "title": "Paradigm Infinitum Pte Ltd",
    "urlinform": "paradigm-infinitum-pte-ltd",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://www.pi.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5SdSMZEZ2jERkZbHxmzCpMQ",
    "lat": 1.3016679,
    "lng": 103.8385816,
    "placeId": "ChIJ5SdSMZEZ2jERkZbHxmzCpMQ",
    "businessStatus": "OPERATIONAL",
    "phone": "6734 3858",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 14,
    "id": 1022,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Kami Kekkai",
    "urlinform": "kami-kekkai",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://kamikekkai.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVW_Ex_sb2jER9jFBEsjzGoQ",
    "lat": 1.287426,
    "lng": 103.8034629,
    "placeId": "ChIJVW_Ex_sb2jER9jFBEsjzGoQ",
    "businessStatus": "OPERATIONAL",
    "phone": "8988 0331",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1277,
    "id": 1023
  },
  {
    "title": "MXYYC",
    "urlinform": "mxyyc",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "https://mxyyc.community/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-75qHooX2jERpCyc724btto",
    "lat": 1.358606,
    "lng": 103.833566,
    "placeId": "ChIJ-75qHooX2jERpCyc724btto",
    "businessStatus": "OPERATIONAL",
    "phone": "9295 4911",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 11:00 PM",
      "Thursday: 2:00 – 11:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 55,
    "id": 1024
  },
  {
    "title": "Waxxed Sports Cards",
    "urlinform": "waxxed-sports-cards",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.waxxedcards.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLxa-DBgZ2jERwANSn07wLQU",
    "lat": 1.2880209,
    "lng": 103.8469761,
    "placeId": "ChIJLxa-DBgZ2jERwANSn07wLQU",
    "businessStatus": "OPERATIONAL",
    "phone": "6047 0387",
    "openingHours": [
      "Monday: 11:30 AM – 8:30 PM",
      "Tuesday: 11:30 AM – 8:30 PM",
      "Wednesday: 11:30 AM – 8:30 PM",
      "Thursday: 11:30 AM – 8:30 PM",
      "Friday: 11:30 AM – 8:30 PM",
      "Saturday: 11:30 AM – 8:30 PM",
      "Sunday: 11:30 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 629,
    "id": 1025
  },
  {
    "title": "Postcard Orchard",
    "urlinform": "postcard-orchard",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.wearepostcard.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJlTgRmfgZ2jERUGJrCQ-BC0g",
    "lat": 1.3033504,
    "lng": 103.8340118,
    "placeId": "ChIJlTgRmfgZ2jERUGJrCQ-BC0g",
    "businessStatus": "OPERATIONAL",
    "phone": "8026 8584",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 260,
    "id": 1026,
    "district": "Orchard"
  },
  {
    "title": "Card Bound",
    "urlinform": "card-bound",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Lorcana"
    ],
    "storeWebsite": "https://www.cardboundgames.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBTMPAvMb2jERenuZKiyoQ40",
    "lat": 1.3076695,
    "lng": 103.792542,
    "placeId": "ChIJBTMPAvMb2jERenuZKiyoQ40",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 45,
    "id": 1027
  },
  {
    "title": "Magic Castle Singapore",
    "urlinform": "magic-castle-singapore",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.magiccastle.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJu_DHjq8Z2jERaxMlgbmFUqw",
    "lat": 1.3009458,
    "lng": 103.8411911,
    "placeId": "ChIJu_DHjq8Z2jERaxMlgbmFUqw",
    "businessStatus": "OPERATIONAL",
    "phone": "9689 1417",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 6:00 – 9:00 PM",
      "Wednesday: 6:00 – 9:00 PM",
      "Thursday: 6:00 – 9:00 PM",
      "Friday: 6:00 – 9:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 362,
    "id": 1028,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Excel cs",
    "urlinform": "excel-cs",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/profile.php?id=271710619522992",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFQv0Xb0Z2jERbeoDTMp5tqA",
    "lat": 1.2992861,
    "lng": 103.8456367,
    "placeId": "ChIJFQv0Xb0Z2jERbeoDTMp5tqA",
    "businessStatus": "OPERATIONAL",
    "phone": "9664 3175",
    "openingHours": [
      "Monday: 1:30 – 10:00 PM",
      "Tuesday: 1:30 – 10:00 PM",
      "Wednesday: 1:30 – 10:00 PM",
      "Thursday: 1:30 – 10:00 PM",
      "Friday: 1:30 – 10:00 PM",
      "Saturday: 1:30 – 10:00 PM",
      "Sunday: 1:30 – 10:00 PM"
    ],
    "rating": 2,
    "userRatingsTotal": 131,
    "id": 1029,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Unsleeved by Lazy Potato",
    "urlinform": "unsleeved-by-lazy-potato",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.treasuresbylazypotato.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY3UgMU4Z2jERQR5lp7593kI",
    "lat": 1.3042819,
    "lng": 103.8596373,
    "placeId": "ChIJY3UgMU4Z2jERQR5lp7593kI",
    "businessStatus": "OPERATIONAL",
    "phone": "8351 9079",
    "openingHours": [
      "Monday: 11:00 AM – 1:00 AM",
      "Tuesday: 11:00 AM – 1:00 AM",
      "Wednesday: 11:00 AM – 1:00 AM",
      "Thursday: 11:00 AM – 1:00 AM",
      "Friday: 11:00 AM – 1:00 AM",
      "Saturday: 11:00 AM – 1:00 AM",
      "Sunday: 11:00 AM – 1:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 18,
    "id": 1030,
    "district": "Bugis"
  },
  {
    "title": "Fastpoke Mart",
    "urlinform": "fastpoke-mart",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "http://fastpokemart.myshopify.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP8TMAVcZ2jERpdC8BkKlSpA",
    "lat": 1.2806138,
    "lng": 103.8528076,
    "placeId": "ChIJP8TMAVcZ2jERpdC8BkKlSpA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.7,
    "userRatingsTotal": 75,
    "id": 1031
  },
  {
    "title": "CardGaiden",
    "urlinform": "cardgaiden",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/CardGaiden",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrb-sDOcZ2jERozlysCACD3w",
    "lat": 1.3030433,
    "lng": 103.8529208,
    "placeId": "ChIJrb-sDOcZ2jERozlysCACD3w",
    "businessStatus": "OPERATIONAL",
    "phone": "8869 1341",
    "openingHours": [],
    "rating": 4,
    "userRatingsTotal": 63,
    "id": 1032,
    "district": "Bugis"
  },
  {
    "title": "GameMartz @ Bugis Junction",
    "urlinform": "gamemartz-bugis-junction",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linktr.ee/GameMartzBugisJunction",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9R411qAZ2jERfamfCdPuuCE",
    "lat": 1.2992456,
    "lng": 103.8551852,
    "placeId": "ChIJ9R411qAZ2jERfamfCdPuuCE",
    "businessStatus": "CLOSED_TEMPORARILY",
    "phone": "6336 0217",
    "openingHours": [],
    "rating": 4.4,
    "userRatingsTotal": 419,
    "id": 1033,
    "district": "Bugis"
  },
  {
    "title": "TripleTactics TCG",
    "urlinform": "tripletactics-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://linktr.ee/tripletacticstcg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8_5b32QZ2jERhX15JMdbwro",
    "lat": 1.30307,
    "lng": 103.8529155,
    "placeId": "ChIJ8_5b32QZ2jERhX15JMdbwro",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:30 – 8:30 PM",
      "Tuesday: 2:30 – 8:30 PM",
      "Wednesday: 2:30 – 8:30 PM",
      "Thursday: 2:30 – 8:30 PM",
      "Friday: 2:30 – 8:30 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 25,
    "id": 1034,
    "district": "Bugis"
  },
  {
    "title": "The Pokemon Guys",
    "urlinform": "the-pokemon-guys",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrzpeUy8X2jER2K_ZNK00ZJQ",
    "lat": 1.3264632,
    "lng": 103.896365,
    "placeId": "ChIJrzpeUy8X2jER2K_ZNK00ZJQ",
    "businessStatus": "OPERATIONAL",
    "phone": "9236 1675",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: Closed",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 56,
    "id": 1035
  },
  {
    "title": "Asianmagickards",
    "urlinform": "asianmagickards",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJw9snPbsZ2jERneAY04FGDL0",
    "lat": 1.2986865,
    "lng": 103.8520951,
    "placeId": "ChIJw9snPbsZ2jERneAY04FGDL0",
    "businessStatus": "OPERATIONAL",
    "phone": "6336 6844",
    "openingHours": [
      "Monday: 11:30 AM – 7:00 PM",
      "Tuesday: 11:30 AM – 8:00 PM",
      "Wednesday: 11:30 AM – 7:00 PM",
      "Thursday: 11:30 AM – 7:00 PM",
      "Friday: 11:30 AM – 8:00 PM",
      "Saturday: 11:30 AM – 8:00 PM",
      "Sunday: 11:30 AM – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 54,
    "id": 1036,
    "district": "Bugis"
  },
  {
    "title": "KouritenSG",
    "urlinform": "kouritensg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/KouritenSG",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQW0YF4AZ2jERNKyNMhAKT4E",
    "lat": 1.2851385,
    "lng": 103.8463117,
    "placeId": "ChIJQW0YF4AZ2jERNKyNMhAKT4E",
    "businessStatus": "OPERATIONAL",
    "phone": "8951 2851",
    "openingHours": [
      "Monday: 12:00 – 11:00 PM",
      "Tuesday: 12:00 – 11:00 PM",
      "Wednesday: 12:00 – 11:00 PM",
      "Thursday: 12:00 – 11:00 PM",
      "Friday: 12:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 237,
    "id": 1037
  },
  {
    "title": "Battle Bunker @ KAP Mall",
    "urlinform": "battle-bunker-kap-mall",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/battlebunker",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ18wZ9QQR2jERKSjKi94EUic",
    "lat": 1.3370643,
    "lng": 103.7794908,
    "placeId": "ChIJ18wZ9QQR2jERKSjKi94EUic",
    "businessStatus": "OPERATIONAL",
    "phone": "9384 0450",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 1038
  },
  {
    "title": "One MTG",
    "urlinform": "one-mtg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Lorcana",
      "MTG",
      "Pokémon"
    ],
    "storeWebsite": "http://onemtg.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJofORDRgZ2jERpDDUk78HyHU",
    "lat": 1.3029608,
    "lng": 103.8617011,
    "placeId": "ChIJofORDRgZ2jERpDDUk78HyHU",
    "businessStatus": "OPERATIONAL",
    "phone": "9048 5881",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 29,
    "id": 1039,
    "district": "Bugis"
  },
  {
    "title": "ALL BLUE COLLECTIBLES",
    "urlinform": "all-blue-collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://t.me/allbluecollectibless",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGa7EUPcX2jERe0lUu7WIINU",
    "lat": 1.3257272,
    "lng": 103.8900753,
    "placeId": "ChIJGa7EUPcX2jERe0lUu7WIINU",
    "businessStatus": "OPERATIONAL",
    "phone": "8029 0225",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 259,
    "id": 1040,
    "district": "Tai Seng MacPherson"
  },
  {
    "title": "Project EXT",
    "urlinform": "project-ext",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://project-ext.crystalcommerce.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFSXgoWAX2jERA9plYDAGx00",
    "lat": 1.3062864,
    "lng": 103.8581069,
    "placeId": "ChIJFSXgoWAX2jERA9plYDAGx00",
    "businessStatus": "OPERATIONAL",
    "phone": "9190 4737",
    "openingHours": [
      "Monday: 12:00 – 6:00 PM",
      "Tuesday: 12:00 – 6:00 PM",
      "Wednesday: 12:00 – 6:00 PM",
      "Thursday: 12:00 – 6:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 68,
    "id": 1041,
    "district": "Bugis"
  },
  {
    "title": "Daimonji Collectibles",
    "urlinform": "daimonji-collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.daimonjitcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc4S_y88b2jERITJkqDN6ZCw",
    "lat": 1.3487053,
    "lng": 103.7032888,
    "placeId": "ChIJc4S_y88b2jERITJkqDN6ZCw",
    "businessStatus": "OPERATIONAL",
    "phone": "8338 5425",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 6:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 166,
    "id": 1042
  },
  {
    "title": "Brints Collectibles",
    "urlinform": "brints-collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "WS"
    ],
    "storeWebsite": "http://brintsco.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLQeJs2cX2jER-f8D9XKK3sI",
    "lat": 1.3154236,
    "lng": 103.8801884,
    "placeId": "ChIJLQeJs2cX2jER-f8D9XKK3sI",
    "businessStatus": "OPERATIONAL",
    "phone": "8899 3616",
    "openingHours": [
      "Monday: 4:30 – 10:00 PM",
      "Tuesday: 4:30 – 10:00 PM",
      "Wednesday: 4:30 – 10:00 PM",
      "Thursday: 4:30 – 10:00 PM",
      "Friday: 4:30 – 10:00 PM",
      "Saturday: 4:30 – 10:00 PM",
      "Sunday: 1:00 – 6:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 201,
    "id": 1043
  },
  {
    "title": "The TCG Alchemists",
    "urlinform": "the-tcg-alchemists",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://thetcgalchemists.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK8NqVAAZ2jER_-csm2jt60c",
    "lat": 1.3029062,
    "lng": 103.8618139,
    "placeId": "ChIJK8NqVAAZ2jER_-csm2jt60c",
    "businessStatus": "OPERATIONAL",
    "phone": "9824 0007",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 9,
    "id": 1044,
    "district": "Bugis"
  },
  {
    "title": "The Imaginarium",
    "urlinform": "the-imaginarium",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Digimon",
      "Flesh and Blood",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "https://www.theimaginariumsg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ92GMCx492jERCWs5CfL_8Cc",
    "lat": 1.3002264,
    "lng": 103.85382,
    "placeId": "ChIJ92GMCx492jERCWs5CfL_8Cc",
    "businessStatus": "OPERATIONAL",
    "phone": "9046 1717",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 23,
    "id": 1045,
    "district": "Bugis"
  },
  {
    "title": "The Playhouse TCG",
    "urlinform": "the-playhouse-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://t.me/theplayhousetcg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUWVhP14R2jERpY9fyHJA4wo",
    "lat": 1.3405952,
    "lng": 103.7739537,
    "placeId": "ChIJUWVhP14R2jERpY9fyHJA4wo",
    "businessStatus": "OPERATIONAL",
    "phone": "8207 0062",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 3:00 – 11:00 PM",
      "Sunday: 3:00 – 11:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 70,
    "id": 1046
  },
  {
    "title": "Games Haven @ Jurong Gateway",
    "urlinform": "games-haven-jurong-gateway",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKXhXfwUQ2jERRymSq_uy6GM",
    "lat": 1.3344041,
    "lng": 103.7402077,
    "placeId": "ChIJKXhXfwUQ2jERRymSq_uy6GM",
    "businessStatus": "OPERATIONAL",
    "phone": "9647 0856",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: Closed"
    ],
    "rating": 3.6,
    "userRatingsTotal": 56,
    "id": 1047,
    "district": "Jurong"
  },
  {
    "title": "DiscardTCG @ Jurong",
    "urlinform": "discardtcg-jurong",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/discardtcg?igsh=MW9tMnkwaTJyNHR1bg==",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1XnPHI8R2jERouDpDaZ6jZY",
    "lat": 1.3342748,
    "lng": 103.7396594,
    "placeId": "ChIJ1XnPHI8R2jERouDpDaZ6jZY",
    "businessStatus": "OPERATIONAL",
    "phone": "8995 5622",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 12,
    "id": 1048,
    "district": "Jurong"
  },
  {
    "title": "CC Collectibles @ Clementi",
    "urlinform": "cc-collectibles-clementi",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/cc_collectibles_sg?igsh=MWExOTEzcG1vc2Z4ZA==&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc0f4Fe8b2jERfFgDZoJuwGE",
    "lat": 1.3167723,
    "lng": 103.7651688,
    "placeId": "ChIJc0f4Fe8b2jERfFgDZoJuwGE",
    "businessStatus": "OPERATIONAL",
    "phone": "8670 6428",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 522,
    "id": 1049
  },
  {
    "title": "Toy Or Game (TOG)",
    "urlinform": "toy-or-game-tog",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.toyorgame.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9-axLZMP2jER6iLeWboTZLw",
    "lat": 1.3400353,
    "lng": 103.7061073,
    "placeId": "ChIJ9-axLZMP2jER6iLeWboTZLw",
    "businessStatus": "OPERATIONAL",
    "phone": "6316 5984",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 141,
    "id": 1050
  },
  {
    "title": "T-OCG",
    "urlinform": "t-ocg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=100054612632321",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY_RDgcYR2jERmF_cSIgt3Uw",
    "lat": 1.3570307,
    "lng": 103.763132,
    "placeId": "ChIJY_RDgcYR2jERmF_cSIgt3Uw",
    "businessStatus": "OPERATIONAL",
    "phone": "9361 4497",
    "openingHours": [
      "Monday: 3:00 – 8:00 PM",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 56,
    "id": 1051
  },
  {
    "title": "VictoryRD TCG",
    "urlinform": "victoryrd-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/victoryrd.tcg?igsh=MTdtbW1uanR1c2I2OQ==&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYVQ6RgAR2jER2e6srgeDq_4",
    "lat": 1.3436801,
    "lng": 103.7371605,
    "placeId": "ChIJYVQ6RgAR2jER2e6srgeDq_4",
    "businessStatus": "OPERATIONAL",
    "phone": "9823 1926",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 24,
    "id": 1052,
    "district": "Jurong"
  },
  {
    "title": "EP Hobby",
    "urlinform": "ep-hobby",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJw5lrQQAX2jERrMhpnego6uI",
    "lat": 1.3707583,
    "lng": 103.8438413,
    "placeId": "ChIJw5lrQQAX2jERrMhpnego6uI",
    "businessStatus": "OPERATIONAL",
    "phone": "8220 3328",
    "openingHours": [
      "Monday: 12:30 – 8:00 PM",
      "Tuesday: 12:30 – 8:00 PM",
      "Wednesday: 12:30 – 11:00 PM",
      "Thursday: 12:30 – 11:00 PM",
      "Friday: 12:30 – 11:00 PM",
      "Saturday: 12:30 – 11:00 PM",
      "Sunday: 12:30 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 84,
    "id": 1053
  },
  {
    "title": "Daruma Gaming",
    "urlinform": "daruma-gaming",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://darumagaming.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc18yUYwb2jERc0Pp2QP6riM",
    "lat": 1.3166406,
    "lng": 103.7573384,
    "placeId": "ChIJc18yUYwb2jERc0Pp2QP6riM",
    "businessStatus": "OPERATIONAL",
    "phone": "8938 9436",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:30 – 7:00 PM",
      "Wednesday: 2:30 – 7:00 PM",
      "Thursday: Closed",
      "Friday: 2:30 – 8:30 PM",
      "Saturday: 2:30 – 8:30 PM",
      "Sunday: 2:30 – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 1054
  },
  {
    "title": "The Gentlemen’s Vault",
    "urlinform": "the-gentlemens-vault",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://gentlemenvault.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrfGFh54T2jERISVN-hCjFiE",
    "lat": 1.4373009,
    "lng": 103.8068931,
    "placeId": "ChIJrfGFh54T2jERISVN-hCjFiE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:30 AM – 12:00 PM, 2:00 – 6:00 PM",
      "Tuesday: 9:30 AM – 12:00 PM, 2:00 – 6:00 PM",
      "Wednesday: 9:30 AM – 12:00 PM, 2:00 – 6:00 PM",
      "Thursday: 9:30 AM – 12:00 PM, 2:00 – 6:00 PM",
      "Friday: 9:30 AM – 12:00 PM, 2:00 – 6:00 PM",
      "Saturday: 9:30 AM – 1:30 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 841,
    "id": 1055
  },
  {
    "title": "Mana Pro - Choa Chu Kang",
    "urlinform": "mana-pro",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Flesh and Blood",
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://sg-manapro.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNydeZnYR2jERT3JnTasIhjs",
    "lat": 1.3815594,
    "lng": 103.7495316,
    "placeId": "ChIJNydeZnYR2jERT3JnTasIhjs",
    "businessStatus": "OPERATIONAL",
    "phone": "8812 4470",
    "openingHours": [
      "Monday: 2:00 – 9:30 PM",
      "Tuesday: 2:00 – 9:30 PM",
      "Wednesday: Closed",
      "Thursday: 2:00 – 9:30 PM",
      "Friday: 2:00 – 9:30 PM",
      "Saturday: 2:00 – 9:30 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 117,
    "id": 1056
  },
  {
    "title": "Urban Arena Pte Ltd",
    "urlinform": "urban-arena-pte-ltd",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://urban-arena-pte-ltd.kyte.site/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_SbvIlEP2jERBa_LrCOQPIk",
    "lat": 1.3323706,
    "lng": 103.6972682,
    "placeId": "ChIJ_SbvIlEP2jERBa_LrCOQPIk",
    "businessStatus": "OPERATIONAL",
    "phone": "8136 7783",
    "openingHours": [
      "Monday: 6:00 PM – 2:00 AM",
      "Tuesday: 6:00 PM – 2:00 AM",
      "Wednesday: 6:00 PM – 2:00 AM",
      "Thursday: 6:00 PM – 2:00 AM",
      "Friday: 6:00 PM – 2:00 AM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 42,
    "id": 1057
  },
  {
    "title": "Newtro Gaming Studios",
    "urlinform": "newtro-gaming-studios",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://newtroshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXQUNqYIZ2jERhCuTvL45P5I",
    "lat": 1.287817,
    "lng": 103.8340295,
    "placeId": "ChIJXQUNqYIZ2jERhCuTvL45P5I",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:30 – 8:00 PM",
      "Wednesday: 1:30 – 8:00 PM",
      "Thursday: 1:30 – 8:00 PM",
      "Friday: 1:30 – 8:00 PM",
      "Saturday: 1:30 – 8:00 PM",
      "Sunday: 1:30 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 220,
    "id": 1058
  },
  {
    "title": "King collex",
    "urlinform": "king-collex",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linktr.ee/King_collex",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN-Wj5p4P2jER34nLbWUkuko",
    "lat": 1.3507131,
    "lng": 103.7199857,
    "placeId": "ChIJN-Wj5p4P2jER34nLbWUkuko",
    "businessStatus": "OPERATIONAL",
    "phone": "9671 3981",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 6,
    "id": 1059
  },
  {
    "title": "Trion TCG",
    "urlinform": "trion-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/share/1Ga2XHPDuY/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJifwjXWkb2jERjshpbYGyuJY",
    "lat": 1.3434331,
    "lng": 103.7758769,
    "placeId": "ChIJifwjXWkb2jERjshpbYGyuJY",
    "businessStatus": "OPERATIONAL",
    "phone": "8455 9088",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 5:00 – 8:30 PM",
      "Saturday: 5:00 – 7:00 PM",
      "Sunday: 3:00 – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 14,
    "id": 1060
  },
  {
    "title": "Seng Lit's Card Syndicate ( Trading Cards / TCG )",
    "urlinform": "seng-lits-card-syndicate-trading-cards-tcg-",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/senglitscardsyndicate?igsh=dzF1cnRtNXJ6enJy&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJe3SdRmwT2jERMki64tQHF9s",
    "lat": 1.4351696,
    "lng": 103.8048721,
    "placeId": "ChIJe3SdRmwT2jERMki64tQHF9s",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 6:00 PM",
      "Tuesday: 1:00 – 8:30 PM",
      "Wednesday: 1:00 – 8:30 PM",
      "Thursday: 1:00 – 8:30 PM",
      "Friday: 1:00 – 8:30 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 18,
    "id": 1061
  },
  {
    "title": "Full-yen Trading",
    "urlinform": "full-yen-trading",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc3wkSPER2jERDut25a7k8tk",
    "lat": 1.3969618,
    "lng": 103.7448792,
    "placeId": "ChIJc3wkSPER2jERDut25a7k8tk",
    "businessStatus": "OPERATIONAL",
    "phone": "6892 5471",
    "openingHours": [
      "Monday: 11:30 AM – 9:30 PM",
      "Tuesday: Closed",
      "Wednesday: 11:30 AM – 9:30 PM",
      "Thursday: 11:30 AM – 9:30 PM",
      "Friday: 11:30 AM – 9:30 PM",
      "Saturday: 11:30 AM – 9:30 PM",
      "Sunday: 11:30 AM – 9:30 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 217,
    "id": 1062
  },
  {
    "title": "CardsandGrading - Meta Games",
    "urlinform": "cardsandgrading-meta-games",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "MTG",
      "Pokémon"
    ],
    "storeWebsite": "http://metagamestcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJyc-ZgoR2jERiIFUzF0c6AM",
    "lat": 1.343183,
    "lng": 103.7760315,
    "placeId": "ChIJJyc-ZgoR2jERiIFUzF0c6AM",
    "businessStatus": "OPERATIONAL",
    "phone": "8611 6112",
    "openingHours": [],
    "rating": 3.5,
    "userRatingsTotal": 4,
    "id": 1063
  },
  {
    "title": "Hideyoshi",
    "urlinform": "hideyoshi",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://hideyoshitcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ81AKGAAP2jERRIn_CH2W8O0",
    "lat": 1.3492252,
    "lng": 103.7192003,
    "placeId": "ChIJ81AKGAAP2jERRIn_CH2W8O0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 7:00 – 11:00 PM",
      "Tuesday: 7:00 – 11:00 PM",
      "Wednesday: 7:00 – 11:00 PM",
      "Thursday: 7:00 – 11:00 PM",
      "Friday: 7:00 – 11:00 PM",
      "Saturday: 3:00 – 11:00 PM",
      "Sunday: 3:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 28,
    "id": 1064
  },
  {
    "title": "Hako",
    "urlinform": "hako",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://toyoutpost.sg/outlets/hako-jurong-point/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJix7zq_4P2jERJeVvf-Ho0xw",
    "lat": 1.3403817,
    "lng": 103.7064897,
    "placeId": "ChIJix7zq_4P2jERJeVvf-Ho0xw",
    "businessStatus": "OPERATIONAL",
    "phone": "6255 1604",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 10:30 AM – 9:30 PM",
      "Sunday: 10:30 AM – 9:30 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 66,
    "id": 1065
  },
  {
    "title": "PokeTee",
    "urlinform": "poketee",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://shopee.sg/poketee",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXc4jotQR2jERDhHtKDTZpzA",
    "lat": 1.3415814,
    "lng": 103.7758553,
    "placeId": "ChIJXc4jotQR2jERDhHtKDTZpzA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 7:00 – 8:00 PM",
      "Wednesday: 7:00 – 8:00 PM",
      "Thursday: 7:00 – 8:00 PM",
      "Friday: 7:00 – 8:00 PM",
      "Saturday: 2:00 – 6:00 PM",
      "Sunday: 2:00 – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 40,
    "id": 1066
  },
  {
    "title": "Beginner's Luck",
    "urlinform": "beginners-luck",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=100086965917762",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGS0VAf4b2jERKBwkuorhkRs",
    "lat": 1.2766033,
    "lng": 103.7920154,
    "placeId": "ChIJGS0VAf4b2jERKBwkuorhkRs",
    "businessStatus": "OPERATIONAL",
    "phone": "9711 0763",
    "openingHours": [
      "Monday: 2:30 – 8:30 PM",
      "Tuesday: 2:30 – 8:30 PM",
      "Wednesday: Closed",
      "Thursday: 2:30 – 8:30 PM",
      "Friday: 2:30 – 8:30 PM",
      "Saturday: 2:30 – 8:30 PM",
      "Sunday: 2:30 – 8:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 39,
    "id": 1067
  },
  {
    "title": "Precious Thoughts (JEM)",
    "urlinform": "precious-thoughts-jem",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://preciousthoughts.co/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG9eysQ4Z2jER2eByFuOMpMg",
    "lat": 1.3331905,
    "lng": 103.7436208,
    "placeId": "ChIJG9eysQ4Z2jER2eByFuOMpMg",
    "businessStatus": "OPERATIONAL",
    "phone": "6684 0587",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 93,
    "id": 1068,
    "district": "Jurong"
  },
  {
    "title": "Gifts Greetings",
    "urlinform": "gifts-greetings",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Dragon Ball",
      "One Piece"
    ],
    "storeWebsite": "https://www.giftsgreetings.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK-p7Hg8Q2jERPxOWV7H1bOc",
    "lat": 1.3332396,
    "lng": 103.7432386,
    "placeId": "ChIJK-p7Hg8Q2jERPxOWV7H1bOc",
    "businessStatus": "OPERATIONAL",
    "phone": "6262 5272",
    "openingHours": [
      "Monday: 11:00 AM – 9:20 PM",
      "Tuesday: 11:00 AM – 9:20 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:20 PM",
      "Saturday: 11:00 AM – 9:20 PM",
      "Sunday: 11:00 AM – 9:20 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 61,
    "id": 1069,
    "district": "Jurong"
  },
  {
    "title": "Card Nation",
    "urlinform": "card-nation",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/CardNationSG/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF5MM9aoT2jERidrrKpbByf8",
    "lat": 1.3530845,
    "lng": 103.8340754,
    "placeId": "ChIJF5MM9aoT2jERidrrKpbByf8",
    "businessStatus": "OPERATIONAL",
    "phone": "9008 8091",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 7:00 – 11:00 PM",
      "Wednesday: 7:00 – 11:00 PM",
      "Thursday: 7:00 – 11:00 PM",
      "Friday: 7:00 – 11:00 PM",
      "Saturday: 3:30 – 11:00 PM",
      "Sunday: 1:30 – 7:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 75,
    "id": 1070
  },
  {
    "title": "Games Haven",
    "urlinform": "games-haven",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Flesh and Blood",
      "MTG"
    ],
    "storeWebsite": "http://www.gameshaventcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAckK0RcY2jERoomQZ6CzrCw",
    "lat": 1.3148582,
    "lng": 103.8919118,
    "placeId": "ChIJAckK0RcY2jERoomQZ6CzrCw",
    "businessStatus": "OPERATIONAL",
    "phone": "9880 8723",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 93,
    "id": 1071
  },
  {
    "title": "Pokey Mart - Card Restoration & Grading Services",
    "urlinform": "pokey-mart",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://heylink.me/POKEYMART/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsyuXQzY5zDERJeNjAM1MH3c",
    "lat": 3.2124696,
    "lng": 101.7288554,
    "placeId": "ChIJsyuXQzY5zDERJeNjAM1MH3c",
    "businessStatus": "OPERATIONAL",
    "phone": "017-709 8834",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 453,
    "id": 1072
  },
  {
    "title": "KAADOYA (カード屋)",
    "urlinform": "kaadoya-",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJr6icEQA3zDERGeLzjXSx96Y",
    "lat": 3.1405257,
    "lng": 101.7080565,
    "placeId": "ChIJr6icEQA3zDERGeLzjXSx96Y",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 140,
    "id": 1073,
    "district": "Bukit Bintang"
  },
  {
    "title": "Ace Cards • Mid Valley Megamall",
    "urlinform": "ace-cards-mid-valley-megamall",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://acecards.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJI8KOl45JzDERjqOzJybPGQ0",
    "lat": 3.1174103,
    "lng": 101.6777107,
    "placeId": "ChIJI8KOl45JzDERjqOzJybPGQ0",
    "businessStatus": "OPERATIONAL",
    "phone": "03-2201 2899",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 357,
    "id": 1074,
    "district": "Mid Valley"
  },
  {
    "title": "Isekai Hobby",
    "urlinform": "isekai-hobby",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/isekaihobbykl?igsh=MTVlZ3loanJ5a3N0Yg==",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHbAl731JzDERpRyJpdRn4hs",
    "lat": 3.1448922,
    "lng": 101.7045655,
    "placeId": "ChIJHbAl731JzDERpRyJpdRn4hs",
    "businessStatus": "OPERATIONAL",
    "phone": "018-212 0412",
    "openingHours": [
      "Monday: 11:00 AM – 7:30 PM",
      "Tuesday: 11:00 AM – 7:30 PM",
      "Wednesday: 11:00 AM – 7:30 PM",
      "Thursday: 11:00 AM – 7:30 PM",
      "Friday: 11:00 AM – 7:30 PM",
      "Saturday: 11:00 AM – 7:30 PM",
      "Sunday: 11:00 AM – 7:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 122,
    "id": 1075,
    "district": "Bukit Bintang"
  },
  {
    "title": "MY Hobby & Collectibles",
    "urlinform": "my-hobby-collectibles",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.myhobbyandcollectibles.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7w72tyBLzDERX5ieODsfcjQ",
    "lat": 3.0699003,
    "lng": 101.6902495,
    "placeId": "ChIJ7w72tyBLzDERX5ieODsfcjQ",
    "businessStatus": "OPERATIONAL",
    "phone": "014-975 4341",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 PM – 12:00 AM",
      "Wednesday: 12:00 PM – 12:00 AM",
      "Thursday: 12:00 PM – 12:00 AM",
      "Friday: 12:00 PM – 12:00 AM",
      "Saturday: 12:00 PM – 12:00 AM",
      "Sunday: 12:00 PM – 12:00 AM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 184,
    "id": 1076
  },
  {
    "title": "Cards Dojo (Sunway Velocity)",
    "urlinform": "cards-dojo-sunway-velocity",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSdXZoKkIuU4RWk63IWZFVRM",
    "lat": 3.1277155,
    "lng": 101.7237652,
    "placeId": "ChIJSdXZoKkIuU4RWk63IWZFVRM",
    "businessStatus": "OPERATIONAL",
    "phone": "014-604 8248",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 344,
    "id": 1077
  },
  {
    "title": "Atom Square",
    "urlinform": "atom-square",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/AtomSquare/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd4s2_mk3zDERT-iMM5BPrro",
    "lat": 3.1448481,
    "lng": 101.7110459,
    "placeId": "ChIJd4s2_mk3zDERT-iMM5BPrro",
    "businessStatus": "OPERATIONAL",
    "phone": "017-682 0023",
    "openingHours": [
      "Monday: 12:30 – 9:30 PM",
      "Tuesday: 12:30 – 9:30 PM",
      "Wednesday: 12:30 – 9:30 PM",
      "Thursday: 12:30 – 9:30 PM",
      "Friday: 12:30 – 9:30 PM",
      "Saturday: 12:30 – 9:30 PM",
      "Sunday: 12:30 – 9:30 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 54,
    "id": 1078,
    "district": "Bukit Bintang"
  },
  {
    "title": "Gaia Card Game Sanctuary",
    "urlinform": "gaia-card-game-sanctuary",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/GaiaCardGameSanctuary/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF02nqWlLzDERIj4H5tgvNfo",
    "lat": 3.0631155,
    "lng": 101.6950693,
    "placeId": "ChIJF02nqWlLzDERIj4H5tgvNfo",
    "businessStatus": "OPERATIONAL",
    "phone": "010-356 8085",
    "openingHours": [
      "Monday: 11:00 AM – 8:30 PM",
      "Tuesday: 11:00 AM – 8:30 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 51,
    "id": 1079
  },
  {
    "title": "Spacecard",
    "urlinform": "spacecard",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61575340827660",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUb9ruck3zDERn7NO9S1ZgXg",
    "lat": 3.1446988,
    "lng": 101.7605025,
    "placeId": "ChIJUb9ruck3zDERn7NO9S1ZgXg",
    "businessStatus": "OPERATIONAL",
    "phone": "016-202 8211",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 137,
    "id": 1080
  },
  {
    "title": "The Silph Co. TCG",
    "urlinform": "the-silph-co-tcg",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrSQpZwU3zDER1DhwXuDdsfE",
    "lat": 3.1577405,
    "lng": 101.712167,
    "placeId": "ChIJrSQpZwU3zDER1DhwXuDdsfE",
    "businessStatus": "OPERATIONAL",
    "phone": "011-2875 2376",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 6:00 PM",
      "Wednesday: 9:00 AM – 6:00 PM",
      "Thursday: 9:00 AM – 6:00 PM",
      "Friday: 9:00 AM – 6:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1081,
    "district": "KLCC"
  },
  {
    "title": "Banana Card & Hobby Shop",
    "urlinform": "banana-card-hobby-shop",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61560258689721",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP9bKbxQ1zDERjPzFAP65RmI",
    "lat": 3.081397,
    "lng": 101.7363571,
    "placeId": "ChIJP9bKbxQ1zDERjPzFAP65RmI",
    "businessStatus": "OPERATIONAL",
    "phone": "017-329 5355",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 146,
    "id": 1082,
    "district": "Cheras"
  },
  {
    "title": "Toysbar",
    "urlinform": "toysbar",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Toysbar/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbdcZQ0tJzDERLia_fqAxZy0",
    "lat": 3.1260328,
    "lng": 101.6154581,
    "placeId": "ChIJbdcZQ0tJzDERLia_fqAxZy0",
    "businessStatus": "OPERATIONAL",
    "phone": "010-761 7278",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 259,
    "id": 1083
  },
  {
    "title": "Cards & Hobbies",
    "urlinform": "cards-hobbies",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://www.cardsandhobbies.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxXqxVR9MzDERa4ct2ZP6ePc",
    "lat": 3.108925,
    "lng": 101.5944871,
    "placeId": "ChIJxXqxVR9MzDERa4ct2ZP6ePc",
    "businessStatus": "OPERATIONAL",
    "phone": "016-906 2507",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 1:30 – 7:30 PM",
      "Sunday: 1:30 – 7:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 178,
    "id": 1084
  },
  {
    "title": "Hobbies Corner",
    "urlinform": "hobbies-corner",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/hobbiescornerkepong/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7b_pINxHzDERysrjOcNohr0",
    "lat": 3.2121029,
    "lng": 101.6414146,
    "placeId": "ChIJ7b_pINxHzDERysrjOcNohr0",
    "businessStatus": "OPERATIONAL",
    "phone": "011-5413 1159",
    "openingHours": [],
    "rating": 4.9,
    "userRatingsTotal": 11,
    "id": 1085
  },
  {
    "title": "GamePay",
    "urlinform": "gamepay",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSQ1rx9I3zDERsZII_V-OR6E",
    "lat": 3.1525875,
    "lng": 101.712256,
    "placeId": "ChIJSQ1rx9I3zDERsZII_V-OR6E",
    "businessStatus": "OPERATIONAL",
    "phone": "03-2161 8188",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 AM",
      "Tuesday: 9:00 AM – 6:00 AM",
      "Wednesday: 9:00 AM – 6:00 AM",
      "Thursday: 9:00 AM – 6:00 AM",
      "Friday: 9:00 AM – 6:00 AM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1086,
    "district": "KLCC"
  },
  {
    "title": "The Entertainer - Suria KLCC",
    "urlinform": "the-entertainer-suria-klcc",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ983OtMo3zDERcYSlBAIFoUM",
    "lat": 3.1575994,
    "lng": 101.7116809,
    "placeId": "ChIJ983OtMo3zDERcYSlBAIFoUM",
    "businessStatus": "OPERATIONAL",
    "phone": "012-660 1695",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 8,
    "id": 1087,
    "district": "KLCC"
  },
  {
    "title": "SAIKYO HOBBY",
    "urlinform": "saikyo-hobby",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXUQO7FU1zDERHB1zcr66jJU",
    "lat": 3.1030557,
    "lng": 101.7330033,
    "placeId": "ChIJXUQO7FU1zDERHB1zcr66jJU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-9132 3113",
    "openingHours": [
      "Monday: 8:00 – 11:00 PM",
      "Tuesday: Closed",
      "Wednesday: 8:00 – 11:00 PM",
      "Thursday: 8:00 – 11:00 PM",
      "Friday: 8:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 56,
    "id": 1088
  },
  {
    "title": "EXAKADO TCG & COLLECTIBLES",
    "urlinform": "exakado-tcg-collectibles",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61569630520979&mibextid=ZbWKwL",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVx0xTwA5zDERn1HSmrxU_nM",
    "lat": 3.2026668,
    "lng": 101.7170769,
    "placeId": "ChIJVx0xTwA5zDERn1HSmrxU_nM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 8:00 – 11:00 PM",
      "Tuesday: 8:00 – 11:00 PM",
      "Wednesday: 8:00 – 11:00 PM",
      "Thursday: 8:00 – 11:00 PM",
      "Friday: 8:00 – 11:00 PM",
      "Saturday: 8:00 – 11:00 PM",
      "Sunday: 8:00 – 11:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 32,
    "id": 1089
  },
  {
    "title": "Stars OG TCG",
    "urlinform": "stars-og-tcg",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfxhKn8JHzDERXPLW-F0kyOQ",
    "lat": 3.2191405,
    "lng": 101.6470023,
    "placeId": "ChIJfxhKn8JHzDERXPLW-F0kyOQ",
    "businessStatus": "OPERATIONAL",
    "phone": "017-202 1638",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 100,
    "id": 1090
  },
  {
    "title": "M.Duelist Society Official Store",
    "urlinform": "mduelist-society-official-store",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxXUC2vs3zDERDyCc5ji6ouQ",
    "lat": 3.1448197,
    "lng": 101.7110198,
    "placeId": "ChIJxXUC2vs3zDERDyCc5ji6ouQ",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1751 8933",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 7,
    "id": 1091,
    "district": "Bukit Bintang"
  },
  {
    "title": "Paper Adventures by Loka Made",
    "urlinform": "paper-adventures-by-loka-made",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://lokamade.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3zWTCd9JzDERbn80YV-RIfA",
    "lat": 3.1452725,
    "lng": 101.6954076,
    "placeId": "ChIJ3zWTCd9JzDERbn80YV-RIfA",
    "businessStatus": "OPERATIONAL",
    "phone": "010-394 1197",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 3763,
    "id": 1092,
    "district": "Petaling Street"
  },
  {
    "title": "APOM @ Central Market",
    "urlinform": "apom-central-market",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://apom.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOX92MBRJzDER17b9tTXz1oI",
    "lat": 3.145704,
    "lng": 101.6955325,
    "placeId": "ChIJOX92MBRJzDER17b9tTXz1oI",
    "businessStatus": "OPERATIONAL",
    "phone": "012-906 8798",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 115,
    "id": 1093,
    "district": "Petaling Street"
  },
  {
    "title": "Treasure Trove 百宝箱 @KLCW",
    "urlinform": "treasure-trove-klcw",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/treasuretrove_klcw",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoahnEXE3zDERXezHxprUohg",
    "lat": 3.1549715,
    "lng": 101.70946,
    "placeId": "ChIJoahnEXE3zDERXezHxprUohg",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1897 8868",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 253,
    "id": 1094,
    "district": "KLCC"
  },
  {
    "title": "Stella Toy House",
    "urlinform": "stella-toy-house",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/StallaToyHouse",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJwWW0AxLzDERwlodPPVBwFg",
    "lat": 3.0575067,
    "lng": 101.674084,
    "placeId": "ChIJJwWW0AxLzDERwlodPPVBwFg",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1447 3791",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 5:00 PM",
      "Wednesday: 6:00 – 10:30 PM",
      "Thursday: 6:00 – 10:30 PM",
      "Friday: 6:00 – 10:30 PM",
      "Saturday: 1:30 – 10:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 98,
    "id": 1095
  },
  {
    "title": "GameStudio",
    "urlinform": "gamestudio",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://gamestudio.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcQnAsCk3zDERSRTwUnfYeMQ",
    "lat": 3.1570258,
    "lng": 101.7119199,
    "placeId": "ChIJcQnAsCk3zDERSRTwUnfYeMQ",
    "businessStatus": "OPERATIONAL",
    "phone": "016-910 1884",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1956,
    "id": 1096,
    "district": "KLCC"
  },
  {
    "title": "Game and Glory (GAG)",
    "urlinform": "game-and-glory-gag",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Flesh and Blood",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.gameandglory.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqS_MuBBPzDERTC6q7KrgnRM",
    "lat": 3.1207726,
    "lng": 101.5966195,
    "placeId": "ChIJqS_MuBBPzDERTC6q7KrgnRM",
    "businessStatus": "OPERATIONAL",
    "phone": "012-298 7153",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 104,
    "id": 1097
  },
  {
    "title": "Ericfun Game And Hobby Shop",
    "urlinform": "ericfun-game-and-hobby-shop",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.ericfun.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrcoAfwC1zTERc3KTFpXJxOo",
    "lat": 2.9983594,
    "lng": 101.6734028,
    "placeId": "ChIJrcoAfwC1zTERc3KTFpXJxOo",
    "businessStatus": "OPERATIONAL",
    "phone": "014-662 4769",
    "openingHours": [
      "Monday: 11:00 AM – 2:00 AM",
      "Tuesday: 11:00 AM – 2:00 AM",
      "Wednesday: 11:00 AM – 2:00 AM",
      "Thursday: 11:00 AM – 2:00 AM",
      "Friday: 11:00 AM – 2:00 AM",
      "Saturday: 11:00 AM – 2:00 AM",
      "Sunday: 11:00 AM – 2:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1897,
    "id": 1098
  },
  {
    "title": "Happy Game Enterprise (GAME SHOP)",
    "urlinform": "happy-game-enterprise-game-shop",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://shopee.com.my/happygameenterprise?originalCategoryId=11001806&page=0",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd90MUkM3zDERkGwcMRTRKcQ",
    "lat": 3.1440548,
    "lng": 101.7104545,
    "placeId": "ChIJd90MUkM3zDERkGwcMRTRKcQ",
    "businessStatus": "OPERATIONAL",
    "phone": "017-871 3593",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 803,
    "id": 1099,
    "district": "Bukit Bintang"
  },
  {
    "title": "Bulba Store Gamez & Hobby (Malaysia)",
    "urlinform": "bulba-store-gamez-hobby-malaysia",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoVHxYEc5zDERG_HieMZXbew",
    "lat": 3.2003577,
    "lng": 101.7170966,
    "placeId": "ChIJoVHxYEc5zDERG_HieMZXbew",
    "businessStatus": "OPERATIONAL",
    "phone": "013-295 9836",
    "openingHours": [
      "Monday: 8:00 – 11:00 PM",
      "Tuesday: Closed",
      "Wednesday: 8:00 – 11:00 PM",
      "Thursday: 8:00 – 11:00 PM",
      "Friday: 8:00 – 11:00 PM",
      "Saturday: 4:00 – 11:30 PM",
      "Sunday: 4:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 257,
    "id": 1100
  },
  {
    "title": "Pasar TCG & Hobby Sdn Bhd",
    "urlinform": "pasar-tcg-hobby-sdn-bhd",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://ericfun.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIXrzIQOzzTERz0lQBKcODss",
    "lat": 3.0265268,
    "lng": 101.5479076,
    "placeId": "ChIJIXrzIQOzzTERz0lQBKcODss",
    "businessStatus": "OPERATIONAL",
    "phone": "012-639 9294",
    "openingHours": [
      "Monday: 11:00 AM – 1:00 AM",
      "Tuesday: 11:00 AM – 1:00 AM",
      "Wednesday: 11:00 AM – 1:00 AM",
      "Thursday: 11:00 AM – 1:00 AM",
      "Friday: 11:00 AM – 1:00 AM",
      "Saturday: 11:00 AM – 1:00 AM",
      "Sunday: 11:00 AM – 1:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 2214,
    "id": 1101
  },
  {
    "title": "Gaming Gadgets",
    "urlinform": "gaming-gadgets",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK8wriIlLzDERWE1bx3Zcluo",
    "lat": 3.0495962,
    "lng": 101.6717199,
    "placeId": "ChIJK8wriIlLzDERWE1bx3Zcluo",
    "businessStatus": "OPERATIONAL",
    "phone": "03-8082 3310",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 276,
    "id": 1102
  },
  {
    "title": "Game Mart",
    "urlinform": "game-mart",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "One Piece",
      "Union Arena"
    ],
    "storeWebsite": "https://www.missionworldstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrTsFFyk2zDER6Q6r9ibugGY",
    "lat": 3.1446522,
    "lng": 101.7108806,
    "placeId": "ChIJrTsFFyk2zDER6Q6r9ibugGY",
    "businessStatus": "OPERATIONAL",
    "phone": "03-2110 3005",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 986,
    "id": 1103,
    "district": "Bukit Bintang"
  },
  {
    "title": "Ace Cards • Sunway Pyramid",
    "urlinform": "ace-cards-sunway-pyramid",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://acecards.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ081d61FNzDERxpV2toJVWSc",
    "lat": 3.071868,
    "lng": 101.6062374,
    "placeId": "ChIJ081d61FNzDERxpV2toJVWSc",
    "businessStatus": "OPERATIONAL",
    "phone": "012-901 0188",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 52,
    "id": 1104
  },
  {
    "title": "UNIQUE GAME ZONE",
    "urlinform": "unique-game-zone",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB9m7qik2zDERbcWaMIjf1sg",
    "lat": 3.1440954,
    "lng": 101.7092533,
    "placeId": "ChIJB9m7qik2zDERbcWaMIjf1sg",
    "businessStatus": "OPERATIONAL",
    "phone": "016-444 4128",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1591,
    "id": 1105,
    "district": "Bukit Bintang"
  },
  {
    "title": "Mario Land (Game Store)",
    "urlinform": "mario-land-game-store",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/mariolandtrad",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJS-wD55E3zDERHhZsWHSlolY",
    "lat": 3.1441688,
    "lng": 101.7099005,
    "placeId": "ChIJS-wD55E3zDERHhZsWHSlolY",
    "businessStatus": "OPERATIONAL",
    "phone": "012-319 2359",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 429,
    "id": 1106,
    "district": "Bukit Bintang"
  },
  {
    "title": "M4G Platinum @ Pavilion Kuala Lumpur",
    "urlinform": "m4g-platinum-pavilion-kuala-lumpur",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.m4g.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWahecrw3zDERHsAiqE5kCh0",
    "lat": 3.1485012,
    "lng": 101.7144421,
    "placeId": "ChIJWahecrw3zDERHsAiqE5kCh0",
    "businessStatus": "OPERATIONAL",
    "phone": "03-2110 4833",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1641,
    "id": 1107,
    "district": "Bukit Bintang"
  },
  {
    "title": "Game Station",
    "urlinform": "game-station",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJH9HsACk2zDERROoMvf8Beac",
    "lat": 3.1440808,
    "lng": 101.709854,
    "placeId": "ChIJH9HsACk2zDERROoMvf8Beac",
    "businessStatus": "OPERATIONAL",
    "phone": "012-369 8813",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:30 PM",
      "Friday: 10:30 AM – 9:30 PM",
      "Saturday: 10:30 AM – 9:30 PM",
      "Sunday: 10:30 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1066,
    "id": 1108,
    "district": "Bukit Bintang"
  },
  {
    "title": "The Card Shop",
    "urlinform": "the-card-shop",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/thecardshopplt",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJV42pWfVJzDERxqjuhCS07V4",
    "lat": 3.120107,
    "lng": 101.629222,
    "placeId": "ChIJV42pWfVJzDERxqjuhCS07V4",
    "businessStatus": "OPERATIONAL",
    "phone": "011-6321 6126",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:30 PM",
      "Thursday: 3:00 – 10:30 PM",
      "Friday: 3:00 – 10:30 PM",
      "Saturday: 12:00 – 10:30 PM",
      "Sunday: 12:00 – 6:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 16,
    "id": 1109
  },
  {
    "title": "Typo @ Suria KLCC",
    "urlinform": "typo-suria-klcc",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cottonon.com/MY/typo-home/?utm_source=google-store-profiles&utm_medium=organic&utm_campaign=google-store-TYPO-MY&utm_id=google-store-7782-TYPO",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJszK1NdE3zDERQ7TucPTMLz0",
    "lat": 3.1579844,
    "lng": 101.712484,
    "placeId": "ChIJszK1NdE3zDERQ7TucPTMLz0",
    "businessStatus": "OPERATIONAL",
    "phone": "03-2181 5205",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 48,
    "id": 1110,
    "district": "KLCC"
  },
  {
    "title": "Mossery Suria KLCC",
    "urlinform": "mossery-suria-klcc",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.mossery.co/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaxmoS9A3zDER8MZPLl79P7k",
    "lat": 3.158154,
    "lng": 101.7120899,
    "placeId": "ChIJaxmoS9A3zDER8MZPLl79P7k",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 224,
    "id": 1111,
    "district": "KLCC"
  },
  {
    "title": "Card Hobby MY",
    "urlinform": "card-hobby-my",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://cardhobbymy.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1bF7I_03zDERv5a48yOQHTk",
    "lat": 3.1613458,
    "lng": 101.7560373,
    "placeId": "ChIJ1bF7I_03zDERv5a48yOQHTk",
    "businessStatus": "OPERATIONAL",
    "phone": "011-6999 8999",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 16,
    "id": 1112
  },
  {
    "title": "Suria KLCC",
    "urlinform": "suria-klcc",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.suriaklcc.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJH5xmLdE3zDERKa4a_IywVck",
    "lat": 3.1572757,
    "lng": 101.7122335,
    "placeId": "ChIJH5xmLdE3zDERKa4a_IywVck",
    "businessStatus": "OPERATIONAL",
    "phone": "03-2382 2828",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 75697,
    "id": 1113,
    "district": "KLCC"
  },
  {
    "title": "Care Bears Bukit Bintang",
    "urlinform": "care-bears-bukit-bintang",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linktr.ee/carebears.my",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ94aKI-g3zDERb7kdVelLfVs",
    "lat": 3.147014,
    "lng": 101.711968,
    "placeId": "ChIJ94aKI-g3zDERb7kdVelLfVs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 120,
    "id": 1114,
    "district": "Bukit Bintang"
  },
  {
    "title": "Ani Honbu @ Sungei Wang Plaza",
    "urlinform": "ani-honbu-sungei-wang-plaza",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.anihonbu.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJk4m5tas3zDERmMfdgqCAhjY",
    "lat": 3.1451126,
    "lng": 101.7114909,
    "placeId": "ChIJk4m5tas3zDERmMfdgqCAhjY",
    "businessStatus": "OPERATIONAL",
    "phone": "016-353 3656",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 571,
    "id": 1115,
    "district": "Bukit Bintang"
  },
  {
    "title": "Mechadioz Omocha & Design",
    "urlinform": "mechadioz-omocha-design",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjeyTFSk2zDEReikIx-uHbRo",
    "lat": 3.1449279,
    "lng": 101.7110366,
    "placeId": "ChIJjeyTFSk2zDEReikIx-uHbRo",
    "businessStatus": "OPERATIONAL",
    "phone": "016-206 6226",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 38,
    "id": 1116,
    "district": "Bukit Bintang"
  },
  {
    "title": "First Hobby",
    "urlinform": "first-hobby",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://sites.google.com/view/firsthobby/%E9%A6%96%E9%A1%B5",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE4OK2XM3zDEROJ9gBYhuhsg",
    "lat": 3.1442429,
    "lng": 101.7106316,
    "placeId": "ChIJE4OK2XM3zDEROJ9gBYhuhsg",
    "businessStatus": "OPERATIONAL",
    "phone": "018-919 8648",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 181,
    "id": 1117,
    "district": "Bukit Bintang"
  },
  {
    "title": "Emmanuel Game House",
    "urlinform": "emmanuel-game-house",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/emmanuelgamehouse",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2yBefys3zDERIBPC7kUojOQ",
    "lat": 3.1434477,
    "lng": 101.7087915,
    "placeId": "ChIJ2yBefys3zDERIBPC7kUojOQ",
    "businessStatus": "OPERATIONAL",
    "phone": "019-978 8192",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 122,
    "id": 1118,
    "district": "Bukit Bintang"
  },
  {
    "title": "Toyzable",
    "urlinform": "toyzable",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://toyzable.com/shop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2ZNlESk2zDER64vVyE-eTeY",
    "lat": 3.1450448,
    "lng": 101.7110863,
    "placeId": "ChIJ2ZNlESk2zDER64vVyE-eTeY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 65,
    "id": 1119,
    "district": "Bukit Bintang"
  },
  {
    "title": "Tsukiharu Station",
    "urlinform": "tsukiharu-station",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4WY7sgw3zDER90lDULDuE3c",
    "lat": 3.1441378,
    "lng": 101.7111402,
    "placeId": "ChIJ4WY7sgw3zDER90lDULDuE3c",
    "businessStatus": "OPERATIONAL",
    "phone": "012-383 5341",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 13,
    "id": 1120,
    "district": "Bukit Bintang"
  },
  {
    "title": "Play On Enterprise",
    "urlinform": "play-on-enterprise",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKzuzFyk2zDERObY7EKvEHr0",
    "lat": 3.1451191,
    "lng": 101.7114766,
    "placeId": "ChIJKzuzFyk2zDERObY7EKvEHr0",
    "businessStatus": "OPERATIONAL",
    "phone": "016-242 6000",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 12:00 – 5:00 PM",
      "Sunday: Closed"
    ],
    "rating": 3,
    "userRatingsTotal": 2,
    "id": 1121,
    "district": "Bukit Bintang"
  },
  {
    "title": "Planet M78",
    "urlinform": "planet-m78",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://planetm78.justorder.today/v2",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF8-SPyk2zDERmZUQfU9Nkwc",
    "lat": 3.1451191,
    "lng": 101.7114766,
    "placeId": "ChIJF8-SPyk2zDERmZUQfU9Nkwc",
    "businessStatus": "OPERATIONAL",
    "phone": "019-829 6849",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 437,
    "id": 1122,
    "district": "Bukit Bintang"
  },
  {
    "title": "Puzzle Planet @ LaLaport BBCC",
    "urlinform": "puzzle-planet-lalaport-bbcc",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.puzzleplanet.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_1juOPk3zDERw2iaWh716AU",
    "lat": 3.1399028,
    "lng": 101.7076813,
    "placeId": "ChIJ_1juOPk3zDERw2iaWh716AU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-9779 0447",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 378,
    "id": 1123,
    "district": "Bukit Bintang"
  },
  {
    "title": "Fantasy Toys UG32",
    "urlinform": "fantasy-toys-ug32",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG3q6ASk2zDERP3kWDg21DXY",
    "lat": 3.1442137,
    "lng": 101.7103171,
    "placeId": "ChIJG3q6ASk2zDERP3kWDg21DXY",
    "businessStatus": "OPERATIONAL",
    "phone": "03-2110 3808",
    "openingHours": [
      "Monday: 10:30 AM – 9:30 PM",
      "Tuesday: 10:30 AM – 9:30 PM",
      "Wednesday: 10:30 AM – 9:30 PM",
      "Thursday: 10:30 AM – 9:30 PM",
      "Friday: 10:30 AM – 9:30 PM",
      "Saturday: 10:30 AM – 9:30 PM",
      "Sunday: 10:30 AM – 9:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 90,
    "id": 1124,
    "district": "Bukit Bintang"
  },
  {
    "title": "7 MASTER GAMING PLT",
    "urlinform": "7-master-gaming-plt",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://7mastergaming.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLUVfpRg3zDERlcNE3Qi_iUE",
    "lat": 3.1441492,
    "lng": 101.7099199,
    "placeId": "ChIJLUVfpRg3zDERlcNE3Qi_iUE",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1427 9246",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 72,
    "id": 1125,
    "district": "Bukit Bintang"
  },
  {
    "title": "My Star Collection Trading",
    "urlinform": "my-star-collection-trading",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo9SSkCg2zDERRwnLUpE78Ls",
    "lat": 3.1421984,
    "lng": 101.7105512,
    "placeId": "ChIJo9SSkCg2zDERRwnLUpE78Ls",
    "businessStatus": "OPERATIONAL",
    "phone": "03-2144 7017",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:24 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 276,
    "id": 1126,
    "district": "Bukit Bintang"
  },
  {
    "title": "Luludemon Collectibles",
    "urlinform": "luludemon-collectibles",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.luludemoncollectibles.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIdqmO2BLzDERg3A-IuXnvcc",
    "lat": 3.0692291,
    "lng": 101.6941301,
    "placeId": "ChIJIdqmO2BLzDERg3A-IuXnvcc",
    "businessStatus": "OPERATIONAL",
    "phone": "018-268 8010",
    "openingHours": [
      "Monday: 1:00 PM – 12:00 AM",
      "Tuesday: Closed",
      "Wednesday: 1:00 PM – 12:00 AM",
      "Thursday: 1:00 PM – 12:00 AM",
      "Friday: 12:00 PM – 12:00 AM",
      "Saturday: 12:00 PM – 12:00 AM",
      "Sunday: 12:00 PM – 12:00 AM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 177,
    "id": 1127
  },
  {
    "title": "Pick & Play",
    "urlinform": "pick-play",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJddcRGdlLzDER4aROzg4TvAA",
    "lat": 3.0766899,
    "lng": 101.6908981,
    "placeId": "ChIJddcRGdlLzDER4aROzg4TvAA",
    "businessStatus": "OPERATIONAL",
    "phone": "011-7022 7270",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 18,
    "id": 1128
  },
  {
    "title": "Toreca Hobby",
    "urlinform": "toreca-hobby",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61559125966110",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-czWfgBJzDERQlxRQpHC8wo",
    "lat": 3.137392,
    "lng": 101.6227984,
    "placeId": "ChIJ-czWfgBJzDERQlxRQpHC8wo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 4:00 – 10:00 PM",
      "Thursday: 4:00 – 10:00 PM",
      "Friday: 4:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 6:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 28,
    "id": 1129
  },
  {
    "title": "Bulba Milk TCG",
    "urlinform": "bulba-milk-tcg",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://shopee.com.my/shop/51689099",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDUMVBStLzDER2QskIbZuUe0",
    "lat": 3.0711322,
    "lng": 101.6933494,
    "placeId": "ChIJDUMVBStLzDER2QskIbZuUe0",
    "businessStatus": "OPERATIONAL",
    "phone": "016-215 1517",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM, 8:00 – 10:30 PM",
      "Tuesday: 1:00 – 7:00 PM, 8:00 – 10:30 PM",
      "Wednesday: 1:00 – 7:00 PM, 8:00 – 10:30 PM",
      "Thursday: 1:00 – 7:00 PM, 8:00 – 10:30 PM",
      "Friday: 1:00 – 11:30 PM",
      "Saturday: 2:00 PM – 12:00 AM",
      "Sunday: 2:00 PM – 12:00 AM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 39,
    "id": 1130
  },
  {
    "title": "Blackstar Cardhub",
    "urlinform": "blackstar-cardhub",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61574146708194",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfVHhmFpJzDERdBncSMPXvug",
    "lat": 3.1154748,
    "lng": 101.6217051,
    "placeId": "ChIJfVHhmFpJzDERdBncSMPXvug",
    "businessStatus": "OPERATIONAL",
    "phone": "012-472 1382",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 187,
    "id": 1131
  },
  {
    "title": "Kai Cards & Collectibles",
    "urlinform": "kai-cards-collectibles",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61555231448897&mibextid=hu50Ix",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd4hpfABNzDERjiLARTIU0X0",
    "lat": 3.0727643,
    "lng": 101.6096845,
    "placeId": "ChIJd4hpfABNzDERjiLARTIU0X0",
    "businessStatus": "OPERATIONAL",
    "phone": "016-313 6316",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 4:00 – 9:00 PM",
      "Thursday: 4:00 – 9:00 PM",
      "Friday: 4:00 – 9:00 PM",
      "Saturday: 3:00 PM – 12:00 AM",
      "Sunday: 3:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 10,
    "id": 1132
  },
  {
    "title": "ABC Play",
    "urlinform": "purr-play",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVaDHJbxPzDERO-K83lyTjiM",
    "lat": 3.1379313,
    "lng": 101.6150223,
    "placeId": "ChIJVaDHJbxPzDERO-K83lyTjiM",
    "businessStatus": "OPERATIONAL",
    "phone": "011-7022 7270",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 76,
    "id": 1133
  },
  {
    "title": "Attilan Games",
    "urlinform": "attilan-games",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://www.attilangames.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLw7jBzxKzDER4ZbzngzfWnc",
    "lat": 3.1286004,
    "lng": 101.6353592,
    "placeId": "ChIJLw7jBzxKzDER4ZbzngzfWnc",
    "businessStatus": "OPERATIONAL",
    "phone": "016-286 2479",
    "openingHours": [
      "Monday: 2:40 – 7:10 PM",
      "Tuesday: 2:40 – 7:10 PM",
      "Wednesday: 2:40 – 7:10 PM",
      "Thursday: 2:40 – 7:10 PM",
      "Friday: 2:40 – 7:10 PM",
      "Saturday: 2:40 – 7:10 PM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 24,
    "id": 1134
  },
  {
    "title": "Classroom Uptown",
    "urlinform": "classroom-uptown",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Lorcana",
      "MTG",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://classroomtgc.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJifFZwjZJzDERGk5jtrqhOII",
    "lat": 3.1353244,
    "lng": 101.6241638,
    "placeId": "ChIJifFZwjZJzDERGk5jtrqhOII",
    "businessStatus": "OPERATIONAL",
    "phone": "017-243 4768",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 83,
    "id": 1135
  },
  {
    "title": "My Oasis TCG (Pasar TCG)",
    "urlinform": "my-oasis-tcg-pasar-tcg",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJM6-7xFtPzDERm8L2TaRpynQ",
    "lat": 3.0271258,
    "lng": 101.5488786,
    "placeId": "ChIJM6-7xFtPzDERm8L2TaRpynQ",
    "businessStatus": "OPERATIONAL",
    "phone": "017-790 6225",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 31,
    "id": 1136
  },
  {
    "title": "MY Hobby Arena",
    "urlinform": "my-hobby-arena",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3Y-C_dtLzDERK8C26ZBNnS0",
    "lat": 3.0699176,
    "lng": 101.6902093,
    "placeId": "ChIJ3Y-C_dtLzDERK8C26ZBNnS0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 5:00 PM – 1:00 AM",
      "Wednesday: 5:00 PM – 1:00 AM",
      "Thursday: 5:00 PM – 1:00 AM",
      "Friday: 5:00 PM – 1:00 AM",
      "Saturday: 1:00 PM – 1:00 AM",
      "Sunday: 1:00 PM – 1:00 AM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1137
  },
  {
    "title": "OhMyCards!",
    "urlinform": "ohmycards",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmSYR7Ig5zDERZZlSknG8X_c",
    "lat": 3.1922529,
    "lng": 101.738096,
    "placeId": "ChIJmSYR7Ig5zDERZZlSknG8X_c",
    "businessStatus": "OPERATIONAL",
    "phone": "017-676 4896",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 3.7,
    "userRatingsTotal": 16,
    "id": 1138,
    "district": "Setapak"
  },
  {
    "title": "OnePlease TCG Sdn Bhd",
    "urlinform": "oneplease-tcg-sdn-bhd",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://oneplease.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2UoG6-BJzDERx09HMJiaoaM",
    "lat": 3.1622982,
    "lng": 101.6485372,
    "placeId": "ChIJ2UoG6-BJzDERx09HMJiaoaM",
    "businessStatus": "OPERATIONAL",
    "phone": "011-2137 1688",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 45,
    "id": 1139
  },
  {
    "title": "Lah Lah Land - Malaysian Souvenirs & Gifts",
    "urlinform": "lah-lah-land-malaysian-souvenirs-gifts",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://visitlahlahland.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhZl2RwBJzDERc3jkMnrHPJo",
    "lat": 3.1449465,
    "lng": 101.6974183,
    "placeId": "ChIJhZl2RwBJzDERc3jkMnrHPJo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 9:00 PM",
      "Tuesday: 9:00 AM – 9:00 PM",
      "Wednesday: 9:00 AM – 9:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 9:00 PM",
      "Saturday: 9:00 AM – 9:00 PM",
      "Sunday: 9:00 AM – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 977,
    "id": 1140,
    "district": "Petaling Street"
  },
  {
    "title": "LF Collectibles Trading",
    "urlinform": "lf-collectibles-trading",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://shopee.com.my/lf_vcollect?categoryId=100639&itemId=17980353365",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoannLYBPzDERkOT4WOj6SLI",
    "lat": 3.1397227,
    "lng": 101.6146651,
    "placeId": "ChIJoannLYBPzDERkOT4WOj6SLI",
    "businessStatus": "OPERATIONAL",
    "phone": "016-358 8827",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 PM – 12:00 AM",
      "Wednesday: 2:00 PM – 12:00 AM",
      "Thursday: 2:00 PM – 12:00 AM",
      "Friday: 2:00 PM – 12:00 AM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 PM – 12:00 AM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 73,
    "id": 1141
  },
  {
    "title": "Concept Grading Malaysia",
    "urlinform": "concept-grading-malaysia",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.conceptgrading.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJ2_y_Ig5zDER555oLiOXKvE",
    "lat": 3.0894567,
    "lng": 101.6840177,
    "placeId": "ChIJJ2_y_Ig5zDER555oLiOXKvE",
    "businessStatus": "OPERATIONAL",
    "phone": "014-630 5466",
    "openingHours": [
      "Monday: 10:30 AM – 7:00 PM",
      "Tuesday: 10:30 AM – 7:00 PM",
      "Wednesday: 10:30 AM – 7:00 PM",
      "Thursday: 10:30 AM – 7:00 PM",
      "Friday: 10:30 AM – 7:00 PM",
      "Saturday: 10:30 AM – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 77,
    "id": 1142
  },
  {
    "title": "Myu Collectibles",
    "urlinform": "myu-collectibles",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://myucollectibles.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_Y56NSxNzDERjVdVMieaFVg",
    "lat": 3.080716,
    "lng": 101.6172496,
    "placeId": "ChIJ_Y56NSxNzDERjVdVMieaFVg",
    "businessStatus": "OPERATIONAL",
    "phone": "016-280 1889",
    "openingHours": [
      "Monday: 7:30 – 11:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:30 – 11:00 PM",
      "Thursday: 3:30 – 11:00 PM",
      "Friday: 3:30 – 11:00 PM",
      "Saturday: 3:30 – 11:00 PM",
      "Sunday: 3:30 – 11:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 28,
    "id": 1143
  },
  {
    "title": "GameOn",
    "urlinform": "gameon",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.gameon.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjyXw7TZJzDERqUYg6wTrWN4",
    "lat": 3.1356435,
    "lng": 101.622741,
    "placeId": "ChIJjyXw7TZJzDERqUYg6wTrWN4",
    "businessStatus": "OPERATIONAL",
    "phone": "019-217 9633",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 217,
    "id": 1144
  },
  {
    "title": "Impulse Gaming (KL Flagship Store)",
    "urlinform": "impulse-gaming-kl-flagship-store",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Pokémon"
    ],
    "storeWebsite": "http://www.impulse.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJV1pxZw3zDERUSa3foRO7SA",
    "lat": 3.1217472,
    "lng": 101.7088347,
    "placeId": "ChIJJV1pxZw3zDERUSa3foRO7SA",
    "businessStatus": "OPERATIONAL",
    "phone": "019-726 2633",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 605,
    "id": 1145
  },
  {
    "title": "Ethereal Sanctum",
    "urlinform": "ethereal-sanctum",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/ethereal.sanctum",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5TNWZrdNzDERFTa34aApnrc",
    "lat": 3.0813314,
    "lng": 101.6123392,
    "placeId": "ChIJ5TNWZrdNzDERFTa34aApnrc",
    "businessStatus": "OPERATIONAL",
    "phone": "016-675 1321",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 5:00 – 11:00 PM",
      "Thursday: 5:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 54,
    "id": 1146
  },
  {
    "title": "Cards Dojo (Melawati Mall)",
    "urlinform": "cards-dojo-melawati-mall",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgaRTnwk5zDERrHsW-bxNTfA",
    "lat": 3.2104842,
    "lng": 101.7485587,
    "placeId": "ChIJgaRTnwk5zDERrHsW-bxNTfA",
    "businessStatus": "OPERATIONAL",
    "phone": "012-239 8248",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 129,
    "id": 1147
  },
  {
    "title": "Armory TCG",
    "urlinform": "armory-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC-pq69LUkkIRxt0u_6zSoCw",
    "lat": 5.414683,
    "lng": 100.331112,
    "placeId": "ChIJC-pq69LUkkIRxt0u_6zSoCw",
    "businessStatus": "OPERATIONAL",
    "phone": "012-638 8322",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 429,
    "id": 1148,
    "district": "Georgetown"
  },
  {
    "title": "Pixbros",
    "urlinform": "pixbros",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/pichubros",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ-MJ2pLDSjARF1TyFbT2LSo",
    "lat": 5.404825,
    "lng": 100.2911401,
    "placeId": "ChIJZ-MJ2pLDSjARF1TyFbT2LSo",
    "businessStatus": "OPERATIONAL",
    "phone": "018-255 0168",
    "openingHours": [
      "Monday: 1:00 – 6:00 PM",
      "Tuesday: 1:00 – 6:00 PM",
      "Wednesday: 1:00 – 11:00 PM",
      "Thursday: 1:00 – 11:00 PM",
      "Friday: 1:00 – 11:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 74,
    "id": 1149
  },
  {
    "title": "Big Monster Ball @ 1st Avenue",
    "urlinform": "big-monster-ball",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAW-o1JbDSjAR87g9FMCEAFQ",
    "lat": 5.413202999999999,
    "lng": 100.3313709,
    "placeId": "ChIJAW-o1JbDSjAR87g9FMCEAFQ",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1319 9814",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 124,
    "id": 1150,
    "district": "Georgetown"
  },
  {
    "title": "ISLAND TCG",
    "urlinform": "island-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNc9O_ubDSjARQj5gvEGUJrU",
    "lat": 5.4489873,
    "lng": 100.2970737,
    "placeId": "ChIJNc9O_ubDSjARQj5gvEGUJrU",
    "businessStatus": "OPERATIONAL",
    "phone": "017-443 3898",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 3:00 PM – 12:00 AM",
      "Sunday: 3:00 – 11:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 21,
    "id": 1151
  },
  {
    "title": "Leafy Legend TCG",
    "urlinform": "leafy-legend-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Leafylegend/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv9Pof1LDSjAR9dVlWq4QfNg",
    "lat": 5.4508306,
    "lng": 100.3044843,
    "placeId": "ChIJv9Pof1LDSjAR9dVlWq4QfNg",
    "businessStatus": "OPERATIONAL",
    "phone": "011-3722 7188",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 127,
    "id": 1152
  },
  {
    "title": "Dueling Nexus",
    "urlinform": "dueling-nexus",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/pages/Dueling-Nexus/289471191894884",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4zi_bZTDSjARD9flaoiMPGg",
    "lat": 5.4147307,
    "lng": 100.3311154,
    "placeId": "ChIJ4zi_bZTDSjARD9flaoiMPGg",
    "businessStatus": "OPERATIONAL",
    "phone": "012-468 4516",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 72,
    "id": 1153,
    "district": "Georgetown"
  },
  {
    "title": "1 Store Gaming TCG",
    "urlinform": "1-store-gaming-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/1storegaming",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc-5BdADDSjARWpcpFEP2kqE",
    "lat": 5.390793,
    "lng": 100.284015,
    "placeId": "ChIJc-5BdADDSjARWpcpFEP2kqE",
    "businessStatus": "OPERATIONAL",
    "phone": "013-480 1688",
    "openingHours": [
      "Monday: 4:00 – 11:30 PM",
      "Tuesday: 2:00 – 11:30 PM",
      "Wednesday: 3:30 – 11:30 PM",
      "Thursday: 2:00 – 11:30 PM",
      "Friday: 2:00 – 11:30 PM",
      "Saturday: 2:00 – 11:30 PM",
      "Sunday: 2:00 – 11:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 18,
    "id": 1154
  },
  {
    "title": "Game Tag",
    "urlinform": "game-tag",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/gametagpranginmall/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxxZHaZTDSjARHBKFwJ9582o",
    "lat": 5.4136049,
    "lng": 100.3318379,
    "placeId": "ChIJxxZHaZTDSjARHBKFwJ9582o",
    "businessStatus": "OPERATIONAL",
    "phone": "012-414 0307",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1321,
    "id": 1155,
    "district": "Georgetown"
  },
  {
    "title": "Impulse Gaming (Penang Branch)",
    "urlinform": "impulse-gaming-penang-branch",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Pokémon"
    ],
    "storeWebsite": "https://impulse.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ05W3f77DSjAR-xgPFtIHagw",
    "lat": 5.415258,
    "lng": 100.3246349,
    "placeId": "ChIJ05W3f77DSjAR-xgPFtIHagw",
    "businessStatus": "OPERATIONAL",
    "phone": "018-972 0633",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 9:30 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 459,
    "id": 1156,
    "district": "Georgetown"
  },
  {
    "title": "Collect All Card Shop",
    "urlinform": "collect-all-card-shop",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6ehFb2DBSjARqarJUx7Or8k",
    "lat": 5.3521182,
    "lng": 100.2998388,
    "placeId": "ChIJ6ehFb2DBSjARqarJUx7Or8k",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 6:00 – 11:00 PM",
      "Tuesday: 6:00 – 11:00 PM",
      "Wednesday: 6:00 – 11:00 PM",
      "Thursday: 6:00 – 11:00 PM",
      "Friday: 6:00 PM – 12:00 AM",
      "Saturday: 12:00 PM – 12:00 AM",
      "Sunday: 12:00 – 11:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 116,
    "id": 1157
  },
  {
    "title": "ToyPanic X Gamepanic (Base1)",
    "urlinform": "toypanic-x-gamepanic-base1",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.toypanic.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-xO2JJTDSjAR5LqzSSp36R0",
    "lat": 5.433055599999999,
    "lng": 100.3066557,
    "placeId": "ChIJ-xO2JJTDSjAR5LqzSSp36R0",
    "businessStatus": "OPERATIONAL",
    "phone": "014-337 2642",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 10:30 AM – 7:00 PM",
      "Wednesday: 10:30 AM – 7:00 PM",
      "Thursday: 10:30 AM – 7:00 PM",
      "Friday: 10:30 AM – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 449,
    "id": 1158,
    "district": "Gurney"
  },
  {
    "title": "Games4Life",
    "urlinform": "games4life",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://web.facebook.com/people/Games-4-Life-Game-Gallery/100063620348481/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF2cTDCfDSjARlAYthp3u6uM",
    "lat": 5.4385869,
    "lng": 100.3100078,
    "placeId": "ChIJF2cTDCfDSjARlAYthp3u6uM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 10:00 PM",
      "Tuesday: 10:30 AM – 10:00 PM",
      "Wednesday: 10:30 AM – 10:00 PM",
      "Thursday: 10:30 AM – 10:00 PM",
      "Friday: 10:30 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 24,
    "id": 1159,
    "district": "Gurney"
  },
  {
    "title": "Legacy Games",
    "urlinform": "legacy-games",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://legames.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJk8OSpl3BSjAR4laIGldAaKo",
    "lat": 5.3868399,
    "lng": 100.303596,
    "placeId": "ChIJk8OSpl3BSjAR4laIGldAaKo",
    "businessStatus": "OPERATIONAL",
    "phone": "012-430 7207",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 5:00 – 11:00 PM",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 37,
    "id": 1160
  },
  {
    "title": "Cardpitiam TCG",
    "urlinform": "cardpitiam-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD2d0EfbBSjARk8PlqMpPB_A",
    "lat": 5.3306395,
    "lng": 100.2783126,
    "placeId": "ChIJD2d0EfbBSjARk8PlqMpPB_A",
    "businessStatus": "OPERATIONAL",
    "phone": "016-488 9125",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 8:00 PM – 1:00 AM",
      "Saturday: 6:00 PM – 1:00 AM",
      "Sunday: 6:00 PM – 1:00 AM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 15,
    "id": 1161
  },
  {
    "title": "Apex Bladers Enterprise",
    "urlinform": "apex-bladers-enterprise",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/apexbladers/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-0XyH9vJSjARMNI-NtNkAwQ",
    "lat": 5.3520033,
    "lng": 100.4715675,
    "placeId": "ChIJ-0XyH9vJSjARMNI-NtNkAwQ",
    "businessStatus": "OPERATIONAL",
    "phone": "012-482 2123",
    "openingHours": [
      "Monday: 12:00 – 6:00 PM",
      "Tuesday: 12:00 – 6:00 PM",
      "Wednesday: 12:00 – 10:30 PM",
      "Thursday: Closed",
      "Friday: 12:00 – 10:30 PM",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 112,
    "id": 1162
  },
  {
    "title": "Top Deck Trading",
    "urlinform": "top-deck-trading",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXxM2B5nDSjAR8cvxkg-HObk",
    "lat": 5.3960272,
    "lng": 100.3165532,
    "placeId": "ChIJXxM2B5nDSjAR8cvxkg-HObk",
    "businessStatus": "OPERATIONAL",
    "phone": "013-533 5367",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 12:30 PM – 12:00 AM",
      "Sunday: 12:30 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1163
  },
  {
    "title": "The Outpost: Hobby House",
    "urlinform": "the-outpost-hobby-house",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOabDfzjDSjARflT1r3YbScU",
    "lat": 5.4285266,
    "lng": 100.3150165,
    "placeId": "ChIJOabDfzjDSjARflT1r3YbScU",
    "businessStatus": "OPERATIONAL",
    "phone": "012-475 1276",
    "openingHours": [
      "Monday: 6:30 PM – 12:00 AM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 5:30 PM – 12:00 AM",
      "Friday: 2:00 PM – 12:00 AM",
      "Saturday: 2:00 PM – 12:00 AM",
      "Sunday: 2:00 PM – 12:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 20,
    "id": 1164
  },
  {
    "title": "Underground Hobby Shop",
    "urlinform": "underground-hobby-shop",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://undergroundhobbyshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYREaPPTHSjARpOGQTCuOhpo",
    "lat": 5.3781064,
    "lng": 100.3982022,
    "placeId": "ChIJYREaPPTHSjARpOGQTCuOhpo",
    "businessStatus": "OPERATIONAL",
    "phone": "016-418 1688",
    "openingHours": [
      "Monday: 5:00 – 8:00 PM",
      "Tuesday: 5:00 – 8:00 PM",
      "Wednesday: 5:00 – 8:00 PM",
      "Thursday: 5:00 – 8:00 PM",
      "Friday: 5:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 28,
    "id": 1165
  },
  {
    "title": "GI GAMES",
    "urlinform": "gi-games",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVavKSJTDSjARWAgUkSvbQU4",
    "lat": 5.4135957,
    "lng": 100.3309682,
    "placeId": "ChIJVavKSJTDSjARWAgUkSvbQU4",
    "businessStatus": "OPERATIONAL",
    "phone": "016-557 5345",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3.5,
    "userRatingsTotal": 2,
    "id": 1166,
    "district": "Georgetown"
  },
  {
    "title": "AeXern",
    "urlinform": "aexern",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Aexern",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsejaj6fFSjARZOGHW6ilR_8",
    "lat": 5.416377499999999,
    "lng": 100.3798185,
    "placeId": "ChIJsejaj6fFSjARZOGHW6ilR_8",
    "businessStatus": "OPERATIONAL",
    "phone": "012-410 6254",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 25,
    "id": 1167
  },
  {
    "title": "Hobby Galaxy Enterprise",
    "urlinform": "hobby-galaxy-enterprise",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/HobbyGalaxy/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTcpzo963SjARAncxXtX4Kzg",
    "lat": 5.2397556,
    "lng": 100.4935064,
    "placeId": "ChIJTcpzo963SjARAncxXtX4Kzg",
    "businessStatus": "OPERATIONAL",
    "phone": "017-414 8947",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 9:00 PM – 12:00 AM",
      "Wednesday: 9:00 PM – 12:00 AM",
      "Thursday: 9:00 PM – 12:00 AM",
      "Friday: 2:00 – 7:00 PM, 8:30 PM – 1:00 AM",
      "Saturday: 2:00 – 7:00 PM, 8:30 PM – 1:00 AM",
      "Sunday: 2:00 – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3,
    "id": 1168
  },
  {
    "title": "Happy Toy 娃娃国 @ 1st Avenue",
    "urlinform": "happy-toy-1st-avenue",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNeBKPvDDSjARu7KnOqvm0uw",
    "lat": 5.412980699999999,
    "lng": 100.3312661,
    "placeId": "ChIJNeBKPvDDSjARu7KnOqvm0uw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 10:00 PM",
      "Tuesday: 10:30 AM – 10:00 PM",
      "Wednesday: 10:30 AM – 10:00 PM",
      "Thursday: 10:30 AM – 10:00 PM",
      "Friday: 10:30 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 3,
    "id": 1169,
    "district": "Georgetown"
  },
  {
    "title": "ETERNAL SPORTS TRADING GEORGETOWN",
    "urlinform": "eternal-sports-trading-georgetown",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/Eternalsportstrading/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJxv6oKrDSjAR9NHGUKRL1ow",
    "lat": 5.419929,
    "lng": 100.3251408,
    "placeId": "ChIJJxv6oKrDSjAR9NHGUKRL1ow",
    "businessStatus": "OPERATIONAL",
    "phone": "016-439 5388",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 39,
    "id": 1170,
    "district": "Georgetown"
  },
  {
    "title": "Twenty Twenty Hobby Centre",
    "urlinform": "twenty-twenty-hobby-centre",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/MtgPenang",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7ctKBj_ASjARoMeHwJbWPr4",
    "lat": 5.352593199999999,
    "lng": 100.3020438,
    "placeId": "ChIJ7ctKBj_ASjARoMeHwJbWPr4",
    "businessStatus": "OPERATIONAL",
    "phone": "012-494 0817",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 8:00 PM – 12:00 AM",
      "Thursday: 8:00 PM – 12:00 AM",
      "Friday: 7:30 PM – 12:00 AM",
      "Saturday: 2:00 – 7:00 PM, 8:00 PM – 12:00 AM",
      "Sunday: 2:00 – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 8,
    "id": 1171
  },
  {
    "title": "Dream World",
    "urlinform": "dream-world",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsWIgy3jDSjARu3GOg_SKJFI",
    "lat": 5.4142888,
    "lng": 100.3298475,
    "placeId": "ChIJsWIgy3jDSjARu3GOg_SKJFI",
    "businessStatus": "OPERATIONAL",
    "phone": "012-488 0914",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1172,
    "district": "Georgetown"
  },
  {
    "title": "Sheldonet.Shop @ Gurney Plaza Penang",
    "urlinform": "sheldonetshop-gurney-plaza",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.sheldonet.shop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_XOYdgDDSjARVe4jxe7UpQs",
    "lat": 5.437455,
    "lng": 100.309343,
    "placeId": "ChIJ_XOYdgDDSjARVe4jxe7UpQs",
    "businessStatus": "OPERATIONAL",
    "phone": "04-605 0670",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 36,
    "id": 1173,
    "district": "Gurney"
  },
  {
    "title": "Typo @ Gurney Paragon Mall",
    "urlinform": "typo-gurney-paragon-mall",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cottonon.com/MY/typo-home/?utm_source=google-store-profiles&utm_medium=organic&utm_campaign=google-store-TYPO-MY&utm_id=google-store-7727-TYPO",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7Q9lJzHDSjARJrEfz-gKr_c",
    "lat": 5.4357359,
    "lng": 100.311185,
    "placeId": "ChIJ7Q9lJzHDSjARJrEfz-gKr_c",
    "businessStatus": "OPERATIONAL",
    "phone": "04-218 9197",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 20,
    "id": 1174,
    "district": "Gurney"
  },
  {
    "title": "Gurney Paragon Mall",
    "urlinform": "gurney-paragon-mall",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://gurneyparagon.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHTeoOQbDSjARsTHDtwiCS9Y",
    "lat": 5.4357359,
    "lng": 100.311185,
    "placeId": "ChIJHTeoOQbDSjARsTHDtwiCS9Y",
    "businessStatus": "OPERATIONAL",
    "phone": "04-228 8266",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 12023,
    "id": 1175,
    "district": "Gurney"
  },
  {
    "title": "Toy World",
    "urlinform": "toy-world",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_93JmUfDSjAR7yOW9dt_Md8",
    "lat": 5.4356066,
    "lng": 100.3111092,
    "placeId": "ChIJ_93JmUfDSjAR7yOW9dt_Md8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 10,
    "id": 1176,
    "district": "Gurney"
  },
  {
    "title": "Gurney Plaza",
    "urlinform": "gurney-plaza",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://gurneyplaza.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbV1ghQPDSjARqoUoHwF0xjM",
    "lat": 5.4380431,
    "lng": 100.3100232,
    "placeId": "ChIJbV1ghQPDSjARqoUoHwF0xjM",
    "businessStatus": "OPERATIONAL",
    "phone": "04-222 8222",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 21427,
    "id": 1177,
    "district": "Gurney"
  },
  {
    "title": "Miniso Gurney Plaza",
    "urlinform": "miniso-gurney-plaza",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJj6YGKADDSjARyJEHFbKMZLg",
    "lat": 5.4372584,
    "lng": 100.3090157,
    "placeId": "ChIJj6YGKADDSjARyJEHFbKMZLg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 29,
    "id": 1178,
    "district": "Gurney"
  },
  {
    "title": "Brands Outlet Gurney Plaza",
    "urlinform": "brands-outlet-gurney-plaza",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP4VrppTDSjARxNqVDMdY40I",
    "lat": 5.438176599999999,
    "lng": 100.3100386,
    "placeId": "ChIJP4VrppTDSjARxNqVDMdY40I",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 30,
    "id": 1179,
    "district": "Gurney"
  },
  {
    "title": "WTF Penang ( WTF Bracelet)",
    "urlinform": "wtf-penang-wtf-bracelet",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.wtfbracelet.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaW72lAPDSjARv8t7epe-SBs",
    "lat": 5.437137,
    "lng": 100.3092735,
    "placeId": "ChIJaW72lAPDSjARv8t7epe-SBs",
    "businessStatus": "OPERATIONAL",
    "phone": "012-592 5616",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 55,
    "id": 1180,
    "district": "Gurney"
  },
  {
    "title": "The Green Party @ Gurney Paragon",
    "urlinform": "the-green-party-gurney-paragon",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJX76M52LDSjARcCVCWsqhPzI",
    "lat": 5.4351744,
    "lng": 100.3111102,
    "placeId": "ChIJX76M52LDSjARcCVCWsqhPzI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 29,
    "id": 1181,
    "district": "Gurney"
  },
  {
    "title": "Card Master Club",
    "urlinform": "card-master-club",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.cardmasterclub.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHco6YQDDSjAR67WEPtqqK-g",
    "lat": 5.4556718,
    "lng": 100.3094112,
    "placeId": "ChIJHco6YQDDSjAR67WEPtqqK-g",
    "businessStatus": "OPERATIONAL",
    "phone": "017-692 8283",
    "openingHours": [
      "Monday: 1:00 – 11:00 PM",
      "Tuesday: 1:00 – 11:00 PM",
      "Wednesday: 1:00 – 11:00 PM",
      "Thursday: 1:00 – 11:00 PM",
      "Friday: 1:00 PM – 12:00 AM",
      "Saturday: 1:00 PM – 12:00 AM",
      "Sunday: 1:00 PM – 12:00 AM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 37,
    "id": 1182
  },
  {
    "title": "Starlight K-store",
    "urlinform": "starlight-k-store",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/starlightkstore_my?igsh=MTkwazk1YnhkcDJ1Mg==",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE0ksemrDSjARtv5gf4gRj5k",
    "lat": 5.4299522,
    "lng": 100.3189478,
    "placeId": "ChIJE0ksemrDSjARtv5gf4gRj5k",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:30 AM – 9:00 PM",
      "Sunday: 11:30 AM – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 36,
    "id": 1183
  },
  {
    "title": "BookXcess Gurney Paragon",
    "urlinform": "bookxcess-gurney-paragon",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.bookxcess.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ40KrUcDDSjARnRgoVZQCv7Y",
    "lat": 5.4357359,
    "lng": 100.311185,
    "placeId": "ChIJ40KrUcDDSjARnRgoVZQCv7Y",
    "businessStatus": "OPERATIONAL",
    "phone": "04-295 0152",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 1800,
    "id": 1184,
    "district": "Gurney"
  },
  {
    "title": "The Mulligan Cove",
    "urlinform": "the-mulligan-cove",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJceruN9_BSjARxu-kE3bMElg",
    "lat": 5.3267085,
    "lng": 100.2810238,
    "placeId": "ChIJceruN9_BSjARxu-kE3bMElg",
    "businessStatus": "OPERATIONAL",
    "phone": "013-885 7745",
    "openingHours": [
      "Monday: 11:00 AM – 12:00 AM",
      "Tuesday: 11:00 AM – 12:00 AM",
      "Wednesday: 11:00 AM – 12:00 AM",
      "Thursday: 11:00 AM – 12:00 AM",
      "Friday: 11:00 AM – 12:00 AM",
      "Saturday: 11:00 AM – 12:00 AM",
      "Sunday: 11:00 AM – 12:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 155,
    "id": 1185
  },
  {
    "title": "Impulse Gaming (Queensbay Mall Branch)",
    "urlinform": "impulse-gaming-queensbay-mall-branch",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJS-Paj2rBSjARh8TGgFUgoPk",
    "lat": 5.333048799999999,
    "lng": 100.3065283,
    "placeId": "ChIJS-Paj2rBSjARh8TGgFUgoPk",
    "businessStatus": "OPERATIONAL",
    "phone": "012-740 4633",
    "openingHours": [
      "Monday: 10:30 AM – 10:30 PM",
      "Tuesday: 10:30 AM – 10:30 PM",
      "Wednesday: 10:30 AM – 10:30 PM",
      "Thursday: 10:30 AM – 10:30 PM",
      "Friday: 10:30 AM – 10:30 PM",
      "Saturday: 10:30 AM – 10:30 PM",
      "Sunday: 10:30 AM – 10:30 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 51,
    "id": 1186
  },
  {
    "title": "Primo Collectibles",
    "urlinform": "primo-collectibles",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.primocollectibles.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCWLoh0TASjAR_AwtRtcuVRk",
    "lat": 5.334053000000001,
    "lng": 100.2909399,
    "placeId": "ChIJCWLoh0TASjAR_AwtRtcuVRk",
    "businessStatus": "OPERATIONAL",
    "phone": "04-606 1068",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 6,
    "id": 1187
  },
  {
    "title": "Young Ones Shopping",
    "urlinform": "young-ones-shopping",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.youngones.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6ZsLMxXASjARjzh5JSLX2sk",
    "lat": 5.3265664,
    "lng": 100.2864427,
    "placeId": "ChIJ6ZsLMxXASjARjzh5JSLX2sk",
    "businessStatus": "OPERATIONAL",
    "phone": "04-641 2233",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 422,
    "id": 1188
  },
  {
    "title": "Modelland Workshop",
    "urlinform": "modelland-workshop",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Modelland.Workshop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8ZZmYpPDSjAR7H-i1Hxvzvc",
    "lat": 5.3262735,
    "lng": 100.281224,
    "placeId": "ChIJ8ZZmYpPDSjAR7H-i1Hxvzvc",
    "businessStatus": "OPERATIONAL",
    "phone": "012-430 5530",
    "openingHours": [
      "Monday: 5:00 – 8:00 PM",
      "Tuesday: 5:00 – 8:00 PM",
      "Wednesday: 5:00 – 8:00 PM",
      "Thursday: 5:00 – 8:00 PM",
      "Friday: 5:00 – 8:00 PM",
      "Saturday: 5:00 – 8:00 PM",
      "Sunday: 5:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 85,
    "id": 1189
  },
  {
    "title": "Wah Bee Marketing",
    "urlinform": "wah-bee-marketing",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD9HVnGrASjARpD2IerEaUPg",
    "lat": 5.3280809,
    "lng": 100.2845369,
    "placeId": "ChIJD9HVnGrASjARpD2IerEaUPg",
    "businessStatus": "OPERATIONAL",
    "phone": "04-646 4673",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 93,
    "id": 1190
  },
  {
    "title": "Gadget Zone Sdn Bhd ASUS",
    "urlinform": "gadget-zone-sdn-bhd-queensbay-mall-relocated-to-golden-triangle-1-",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.gadgetzone.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4x85N3bBSjARs43cWYB7dBw",
    "lat": 5.3313637,
    "lng": 100.2764345,
    "placeId": "ChIJ4x85N3bBSjARs43cWYB7dBw",
    "businessStatus": "OPERATIONAL",
    "phone": "016-435 8006",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1440,
    "id": 1191
  },
  {
    "title": "CelcomDigi Store Penang International Airport",
    "urlinform": "celcomdigi-store-penang-international-airport",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.celcomdigi.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb4noSNy_SjAR11FbXutM5_E",
    "lat": 5.2929126,
    "lng": 100.265487,
    "placeId": "ChIJb4noSNy_SjAR11FbXutM5_E",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 7:00 AM – 11:00 PM",
      "Tuesday: 7:00 AM – 11:00 PM",
      "Wednesday: 7:00 AM – 11:00 PM",
      "Thursday: 7:00 AM – 11:00 PM",
      "Friday: 7:00 AM – 11:00 PM",
      "Saturday: 7:00 AM – 11:00 PM",
      "Sunday: 7:00 AM – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 49,
    "id": 1192
  },
  {
    "title": "Aswing Trading",
    "urlinform": "aswing-trading",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/aswingtradingpg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW1c__xrASjARJWx1v7K5nVI",
    "lat": 5.3199109,
    "lng": 100.2701228,
    "placeId": "ChIJW1c__xrASjARJWx1v7K5nVI",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1631 5066",
    "openingHours": [
      "Monday: 9:30 AM – 8:30 PM",
      "Tuesday: 9:30 AM – 8:30 PM",
      "Wednesday: 9:30 AM – 8:30 PM",
      "Thursday: 9:30 AM – 8:30 PM",
      "Friday: 9:30 AM – 8:30 PM",
      "Saturday: 9:30 AM – 8:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.4,
    "userRatingsTotal": 250,
    "id": 1193
  },
  {
    "title": "Love Corner 爱转角 + Gadget Store",
    "urlinform": "love-corner-gadget-store",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/lovecornertea/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBRbXVjDBSjARVvd3If9GFvE",
    "lat": 5.3297338,
    "lng": 100.2754142,
    "placeId": "ChIJBRbXVjDBSjARVvd3If9GFvE",
    "businessStatus": "OPERATIONAL",
    "phone": "016-463 6688",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 11:00 PM",
      "Wednesday: 12:00 – 11:00 PM",
      "Thursday: 12:00 – 11:00 PM",
      "Friday: 12:00 – 11:30 PM",
      "Saturday: 12:00 – 11:30 PM",
      "Sunday: 12:00 – 11:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 158,
    "id": 1194
  },
  {
    "title": "Fanstore Device Sdn Bhd (Bayan Lepas)",
    "urlinform": "fanstore-device-sdn-bhd-bayan-lepas",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://fb.com/fanstoredevice",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJ2Yw7xrBSjARGj05dsRCFTA",
    "lat": 5.333558,
    "lng": 100.2913328,
    "placeId": "ChIJJ2Yw7xrBSjARGj05dsRCFTA",
    "businessStatus": "OPERATIONAL",
    "phone": "016-403 5886",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 6:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 1:00 – 6:00 PM",
      "Sunday: 1:00 – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 33,
    "id": 1195
  },
  {
    "title": "WingsHigh Anime Concept Store",
    "urlinform": "wingshigh-anime-concept-store",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61574957796500",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP_wyKwDBSjAR9NnbaXKVfTs",
    "lat": 5.3440414,
    "lng": 100.2966055,
    "placeId": "ChIJP_wyKwDBSjAR9NnbaXKVfTs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 13,
    "id": 1196
  },
  {
    "title": "I.D. Card",
    "urlinform": "id-card",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPyD_6D3ASjARkoAcr7fcsrs",
    "lat": 5.3330176,
    "lng": 100.2879852,
    "placeId": "ChIJPyD_6D3ASjARkoAcr7fcsrs",
    "businessStatus": "OPERATIONAL",
    "phone": "04-646 9876",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1197
  },
  {
    "title": "SunPrint Enterprise",
    "urlinform": "sunprint-enterprise",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2SQ1s2vASjARwuhtgKnfz5k",
    "lat": 5.3257582,
    "lng": 100.2861652,
    "placeId": "ChIJ2SQ1s2vASjARwuhtgKnfz5k",
    "businessStatus": "OPERATIONAL",
    "phone": "010-457 4768",
    "openingHours": [
      "Monday: 10:30 AM – 6:00 PM",
      "Tuesday: 10:30 AM – 6:00 PM",
      "Wednesday: 10:30 AM – 6:00 PM",
      "Thursday: 10:30 AM – 6:00 PM",
      "Friday: 10:30 AM – 6:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.6,
    "userRatingsTotal": 59,
    "id": 1198
  },
  {
    "title": "Kaizen Vapestore Bayan Baru",
    "urlinform": "kaizen-vapestore-bayan-baru",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxxYqrga_SjARqnMvAMqyCdU",
    "lat": 5.328359799999999,
    "lng": 100.2849338,
    "placeId": "ChIJxxYqrga_SjARqnMvAMqyCdU",
    "businessStatus": "OPERATIONAL",
    "phone": "011-3305 4481",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:30 AM – 11:30 PM",
      "Wednesday: 11:30 AM – 11:30 PM",
      "Thursday: 11:30 AM – 11:30 PM",
      "Friday: 11:30 AM – 11:00 PM",
      "Saturday: 11:30 AM – 11:30 PM",
      "Sunday: 11:30 AM – 11:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 114,
    "id": 1199
  },
  {
    "title": "Caryon Enterprise",
    "urlinform": "caryon-enterprise",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0a87yGvASjARrZxFJb6cPHI",
    "lat": 5.326032,
    "lng": 100.286312,
    "placeId": "ChIJ0a87yGvASjARrZxFJb6cPHI",
    "businessStatus": "OPERATIONAL",
    "phone": "012-416 6776",
    "openingHours": [
      "Monday: 9:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 9:00 AM – 9:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 9:00 PM",
      "Saturday: 9:00 AM – 8:00 PM",
      "Sunday: 9:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 7,
    "id": 1200
  },
  {
    "title": "FZ BOUQUET PENANG",
    "urlinform": "fz-bouquet-penang",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://instagram.com/fz_bouquetpenang",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJL0V4gUXBSjARIz-INzYobyQ",
    "lat": 5.3162772,
    "lng": 100.2837007,
    "placeId": "ChIJL0V4gUXBSjARIz-INzYobyQ",
    "businessStatus": "OPERATIONAL",
    "phone": "012-595 4344",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 3:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 249,
    "id": 1201
  },
  {
    "title": "ANTZ gaming studio",
    "urlinform": "antz-gaming-studio",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/pg/antzgamingstudio/posts/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGTGtZlO_SjARBaG_-J5GCQE",
    "lat": 5.3015621,
    "lng": 100.2700372,
    "placeId": "ChIJGTGtZlO_SjARBaG_-J5GCQE",
    "businessStatus": "OPERATIONAL",
    "phone": "017-460 7691",
    "openingHours": [
      "Monday: 3:00 PM – 12:00 AM",
      "Tuesday: 3:00 PM – 12:00 AM",
      "Wednesday: 3:00 PM – 12:00 AM",
      "Thursday: 3:00 PM – 12:00 AM",
      "Friday: 3:00 PM – 1:00 AM",
      "Saturday: 3:00 PM – 1:00 AM",
      "Sunday: 3:00 PM – 1:00 AM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 22,
    "id": 1202,
    "district": "Bayan Lepas"
  },
  {
    "title": "Good Games Town Hall",
    "urlinform": "good-games-town-hall",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.goodgames.com.au/venue/good-games-town-hall/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNRd6vT6uEmsRjZxh73wX6M0",
    "lat": -33.8700367,
    "lng": 151.2060557,
    "placeId": "ChIJNRd6vT6uEmsRjZxh73wX6M0",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9264 0568",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 757,
    "id": 1203,
    "district": "CBD"
  },
  {
    "title": "Pidoof Collectibles",
    "urlinform": "pidoof-collectibles",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.pidoofcollectibles.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvx6hcQOvEmsRtJjhap0fff8",
    "lat": -33.8836033,
    "lng": 151.2018641,
    "placeId": "ChIJvx6hcQOvEmsRtJjhap0fff8",
    "businessStatus": "OPERATIONAL",
    "phone": "0481 721 115",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 432,
    "id": 1204,
    "district": "Haymarket"
  },
  {
    "title": "Devitt Collectables",
    "urlinform": "devitt-collectables",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://devittcollectables.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb-Ym9mGvEmsRUnBEX9klDqY",
    "lat": -33.8722462,
    "lng": 151.2052128,
    "placeId": "ChIJb-Ym9mGvEmsRUnBEX9klDqY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 962,
    "id": 1205,
    "district": "CBD"
  },
  {
    "title": "Good Games Sydney Central",
    "urlinform": "good-games-sydney-central",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.goodgames.com.au/venue/good-games-central",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2YUKlCauEmsREodEMn4tERA",
    "lat": -33.883607,
    "lng": 151.202572,
    "placeId": "ChIJ2YUKlCauEmsREodEMn4tERA",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9281 1760",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 363,
    "id": 1206,
    "district": "Haymarket"
  },
  {
    "title": "TCG & HOBBY (George St) - DOUBLE KILL GAMES（卡牌谷店）",
    "urlinform": "tcg-hobby-george-st-double-kill-games",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSTRFr6GvEmsRlzp-vORUScg",
    "lat": -33.8820763,
    "lng": 151.2041883,
    "placeId": "ChIJSTRFr6GvEmsRlzp-vORUScg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 8:00 PM",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 3:00 – 8:00 PM",
      "Sunday: 3:00 – 8:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 49,
    "id": 1207,
    "district": "Haymarket"
  },
  {
    "title": "Trading Card Masters",
    "urlinform": "trading-card-masters",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.tradingcardmasters.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW5w6PXf7g4IRwEvwyQw11mA",
    "lat": -33.869959,
    "lng": 151.1290294,
    "placeId": "ChIJW5w6PXf7g4IRwEvwyQw11mA",
    "businessStatus": "OPERATIONAL",
    "phone": "0401 149 759",
    "openingHours": [
      "Monday: 5:00 – 9:00 PM",
      "Tuesday: 5:00 – 9:00 PM",
      "Wednesday: 5:00 – 9:00 PM",
      "Thursday: 5:00 – 9:00 PM",
      "Friday: 5:00 – 9:00 PM",
      "Saturday: 9:00 AM – 4:00 PM",
      "Sunday: 10:00 AM – 3:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 62,
    "id": 1208
  },
  {
    "title": "Tokyo Lifestyle Haymarket",
    "urlinform": "tokyo-lifestyle-haymarket",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://tokyolifestyle.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD8BqB32vEmsRru3XBZvKE7k",
    "lat": -33.8788095,
    "lng": 151.2043914,
    "placeId": "ChIJD8BqB32vEmsRru3XBZvKE7k",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 7245 9876",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 87,
    "id": 1209,
    "district": "Haymarket"
  },
  {
    "title": "Good Games Top Ryde City",
    "urlinform": "good-games-top-ryde-city",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.goodgames.com.au/venue/good-games-top-ryde-city",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJl0AqTKWlEmsRhrGussfMnTg",
    "lat": -33.8122691,
    "lng": 151.1062825,
    "placeId": "ChIJl0AqTKWlEmsRhrGussfMnTg",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9807 4929",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 9:00 PM",
      "Wednesday: 9:00 AM – 9:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 5:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 256,
    "id": 1210
  },
  {
    "title": "Light of Cards - Zetland",
    "urlinform": "light-of-cards-zetland",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://lightofcards.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJO4agiFKxEmsRM3CgWp79p3U",
    "lat": -33.9056187,
    "lng": 151.203584,
    "placeId": "ChIJO4agiFKxEmsRM3CgWp79p3U",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 6:00 PM",
      "Tuesday: 12:00 – 6:00 PM",
      "Wednesday: 12:00 – 6:00 PM",
      "Thursday: 12:00 – 8:30 PM",
      "Friday: 12:00 – 6:00 PM",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 75,
    "id": 1211
  },
  {
    "title": "Onestoppokeshop",
    "urlinform": "onestoppokeshop",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.onestoppokeshop.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXaoqzpSpEmsRW1Dgn5zdcHc",
    "lat": -33.7876701,
    "lng": 151.2015134,
    "placeId": "ChIJXaoqzpSpEmsRW1Dgn5zdcHc",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8188 7528",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 12:30 – 4:30 PM",
      "Thursday: Closed",
      "Friday: 12:30 – 4:30 PM",
      "Saturday: 12:00 – 4:30 PM",
      "Sunday: 11:30 AM – 4:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 92,
    "id": 1212
  },
  {
    "title": "Behold Games",
    "urlinform": "behold-games",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Lorcana",
      "MTG"
    ],
    "storeWebsite": "http://www.beholdgames.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJ4JSosevEmsR8ScyjS_OfQo",
    "lat": -33.8800057,
    "lng": 151.1975561,
    "placeId": "ChIJJ4JSosevEmsR8ScyjS_OfQo",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8358 2485",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 6:00 – 10:00 PM",
      "Thursday: 6:00 – 10:00 PM",
      "Friday: 6:00 – 10:00 PM",
      "Saturday: 12:00 – 5:00 PM",
      "Sunday: 12:00 – 5:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 110,
    "id": 1213,
    "district": "Haymarket"
  },
  {
    "title": "Kuruma Collectables™",
    "urlinform": "kuruma-collectables",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.kurumacollectables.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJw3JzVDxZkWsR8XX035mMzcc",
    "lat": -33.879562,
    "lng": 151.1937155,
    "placeId": "ChIJw3JzVDxZkWsR8XX035mMzcc",
    "businessStatus": "OPERATIONAL",
    "phone": "0481 856 996",
    "openingHours": [
      "Monday: 4:30 – 8:30 PM",
      "Tuesday: 4:30 – 8:30 PM",
      "Wednesday: 2:00 – 8:30 PM",
      "Thursday: 8:00 AM – 8:30 PM",
      "Friday: 8:00 AM – 8:30 PM",
      "Saturday: 8:00 AM – 8:30 PM",
      "Sunday: 8:00 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 77,
    "id": 1214
  },
  {
    "title": "Sugo Toys Hurstville (TCG)",
    "urlinform": "sugo-toys-hurstville-tcg",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.sugotoys.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7ViiEfe5EmsRth-fIzE8rno",
    "lat": -33.96596590000001,
    "lng": 151.1020246,
    "placeId": "ChIJ7ViiEfe5EmsRth-fIzE8rno",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8318 5900",
    "openingHours": [
      "Monday: 1:00 – 6:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 255,
    "id": 1215
  },
  {
    "title": "RC Crew Hobbies and Games",
    "urlinform": "rc-crew-hobbies-and-games",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.rccrewhobbies.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUXBku_O_EmsRq2ICDyTkB88",
    "lat": -33.9314346,
    "lng": 151.0144653,
    "placeId": "ChIJUXBku_O_EmsRq2ICDyTkB88",
    "businessStatus": "OPERATIONAL",
    "phone": "0422 179 479",
    "openingHours": [
      "Monday: 7:00 AM – 10:30 PM",
      "Tuesday: 7:00 AM – 10:30 PM",
      "Wednesday: 7:00 AM – 10:30 PM",
      "Thursday: 7:00 AM – 10:30 PM",
      "Friday: 7:00 AM – 10:30 PM",
      "Saturday: 10:30 AM – 6:00 PM",
      "Sunday: 11:00 AM – 5:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 169,
    "id": 1216
  },
  {
    "title": "Games Corner",
    "urlinform": "games-corner",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://www.thegamescorner.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfyYrdgOjEmsRioyHhwd_h8g",
    "lat": -33.804044,
    "lng": 151.005619,
    "placeId": "ChIJfyYrdgOjEmsRioyHhwd_h8g",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8677 3473",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: Closed",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 203,
    "id": 1217
  },
  {
    "title": "The Games Cube PTY LTD",
    "urlinform": "the-games-cube-pty-ltd",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "MTG",
      "One Piece",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.thegamescube.com/?utm_medium=organic&utm_source=local&utm_campaign=gmb&utm_content=website",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwRlCP6-jEmsRZtdRCLyVEEA",
    "lat": -33.8151923,
    "lng": 150.999905,
    "placeId": "ChIJwRlCP6-jEmsRZtdRCLyVEEA",
    "businessStatus": "OPERATIONAL",
    "phone": "0404 670 288",
    "openingHours": [
      "Monday: 11:00 AM – 5:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 5:00 PM",
      "Sunday: 10:00 AM – 4:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 171,
    "id": 1218,
    "district": "Parramatta"
  },
  {
    "title": "Hobby Collectors Australia",
    "urlinform": "hobby-collectors-australia",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://hobbycollectorsaustralia.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsxmiqhO9EmsRY_2Dp7cXWsc",
    "lat": -33.8720252,
    "lng": 150.955666,
    "placeId": "ChIJsxmiqhO9EmsRY_2Dp7cXWsc",
    "businessStatus": "OPERATIONAL",
    "phone": "0432 350 521",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 10:00 AM – 5:00 PM",
      "Sunday: 10:00 AM – 5:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 84,
    "id": 1219
  },
  {
    "title": "Decked Out Gaming",
    "urlinform": "decked-out-gaming",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.deckedoutgaming.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd945ZmeqEmsRkRkUwjsTKb0",
    "lat": -33.7614152,
    "lng": 151.2726606,
    "placeId": "ChIJd945ZmeqEmsRkRkUwjsTKb0",
    "businessStatus": "CLOSED_TEMPORARILY",
    "phone": "0429 530 725",
    "openingHours": [],
    "rating": 4.7,
    "userRatingsTotal": 131,
    "id": 1220
  },
  {
    "title": "House Of Cards And Collectables",
    "urlinform": "house-of-cards-and-collectables",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://houseofcardsnco.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF1jtP9G7EmsRVP5z0nUA6wE",
    "lat": -33.8811421,
    "lng": 151.1396256,
    "placeId": "ChIJF1jtP9G7EmsRVP5z0nUA6wE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 9:00 AM – 5:30 PM",
      "Wednesday: 9:00 AM – 5:30 PM",
      "Thursday: 9:00 AM – 5:30 PM",
      "Friday: 9:00 AM – 5:30 PM",
      "Saturday: 10:00 AM – 4:00 PM",
      "Sunday: 10:00 AM – 4:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 133,
    "id": 1221
  },
  {
    "title": "The Gamesmen",
    "urlinform": "the-gamesmen",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.gamesmen.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbxKENhK5EmsRdEStbebpl5U",
    "lat": -33.9624138,
    "lng": 151.0794555,
    "placeId": "ChIJbxKENhK5EmsRdEStbebpl5U",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9580 9888",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 4:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 21770,
    "id": 1222
  },
  {
    "title": "Card King",
    "urlinform": "card-king",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.thecardking.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsY2J4kCuEmsRkS5B46IG2N8",
    "lat": -33.8652985,
    "lng": 151.2063994,
    "placeId": "ChIJsY2J4kCuEmsRkS5B46IG2N8",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8054 4626",
    "openingHours": [
      "Monday: 7:00 AM – 7:00 PM",
      "Tuesday: 7:00 AM – 7:00 PM",
      "Wednesday: 7:00 AM – 7:00 PM",
      "Thursday: 7:00 AM – 7:00 PM",
      "Friday: 7:00 AM – 7:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 41,
    "id": 1223,
    "district": "CBD"
  },
  {
    "title": "Lion’s Den Collectibles Liverpool",
    "urlinform": "lions-den-collectibles-liverpool",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lionsdencollectibles.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMXifyl2VEmsRrsvPR_iq9o8",
    "lat": -33.922462,
    "lng": 150.925398,
    "placeId": "ChIJMXifyl2VEmsRrsvPR_iq9o8",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9822 2617",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 196,
    "id": 1224
  },
  {
    "title": "Games Empire",
    "urlinform": "games-empire",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.gamesempire.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHYn3puqhEmsRITddOrhkY1A",
    "lat": -33.7323837,
    "lng": 150.984375,
    "placeId": "ChIJHYn3puqhEmsRITddOrhkY1A",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8850 6226",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 10:00 AM – 5:30 PM",
      "Wednesday: Closed",
      "Thursday: 10:00 AM – 5:30 PM",
      "Friday: Closed",
      "Saturday: 10:00 AM – 3:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 414,
    "id": 1225
  },
  {
    "title": "Games Paradise",
    "urlinform": "games-paradise",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://gamesparadise.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs9-UrT2uEmsRvrdEPOW0AaU",
    "lat": -33.8755505,
    "lng": 151.2076938,
    "placeId": "ChIJs9-UrT2uEmsRvrdEPOW0AaU",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9267 2069",
    "openingHours": [
      "Monday: 12:00 – 6:00 PM",
      "Tuesday: 12:00 – 6:00 PM",
      "Wednesday: 12:00 – 6:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 12:00 – 5:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 574,
    "id": 1226,
    "district": "Haymarket"
  },
  {
    "title": "Anime at Abbotsford City Store",
    "urlinform": "anime-at-abbotsford-city-store",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "MTG",
      "One Piece",
      "Pokémon",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.anime-oz.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5whbbCSuEmsR6eaRIE573Aw",
    "lat": -33.8810845,
    "lng": 151.2032268,
    "placeId": "ChIJ5whbbCSuEmsR6eaRIE573Aw",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9281 9355",
    "openingHours": [
      "Monday: 10:30 AM – 5:30 PM",
      "Tuesday: 10:30 AM – 5:30 PM",
      "Wednesday: 10:30 AM – 5:30 PM",
      "Thursday: 10:30 AM – 5:30 PM",
      "Friday: 10:30 AM – 5:30 PM",
      "Saturday: 10:30 AM – 5:30 PM",
      "Sunday: 10:30 AM – 5:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 230,
    "id": 1227,
    "district": "Haymarket"
  },
  {
    "title": "Good Games Parramatta",
    "urlinform": "good-games-parramatta",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.goodgames.com.au/venue/good-games-parramatta/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7f6AbQSjEmsR5FDfkcf7NJg",
    "lat": -33.8140457,
    "lng": 151.0031198,
    "placeId": "ChIJ7f6AbQSjEmsR5FDfkcf7NJg",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9025 9621",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 5:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 178,
    "id": 1228,
    "district": "Parramatta"
  },
  {
    "title": "Gametraders Live Hornsby",
    "urlinform": "gametraders-live-hornsby",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.gametraders.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpbPFtoOnEmsRlrFj93N0HyY",
    "lat": -33.7024803,
    "lng": 151.0969895,
    "placeId": "ChIJpbPFtoOnEmsRlrFj93N0HyY",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9477 6477",
    "openingHours": [
      "Monday: 12:00 – 4:00 PM",
      "Tuesday: 11:00 AM – 4:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: Closed",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 11:00 AM – 4:00 PM",
      "Sunday: 11:00 AM – 4:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 129,
    "id": 1229
  },
  {
    "title": "From The Deep Games",
    "urlinform": "from-the-deep-games",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://fromthedeepgames.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ2reWPOFEmsRGybVtH38xxk",
    "lat": -33.7536531,
    "lng": 150.6998489,
    "placeId": "ChIJZ2reWPOFEmsRGybVtH38xxk",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 4731 3894",
    "openingHours": [
      "Monday: 12:00 – 5:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 5:00 PM",
      "Sunday: 10:00 AM – 4:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 148,
    "id": 1230
  },
  {
    "title": "Gametraders Rouse Hill",
    "urlinform": "gametraders-rouse-hill",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.gametradersrousehill.com.au/?utm_source=google&utm_medium=organic&utm_campaign=GMB",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ02heEACZEmsR1OwTqOh5MTs",
    "lat": -33.6910733,
    "lng": 150.9251346,
    "placeId": "ChIJ02heEACZEmsR1OwTqOh5MTs",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8883 4006",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 6:00 PM",
      "Wednesday: 9:00 AM – 6:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 5:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 314,
    "id": 1231
  },
  {
    "title": "Good Games Castle Hill",
    "urlinform": "good-games-castle-hill",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.goodgames.com.au/venue/good-games-castle-hill",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJS53JIdehEmsRq4DsCK02oCs",
    "lat": -33.7306293,
    "lng": 151.0065332,
    "placeId": "ChIJS53JIdehEmsRq4DsCK02oCs",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9680 2205",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 105,
    "id": 1232
  },
  {
    "title": "Sugo Toys City",
    "urlinform": "sugo-toys-city",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://sugotoys.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6-0_x6OvEmsRWSmAgEF6xMQ",
    "lat": -33.8813447,
    "lng": 151.2024785,
    "placeId": "ChIJ6-0_x6OvEmsRWSmAgEF6xMQ",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9159 4950",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 127,
    "id": 1233,
    "district": "Haymarket"
  },
  {
    "title": "Good Games Bondi Junction",
    "urlinform": "good-games-bondi-junction",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.goodgames.com.au/venue/good-games-bondi-junction",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRcg5CPGtEmsRUK0xahUaf7Y",
    "lat": -33.8919578,
    "lng": 151.2506216,
    "placeId": "ChIJRcg5CPGtEmsRUK0xahUaf7Y",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9386 5488",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 9:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 9:00 PM",
      "Saturday: 9:30 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 186,
    "id": 1234
  },
  {
    "title": "Kings Comics",
    "urlinform": "kings-comics",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://kingscomics.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVVVVVTyuEmsRU37vfBGx4HQ",
    "lat": -33.8725112,
    "lng": 151.2054874,
    "placeId": "ChIJVVVVVTyuEmsRU37vfBGx4HQ",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9267 5615",
    "openingHours": [
      "Monday: 10:00 AM – 5:30 PM",
      "Tuesday: 10:00 AM – 5:30 PM",
      "Wednesday: 10:00 AM – 5:30 PM",
      "Thursday: 10:00 AM – 5:30 PM",
      "Friday: 10:00 AM – 5:30 PM",
      "Saturday: 10:00 AM – 5:00 PM",
      "Sunday: 10:00 AM – 5:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 1329,
    "id": 1235,
    "district": "CBD"
  },
  {
    "title": "Origami Pop Cards",
    "urlinform": "origami-pop-cards",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.origamipopcards.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzVj417axEmsR8YMIwIRkCLQ",
    "lat": -33.8739376,
    "lng": 151.2054791,
    "placeId": "ChIJzVj417axEmsR8YMIwIRkCLQ",
    "businessStatus": "OPERATIONAL",
    "phone": "0405 647 755",
    "openingHours": [
      "Monday: 8:00 AM – 7:00 PM",
      "Tuesday: 8:00 AM – 7:00 PM",
      "Wednesday: 8:00 AM – 7:00 PM",
      "Thursday: 8:00 AM – 7:00 PM",
      "Friday: 8:00 AM – 7:00 PM",
      "Saturday: 9:00 AM – 5:00 PM",
      "Sunday: 10:00 AM – 5:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 169,
    "id": 1236,
    "district": "Haymarket"
  },
  {
    "title": "THE CARD SPOT PTY LTD.",
    "urlinform": "the-card-spot-pty-ltd",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "http://www.thecardspot.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtVIQuVSxVUsRatyD0bTmeKc",
    "lat": -33.7509225,
    "lng": 150.9391657,
    "placeId": "ChIJtVIQuVSxVUsRatyD0bTmeKc",
    "businessStatus": "OPERATIONAL",
    "phone": "0406 864 707",
    "openingHours": [
      "Monday: 9:00 AM – 5:30 PM",
      "Tuesday: 9:00 AM – 5:30 PM",
      "Wednesday: 9:00 AM – 5:30 PM",
      "Thursday: 9:00 AM – 5:30 PM",
      "Friday: 9:00 AM – 5:30 PM",
      "Saturday: 9:00 AM – 4:00 PM",
      "Sunday: 9:00 AM – 4:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 77,
    "id": 1237
  },
  {
    "title": "Telephonecard.com.au",
    "urlinform": "telephonecardcomau",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://telephonecard.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo8nrjDuuEmsRMsOJkYWnl6g",
    "lat": -33.8739131,
    "lng": 151.203943,
    "placeId": "ChIJo8nrjDuuEmsRMsOJkYWnl6g",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9283 9292",
    "openingHours": [
      "Monday: 9:00 AM – 5:00 PM",
      "Tuesday: 9:00 AM – 5:00 PM",
      "Wednesday: 9:00 AM – 5:00 PM",
      "Thursday: 9:00 AM – 5:00 PM",
      "Friday: 9:00 AM – 5:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1238,
    "district": "Haymarket"
  },
  {
    "title": "Sydney Board and Card Games",
    "urlinform": "sydney-board-and-card-games",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://sydneyboardandcardgames.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFZzbcYuvEmsRJLce8kw--1w",
    "lat": -33.8726585,
    "lng": 151.1954638,
    "placeId": "ChIJFZzbcYuvEmsRJLce8kw--1w",
    "businessStatus": "OPERATIONAL",
    "phone": "0424 473 724",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 6,
    "id": 1239,
    "district": "CBD"
  },
  {
    "title": "The Combat Company",
    "urlinform": "the-combat-company",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://thecombatcompany.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJndEbzDy5EmsRWSILjL7FI2M",
    "lat": -33.96492509999999,
    "lng": 151.066494,
    "placeId": "ChIJndEbzDy5EmsRWSILjL7FI2M",
    "businessStatus": "OPERATIONAL",
    "phone": "0478 602 915",
    "openingHours": [
      "Monday: 9:00 AM – 10:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 10:00 PM",
      "Sunday: 9:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 529,
    "id": 1240
  },
  {
    "title": "Alliance Games",
    "urlinform": "alliance-games",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/AGamesKingsford",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW2NgvJ6xEmsRlZs0zdY7lZE",
    "lat": -33.9205555,
    "lng": 151.2270671,
    "placeId": "ChIJW2NgvJ6xEmsRlZs0zdY7lZE",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8095 9566",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 57,
    "id": 1241
  },
  {
    "title": "The Wandering Collector: Online TCG Store",
    "urlinform": "the-wandering-collector-online-tcg-store",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://thewanderingcollector.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJf9m6hnKjEmsR7y66PAM-6mk",
    "lat": -33.7951084,
    "lng": 151.0167222,
    "placeId": "ChIJf9m6hnKjEmsR7y66PAM-6mk",
    "businessStatus": "OPERATIONAL",
    "phone": "0470 463 607",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.9,
    "userRatingsTotal": 55,
    "id": 1242
  },
  {
    "title": "Planet pop world",
    "urlinform": "planet-pop-world",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.planetpopworld.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPT0T3uyvEmsRPjNgc1YMQ3I",
    "lat": -33.8781937,
    "lng": 151.2013364,
    "placeId": "ChIJPT0T3uyvEmsRPjNgc1YMQ3I",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 255,
    "id": 1243,
    "district": "Haymarket"
  },
  {
    "title": "Card Konbini - Ashfield",
    "urlinform": "card-konbini-ashfield",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.cardkonbini.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1ZpXwl27EmsRKej8PR4adKE",
    "lat": -33.889179,
    "lng": 151.1251734,
    "placeId": "ChIJ1ZpXwl27EmsRKej8PR4adKE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 65,
    "id": 1244
  },
  {
    "title": "Dymocks Sydney",
    "urlinform": "dymocks-sydney",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.dymocks.com.au/stores/Dymocks+Sydney",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwZtEpz-uEmsR_KVgqT4EtLU",
    "lat": -33.8697999,
    "lng": 151.2070811,
    "placeId": "ChIJwZtEpz-uEmsR_KVgqT4EtLU",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9230 9000",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 7:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 4178,
    "id": 1245,
    "district": "CBD"
  },
  {
    "title": "Card Bot - The Galeries Sydney",
    "urlinform": "card-bot-the-galeries-sydney",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardbot.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6ZxMim6vEmsR-R2NSGrxCkY",
    "lat": -33.8724408,
    "lng": 151.2071504,
    "placeId": "ChIJ6ZxMim6vEmsR-R2NSGrxCkY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 6:00 AM – 8:00 PM",
      "Tuesday: 6:00 AM – 8:00 PM",
      "Wednesday: 6:00 AM – 8:00 PM",
      "Thursday: 6:00 AM – 8:00 PM",
      "Friday: 6:00 AM – 8:00 PM",
      "Saturday: 6:00 AM – 8:00 PM",
      "Sunday: 6:00 AM – 8:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 5,
    "id": 1246,
    "district": "CBD"
  },
  {
    "title": "SWAP ITT. Cards and Collectables",
    "urlinform": "swap-itt-cards-and-collectables",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://swapitt.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC1Q9cEejEmsRLAgoJ2ixx3Y",
    "lat": -33.8149148,
    "lng": 151.0034974,
    "placeId": "ChIJC1Q9cEejEmsRLAgoJ2ixx3Y",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 7813 8931",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 5:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 34,
    "id": 1247,
    "district": "Parramatta"
  },
  {
    "title": "Premier Card Grading Australia",
    "urlinform": "premier-card-grading-australia",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://premiercardgrading.com.au/?srsltid=AfmBOoqkJBpz1z6vWIF9037yL2qleF1V_9sNhTzX3gQC17xwGqnfQ33N",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbymLYsOjEmsRspZWDsrVq7M",
    "lat": -33.8138079,
    "lng": 151.0035442,
    "placeId": "ChIJbymLYsOjEmsRspZWDsrVq7M",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:30 AM – 5:00 PM",
      "Tuesday: 9:30 AM – 5:00 PM",
      "Wednesday: 9:30 AM – 5:00 PM",
      "Thursday: 9:30 AM – 5:00 PM",
      "Friday: 9:30 AM – 5:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 33,
    "id": 1248,
    "district": "Parramatta"
  },
  {
    "title": "The Grail Factory",
    "urlinform": "the-grail-factory",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ14mgquKjEmsRh0CmrhBHz0w",
    "lat": -33.832384,
    "lng": 151.0103648,
    "placeId": "ChIJ14mgquKjEmsRh0CmrhBHz0w",
    "businessStatus": "OPERATIONAL",
    "phone": "0457 209 158",
    "openingHours": [
      "Monday: 2:00 – 8:30 PM",
      "Tuesday: 2:00 – 8:30 PM",
      "Wednesday: 2:00 – 8:30 PM",
      "Thursday: 2:00 – 8:30 PM",
      "Friday: 2:00 – 8:30 PM",
      "Saturday: 2:00 – 7:00 PM",
      "Sunday: 3:00 – 7:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 30,
    "id": 1249
  },
  {
    "title": "Ommeh TCG",
    "urlinform": "ommeh-tcg",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.ommeh.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaaFwJA-jEmsRDoSNeNlk-Ko",
    "lat": -33.7856624,
    "lng": 151.0383676,
    "placeId": "ChIJaaFwJA-jEmsRDoSNeNlk-Ko",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "id": 1250
  },
  {
    "title": "Mumu Life",
    "urlinform": "mumu-life",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG9z8nkmjEmsRRL5Db6WQxiA",
    "lat": -33.8173782,
    "lng": 151.0016557,
    "placeId": "ChIJG9z8nkmjEmsRRL5Db6WQxiA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 236,
    "id": 1251,
    "district": "Parramatta"
  },
  {
    "title": "EB Games / ZiNG Pop Culture - Parramatta",
    "urlinform": "eb-games-parramatta",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ebgames.com.au/stores/store/217-parramatta",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgSFL0yGjEmsR61u1ruJysdI",
    "lat": -33.8176295,
    "lng": 151.0008036,
    "placeId": "ChIJgSFL0yGjEmsR61u1ruJysdI",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9635 6634",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 327,
    "id": 1252,
    "district": "Parramatta"
  },
  {
    "title": "Typo Parramatta",
    "urlinform": "typo-parramatta",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://typo.com/AU/?utm_source=google-store-profiles&utm_medium=organic&utm_campaign=google-store-TYPO-AU&utm_id=google-store-2736-TYPO",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJ3AVXSCjEmsRX_LBBz4oT5Y",
    "lat": -33.8176887,
    "lng": 151.0020378,
    "placeId": "ChIJJ3AVXSCjEmsRX_LBBz4oT5Y",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9635 7219",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 139,
    "id": 1253,
    "district": "Parramatta"
  },
  {
    "title": "Westfield Parramatta",
    "urlinform": "westfield-parramatta",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.westfield.com.au/parramatta",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK5PQZyCjEmsR4Czz-Wh9AQ8",
    "lat": -33.816981,
    "lng": 151.0016287,
    "placeId": "ChIJK5PQZyCjEmsR4Czz-Wh9AQ8",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8892 5200",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 28485,
    "id": 1254,
    "district": "Parramatta"
  },
  {
    "title": "Lion's Den Collectibles Parramatta",
    "urlinform": "lions-den-collectibles-parramatta",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lionsdencollectibles.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvb_W57KjEmsRMsd8KYVRukM",
    "lat": -33.8173782,
    "lng": 151.0016557,
    "placeId": "ChIJvb_W57KjEmsRMsd8KYVRukM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 7:00 PM",
      "Saturday: 9:00 AM – 7:00 PM",
      "Sunday: 9:00 AM – 7:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 18,
    "id": 1255,
    "district": "Parramatta"
  },
  {
    "title": "Warhammer",
    "urlinform": "warhammer",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.games-workshop.com/Warhammer-Parramatta?utm_source=Google&utm_medium=Yext",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJf4o1th6jEmsR_VE5ZQm06AU",
    "lat": -33.8128661,
    "lng": 151.0058938,
    "placeId": "ChIJf4o1th6jEmsR_VE5ZQm06AU",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9891 4543",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 10:00 AM – 5:30 PM",
      "Thursday: 10:00 AM – 5:30 PM",
      "Friday: 10:00 AM – 5:30 PM",
      "Saturday: 10:00 AM – 5:30 PM",
      "Sunday: 10:00 AM – 4:30 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 253,
    "id": 1256,
    "district": "Parramatta"
  },
  {
    "title": "Kmart Parramatta",
    "urlinform": "kmart-parramatta",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.kmart.com.au/store-detail/Kmart+Parramatta?utm_source=google&utm_medium=organic&utm_campaign=googleplaces&utm_content=kmart+parramatta",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1ffoQiCjEmsRVwcgR-HYceQ",
    "lat": -33.8171388,
    "lng": 151.0008208,
    "placeId": "ChIJ1ffoQiCjEmsRVwcgR-HYceQ",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9689 9800",
    "openingHours": [
      "Monday: 8:00 AM – 10:00 PM",
      "Tuesday: 8:00 AM – 10:00 PM",
      "Wednesday: 8:00 AM – 10:00 PM",
      "Thursday: 8:00 AM – 10:00 PM",
      "Friday: 8:00 AM – 10:00 PM",
      "Saturday: 8:00 AM – 10:00 PM",
      "Sunday: 8:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 5589,
    "id": 1257,
    "district": "Parramatta"
  },
  {
    "title": "SWAP ITT. Cards and Collectables",
    "urlinform": "swap-itt-cards-and-collectables",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.swapitt.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7dyqJSK5EmsRqCcrkZ0q42U",
    "lat": -34.0248269,
    "lng": 151.1211368,
    "placeId": "ChIJ7dyqJSK5EmsRqCcrkZ0q42U",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9521 8109",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 5:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 259,
    "id": 1258
  },
  {
    "title": "CeX",
    "urlinform": "cex",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://au.webuy.com/site/storeDetail/?branchId=9002",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSd9aQiCjEmsRelBXYktH_1M",
    "lat": -33.8173782,
    "lng": 151.0016557,
    "placeId": "ChIJSd9aQiCjEmsRelBXYktH_1M",
    "businessStatus": "OPERATIONAL",
    "phone": "1300 233 327",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 608,
    "id": 1259,
    "district": "Parramatta"
  },
  {
    "title": "Eckersley's Art & Craft - Parramatta",
    "urlinform": "eckersleys-art-craft-parramatta",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.eckersleys.com.au/pages/store-parramatta?utm_source=google&utm_medium=organic-maps",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDe7VlR-jEmsR4QUhD5DMCCo",
    "lat": -33.8128395,
    "lng": 151.0038757,
    "placeId": "ChIJDe7VlR-jEmsR4QUhD5DMCCo",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9893 9191",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 6:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 10:00 AM – 4:00 PM",
      "Sunday: 11:00 AM – 4:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 331,
    "id": 1260,
    "district": "Parramatta"
  },
  {
    "title": "Rice Collects",
    "urlinform": "rice-collects",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ricecollects.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0_RzU46pEmsRJmPGwwJKQn4",
    "lat": -33.7959221,
    "lng": 151.1859617,
    "placeId": "ChIJ0_RzU46pEmsRJmPGwwJKQn4",
    "businessStatus": "OPERATIONAL",
    "phone": "0415 605 779",
    "openingHours": [
      "Monday: 1:00 – 6:30 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 6:30 PM",
      "Thursday: 1:00 – 6:30 PM",
      "Friday: 1:00 – 6:30 PM",
      "Saturday: 1:00 – 6:30 PM",
      "Sunday: 1:00 – 6:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 743,
    "id": 1261,
    "district": "Chatswood"
  },
  {
    "title": "PapaChonk TCG (CHINESE TCG ONLY)",
    "urlinform": "papachonk-tcg",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.papachonktcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0Q25aEipEmsRO8v-eSsNQuQ",
    "lat": -33.7960709,
    "lng": 151.17959,
    "placeId": "ChIJ0Q25aEipEmsRO8v-eSsNQuQ",
    "businessStatus": "OPERATIONAL",
    "phone": "0481 862 383",
    "openingHours": [
      "Monday: 6:00 – 9:00 PM",
      "Tuesday: 6:00 – 9:00 PM",
      "Wednesday: 4:00 – 9:00 PM",
      "Thursday: 4:00 – 9:00 PM",
      "Friday: 6:00 – 9:00 PM",
      "Saturday: Closed",
      "Sunday: 4:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 7,
    "id": 1262,
    "district": "Chatswood"
  },
  {
    "title": "CardPlus TCG & Collectibles",
    "urlinform": "cardplus-tcg-collectibles",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.cardplustcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPeXczKivEmsRx3WLws0_utY",
    "lat": -33.7952026,
    "lng": 151.1856197,
    "placeId": "ChIJPeXczKivEmsRx3WLws0_utY",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 7813 8961",
    "openingHours": [
      "Monday: 11:00 AM – 6:30 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 6:30 PM",
      "Friday: 11:00 AM – 6:30 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 12:00 – 5:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 46,
    "id": 1263,
    "district": "Chatswood"
  },
  {
    "title": "OMG Station",
    "urlinform": "omg-station",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://omgstation.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoYF6fG-pEmsR1AvDTUTEYIk",
    "lat": -33.7966443,
    "lng": 151.1820728,
    "placeId": "ChIJoYF6fG-pEmsR1AvDTUTEYIk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 43,
    "id": 1264,
    "district": "Chatswood"
  },
  {
    "title": "Card Bot - Chatswood Chase Sydney",
    "urlinform": "card-bot-chatswood-chase-sydney",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://cardbot.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJlfXAkZSpEmsRO7Unk2ZNsUU",
    "lat": -33.7970008,
    "lng": 151.1842009,
    "placeId": "ChIJlfXAkZSpEmsRO7Unk2ZNsUU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 10:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 10:00 PM",
      "Sunday: 9:00 AM – 10:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 3,
    "id": 1265,
    "district": "Chatswood"
  },
  {
    "title": "Games Chain",
    "urlinform": "games-chain",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "http://www.gameschain.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3yYnRtSoEmsR3rEvSP76usY",
    "lat": -33.7966588,
    "lng": 151.184015,
    "placeId": "ChIJ3yYnRtSoEmsR3rEvSP76usY",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9884 7333",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 8:30 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:30 AM – 6:00 PM",
      "Sunday: 10:00 AM – 5:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 111,
    "id": 1266,
    "district": "Chatswood"
  },
  {
    "title": "Rice Collects Eastwood",
    "urlinform": "rice-collects-eastwood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://ricecollects.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBz2a_E6lEmsRo7BuwUgQ3BQ",
    "lat": -33.7915897,
    "lng": 151.0796617,
    "placeId": "ChIJBz2a_E6lEmsRo7BuwUgQ3BQ",
    "businessStatus": "OPERATIONAL",
    "phone": "0415 605 779",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 7:30 PM",
      "Wednesday: 1:00 – 7:30 PM",
      "Thursday: 1:00 – 7:30 PM",
      "Friday: 1:00 – 7:30 PM",
      "Saturday: 1:00 – 7:30 PM",
      "Sunday: 1:00 – 7:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 267,
    "id": 1267
  },
  {
    "title": "Zing Pop Culture",
    "urlinform": "zing-pop-culture",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.zingpopculture.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQxAlttWoEmsRDDDl9E7VIVI",
    "lat": -33.7970894,
    "lng": 151.1843694,
    "placeId": "ChIJQxAlttWoEmsRDDDl9E7VIVI",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9412 3400",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 24,
    "id": 1268,
    "district": "Chatswood"
  },
  {
    "title": "AnythingTCG",
    "urlinform": "anythingtcg",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmSrRDNa9EmsRZThjWDbs_FE",
    "lat": -33.8633971,
    "lng": 151.01139,
    "placeId": "ChIJmSrRDNa9EmsRZThjWDbs_FE",
    "businessStatus": "OPERATIONAL",
    "phone": "0412 507 507",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 4:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 14,
    "id": 1269
  },
  {
    "title": "POP MART Westfield Chatswood Store",
    "urlinform": "pop-mart-westfield-chatswood-store",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "https://au.popmart.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZdX8JhupEmsRJtu_sR9p444",
    "lat": -33.7971307,
    "lng": 151.1845025,
    "placeId": "ChIJZdX8JhupEmsRJtu_sR9p444",
    "businessStatus": "OPERATIONAL",
    "phone": "0416 967 565",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 135,
    "id": 1270,
    "district": "Chatswood"
  },
  {
    "title": "Warhammer",
    "urlinform": "warhammer",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.games-workshop.com/Warhammer-Chatswood?utm_source=Google&utm_medium=Yext",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPcZCHtaoEmsR6XiJLunafoY",
    "lat": -33.7959353,
    "lng": 151.1859082,
    "placeId": "ChIJPcZCHtaoEmsR6XiJLunafoY",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9411 1439",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 5:30 PM",
      "Sunday: 10:00 AM – 5:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 136,
    "id": 1271,
    "district": "Chatswood"
  },
  {
    "title": "Foxy Gaming",
    "urlinform": "foxy-gaming",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://foxy-gaming.odoo.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXcrC7WupEmsR3e8GZrptN3o",
    "lat": -33.7986478,
    "lng": 151.1789999,
    "placeId": "ChIJXcrC7WupEmsR3e8GZrptN3o",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 4:00 PM",
      "Wednesday: 11:00 AM – 4:00 PM",
      "Thursday: 11:00 AM – 4:00 PM",
      "Friday: 11:00 AM – 4:00 PM",
      "Saturday: 10:00 AM – 3:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4,
    "userRatingsTotal": 4,
    "id": 1272,
    "district": "Chatswood"
  },
  {
    "title": "EB Games / ZiNG Pop Culture - Chatswood",
    "urlinform": "eb-games-zing-pop-culture-chatswood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ebgames.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfeHeyNWoEmsRQmEsGD_a3lA",
    "lat": -33.7973188,
    "lng": 151.1844964,
    "placeId": "ChIJfeHeyNWoEmsRQmEsGD_a3lA",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9412 3400",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 322,
    "id": 1273,
    "district": "Chatswood"
  },
  {
    "title": "Good Games Macquarie",
    "urlinform": "good-games-macquarie",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.goodgames.com.au/venue/good-games-macquarie",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJT_oawCOnEmsRP3j_ikmXbSc",
    "lat": -33.7767187,
    "lng": 151.1205172,
    "placeId": "ChIJT_oawCOnEmsRP3j_ikmXbSc",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9887 1260",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 10:00 PM",
      "Wednesday: 9:30 AM – 10:00 PM",
      "Thursday: 9:30 AM – 10:00 PM",
      "Friday: 9:30 AM – 10:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 132,
    "id": 1274
  },
  {
    "title": "Timezone Chatswood",
    "urlinform": "timezone-chatswood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.timezonegames.com/en-au/venues/nsw/timezone-chatswood/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb1PVN9SoEmsRX-e0Oni3tKM",
    "lat": -33.7965025,
    "lng": 151.182949,
    "placeId": "ChIJb1PVN9SoEmsRX-e0Oni3tKM",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8806 0748",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 9:00 AM – 11:00 PM",
      "Sunday: 9:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 2420,
    "id": 1275,
    "district": "Chatswood"
  },
  {
    "title": "Collector's Cove TCG",
    "urlinform": "collectors-cove-tcg",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.collectorscovetcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJky1cdCmvEmsRY0NbVPie1r4",
    "lat": -33.8137645,
    "lng": 151.1702758,
    "placeId": "ChIJky1cdCmvEmsRY0NbVPie1r4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 10:00 AM – 1:00 PM",
      "Friday: 10:00 AM – 1:00 PM",
      "Saturday: 10:00 AM – 1:00 PM",
      "Sunday: 10:00 AM – 1:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 6,
    "id": 1276
  },
  {
    "title": "Westfield Gift Card Chatswood",
    "urlinform": "westfield-gift-card-chatswood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.westfieldgiftcards.com.au/Online/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtXJ0NdSoEmsRMwYFZkaFLGA",
    "lat": -33.7971007,
    "lng": 151.1829642,
    "placeId": "ChIJtXJ0NdSoEmsRMwYFZkaFLGA",
    "businessStatus": "OPERATIONAL",
    "phone": "1300 790 292",
    "openingHours": [
      "Monday: 9:00 AM – 5:00 PM",
      "Tuesday: 9:00 AM – 5:00 PM",
      "Wednesday: 9:00 AM – 5:00 PM",
      "Thursday: 9:00 AM – 5:00 PM",
      "Friday: 9:00 AM – 5:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 4,
    "id": 1277,
    "district": "Chatswood"
  },
  {
    "title": "Westfield Chatswood",
    "urlinform": "westfield-chatswood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.westfield.com.au/chatswood",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJj-yYy9WoEmsRqsttUM46JR4",
    "lat": -33.7965082,
    "lng": 151.1827496,
    "placeId": "ChIJj-yYy9WoEmsRqsttUM46JR4",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9412 1555",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 13776,
    "id": 1278,
    "district": "Chatswood"
  },
  {
    "title": "Nextra Chatswood Westfield",
    "urlinform": "nextra-chatswood-westfield",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://nextra.com.au/store-locator/#wpsl-search-wrap",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg9JmM9SoEmsRWyjYPghqBkc",
    "lat": -33.7970008,
    "lng": 151.1842009,
    "placeId": "ChIJg9JmM9SoEmsRWyjYPghqBkc",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8084 9977",
    "openingHours": [
      "Monday: 8:15 AM – 5:45 PM",
      "Tuesday: 8:15 AM – 5:45 PM",
      "Wednesday: 8:15 AM – 5:45 PM",
      "Thursday: 8:15 AM – 8:30 PM",
      "Friday: 8:15 AM – 5:45 PM",
      "Saturday: 8:15 AM – 5:45 PM",
      "Sunday: 9:45 AM – 5:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 140,
    "id": 1279,
    "district": "Chatswood"
  },
  {
    "title": "Chatswood Chase",
    "urlinform": "chatswood-chase",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.chatswoodchasesydney.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJT2OmMNaoEmsRXufbNT-tP14",
    "lat": -33.7942587,
    "lng": 151.1861126,
    "placeId": "ChIJT2OmMNaoEmsRXufbNT-tP14",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9422 5300",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 9:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 6661,
    "id": 1280,
    "district": "Chatswood"
  },
  {
    "title": "Morning Glory",
    "urlinform": "morning-glory",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://mgshop.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt5gpjNOoEmsRAv-crFuQq1o",
    "lat": -33.7980558,
    "lng": 151.1821582,
    "placeId": "ChIJt5gpjNOoEmsRAv-crFuQq1o",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9419 3300",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 21,
    "id": 1281,
    "district": "Chatswood"
  },
  {
    "title": "Sootang Hobby Chatswood",
    "urlinform": "sootang-hobby-chatswood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://sootang.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd3XvdDypEmsR71ycOCikuoA",
    "lat": -33.7967052,
    "lng": 151.1836438,
    "placeId": "ChIJd3XvdDypEmsR71ycOCikuoA",
    "businessStatus": "OPERATIONAL",
    "phone": "0468 838 441",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 9:30 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 18,
    "id": 1282,
    "district": "Chatswood"
  },
  {
    "title": "Chatswood Shopping Centre",
    "urlinform": "chatswood-shopping-centre",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD3U0_J2pEmsRWuOmUEgQOU4",
    "lat": -33.7967682,
    "lng": 151.1828639,
    "placeId": "ChIJD3U0_J2pEmsRWuOmUEgQOU4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 244,
    "id": 1283,
    "district": "Chatswood"
  },
  {
    "title": "Officeworks Chatswood",
    "urlinform": "officeworks-chatswood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.officeworks.com.au/shop/officeworks/storelocator",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ02ZY9yWpEmsROhZiny47wKg",
    "lat": -33.7928269,
    "lng": 151.1934559,
    "placeId": "ChIJ02ZY9yWpEmsROhZiny47wKg",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9201 8600",
    "openingHours": [
      "Monday: 7:00 AM – 9:00 PM",
      "Tuesday: 7:00 AM – 9:00 PM",
      "Wednesday: 7:00 AM – 9:00 PM",
      "Thursday: 7:00 AM – 9:00 PM",
      "Friday: 7:00 AM – 9:00 PM",
      "Saturday: 8:00 AM – 6:00 PM",
      "Sunday: 9:00 AM – 6:00 PM"
    ],
    "rating": 2.9,
    "userRatingsTotal": 604,
    "id": 1284
  },
  {
    "title": "Kmart Chatswood",
    "urlinform": "kmart-chatswood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.kmart.com.au/store-detail/Kmart+Chatswood?utm_source=google&utm_medium=organic&utm_campaign=googleplaces&utm_content=kmart+chatswood",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv1eNctaoEmsRWcx4nuptHCU",
    "lat": -33.7951238,
    "lng": 151.1858439,
    "placeId": "ChIJv1eNctaoEmsRWcx4nuptHCU",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9934 7400",
    "openingHours": [
      "Monday: 8:00 AM – 10:00 PM",
      "Tuesday: 8:00 AM – 10:00 PM",
      "Wednesday: 8:00 AM – 10:00 PM",
      "Thursday: 8:00 AM – 10:00 PM",
      "Friday: 8:00 AM – 10:00 PM",
      "Saturday: 8:00 AM – 10:00 PM",
      "Sunday: 8:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 2406,
    "id": 1285,
    "district": "Chatswood"
  },
  {
    "title": "ポケカ専門店ニンニン大阪日本橋2号店",
    "urlinform": "2",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://nin-nin-pokeka.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnfnkxbrnAGAR5PMo0-MoKCs",
    "lat": 34.6609154,
    "lng": 135.5037795,
    "placeId": "ChIJnfnkxbrnAGAR5PMo0-MoKCs",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6606-9898",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 21,
    "id": 1286,
    "district": "Namba"
  },
  {
    "title": "[ Pokemon Card Shop ] Ninnin Osaka Nihonbashi",
    "urlinform": "store-67",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://nin-nin-pokeka.jp/news/320/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ7imWgDnAGARdmcEo84lcqE",
    "lat": 34.6621845,
    "lng": 135.5053944,
    "placeId": "ChIJZ7imWgDnAGARdmcEo84lcqE",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6647-3383",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 54,
    "id": 1287,
    "district": "Namba"
  },
  {
    "title": "鑑定屋きりん",
    "urlinform": "store-70",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh502enTnAGARQfAfql2jjI8",
    "lat": 34.6611969,
    "lng": 135.5049832,
    "placeId": "ChIJh502enTnAGARQfAfql2jjI8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 58,
    "id": 1288,
    "district": "Namba"
  },
  {
    "title": "トレカショップPOEM",
    "urlinform": "poem",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cardshop-review.com/archives/review/poem_pokeca?utm_source=GBP&utm_medium=GBP&utm_term=GBP&utm_content=GBP&utm_campaign=GBP",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2UvtdQDnAGAR7waW_9U6q78",
    "lat": 34.6593182,
    "lng": 135.5042168,
    "placeId": "ChIJ2UvtdQDnAGAR7waW_9U6q78",
    "businessStatus": "OPERATIONAL",
    "phone": "080-3848-4409",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 9,
    "id": 1289,
    "district": "Nipponbashi"
  },
  {
    "title": "Card labo Osaka-nipponbashi",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.c-labo.jp/shop/nipponbashi/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ62zeWmjnAGARog7oLrrG2vk",
    "lat": 34.6605473,
    "lng": 135.5046125,
    "placeId": "ChIJ62zeWmjnAGARog7oLrrG2vk",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6567-9494",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 2.4,
    "userRatingsTotal": 100,
    "id": 1290,
    "district": "Namba"
  },
  {
    "title": "トレカチャンピオンなんば日本橋店",
    "urlinform": "store-89",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.trading-card-champion.com/concept8.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTc5tzNvnAGAR26pXMqNsqvo",
    "lat": 34.6630282,
    "lng": 135.5032307,
    "placeId": "ChIJTc5tzNvnAGAR26pXMqNsqvo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 2.2,
    "userRatingsTotal": 50,
    "id": 1291,
    "district": "Namba"
  },
  {
    "title": "HOMEGAME OSAKA",
    "urlinform": "homegame-osaka",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://homegame-tokyo.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3XXclO_nAGARE2IxvqALzsk",
    "lat": 34.6704874,
    "lng": 135.5014136,
    "placeId": "ChIJ3XXclO_nAGARE2IxvqALzsk",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6755-8035",
    "openingHours": [
      "Monday: 10:30 AM – 10:30 PM",
      "Tuesday: 10:30 AM – 10:30 PM",
      "Wednesday: 10:30 AM – 10:30 PM",
      "Thursday: 10:30 AM – 10:30 PM",
      "Friday: 10:30 AM – 10:30 PM",
      "Saturday: 10:30 AM – 10:30 PM",
      "Sunday: 10:30 AM – 10:30 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 173,
    "id": 1292,
    "district": "Shinsaibashi"
  },
  {
    "title": "カードショップガルタ",
    "urlinform": "mtg-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cardshopghalta.com/?utm_source=GBP&utm_medium=GBP&utm_term=GBP&utm_content=GBP&utm_campaign=GBP",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi_HhJpjnAGARG6eP0btrLfc",
    "lat": 34.6831629,
    "lng": 135.5152329,
    "placeId": "ChIJi_HhJpjnAGARG6eP0btrLfc",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6467-4970",
    "openingHours": [
      "Monday: 3:00 PM – 12:00 AM",
      "Tuesday: 3:00 PM – 12:00 AM",
      "Wednesday: 3:00 PM – 12:00 AM",
      "Thursday: Closed",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 3:00 – 9:00 PM",
      "Sunday: 3:00 – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 6,
    "id": 1293
  },
  {
    "title": "K1 Trading Card Shop",
    "urlinform": "k1-trading-card-shop",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.k1tcgbuylist.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJobiWedLnAGARCkd68nkWxEU",
    "lat": 34.6595454,
    "lng": 135.5063942,
    "placeId": "ChIJobiWedLnAGARCkd68nkWxEU",
    "businessStatus": "OPERATIONAL",
    "phone": "070-8485-4669",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1294,
    "district": "Nipponbashi"
  },
  {
    "title": "magi大阪オタロード店(TCG shop)",
    "urlinform": "magi",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/magiNiponbashi2",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJX_XcPcnnAGARdR3rivtrLos",
    "lat": 34.661696,
    "lng": 135.5050524,
    "placeId": "ChIJX_XcPcnnAGARdR3rivtrLos",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 7:30 PM",
      "Tuesday: 1:00 – 7:30 PM",
      "Wednesday: 1:00 – 7:30 PM",
      "Thursday: 1:00 – 7:30 PM",
      "Friday: 1:00 – 7:30 PM",
      "Saturday: 1:00 – 7:30 PM",
      "Sunday: 1:00 – 7:30 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 17,
    "id": 1295,
    "district": "Namba"
  },
  {
    "title": "Nipponbashi Denden Town",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.nippombashi.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv6w_-2fnAGARH2p9wbwos3c",
    "lat": 34.6604299,
    "lng": 135.5058817,
    "placeId": "ChIJv6w_-2fnAGARH2p9wbwos3c",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6655-1717",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 9703,
    "id": 1296,
    "district": "Namba"
  },
  {
    "title": "カードショップえぬ",
    "urlinform": "store-109",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/Card_shop_n",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCx23DqbnAGARh9wREdfJPbw",
    "lat": 34.6593613,
    "lng": 135.5050771,
    "placeId": "ChIJCx23DqbnAGARh9wREdfJPbw",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6567-8255",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: Closed",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 13,
    "id": 1297,
    "district": "Nipponbashi"
  },
  {
    "title": "BAR UNKNOWN トレーディングカードショップ",
    "urlinform": "bar-unknown-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://bar-unknown.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiUFtfmPnAGAR3qpV-pks18c",
    "lat": 34.6611251,
    "lng": 135.5038636,
    "placeId": "ChIJiUFtfmPnAGAR3qpV-pks18c",
    "businessStatus": "OPERATIONAL",
    "phone": "06-4393-8989",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 3:00 PM – 12:00 AM",
      "Thursday: 3:00 PM – 12:00 AM",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 3:00 PM – 12:00 AM",
      "Sunday: 3:00 PM – 12:00 AM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 45,
    "id": 1298,
    "district": "Namba"
  },
  {
    "title": "ケンショクマジック・ザ・ギャザリング専門店",
    "urlinform": "store-46",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/in_innn7",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEbZ0TfGUQTURsJXqICNd5co",
    "lat": 33.5386487,
    "lng": 130.3444469,
    "placeId": "ChIJEbZ0TfGUQTURsJXqICNd5co",
    "businessStatus": "OPERATIONAL",
    "phone": "092-862-2445",
    "openingHours": [
      "Monday: 2:00 – 7:30 PM",
      "Tuesday: 2:00 – 7:30 PM",
      "Wednesday: 2:00 – 7:30 PM",
      "Thursday: 2:00 – 7:30 PM",
      "Friday: 2:00 – 7:30 PM",
      "Saturday: 11:00 AM – 7:30 PM",
      "Sunday: 11:00 AM – 7:30 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 10,
    "id": 1299
  },
  {
    "title": "Daimaru",
    "urlinform": "store-48",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.daimaru.co.jp/fukuoka/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgY9sI5CRQTUROK04wom2Es0",
    "lat": 33.5886461,
    "lng": 130.4011817,
    "placeId": "ChIJgY9sI5CRQTUROK04wom2Es0",
    "businessStatus": "OPERATIONAL",
    "phone": "092-712-8181",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 8695,
    "id": 1300,
    "district": "Tenjin"
  },
  {
    "title": "カードショップテンペスト",
    "urlinform": "store-49",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN45zXmqRQTURwZSDD5_80gY",
    "lat": 33.5882211,
    "lng": 130.4023639,
    "placeId": "ChIJN45zXmqRQTURwZSDD5_80gY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1301,
    "district": "Tenjin"
  },
  {
    "title": "トレカウィッシュ 北九州小倉",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJT8eF-1a_QzURbab2D5Iv5Rk",
    "lat": 33.8832534,
    "lng": 130.8794185,
    "placeId": "ChIJT8eF-1a_QzURbab2D5Iv5Rk",
    "businessStatus": "OPERATIONAL",
    "phone": "080-6387-3763",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 54,
    "id": 1302,
    "district": "Kokura"
  },
  {
    "title": "Lib Stock-リブストック-ポケモンカード・トレカ専門店",
    "urlinform": "lib-stock-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.libretradingcard.shop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJr9j7YGe_QzUR4MPEP6DtQGY",
    "lat": 33.8856087,
    "lng": 130.879262,
    "placeId": "ChIJr9j7YGe_QzUR4MPEP6DtQGY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 16,
    "id": 1303,
    "district": "Kokura"
  },
  {
    "title": "ポケモンカード専門店 The トレカ",
    "urlinform": "-the-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFeBRTz2_QzURY4n0dHJNqrY",
    "lat": 33.8881773,
    "lng": 130.88228,
    "placeId": "ChIJFeBRTz2_QzURY4n0dHJNqrY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.9,
    "userRatingsTotal": 22,
    "id": 1304,
    "district": "Kokura"
  },
  {
    "title": "トレカワールド 小倉駅前店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/ryuseikokura",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP54FlD7AQzURRjnBS-UJ4w8",
    "lat": 33.8851233,
    "lng": 130.8825117,
    "placeId": "ChIJP54FlD7AQzURRjnBS-UJ4w8",
    "businessStatus": "OPERATIONAL",
    "phone": "093-967-9792",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 273,
    "id": 1305,
    "district": "Kokura"
  },
  {
    "title": "カードショップ八百万",
    "urlinform": "store-55",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJla6xMsjHQzURW0skW0DTMPA",
    "lat": 33.8653674,
    "lng": 130.810294,
    "placeId": "ChIJla6xMsjHQzURW0skW0DTMPA",
    "businessStatus": "OPERATIONAL",
    "phone": "080-3994-8046",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 10,
    "id": 1306
  },
  {
    "title": "Card Labo Kokura",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.c-labo.jp/shop/kokura.shtml",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd_tBEEm_QzURz-MYbOMxyO8",
    "lat": 33.8877191,
    "lng": 130.8847887,
    "placeId": "ChIJd_tBEEm_QzURz-MYbOMxyO8",
    "businessStatus": "OPERATIONAL",
    "phone": "093-541-5055",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 123,
    "id": 1307,
    "district": "Kokura"
  },
  {
    "title": "Gee! Store Kokura",
    "urlinform": "store-58",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.geestore.com/geenet/geestore/kokura",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0SP0GLu_QzURmZUuEsmvsc0",
    "lat": 33.88751,
    "lng": 130.8846736,
    "placeId": "ChIJ0SP0GLu_QzURmZUuEsmvsc0",
    "businessStatus": "OPERATIONAL",
    "phone": "093-533-0660",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 23,
    "id": 1308,
    "district": "Kokura"
  },
  {
    "title": "ホビーステーション小倉",
    "urlinform": "store-59",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hbst.net/shop/53/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR58VJwC_QzURlOKtzA8DJ5g",
    "lat": 33.8875235,
    "lng": 130.8847897,
    "placeId": "ChIJR58VJwC_QzURlOKtzA8DJ5g",
    "businessStatus": "OPERATIONAL",
    "phone": "093-383-3828",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.6,
    "userRatingsTotal": 20,
    "id": 1309,
    "district": "Kokura"
  },
  {
    "title": "カードボックス小倉リバーウォーク店",
    "urlinform": "store-63",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.speed-neobravo.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOZvd6rm5QzUR5VNYysHA5vU",
    "lat": 33.8858129,
    "lng": 130.8758048,
    "placeId": "ChIJOZvd6rm5QzUR5VNYysHA5vU",
    "businessStatus": "OPERATIONAL",
    "phone": "093-383-0881",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.9,
    "userRatingsTotal": 25,
    "id": 1310,
    "district": "Kokura"
  },
  {
    "title": "G-PROJECT (カードゲーム専門店)",
    "urlinform": "g-project-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.gproject-tcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJczDKbQDMQzURlsa70S6uHIA",
    "lat": 33.8646445,
    "lng": 130.7703844,
    "placeId": "ChIJczDKbQDMQzURlsa70S6uHIA",
    "businessStatus": "OPERATIONAL",
    "phone": "093-632-1181",
    "openingHours": [
      "Monday: 4:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 4:00 – 10:00 PM",
      "Thursday: 4:00 – 10:00 PM",
      "Friday: 4:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 33,
    "id": 1311
  },
  {
    "title": "トレカショップEDEL",
    "urlinform": "edel",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/edeltraca2024?igsh=bzR3amJqNGVwZ2xi&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg3eINozJQzURg0Fj1sUs6T8",
    "lat": 33.8916915,
    "lng": 130.7711391,
    "placeId": "ChIJg3eINozJQzURg0Fj1sUs6T8",
    "businessStatus": "OPERATIONAL",
    "phone": "080-4581-9343",
    "openingHours": [
      "Monday: 11:00 AM – 5:00 PM",
      "Tuesday: 11:00 AM – 5:00 PM",
      "Wednesday: Closed",
      "Thursday: 11:00 AM – 5:00 PM",
      "Friday: 11:00 AM – 5:00 PM",
      "Saturday: 11:00 AM – 5:00 PM",
      "Sunday: 11:00 AM – 5:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 11,
    "id": 1312
  },
  {
    "title": "買取小倉バンク",
    "urlinform": "store-66",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://watch-kokura-bank.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJceqL84q_QzURdDr1FYSef4U",
    "lat": 33.8826735,
    "lng": 130.8820725,
    "placeId": "ChIJceqL84q_QzURdDr1FYSef4U",
    "businessStatus": "OPERATIONAL",
    "phone": "093-330-1119",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 29,
    "id": 1313,
    "district": "Kokura"
  },
  {
    "title": "川上玩具店",
    "urlinform": "store-67",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ__PMfy6WQzUR_cWD76px29w",
    "lat": 33.9459686,
    "lng": 130.9662554,
    "placeId": "ChIJ__PMfy6WQzUR_cWD76px29w",
    "businessStatus": "OPERATIONAL",
    "phone": "093-321-1408",
    "openingHours": [
      "Monday: 10:00 AM – 5:00 PM",
      "Tuesday: 10:00 AM – 5:00 PM",
      "Wednesday: 10:00 AM – 5:00 PM",
      "Thursday: 10:00 AM – 5:00 PM",
      "Friday: 10:00 AM – 5:00 PM",
      "Saturday: 10:00 AM – 5:00 PM",
      "Sunday: 10:00 AM – 4:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 16,
    "id": 1314
  },
  {
    "title": "Aruaru City",
    "urlinform": "city",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://aruarucity.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJU41AEEm_QzURmQifczh8sqM",
    "lat": 33.8875512,
    "lng": 130.8846773,
    "placeId": "ChIJU41AEEm_QzURmQifczh8sqM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 4260,
    "id": 1315,
    "district": "Kokura"
  },
  {
    "title": "トレカセンター エース",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAWEPFgC5QzURwhUGekkRMgk",
    "lat": 33.8872703,
    "lng": 130.8712136,
    "placeId": "ChIJAWEPFgC5QzURwhUGekkRMgk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 5:00 – 11:00 PM",
      "Wednesday: Closed",
      "Thursday: 5:00 – 11:00 PM",
      "Friday: Closed",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 2.7,
    "userRatingsTotal": 3,
    "id": 1316,
    "district": "Kokura"
  },
  {
    "title": "Quest Book Store",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.nic-retails.co.jp/shop/7387/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLUOw0FK_QzURtUCgHscjrkc",
    "lat": 33.881818,
    "lng": 130.878413,
    "placeId": "ChIJLUOw0FK_QzURtUCgHscjrkc",
    "businessStatus": "OPERATIONAL",
    "phone": "093-522-3912",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 1403,
    "id": 1317,
    "district": "Kokura"
  },
  {
    "title": "66トレカ",
    "urlinform": "66",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/rokurokutoreka",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbz9EMgDLQzURpN9ZnYi-h84",
    "lat": 33.887948,
    "lng": 130.7048642,
    "placeId": "ChIJbz9EMgDLQzURpN9ZnYi-h84",
    "businessStatus": "OPERATIONAL",
    "phone": "093-280-8263",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 7,
    "id": 1318
  },
  {
    "title": "ガラクタ王国",
    "urlinform": "store-74",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8T-v89vRQzURq-pX3WAM4TQ",
    "lat": 33.7485593,
    "lng": 130.7375347,
    "placeId": "ChIJ8T-v89vRQzURq-pX3WAM4TQ",
    "businessStatus": "OPERATIONAL",
    "phone": "0949-28-2660",
    "openingHours": [
      "Monday: 12:00 PM – 12:00 AM",
      "Tuesday: 12:00 PM – 12:00 AM",
      "Wednesday: 12:00 PM – 12:00 AM",
      "Thursday: 12:00 PM – 12:00 AM",
      "Friday: 12:00 PM – 12:00 AM",
      "Saturday: 12:00 PM – 12:00 AM",
      "Sunday: 12:00 PM – 12:00 AM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 73,
    "id": 1319
  },
  {
    "title": "オフィスランド 足立インター店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.officeland.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpaQ9IFm_QzURS4M3TKmwlI0",
    "lat": 33.87149369999999,
    "lng": 130.8918328,
    "placeId": "ChIJpaQ9IFm_QzURS4M3TKmwlI0",
    "businessStatus": "OPERATIONAL",
    "phone": "093-512-6011",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 407,
    "id": 1320
  },
  {
    "title": "Izutsuya Kokura",
    "urlinform": "store-77",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.izutsuya.co.jp/storelist/kokura/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAf7dTU2_QzUROfNUuOdEGpk",
    "lat": 33.8842088,
    "lng": 130.8781954,
    "placeId": "ChIJAf7dTU2_QzUROfNUuOdEGpk",
    "businessStatus": "OPERATIONAL",
    "phone": "093-522-3111",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 4760,
    "id": 1321,
    "district": "Kokura"
  },
  {
    "title": "Hobby Space Eins",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://hobbyspace-eins.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP65joYHIQzURzPQQP-A74v8",
    "lat": 33.86393,
    "lng": 130.789935,
    "placeId": "ChIJP65joYHIQzURzPQQP-A74v8",
    "businessStatus": "OPERATIONAL",
    "phone": "093-616-8534",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 5:00 – 9:00 PM",
      "Wednesday: 5:00 – 9:00 PM",
      "Thursday: Closed",
      "Friday: 5:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 9,
    "id": 1322
  },
  {
    "title": "HAPPY DRAGON（ハッピードラゴン）",
    "urlinform": "happy-dragon",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.at-ml.jp/63389/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhzqn5VK_QzURx9a9taGLgNk",
    "lat": 33.8815634,
    "lng": 130.8801937,
    "placeId": "ChIJhzqn5VK_QzURx9a9taGLgNk",
    "businessStatus": "OPERATIONAL",
    "phone": "093-533-3732",
    "openingHours": [
      "Monday: 10:30 AM – 5:30 PM",
      "Tuesday: 10:30 AM – 5:30 PM",
      "Wednesday: 10:30 AM – 5:30 PM",
      "Thursday: 10:30 AM – 5:30 PM",
      "Friday: 10:30 AM – 5:30 PM",
      "Saturday: 10:30 AM – 5:30 PM",
      "Sunday: 10:30 AM – 5:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 17,
    "id": 1323,
    "district": "Kokura"
  },
  {
    "title": "Jangurukokuraten",
    "urlinform": "store-80",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://jungle-scs.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9_JpEEm_QzURYSqTDqQwfPQ",
    "lat": 33.8874621,
    "lng": 130.8848081,
    "placeId": "ChIJ9_JpEEm_QzURYSqTDqQwfPQ",
    "businessStatus": "OPERATIONAL",
    "phone": "093-967-7446",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 98,
    "id": 1324,
    "district": "Kokura"
  },
  {
    "title": "Melon Books Kokura",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.melonbooks.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs1NvEEm_QzURcJUrVP46op4",
    "lat": 33.8873729,
    "lng": 130.8847634,
    "placeId": "ChIJs1NvEEm_QzURcJUrVP46op4",
    "businessStatus": "OPERATIONAL",
    "phone": "093-512-3363",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 170,
    "id": 1325,
    "district": "Kokura"
  },
  {
    "title": "Lashinbang Kokura Store",
    "urlinform": "store-82",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lashinbang.com/store/51/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOef1EEm_QzURJlIYkzqnGow",
    "lat": 33.8875419,
    "lng": 130.8847304,
    "placeId": "ChIJOef1EEm_QzURJlIYkzqnGow",
    "businessStatus": "OPERATIONAL",
    "phone": "0570-008-620",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 69,
    "id": 1326,
    "district": "Kokura"
  },
  {
    "title": "光華堂",
    "urlinform": "store-83",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ779577K4QzURcDbTJrTF2Bc",
    "lat": 33.8863432,
    "lng": 130.8760912,
    "placeId": "ChIJ779577K4QzURcDbTJrTF2Bc",
    "businessStatus": "OPERATIONAL",
    "phone": "093-582-6745",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 12:00 – 4:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 1,
    "id": 1327,
    "district": "Kokura"
  },
  {
    "title": "TCGSHOP MINA",
    "urlinform": "tcgshop-mina",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/TCGSHOPMINA",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJayVfoWRp5TQRTr4XFf-1Nhs",
    "lat": 26.210831,
    "lng": 127.7024129,
    "placeId": "ChIJayVfoWRp5TQRTr4XFf-1Nhs",
    "businessStatus": "OPERATIONAL",
    "phone": "098-995-8471",
    "openingHours": [],
    "rating": 4.9,
    "userRatingsTotal": 34,
    "id": 1328
  },
  {
    "title": "ニンニン沖縄店",
    "urlinform": "store-34",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ12OWEARp5TQRLpDiqF2AV9s",
    "lat": 26.2177523,
    "lng": 127.687,
    "placeId": "ChIJ12OWEARp5TQRLpDiqF2AV9s",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 7,
    "id": 1329,
    "district": "Kokusai Street"
  },
  {
    "title": "Manga Souko",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://mangasouko-okinawa.com/awase/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJl9shMp0N5TQRr1OFLf6-x4c",
    "lat": 26.3073654,
    "lng": 127.819684,
    "placeId": "ChIJl9shMp0N5TQRr1OFLf6-x4c",
    "businessStatus": "OPERATIONAL",
    "phone": "098-931-9911",
    "openingHours": [
      "Monday: 9:00 AM – 12:00 AM",
      "Tuesday: 9:00 AM – 12:00 AM",
      "Wednesday: 9:00 AM – 12:00 AM",
      "Thursday: 9:00 AM – 12:00 AM",
      "Friday: 9:00 AM – 12:00 AM",
      "Saturday: 9:00 AM – 12:00 AM",
      "Sunday: 9:00 AM – 12:00 AM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 909,
    "id": 1330
  },
  {
    "title": "Aeon Chatan Branch",
    "urlinform": "store-66",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.aeon-ryukyu.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrfNFyxoT5TQRM8SMRwelRbg",
    "lat": 26.3143904,
    "lng": 127.7572027,
    "placeId": "ChIJrfNFyxoT5TQRM8SMRwelRbg",
    "businessStatus": "OPERATIONAL",
    "phone": "098-982-7575",
    "openingHours": [
      "Monday: 9:00 AM – 11:00 PM",
      "Tuesday: 9:00 AM – 11:00 PM",
      "Wednesday: 9:00 AM – 11:00 PM",
      "Thursday: 9:00 AM – 11:00 PM",
      "Friday: 9:00 AM – 11:00 PM",
      "Saturday: 9:00 AM – 11:00 PM",
      "Sunday: 9:00 AM – 11:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 4907,
    "id": 1331,
    "district": "American Village"
  },
  {
    "title": "GEO",
    "urlinform": "58",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://geo-online.co.jp/store/03438/?utm_source=google&utm_medium=map&utm_campaign=03438",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJycYR4SMT5TQRhDN8YXoo3Pw",
    "lat": 26.299431,
    "lng": 127.760759,
    "placeId": "ChIJycYR4SMT5TQRhDN8YXoo3Pw",
    "businessStatus": "OPERATIONAL",
    "phone": "098-921-7371",
    "openingHours": [
      "Monday: 9:00 AM – 12:00 AM",
      "Tuesday: 9:00 AM – 12:00 AM",
      "Wednesday: 9:00 AM – 12:00 AM",
      "Thursday: 9:00 AM – 12:00 AM",
      "Friday: 9:00 AM – 12:00 AM",
      "Saturday: 9:00 AM – 12:00 AM",
      "Sunday: 9:00 AM – 12:00 AM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 201,
    "id": 1332
  },
  {
    "title": "Threeppy Aeon Chatan Branch",
    "urlinform": "threeppy-sc",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.threeppy.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOzGN9kMT5TQRGwvKST-LzH8",
    "lat": 26.3149106,
    "lng": 127.7574149,
    "placeId": "ChIJOzGN9kMT5TQRGwvKST-LzH8",
    "businessStatus": "OPERATIONAL",
    "phone": "098-989-8600",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 8,
    "id": 1333,
    "district": "American Village"
  },
  {
    "title": "ボードゲームショップほたる屋",
    "urlinform": "store-71",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://hotaruyaboardgame.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJeYATxukT5TQR_BUrYDmNrUc",
    "lat": 26.279167,
    "lng": 127.7783584,
    "placeId": "ChIJeYATxukT5TQR_BUrYDmNrUc",
    "businessStatus": "OPERATIONAL",
    "phone": "080-6496-8408",
    "openingHours": [
      "Monday: 3:00 PM – 12:00 AM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 3:00 PM – 12:00 AM",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 11:00 AM – 12:00 AM",
      "Sunday: 11:00 AM – 12:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 5,
    "id": 1334,
    "district": "Ginowan"
  },
  {
    "title": "Kaitorisenmontendaikichi Okinawachatanten",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lin.ee/Z00KCPj",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC9O_jxwT5TQRDm0c8XRhxaE",
    "lat": 26.311162,
    "lng": 127.761718,
    "placeId": "ChIJC9O_jxwT5TQRDm0c8XRhxaE",
    "businessStatus": "OPERATIONAL",
    "phone": "098-989-0082",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 98,
    "id": 1335,
    "district": "American Village"
  },
  {
    "title": "Manga Souko Urasoe",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://mangasouko-okinawa.com/urasoe/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrQMeFXdr5TQRb0KEfzTeTUA",
    "lat": 26.261789,
    "lng": 127.712023,
    "placeId": "ChIJrQMeFXdr5TQRb0KEfzTeTUA",
    "businessStatus": "OPERATIONAL",
    "phone": "098-874-4455",
    "openingHours": [
      "Monday: 9:00 AM – 12:00 AM",
      "Tuesday: 9:00 AM – 12:00 AM",
      "Wednesday: 9:00 AM – 12:00 AM",
      "Thursday: 9:00 AM – 12:00 AM",
      "Friday: 9:00 AM – 12:00 AM",
      "Saturday: 9:00 AM – 12:00 AM",
      "Sunday: 9:00 AM – 12:00 AM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 2962,
    "id": 1336
  },
  {
    "title": "GEO Nishihara",
    "urlinform": "store-77",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://geo-online.co.jp/store/02940/?utm_source=google&utm_medium=map&utm_campaign=02940",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv87rWohs5TQRDbEKdWmZpdc",
    "lat": 26.2525752,
    "lng": 127.7363493,
    "placeId": "ChIJv87rWohs5TQRDbEKdWmZpdc",
    "businessStatus": "OPERATIONAL",
    "phone": "098-870-1300",
    "openingHours": [
      "Monday: 9:00 AM – 1:00 AM",
      "Tuesday: 9:00 AM – 1:00 AM",
      "Wednesday: 9:00 AM – 1:00 AM",
      "Thursday: 9:00 AM – 1:00 AM",
      "Friday: 9:00 AM – 1:00 AM",
      "Saturday: 9:00 AM – 1:00 AM",
      "Sunday: 9:00 AM – 1:00 AM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 286,
    "id": 1337
  },
  {
    "title": "GEO Urasoe",
    "urlinform": "store-78",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://geo-online.co.jp/store/02542/?utm_source=google&utm_medium=map&utm_campaign=02542",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE8_rV4Nr5TQRLQS1iZJ-xYQ",
    "lat": 26.2525504,
    "lng": 127.7137447,
    "placeId": "ChIJE8_rV4Nr5TQRLQS1iZJ-xYQ",
    "businessStatus": "OPERATIONAL",
    "phone": "098-942-5351",
    "openingHours": [
      "Monday: 9:00 AM – 11:00 PM",
      "Tuesday: 9:00 AM – 11:00 PM",
      "Wednesday: 9:00 AM – 11:00 PM",
      "Thursday: 9:00 AM – 11:00 PM",
      "Friday: 9:00 AM – 11:00 PM",
      "Saturday: 9:00 AM – 11:00 PM",
      "Sunday: 9:00 AM – 11:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 159,
    "id": 1338
  },
  {
    "title": "Hands Craft Ginowan",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://handscraft-okinawa.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh5ZiIopt5TQRsqlL4CSSAe4",
    "lat": 26.2599492,
    "lng": 127.7455937,
    "placeId": "ChIJh5ZiIopt5TQRsqlL4CSSAe4",
    "businessStatus": "OPERATIONAL",
    "phone": "098-942-2780",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 1410,
    "id": 1339
  },
  {
    "title": "Green note",
    "urlinform": "store-81",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.green-note.biz/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_4V8hi0T5TQR1VKMCIdq6Lg",
    "lat": 26.2891487,
    "lng": 127.7565172,
    "placeId": "ChIJ_4V8hi0T5TQR1VKMCIdq6Lg",
    "businessStatus": "OPERATIONAL",
    "phone": "098-897-1066",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.5,
    "userRatingsTotal": 186,
    "id": 1340
  },
  {
    "title": "PawnShop Kantei Kyoku Ginowan Aichi",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.kanteikyoku.co.jp/?utm_source=google&utm_medium=MyBusiness",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJL-ZjLyZt5TQR-luafQ3Vjk8",
    "lat": 26.2700997,
    "lng": 127.7695346,
    "placeId": "ChIJL-ZjLyZt5TQR-luafQ3Vjk8",
    "businessStatus": "OPERATIONAL",
    "phone": "098-893-8378",
    "openingHours": [
      "Monday: 10:00 AM – 6:30 PM",
      "Tuesday: 10:00 AM – 6:30 PM",
      "Wednesday: 10:00 AM – 6:30 PM",
      "Thursday: 10:00 AM – 6:30 PM",
      "Friday: 10:00 AM – 6:30 PM",
      "Saturday: 10:00 AM – 6:30 PM",
      "Sunday: 10:00 AM – 6:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 160,
    "id": 1341
  },
  {
    "title": "Hobby shop G-SouL / Tamashii Nation",
    "urlinform": "hobby-shop-g-soul",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.parcocity.jp/floorguide/detail/?scd=000083",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR8dR9ihr5TQRFIaKzv1n_kE",
    "lat": 26.2617727,
    "lng": 127.6978482,
    "placeId": "ChIJR8dR9ihr5TQRFIaKzv1n_kE",
    "businessStatus": "OPERATIONAL",
    "phone": "098-871-1185",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 53,
    "id": 1342
  },
  {
    "title": "買取店わかば那覇コープあっぷるタウン店",
    "urlinform": "store-84",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "MTG",
      "One Piece",
      "Pokémon",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://wakaba-shop.jp/shop/okinawa-at-naha/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWyfotP1r5TQRk0mTheXMahE",
    "lat": 26.2283096,
    "lng": 127.6919485,
    "placeId": "ChIJWyfotP1r5TQRk0mTheXMahE",
    "businessStatus": "OPERATIONAL",
    "phone": "098-943-6773",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 140,
    "id": 1343
  },
  {
    "title": "HMV&BOOKS OKINAWA",
    "urlinform": "hmvbooks-okinawa",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hmv.co.jp/store/BOK/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5R8LFclr5TQRheE6p4LrfeQ",
    "lat": 26.2618741,
    "lng": 127.6975646,
    "placeId": "ChIJ5R8LFclr5TQRheE6p4LrfeQ",
    "businessStatus": "OPERATIONAL",
    "phone": "098-943-0540",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 131,
    "id": 1344
  },
  {
    "title": "Sino Centre",
    "urlinform": "sino-centre",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5VtEGMcABDQRpuim-g86r_w",
    "lat": 22.3160359,
    "lng": 114.1703368,
    "placeId": "ChIJ5VtEGMcABDQRpuim-g86r_w",
    "businessStatus": "OPERATIONAL",
    "phone": "2770 7598",
    "openingHours": [
      "Monday: 7:30 AM – 11:30 PM",
      "Tuesday: 7:30 AM – 11:30 PM",
      "Wednesday: 7:30 AM – 11:30 PM",
      "Thursday: 7:30 AM – 11:30 PM",
      "Friday: 7:30 AM – 11:30 PM",
      "Saturday: 7:30 AM – 11:30 PM",
      "Sunday: 7:30 AM – 11:30 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 993,
    "id": 1345,
    "district": "Mong Kok"
  },
  {
    "title": "Card Express",
    "urlinform": "card-express",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ52OGdQABBDQRu4Ie8JrSz8c",
    "lat": 22.3232487,
    "lng": 114.1686854,
    "placeId": "ChIJ52OGdQABBDQRu4Ie8JrSz8c",
    "businessStatus": "OPERATIONAL",
    "phone": "9793 3930",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 2:00 – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 2,
    "userRatingsTotal": 2,
    "id": 1346,
    "district": "Mong Kok"
  },
  {
    "title": "藏卡王香港 Logoman Sports Cards",
    "urlinform": "-logoman-sports-cards",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJy8tShFoBBDQRFPsiIwkSKfM",
    "lat": 22.3157329,
    "lng": 114.1708984,
    "placeId": "ChIJy8tShFoBBDQRFPsiIwkSKfM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 4,
    "id": 1347,
    "district": "Mong Kok"
  },
  {
    "title": "C. Gift Shop",
    "urlinform": "c-gift-shop",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://c-gifts.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSYGvNcgABDQRTub7fqxN4LA",
    "lat": 22.3228192,
    "lng": 114.1690566,
    "placeId": "ChIJSYGvNcgABDQRTub7fqxN4LA",
    "businessStatus": "OPERATIONAL",
    "phone": "3693 4312",
    "openingHours": [
      "Monday: 12:30 – 9:00 PM",
      "Tuesday: 12:30 – 9:00 PM",
      "Wednesday: 12:30 – 9:00 PM",
      "Thursday: 12:30 – 9:00 PM",
      "Friday: 12:30 – 9:00 PM",
      "Saturday: 12:30 – 9:00 PM",
      "Sunday: 12:30 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 9,
    "id": 1348,
    "district": "Mong Kok"
  },
  {
    "title": "COMBO 天悅店 The Card Games Academy",
    "urlinform": "combo-the-card-games-academy",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://combotcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMaQbd8MHBDQRKG8MBb3B_2o",
    "lat": 22.3348174,
    "lng": 114.1603311,
    "placeId": "ChIJMaQbd8MHBDQRKG8MBb3B_2o",
    "businessStatus": "OPERATIONAL",
    "phone": "5683 1635",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 8,
    "id": 1349,
    "district": "Sham Shui Po"
  },
  {
    "title": "3AM TCG",
    "urlinform": "3am-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://3amtcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJISXCjOkHBDQR25kerNWJim4",
    "lat": 22.3348174,
    "lng": 114.1603311,
    "placeId": "ChIJISXCjOkHBDQR25kerNWJim4",
    "businessStatus": "OPERATIONAL",
    "phone": "5598 3951",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 2:30 – 9:00 PM",
      "Sunday: 2:30 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 5,
    "id": 1350,
    "district": "Sham Shui Po"
  },
  {
    "title": "G POINT 遊戲熱點",
    "urlinform": "g-point-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://gpointhobby.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2cv_p7QABDQRdPX6kvrTJGo",
    "lat": 22.3318073,
    "lng": 114.1617244,
    "placeId": "ChIJ2cv_p7QABDQRdPX6kvrTJGo",
    "businessStatus": "OPERATIONAL",
    "phone": "2429 6192",
    "openingHours": [
      "Monday: 12:30 – 9:00 PM",
      "Tuesday: 12:30 – 9:00 PM",
      "Wednesday: 12:30 – 9:00 PM",
      "Thursday: 12:30 – 9:00 PM",
      "Friday: 12:30 – 9:00 PM",
      "Saturday: 12:30 – 9:00 PM",
      "Sunday: 12:30 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 26,
    "id": 1351,
    "district": "Sham Shui Po"
  },
  {
    "title": "CiaoCard 丨日版美版PTCG集換式卡牌專門店",
    "urlinform": "ciaocard-ptcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://ciaocard.shoplineapp.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVQdpSjYHBDQRBMf_bWmzR2Y",
    "lat": 22.336737,
    "lng": 114.1475853,
    "placeId": "ChIJVQdpSjYHBDQRBMf_bWmzR2Y",
    "businessStatus": "OPERATIONAL",
    "phone": "5476 3965",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 52,
    "id": 1352
  },
  {
    "title": "OVERTIME TCG",
    "urlinform": "overtime-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Gundam",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://ottcg.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1QRXMzcHBDQRt6aaZ9XSeHQ",
    "lat": 22.3351446,
    "lng": 114.1601917,
    "placeId": "ChIJ1QRXMzcHBDQRt6aaZ9XSeHQ",
    "businessStatus": "OPERATIONAL",
    "phone": "6604 5573",
    "openingHours": [
      "Monday: 3:00 – 8:00 PM",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 2:00 – 8:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 17,
    "id": 1353,
    "district": "Sham Shui Po"
  },
  {
    "title": "9sss.tcg",
    "urlinform": "9ssstcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/9sss.tcg?igsh=MWN6am00c2RxMTI0aA==&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJI4Sn4SYBBDQRgDPk2v57C_8",
    "lat": 22.3319229,
    "lng": 114.1620778,
    "placeId": "ChIJI4Sn4SYBBDQRgDPk2v57C_8",
    "businessStatus": "OPERATIONAL",
    "phone": "6521 2126",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1354,
    "district": "Sham Shui Po"
  },
  {
    "title": "Animes-Pro",
    "urlinform": "animes-pro",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://animes-pro.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMRGoHbUABDQRIJEVzFpbnjM",
    "lat": 22.3301741,
    "lng": 114.1649059,
    "placeId": "ChIJMRGoHbUABDQRIJEVzFpbnjM",
    "businessStatus": "OPERATIONAL",
    "phone": "2148 9483",
    "openingHours": [
      "Monday: 10:30 AM – 8:00 PM",
      "Tuesday: 10:30 AM – 8:00 PM",
      "Wednesday: 10:30 AM – 8:00 PM",
      "Thursday: 10:30 AM – 8:00 PM",
      "Friday: 10:30 AM – 8:00 PM",
      "Saturday: 10:30 AM – 8:00 PM",
      "Sunday: 10:30 AM – 8:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 773,
    "id": 1355,
    "district": "Sham Shui Po"
  },
  {
    "title": "Mirror Force",
    "urlinform": "mirror-force",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://mirrorforce130.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD0_wYdkHBDQRC9N-sgIzggw",
    "lat": 22.3350235,
    "lng": 114.1605033,
    "placeId": "ChIJD0_wYdkHBDQRC9N-sgIzggw",
    "businessStatus": "OPERATIONAL",
    "phone": "6365 1461",
    "openingHours": [
      "Monday: 6:30 – 9:30 PM",
      "Tuesday: 6:30 – 9:30 PM",
      "Wednesday: 6:30 – 9:30 PM",
      "Thursday: 6:30 – 9:30 PM",
      "Friday: 6:30 – 10:00 PM",
      "Saturday: 1:30 – 8:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1356,
    "district": "Sham Shui Po"
  },
  {
    "title": "2000Fun",
    "urlinform": "2000fun",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard"
    ],
    "storeWebsite": "http://www.openshop.com.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiwmBVbMABDQRnON_Lv98n9A",
    "lat": 22.33234,
    "lng": 114.162001,
    "placeId": "ChIJiwmBVbMABDQRnON_Lv98n9A",
    "businessStatus": "OPERATIONAL",
    "phone": "2708 3123",
    "openingHours": [
      "Monday: 12:00 – 8:30 PM",
      "Tuesday: 12:00 – 8:30 PM",
      "Wednesday: 12:00 – 8:30 PM",
      "Thursday: 12:00 – 8:30 PM",
      "Friday: 12:00 – 8:30 PM",
      "Saturday: 12:00 – 8:30 PM",
      "Sunday: 12:00 – 8:30 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 47,
    "id": 1357,
    "district": "Sham Shui Po"
  },
  {
    "title": "Shop @ Buy Game 2.com",
    "urlinform": "shop-buy-game-2com",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://buygame2.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2_V8u7UABDQRFQy_TJzlDg4",
    "lat": 22.332116,
    "lng": 114.16091,
    "placeId": "ChIJ2_V8u7UABDQRFQy_TJzlDg4",
    "businessStatus": "OPERATIONAL",
    "phone": "2702 2044",
    "openingHours": [
      "Monday: 2:30 – 7:30 PM",
      "Tuesday: 2:30 – 7:30 PM",
      "Wednesday: 2:30 – 7:30 PM",
      "Thursday: 2:30 – 7:30 PM",
      "Friday: 2:30 – 7:30 PM",
      "Saturday: 11:30 AM – 6:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.3,
    "userRatingsTotal": 218,
    "id": 1358,
    "district": "Sham Shui Po"
  },
  {
    "title": "Logic Dream",
    "urlinform": "logic-dream",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Gundam",
      "One Piece",
      "Union Arena",
      "WS"
    ],
    "storeWebsite": "https://www.logicdreamhk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHZtda7EHBDQRZVj3k0CD7nM",
    "lat": 22.3375783,
    "lng": 114.146996,
    "placeId": "ChIJHZtda7EHBDQRZVj3k0CD7nM",
    "businessStatus": "OPERATIONAL",
    "phone": "6769 5787",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 11:00 PM",
      "Wednesday: 6:30 – 11:00 PM",
      "Thursday: 6:30 – 11:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 2:00 – 8:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 10,
    "id": 1359
  },
  {
    "title": "TOP3 Card Game",
    "urlinform": "top3-card-game",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://top3tcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW81ccL8HBDQRmPBmX2UtM_E",
    "lat": 22.3375561,
    "lng": 114.14673,
    "placeId": "ChIJW81ccL8HBDQRmPBmX2UtM_E",
    "businessStatus": "OPERATIONAL",
    "phone": "9072 3581",
    "openingHours": [
      "Monday: 5:00 – 10:00 PM",
      "Tuesday: 5:00 – 10:00 PM",
      "Wednesday: 5:00 – 10:00 PM",
      "Thursday: 5:00 – 10:00 PM",
      "Friday: 5:00 – 10:00 PM",
      "Saturday: 3:30 – 11:00 PM",
      "Sunday: 3:30 – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 6,
    "id": 1360
  },
  {
    "title": "Smiling Plaza",
    "urlinform": "smiling-plaza",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJw8P80wHBDQR-ZaoYOd_gUI",
    "lat": 22.3350001,
    "lng": 114.1605063,
    "placeId": "ChIJJw8P80wHBDQR-ZaoYOd_gUI",
    "businessStatus": "OPERATIONAL",
    "phone": "2361 9813",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 1660,
    "id": 1361,
    "district": "Sham Shui Po"
  },
  {
    "title": "Golden Computer Arcade",
    "urlinform": "golden-computer-arcade",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://gcamall.com.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn2Nqr7QABDQR-__8ruLtig4",
    "lat": 22.3317241,
    "lng": 114.1623086,
    "placeId": "ChIJn2Nqr7QABDQR-__8ruLtig4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 9:30 PM",
      "Tuesday: 10:30 AM – 9:30 PM",
      "Wednesday: 10:30 AM – 9:30 PM",
      "Thursday: 10:30 AM – 9:30 PM",
      "Friday: 10:30 AM – 9:30 PM",
      "Saturday: 10:30 AM – 9:30 PM",
      "Sunday: 10:30 AM – 9:30 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 15824,
    "id": 1362,
    "district": "Sham Shui Po"
  },
  {
    "title": "9號研究所",
    "urlinform": "9",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://studio-9.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCzZbQo8HBDQRTldTcU2NlUc",
    "lat": 22.335094,
    "lng": 114.159844,
    "placeId": "ChIJCzZbQo8HBDQRTldTcU2NlUc",
    "businessStatus": "OPERATIONAL",
    "phone": "5402 9816",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1363,
    "district": "Sham Shui Po"
  },
  {
    "title": "卡樂師 CARDLOS",
    "urlinform": "-cardlos",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61584441935974",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSW2_raEHBDQRjuaTKhORUZE",
    "lat": 22.3351507,
    "lng": 114.1597702,
    "placeId": "ChIJSW2_raEHBDQRjuaTKhORUZE",
    "businessStatus": "OPERATIONAL",
    "phone": "6944 6002",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 1,
    "userRatingsTotal": 1,
    "id": 1364,
    "district": "Sham Shui Po"
  },
  {
    "title": "My咭",
    "urlinform": "my",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.mycard113hk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaxYLEDwHBDQRjUyU5_NlILk",
    "lat": 22.335087,
    "lng": 114.159959,
    "placeId": "ChIJaxYLEDwHBDQRjUyU5_NlILk",
    "businessStatus": "OPERATIONAL",
    "phone": "6121 7343",
    "openingHours": [
      "Monday: 1:00 – 8:30 PM",
      "Tuesday: 1:00 – 8:30 PM",
      "Wednesday: 1:00 – 8:30 PM",
      "Thursday: 1:00 – 8:30 PM",
      "Friday: 1:00 – 8:30 PM",
      "Saturday: 1:00 – 8:30 PM",
      "Sunday: 1:00 – 8:30 PM"
    ],
    "rating": 1,
    "userRatingsTotal": 2,
    "id": 1365,
    "district": "Sham Shui Po"
  },
  {
    "title": "Sham Shui Po Gadget Outlet",
    "urlinform": "sham-shui-po-gadget-outlet",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.sspgadgetoutlet.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0622p7QABDQRCzlCeTJfGMU",
    "lat": 22.3317331,
    "lng": 114.1619539,
    "placeId": "ChIJ0622p7QABDQRCzlCeTJfGMU",
    "businessStatus": "OPERATIONAL",
    "phone": "2387 3666",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 5087,
    "id": 1366,
    "district": "Sham Shui Po"
  },
  {
    "title": "Lucky Time Watch",
    "urlinform": "lucky-time-watch",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.luckytimewatch.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJocXvWLQABDQRZs8NI8HB-FM",
    "lat": 22.3293369,
    "lng": 114.1639041,
    "placeId": "ChIJocXvWLQABDQRZs8NI8HB-FM",
    "businessStatus": "OPERATIONAL",
    "phone": "2885 5554",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 2:00 – 6:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 323,
    "id": 1367,
    "district": "Sham Shui Po"
  },
  {
    "title": "Muze Pens",
    "urlinform": "muze-pens",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.muzepens.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-YZPkcYABDQRCM5cXXuUMxs",
    "lat": 22.3279249,
    "lng": 114.1625426,
    "placeId": "ChIJ-YZPkcYABDQRCM5cXXuUMxs",
    "businessStatus": "OPERATIONAL",
    "phone": "3619 5136",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 291,
    "id": 1368,
    "district": "Sham Shui Po"
  },
  {
    "title": "Ying Kee Trading",
    "urlinform": "ying-kee-trading",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.yingkee.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNbgdirQABDQRtK8dbeumh1U",
    "lat": 22.3283337,
    "lng": 114.1634224,
    "placeId": "ChIJNbgdirQABDQRtK8dbeumh1U",
    "businessStatus": "OPERATIONAL",
    "phone": "2725 2373",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 284,
    "id": 1369,
    "district": "Sham Shui Po"
  },
  {
    "title": "Dream Trading Card",
    "urlinform": "dream-trading-card",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5x08ZR8BBDQRNILk7HduDBM",
    "lat": 22.277945,
    "lng": 114.1773849,
    "placeId": "ChIJ5x08ZR8BBDQRNILk7HduDBM",
    "businessStatus": "OPERATIONAL",
    "phone": "5903 6811",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1370,
    "district": "Wan Chai"
  },
  {
    "title": "West City PC Game Store",
    "urlinform": "west-city-pc-game-store",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://westdos.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN-lDWloABDQRNpv_ADoIFgk",
    "lat": 22.2779191,
    "lng": 114.1773507,
    "placeId": "ChIJN-lDWloABDQRNpv_ADoIFgk",
    "businessStatus": "OPERATIONAL",
    "phone": "6801 2388",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 851,
    "id": 1371,
    "district": "Wan Chai"
  },
  {
    "title": "Chiba (Sogo) Game City",
    "urlinform": "chiba-sogo-game-city",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJa2nUFoABDQRotepmJT8mAM",
    "lat": 22.2776039,
    "lng": 114.1775919,
    "placeId": "ChIJJa2nUFoABDQRotepmJT8mAM",
    "businessStatus": "OPERATIONAL",
    "phone": "2834 7990",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 13,
    "id": 1372,
    "district": "Wan Chai"
  },
  {
    "title": "Oriental 188 Shopping Centre",
    "urlinform": "oriental-188-shopping-centre",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://facebook.com/TimePiece188",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5602WloABDQRL4lTqw_i4cQ",
    "lat": 22.2776361,
    "lng": 114.1775746,
    "placeId": "ChIJ5602WloABDQRL4lTqw_i4cQ",
    "businessStatus": "OPERATIONAL",
    "phone": "2591 1521",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 1171,
    "id": 1373,
    "district": "Wan Chai"
  },
  {
    "title": "孤注一扭（灣仔東方188分店）",
    "urlinform": "188",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/LastChanceToy/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ41kuWloABDQRDi5J2bC-QuQ",
    "lat": 22.277635,
    "lng": 114.177652,
    "placeId": "ChIJ41kuWloABDQRDi5J2bC-QuQ",
    "businessStatus": "OPERATIONAL",
    "phone": "9794 2754",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 19,
    "id": 1374,
    "district": "Wan Chai"
  },
  {
    "title": "Card Holo",
    "urlinform": "card-holo",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://cardholo.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJdaxUgnIBBDQRmGNb9yE4j7c",
    "lat": 22.2777448,
    "lng": 114.1824243,
    "placeId": "ChIJdaxUgnIBBDQRmGNb9yE4j7c",
    "businessStatus": "OPERATIONAL",
    "phone": "9723 9021",
    "openingHours": [
      "Monday: 12:00 – 11:00 PM",
      "Tuesday: 12:00 – 11:00 PM",
      "Wednesday: 12:00 – 11:00 PM",
      "Thursday: 12:00 – 11:00 PM",
      "Friday: 12:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 23,
    "id": 1375,
    "district": "Causeway Bay"
  },
  {
    "title": "BasicLand Card Game Shop",
    "urlinform": "basicland-card-game-shop",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb-fWePcBBDQR47HcBlC2OjQ",
    "lat": 22.277806,
    "lng": 114.1730024,
    "placeId": "ChIJb-fWePcBBDQR47HcBlC2OjQ",
    "businessStatus": "OPERATIONAL",
    "phone": "9300 0421",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 1376,
    "district": "Wan Chai"
  },
  {
    "title": "Hallmark",
    "urlinform": "hallmark",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hkhallmark.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYW7evlwABDQRjgORYdFbrcc",
    "lat": 22.2760553,
    "lng": 114.1725936,
    "placeId": "ChIJYW7evlwABDQRjgORYdFbrcc",
    "businessStatus": "OPERATIONAL",
    "phone": "2320 7599",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 9,
    "id": 1377,
    "district": "Wan Chai"
  },
  {
    "title": "Since Concept Store",
    "urlinform": "since-concept-store",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://sinceconceptstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-yedHFABBDQRnlO0yQDr-Kk",
    "lat": 22.2777777,
    "lng": 114.1778408,
    "placeId": "ChIJ-yedHFABBDQRnlO0yQDr-Kk",
    "businessStatus": "OPERATIONAL",
    "phone": "6024 9390",
    "openingHours": [
      "Monday: 11:00 AM – 7:30 PM",
      "Tuesday: 11:00 AM – 7:30 PM",
      "Wednesday: 11:00 AM – 7:30 PM",
      "Thursday: 11:00 AM – 7:30 PM",
      "Friday: 11:00 AM – 7:30 PM",
      "Saturday: 11:00 AM – 7:30 PM",
      "Sunday: 11:00 AM – 7:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "id": 1378,
    "district": "Wan Chai"
  },
  {
    "title": "Pure TCG",
    "urlinform": "pure-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzyEG3aYBBDQR7uwvu3_BCGk",
    "lat": 22.3102003,
    "lng": 114.2234929,
    "placeId": "ChIJzyEG3aYBBDQR7uwvu3_BCGk",
    "businessStatus": "OPERATIONAL",
    "phone": "6511 4691",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 316,
    "id": 1379,
    "district": "Kwun Tong"
  },
  {
    "title": "Brothers Card Kingdom",
    "urlinform": "brothers-card-kingdom",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.carousell.com.hk/u/brothers_cardkingdom/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx3VMMLoBBDQRKo6NWGOcRdw",
    "lat": 22.3106862,
    "lng": 114.2240038,
    "placeId": "ChIJx3VMMLoBBDQRKo6NWGOcRdw",
    "businessStatus": "OPERATIONAL",
    "phone": "5299 9536",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 156,
    "id": 1380,
    "district": "Kwun Tong"
  },
  {
    "title": "Cardzoku Limited",
    "urlinform": "cardzoku-limited",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://cardzoku.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ962yhDQBBDQRR8RXWowA8Bg",
    "lat": 22.3125643,
    "lng": 114.2241582,
    "placeId": "ChIJ962yhDQBBDQRR8RXWowA8Bg",
    "businessStatus": "OPERATIONAL",
    "phone": "5117 3610",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 3:00 – 9:00 PM",
      "Sunday: Closed"
    ],
    "rating": 3.4,
    "userRatingsTotal": 10,
    "id": 1381,
    "district": "Kwun Tong"
  },
  {
    "title": "Rocket Collectables",
    "urlinform": "rocket-collectables",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://rocketcoll.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPQiMXoUBBDQR5ARbKy70VE8",
    "lat": 22.310794,
    "lng": 114.2247003,
    "placeId": "ChIJPQiMXoUBBDQR5ARbKy70VE8",
    "businessStatus": "OPERATIONAL",
    "phone": "9031 2481",
    "openingHours": [],
    "rating": 4.9,
    "userRatingsTotal": 64,
    "id": 1382,
    "district": "Kwun Tong"
  },
  {
    "title": "POKECARD_GOLD",
    "urlinform": "pokecard_gold",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/pokecard_gold/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1wcwdxcBBDQR7aJQP0YmBDk",
    "lat": 22.3107275,
    "lng": 114.2253969,
    "placeId": "ChIJ1wcwdxcBBDQR7aJQP0YmBDk",
    "businessStatus": "OPERATIONAL",
    "phone": "9480 7163",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 11:30 AM – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 11,
    "id": 1383,
    "district": "Kwun Tong"
  },
  {
    "title": "Turbo TCG",
    "urlinform": "turbo-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbbMP-4sBBDQRiLF0Xbf1f0I",
    "lat": 22.3097582,
    "lng": 114.2273938,
    "placeId": "ChIJbbMP-4sBBDQRiLF0Xbf1f0I",
    "businessStatus": "OPERATIONAL",
    "phone": "5618 1242",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:30 – 10:30 PM",
      "Wednesday: 2:30 – 10:30 PM",
      "Thursday: 2:30 – 10:30 PM",
      "Friday: 2:30 – 10:30 PM",
      "Saturday: 2:30 – 7:30 PM",
      "Sunday: 2:30 – 7:30 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 3,
    "id": 1384,
    "district": "Kwun Tong"
  },
  {
    "title": "Card Legacy",
    "urlinform": "card-legacy",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJI5zDEwABBDQRo9AqcyGmqvQ",
    "lat": 22.3102003,
    "lng": 114.2234929,
    "placeId": "ChIJI5zDEwABBDQRo9AqcyGmqvQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 4,
    "id": 1385,
    "district": "Kwun Tong"
  },
  {
    "title": "Top Draw HK",
    "urlinform": "top-draw-hk",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.topdraw.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4zSZITUBBDQRuKnc7o8sVAI",
    "lat": 22.3115975,
    "lng": 114.2265115,
    "placeId": "ChIJ4zSZITUBBDQRuKnc7o8sVAI",
    "businessStatus": "OPERATIONAL",
    "phone": "6572 3153",
    "openingHours": [
      "Monday: 1:00 PM – 12:00 AM",
      "Tuesday: 1:00 PM – 12:00 AM",
      "Wednesday: 1:00 PM – 12:00 AM",
      "Thursday: 1:00 PM – 12:00 AM",
      "Friday: 1:00 PM – 12:00 AM",
      "Saturday: 1:00 PM – 12:00 AM",
      "Sunday: 1:00 PM – 12:00 AM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 11,
    "id": 1386,
    "district": "Kwun Tong"
  },
  {
    "title": "Yamacardo 嵐山卡店",
    "urlinform": "yamacardo-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.yamacardo.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUUF0_nMBBDQR5gq7x8fmiIc",
    "lat": 22.3095383,
    "lng": 114.2240966,
    "placeId": "ChIJUUF0_nMBBDQR5gq7x8fmiIc",
    "businessStatus": "OPERATIONAL",
    "phone": "6551 3120",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.3,
    "userRatingsTotal": 12,
    "id": 1387,
    "district": "Kwun Tong"
  },
  {
    "title": "Trading Card Man",
    "urlinform": "trading-card-man",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.tradingcardman.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJM-UhpnwBBDQRXJxJvb77VbY",
    "lat": 22.3095471,
    "lng": 114.2252452,
    "placeId": "ChIJM-UhpnwBBDQRXJxJvb77VbY",
    "businessStatus": "OPERATIONAL",
    "phone": "9168 4203",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 9,
    "id": 1388,
    "district": "Kwun Tong"
  },
  {
    "title": "CardKoi 卡酷愛玩具",
    "urlinform": "cardkoi-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6YW3-s8BBDQRLiYDqWfTQ1o",
    "lat": 22.3115856,
    "lng": 114.2202422,
    "placeId": "ChIJ6YW3-s8BBDQRLiYDqWfTQ1o",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 6:30 – 11:00 PM",
      "Tuesday: 3:00 PM – 12:00 AM",
      "Wednesday: 3:00 PM – 12:00 AM",
      "Thursday: Closed",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 2:00 PM – 12:00 AM",
      "Sunday: 2:00 PM – 12:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 6,
    "id": 1389,
    "district": "Kwun Tong"
  },
  {
    "title": "有得Lam",
    "urlinform": "lam",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUX2g0FQBBDQR0NYXJ-PlggE",
    "lat": 22.3111987,
    "lng": 114.2260006,
    "placeId": "ChIJUX2g0FQBBDQR0NYXJ-PlggE",
    "businessStatus": "OPERATIONAL",
    "phone": "9829 0311",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.3,
    "userRatingsTotal": 18,
    "id": 1390,
    "district": "Kwun Tong"
  },
  {
    "title": "Ark Black Cat",
    "urlinform": "ark-black-cat",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://arkblackcat.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJA4SPto4BBDQRtt6GsREeNMU",
    "lat": 22.3104909,
    "lng": 114.2279975,
    "placeId": "ChIJA4SPto4BBDQRtt6GsREeNMU",
    "businessStatus": "OPERATIONAL",
    "phone": "9150 6088",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 15,
    "id": 1391,
    "district": "Kwun Tong"
  },
  {
    "title": "Grass Type TCG 草系道館",
    "urlinform": "grass-type-tcg-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://grasstypetcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsbk9rAoBBDQRdjX4dDpiwvw",
    "lat": 22.3132677,
    "lng": 114.2222855,
    "placeId": "ChIJsbk9rAoBBDQRdjX4dDpiwvw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1392,
    "district": "Kwun Tong"
  },
  {
    "title": "Capstone Board Game Superstore",
    "urlinform": "capstone-board-game-superstore",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQ7a9nBYBBDQRauV7uk4z6YE",
    "lat": 22.3104692,
    "lng": 114.2251591,
    "placeId": "ChIJQ7a9nBYBBDQRauV7uk4z6YE",
    "businessStatus": "OPERATIONAL",
    "phone": "3705 8670",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 14,
    "id": 1393,
    "district": "Kwun Tong"
  },
  {
    "title": "One Draw Trading Card Game Store",
    "urlinform": "one-draw-trading-card-game-store",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSzRiOo4BBDQR_ZKgR_nSza8",
    "lat": 22.3102003,
    "lng": 114.2234929,
    "placeId": "ChIJSzRiOo4BBDQR_ZKgR_nSza8",
    "businessStatus": "OPERATIONAL",
    "phone": "9080 4987",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1394,
    "district": "Kwun Tong"
  },
  {
    "title": "賣卡佬 My Card Low 卡牌店",
    "urlinform": "-my-card-low-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.mycardlow.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRTAgAdQBBDQRVUBm7gVnn04",
    "lat": 22.3104591,
    "lng": 114.2251647,
    "placeId": "ChIJRTAgAdQBBDQRVUBm7gVnn04",
    "businessStatus": "OPERATIONAL",
    "phone": "9785 7049",
    "openingHours": [
      "Monday: 6:00 – 8:30 PM",
      "Tuesday: 6:00 – 8:30 PM",
      "Wednesday: 6:00 – 8:30 PM",
      "Thursday: 6:00 – 8:30 PM",
      "Friday: 6:00 – 8:30 PM",
      "Saturday: 2:00 – 7:00 PM",
      "Sunday: 2:00 – 7:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1395,
    "district": "Kwun Tong"
  },
  {
    "title": "DMZ",
    "urlinform": "dmz",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://playatdmz.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4ckV6F0BBDQRaSYX2t_P2uo",
    "lat": 22.3153949,
    "lng": 114.2169934,
    "placeId": "ChIJ4ckV6F0BBDQRaSYX2t_P2uo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 100,
    "id": 1396,
    "district": "Kwun Tong"
  },
  {
    "title": "MS TCG Store",
    "urlinform": "ms-tcg-store",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Flesh and Blood",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "https://www.mstcgstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt8AdTxf5AzQRMwzdN5AHOqY",
    "lat": 22.3579649,
    "lng": 114.1308732,
    "placeId": "ChIJt8AdTxf5AzQRMwzdN5AHOqY",
    "businessStatus": "OPERATIONAL",
    "phone": "9541 8445",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 36,
    "id": 1397
  },
  {
    "title": "半日閒卡牌桌遊模型中心",
    "urlinform": "store-133",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/AfterFiveGameStore",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyzp0UW4BBDQRzsJ8ibhItjQ",
    "lat": 22.3146091,
    "lng": 114.2193134,
    "placeId": "ChIJyzp0UW4BBDQRzsJ8ibhItjQ",
    "businessStatus": "OPERATIONAL",
    "phone": "9456 6722",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 5:00 – 9:00 PM",
      "Thursday: 5:00 – 9:00 PM",
      "Friday: 5:00 – 9:00 PM",
      "Saturday: 2:00 – 6:00 PM",
      "Sunday: 2:00 – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "id": 1398,
    "district": "Kwun Tong"
  },
  {
    "title": "Sherlock board games store",
    "urlinform": "-80",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/SherlockBoardGamestore",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh01Wac-rQjQR9XkF1KVciQM",
    "lat": 25.0388171,
    "lng": 121.5523857,
    "placeId": "ChIJh01Wac-rQjQR9XkF1KVciQM",
    "businessStatus": "OPERATIONAL",
    "phone": "02 8771 5911",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 PM – 4:00 AM",
      "Saturday: 1:00 PM – 4:00 AM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1290,
    "id": 1399
  },
  {
    "title": "Sunny Board Games",
    "urlinform": "-ptcg",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/sunnyboardgame/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrSaMFcGrQjQRDXkM-JecNDk",
    "lat": 25.0452493,
    "lng": 121.5564892,
    "placeId": "ChIJrSaMFcGrQjQRDXkM-JecNDk",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2577 8165",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 867,
    "id": 1400
  },
  {
    "title": "YOYOGI Land 代代木樂園 ｜桌遊空間｜場地租借｜販售教學「原遊戲平方-市府店」",
    "urlinform": "yoyogi-land-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5Ybf-LurQjQRqJ_cVVDvuEo",
    "lat": 25.0406713,
    "lng": 121.5545931,
    "placeId": "ChIJ5Ybf-LurQjQRqJ_cVVDvuEo",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2765 5659",
    "openingHours": [
      "Monday: 2:00 PM – 12:00 AM",
      "Tuesday: 2:00 PM – 12:00 AM",
      "Wednesday: 2:00 PM – 12:00 AM",
      "Thursday: 2:00 PM – 12:00 AM",
      "Friday: 2:00 PM – 2:00 AM",
      "Saturday: 12:00 PM – 2:00 AM",
      "Sunday: 12:00 PM – 12:00 AM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 517,
    "id": 1401
  },
  {
    "title": "founding player 房頂上饗玩俱樂部×師大桌遊×投影Switch",
    "urlinform": "founding-player-switch",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Founding-player-%E6%88%BF%E9%A0%82%E4%B8%8A%E9%A5%97%E7%8E%A9%E4%BF%B1%E6%A8%82%E9%83%A8%E5%B8%AB%E5%A4%A7%E6%A1%8C%E9%81%8A%E6%8A%95%E5%BD%B1Switch%E9%A3%9B%E9%8F%A2-105921584178307/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJA5W6dSmpQjQRuMFjOL7gUOU",
    "lat": 25.0221673,
    "lng": 121.5293188,
    "placeId": "ChIJA5W6dSmpQjQRuMFjOL7gUOU",
    "businessStatus": "OPERATIONAL",
    "phone": "0982 020 714",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 11:30 AM – 10:00 PM",
      "Sunday: 11:30 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 37,
    "id": 1402
  },
  {
    "title": "Hala Planet Ximen",
    "urlinform": "store-79",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZZic5FipQjQRy4D8f6FzefM",
    "lat": 25.0439389,
    "lng": 121.508028,
    "placeId": "ChIJZZic5FipQjQRy4D8f6FzefM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4,
    "userRatingsTotal": 138,
    "id": 1403,
    "district": "Ximending"
  },
  {
    "title": "WillMusic 微樂客 (台北西門町門市)",
    "urlinform": "willmusic-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.willmusic.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEz6XZZOpQjQR4DIt9dXRbmA",
    "lat": 25.0444748,
    "lng": 121.505538,
    "placeId": "ChIJEz6XZZOpQjQR4DIt9dXRbmA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 64,
    "id": 1404,
    "district": "Ximending"
  },
  {
    "title": "模卡玩具",
    "urlinform": "store-97",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwa9rVDE9aTQRmDF1vzRr9uM",
    "lat": 24.1538659,
    "lng": 120.6877578,
    "placeId": "ChIJwa9rVDE9aTQRmDF1vzRr9uM",
    "businessStatus": "OPERATIONAL",
    "phone": "0918 063 291",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 12:05 – 10:00 PM",
      "Sunday: 12:05 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 92,
    "id": 1405,
    "district": "Taichung Yizhong"
  },
  {
    "title": "飛鷹桌遊｜桌遊現場玩/販售/租借｜適合人數多的聚會｜空間寬敞｜免費教學｜收文化幣｜電話或IG訂位｜可帶外食叫外送｜原 瘋桌松山店",
    "urlinform": "ig-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://rink.cc/x28xu",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqVymxM-rQjQRlLeLmeGLuDo",
    "lat": 25.0468045,
    "lng": 121.5508256,
    "placeId": "ChIJqVymxM-rQjQRlLeLmeGLuDo",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2579 8608",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1301,
    "id": 1406
  },
  {
    "title": "假面騎士玩具店",
    "urlinform": "store-108",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/maskedrider1",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh-a0XhOpQjQRqgd5WU488gg",
    "lat": 25.0541481,
    "lng": 121.5131085,
    "placeId": "ChIJh-a0XhOpQjQRqgd5WU488gg",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2556 3786",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 194,
    "id": 1407,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "明琦卡店",
    "urlinform": "store-120",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/p/%E6%98%8E%E7%90%A6%E5%8D%A1%E5%BA%97-100054628592522",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYddoYjipQjQRzZK4W4FEia8",
    "lat": 25.0676207,
    "lng": 121.5132068,
    "placeId": "ChIJYddoYjipQjQRzZK4W4FEia8",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2585 0665",
    "openingHours": [
      "Monday: 10:00 AM – 10:30 PM",
      "Tuesday: 10:00 AM – 10:30 PM",
      "Wednesday: 10:00 AM – 10:30 PM",
      "Thursday: 10:00 AM – 10:30 PM",
      "Friday: 10:00 AM – 10:30 PM",
      "Saturday: 10:00 AM – 10:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.2,
    "userRatingsTotal": 73,
    "id": 1408
  },
  {
    "title": "陽光桌遊卡鋪-寶可夢專賣(已轉移營業地址至光復南路66巷28號哦)",
    "urlinform": "-6628",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ruten.com.tw/user/index00.php?s=sunny22ya",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzVHyUbmrQjQR9_qRYlMzj-s",
    "lat": 25.0452635,
    "lng": 121.5564678,
    "placeId": "ChIJzVHyUbmrQjQR9_qRYlMzj-s",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2577 8165",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 51,
    "id": 1409
  },
  {
    "title": "一週七日桌遊/台中桌遊",
    "urlinform": "1000",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/1w7d.boardgame",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJlUF_kz49aTQRabq0BWIFwyU",
    "lat": 24.1455071,
    "lng": 120.6891624,
    "placeId": "ChIJlUF_kz49aTQRabq0BWIFwyU",
    "businessStatus": "OPERATIONAL",
    "phone": "0986 504 389",
    "openingHours": [
      "Monday: 1:00 PM – 12:00 AM",
      "Tuesday: 1:00 PM – 12:00 AM",
      "Wednesday: 1:00 PM – 12:00 AM",
      "Thursday: 1:00 PM – 12:00 AM",
      "Friday: 1:00 PM – 12:00 AM",
      "Saturday: 1:00 PM – 12:00 AM",
      "Sunday: 1:00 PM – 12:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 217,
    "id": 1410,
    "district": "Taichung Yizhong"
  },
  {
    "title": "光華卡POOL! sport card",
    "urlinform": "pool-sport-card",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lit.link/zh-tw/poolsportcard",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJncTaGEWpQjQRgML2LEAjgX0",
    "lat": 25.0451499,
    "lng": 121.5319628,
    "placeId": "ChIJncTaGEWpQjQRgML2LEAjgX0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:30 – 9:00 PM",
      "Tuesday: 12:30 – 6:00 PM",
      "Wednesday: 12:30 – 9:00 PM",
      "Thursday: 12:30 – 9:00 PM",
      "Friday: 12:30 – 9:00 PM",
      "Saturday: 11:30 AM – 9:00 PM",
      "Sunday: 11:30 AM – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 29,
    "id": 1411
  },
  {
    "title": "第一家球員卡店",
    "urlinform": "store-141",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/pages/%E7%AC%AC%E4%B8%80%E5%AE%B6%E7%90%83%E5%93%A1%E5%8D%A1%E5%BA%97/247364755277047",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLU9qrmepQjQRMTzi2EXFfak",
    "lat": 25.0539121,
    "lng": 121.5278256,
    "placeId": "ChIJLU9qrmepQjQRMTzi2EXFfak",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2536 2332",
    "openingHours": [
      "Monday: 2:30 – 8:00 PM",
      "Tuesday: 2:30 – 8:00 PM",
      "Wednesday: 2:30 – 7:30 PM",
      "Thursday: 2:30 – 7:30 PM",
      "Friday: 2:30 – 8:00 PM",
      "Saturday: 2:30 – 6:30 PM",
      "Sunday: Closed"
    ],
    "rating": 3.8,
    "userRatingsTotal": 122,
    "id": 1412,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "卡之洞 Cards Cave 卡牌遊戲專賣店",
    "urlinform": "-cards-cave-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/cardscave/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRaZ9HBupQjQRiJXj7gSIwBM",
    "lat": 25.0330342,
    "lng": 121.444379,
    "placeId": "ChIJRaZ9HBupQjQRiJXj7gSIwBM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 189,
    "id": 1413
  },
  {
    "title": "拼圖總動員（西門複合店）",
    "urlinform": "store-143",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/puzzlestory",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJy_wlrmepQjQR0rgFEnreFqw",
    "lat": 25.0438835,
    "lng": 121.5088046,
    "placeId": "ChIJy_wlrmepQjQR0rgFEnreFqw",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2312 0020",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1414,
    "district": "Ximending"
  },
  {
    "title": "美有辦法 西門線下店 (DIY可用文化幣)",
    "urlinform": "-diy",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/how_to_get_pretty?igsh=aWQ4MDUzcm42NmRu&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJz51T3nqpQjQRQmwrFYCXrb8",
    "lat": 25.0439604,
    "lng": 121.5090764,
    "placeId": "ChIJz51T3nqpQjQRQmwrFYCXrb8",
    "businessStatus": "OPERATIONAL",
    "phone": "0921 086 639",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 153,
    "id": 1415,
    "district": "Ximending"
  },
  {
    "title": "JACK球卡專賣店",
    "urlinform": "jack",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Jack%E7%90%83%E5%8D%A1%E5%B0%88%E8%B3%A3%E5%BA%97-224928827670861/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBcC6vOGrQjQRT_Is7IGE5Js",
    "lat": 25.057185,
    "lng": 121.5390417,
    "placeId": "ChIJBcC6vOGrQjQRT_Is7IGE5Js",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2506 7330",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 135,
    "id": 1416
  },
  {
    "title": "桌上旅程 APP STORE",
    "urlinform": "-app-store",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/App-Store-%E9%81%8A%E6%88%B2%E7%8E%8B-%E5%8D%A1%E7%89%87-%E4%BA%A4%E6%98%93-%E4%BA%A4%E6%8F%9B-%E7%A0%94%E7%A9%B6-%E9%9C%B2%E5%A4%A9-2000951946856257",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8aVyD8apQjQRSZeqTpv5b2E",
    "lat": 25.0609217,
    "lng": 121.5281113,
    "placeId": "ChIJ8aVyD8apQjQRSZeqTpv5b2E",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 10:30 PM",
      "Tuesday: 2:00 – 10:30 PM",
      "Wednesday: 2:00 – 10:30 PM",
      "Thursday: 2:00 – 10:30 PM",
      "Friday: 2:00 – 10:30 PM",
      "Saturday: 12:00 – 10:30 PM",
      "Sunday: 12:00 – 10:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 399,
    "id": 1417
  },
  {
    "title": "貳家桌遊中山條通店",
    "urlinform": "store-148",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.oursecondhome12.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJS3kYJ4apQjQRWcWAQAN_RXE",
    "lat": 25.0508276,
    "lng": 121.5236758,
    "placeId": "ChIJS3kYJ4apQjQRWcWAQAN_RXE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 63,
    "id": 1418,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "桌友之地：中山店（中山桌遊店/24小時服務/桌遊玩樂/租借桌遊/親親貓咪）*文化幣適用",
    "urlinform": "24",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/FriendinBGClub",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx6shw1SpQjQRcaFZGnEy8Ok",
    "lat": 25.0602125,
    "lng": 121.5258895,
    "placeId": "ChIJx6shw1SpQjQRcaFZGnEy8Ok",
    "businessStatus": "OPERATIONAL",
    "phone": "0921 608 262",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1058,
    "id": 1419,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "漫遊雀海24h自助桌遊館-麻將館",
    "urlinform": "24h-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.manyoumahjong.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJr6jDLympQjQRSV6plWKO3_c",
    "lat": 25.0597947,
    "lng": 121.5250492,
    "placeId": "ChIJr6jDLympQjQRSV6plWKO3_c",
    "businessStatus": "OPERATIONAL",
    "phone": "0975 005 119",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 221,
    "id": 1420,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "ONE桌遊台北林森北店",
    "urlinform": "one",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0w5em2mpQjQR5ZMiJUMvYSA",
    "lat": 25.0569452,
    "lng": 121.5253644,
    "placeId": "ChIJ0w5em2mpQjQR5ZMiJUMvYSA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 15,
    "id": 1421,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "Bindo冰逗桌遊空間/三隻店貓/友善教學/入場須滿12歲",
    "urlinform": "bindo12",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://bindogames.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ75T6N1WpQjQRF82ssFGbXOI",
    "lat": 25.0517082,
    "lng": 121.5230277,
    "placeId": "ChIJ75T6N1WpQjQRF82ssFGbXOI",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2568 1051",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: Closed",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 184,
    "id": 1422,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "【玩樂基地】桌遊及TCG專門店",
    "urlinform": "tcg",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/GoKidsBase",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJlSjSoPWpQjQR6Lc6w66bsoI",
    "lat": 25.0671369,
    "lng": 121.526943,
    "placeId": "ChIJlSjSoPWpQjQR6Lc6w66bsoI",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2592 8128",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 220,
    "id": 1423
  },
  {
    "title": "Baker Street board game store",
    "urlinform": "store-154",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://bgstreet.simplybook.asia/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTaVDkEGpQjQR0GW-pkXZ_v8",
    "lat": 25.060128,
    "lng": 121.51903,
    "placeId": "ChIJTaVDkEGpQjQR0GW-pkXZ_v8",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2552 9059",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 11:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 1104,
    "id": 1424,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "One桌遊 台北復興北路店-中山麻將會館|棋牌會館|麻將館首選|桌遊店推薦|棋牌休閒館|熱門麻將館|電動麻將館|休閒棋牌社",
    "urlinform": "one-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://line.me/R/ti/p/@049iwnqg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9cJ3YFOrQjQRNPMl4UJRhBo",
    "lat": 25.065018,
    "lng": 121.543891,
    "placeId": "ChIJ9cJ3YFOrQjQRNPMl4UJRhBo",
    "businessStatus": "OPERATIONAL",
    "phone": "0900 730 662",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3.9,
    "userRatingsTotal": 11,
    "id": 1425
  },
  {
    "title": "一起咪吉桌遊館-24hr過山車麻將館",
    "urlinform": "store-156",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/ichi_migi?igsh=bGZ2MzN5a2F4ZXJl&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ39QjZCKpQjQRt5Sasn2Cq5Y",
    "lat": 25.0489423,
    "lng": 121.5294883,
    "placeId": "ChIJ39QjZCKpQjQRt5Sasn2Cq5Y",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2511 0856",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.6,
    "userRatingsTotal": 40,
    "id": 1426,
    "district": "Taipei Zhongshan Zhongzheng"
  },
  {
    "title": "普雷伊台中一中門市(寶可夢MEZASTAR機台營運中)",
    "urlinform": "mezastar",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Tztvgame",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWaWtZik9aTQROu8NB-8bKO4",
    "lat": 24.1480208,
    "lng": 120.6837932,
    "placeId": "ChIJWaWtZik9aTQROu8NB-8bKO4",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2229 0766",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 535,
    "id": 1427,
    "district": "Taichung Yizhong"
  },
  {
    "title": "魔都玩具",
    "urlinform": "store-158",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/md15toys/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjSlKMgA9aTQRqkFaBJp-w4Y",
    "lat": 24.1493425,
    "lng": 120.6852026,
    "placeId": "ChIJjSlKMgA9aTQRqkFaBJp-w4Y",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 123,
    "id": 1428,
    "district": "Taichung Yizhong"
  },
  {
    "title": "木棉花樂園-台中一中街門市",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.e-muse.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMWcV8ZE9aTQRGumMMutzbW4",
    "lat": 24.1493425,
    "lng": 120.6852026,
    "placeId": "ChIJMWcV8ZE9aTQRGumMMutzbW4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 212,
    "id": 1429,
    "district": "Taichung Yizhong"
  },
  {
    "title": "木棉花樂園-台北地下街門市",
    "urlinform": "store-161",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://mall.e-muse.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB97tHACpQjQRndgsJL1nISc",
    "lat": 25.050151,
    "lng": 121.5113831,
    "placeId": "ChIJB97tHACpQjQRndgsJL1nISc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 AM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 652,
    "id": 1430,
    "district": "Taipei Station"
  },
  {
    "title": "Wonderful玩的夥 台中店",
    "urlinform": "wonderful-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Wonderful-%E7%8E%A9%E7%9A%84%E5%A4%A5-%E6%97%A5%E6%9C%AC%E5%93%81%E7%89%8C%E7%8E%A9%E5%85%B7%E5%B0%88%E8%B3%A3-%E5%8F%B0%E4%B8%AD%E5%BA%97-101536311501011/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJX8fbpAQ9aTQR40jjocrlASc",
    "lat": 24.1532551,
    "lng": 120.6861689,
    "placeId": "ChIJX8fbpAQ9aTQR40jjocrlASc",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2220 1899",
    "openingHours": [
      "Monday: 1:00 – 8:50 PM",
      "Tuesday: 1:00 – 8:50 PM",
      "Wednesday: 1:00 – 8:50 PM",
      "Thursday: 1:00 – 8:50 PM",
      "Friday: 1:00 – 9:50 PM",
      "Saturday: 1:00 – 9:50 PM",
      "Sunday: 1:00 – 8:50 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 194,
    "id": 1431,
    "district": "Taichung Yizhong"
  },
  {
    "title": "遊戲頻道",
    "urlinform": "store-164",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://tw.bid.yahoo.com/booth/y0851305779",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHTUFNbquQjQRNR9fJQTQC_o",
    "lat": 25.0911191,
    "lng": 121.5214287,
    "placeId": "ChIJHTUFNbquQjQRNR9fJQTQC_o",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2882 0978",
    "openingHours": [
      "Monday: 2:30 – 8:30 PM",
      "Tuesday: 2:30 – 8:30 PM",
      "Wednesday: 2:30 – 8:30 PM",
      "Thursday: 2:30 – 8:30 PM",
      "Friday: 2:30 – 8:30 PM",
      "Saturday: 2:30 – 8:30 PM",
      "Sunday: 2:30 – 6:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 207,
    "id": 1432
  },
  {
    "title": "Stepping Stone Bookstore",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Gundam"
    ],
    "storeWebsite": "http://www.steppingstone.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR5Y-L2k9aTQRx34Ck41s_WM",
    "lat": 24.1487558,
    "lng": 120.6838722,
    "placeId": "ChIJR5Y-L2k9aTQRx34Ck41s_WM",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2223 9838",
    "openingHours": [
      "Monday: 10:00 AM – 12:00 AM",
      "Tuesday: 10:00 AM – 12:00 AM",
      "Wednesday: 10:00 AM – 12:00 AM",
      "Thursday: 10:00 AM – 12:00 AM",
      "Friday: 10:00 AM – 12:00 AM",
      "Saturday: 10:00 AM – 12:00 AM",
      "Sunday: 10:00 AM – 12:00 AM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 6703,
    "id": 1433,
    "district": "Taichung Yizhong"
  },
  {
    "title": "摩力科娛樂股份有限公司",
    "urlinform": "store-166",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.magical.game.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPy9YWG2pQjQRWdsY9vmYmDo",
    "lat": 25.0487788,
    "lng": 121.5146313,
    "placeId": "ChIJPy9YWG2pQjQRWdsY9vmYmDo",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2559 7574",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 250,
    "id": 1434,
    "district": "Taipei Station"
  },
  {
    "title": "ONE桌遊 台中一中店|自助桌遊|24H|電動麻將|包廂出租「點網站查詢及訂位」",
    "urlinform": "one-24h",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://one.onegame.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJscgfmTY9aTQRMNcZ5mdviLQ",
    "lat": 24.153627,
    "lng": 120.685911,
    "placeId": "ChIJscgfmTY9aTQRMNcZ5mdviLQ",
    "businessStatus": "OPERATIONAL",
    "phone": "04 3701 2968",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.6,
    "userRatingsTotal": 68,
    "id": 1435,
    "district": "Taichung Yizhong"
  },
  {
    "title": "COCOS星球",
    "urlinform": "cocos",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://mall.shopee.tw/cocos",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF-5ztmc9aTQRYFEIbcPhRGQ",
    "lat": 24.1530068,
    "lng": 120.6866608,
    "placeId": "ChIJF-5ztmc9aTQRYFEIbcPhRGQ",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2225 9006",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 40,
    "id": 1436,
    "district": "Taichung Yizhong"
  },
  {
    "title": "MaMamiya一中店 - 一番賞/卡牌/盒玩/動漫周邊",
    "urlinform": "mamamiya-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/mamamiyaifan/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUxrD9LI9aTQR1X1dOHXxnJc",
    "lat": 24.1486636,
    "lng": 120.6855678,
    "placeId": "ChIJUxrD9LI9aTQR1X1dOHXxnJc",
    "businessStatus": "OPERATIONAL",
    "phone": "0979 126 215",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 309,
    "id": 1437,
    "district": "Taichung Yizhong"
  },
  {
    "title": "拼圖密室(台中店)",
    "urlinform": "store-171",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://secretchamber.shoplineapp.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJubCACWc9aTQRB-VmKzzWw_U",
    "lat": 24.1528363,
    "lng": 120.6862036,
    "placeId": "ChIJubCACWc9aTQRB-VmKzzWw_U",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2225 0883",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 381,
    "id": 1438,
    "district": "Taichung Yizhong"
  },
  {
    "title": "13Bra｜無鋼圈調整型內衣專賣",
    "urlinform": "13bra",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://13bra.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDf5v1MI9aTQR0RmtOKQ2BKY",
    "lat": 24.1531284,
    "lng": 120.6871712,
    "placeId": "ChIJDf5v1MI9aTQR0RmtOKQ2BKY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 10:30 PM",
      "Tuesday: 2:00 – 10:30 PM",
      "Wednesday: 2:00 – 10:30 PM",
      "Thursday: 2:00 – 10:30 PM",
      "Friday: 2:00 – 10:30 PM",
      "Saturday: 1:00 – 10:30 PM",
      "Sunday: 1:00 – 10:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1147,
    "id": 1439,
    "district": "Taichung Yizhong"
  },
  {
    "title": "Yizhong Street Night Market",
    "urlinform": "store-173",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJeZhxjmg9aTQRu4ClJlnbzHk",
    "lat": 24.1505158,
    "lng": 120.6855337,
    "placeId": "ChIJeZhxjmg9aTQRu4ClJlnbzHk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 49036,
    "id": 1440,
    "district": "Taichung Yizhong"
  },
  {
    "title": "雷諾瓦拼圖文化坊(台中一中店)",
    "urlinform": "store-174",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPWtgNWY9aTQRF1aSTPKxeNQ",
    "lat": 24.1525827,
    "lng": 120.6862532,
    "placeId": "ChIJPWtgNWY9aTQRF1aSTPKxeNQ",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2225 8077",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 105,
    "id": 1441,
    "district": "Taichung Yizhong"
  },
  {
    "title": "CASETiFY STUDiO Taichung Chungyo Store",
    "urlinform": "casetify-studio-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "https://www.casetify.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1zvkX5U9aTQR_Pny877aqHg",
    "lat": 24.1519494,
    "lng": 120.6846261,
    "placeId": "ChIJ1zvkX5U9aTQR_Pny877aqHg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 662,
    "id": 1442,
    "district": "Taichung Yizhong"
  },
  {
    "title": "I PLAZA愛廣場",
    "urlinform": "i-plaza",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://i-plaza.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyW1ZgFU9aTQRmU_Hbb1-1xI",
    "lat": 24.1493425,
    "lng": 120.6852026,
    "placeId": "ChIJyW1ZgFU9aTQRmU_Hbb1-1xI",
    "businessStatus": "OPERATIONAL",
    "phone": "0966 588 797",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 1010,
    "id": 1443,
    "district": "Taichung Yizhong"
  },
  {
    "title": "小時候彈珠堂-台中一中店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=100088268043754&mibextid=LQQJ4d",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsapwQsg9aTQRcpyqkOPYn24",
    "lat": 24.1487647,
    "lng": 120.6851406,
    "placeId": "ChIJsapwQsg9aTQRcpyqkOPYn24",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 PM – 12:00 AM",
      "Tuesday: 12:00 PM – 12:00 AM",
      "Wednesday: 12:00 PM – 12:00 AM",
      "Thursday: 12:00 PM – 12:00 AM",
      "Friday: 12:00 PM – 12:00 AM",
      "Saturday: 11:00 AM – 12:00 AM",
      "Sunday: 11:00 AM – 12:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 6897,
    "id": 1444,
    "district": "Taichung Yizhong"
  },
  {
    "title": "GUBAN Taichung",
    "urlinform": "guban-taichung",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://gubanstore.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXSK5gTQ9aTQRGx9AKJtwt3Q",
    "lat": 24.1505006,
    "lng": 120.6854268,
    "placeId": "ChIJXSK5gTQ9aTQRGx9AKJtwt3Q",
    "businessStatus": "OPERATIONAL",
    "phone": "0981 349 641",
    "openingHours": [
      "Monday: 2:00 – 10:30 PM",
      "Tuesday: 2:00 – 10:30 PM",
      "Wednesday: 2:00 – 10:30 PM",
      "Thursday: 2:00 – 10:30 PM",
      "Friday: 2:00 – 10:30 PM",
      "Saturday: 2:00 – 10:30 PM",
      "Sunday: 2:00 – 10:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 41,
    "id": 1445,
    "district": "Taichung Yizhong"
  },
  {
    "title": "皮小姐衣櫃-台中一中店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lovebyby.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgc3kaOg9aTQRwtSgIT47j2M",
    "lat": 24.15135,
    "lng": 120.6855788,
    "placeId": "ChIJgc3kaOg9aTQRwtSgIT47j2M",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2222 0017",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:30 PM",
      "Saturday: 1:00 – 10:30 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 812,
    "id": 1446,
    "district": "Taichung Yizhong"
  },
  {
    "title": "ROBINMAY台中概念店",
    "urlinform": "robinmay",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.robinmaybag.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFWsSetg9aTQRRuPl0FC7h-Y",
    "lat": 24.150383,
    "lng": 120.6854263,
    "placeId": "ChIJFWsSetg9aTQRRuPl0FC7h-Y",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 10:30 PM",
      "Tuesday: 1:00 – 10:30 PM",
      "Wednesday: 1:00 – 10:30 PM",
      "Thursday: 1:00 – 10:30 PM",
      "Friday: 1:00 – 10:30 PM",
      "Saturday: 12:30 – 10:30 PM",
      "Sunday: 12:30 – 10:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 4153,
    "id": 1447,
    "district": "Taichung Yizhong"
  },
  {
    "title": "Go分期-手機公社一中店",
    "urlinform": "go-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.go9533.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHx6Us5A9aTQR0_ff-g3AslA",
    "lat": 24.1520462,
    "lng": 120.6858029,
    "placeId": "ChIJHx6Us5A9aTQR0_ff-g3AslA",
    "businessStatus": "OPERATIONAL",
    "phone": "0968 551 012",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 717,
    "id": 1448,
    "district": "Taichung Yizhong"
  },
  {
    "title": "超Z星球景品一中旗艦店",
    "urlinform": "z",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4QPOBwc9aTQRFnGOPs8nLEU",
    "lat": 24.1474193,
    "lng": 120.6840475,
    "placeId": "ChIJ4QPOBwc9aTQRFnGOPs8nLEU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 1,
    "userRatingsTotal": 5,
    "id": 1449,
    "district": "Taichung Yizhong"
  },
  {
    "title": "吉兒龐克(台中一中店)",
    "urlinform": "store-189",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.jill-punk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiz2keC09aTQRqjqMSFRnhZk",
    "lat": 24.1502558,
    "lng": 120.6853726,
    "placeId": "ChIJiz2keC09aTQRqjqMSFRnhZk",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2229 7848",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 287,
    "id": 1450,
    "district": "Taichung Yizhong"
  },
  {
    "title": "vivo台中一中體驗店",
    "urlinform": "vivo",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/vivoYiZhong/?ref=page_internal",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLwdv7HE9aTQRm-AMJ1b0IrY",
    "lat": 24.1519763,
    "lng": 120.6851813,
    "placeId": "ChIJLwdv7HE9aTQRm-AMJ1b0IrY",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2225 0286",
    "openingHours": [
      "Monday: 12:00 – 8:30 PM",
      "Tuesday: 12:00 – 8:30 PM",
      "Wednesday: 12:00 – 8:30 PM",
      "Thursday: 12:00 – 8:30 PM",
      "Friday: 12:00 – 8:30 PM",
      "Saturday: 12:00 – 8:30 PM",
      "Sunday: 12:00 – 8:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 2468,
    "id": 1451,
    "district": "Taichung Yizhong"
  },
  {
    "title": "咪呀小姐Mrs. Mia 一中店 盲盒 盒玩 玩具 扭蛋 公仔 大娃",
    "urlinform": "mrs-mia-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/mrs.mia_toys/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqWl76CI9aTQRbMEaJbVoIc0",
    "lat": 24.1464633,
    "lng": 120.68355,
    "placeId": "ChIJqWl76CI9aTQRbMEaJbVoIc0",
    "businessStatus": "OPERATIONAL",
    "phone": "0961 567 837",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 342,
    "id": 1452,
    "district": "Taichung Yizhong"
  },
  {
    "title": "玩物暴走 模型玩具店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR7Ff6589aTQRlfzjUvzpw8M",
    "lat": 24.1532517,
    "lng": 120.6862522,
    "placeId": "ChIJR7Ff6589aTQRlfzjUvzpw8M",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 25,
    "id": 1453,
    "district": "Taichung Yizhong"
  },
  {
    "title": "欣奇玩具行",
    "urlinform": "store-193",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61558048803805",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaaSQJGs9aTQRq6IakwA6zKw",
    "lat": 24.1416346,
    "lng": 120.6855951,
    "placeId": "ChIJaaSQJGs9aTQRq6IakwA6zKw",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2224 2004",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 433,
    "id": 1454,
    "district": "Taichung Yizhong"
  },
  {
    "title": "崩潰潮玩Collapse Toys- 台中三民店",
    "urlinform": "collapse-toys-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/54gachagirl/?locale=zh_TW",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJD7LWu489aTQREnRW6d0gWU4",
    "lat": 24.1489858,
    "lng": 120.6839161,
    "placeId": "ChIJD7LWu489aTQREnRW6d0gWU4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:30 – 10:30 PM",
      "Tuesday: 1:30 – 10:30 PM",
      "Wednesday: 1:30 – 10:30 PM",
      "Thursday: 1:30 – 10:30 PM",
      "Friday: 1:30 – 10:30 PM",
      "Saturday: 1:30 – 11:00 PM",
      "Sunday: 1:30 – 10:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 347,
    "id": 1455,
    "district": "Taichung Yizhong"
  },
  {
    "title": "台中后里躲貓貓桌遊店",
    "urlinform": "store-196",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/finding.kittens.bg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG8gPZsgbaTQRz-VGL1x7GvI",
    "lat": 24.3087677,
    "lng": 120.722596,
    "placeId": "ChIJG8gPZsgbaTQRz-VGL1x7GvI",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2558 8065",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 73,
    "id": 1456
  },
  {
    "title": "東牆補西牆Toys (一中旗艦店) 玩具店 —｜盒玩｜盲盒｜扭蛋｜卡牌｜一番賞｜格子鋪｜動漫周邊｜庫柏力克熊｜POP MART｜GK｜",
    "urlinform": "toys-pop-martgk",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYdzVvkI9aTQRe1ULm0SAvXI",
    "lat": 24.1498112,
    "lng": 120.6845496,
    "placeId": "ChIJYdzVvkI9aTQRe1ULm0SAvXI",
    "businessStatus": "OPERATIONAL",
    "phone": "0960 924 957",
    "openingHours": [
      "Monday: 1:30 – 10:30 PM",
      "Tuesday: 1:30 – 10:30 PM",
      "Wednesday: 1:30 – 10:30 PM",
      "Thursday: 1:30 – 10:30 PM",
      "Friday: 1:30 – 10:30 PM",
      "Saturday: 1:00 – 10:30 PM",
      "Sunday: 1:00 – 10:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 165,
    "id": 1457,
    "district": "Taichung Yizhong"
  },
  {
    "title": "JJ自助桌遊(一中店）24H電動麻將",
    "urlinform": "jj24h",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuT8tAAE9aTQRJxSz_xrc1aA",
    "lat": 24.1526032,
    "lng": 120.6862922,
    "placeId": "ChIJuT8tAAE9aTQRJxSz_xrc1aA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3.1,
    "userRatingsTotal": 34,
    "id": 1458,
    "district": "Taichung Yizhong"
  },
  {
    "title": "《記住周遊》自助桌遊｜ 派對聚會空間｜24H (線上預約)",
    "urlinform": "-24h-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lin.ee/x1kAlqg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIzXXVEI9aTQREDhzh8ljhso",
    "lat": 24.1534566,
    "lng": 120.686889,
    "placeId": "ChIJIzXXVEI9aTQREDhzh8ljhso",
    "businessStatus": "OPERATIONAL",
    "phone": "0966 938 592",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 13,
    "id": 1459,
    "district": "Taichung Yizhong"
  },
  {
    "title": "Happy Mode",
    "urlinform": "happy-mode",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.happymodee.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSVqiTCo9aTQRIKkDuLqJgXw",
    "lat": 24.147631,
    "lng": 120.6842673,
    "placeId": "ChIJSVqiTCo9aTQRIKkDuLqJgXw",
    "businessStatus": "OPERATIONAL",
    "phone": "0930 556 875",
    "openingHours": [],
    "rating": 4.6,
    "userRatingsTotal": 277,
    "id": 1460,
    "district": "Taichung Yizhong"
  },
  {
    "title": "摸很大 MOHENDA桌遊休閒館",
    "urlinform": "-mohenda",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFefhQGk9aTQRF2bHwV0LRPs",
    "lat": 24.1474951,
    "lng": 120.6845166,
    "placeId": "ChIJFefhQGk9aTQRF2bHwV0LRPs",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2225 7102",
    "openingHours": [
      "Monday: 1:00 PM – 5:00 AM",
      "Tuesday: 1:00 PM – 5:00 AM",
      "Wednesday: 1:00 PM – 5:00 AM",
      "Thursday: 1:00 PM – 5:00 AM",
      "Friday: 1:00 PM – 5:00 AM",
      "Saturday: 1:00 PM – 5:00 AM",
      "Sunday: 1:00 PM – 5:00 AM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 85,
    "id": 1461,
    "district": "Taichung Yizhong"
  },
  {
    "title": "Pokémon Play Lab Game休閒館 高雄店",
    "urlinform": "pokmon-play-lab-game-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXzg3ZDoFbjQRoTfujNEomEY",
    "lat": 22.6377822,
    "lng": 120.3082628,
    "placeId": "ChIJXzg3ZDoFbjQRoTfujNEomEY",
    "businessStatus": "OPERATIONAL",
    "phone": "07 236 8777",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 6,
    "id": 1462,
    "district": "Kaohsiung Sanmin Station"
  },
  {
    "title": "高雄驛一番街 墨凡捷運高雄車站商場",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.mofan.co.com/mall-detail/KHHC2023/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd-o7jJ4FbjQR5fye6lXCU4Y",
    "lat": 22.6394351,
    "lng": 120.3027697,
    "placeId": "ChIJd-o7jJ4FbjQR5fye6lXCU4Y",
    "businessStatus": "OPERATIONAL",
    "phone": "07 235 1536",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 337,
    "id": 1463,
    "district": "Kaohsiung Sanmin Station"
  },
  {
    "title": "碰碰鳥卡牌Pokémon球員卡PSA鑑定-前金店（高雄親子旅遊）",
    "urlinform": "pokmonpsa-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.facebook.com/pongpongbird/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiZhLJXQPbjQR6akmWyQOE68",
    "lat": 22.6294103,
    "lng": 120.2966878,
    "placeId": "ChIJiZhLJXQPbjQR6akmWyQOE68",
    "businessStatus": "OPERATIONAL",
    "phone": "0919 133 521",
    "openingHours": [
      "Monday: 5:30 – 9:30 PM",
      "Tuesday: Closed",
      "Wednesday: 7:00 – 10:00 PM",
      "Thursday: 7:00 – 10:00 PM",
      "Friday: 5:30 – 9:30 PM",
      "Saturday: 3:00 – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 185,
    "id": 1464
  },
  {
    "title": "ONE桌遊x高雄三民館-三民麻將會館|棋牌會館|麻將館首選|桌遊店推薦|電動麻將館|休閒棋牌社|棋牌休閒館|熱門麻將館",
    "urlinform": "onex-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lin.ee/1Cpwk5l",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsUnJM7QFbjQRWyxsNTjyvaw",
    "lat": 22.651918,
    "lng": 120.317671,
    "placeId": "ChIJsUnJM7QFbjQRWyxsNTjyvaw",
    "businessStatus": "OPERATIONAL",
    "phone": "0986 995 673",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.5,
    "userRatingsTotal": 32,
    "id": 1465
  },
  {
    "title": "遊戲本舖",
    "urlinform": "store-210",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.yoshihonpo.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVyW5l3UFbjQRTKTP_r4D5Jo",
    "lat": 22.63709,
    "lng": 120.312831,
    "placeId": "ChIJVyW5l3UFbjQRTKTP_r4D5Jo",
    "businessStatus": "OPERATIONAL",
    "phone": "07 236 0506",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 7,
    "id": 1466,
    "district": "Kaohsiung Sanmin Station"
  },
  {
    "title": "GAME休閒館高雄旗艦店",
    "urlinform": "game",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.game4fun.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJu-TB3PIEbjQRc-08KTw6zOc",
    "lat": 22.6377822,
    "lng": 120.3082628,
    "placeId": "ChIJu-TB3PIEbjQRc-08KTw6zOc",
    "businessStatus": "OPERATIONAL",
    "phone": "07 236 8777",
    "openingHours": [
      "Monday: 12:30 – 9:30 PM",
      "Tuesday: 12:30 – 9:30 PM",
      "Wednesday: 12:30 – 9:30 PM",
      "Thursday: 12:30 – 9:30 PM",
      "Friday: 12:30 – 9:30 PM",
      "Saturday: 12:30 – 9:30 PM",
      "Sunday: 12:30 – 9:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 1763,
    "id": 1467,
    "district": "Kaohsiung Sanmin Station"
  },
  {
    "title": "雙子星桌上遊戲專賣店",
    "urlinform": "store-212",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://2stargame.web.fc2.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK-PahttXBxQRYO0pKnGDwmw",
    "lat": 22.6282677,
    "lng": 120.2807355,
    "placeId": "ChIJK-PahttXBxQRYO0pKnGDwmw",
    "businessStatus": "OPERATIONAL",
    "phone": "07 521 9599",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 11:00 PM",
      "Wednesday: 2:00 – 11:00 PM",
      "Thursday: 2:00 – 11:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 11:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 177,
    "id": 1468
  },
  {
    "title": "雙子星 高雄民權店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Battle Spirits",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://2stargame.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOU8az8sDbjQRRp1TRMpbfn0",
    "lat": 22.61065,
    "lng": 120.3140829,
    "placeId": "ChIJOU8az8sDbjQRRp1TRMpbfn0",
    "businessStatus": "OPERATIONAL",
    "phone": "07 536 8689",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 16,
    "id": 1469
  },
  {
    "title": "卡金帝國 Card Digger",
    "urlinform": "-card-digger",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61574741647147",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHew740IFbjQRuh_hHwDwYWA",
    "lat": 22.6841467,
    "lng": 120.3152296,
    "placeId": "ChIJHew740IFbjQRuh_hHwDwYWA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 2:00 PM – 12:00 AM",
      "Saturday: 2:00 PM – 12:00 AM",
      "Sunday: 2:00 PM – 12:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 95,
    "id": 1470
  },
  {
    "title": "卡庫桌遊店",
    "urlinform": "store-215",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=100075557970549",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJV_bIq80PbjQRPN94-x6tJxc",
    "lat": 22.7897288,
    "lng": 120.28158,
    "placeId": "ChIJV_bIq80PbjQRPN94-x6tJxc",
    "businessStatus": "OPERATIONAL",
    "phone": "0906 528 208",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 46,
    "id": 1471
  },
  {
    "title": "White Dragon Gaming 白龍遊戲",
    "urlinform": "white-dragon-gaming-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/WDGonline",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2SMrRNEfaDQRLmqD4v-qti0",
    "lat": 24.9950069,
    "lng": 121.3114589,
    "placeId": "ChIJ2SMrRNEfaDQRLmqD4v-qti0",
    "businessStatus": "OPERATIONAL",
    "phone": "0903 554 609",
    "openingHours": [
      "Monday: 12:30 – 9:30 PM",
      "Tuesday: 12:30 – 9:30 PM",
      "Wednesday: 12:30 – 9:30 PM",
      "Thursday: 12:30 – 9:30 PM",
      "Friday: 12:30 – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 12:30 – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 79,
    "id": 1472
  },
  {
    "title": "超威電視遊樂器社",
    "urlinform": "store-217",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/CHAOWEI.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIYq_u5kEbjQRXFT_gYj_iwI",
    "lat": 22.6248897,
    "lng": 120.3144132,
    "placeId": "ChIJIYq_u5kEbjQRXFT_gYj_iwI",
    "businessStatus": "OPERATIONAL",
    "phone": "07 223 0208",
    "openingHours": [
      "Monday: 10:30 AM – 9:30 PM",
      "Tuesday: 10:30 AM – 9:30 PM",
      "Wednesday: 10:30 AM – 9:30 PM",
      "Thursday: 10:30 AM – 9:30 PM",
      "Friday: 10:30 AM – 9:30 PM",
      "Saturday: 10:30 AM – 9:30 PM",
      "Sunday: 10:30 AM – 7:30 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 275,
    "id": 1473
  },
  {
    "title": "貓腳印遊樂園 三民店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=100084224201838",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKe20b-IFbjQRKgYDxVnELkE",
    "lat": 22.6406745,
    "lng": 120.3415496,
    "placeId": "ChIJKe20b-IFbjQRKgYDxVnELkE",
    "businessStatus": "OPERATIONAL",
    "phone": "07 385 2918",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 28,
    "id": 1474
  },
  {
    "title": "兔屋 卡牌遊戲 (遊戲王、寶可夢PTCG、魔法風雲會、海賊王OPCG、WS黑白雙翼、薑餅人對戰卡牌)",
    "urlinform": "-ptcgopcgws",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://sites.google.com/view/bunnyhousetcg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYaZBlrkFbjQR9vIN7ejr9eY",
    "lat": 22.653587,
    "lng": 120.318423,
    "placeId": "ChIJYaZBlrkFbjQR9vIN7ejr9eY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 4:30 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 4:30 – 10:00 PM",
      "Saturday: 1:30 – 10:00 PM",
      "Sunday: 1:30 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 54,
    "id": 1475
  },
  {
    "title": "東湖拉比卡牌 - 內湖 南港 汐止 寶可夢卡牌|鑑定卡|新手教學|卡牌店|出租場地",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/labytcg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYZVqX5StQjQRvNaESdx9jnA",
    "lat": 25.0673861,
    "lng": 121.6157976,
    "placeId": "ChIJYZVqX5StQjQRvNaESdx9jnA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2633 7637",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 46,
    "id": 1476
  },
  {
    "title": "桌癮桌遊休閒空間",
    "urlinform": "store-221",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Joinboardgame",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnY2-1t0EbjQRWl-JujqR1PA",
    "lat": 22.6487727,
    "lng": 120.3229415,
    "placeId": "ChIJnY2-1t0EbjQRWl-JujqR1PA",
    "businessStatus": "OPERATIONAL",
    "phone": "07 380 8020",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 PM – 12:00 AM",
      "Saturday: 12:00 PM – 12:00 AM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 316,
    "id": 1477
  },
  {
    "title": "ONE桌遊大昌店x高雄三民大昌館-大昌麻將會館|棋牌會館|麻將館首選|桌遊店推薦|電動麻將館|休閒棋牌社",
    "urlinform": "onex-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://apps.apple.com/tw/app/one%E8%81%9A/id6469089066",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUehXSQAFbjQR2ChOMgCdGO4",
    "lat": 22.6475612,
    "lng": 120.3335352,
    "placeId": "ChIJUehXSQAFbjQR2ChOMgCdGO4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.4,
    "userRatingsTotal": 19,
    "id": 1478
  },
  {
    "title": "Bruce 桌遊空間-嫩江店",
    "urlinform": "bruce-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/bruceboardgame/?hc_ref=ARSi4H8zaj5UHYJKpVzKcfAXTwsA6gT1XlcEJBt-Qk_m36p0yl-CAOcwAjeBmxIRcsM&fref=nf&__xts__[0]=68.ARCVfp7YKKTeIZdaxIjV70nqwUgv0p3jBml3B1oQlR_ojjuKbc62lnskv6D0LHEf4F1w8CgzLaRymk_D2yn4MHMCiuaRY8Vq51bL35gbHQop6Do0Ceao_4Px4t29sJGv67p4cD_Q3MdV6G6MtBuP54wLnQnsY5qYx7SIONisEdO1RovSU--9tr8HlHtbigrIHwZbthLGopiFG2L5gtPQOaMx-FC7yFYCHi7_FG8MDbh1sd-uMnx784I7EZDQ6QgNVOiKLWeDju4riMTDnvhlsN2EBQ6rI5rtE1anDevfUBHkv5kIAxU",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJa95iKLMFbjQRM1S8svVXygg",
    "lat": 22.642926,
    "lng": 120.298538,
    "placeId": "ChIJa95iKLMFbjQRM1S8svVXygg",
    "businessStatus": "OPERATIONAL",
    "phone": "0905 328 053",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 5:00 – 11:00 PM",
      "Wednesday: Closed",
      "Thursday: 5:00 – 11:00 PM",
      "Friday: 5:00 – 11:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1086,
    "id": 1479,
    "district": "Kaohsiung Sanmin Station"
  },
  {
    "title": "小樹點餐飲桌遊店",
    "urlinform": "store-224",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/share/esSTnoefZrDcRRrq/?mibextid=LQQJ4d",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1bKLL94FbjQRFkhEVA3x4Rg",
    "lat": 22.6350716,
    "lng": 120.3164152,
    "placeId": "ChIJ1bKLL94FbjQRFkhEVA3x4Rg",
    "businessStatus": "OPERATIONAL",
    "phone": "0979 557 009",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.8,
    "userRatingsTotal": 688,
    "id": 1480
  },
  {
    "title": "桌樂趣桌遊空間",
    "urlinform": "store-225",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/drawlunch",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrU7HfVMbbjQRcpB-FYzP_2E",
    "lat": 22.6400159,
    "lng": 120.339734,
    "placeId": "ChIJrU7HfVMbbjQRcpB-FYzP_2E",
    "businessStatus": "OPERATIONAL",
    "phone": "0911 327 163",
    "openingHours": [
      "Monday: 7:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 7:00 – 10:00 PM",
      "Thursday: 7:00 – 10:00 PM",
      "Friday: 7:00 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 127,
    "id": 1481
  },
  {
    "title": "Corner Board Game X Life Exchange",
    "urlinform": "x",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/PsychoasisGame",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4VwwszMFbjQRvKcfMW5NFvY",
    "lat": 22.650592,
    "lng": 120.306941,
    "placeId": "ChIJ4VwwszMFbjQRvKcfMW5NFvY",
    "businessStatus": "OPERATIONAL",
    "phone": "0911 062 153",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 6:00 – 11:00 PM",
      "Wednesday: 6:00 – 11:00 PM",
      "Thursday: 6:00 – 11:00 PM",
      "Friday: 6:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 187,
    "id": 1482
  },
  {
    "title": "Fun4桌遊餐廳(高醫店)",
    "urlinform": "fun4",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/FUN4%E6%A1%8C%E9%81%8A%E9%AB%98%E9%86%AB%E6%93%B4%E5%85%85-485146598231512/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhYXiLe4EbjQRoLmsUtIQcaw",
    "lat": 22.6434187,
    "lng": 120.3096206,
    "placeId": "ChIJhYXiLe4EbjQRoLmsUtIQcaw",
    "businessStatus": "OPERATIONAL",
    "phone": "0928 978 199",
    "openingHours": [
      "Monday: 12:00 – 10:30 PM",
      "Tuesday: 12:00 – 10:30 PM",
      "Wednesday: 12:00 – 10:30 PM",
      "Thursday: 12:00 – 10:30 PM",
      "Friday: 12:00 – 10:30 PM",
      "Saturday: 12:00 – 10:30 PM",
      "Sunday: 12:00 – 10:30 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 208,
    "id": 1483,
    "district": "Kaohsiung Sanmin Station"
  },
  {
    "title": "桌遊帝國咖啡廳",
    "urlinform": "store-228",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/tkbgame2024/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9R6CSPUFbjQRpfhnh75Be5Y",
    "lat": 22.6471207,
    "lng": 120.3229115,
    "placeId": "ChIJ9R6CSPUFbjQRpfhnh75Be5Y",
    "businessStatus": "OPERATIONAL",
    "phone": "07 380 9096",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 11:00 PM",
      "Wednesday: 2:00 – 11:00 PM",
      "Thursday: 2:00 – 11:00 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 1:00 PM – 12:00 AM",
      "Sunday: 1:00 PM – 12:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 53,
    "id": 1484
  },
  {
    "title": "L'Occitane en Provence Lotte Gangnam",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbYUrhhykfDURQFKHYXUI59s",
    "lat": 37.4970578,
    "lng": 127.0535939,
    "placeId": "ChIJbYUrhhykfDURQFKHYXUI59s",
    "businessStatus": "OPERATIONAL",
    "phone": "02-531-2565",
    "openingHours": [
      "Monday: 10:30 AM – 8:00 PM",
      "Tuesday: 10:30 AM – 8:00 PM",
      "Wednesday: 10:30 AM – 8:00 PM",
      "Thursday: 10:30 AM – 8:00 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3,
    "id": 1485
  },
  {
    "title": "옐로우스타게임즈 보드게임샵 (Yellowstargames Boardgame shop)",
    "urlinform": "-yellowstargames-boardgame-shop",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/cafe_yellowmeeple/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHz_bPACZfDURlwZxsIxxeSM",
    "lat": 37.5607822,
    "lng": 126.9234964,
    "placeId": "ChIJHz_bPACZfDURlwZxsIxxeSM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:30 – 9:00 PM",
      "Wednesday: 3:30 – 9:00 PM",
      "Thursday: 3:30 – 9:00 PM",
      "Friday: 3:30 – 9:00 PM",
      "Saturday: 2:30 – 9:00 PM",
      "Sunday: 3:30 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 6,
    "id": 1486,
    "district": "Hongdae"
  },
  {
    "title": "Daewon Shop Yongsan iPark Mall",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY5x9HgCjfDURnjA2lRsDAlo",
    "lat": 37.5287599,
    "lng": 126.9643077,
    "placeId": "ChIJY5x9HgCjfDURnjA2lRsDAlo",
    "businessStatus": "OPERATIONAL",
    "phone": "02-2012-3406",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1487,
    "district": "Kukje Electronics Center"
  },
  {
    "title": "Screen Game Console Repair Shop",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8fMI9DylfDUReuthV-yvDBU",
    "lat": 37.5328376,
    "lng": 126.9647395,
    "placeId": "ChIJ8fMI9DylfDUReuthV-yvDBU",
    "businessStatus": "OPERATIONAL",
    "phone": "02-704-7414",
    "openingHours": [
      "Monday: 11:00 AM – 6:30 PM",
      "Tuesday: 11:00 AM – 6:30 PM",
      "Wednesday: 11:00 AM – 6:30 PM",
      "Thursday: 11:00 AM – 6:30 PM",
      "Friday: 11:00 AM – 6:30 PM",
      "Saturday: 11:00 AM – 6:30 PM",
      "Sunday: 11:00 AM – 6:30 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 9,
    "id": 1488,
    "district": "Yongsan"
  },
  {
    "title": "오피스디포 청계천점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.officedepot.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJVpEr-6ifDURrFYvRT4Ha4U",
    "lat": 37.5692999,
    "lng": 126.9813613,
    "placeId": "ChIJJVpEr-6ifDURrFYvRT4Ha4U",
    "businessStatus": "OPERATIONAL",
    "phone": "02-771-4600",
    "openingHours": [
      "Monday: 8:30 AM – 7:00 PM",
      "Tuesday: 8:30 AM – 7:00 PM",
      "Wednesday: 8:30 AM – 7:00 PM",
      "Thursday: 8:30 AM – 7:00 PM",
      "Friday: 8:30 AM – 7:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.2,
    "userRatingsTotal": 12,
    "id": 1489,
    "district": "Myeongdong"
  },
  {
    "title": "Alpha",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.alpha.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJL08Kn92ifDURpUoLILCdQNc",
    "lat": 37.5726596,
    "lng": 126.9892033,
    "placeId": "ChIJL08Kn92ifDURpUoLILCdQNc",
    "businessStatus": "OPERATIONAL",
    "phone": "02-765-2137",
    "openingHours": [
      "Monday: 9:00 AM – 8:00 PM",
      "Tuesday: 9:00 AM – 8:00 PM",
      "Wednesday: 9:00 AM – 8:00 PM",
      "Thursday: 9:00 AM – 8:00 PM",
      "Friday: 9:00 AM – 8:00 PM",
      "Saturday: 9:00 AM – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 3.8,
    "userRatingsTotal": 4,
    "id": 1490
  },
  {
    "title": "예작쥬얼리(YEI-JAK Jade Jewelry)",
    "urlinform": "yei-jak-jade-jewelry",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://yeijak.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi0M5jmijfDUR4dz-jV92qBY",
    "lat": 37.5713543,
    "lng": 126.992055,
    "placeId": "ChIJi0M5jmijfDUR4dz-jV92qBY",
    "businessStatus": "OPERATIONAL",
    "phone": "010-2745-6592",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 565,
    "id": 1491
  },
  {
    "title": "LOTTE DUTY FREE Main Store",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.messika.com/kr_kr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY0Y1cjSjfDUREep_rfaAucw",
    "lat": 37.564725,
    "lng": 126.9816625,
    "placeId": "ChIJY0Y1cjSjfDUREep_rfaAucw",
    "businessStatus": "OPERATIONAL",
    "phone": "02-759-6000",
    "openingHours": [
      "Monday: 9:30 AM – 8:00 PM",
      "Tuesday: 9:30 AM – 8:00 PM",
      "Wednesday: 9:30 AM – 8:00 PM",
      "Thursday: 9:30 AM – 8:00 PM",
      "Friday: 9:30 AM – 8:00 PM",
      "Saturday: 9:30 AM – 8:00 PM",
      "Sunday: 9:30 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 805,
    "id": 1492,
    "district": "Myeongdong"
  },
  {
    "title": "Musinsa Standard",
    "urlinform": "-musinsa-standard-myeongdong",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.musinsa.com/brands/musinsastandard",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9QkCyRmjfDURf5dnXDO6oVc",
    "lat": 37.5650971,
    "lng": 126.9828426,
    "placeId": "ChIJ9QkCyRmjfDURf5dnXDO6oVc",
    "businessStatus": "OPERATIONAL",
    "phone": "050-7872-3710",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1235,
    "id": 1493,
    "district": "Myeongdong"
  },
  {
    "title": "명동CD샵(Myeong-dong CD SHOP) - Wholesale",
    "urlinform": "cdmyeong-dong-cd-shop-wholesale",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6zV3Wt6jfDURDckwCkeXqb8",
    "lat": 37.5597,
    "lng": 126.9843745,
    "placeId": "ChIJ6zV3Wt6jfDURDckwCkeXqb8",
    "businessStatus": "OPERATIONAL",
    "phone": "010-4737-4445",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 6:00 PM",
      "Wednesday: 12:00 – 6:00 PM",
      "Thursday: 12:00 – 6:00 PM",
      "Friday: 12:00 – 6:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1494,
    "district": "Myeongdong"
  },
  {
    "title": "택매직 - Tek Magic",
    "urlinform": "-tekmagic",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.tekmagic.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcw2SzemYfDURkNmaz3cWYeQ",
    "lat": 37.5561625,
    "lng": 126.939337,
    "placeId": "ChIJcw2SzemYfDURkNmaz3cWYeQ",
    "businessStatus": "OPERATIONAL",
    "phone": "02-313-1548",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 12:00 – 5:00 PM",
      "Sunday: 12:00 – 5:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 44,
    "id": 1495,
    "district": "Sinchon"
  },
  {
    "title": "Strange card cafe",
    "urlinform": "strange-card-cafe",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-5PnFwCZfDUR6ZMucEEiLQY",
    "lat": 37.5572065,
    "lng": 126.9449589,
    "placeId": "ChIJ-5PnFwCZfDUR6ZMucEEiLQY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: Closed",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1496,
    "district": "Sinchon"
  },
  {
    "title": "놀숲 신촌점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://landing.nolsoop.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2dKaWZGYfDURpsoVvYI0k3k",
    "lat": 37.5584944,
    "lng": 126.9382782,
    "placeId": "ChIJ2dKaWZGYfDURpsoVvYI0k3k",
    "businessStatus": "OPERATIONAL",
    "phone": "070-4145-6000",
    "openingHours": [
      "Monday: 10:00 AM – 12:00 AM",
      "Tuesday: 10:00 AM – 12:00 AM",
      "Wednesday: 10:00 AM – 12:00 AM",
      "Thursday: 10:00 AM – 12:00 AM",
      "Friday: 10:00 AM – 12:00 AM",
      "Saturday: 10:00 AM – 12:00 AM",
      "Sunday: 10:00 AM – 12:00 AM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 235,
    "id": 1497,
    "district": "Sinchon"
  },
  {
    "title": "Artbox Sinchon",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.poom.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcS0WC5SYfDURJSN1P9drd2g",
    "lat": 37.55815090000001,
    "lng": 126.9378529,
    "placeId": "ChIJcS0WC5SYfDURJSN1P9drd2g",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71471-1049",
    "openingHours": [
      "Monday: 11:00 AM – 10:30 PM",
      "Tuesday: 11:00 AM – 10:30 PM",
      "Wednesday: 11:00 AM – 10:30 PM",
      "Thursday: 11:00 AM – 10:30 PM",
      "Friday: 11:00 AM – 10:30 PM",
      "Saturday: 11:00 AM – 10:30 PM",
      "Sunday: 11:00 AM – 10:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 351,
    "id": 1498,
    "district": "Sinchon"
  },
  {
    "title": "Hongik Books",
    "urlinform": "store-125",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRWJqzJWYfDURGciU25Ey5Tg",
    "lat": 37.5557223,
    "lng": 126.9370542,
    "placeId": "ChIJRWJqzJWYfDURGciU25Ey5Tg",
    "businessStatus": "OPERATIONAL",
    "phone": "02-392-2020",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 497,
    "id": 1499,
    "district": "Sinchon"
  },
  {
    "title": "Daiso Sinchon",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.daiso.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuWttn5WYfDURI_JgL4vrQHs",
    "lat": 37.555296,
    "lng": 126.9355255,
    "placeId": "ChIJuWttn5WYfDURI_JgL4vrQHs",
    "businessStatus": "OPERATIONAL",
    "phone": "02-335-6016",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 1096,
    "id": 1500,
    "district": "Sinchon"
  },
  {
    "title": "Aladin Used Bookstore",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://off.aladin.co.kr/usedstore/wgate.aspx",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwadPE5SYfDUR_n6TLnpa9ts",
    "lat": 37.5575246,
    "lng": 126.9367405,
    "placeId": "ChIJwadPE5SYfDUR_n6TLnpa9ts",
    "businessStatus": "OPERATIONAL",
    "phone": "1544-2514",
    "openingHours": [
      "Monday: 9:30 AM – 10:00 PM",
      "Tuesday: 9:30 AM – 10:00 PM",
      "Wednesday: 9:30 AM – 10:00 PM",
      "Thursday: 9:30 AM – 10:00 PM",
      "Friday: 9:30 AM – 10:00 PM",
      "Saturday: 9:30 AM – 10:00 PM",
      "Sunday: 9:30 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 1335,
    "id": 1501,
    "district": "Sinchon"
  },
  {
    "title": "OG9 신촌점｜OG9电子烟新村店｜OG9 PREMIUM VAPE STORE SINCHON",
    "urlinform": "og9-og9og9-premium-vape-store-sinchon",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6VoGEwCZfDURMY2ZeN1NR0g",
    "lat": 37.5574863,
    "lng": 126.9370926,
    "placeId": "ChIJ6VoGEwCZfDURMY2ZeN1NR0g",
    "businessStatus": "OPERATIONAL",
    "phone": "070-4366-6022",
    "openingHours": [
      "Monday: 11:00 AM – 2:00 AM",
      "Tuesday: 11:00 AM – 2:00 AM",
      "Wednesday: 11:00 AM – 2:00 AM",
      "Thursday: 11:00 AM – 2:00 AM",
      "Friday: 11:00 AM – 2:00 AM",
      "Saturday: 11:00 AM – 2:00 AM",
      "Sunday: 11:00 AM – 2:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 92,
    "id": 1502,
    "district": "Sinchon"
  },
  {
    "title": "Poset Yeonhui",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://poset.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC76iGmqZfDURDXqhTJjuodQ",
    "lat": 37.5699642,
    "lng": 126.9312486,
    "placeId": "ChIJC76iGmqZfDURDXqhTJjuodQ",
    "businessStatus": "OPERATIONAL",
    "phone": "02-3141-7427",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 35,
    "id": 1503
  },
  {
    "title": "Daiso Sinchon Myeongmul Street",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.daiso.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHW0-VpGYfDURv-gqDJVcgrI",
    "lat": 37.55825,
    "lng": 126.9380507,
    "placeId": "ChIJHW0-VpGYfDURv-gqDJVcgrI",
    "businessStatus": "OPERATIONAL",
    "phone": "02-362-6016",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 207,
    "id": 1504,
    "district": "Sinchon"
  },
  {
    "title": "대한민국 플스방",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpwWCkpOYfDURYPrh_BkQKcM",
    "lat": 37.5590469,
    "lng": 126.9366333,
    "placeId": "ChIJpwWCkpOYfDURYPrh_BkQKcM",
    "businessStatus": "OPERATIONAL",
    "phone": "070-8682-2822",
    "openingHours": [
      "Monday: 12:30 PM – 2:30 AM",
      "Tuesday: 12:30 PM – 2:30 AM",
      "Wednesday: 12:30 PM – 2:30 AM",
      "Thursday: 12:30 PM – 2:30 AM",
      "Friday: 12:30 PM – 2:30 AM",
      "Saturday: 12:30 PM – 2:30 AM",
      "Sunday: 12:30 PM – 2:30 AM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 51,
    "id": 1505,
    "district": "Sinchon"
  },
  {
    "title": "캡틴플스 신촌본점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDepyGpSYfDUREH7dbSrQCQc",
    "lat": 37.55728330000001,
    "lng": 126.9374637,
    "placeId": "ChIJDepyGpSYfDUREH7dbSrQCQc",
    "businessStatus": "OPERATIONAL",
    "phone": "02-313-9524",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 AM",
      "Tuesday: 10:00 AM – 6:00 AM",
      "Wednesday: 10:00 AM – 6:00 AM",
      "Thursday: 10:00 AM – 6:00 AM",
      "Friday: 10:00 AM – 6:00 AM",
      "Saturday: 10:00 AM – 6:00 AM",
      "Sunday: 10:00 AM – 6:00 AM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 11,
    "id": 1506,
    "district": "Sinchon"
  },
  {
    "title": "Board Game Café Red Button Sinchon Branch",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.redbutton.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvdpjxtqZfDURABBYKaBbniA",
    "lat": 37.5561953,
    "lng": 126.9371334,
    "placeId": "ChIJvdpjxtqZfDURABBYKaBbniA",
    "businessStatus": "OPERATIONAL",
    "phone": "02-363-3799",
    "openingHours": [
      "Monday: 1:00 PM – 1:00 AM",
      "Tuesday: 1:00 PM – 1:00 AM",
      "Wednesday: 1:00 PM – 1:00 AM",
      "Thursday: 1:00 PM – 1:00 AM",
      "Friday: 1:00 PM – 2:00 AM",
      "Saturday: 12:00 PM – 2:00 AM",
      "Sunday: 12:00 PM – 1:00 AM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 169,
    "id": 1507,
    "district": "Sinchon"
  },
  {
    "title": "Kukje Electronics Center",
    "urlinform": "store-135",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQxcasEOhfDURyiko9xvzExA",
    "lat": 37.484742,
    "lng": 127.0177676,
    "placeId": "ChIJQxcasEOhfDURyiko9xvzExA",
    "businessStatus": "OPERATIONAL",
    "phone": "02-3465-0114",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 1778,
    "id": 1508
  },
  {
    "title": "Kukje Electronics Center",
    "urlinform": "store-136",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKcX6cBWhfDURe3pGE8D7mi0",
    "lat": 37.485479,
    "lng": 127.017874,
    "placeId": "ChIJKcX6cBWhfDURe3pGE8D7mi0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 4.3,
    "userRatingsTotal": 10,
    "id": 1509
  },
  {
    "title": "게임스테이션",
    "urlinform": "store-44",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqUlH35TpaDURSByKQ1IcI0I",
    "lat": 35.1061051,
    "lng": 129.0227649,
    "placeId": "ChIJqUlH35TpaDURSByKQ1IcI0I",
    "businessStatus": "OPERATIONAL",
    "phone": "051-245-9117",
    "openingHours": [
      "Monday: 12:00 AM – 8:00 PM",
      "Tuesday: 12:00 AM – 8:00 PM",
      "Wednesday: 12:00 AM – 8:00 PM",
      "Thursday: 12:00 AM – 8:00 PM",
      "Friday: 12:00 AM – 8:00 PM",
      "Saturday: 2:00 – 6:00 PM",
      "Sunday: 2:00 – 6:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 1,
    "id": 1510
  },
  {
    "title": "LOTTE Mart Gwangbok",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://company.lottemart.com/branch/bc/main.do?brnchCd=0100253",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJWe5w-rpaDURkpa2CSfQwXs",
    "lat": 35.0976981,
    "lng": 129.0361688,
    "placeId": "ChIJJWe5w-rpaDURkpa2CSfQwXs",
    "businessStatus": "OPERATIONAL",
    "phone": "051-441-2500",
    "openingHours": [
      "Monday: 10:00 AM – 11:00 PM",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: 10:00 AM – 11:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 1564,
    "id": 1511,
    "district": "Nampodong"
  },
  {
    "title": "Kim Soo-hoe",
    "urlinform": "store-54",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJz_myhp_paDURanvDmSZ3e5g",
    "lat": 35.1021125,
    "lng": 129.0271172,
    "placeId": "ChIJz_myhp_paDURanvDmSZ3e5g",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 6:00 PM",
      "Wednesday: 9:00 AM – 6:00 PM",
      "Thursday: 9:00 AM – 6:00 PM",
      "Friday: 9:00 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 9:00 AM – 6:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 49,
    "id": 1512,
    "district": "Nampo"
  },
  {
    "title": "티씨지샵 셔플",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-9Xz9_qTaDUR7OdMcZb3jc8",
    "lat": 35.2053786,
    "lng": 129.0750156,
    "placeId": "ChIJ-9Xz9_qTaDUR7OdMcZb3jc8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 31,
    "id": 1513
  },
  {
    "title": "Souvenir kedai cenderahati Nampodong",
    "urlinform": "store-73",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJI60N89_paDURVd_f582dUHw",
    "lat": 35.1008391,
    "lng": 129.0285699,
    "placeId": "ChIJI60N89_paDURVd_f582dUHw",
    "businessStatus": "OPERATIONAL",
    "phone": "051-248-5445",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 7:00 PM",
      "Friday: 9:00 AM – 7:00 PM",
      "Saturday: 9:00 AM – 7:00 PM",
      "Sunday: 9:00 AM – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 25,
    "id": 1514,
    "district": "Nampo"
  },
  {
    "title": "KODAK Cine Shop Busan Gwangbok",
    "urlinform": "kodak-cine-shop-busan-gwangbok",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://hilightbrands-kodak.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoWdPPo_paDURbBnN_OoBhQQ",
    "lat": 35.0991366,
    "lng": 129.0312535,
    "placeId": "ChIJoWdPPo_paDURbBnN_OoBhQQ",
    "businessStatus": "OPERATIONAL",
    "phone": "051-231-1126",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1216,
    "id": 1515,
    "district": "Nampo"
  },
  {
    "title": "VIVARO COFFEE",
    "urlinform": "vivaro-coffee",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt5w2cgDpaDURElCuhotTbwY",
    "lat": 35.1002589,
    "lng": 129.0300696,
    "placeId": "ChIJt5w2cgDpaDURElCuhotTbwY",
    "businessStatus": "OPERATIONAL",
    "phone": "010-6796-8875",
    "openingHours": [
      "Monday: 7:30 AM – 7:00 PM",
      "Tuesday: 7:30 AM – 7:00 PM",
      "Wednesday: 7:30 AM – 7:00 PM",
      "Thursday: 7:30 AM – 7:00 PM",
      "Friday: 7:30 AM – 7:00 PM",
      "Saturday: 7:30 AM – 7:00 PM",
      "Sunday: 7:30 AM – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 58,
    "id": 1516,
    "district": "Nampo"
  },
  {
    "title": "Y’Z PARK Gwangbok",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJkQJknwrpaDURDXk36tHwxo8",
    "lat": 35.0997662,
    "lng": 129.029621,
    "placeId": "ChIJkQJknwrpaDURDXk36tHwxo8",
    "businessStatus": "OPERATIONAL",
    "phone": "051-260-5000",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 305,
    "id": 1517,
    "district": "Nampo"
  },
  {
    "title": "Siam Paragon",
    "urlinform": "siam-paragon",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.siamparagon.co.th/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIeWu482e4jARYymvLJqTQ58",
    "lat": 13.7461302,
    "lng": 100.5347792,
    "placeId": "ChIJIeWu482e4jARYymvLJqTQ58",
    "businessStatus": "OPERATIONAL",
    "phone": "02 610 8000",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 63030,
    "id": 1518,
    "district": "Siam"
  },
  {
    "title": "Mega Plaza Saphan Lek",
    "urlinform": "mega-plaza-saphan-lek",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/MegaPlazaSaphanlek?mibextid=eHce3h",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmbaDkBmZ4jARisvkpvTPrYc",
    "lat": 13.7452187,
    "lng": 100.5024664,
    "placeId": "ChIJmbaDkBmZ4jARisvkpvTPrYc",
    "businessStatus": "OPERATIONAL",
    "phone": "02 623 7888",
    "openingHours": [
      "Monday: 10:30 AM – 7:30 PM",
      "Tuesday: 10:30 AM – 7:30 PM",
      "Wednesday: 10:30 AM – 7:30 PM",
      "Thursday: 10:30 AM – 7:30 PM",
      "Friday: 10:30 AM – 7:30 PM",
      "Saturday: 10:30 AM – 7:30 PM",
      "Sunday: 10:30 AM – 7:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 11027,
    "id": 1519,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "play2anime",
    "urlinform": "play2anime",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://www.play2anime.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEbmAaUCc4jARNY929bZrzEQ",
    "lat": 13.8024623,
    "lng": 100.5513147,
    "placeId": "ChIJEbmAaUCc4jARNY929bZrzEQ",
    "businessStatus": "OPERATIONAL",
    "phone": "081 550 2600",
    "openingHours": [
      "Monday: 11:00 AM – 7:30 PM",
      "Tuesday: 11:00 AM – 7:30 PM",
      "Wednesday: 11:00 AM – 7:30 PM",
      "Thursday: 11:00 AM – 7:30 PM",
      "Friday: 11:00 AM – 7:30 PM",
      "Saturday: 11:00 AM – 7:30 PM",
      "Sunday: 11:00 AM – 7:30 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 49,
    "id": 1520,
    "district": "Chatuchak"
  },
  {
    "title": "3Brothers Chatuchak K3",
    "urlinform": "3brothers-chatuchak-k3",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJecNEQACd4jARdr9CEVo1kaE",
    "lat": 13.7980107,
    "lng": 100.5500517,
    "placeId": "ChIJecNEQACd4jARdr9CEVo1kaE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 8:00 AM – 7:00 PM",
      "Saturday: 8:00 AM – 7:00 PM",
      "Sunday: 8:00 AM – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 110,
    "id": 1521,
    "district": "Chatuchak"
  },
  {
    "title": "Nx Gallery - BTS Ari",
    "urlinform": "nx-gallery-bts-ari",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://fb.com/NxGallery",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFUnRuIqf4jAR9wlXoLg63jA",
    "lat": 13.7796646,
    "lng": 100.5446239,
    "placeId": "ChIJFUnRuIqf4jAR9wlXoLg63jA",
    "businessStatus": "OPERATIONAL",
    "phone": "064 235 3743",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 103,
    "id": 1522
  },
  {
    "title": "The One - Bangkok's Finest",
    "urlinform": "the-one-bangkoks-finest",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.the1-th.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ87xAsMSf4jARKRZ7Skitsbs",
    "lat": 13.7139864,
    "lng": 100.5920175,
    "placeId": "ChIJ87xAsMSf4jARKRZ7Skitsbs",
    "businessStatus": "OPERATIONAL",
    "phone": "098 329 0037",
    "openingHours": [
      "Monday: 12:00 PM – 1:00 AM",
      "Tuesday: 12:00 PM – 1:00 AM",
      "Wednesday: 12:00 PM – 1:00 AM",
      "Thursday: 12:00 PM – 1:00 AM",
      "Friday: 12:00 PM – 1:00 AM",
      "Saturday: 12:00 PM – 1:00 AM",
      "Sunday: 1:00 PM – 1:00 AM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 23,
    "id": 1523
  },
  {
    "title": "Scavengers TCG Bangkok",
    "urlinform": "scavengers-tcg-bangkok",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/ScavengersTCGBangkok/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt34pMQBhHTER2zsRkaAM3Rw",
    "lat": 13.696102,
    "lng": 100.648022,
    "placeId": "ChIJt34pMQBhHTER2zsRkaAM3Rw",
    "businessStatus": "OPERATIONAL",
    "phone": "081 402 9761",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1524
  },
  {
    "title": "DRAGON CARD ดรากอน การ์ด",
    "urlinform": "dragon-card-",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE45MWQCf4jARaWVX6zwjF88",
    "lat": 13.742306,
    "lng": 100.5856698,
    "placeId": "ChIJE45MWQCf4jARaWVX6zwjF88",
    "businessStatus": "OPERATIONAL",
    "phone": "064 265 9991",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1525
  },
  {
    "title": "CardON การ์ดออน",
    "urlinform": "cardon-",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5W-NkLuZ4jARTbco8cRRD4o",
    "lat": 13.7453064,
    "lng": 100.5022919,
    "placeId": "ChIJ5W-NkLuZ4jARTbco8cRRD4o",
    "businessStatus": "OPERATIONAL",
    "phone": "095 658 9158",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 74,
    "id": 1526,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "pop kingdom toys",
    "urlinform": "pop-kingdom-toys",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYZlUa7yZ4jARWWRxArSfKio",
    "lat": 13.7454831,
    "lng": 100.5023217,
    "placeId": "ChIJYZlUa7yZ4jARWWRxArSfKio",
    "businessStatus": "OPERATIONAL",
    "phone": "088 160 9090",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 10:30 AM – 6:30 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 5,
    "id": 1527,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "FM Toy",
    "urlinform": "fm-toy",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiZmSkxmZ4jARMQWZ88jaQ88",
    "lat": 13.7454767,
    "lng": 100.5025863,
    "placeId": "ChIJiZmSkxmZ4jARMQWZ88jaQ88",
    "businessStatus": "OPERATIONAL",
    "phone": "089 001 3723",
    "openingHours": [
      "Monday: 9:30 AM – 5:00 PM",
      "Tuesday: 9:30 AM – 5:00 PM",
      "Wednesday: 9:30 AM – 5:00 PM",
      "Thursday: 9:30 AM – 5:00 PM",
      "Friday: 9:30 AM – 5:00 PM",
      "Saturday: 9:30 AM – 5:00 PM",
      "Sunday: 9:30 AM – 5:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 3,
    "id": 1528,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Neverland Toys & Collectibles Mega Plaza",
    "urlinform": "neverland-toys-collectibles-mega-plaza",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://neverland.co.th/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJk6aL4GuZ4jARwVbwUWaXXQs",
    "lat": 13.7452476,
    "lng": 100.5023904,
    "placeId": "ChIJk6aL4GuZ4jARwVbwUWaXXQs",
    "businessStatus": "OPERATIONAL",
    "phone": "061 389 8933",
    "openingHours": [
      "Monday: 10:30 AM – 5:30 PM",
      "Tuesday: 10:30 AM – 5:30 PM",
      "Wednesday: 10:30 AM – 5:30 PM",
      "Thursday: 10:30 AM – 5:30 PM",
      "Friday: 10:30 AM – 5:30 PM",
      "Saturday: 10:30 AM – 6:00 PM",
      "Sunday: 10:30 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3409,
    "id": 1529,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "D-Toys Gundam",
    "urlinform": "d-toys-gundam",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "Gundam"
    ],
    "storeWebsite": "https://www.facebook.com/dtoygundam/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4Y6ffyeZ4jARX9d_qTZAUzo",
    "lat": 13.7454762,
    "lng": 100.5024744,
    "placeId": "ChIJ4Y6ffyeZ4jARX9d_qTZAUzo",
    "businessStatus": "OPERATIONAL",
    "phone": "02 108 3552",
    "openingHours": [
      "Monday: 10:30 AM – 6:00 PM",
      "Tuesday: 10:30 AM – 6:00 PM",
      "Wednesday: 10:30 AM – 6:00 PM",
      "Thursday: 10:30 AM – 6:00 PM",
      "Friday: 10:30 AM – 6:00 PM",
      "Saturday: 10:30 AM – 6:00 PM",
      "Sunday: 10:30 AM – 6:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 21,
    "id": 1530,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Toys Legends",
    "urlinform": "toys-legends",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQZlC_H-Z4jARDg_EjLSvi38",
    "lat": 13.7454961,
    "lng": 100.5023792,
    "placeId": "ChIJQZlC_H-Z4jARDg_EjLSvi38",
    "businessStatus": "OPERATIONAL",
    "phone": "061 497 8955",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 556,
    "id": 1531,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "4.0 Collector Toys",
    "urlinform": "40-collector-toys",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3RP7gtuZ4jARWKVVlg3Q0Bs",
    "lat": 13.745432,
    "lng": 100.5021836,
    "placeId": "ChIJ3RP7gtuZ4jARWKVVlg3Q0Bs",
    "businessStatus": "OPERATIONAL",
    "phone": "099 262 8256",
    "openingHours": [
      "Monday: 10:30 AM – 6:30 PM",
      "Tuesday: 10:30 AM – 6:30 PM",
      "Wednesday: 10:30 AM – 6:30 PM",
      "Thursday: 10:30 AM – 6:30 PM",
      "Friday: 10:30 AM – 6:30 PM",
      "Saturday: 10:30 AM – 6:30 PM",
      "Sunday: 10:30 AM – 6:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "id": 1532,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Mewtoy",
    "urlinform": "mewtoy",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://shopee.co.th/mewtoy_gundam",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJkTTczfGZ4jAR3GdtcrLmD7Q",
    "lat": 13.7453826,
    "lng": 100.5023415,
    "placeId": "ChIJkTTczfGZ4jAR3GdtcrLmD7Q",
    "businessStatus": "OPERATIONAL",
    "phone": "080 598 5955",
    "openingHours": [
      "Monday: 11:30 AM – 6:15 PM",
      "Tuesday: 11:30 AM – 6:15 PM",
      "Wednesday: 11:30 AM – 6:15 PM",
      "Thursday: 11:30 AM – 6:15 PM",
      "Friday: 11:30 AM – 6:15 PM",
      "Saturday: 11:30 AM – 6:15 PM",
      "Sunday: 11:30 AM – 6:15 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 15,
    "id": 1533,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Always One Plaza",
    "urlinform": "always-one-plaza",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.alwaysoneplaza.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJad0WvBmZ4jARBF8G36aJ1Hc",
    "lat": 13.745412,
    "lng": 100.503177,
    "placeId": "ChIJad0WvBmZ4jARBF8G36aJ1Hc",
    "businessStatus": "OPERATIONAL",
    "phone": "061 914 4564",
    "openingHours": [
      "Monday: 10:30 AM – 5:30 PM",
      "Tuesday: 10:30 AM – 5:30 PM",
      "Wednesday: 10:30 AM – 5:30 PM",
      "Thursday: 10:30 AM – 5:30 PM",
      "Friday: 10:30 AM – 5:30 PM",
      "Saturday: 10:30 AM – 5:30 PM",
      "Sunday: 10:30 AM – 6:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 159,
    "id": 1534,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Card Harbor",
    "urlinform": "card-harbor",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61568108661172&mibextid=LQQJ4d",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWXWsawCZ4jARuMd42wwv0yU",
    "lat": 13.7455277,
    "lng": 100.5030105,
    "placeId": "ChIJWXWsawCZ4jARuMd42wwv0yU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 72,
    "id": 1535,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Ohho Game Shop",
    "urlinform": "ohho-game-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1w4dWVOZ4jARBH9NpktyVBM",
    "lat": 13.7456527,
    "lng": 100.5022097,
    "placeId": "ChIJ1w4dWVOZ4jARBH9NpktyVBM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 3,
    "id": 1536,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Hot Toys Thailand by Kingdom Come สาขาเมก้า พลาซ่า",
    "urlinform": "hot-toys-thailand-by-kingdom-come-",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.kingdomcome.co.th/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCTuLXgCZ4jARz4b56AuOOyw",
    "lat": 13.7454547,
    "lng": 100.5024055,
    "placeId": "ChIJCTuLXgCZ4jARz4b56AuOOyw",
    "businessStatus": "OPERATIONAL",
    "phone": "085 150 7373",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: Closed",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 280,
    "id": 1537,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "OHHO TOYs",
    "urlinform": "ohho-toys",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/OHHOTOYSS/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJay6ejD2Z4jARVl2K_i9s2dg",
    "lat": 13.7453272,
    "lng": 100.5024349,
    "placeId": "ChIJay6ejD2Z4jARVl2K_i9s2dg",
    "businessStatus": "OPERATIONAL",
    "phone": "080 969 9089",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 4,
    "id": 1538,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "ร้าน Akiba Toys & Hobby Shop",
    "urlinform": "-akiba-toys-hobby-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP-92TjWZ4jARkS6rKDj8s0g",
    "lat": 13.74597,
    "lng": 100.5023691,
    "placeId": "ChIJP-92TjWZ4jARkS6rKDj8s0g",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 6:30 PM",
      "Tuesday: 1:00 – 6:30 PM",
      "Wednesday: 1:00 – 6:30 PM",
      "Thursday: 1:00 – 6:30 PM",
      "Friday: 1:00 – 6:30 PM",
      "Saturday: 12:30 – 7:00 PM",
      "Sunday: 12:30 – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "id": 1539,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Mawin Toys",
    "urlinform": "mawin-toys",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://mawinmega.com/?utm_source=gmb&utm_medium=referral",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPaZsMUaZ4jARJcfhhryjFfk",
    "lat": 13.7452851,
    "lng": 100.5022736,
    "placeId": "ChIJPaZsMUaZ4jARJcfhhryjFfk",
    "businessStatus": "OPERATIONAL",
    "phone": "062 236 5446",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "id": 1540,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Jeng RC Shop",
    "urlinform": "jeng-rc-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/jengrcshop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiQWVe0-Z4jARiuBsisnje8U",
    "lat": 13.7454336,
    "lng": 100.5023569,
    "placeId": "ChIJiQWVe0-Z4jARiuBsisnje8U",
    "businessStatus": "OPERATIONAL",
    "phone": "081 346 8555",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 33,
    "id": 1541,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "galestation",
    "urlinform": "galestation",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/galestation",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6ZewZLmZ4jARADJQk_LJiaQ",
    "lat": 13.7452349,
    "lng": 100.5024057,
    "placeId": "ChIJ6ZewZLmZ4jARADJQk_LJiaQ",
    "businessStatus": "OPERATIONAL",
    "phone": "091 987 8962",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 5,
    "id": 1542,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "คลินิก ซ่อมเกมส์ (ทุกรุ่น ทุกอาการ) ซ่อม จอยเกมส์ ทุก ยี่ห้อ โดย ช่างผู้ชำนานงาน ราคาใมแพง แน่นอน สอบถามราคาใด้เลย",
    "urlinform": "-",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyaTBJI2Z4jARpQQgEWpdTRI",
    "lat": 13.7454965,
    "lng": 100.502201,
    "placeId": "ChIJyaTBJI2Z4jARpQQgEWpdTRI",
    "businessStatus": "OPERATIONAL",
    "phone": "088 616 0657",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 45,
    "id": 1543,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Mega-Plaza Movie",
    "urlinform": "mega-plaza-movie",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJlxTwVauZ4jARhX5DmCeo76Y",
    "lat": 13.7462168,
    "lng": 100.5027981,
    "placeId": "ChIJlxTwVauZ4jARhX5DmCeo76Y",
    "businessStatus": "OPERATIONAL",
    "phone": "094 314 0498",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1544,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Happy Game - เมก้าพลาซ่าสะพานเหล็ก",
    "urlinform": "happy-game-",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/happygamesaphanlek/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE9w7-PKZ4jARb-GOrUpn2hI",
    "lat": 13.7453847,
    "lng": 100.5024502,
    "placeId": "ChIJE9w7-PKZ4jARb-GOrUpn2hI",
    "businessStatus": "OPERATIONAL",
    "phone": "090 801 2546",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3,
    "id": 1545,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Mega Food Center",
    "urlinform": "mega-food-center",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/MegaPlazaSaphanlek?mibextid=LQQJ4d",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJV7AjN-WZ4jAReZav2kABC-I",
    "lat": 13.7453785,
    "lng": 100.5023584,
    "placeId": "ChIJV7AjN-WZ4jAReZav2kABC-I",
    "businessStatus": "OPERATIONAL",
    "phone": "02 623 7888",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 22,
    "id": 1546,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "KTD แมวอ้วน card game",
    "urlinform": "ktd-card-game",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJe77fAgCZ4jARZPi-2dFr-Ws",
    "lat": 13.7453603,
    "lng": 100.502289,
    "placeId": "ChIJe77fAgCZ4jARZPi-2dFr-Ws",
    "businessStatus": "OPERATIONAL",
    "phone": "066 132 3825",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 8,
    "id": 1547,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Ontoptoys",
    "urlinform": "ontoptoys",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJm09OC_KZ4jARpcvUow4OS0Y",
    "lat": 13.7453162,
    "lng": 100.5025129,
    "placeId": "ChIJm09OC_KZ4jARpcvUow4OS0Y",
    "businessStatus": "OPERATIONAL",
    "phone": "061 121 1330",
    "openingHours": [
      "Monday: 10:30 AM – 7:00 PM",
      "Tuesday: 10:30 AM – 7:00 PM",
      "Wednesday: 10:30 AM – 7:00 PM",
      "Thursday: 10:30 AM – 7:00 PM",
      "Friday: 10:30 AM – 7:00 PM",
      "Saturday: 10:30 AM – 7:00 PM",
      "Sunday: 10:30 AM – 7:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 7,
    "id": 1548,
    "district": "Mega Plaza Wang Burapa"
  },
  {
    "title": "Tuktik Comic Book",
    "urlinform": "tuktik-comic-book",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/TukTikKartun/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDaM2ruw62jARabNeriPXFfk",
    "lat": 18.8051535,
    "lng": 98.98465159999999,
    "placeId": "ChIJDaM2ruw62jARabNeriPXFfk",
    "businessStatus": "OPERATIONAL",
    "phone": "083 567 7887",
    "openingHours": [
      "Monday: 10:30 AM – 8:00 PM",
      "Tuesday: 10:30 AM – 8:00 PM",
      "Wednesday: 10:30 AM – 8:00 PM",
      "Thursday: 10:30 AM – 8:00 PM",
      "Friday: 10:30 AM – 8:00 PM",
      "Saturday: 10:30 AM – 8:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 173,
    "id": 1549
  },
  {
    "title": "Meenoiland",
    "urlinform": "meenoiland",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQ3w5b5c72jARVAf1TqDzsP0",
    "lat": 18.8074575,
    "lng": 98.9850156,
    "placeId": "ChIJQ3w5b5c72jARVAf1TqDzsP0",
    "businessStatus": "OPERATIONAL",
    "phone": "096 997 5059",
    "openingHours": [],
    "rating": 4.8,
    "userRatingsTotal": 28,
    "id": 1550
  },
  {
    "title": "Night Bazaar Place Chiang Mai",
    "urlinform": "night-bazaar-place-chiang-mai",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://nightbazaarplacechiangmai.shop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuXBQVVVF2jARwk2ZvnvS-s8",
    "lat": 18.7864006,
    "lng": 99.00089159999999,
    "placeId": "ChIJuXBQVVVF2jARwk2ZvnvS-s8",
    "businessStatus": "OPERATIONAL",
    "phone": "053 283 250",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.2,
    "userRatingsTotal": 1344,
    "id": 1551,
    "district": "Night Bazaar"
  },
  {
    "title": "Waroros Market",
    "urlinform": "waroros-market",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUXF8Lzo72jARQGy1_Bh_wCQ",
    "lat": 18.7898494,
    "lng": 99.00099639999999,
    "placeId": "ChIJUXF8Lzo72jARQGy1_Bh_wCQ",
    "businessStatus": "OPERATIONAL",
    "phone": "092 428 9097",
    "openingHours": [
      "Monday: 6:00 AM – 6:00 PM",
      "Tuesday: 6:00 AM – 6:00 PM",
      "Wednesday: 6:00 AM – 6:00 PM",
      "Thursday: 6:00 AM – 6:00 PM",
      "Friday: 6:00 AM – 6:00 PM",
      "Saturday: 6:00 AM – 6:00 PM",
      "Sunday: 6:00 AM – 6:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 7223,
    "id": 1552,
    "district": "Night Bazaar"
  },
  {
    "title": "Pae Game Shop",
    "urlinform": "pae-game-shop",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh-mWU6s62jAReDeey285Xl0",
    "lat": 18.7844827,
    "lng": 99.0126196,
    "placeId": "ChIJh-mWU6s62jAReDeey285Xl0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 4:00 PM",
      "Tuesday: 11:00 AM – 4:00 PM",
      "Wednesday: Closed",
      "Thursday: 11:00 AM – 4:00 PM",
      "Friday: 11:00 AM – 4:00 PM",
      "Saturday: 11:00 AM – 4:00 PM",
      "Sunday: 11:00 AM – 4:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 147,
    "id": 1553
  },
  {
    "title": "Prostar Magic Shop",
    "urlinform": "prostar-magic-shop",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.prostar-magic.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUWPwXqA62jARNI0QJBEp6TA",
    "lat": 18.7824246,
    "lng": 98.99329999999999,
    "placeId": "ChIJUWPwXqA62jARNI0QJBEp6TA",
    "businessStatus": "OPERATIONAL",
    "phone": "089 756 2341",
    "openingHours": [
      "Monday: 10:00 AM – 7:30 PM",
      "Tuesday: 10:00 AM – 7:30 PM",
      "Wednesday: 10:00 AM – 7:30 PM",
      "Thursday: 10:00 AM – 7:30 PM",
      "Friday: 10:00 AM – 7:30 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 21,
    "id": 1554,
    "district": "Night Bazaar"
  },
  {
    "title": "Chiang Mai University",
    "urlinform": "chiang-mai-university",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.cmu.ac.th/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJH6leNWg62jARUoNPYXsZk9M",
    "lat": 18.8082363,
    "lng": 98.9546953,
    "placeId": "ChIJH6leNWg62jARUoNPYXsZk9M",
    "businessStatus": "OPERATIONAL",
    "phone": "053 941 000",
    "openingHours": [
      "Monday: 8:30 AM – 4:30 PM",
      "Tuesday: 8:30 AM – 4:30 PM",
      "Wednesday: 8:30 AM – 4:30 PM",
      "Thursday: 8:30 AM – 4:30 PM",
      "Friday: 8:30 AM – 4:30 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.6,
    "userRatingsTotal": 1409,
    "id": 1555
  },
  {
    "title": "BAANGUNDAM หรือ HERO HOBBY",
    "urlinform": "baangundam-hero-hobby",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "Gundam"
    ],
    "storeWebsite": "http://www.baangundam.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJa4rvx_kl2jAR5xWXdKyM6dI",
    "lat": 18.768695,
    "lng": 98.9752802,
    "placeId": "ChIJa4rvx_kl2jAR5xWXdKyM6dI",
    "businessStatus": "OPERATIONAL",
    "phone": "095 694 6556",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:30 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 10,
    "id": 1556
  },
  {
    "title": "Active Game Collection",
    "urlinform": "active-game-collection",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhdxIia8X2jERjyRCrDtLCiQ",
    "lat": 1.3546891,
    "lng": 103.8777489,
    "placeId": "ChIJhdxIia8X2jERjyRCrDtLCiQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:30 – 6:00 PM",
      "Wednesday: 1:30 – 6:00 PM",
      "Thursday: 1:30 – 6:00 PM",
      "Friday: 1:30 – 6:00 PM",
      "Saturday: 1:30 – 6:00 PM",
      "Sunday: 1:30 – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 48,
    "id": 1557
  },
  {
    "title": "Flagship Games",
    "urlinform": "flagship-games",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "Pokémon"
    ],
    "storeWebsite": "http://www.flagshipgames.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC8z_9j4X2jERU6Jj496GA4g",
    "lat": 1.3574938,
    "lng": 103.8483954,
    "placeId": "ChIJC8z_9j4X2jERU6Jj496GA4g",
    "businessStatus": "OPERATIONAL",
    "phone": "8060 6978",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 111,
    "id": 1558
  },
  {
    "title": "Edition Vault",
    "urlinform": "edition-vault",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBWiSllMZ2jERYR0wEvV1UzE",
    "lat": 1.3045349,
    "lng": 103.8610712,
    "placeId": "ChIJBWiSllMZ2jERYR0wEvV1UzE",
    "businessStatus": "OPERATIONAL",
    "phone": "8993 3168",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 18,
    "id": 1559,
    "district": "Bugis"
  },
  {
    "title": "Toy Or Game",
    "urlinform": "toy-or-game",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://toyorgame.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOadzwroZ2jERpjEdF9VB3uY",
    "lat": 1.2995533,
    "lng": 103.8545611,
    "placeId": "ChIJOadzwroZ2jERpjEdF9VB3uY",
    "businessStatus": "OPERATIONAL",
    "phone": "6634 2637",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:30 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 166,
    "id": 1560,
    "district": "Bugis"
  },
  {
    "title": "Games Haven - Beauty World",
    "urlinform": "games-haven-beauty-world",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Flesh and Blood",
      "MTG"
    ],
    "storeWebsite": "http://gameshaventcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJp8_2cgAR2jERK-ZpMqhJwJc",
    "lat": 1.3417925,
    "lng": 103.7762193,
    "placeId": "ChIJp8_2cgAR2jERK-ZpMqhJwJc",
    "businessStatus": "OPERATIONAL",
    "phone": "9880 8723",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: Closed"
    ],
    "rating": 3.3,
    "userRatingsTotal": 7,
    "id": 1561
  },
  {
    "title": "New Game World",
    "urlinform": "new-game-world",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "MTG",
      "One Piece",
      "Pokémon",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.mgwgames.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs3DSJY8R2jER2eES8DnQi00",
    "lat": 1.328382,
    "lng": 103.752966,
    "placeId": "ChIJs3DSJY8R2jER2eES8DnQi00",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 3,
    "userRatingsTotal": 2,
    "id": 1562,
    "district": "Jurong"
  },
  {
    "title": "GameMartz (Plaza Sing)",
    "urlinform": "gamemartz-plaza-sing",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linktr.ee/GameMartzPlazaSingapura",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQUb825YP2jERB1R_z9rB5x0",
    "lat": 1.3002531,
    "lng": 103.8449843,
    "placeId": "ChIJQUb825YP2jERB1R_z9rB5x0",
    "businessStatus": "OPERATIONAL",
    "phone": "6792 1217",
    "openingHours": [
      "Monday: 11:15 AM – 9:30 PM",
      "Tuesday: 11:15 AM – 9:30 PM",
      "Wednesday: 11:15 AM – 9:30 PM",
      "Thursday: 11:15 AM – 9:30 PM",
      "Friday: 11:15 AM – 9:30 PM",
      "Saturday: 11:15 AM – 9:30 PM",
      "Sunday: 11:15 AM – 9:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 371,
    "id": 1563,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Toy Outpost @ Plaza Singapura",
    "urlinform": "toy-outpost-plaza-singapura",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.toyoutpost.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc6zIfr0Z2jERoAz1y47623w",
    "lat": 1.3003286,
    "lng": 103.8451058,
    "placeId": "ChIJc6zIfr0Z2jERoAz1y47623w",
    "businessStatus": "OPERATIONAL",
    "phone": "6339 9022",
    "openingHours": [
      "Monday: 12:00 – 9:30 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 9:30 PM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 112,
    "id": 1564,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Simply Toys @ Plaza Singapura",
    "urlinform": "simply-toys-plaza-singapura",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.simplytoys.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoyM62ZcZ2jERoipaoAJt-3c",
    "lat": 1.3007111,
    "lng": 103.844904,
    "placeId": "ChIJoyM62ZcZ2jERoipaoAJt-3c",
    "businessStatus": "CLOSED_TEMPORARILY",
    "phone": "8836 4872",
    "openingHours": [],
    "rating": 3.4,
    "userRatingsTotal": 194,
    "id": 1565,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "TOG - Toy Or Game (Plaza Singapura)",
    "urlinform": "tog-toy-or-game-plaza-singapura",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://toyorgame.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo1p0cpIZ2jERotlg6II4Q5I",
    "lat": 1.30061,
    "lng": 103.8452731,
    "placeId": "ChIJo1p0cpIZ2jERotlg6II4Q5I",
    "businessStatus": "OPERATIONAL",
    "phone": "6238 7632",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 96,
    "id": 1566,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Co-Play Singapore",
    "urlinform": "co-play-singapore",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbbBlKmcZ2jERDtJqj7OHaro",
    "lat": 1.2993763,
    "lng": 103.8453547,
    "placeId": "ChIJbbBlKmcZ2jERDtJqj7OHaro",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 9:30 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 67,
    "id": 1567,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Precious Thoughts (Plaza Singapura)",
    "urlinform": "precious-thoughts-plaza-singapura",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoyM62ZcZ2jERwtyDzTr7DWo",
    "lat": 1.3007111,
    "lng": 103.8451085,
    "placeId": "ChIJoyM62ZcZ2jERwtyDzTr7DWo",
    "businessStatus": "OPERATIONAL",
    "phone": "6336 6179",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 145,
    "id": 1568,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Otaku House",
    "urlinform": "otaku-house",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon",
      "Vanguard"
    ],
    "storeWebsite": "https://shop.otakuhouse.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc6zIfr0Z2jERoLAPmTSvx90",
    "lat": 1.3006382,
    "lng": 103.845036,
    "placeId": "ChIJc6zIfr0Z2jERoLAPmTSvx90",
    "businessStatus": "OPERATIONAL",
    "phone": "6884 8414",
    "openingHours": [
      "Monday: 11:30 AM – 9:30 PM",
      "Tuesday: 11:30 AM – 9:30 PM",
      "Wednesday: 11:30 AM – 9:30 PM",
      "Thursday: 11:30 AM – 9:30 PM",
      "Friday: 11:30 AM – 10:00 PM",
      "Saturday: 11:30 AM – 10:00 PM",
      "Sunday: 11:30 AM – 10:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 134,
    "id": 1569,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Plaza Singapura",
    "urlinform": "plaza-singapura",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.plazasingapura.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR1Fyfr0Z2jERzwO-AZiJ-HM",
    "lat": 1.3000678,
    "lng": 103.8447831,
    "placeId": "ChIJR1Fyfr0Z2jERzwO-AZiJ-HM",
    "businessStatus": "OPERATIONAL",
    "phone": "6332 9248",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 22568,
    "id": 1570,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Stereo - The Headphone Concept Store @ Plaza Singapura",
    "urlinform": "stereo-the-headphone-concept-store-plaza-singapura",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.stereo.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc6zIfr0Z2jERGV6qS7VI6Gw",
    "lat": 1.3005118,
    "lng": 103.8448198,
    "placeId": "ChIJc6zIfr0Z2jERGV6qS7VI6Gw",
    "businessStatus": "OPERATIONAL",
    "phone": "6336 7113",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 5876,
    "id": 1571,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Art Friend",
    "urlinform": "art-friend",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.artfriendonline.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYZYCfr0Z2jERSVIIzp1IOuU",
    "lat": 1.3007111,
    "lng": 103.844904,
    "placeId": "ChIJYZYCfr0Z2jERSVIIzp1IOuU",
    "businessStatus": "OPERATIONAL",
    "phone": "6336 1120",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 1487,
    "id": 1572,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Smiggle",
    "urlinform": "smiggle",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://smiggle.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc6zIfr0Z2jERrmblbYx8s04",
    "lat": 1.3005206,
    "lng": 103.8449719,
    "placeId": "ChIJc6zIfr0Z2jERrmblbYx8s04",
    "businessStatus": "OPERATIONAL",
    "phone": "6338 5782",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 69,
    "id": 1573,
    "district": "Plaza Singapura Dhoby Ghaut"
  },
  {
    "title": "Tefuda",
    "urlinform": "tefuda",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Battle Spirits",
      "Gundam",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Vanguard",
      "WS"
    ],
    "storeWebsite": "http://tefudagames.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ26wxoI4X2jERcKjWl0Opfqw",
    "lat": 1.331732,
    "lng": 103.879124,
    "placeId": "ChIJ26wxoI4X2jERcKjWl0Opfqw",
    "businessStatus": "OPERATIONAL",
    "phone": "8896 7818",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 9:30 PM",
      "Wednesday: 3:00 – 9:30 PM",
      "Thursday: 3:00 – 9:30 PM",
      "Friday: 3:00 – 9:30 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 120,
    "id": 1574,
    "district": "Tai Seng MacPherson"
  },
  {
    "title": "Deckard Gaming",
    "urlinform": "deckard-gaming",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.deckardgaming.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJe2v7BbIX2jERIeibfypibdo",
    "lat": 1.3358077,
    "lng": 103.8852906,
    "placeId": "ChIJe2v7BbIX2jERIeibfypibdo",
    "businessStatus": "OPERATIONAL",
    "phone": "9228 4321",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 23,
    "id": 1575
  },
  {
    "title": "Yukai Collectibles",
    "urlinform": "yukai-collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPVguJcwX2jERLensbLa8HwM",
    "lat": 1.3322152,
    "lng": 103.8903577,
    "placeId": "ChIJPVguJcwX2jERLensbLa8HwM",
    "businessStatus": "OPERATIONAL",
    "phone": "9392 3932",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 PM – 12:00 AM",
      "Wednesday: 3:00 PM – 12:00 AM",
      "Thursday: 3:00 PM – 12:00 AM",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 3:00 PM – 12:00 AM",
      "Sunday: 3:00 PM – 12:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 40,
    "id": 1576
  },
  {
    "title": "Art of Cards",
    "urlinform": "art-of-cards",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://t.me/artofcards",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi5ftw9wX2jERhi89EfaEeTE",
    "lat": 1.3353892,
    "lng": 103.8855939,
    "placeId": "ChIJi5ftw9wX2jERhi89EfaEeTE",
    "businessStatus": "OPERATIONAL",
    "phone": "8484 3238",
    "openingHours": [
      "Monday: 2:30 – 10:30 PM",
      "Tuesday: 2:30 – 10:30 PM",
      "Wednesday: 2:30 – 10:30 PM",
      "Thursday: 2:30 – 10:30 PM",
      "Friday: 2:30 – 10:30 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 47,
    "id": 1577,
    "district": "Tai Seng MacPherson"
  },
  {
    "title": "That Card Shop SG (TCS)",
    "urlinform": "that-card-shop-sg-tcs",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://thatlocalstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJWD7lRkX2jER9TejB2_eRms",
    "lat": 1.3371344,
    "lng": 103.8905766,
    "placeId": "ChIJJWD7lRkX2jER9TejB2_eRms",
    "businessStatus": "OPERATIONAL",
    "phone": "8114 4265",
    "openingHours": [
      "Monday: 3:00 – 8:30 PM",
      "Tuesday: 3:00 – 8:30 PM",
      "Wednesday: 3:00 – 8:30 PM",
      "Thursday: 3:00 – 8:30 PM",
      "Friday: 3:00 – 8:30 PM",
      "Saturday: 3:00 – 8:30 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1578
  },
  {
    "title": "The Card Lounge - Pokemon Riftbound & More (In Cafe Barco)",
    "urlinform": "the-card-lounge-pokemon-and-sports-inside-cafe-barco",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIW9HFSgX2jER4Vxy1gCYDPM",
    "lat": 1.3358165,
    "lng": 103.9097526,
    "placeId": "ChIJIW9HFSgX2jER4Vxy1gCYDPM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:30 AM – 8:30 PM",
      "Tuesday: Closed",
      "Wednesday: 11:30 AM – 8:30 PM",
      "Thursday: 11:30 AM – 8:30 PM",
      "Friday: 11:30 AM – 8:30 PM",
      "Saturday: Closed",
      "Sunday: 11:30 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 53,
    "id": 1579
  },
  {
    "title": "Matt's Vault",
    "urlinform": "matts-vault",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Mattsvault/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ82hIkKEX2jERRcFtDbtJ8OM",
    "lat": 1.3358564,
    "lng": 103.885446,
    "placeId": "ChIJ82hIkKEX2jERRcFtDbtJ8OM",
    "businessStatus": "OPERATIONAL",
    "phone": "9720 8290",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: Closed",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.4,
    "userRatingsTotal": 143,
    "id": 1580
  },
  {
    "title": "PostPackClarity",
    "urlinform": "postpackclarity",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJk7vji68X2jERYwJAwWPbg70",
    "lat": 1.3552773,
    "lng": 103.8876002,
    "placeId": "ChIJk7vji68X2jERYwJAwWPbg70",
    "businessStatus": "OPERATIONAL",
    "phone": "9741 8713",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: Closed",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 132,
    "id": 1581
  },
  {
    "title": "PLAY UNITED",
    "urlinform": "play-united",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJA-qABgAX2jERar6uJc-SbfE",
    "lat": 1.372408,
    "lng": 103.893821,
    "placeId": "ChIJA-qABgAX2jERar6uJc-SbfE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 154,
    "id": 1582
  },
  {
    "title": "Card Connect",
    "urlinform": "card-connect",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.cardconnectsg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB_Z--lMZ2jER21y3UhAO3pM",
    "lat": 1.3182598,
    "lng": 103.8813786,
    "placeId": "ChIJB_Z--lMZ2jER21y3UhAO3pM",
    "businessStatus": "OPERATIONAL",
    "phone": "9151 3557",
    "openingHours": [
      "Monday: 2:30 – 10:00 PM",
      "Tuesday: 2:30 – 10:00 PM",
      "Wednesday: 2:30 – 10:00 PM",
      "Thursday: 2:30 – 11:30 PM",
      "Friday: 2:30 – 11:30 PM",
      "Saturday: 2:30 – 11:30 PM",
      "Sunday: 2:30 – 11:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 87,
    "id": 1583,
    "district": "Tai Seng MacPherson"
  },
  {
    "title": "PokeMakTCG",
    "urlinform": "pokemaktcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJX9yVhA0X2jER70gRrBqiBN4",
    "lat": 1.3324618,
    "lng": 103.8903176,
    "placeId": "ChIJX9yVhA0X2jER70gRrBqiBN4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 49,
    "id": 1584
  },
  {
    "title": "TTZ ONE",
    "urlinform": "ttz-one",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzbTyqTcW2jERVI188pLy2H4",
    "lat": 1.3712175,
    "lng": 103.8941646,
    "placeId": "ChIJzbTyqTcW2jERVI188pLy2H4",
    "businessStatus": "OPERATIONAL",
    "phone": "9125 9290",
    "openingHours": [
      "Monday: 11:00 AM – 8:30 PM",
      "Tuesday: 11:00 AM – 8:30 PM",
      "Wednesday: 11:00 AM – 8:30 PM",
      "Thursday: 11:00 AM – 8:30 PM",
      "Friday: 11:00 AM – 8:30 PM",
      "Saturday: 11:00 AM – 8:30 PM",
      "Sunday: 11:00 AM – 8:30 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 107,
    "id": 1585
  },
  {
    "title": "Ah Kit Store",
    "urlinform": "ah-kit-store",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTbcSBl0X2jERLX7GVKf8ZHA",
    "lat": 1.3362524,
    "lng": 103.8864057,
    "placeId": "ChIJTbcSBl0X2jERLX7GVKf8ZHA",
    "businessStatus": "OPERATIONAL",
    "phone": "9176 3584",
    "openingHours": [
      "Monday: 5:00 – 10:00 PM",
      "Tuesday: 5:00 – 10:00 PM",
      "Wednesday: Closed",
      "Thursday: 5:00 – 10:00 PM",
      "Friday: 5:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 6:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 24,
    "id": 1586
  },
  {
    "title": "ThePeachTCG Pte Ltd",
    "urlinform": "thepeachtcg-pte-ltd",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuUagaSoZ2jERwppcKJoQMfw",
    "lat": 1.3048175,
    "lng": 103.9040639,
    "placeId": "ChIJuUagaSoZ2jERwppcKJoQMfw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 4:00 PM – 2:00 AM",
      "Wednesday: 4:00 PM – 2:00 AM",
      "Thursday: 4:00 PM – 2:00 AM",
      "Friday: 4:00 PM – 2:00 AM",
      "Saturday: 6:00 PM – 2:00 AM",
      "Sunday: 6:00 PM – 2:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 178,
    "id": 1587
  },
  {
    "title": "TableTop (PECS Trading Company)",
    "urlinform": "tabletop-pecs-trading-company",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/tabletop.singapore",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzdbNLEUX2jERe4tMXW1xXLs",
    "lat": 1.3265946,
    "lng": 103.8755727,
    "placeId": "ChIJzdbNLEUX2jERe4tMXW1xXLs",
    "businessStatus": "OPERATIONAL",
    "phone": "8028 8098",
    "openingHours": [
      "Monday: 2:30 – 6:30 PM",
      "Tuesday: 2:30 – 9:30 PM",
      "Wednesday: 2:30 – 6:30 PM",
      "Thursday: 2:30 – 9:30 PM",
      "Friday: 2:30 – 6:30 PM",
      "Saturday: 3:00 – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.3,
    "userRatingsTotal": 18,
    "id": 1588,
    "district": "Tai Seng MacPherson"
  },
  {
    "title": "EmpireCardz",
    "urlinform": "empirecardz",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBQL8KEQY2jERmXDBKCZLkdg",
    "lat": 1.3026928,
    "lng": 103.8831417,
    "placeId": "ChIJBQL8KEQY2jERmXDBKCZLkdg",
    "businessStatus": "OPERATIONAL",
    "phone": "8178 5880",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 98,
    "id": 1589
  },
  {
    "title": "Sentinel Games",
    "urlinform": "sentinel-games",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "One Piece",
      "Vanguard",
      "WS"
    ],
    "storeWebsite": "https://www.sentinelgamessg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjRcOjxsX2jERq8FBrJ5BsGc",
    "lat": 1.3370547,
    "lng": 103.8869414,
    "placeId": "ChIJjRcOjxsX2jERq8FBrJ5BsGc",
    "businessStatus": "OPERATIONAL",
    "phone": "8993 8994",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 42,
    "id": 1590
  },
  {
    "title": "Team Board Game",
    "urlinform": "team-board-game",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Gundam",
      "MTG",
      "One Piece"
    ],
    "storeWebsite": "https://www.teamboardgame.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJURRUbrwZ2jERu6ckQt08hYw",
    "lat": 1.3253532,
    "lng": 103.8915152,
    "placeId": "ChIJURRUbrwZ2jERu6ckQt08hYw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 142,
    "id": 1591,
    "district": "Tai Seng MacPherson"
  },
  {
    "title": "SCC Consignments",
    "urlinform": "scc-consignments",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.consignscc.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWTUqp2QX2jERpV03lh2ADU8",
    "lat": 1.3371344,
    "lng": 103.8905766,
    "placeId": "ChIJWTUqp2QX2jERpV03lh2ADU8",
    "businessStatus": "OPERATIONAL",
    "phone": "8882 1722",
    "openingHours": [
      "Monday: 9:00 AM – 5:00 PM",
      "Tuesday: 9:00 AM – 5:00 PM",
      "Wednesday: 9:00 AM – 5:00 PM",
      "Thursday: 9:00 AM – 5:00 PM",
      "Friday: 9:00 AM – 5:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 74,
    "id": 1592
  },
  {
    "title": "Concept Armour",
    "urlinform": "concept-armour",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJw13xem4X2jERwd2Pd9NFi5c",
    "lat": 1.3371344,
    "lng": 103.8905766,
    "placeId": "ChIJw13xem4X2jERwd2Pd9NFi5c",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1593
  },
  {
    "title": "TCG CULT MY",
    "urlinform": "tcg-cult-my",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmZ01G6g3zDERvUgD9hvdpyg",
    "lat": 3.1578765,
    "lng": 101.7143787,
    "placeId": "ChIJmZ01G6g3zDERvUgD9hvdpyg",
    "businessStatus": "CLOSED_TEMPORARILY",
    "phone": "013-937 3677",
    "openingHours": [],
    "rating": 1,
    "userRatingsTotal": 1,
    "id": 1594,
    "district": "KLCC"
  },
  {
    "title": "The Private Collective MY",
    "urlinform": "the-private-collective-my",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linktr.ee/theprivatecollective",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8zku9KpPzDERXBcHZB-KI5M",
    "lat": 3.1135917,
    "lng": 101.5756237,
    "placeId": "ChIJ8zku9KpPzDERXBcHZB-KI5M",
    "businessStatus": "OPERATIONAL",
    "phone": "011-8888 0419",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 1595
  },
  {
    "title": "Tulis Lukis by Loka Made",
    "urlinform": "tulis-lukis-by-loka-made",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lokamade.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDXTUYxtJzDEReXrRii_Du6A",
    "lat": 3.145704,
    "lng": 101.6955325,
    "placeId": "ChIJDXTUYxtJzDEReXrRii_Du6A",
    "businessStatus": "OPERATIONAL",
    "phone": "010-932 1452",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2610,
    "id": 1596,
    "district": "Petaling Street"
  },
  {
    "title": "Sonny Box Breaks Midvalley",
    "urlinform": "sonny-box-breaks-midvalley",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.sonnyboxbreaks.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5U8PdwBJzDERsjbnCzzJal4",
    "lat": 3.1181728,
    "lng": 101.6783391,
    "placeId": "ChIJ5U8PdwBJzDERsjbnCzzJal4",
    "businessStatus": "OPERATIONAL",
    "phone": "016-216 0612",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 35,
    "id": 1597,
    "district": "Mid Valley"
  },
  {
    "title": "Shiok Collection Sdn Bhd (Jalan Petaling, KL)",
    "urlinform": "shiok-collection-sdn-bhd-jalan-petaling-kl",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://shiokcollection.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuwEte9BJzDERDAfXH1wASqc",
    "lat": 3.1422311,
    "lng": 101.6978424,
    "placeId": "ChIJuwEte9BJzDERDAfXH1wASqc",
    "businessStatus": "OPERATIONAL",
    "phone": "03-2031 3881",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 6:00 PM",
      "Wednesday: 9:00 AM – 6:00 PM",
      "Thursday: 9:00 AM – 6:00 PM",
      "Friday: 9:00 AM – 6:00 PM",
      "Saturday: 9:00 AM – 5:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.3,
    "userRatingsTotal": 125,
    "id": 1598,
    "district": "Petaling Street"
  },
  {
    "title": "Mission World - Mid Valley KL",
    "urlinform": "mission-world-mid-valley-kl",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "One Piece",
      "Union Arena"
    ],
    "storeWebsite": "https://www.missionworldstore.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWVX8fY5JzDERtbNsNXqrzos",
    "lat": 3.1192351,
    "lng": 101.677526,
    "placeId": "ChIJWVX8fY5JzDERtbNsNXqrzos",
    "businessStatus": "OPERATIONAL",
    "phone": "012-953 4211",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3471,
    "id": 1599,
    "district": "Mid Valley"
  },
  {
    "title": "Impulse Gaming Mid Valley KL",
    "urlinform": "impulse-gaming-mid-valley-kl",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Pokémon"
    ],
    "storeWebsite": "https://www.impulse.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK5BYostJzDERyZHE-YzRtm4",
    "lat": 3.1168779,
    "lng": 101.6772665,
    "placeId": "ChIJK5BYostJzDERyZHE-YzRtm4",
    "businessStatus": "OPERATIONAL",
    "phone": "019-734 0633",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 97,
    "id": 1600,
    "district": "Mid Valley"
  },
  {
    "title": "Ace Cards - Collect A Deck • 1 Utama",
    "urlinform": "ace-cards-collect-a-deck-1-utama",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://acecards.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDSYuYBBJzDERrFK0CDJ0Nio",
    "lat": 3.1485323,
    "lng": 101.6167651,
    "placeId": "ChIJDSYuYBBJzDERrFK0CDJ0Nio",
    "businessStatus": "OPERATIONAL",
    "phone": "012-811 3589",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:30 PM",
      "Saturday: 10:00 AM – 10:30 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 43,
    "id": 1601
  },
  {
    "title": "CeX",
    "urlinform": "cex",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://my.webuy.com/site/storeDetail/?branchId=25005",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJe27-1lNJzDERuzXP1xNXevM",
    "lat": 3.1175628,
    "lng": 101.6774073,
    "placeId": "ChIJe27-1lNJzDERuzXP1xNXevM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 479,
    "id": 1602,
    "district": "Mid Valley"
  },
  {
    "title": "The Paper Boutique - Mid Valley Megamall",
    "urlinform": "the-paper-boutique-mid-valley-megamall",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.midvalley.com.my/tenant/ThePaperBoutique/094d897b-cd37-4317-b0eb-3966352b6301/SHOP",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJp6_-s45JzDERsFUeKf2baik",
    "lat": 3.1180888,
    "lng": 101.6776678,
    "placeId": "ChIJp6_-s45JzDERsFUeKf2baik",
    "businessStatus": "OPERATIONAL",
    "phone": "012-375 0880",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 166,
    "id": 1603,
    "district": "Mid Valley"
  },
  {
    "title": "Box Hunt - Mid Valley Megamall",
    "urlinform": "box-hunt-mid-valley-megamall",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/boxhuntmy",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQUeYqfxJzDERY1ZOcrGPyds",
    "lat": 3.1171283,
    "lng": 101.677182,
    "placeId": "ChIJQUeYqfxJzDERY1ZOcrGPyds",
    "businessStatus": "OPERATIONAL",
    "phone": "019-717 7133",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 146,
    "id": 1604,
    "district": "Mid Valley"
  },
  {
    "title": "Midvalley Megamall Typo",
    "urlinform": "midvalley-megamall-typo",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cottonon.com/MY/typo-home/?utm_source=google-store-profiles&utm_medium=organic&utm_campaign=google-store-TYPO-MY&utm_id=google-store-7726-TYPO",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ60ly_NFJzDERPd02xHXwJEs",
    "lat": 3.1184811,
    "lng": 101.6776826,
    "placeId": "ChIJ60ly_NFJzDERPd02xHXwJEs",
    "businessStatus": "OPERATIONAL",
    "phone": "03-2052 6009",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 13,
    "id": 1605,
    "district": "Mid Valley"
  },
  {
    "title": "HOBIBEAR GAMING",
    "urlinform": "hobibear-gaming",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJeRP9StM1zDERJUMlQ2BZnA4",
    "lat": 3.0814057,
    "lng": 101.7376678,
    "placeId": "ChIJeRP9StM1zDERJUMlQ2BZnA4",
    "businessStatus": "OPERATIONAL",
    "phone": "017-736 2638",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 PM – 12:00 AM",
      "Wednesday: 2:00 PM – 12:00 AM",
      "Thursday: 2:00 PM – 12:00 AM",
      "Friday: 2:00 PM – 12:00 AM",
      "Saturday: 2:00 PM – 12:00 AM",
      "Sunday: 2:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 229,
    "id": 1606,
    "district": "Cheras"
  },
  {
    "title": "Hobby Outpost (Cheras)",
    "urlinform": "hobby-outpost-cheras",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Digimon",
      "Flesh and Blood",
      "One Piece",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "https://sites.google.com/view/hobbyoutpostcheras/home",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmYIXR-k1zDERt-CyeRmzGiE",
    "lat": 3.0374001,
    "lng": 101.7656454,
    "placeId": "ChIJmYIXR-k1zDERt-CyeRmzGiE",
    "businessStatus": "OPERATIONAL",
    "phone": "010-820 9075",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 10:30 PM",
      "Wednesday: 3:00 – 10:30 PM",
      "Thursday: 3:00 – 10:30 PM",
      "Friday: 3:00 – 10:30 PM",
      "Saturday: 3:00 – 10:30 PM",
      "Sunday: 10:30 AM – 6:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 27,
    "id": 1607
  },
  {
    "title": "Monxter",
    "urlinform": "monxter",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Digimon",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "https://deskmonxter.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjThtW0c1zDERRhjZYxThgjM",
    "lat": 3.0806548,
    "lng": 101.7329081,
    "placeId": "ChIJjThtW0c1zDERRhjZYxThgjM",
    "businessStatus": "OPERATIONAL",
    "phone": "012-825 8843",
    "openingHours": [
      "Monday: 12:00 PM – 12:00 AM",
      "Tuesday: 12:00 PM – 12:00 AM",
      "Wednesday: 12:00 PM – 12:00 AM",
      "Thursday: 12:00 PM – 12:00 AM",
      "Friday: 12:00 PM – 12:00 AM",
      "Saturday: 12:00 PM – 12:00 AM",
      "Sunday: 12:00 PM – 12:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 124,
    "id": 1608
  },
  {
    "title": "007 TCG EMPIRE",
    "urlinform": "007-tcg-empire",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh8qWXB03zDERbftAtJa8B8g",
    "lat": 3.1285708,
    "lng": 101.7332258,
    "placeId": "ChIJh8qWXB03zDERbftAtJa8B8g",
    "businessStatus": "OPERATIONAL",
    "phone": "012-511 0051",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1609
  },
  {
    "title": "The Card Go-Getters (TCGG)",
    "urlinform": "the-card-go-getters-tcgg",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/people/The-Card-Go-Getters-PLT/61587144134449/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn9NZMjE1zDER0lMmXh1Utks",
    "lat": 3.062344,
    "lng": 101.7586481,
    "placeId": "ChIJn9NZMjE1zDER0lMmXh1Utks",
    "businessStatus": "OPERATIONAL",
    "phone": "019-255 6929",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 14,
    "id": 1610
  },
  {
    "title": "GamerHubStore.Shop",
    "urlinform": "gamerhubstoreshop",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://gamerhubstore.shop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0fGZhmJHzDERHbz-IsEpiZM",
    "lat": 3.0777286,
    "lng": 101.7505064,
    "placeId": "ChIJ0fGZhmJHzDERHbz-IsEpiZM",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1599 1599",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 153,
    "id": 1611,
    "district": "Cheras"
  },
  {
    "title": "Zone Quest Station",
    "urlinform": "zone-quest-station",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/zonequeststation",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5TyQd8M1zDERFnw3qp9n4oE",
    "lat": 3.0989896,
    "lng": 101.7349349,
    "placeId": "ChIJ5TyQd8M1zDERFnw3qp9n4oE",
    "businessStatus": "OPERATIONAL",
    "phone": "012-686 6106",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 100,
    "id": 1612
  },
  {
    "title": "Cloud Online Mart",
    "urlinform": "cloud-online-mart",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/share/1BUmAhWN6U/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJp1-fnwQ1zDERkUGe8J7mjxE",
    "lat": 3.1004099,
    "lng": 101.7139946,
    "placeId": "ChIJp1-fnwQ1zDERkUGe8J7mjxE",
    "businessStatus": "OPERATIONAL",
    "phone": "011-2431 6626",
    "openingHours": [
      "Monday: 7:00 AM – 1:00 AM",
      "Tuesday: 7:00 AM – 1:00 AM",
      "Wednesday: 7:00 AM – 1:00 AM",
      "Thursday: 7:00 AM – 1:00 AM",
      "Friday: 7:00 AM – 1:00 AM",
      "Saturday: 7:00 AM – 1:00 AM",
      "Sunday: 7:00 AM – 1:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 177,
    "id": 1613
  },
  {
    "title": "Game Houz Cheras",
    "urlinform": "game-houz-cheras",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://gamehouz.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4x78hhU1zDERHSQxHTsLlLE",
    "lat": 3.034748,
    "lng": 101.763132,
    "placeId": "ChIJ4x78hhU1zDERHSQxHTsLlLE",
    "businessStatus": "OPERATIONAL",
    "phone": "010-765 0772",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 92,
    "id": 1614
  },
  {
    "title": "Cards & Games Capital",
    "urlinform": "cards-games-capital",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW9xUb5q1zTERUlOZIA7Z0VA",
    "lat": 3.020644,
    "lng": 101.699876,
    "placeId": "ChIJW9xUb5q1zTERUlOZIA7Z0VA",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1095 1439",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 12:30 – 7:00 PM",
      "Sunday: 12:30 – 7:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 45,
    "id": 1615
  },
  {
    "title": "Cardinals Hobby Store",
    "urlinform": "cardinals-hobby-store",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Flesh and Blood",
      "MTG",
      "Pokémon"
    ],
    "storeWebsite": "https://cardinalshobby-tcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2Z_JrIqzzTERl8Icpv_fhSE",
    "lat": 3.0239858,
    "lng": 101.5819658,
    "placeId": "ChIJ2Z_JrIqzzTERl8Icpv_fhSE",
    "businessStatus": "OPERATIONAL",
    "phone": "018-660 0559",
    "openingHours": [
      "Monday: 6:00 – 11:00 PM",
      "Tuesday: 6:00 – 11:00 PM",
      "Wednesday: Closed",
      "Thursday: 6:00 – 11:00 PM",
      "Friday: 6:00 – 11:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 64,
    "id": 1616
  },
  {
    "title": "Pod Mart Cheras (LRT Cheras)",
    "urlinform": "pod-mart-cheras-lrt-cheras",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJdznVuYI3zDERsdbMkV_ifqo",
    "lat": 3.1126642,
    "lng": 101.7155267,
    "placeId": "ChIJdznVuYI3zDERsdbMkV_ifqo",
    "businessStatus": "OPERATIONAL",
    "phone": "012-392 6610",
    "openingHours": [
      "Monday: 1:00 – 11:00 PM",
      "Tuesday: 1:00 – 11:00 PM",
      "Wednesday: 1:00 – 11:00 PM",
      "Thursday: 1:00 – 11:00 PM",
      "Friday: 1:00 – 11:00 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 397,
    "id": 1617
  },
  {
    "title": "VORTEX MY EMPIRE",
    "urlinform": "vortex-my-empire",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg1zizJA5zDER9auVOs2eJsE",
    "lat": 3.1951887,
    "lng": 101.7116856,
    "placeId": "ChIJg1zizJA5zDER9auVOs2eJsE",
    "businessStatus": "OPERATIONAL",
    "phone": "012-614 2104",
    "openingHours": [
      "Monday: 1:00 – 11:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 11:00 PM",
      "Thursday: 1:00 – 11:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 17,
    "id": 1618
  },
  {
    "title": "Pokemon PlayLab One Utama",
    "urlinform": "pokemon-playlab-one-utama",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrxzLHQBPzDERcwh8ZpwjVPU",
    "lat": 3.1481566,
    "lng": 101.6150319,
    "placeId": "ChIJrxzLHQBPzDERcwh8ZpwjVPU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 22,
    "id": 1619
  },
  {
    "title": "Axes & Hexes",
    "urlinform": "axes-hexes",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/axesnhexes/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuVpWcZQ5zDERrbUc2iok5sc",
    "lat": 3.1948257,
    "lng": 101.7316514,
    "placeId": "ChIJuVpWcZQ5zDERrbUc2iok5sc",
    "businessStatus": "OPERATIONAL",
    "phone": "017-301 7863",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 7:30 – 11:00 PM",
      "Wednesday: 7:30 – 11:00 PM",
      "Thursday: Closed",
      "Friday: 7:30 PM – 12:00 AM",
      "Saturday: 11:30 AM – 5:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.6,
    "userRatingsTotal": 14,
    "id": 1620,
    "district": "Setapak"
  },
  {
    "title": "Discover Collectibles",
    "urlinform": "discover-collectibles",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0QvI7DlHzDER7wl1aMxoGRo",
    "lat": 3.210721,
    "lng": 101.6470232,
    "placeId": "ChIJ0QvI7DlHzDER7wl1aMxoGRo",
    "businessStatus": "OPERATIONAL",
    "phone": "012-948 9582",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 88,
    "id": 1621
  },
  {
    "title": "CTRL + PLAY (Setapak) Sim Racing | Pool | PS5",
    "urlinform": "ctrl-play-setapak-sim-racing-pool-ps5",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://app.ctrlplay.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ93bwkVo5zDERm7ONYZIJ000",
    "lat": 3.2018662,
    "lng": 101.7179324,
    "placeId": "ChIJ93bwkVo5zDERm7ONYZIJ000",
    "businessStatus": "OPERATIONAL",
    "phone": "010-206 8868",
    "openingHours": [
      "Monday: 12:00 PM – 2:00 AM",
      "Tuesday: 12:00 PM – 2:00 AM",
      "Wednesday: 12:00 PM – 2:00 AM",
      "Thursday: 12:00 PM – 2:00 AM",
      "Friday: 12:00 PM – 2:00 AM",
      "Saturday: 12:00 PM – 2:00 AM",
      "Sunday: 12:00 PM – 2:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 1720,
    "id": 1622
  },
  {
    "title": "ALL IT Xpress @ Setapak Central Mall",
    "urlinform": "all-it-xpress-setapak-central-mall",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.allithypermarket.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCQp9BhE4zDERt0tyACebwbk",
    "lat": 3.2045231,
    "lng": 101.7202131,
    "placeId": "ChIJCQp9BhE4zDERt0tyACebwbk",
    "businessStatus": "OPERATIONAL",
    "phone": "03-4143 8869",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 77,
    "id": 1623
  },
  {
    "title": "Gadgethub Official Store @ Setapak Central",
    "urlinform": "gadgethub-official-store-setapak-central",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXYHxpO45zDERevnwmegtXBE",
    "lat": 3.2045747,
    "lng": 101.7205297,
    "placeId": "ChIJXYHxpO45zDERevnwmegtXBE",
    "businessStatus": "OPERATIONAL",
    "phone": "014-318 8283",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 40,
    "id": 1624
  },
  {
    "title": "JK Florist & Party Shop @ Setapak",
    "urlinform": "jk-florist-party-shop-setapak",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.jkfloristt.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxdXzrOE5zDERZJ1sl2tYIqY",
    "lat": 3.1998434,
    "lng": 101.7165011,
    "placeId": "ChIJxdXzrOE5zDERZJ1sl2tYIqY",
    "businessStatus": "OPERATIONAL",
    "phone": "012-396 8365",
    "openingHours": [
      "Monday: 9:00 AM – 2:00 AM",
      "Tuesday: 9:00 AM – 2:00 AM",
      "Wednesday: 9:00 AM – 2:00 AM",
      "Thursday: 9:00 AM – 2:00 AM",
      "Friday: 9:00 AM – 2:00 AM",
      "Saturday: 9:00 AM – 2:00 AM",
      "Sunday: 9:00 AM – 2:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 2038,
    "id": 1625
  },
  {
    "title": "Ping Ooi Card Game Trading",
    "urlinform": "ping-ooi-card-game-trading",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61559608318548&mibextid=ZbWKwL",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP3aGSwDDSjARTRG90qrt19A",
    "lat": 5.4493991,
    "lng": 100.2979221,
    "placeId": "ChIJP3aGSwDDSjARTRG90qrt19A",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 4:00 – 10:00 PM",
      "Friday: 4:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 1626
  },
  {
    "title": "Shuffle by Snacks & Ladders",
    "urlinform": "shuffle-by-snacks-ladders",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://playatshuffle.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv4ZneoXDSjARD55DOeOSfzw",
    "lat": 5.3994364,
    "lng": 100.3151915,
    "placeId": "ChIJv4ZneoXDSjARD55DOeOSfzw",
    "businessStatus": "OPERATIONAL",
    "phone": "010-392 7087",
    "openingHours": [
      "Monday: 7:00 – 11:30 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 7:00 – 11:30 PM",
      "Friday: 7:00 – 11:30 PM",
      "Saturday: 3:00 – 11:30 PM",
      "Sunday: 3:00 – 11:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 8,
    "id": 1627
  },
  {
    "title": "The Postcard Shop",
    "urlinform": "the-postcard-shop",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJkU5rxo3DSjARD0O69dSwxUg",
    "lat": 5.414105200000001,
    "lng": 100.3405997,
    "placeId": "ChIJkU5rxo3DSjARD0O69dSwxUg",
    "businessStatus": "OPERATIONAL",
    "phone": "012-202 2638",
    "openingHours": [
      "Monday: 7:30 AM – 6:00 PM",
      "Tuesday: 7:30 AM – 6:00 PM",
      "Wednesday: 7:30 AM – 6:00 PM",
      "Thursday: 7:30 AM – 6:00 PM",
      "Friday: 7:30 AM – 6:00 PM",
      "Saturday: 7:30 AM – 6:00 PM",
      "Sunday: 7:30 AM – 6:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 205,
    "id": 1628
  },
  {
    "title": "NICEDAY Gift Shop, Florist, Party Balloon, Blind Box Toys, Wrapping Service In Prangin Mall",
    "urlinform": "niceday-gift-shop-florist-party-balloon-blind-box-toys-wrapping-service-in-prangin-mall",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.nicedayshoppe.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5aU2PpTDSjAR605UBVwUI1o",
    "lat": 5.414683,
    "lng": 100.331112,
    "placeId": "ChIJ5aU2PpTDSjAR605UBVwUI1o",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:30 PM",
      "Saturday: 10:30 AM – 9:30 PM",
      "Sunday: 10:30 AM – 9:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1183,
    "id": 1629,
    "district": "Georgetown"
  },
  {
    "title": "The Postcard Shop@pitt",
    "urlinform": "the-postcard-shoppitt",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYXNLqU_DSjARFBjiqY2xyn4",
    "lat": 5.41745,
    "lng": 100.338022,
    "placeId": "ChIJYXNLqU_DSjARFBjiqY2xyn4",
    "businessStatus": "OPERATIONAL",
    "phone": "016-444 7179",
    "openingHours": [
      "Monday: 9:00 AM – 5:00 PM",
      "Tuesday: 9:00 AM – 5:00 PM",
      "Wednesday: 9:00 AM – 5:00 PM",
      "Thursday: 9:00 AM – 5:00 PM",
      "Friday: 9:00 AM – 5:00 PM",
      "Saturday: 9:00 AM – 5:00 PM",
      "Sunday: 9:00 AM – 5:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 52,
    "id": 1630,
    "district": "Georgetown"
  },
  {
    "title": "Penang Hot Print (Factory Direct)",
    "urlinform": "penang-hot-print-factory-direct",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.hotprint.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJeXIWpr3DSjAR75b0uL6yZV0",
    "lat": 5.415288299999999,
    "lng": 100.3213203,
    "placeId": "ChIJeXIWpr3DSjAR75b0uL6yZV0",
    "businessStatus": "OPERATIONAL",
    "phone": "04-227 7606",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 6:00 PM",
      "Wednesday: 9:00 AM – 6:00 PM",
      "Thursday: 9:00 AM – 6:00 PM",
      "Friday: 9:00 AM – 6:00 PM",
      "Saturday: 9:00 AM – 2:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.5,
    "userRatingsTotal": 229,
    "id": 1631,
    "district": "Georgetown"
  },
  {
    "title": "DeckOutDen",
    "urlinform": "deckoutden",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAZz_TKHLzTERX6LJZcVW_ck",
    "lat": 2.9684518,
    "lng": 101.7889542,
    "placeId": "ChIJAZz_TKHLzTERX6LJZcVW_ck",
    "businessStatus": "OPERATIONAL",
    "phone": "019-998 4916",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 11:00 PM",
      "Thursday: 2:00 – 11:00 PM",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 12:00 PM – 12:00 AM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 87,
    "id": 1632
  },
  {
    "title": "Switch @ Gurney Paragon Mall",
    "urlinform": "switch-gurney-paragon-mall",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/pages/Switch-Gurney-Paragon/632272186792686?nr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNwY1SwHDSjARyrkSBhSYqPo",
    "lat": 5.4353348,
    "lng": 100.3108517,
    "placeId": "ChIJNwY1SwHDSjARyrkSBhSYqPo",
    "businessStatus": "OPERATIONAL",
    "phone": "04-218 9591",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 946,
    "id": 1633,
    "district": "Gurney"
  },
  {
    "title": "Puzzle Planet - Sunway Carnival",
    "urlinform": "puzzle-planet-sunway-carnival",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.puzzleplanet.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoStN_knFSjAR-cKr0zaZb90",
    "lat": 5.398784,
    "lng": 100.3979849,
    "placeId": "ChIJoStN_knFSjAR-cKr0zaZb90",
    "businessStatus": "OPERATIONAL",
    "phone": "04-287 5023",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 33,
    "id": 1634
  },
  {
    "title": "TOP TOY Queensbay Mall",
    "urlinform": "top-toy-queensbay-mall",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8V6lawDBSjARddayY0922Bw",
    "lat": 5.333048799999999,
    "lng": 100.3065283,
    "placeId": "ChIJ8V6lawDBSjARddayY0922Bw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 10:30 PM",
      "Tuesday: 10:30 AM – 10:30 PM",
      "Wednesday: 10:30 AM – 10:30 PM",
      "Thursday: 10:30 AM – 10:30 PM",
      "Friday: 10:30 AM – 10:30 PM",
      "Saturday: 10:30 AM – 10:30 PM",
      "Sunday: 10:30 AM – 10:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 11,
    "id": 1635
  },
  {
    "title": "Starship Clothing Queensbay Mall",
    "urlinform": "starship-clothing-queensbay-mall",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.starship.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyaQj-DDBSjARlbLGjE-chtc",
    "lat": 5.333048799999999,
    "lng": 100.3065283,
    "placeId": "ChIJyaQj-DDBSjARlbLGjE-chtc",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1295 2628",
    "openingHours": [
      "Monday: 10:30 AM – 10:30 PM",
      "Tuesday: 10:30 AM – 10:30 PM",
      "Wednesday: 10:30 AM – 10:30 PM",
      "Thursday: 10:30 AM – 10:30 PM",
      "Friday: 10:30 AM – 10:30 PM",
      "Saturday: 10:30 AM – 10:30 PM",
      "Sunday: 10:30 AM – 10:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 69,
    "id": 1636
  },
  {
    "title": "YONEX Eternal sport",
    "urlinform": "yonex-eternal-sport",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Eternalsportstrading/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuxmlSTrBSjARTriWdIfLXTQ",
    "lat": 5.3255469,
    "lng": 100.2819982,
    "placeId": "ChIJuxmlSTrBSjARTriWdIfLXTQ",
    "businessStatus": "OPERATIONAL",
    "phone": "04-611 0379",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 3.7,
    "userRatingsTotal": 49,
    "id": 1637
  },
  {
    "title": "Impulse Gaming (Autocity Flagship Store)",
    "urlinform": "impulse-gaming-autocity-flagship-store",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Pokémon"
    ],
    "storeWebsite": "https://www.impulse.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt3X2loXHSjAR7w3wzP44f_Y",
    "lat": 5.336182099999999,
    "lng": 100.429266,
    "placeId": "ChIJt3X2loXHSjAR7w3wzP44f_Y",
    "businessStatus": "OPERATIONAL",
    "phone": "019-837 0633",
    "openingHours": [
      "Monday: 11:00 AM – 11:00 PM",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 326,
    "id": 1638
  },
  {
    "title": "D Net Gaming Zone",
    "urlinform": "d-net-gaming-zone",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/DNetgamingzone/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJa7U4zj3ASjAROT1PCGt2KvA",
    "lat": 5.3306761,
    "lng": 100.2760306,
    "placeId": "ChIJa7U4zj3ASjAROT1PCGt2KvA",
    "businessStatus": "OPERATIONAL",
    "phone": "04-370 5861",
    "openingHours": [
      "Monday: 8:00 AM – 1:30 AM",
      "Tuesday: 8:00 AM – 1:30 AM",
      "Wednesday: 8:00 AM – 1:30 AM",
      "Thursday: 8:00 AM – 12:00 AM",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: 12:00 – 1:30 AM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 171,
    "id": 1639
  },
  {
    "title": "Coral Gift Sdn Bhd",
    "urlinform": "coral-gift-sdn-bhd",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.coralgift.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDW86whrASjARfxsAcBjl9-s",
    "lat": 5.319521,
    "lng": 100.269419,
    "placeId": "ChIJDW86whrASjARfxsAcBjl9-s",
    "businessStatus": "OPERATIONAL",
    "phone": "04-644 9691",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 6:00 PM",
      "Wednesday: 9:00 AM – 6:00 PM",
      "Thursday: 9:00 AM – 6:00 PM",
      "Friday: 9:00 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 13,
    "id": 1640
  },
  {
    "title": "Duplicate Access Card Penang",
    "urlinform": "duplicate-access-card-penang",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRyRT3V_BSjARCq2Gf9-EPYc",
    "lat": 5.330271799999999,
    "lng": 100.2751002,
    "placeId": "ChIJRyRT3V_BSjARCq2Gf9-EPYc",
    "businessStatus": "OPERATIONAL",
    "phone": "013-984 2506",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 6:00 PM",
      "Wednesday: 9:00 AM – 6:00 PM",
      "Thursday: 9:00 AM – 6:00 PM",
      "Friday: 9:00 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 9:00 AM – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 155,
    "id": 1641
  },
  {
    "title": "Umbra Vault TCG",
    "urlinform": "umbra-vault-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ-0VZL5NzDERaxqpqdfdVYc",
    "lat": 3.0665377,
    "lng": 101.6023939,
    "placeId": "ChIJZ-0VZL5NzDERaxqpqdfdVYc",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1766 3112",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 29,
    "id": 1642,
    "district": "Subang Jaya"
  },
  {
    "title": "MyRareFinds TCG @ Pasar TCG",
    "urlinform": "myrarefinds-tcg-pasar-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/myrarefinds_tcg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN22D9DhPzDER5x125z76tj0",
    "lat": 3.0265655,
    "lng": 101.5479641,
    "placeId": "ChIJN22D9DhPzDER5x125z76tj0",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1100 7016",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 27,
    "id": 1643
  },
  {
    "title": "Let's Koppie and Hobbies @ Subang Square",
    "urlinform": "lets-koppie-and-hobbies-subang-square",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/letskoppie",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt4zA7TpNzDER2_0eBlfvpbg",
    "lat": 3.0776394,
    "lng": 101.5897073,
    "placeId": "ChIJt4zA7TpNzDER2_0eBlfvpbg",
    "businessStatus": "OPERATIONAL",
    "phone": "016-222 5135",
    "openingHours": [
      "Monday: 12:00 – 6:00 PM",
      "Tuesday: 12:00 – 6:00 PM",
      "Wednesday: 12:00 – 7:30 PM",
      "Thursday: 12:00 – 6:00 PM",
      "Friday: 12:00 – 7:30 PM",
      "Saturday: 1:00 – 7:30 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 77,
    "id": 1644
  },
  {
    "title": "Deck Out Trading Cards",
    "urlinform": "deck-out-trading-cards",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/deckouttcg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEX6Oo9SzzTERVITsjjCkIG4",
    "lat": 3.0250327,
    "lng": 101.5812008,
    "placeId": "ChIJEX6Oo9SzzTERVITsjjCkIG4",
    "businessStatus": "OPERATIONAL",
    "phone": "011-3316 0511",
    "openingHours": [
      "Monday: 8:00 PM – 12:00 AM",
      "Tuesday: 8:00 PM – 12:00 AM",
      "Wednesday: Closed",
      "Thursday: 8:00 PM – 12:00 AM",
      "Friday: 8:00 PM – 12:00 AM",
      "Saturday: 12:00 – 5:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.7,
    "userRatingsTotal": 38,
    "id": 1645
  },
  {
    "title": "Snorlex TCG Enterprise",
    "urlinform": "snorlex-tcg-enterprise",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1UuT9oGzzTER3VwItiMDkIU",
    "lat": 3.0599489,
    "lng": 101.59356,
    "placeId": "ChIJ1UuT9oGzzTER3VwItiMDkIU",
    "businessStatus": "OPERATIONAL",
    "phone": "011-2388 1999",
    "openingHours": [
      "Monday: 2:30 – 8:30 PM",
      "Tuesday: 2:30 – 8:30 PM",
      "Wednesday: 2:30 – 8:30 PM",
      "Thursday: 2:30 – 8:30 PM",
      "Friday: 2:30 – 8:30 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.4,
    "userRatingsTotal": 58,
    "id": 1646
  },
  {
    "title": "HeavyArm Store (Subang Jaya HQ)",
    "urlinform": "heavyarm-store-subang-jaya-hq",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://heavyarm-asia.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJy2q4qVhMzDEROD2MetRM2Uk",
    "lat": 3.0741254,
    "lng": 101.5868426,
    "placeId": "ChIJy2q4qVhMzDEROD2MetRM2Uk",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5631 2489",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 1944,
    "id": 1647
  },
  {
    "title": "Rare Candy Cards & Curios",
    "urlinform": "rare-candy-cards-curios",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61577101659459",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLwXqk56zzTERXXqPxyOA6wg",
    "lat": 3.0272504,
    "lng": 101.581121,
    "placeId": "ChIJLwXqk56zzTERXXqPxyOA6wg",
    "businessStatus": "OPERATIONAL",
    "phone": "012-895 6326",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 6:00 – 11:00 PM",
      "Wednesday: 6:00 – 11:00 PM",
      "Thursday: 6:00 – 11:00 PM",
      "Friday: 6:00 – 11:00 PM",
      "Saturday: 2:00 – 7:00 PM",
      "Sunday: 2:00 – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 25,
    "id": 1648
  },
  {
    "title": "Kichi TCG",
    "urlinform": "kichi-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Digimon",
      "Gundam",
      "MTG",
      "Union Arena"
    ],
    "storeWebsite": "http://www.kichitcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJj_Xf_F9LzDERl2Ibchwe9uI",
    "lat": 3.0468519,
    "lng": 101.6468539,
    "placeId": "ChIJj_Xf_F9LzDERl2Ibchwe9uI",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1093 3488",
    "openingHours": [
      "Monday: 2:00 PM – 1:00 AM",
      "Tuesday: 2:00 PM – 1:00 AM",
      "Wednesday: 2:00 PM – 1:00 AM",
      "Thursday: 2:00 PM – 1:00 AM",
      "Friday: 2:00 PM – 1:00 AM",
      "Saturday: 2:00 PM – 1:00 AM",
      "Sunday: 2:00 PM – 1:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 113,
    "id": 1649
  },
  {
    "title": "Secret Base Tcg Enterprise",
    "urlinform": "secret-base-tcg-enterprise",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSbE7GDizzTERVl2zt-E_mbM",
    "lat": 3.0006031,
    "lng": 101.5269387,
    "placeId": "ChIJSbE7GDizzTERVl2zt-E_mbM",
    "businessStatus": "OPERATIONAL",
    "phone": "012-540 9322",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 PM – 1:00 AM",
      "Saturday: 3:00 PM – 1:00 AM",
      "Sunday: 3:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 16,
    "id": 1650
  },
  {
    "title": "HeavyArm Store (Kota Kemuning Branch)",
    "urlinform": "heavyarm-store-kota-kemuning-branch",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://heavyarm-asia.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4edpRcyzzTERLuUNuPPe5Xw",
    "lat": 3.0036531,
    "lng": 101.5390546,
    "placeId": "ChIJ4edpRcyzzTERLuUNuPPe5Xw",
    "businessStatus": "OPERATIONAL",
    "phone": "017-208 8412",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 11:00 AM – 8:30 PM",
      "Sunday: 11:00 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 670,
    "id": 1651
  },
  {
    "title": "FirstStop Gaming",
    "urlinform": "firststop-gaming",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/firststopgaming?mibextid=ZbWKwL",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJy8wPgARNzDERuT3ZLAV_9cU",
    "lat": 3.0740486,
    "lng": 101.5877253,
    "placeId": "ChIJy8wPgARNzDERuT3ZLAV_9cU",
    "businessStatus": "OPERATIONAL",
    "phone": "011-5662 8469",
    "openingHours": [
      "Monday: 11:00 AM – 8:30 PM",
      "Tuesday: 11:00 AM – 8:30 PM",
      "Wednesday: 11:00 AM – 8:30 PM",
      "Thursday: Closed",
      "Friday: 11:00 AM – 8:30 PM",
      "Saturday: 11:00 AM – 8:30 PM",
      "Sunday: 11:00 AM – 8:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 312,
    "id": 1652
  },
  {
    "title": "Belalang Collectablez @ Pasar TCG",
    "urlinform": "belalang-collectablez-pasar-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0dCfdwCzzTER7ZKp796qWg0",
    "lat": 3.0265336,
    "lng": 101.5479254,
    "placeId": "ChIJ0dCfdwCzzTER7ZKp796qWg0",
    "businessStatus": "OPERATIONAL",
    "phone": "012-600 4970",
    "openingHours": [
      "Monday: 11:00 AM – 11:00 PM",
      "Tuesday: Closed",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 10,
    "id": 1653
  },
  {
    "title": "Prismatic Dream",
    "urlinform": "prismatic-dream",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJk06dfABNzDERRJya-1A17Dk",
    "lat": 3.0602399,
    "lng": 101.593544,
    "placeId": "ChIJk06dfABNzDERRJya-1A17Dk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 6,
    "id": 1654
  },
  {
    "title": "Game Over Here",
    "urlinform": "game-over-here",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.gameoverheremy.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLX6QLtNNzDER972Utjiwbts",
    "lat": 3.0780407,
    "lng": 101.6112691,
    "placeId": "ChIJLX6QLtNNzDER972Utjiwbts",
    "businessStatus": "OPERATIONAL",
    "phone": "012-397 2663",
    "openingHours": [
      "Monday: 3:00 PM – 12:00 AM",
      "Tuesday: 3:00 PM – 12:00 AM",
      "Wednesday: 3:00 PM – 12:00 AM",
      "Thursday: 3:00 PM – 12:00 AM",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 3:00 PM – 12:00 AM",
      "Sunday: 3:00 PM – 12:00 AM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 94,
    "id": 1655,
    "district": "Subang Jaya"
  },
  {
    "title": "littleAKIBA",
    "urlinform": "littleakiba",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://littleakiba.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8XPBePVMzDERBGXBj_LmlyQ",
    "lat": 3.0483278,
    "lng": 101.5852198,
    "placeId": "ChIJ8XPBePVMzDERBGXBj_LmlyQ",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5892 2775",
    "openingHours": [
      "Monday: 2:00 – 7:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 2:00 – 7:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 112,
    "id": 1656
  },
  {
    "title": "The Weatherlight Enterprise",
    "urlinform": "the-weatherlight-enterprise",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ81aImG9NzDERUiqbTziYGdk",
    "lat": 3.049664,
    "lng": 101.5851612,
    "placeId": "ChIJ81aImG9NzDERUiqbTziYGdk",
    "businessStatus": "OPERATIONAL",
    "phone": "016-311 7605",
    "openingHours": [
      "Monday: 3:00 – 11:45 PM",
      "Tuesday: 3:00 – 11:45 PM",
      "Wednesday: 3:00 – 11:45 PM",
      "Thursday: 3:00 – 11:45 PM",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 1:30 PM – 12:00 AM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 17,
    "id": 1657
  },
  {
    "title": "Decards Enterprise",
    "urlinform": "decards-enterprise",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhUlW_MRNzDERsa20LOeAMeU",
    "lat": 3.0164567,
    "lng": 101.6151046,
    "placeId": "ChIJhUlW_MRNzDERsa20LOeAMeU",
    "businessStatus": "OPERATIONAL",
    "phone": "016-203 9727",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 6:00 – 11:00 PM",
      "Thursday: 6:00 – 11:00 PM",
      "Friday: 6:00 – 11:00 PM",
      "Saturday: 3:00 – 7:00 PM",
      "Sunday: 3:00 – 7:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 5,
    "id": 1658
  },
  {
    "title": "Mirai Creations Studio ® Subang Jaya",
    "urlinform": "mirai-creations-studio-subang-jaya",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG2smTahNzDERVNuPCYWQ0LM",
    "lat": 3.0602286,
    "lng": 101.5933443,
    "placeId": "ChIJG2smTahNzDERVNuPCYWQ0LM",
    "businessStatus": "OPERATIONAL",
    "phone": "012-266 7959",
    "openingHours": [
      "Monday: 11:00 AM – 8:30 PM",
      "Tuesday: 11:00 AM – 8:30 PM",
      "Wednesday: 11:00 AM – 8:30 PM",
      "Thursday: 11:00 AM – 8:30 PM",
      "Friday: 11:00 AM – 8:30 PM",
      "Saturday: 11:00 AM – 8:30 PM",
      "Sunday: 11:00 AM – 8:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 51,
    "id": 1659
  },
  {
    "title": "Pullzone Enterprise",
    "urlinform": "pullzone-enterprise",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR2s3bABNzDERtCWOKGhAbjs",
    "lat": 3.0779642,
    "lng": 101.5864862,
    "placeId": "ChIJR2s3bABNzDERtCWOKGhAbjs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1660
  },
  {
    "title": "Boards & Brews • by TD",
    "urlinform": "boards-brews-by-td",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/TDSunway/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB7TnJY9MzDERMsC-3KsqKE4",
    "lat": 3.0703722,
    "lng": 101.602748,
    "placeId": "ChIJB7TnJY9MzDERMsC-3KsqKE4",
    "businessStatus": "OPERATIONAL",
    "phone": "012-480 6673",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 11:30 PM",
      "Wednesday: 2:00 – 11:30 PM",
      "Thursday: 2:00 – 11:30 PM",
      "Friday: 2:00 – 11:30 PM",
      "Saturday: 2:00 – 11:30 PM",
      "Sunday: 2:00 – 11:30 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 169,
    "id": 1661,
    "district": "Subang Jaya"
  },
  {
    "title": "Impulse Gaming • Sunway Branch",
    "urlinform": "impulse-gaming-sunway-branch",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7WXip4BLzDERWRfMahnIaDo",
    "lat": 3.0657229,
    "lng": 101.6031344,
    "placeId": "ChIJ7WXip4BLzDERWRfMahnIaDo",
    "businessStatus": "OPERATIONAL",
    "phone": "010-663 3155",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 9:30 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 680,
    "id": 1662,
    "district": "Subang Jaya"
  },
  {
    "title": "CTRL + PLAY (The Grand SS15) Sim Racing | PS5",
    "urlinform": "ctrl-play-the-grand-ss15-sim-racing-ps5",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://app.ctrlplay.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE5A5ONpNzDERllnj5Jn9g9o",
    "lat": 3.0744553,
    "lng": 101.5899987,
    "placeId": "ChIJE5A5ONpNzDERllnj5Jn9g9o",
    "businessStatus": "OPERATIONAL",
    "phone": "010-277 0686",
    "openingHours": [
      "Monday: 12:00 PM – 2:00 AM",
      "Tuesday: 12:00 PM – 2:00 AM",
      "Wednesday: 12:00 PM – 2:00 AM",
      "Thursday: 12:00 PM – 2:00 AM",
      "Friday: 12:00 PM – 2:00 AM",
      "Saturday: 12:00 PM – 2:00 AM",
      "Sunday: 12:00 PM – 2:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 350,
    "id": 1663
  },
  {
    "title": "PTS CARD MULTIVERSE",
    "urlinform": "pts-card-multiverse",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/ptscardmultiverse?igsh=cG9zNm1tc3VoNHFy&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJI1m0G-pPzDER2x_Ikqf1BWY",
    "lat": 3.1787078,
    "lng": 101.5478272,
    "placeId": "ChIJI1m0G-pPzDER2x_Ikqf1BWY",
    "businessStatus": "OPERATIONAL",
    "phone": "016-381 2908",
    "openingHours": [
      "Monday: 10:15 AM – 10:00 PM",
      "Tuesday: 10:15 AM – 11:00 PM",
      "Wednesday: 10:15 AM – 9:30 PM",
      "Thursday: 10:15 AM – 9:00 PM",
      "Friday: 10:15 AM – 8:45 PM",
      "Saturday: 10:10 AM – 3:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 47,
    "id": 1664
  },
  {
    "title": "AUTHENTIC CARDS AND COLLECTIBLES",
    "urlinform": "authentic-cards-and-collectibles",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjYhqvK1NzDERtbS4elJq0vo",
    "lat": 3.0599489,
    "lng": 101.59356,
    "placeId": "ChIJjYhqvK1NzDERtbS4elJq0vo",
    "businessStatus": "OPERATIONAL",
    "phone": "011-2388 1999",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1665
  },
  {
    "title": "TCG Malaysia - Amcorp Mall",
    "urlinform": "tcg-malaysia-amcorp-mall",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://tcgmalaysia.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhwgg9C1LzDERc9Oqp67r3ZQ",
    "lat": 3.1049812,
    "lng": 101.6467118,
    "placeId": "ChIJhwgg9C1LzDERc9Oqp67r3ZQ",
    "businessStatus": "OPERATIONAL",
    "phone": "016-700 6200",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 5,
    "id": 1666
  },
  {
    "title": "Premier Card Grading SEA",
    "urlinform": "premier-card-grading-sea",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://premiercardgrading.com.my/HBZFvC",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYaE3pqxPzDER52HLO_4a3iI",
    "lat": 3.1487845,
    "lng": 101.5947374,
    "placeId": "ChIJYaE3pqxPzDER52HLO_4a3iI",
    "businessStatus": "OPERATIONAL",
    "phone": "017-958 8724",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.5,
    "userRatingsTotal": 16,
    "id": 1667
  },
  {
    "title": "Rel Collectibles",
    "urlinform": "rel-collectibles",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.relcollectibles.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBVQOWitPzDERmNffZVsWu8I",
    "lat": 3.1184714,
    "lng": 101.5949755,
    "placeId": "ChIJBVQOWitPzDERmNffZVsWu8I",
    "businessStatus": "OPERATIONAL",
    "phone": "011-3915 1718",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 55,
    "id": 1668
  },
  {
    "title": "Hobby Base Trading",
    "urlinform": "hobby-base-trading",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/KZHobbyBase/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVbO63JJPzDER_d3dwM1flZ8",
    "lat": 3.1500155,
    "lng": 101.575298,
    "placeId": "ChIJVbO63JJPzDER_d3dwM1flZ8",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1121 8716",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 24,
    "id": 1669
  },
  {
    "title": "UNITY GAME",
    "urlinform": "unity-game",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.unitygames.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJV27y-EFLzDER2e59GO2ZHOY",
    "lat": 3.1508627,
    "lng": 101.5911135,
    "placeId": "ChIJV27y-EFLzDER2e59GO2ZHOY",
    "businessStatus": "OPERATIONAL",
    "phone": "017-777 1402",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 9:30 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 67,
    "id": 1670
  },
  {
    "title": "Gamester Direct",
    "urlinform": "gamester-direct",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJT_lbN9VOzDERWok9oWbiGGE",
    "lat": 3.147911,
    "lng": 101.6159551,
    "placeId": "ChIJT_lbN9VOzDERWok9oWbiGGE",
    "businessStatus": "OPERATIONAL",
    "phone": "03-7733 0245",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:30 PM",
      "Saturday: 10:00 AM – 10:30 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 299,
    "id": 1671
  },
  {
    "title": "Precious Ones",
    "urlinform": "precious-ones",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://preciousones.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW3y5qb3DSjARU6X4ozeNbso",
    "lat": 5.426273699999999,
    "lng": 100.3118269,
    "placeId": "ChIJW3y5qb3DSjARU6X4ozeNbso",
    "businessStatus": "OPERATIONAL",
    "phone": "016-463 8263",
    "openingHours": [
      "Monday: 10:30 AM – 6:30 PM",
      "Tuesday: 10:30 AM – 6:30 PM",
      "Wednesday: 10:30 AM – 6:30 PM",
      "Thursday: 10:30 AM – 6:30 PM",
      "Friday: 10:30 AM – 6:30 PM",
      "Saturday: 10:30 AM – 5:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 14,
    "id": 1672
  },
  {
    "title": "The Atelier by My Puzzle",
    "urlinform": "the-atelier-by-my-puzzle",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.mypuzzle.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAUXtqifDSjARilgFJLc_iYI",
    "lat": 5.414861399999999,
    "lng": 100.3388312,
    "placeId": "ChIJAUXtqifDSjARilgFJLc_iYI",
    "businessStatus": "OPERATIONAL",
    "phone": "018-278 7959",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:30 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 16,
    "id": 1673,
    "district": "Georgetown"
  },
  {
    "title": "P.66",
    "urlinform": "p66",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/p66.store/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJawxLxtfDSjARNPtk8cp-Rg0",
    "lat": 5.417781799999999,
    "lng": 100.3343943,
    "placeId": "ChIJawxLxtfDSjARNPtk8cp-Rg0",
    "businessStatus": "OPERATIONAL",
    "phone": "04-262 7899",
    "openingHours": [
      "Monday: 9:00 AM – 6:00 PM",
      "Tuesday: 9:00 AM – 6:00 PM",
      "Wednesday: 9:00 AM – 6:00 PM",
      "Thursday: 9:00 AM – 6:00 PM",
      "Friday: 9:00 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 9:00 AM – 6:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 469,
    "id": 1674,
    "district": "Georgetown"
  },
  {
    "title": "Fine Gifts",
    "urlinform": "fine-gifts",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/myfinegifts/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJe0yeO5TDSjARS7DGMMM2voc",
    "lat": 5.4144913,
    "lng": 100.3311195,
    "placeId": "ChIJe0yeO5TDSjARS7DGMMM2voc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 2,
    "id": 1675,
    "district": "Georgetown"
  },
  {
    "title": "Mucca Paper• The Notebook Lab Penang",
    "urlinform": "mucca-paper-the-notebook-lab-penang",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://muccapaper.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnUfzR3fDSjAR10BydivRZpY",
    "lat": 5.4183822,
    "lng": 100.3408512,
    "placeId": "ChIJnUfzR3fDSjAR10BydivRZpY",
    "businessStatus": "OPERATIONAL",
    "phone": "017-403 2363",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 5:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 101,
    "id": 1676
  },
  {
    "title": "Loka Made @ Armenian Street",
    "urlinform": "loka-made-armenian-street",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lokamade.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2312p6nDSjARiiNxFqNTxzc",
    "lat": 5.4152355,
    "lng": 100.3374474,
    "placeId": "ChIJ2312p6nDSjARiiNxFqNTxzc",
    "businessStatus": "OPERATIONAL",
    "phone": "016-213 4987",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 9:00 AM – 9:00 PM",
      "Sunday: 9:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 383,
    "id": 1677,
    "district": "Georgetown"
  },
  {
    "title": "Trendy Toy Box TCG Card Game",
    "urlinform": "trendy-toy-box-tcg-card-game",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://trendytoybox.com/?srsltid=AfmBOoqvSxLxsa_0VZCZ95ZVV75saoVSnX5obYsAtYR2HeLik_82ZxNY",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8-R9FcNv2jER7ukWJM9aoWA",
    "lat": 1.578649,
    "lng": 103.7703753,
    "placeId": "ChIJ8-R9FcNv2jER7ukWJM9aoWA",
    "businessStatus": "OPERATIONAL",
    "phone": "011-6228 8082",
    "openingHours": [
      "Monday: 2:00 PM – 12:00 AM",
      "Tuesday: 2:00 PM – 12:00 AM",
      "Wednesday: 2:00 PM – 12:00 AM",
      "Thursday: 2:00 PM – 12:00 AM",
      "Friday: 1:00 PM – 1:00 AM",
      "Saturday: 1:00 PM – 1:00 AM",
      "Sunday: 1:00 PM – 1:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 306,
    "id": 1678
  },
  {
    "title": "TCWIN TOYS / TCWIN TCG • R&F Mall",
    "urlinform": "tcwin-toys-tcwin-tcg-rf-mall",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP_RmyvoT2jERrdtHRsJXToQ",
    "lat": 1.4594592,
    "lng": 103.7697502,
    "placeId": "ChIJP_RmyvoT2jERrdtHRsJXToQ",
    "businessStatus": "OPERATIONAL",
    "phone": "011-1171 7688",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 84,
    "id": 1679,
    "district": "Johor Bahru"
  },
  {
    "title": "The Bonfire Hobby Shop",
    "urlinform": "the-bonfire-hobby-shop",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://hitpay.shop/BonfireHobbyShopMY/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhw8Yiu0J2jERnwubecpmRqk",
    "lat": 1.4835705,
    "lng": 103.6624072,
    "placeId": "ChIJhw8Yiu0J2jERnwubecpmRqk",
    "businessStatus": "OPERATIONAL",
    "phone": "011-5432 2509",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 13,
    "id": 1680
  },
  {
    "title": "KADO ASIA (Trading Card Shop)",
    "urlinform": "kado-asia-trading-card-shop",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.kado.asia/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLY_fjJ8L2jER7tvs7RHSqVc",
    "lat": 1.4420908,
    "lng": 103.6157873,
    "placeId": "ChIJLY_fjJ8L2jER7tvs7RHSqVc",
    "businessStatus": "OPERATIONAL",
    "phone": "014-317 8621",
    "openingHours": [
      "Monday: 12:30 – 8:00 PM",
      "Tuesday: 12:30 – 8:00 PM",
      "Wednesday: 12:30 – 8:00 PM",
      "Thursday: 12:30 – 10:00 PM",
      "Friday: 12:30 – 10:00 PM",
      "Saturday: 12:30 – 10:00 PM",
      "Sunday: 12:30 – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 54,
    "id": 1681
  },
  {
    "title": "HC Games Paradigm Mall",
    "urlinform": "hc-games-paradigm-mall",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzxZz6Ntz2jERzZsuwimaOwY",
    "lat": 1.516239,
    "lng": 103.6851193,
    "placeId": "ChIJzxZz6Ntz2jERzZsuwimaOwY",
    "businessStatus": "OPERATIONAL",
    "phone": "016-778 7135",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 35,
    "id": 1682
  },
  {
    "title": "SC Games Holiday Plaza ( Specialist in Repairing )",
    "urlinform": "sc-games-holiday-plaza-specialist-in-repairing-",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://wa.link/9nfnhh",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK3eWb3ht2jERY56HGFfFaGo",
    "lat": 1.4884934,
    "lng": 103.7585467,
    "placeId": "ChIJK3eWb3ht2jERY56HGFfFaGo",
    "businessStatus": "OPERATIONAL",
    "phone": "012-771 3518",
    "openingHours": [
      "Monday: 1:00 – 9:30 PM",
      "Tuesday: 1:00 – 9:30 PM",
      "Wednesday: 1:00 – 9:30 PM",
      "Thursday: 1:00 – 9:30 PM",
      "Friday: 1:00 – 9:30 PM",
      "Saturday: 1:00 – 9:30 PM",
      "Sunday: 1:00 – 9:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1153,
    "id": 1683
  },
  {
    "title": "Card Konbini - Liverpool",
    "urlinform": "card-konbini-liverpool",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.cardkonbini.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn08IAJK9EmsRBPQLnekAKno",
    "lat": -33.9217284,
    "lng": 150.9252518,
    "placeId": "ChIJn08IAJK9EmsRBPQLnekAKno",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 206,
    "id": 1684
  },
  {
    "title": "Chromatic Games",
    "urlinform": "chromatic-games",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.chromaticgames.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcT5OUf67EmsR6tfxK6KCWOc",
    "lat": -33.8888215,
    "lng": 151.1253946,
    "placeId": "ChIJcT5OUf67EmsR6tfxK6KCWOc",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8590 2789",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 225,
    "id": 1685
  },
  {
    "title": "Light of Cards - Waterloo",
    "urlinform": "light-of-cards-waterloo",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://lightofcards.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrRoHmcexEmsR47js4mfYiP8",
    "lat": -33.9020651,
    "lng": 151.2133698,
    "placeId": "ChIJrRoHmcexEmsR47js4mfYiP8",
    "businessStatus": "CLOSED_TEMPORARILY",
    "phone": "",
    "openingHours": [],
    "rating": 4.3,
    "userRatingsTotal": 27,
    "id": 1686
  },
  {
    "title": "NJ Collectables",
    "urlinform": "nj-collectables",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://njcollectables.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN3W94JTPcmsRbC5NMqBX44Y",
    "lat": -33.3129571,
    "lng": 151.4205742,
    "placeId": "ChIJN3W94JTPcmsRbC5NMqBX44Y",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 4330 0317",
    "openingHours": [
      "Monday: 4:00 – 9:00 PM",
      "Tuesday: 4:00 – 9:00 PM",
      "Wednesday: 4:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 3:00 PM",
      "Sunday: 10:00 AM – 3:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 138,
    "id": 1687
  },
  {
    "title": "One Place Trading Card Shop",
    "urlinform": "one-place-trading-card-shop",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "MTG",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://oneplacetcs.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC9lzYgD_nWsRvduE-3Mg1yA",
    "lat": -31.4477696,
    "lng": 152.8933976,
    "placeId": "ChIJC9lzYgD_nWsRvduE-3Mg1yA",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 6584 4260",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 6:00 PM",
      "Thursday: 10:00 AM – 6:00 PM",
      "Friday: 10:00 AM – 6:00 PM",
      "Saturday: 10:00 AM – 5:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 51,
    "id": 1688
  },
  {
    "title": "Western Sydney TCG",
    "urlinform": "western-sydney-tcg",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd9sw5m29EmsRKoeYGKstTJo",
    "lat": -33.8620572,
    "lng": 151.0363466,
    "placeId": "ChIJd9sw5m29EmsRKoeYGKstTJo",
    "businessStatus": "OPERATIONAL",
    "phone": "0451 067 711",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 5:00 – 10:00 PM",
      "Thursday: 5:00 – 10:00 PM",
      "Friday: 5:00 – 10:00 PM",
      "Saturday: 5:00 – 10:00 PM",
      "Sunday: 4:00 – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 7,
    "id": 1689
  },
  {
    "title": "Sydney labubu",
    "urlinform": "sydney-labubu",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://labubu.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7_3HKQmpEmsRsEdUpPP-hKg",
    "lat": -33.7974818,
    "lng": 151.1821676,
    "placeId": "ChIJ7_3HKQmpEmsRsEdUpPP-hKg",
    "businessStatus": "OPERATIONAL",
    "phone": "0433 198 586",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.7,
    "userRatingsTotal": 26,
    "id": 1690,
    "district": "Chatswood"
  },
  {
    "title": "Smiggle Chatswood Chase",
    "urlinform": "smiggle-chatswood-chase",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://smiggle.jgl.com.au/?utm_source=google&utm_medium=organic&utm_campaign=google_business&utm_term=plcid_3774463457832247786",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh-Sby9WoEmsRaHxvMT6UuxQ",
    "lat": -33.7942048,
    "lng": 151.1860513,
    "placeId": "ChIJh-Sby9WoEmsRaHxvMT6UuxQ",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9410 0607",
    "openingHours": [
      "Monday: 10:00 AM – 6:00 PM",
      "Tuesday: 10:00 AM – 6:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 9:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 21,
    "id": 1691,
    "district": "Chatswood"
  },
  {
    "title": "Chatswood Mall",
    "urlinform": "chatswood-mall",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.willoughby.nsw.gov.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoyfJL9aoEmsRcNda7aQpxck",
    "lat": -33.7965764,
    "lng": 151.1822887,
    "placeId": "ChIJoyfJL9aoEmsRcNda7aQpxck",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 5:30 PM",
      "Tuesday: 10:00 AM – 5:30 PM",
      "Wednesday: 10:00 AM – 5:30 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 5:30 PM",
      "Saturday: 10:00 AM – 5:30 PM",
      "Sunday: 10:00 AM – 5:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 88,
    "id": 1692,
    "district": "Chatswood"
  },
  {
    "title": "平行世界悉尼剧本杀 | 桌游馆 Parallel Universe Entertainment",
    "urlinform": "-parallel-universe-entertainment",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.pu221.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvVyZs_ivEmsR5LOY_H4KIlY",
    "lat": -33.8816172,
    "lng": 151.2049048,
    "placeId": "ChIJvVyZs_ivEmsR5LOY_H4KIlY",
    "businessStatus": "OPERATIONAL",
    "phone": "0414 408 150",
    "openingHours": [
      "Monday: 9:00 AM – 2:00 AM",
      "Tuesday: 9:00 AM – 2:00 AM",
      "Wednesday: 9:00 AM – 2:00 AM",
      "Thursday: 9:00 AM – 2:00 AM",
      "Friday: 9:00 AM – 2:00 AM",
      "Saturday: 9:00 AM – 3:00 AM",
      "Sunday: 9:00 AM – 2:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 345,
    "id": 1693,
    "district": "Haymarket"
  },
  {
    "title": "Funny Lab",
    "urlinform": "funny-lab",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "One Piece"
    ],
    "storeWebsite": "http://www.funnylab.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCVNSZvavEmsR-0uXJHAM9tc",
    "lat": -33.8801893,
    "lng": 151.2031711,
    "placeId": "ChIJCVNSZvavEmsR-0uXJHAM9tc",
    "businessStatus": "OPERATIONAL",
    "phone": "0477 655 240",
    "openingHours": [
      "Monday: 6:00 AM – 11:00 PM",
      "Tuesday: 6:00 AM – 11:00 PM",
      "Wednesday: 6:00 AM – 11:00 PM",
      "Thursday: 6:00 AM – 11:00 PM",
      "Friday: 6:00 AM – 11:00 PM",
      "Saturday: 6:00 AM – 11:00 PM",
      "Sunday: 6:00 AM – 11:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 6,
    "id": 1694,
    "district": "Haymarket"
  },
  {
    "title": "Morning Glory",
    "urlinform": "morning-glory",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://mgshop.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC6ROiSSuEmsRE-erTClxgqk",
    "lat": -33.8783333,
    "lng": 151.2041667,
    "placeId": "ChIJC6ROiSSuEmsRE-erTClxgqk",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9212 4088",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 288,
    "id": 1695,
    "district": "Haymarket"
  },
  {
    "title": "Lillianna Home and Gifts Haymarket",
    "urlinform": "lillianna-home-and-gifts-haymarket",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lillianna.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJyBpxQuvEmsRsAJ_BzUqdDI",
    "lat": -33.8783863,
    "lng": 151.2011989,
    "placeId": "ChIJJyBpxQuvEmsRsAJ_BzUqdDI",
    "businessStatus": "OPERATIONAL",
    "phone": "0487 117 707",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 124,
    "id": 1696,
    "district": "Haymarket"
  },
  {
    "title": "Lion's Den Collectibles Burwood",
    "urlinform": "lions-den-collectibles-burwood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lionsdencollectibles.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCaZa73S7EmsRGtfkg_LxJqw",
    "lat": -33.8745651,
    "lng": 151.1059151,
    "placeId": "ChIJCaZa73S7EmsRGtfkg_LxJqw",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9878 5426",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 7:00 PM",
      "Saturday: 9:00 AM – 7:00 PM",
      "Sunday: 9:00 AM – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 41,
    "id": 1697,
    "district": "Burwood"
  },
  {
    "title": "Vanguard Vault (Collectables & Trading Cards)",
    "urlinform": "vanguard-vault-collectables-trading-cards",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Vanguard"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMfPHWgC7EmsRLGPvtQ8t0_U",
    "lat": -33.8777889,
    "lng": 151.1022748,
    "placeId": "ChIJMfPHWgC7EmsRLGPvtQ8t0_U",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 5:30 PM",
      "Wednesday: 12:00 – 5:30 PM",
      "Thursday: 12:00 – 5:30 PM",
      "Friday: 12:00 – 7:30 PM",
      "Saturday: 12:00 – 7:30 PM",
      "Sunday: 12:00 – 5:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 26,
    "id": 1698,
    "district": "Burwood"
  },
  {
    "title": "Vault Collectables",
    "urlinform": "vault-collectables",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.vault-collectables.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyzttQX-7EmsRWKc0mb3Yar8",
    "lat": -33.88344,
    "lng": 151.1144784,
    "placeId": "ChIJyzttQX-7EmsRWKc0mb3Yar8",
    "businessStatus": "OPERATIONAL",
    "phone": "0475 991 026",
    "openingHours": [
      "Monday: 11:00 AM – 4:00 PM",
      "Tuesday: Closed",
      "Wednesday: 11:00 AM – 4:00 PM",
      "Thursday: 9:30 AM – 5:00 PM",
      "Friday: 9:30 AM – 5:00 PM",
      "Saturday: 9:00 AM – 5:00 PM",
      "Sunday: 10:00 AM – 3:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 29,
    "id": 1699
  },
  {
    "title": "Anime Kaika Burwood",
    "urlinform": "anime-kaika-burwood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "MTG",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.kaika.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoY-6wcI3UE0RFmIvXTRH-bc",
    "lat": -33.8719213,
    "lng": 151.1048855,
    "placeId": "ChIJoY-6wcI3UE0RFmIvXTRH-bc",
    "businessStatus": "OPERATIONAL",
    "phone": "0468 402 574",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 17,
    "id": 1700,
    "district": "Burwood"
  },
  {
    "title": "Topdeck Gaming Strathfield",
    "urlinform": "topdeck-gaming-strathfield",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "http://topdeckgaming.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJM985Vpu7EmsRJUyuEPFQJmA",
    "lat": -33.8728554,
    "lng": 151.094081,
    "placeId": "ChIJM985Vpu7EmsRJUyuEPFQJmA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 5:30 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 6:00 PM",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 30,
    "id": 1701,
    "district": "Burwood"
  },
  {
    "title": "Vault Collectables",
    "urlinform": "vault-collectables",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://vault-collectables.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_SHH2Iq7EmsRtCLQWVx-fWs",
    "lat": -33.8921131,
    "lng": 151.138391,
    "placeId": "ChIJ_SHH2Iq7EmsRtCLQWVx-fWs",
    "businessStatus": "OPERATIONAL",
    "phone": "0456 386 436",
    "openingHours": [
      "Monday: 9:30 AM – 8:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 8:00 PM",
      "Thursday: 9:30 AM – 6:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 4:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 140,
    "id": 1702
  },
  {
    "title": "Lion’s Den Collectibles Bexley",
    "urlinform": "lions-den-collectibles-bexley",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv2GpQ5G7EmsRALTlB00RjyY",
    "lat": -33.94859350000001,
    "lng": 151.127534,
    "placeId": "ChIJv2GpQ5G7EmsRALTlB00RjyY",
    "businessStatus": "OPERATIONAL",
    "phone": "0435 271 103",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 189,
    "id": 1703
  },
  {
    "title": "Toy of the Day",
    "urlinform": "toy-of-the-day",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.planetpopworld.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXQSkKQC7EmsRyPby9hpAmVg",
    "lat": -33.8778349,
    "lng": 151.1033669,
    "placeId": "ChIJXQSkKQC7EmsRyPby9hpAmVg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 279,
    "id": 1704,
    "district": "Burwood"
  },
  {
    "title": "Lion's Den Collectibles Bonnyrigg Plaza",
    "urlinform": "lions-den-collectibles-bonnyrigg-plaza",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lionsdencollectibles.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtcgymQKXEmsRkl4F0rLAqVU",
    "lat": -33.886739,
    "lng": 150.888924,
    "placeId": "ChIJtcgymQKXEmsRkl4F0rLAqVU",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9610 3672",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 7:00 PM",
      "Saturday: 9:00 AM – 7:00 PM",
      "Sunday: 9:00 AM – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 48,
    "id": 1705
  },
  {
    "title": "Gacha Gacha Burwood",
    "urlinform": "gacha-gacha-burwood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.gachagacha.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4QmDqA-7EmsRU_nfkU4_zmQ",
    "lat": -33.8784196,
    "lng": 151.102158,
    "placeId": "ChIJ4QmDqA-7EmsRU_nfkU4_zmQ",
    "businessStatus": "OPERATIONAL",
    "phone": "0490 935 818",
    "openingHours": [
      "Monday: 9:00 AM – 11:00 PM",
      "Tuesday: 9:00 AM – 11:00 PM",
      "Wednesday: 9:00 AM – 11:00 PM",
      "Thursday: 9:00 AM – 11:00 PM",
      "Friday: 9:00 AM – 11:00 PM",
      "Saturday: 9:00 AM – 11:00 PM",
      "Sunday: 9:00 AM – 11:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 22,
    "id": 1706,
    "district": "Burwood"
  },
  {
    "title": "Lion’s Den Collectibles Roselands",
    "urlinform": "lions-den-collectibles-roselands",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVe8kTQC7EmsRIFhEsdz2NxM",
    "lat": -33.9357781,
    "lng": 151.0688131,
    "placeId": "ChIJVe8kTQC7EmsRIFhEsdz2NxM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 7:00 PM",
      "Saturday: 9:00 AM – 7:00 PM",
      "Sunday: 9:00 AM – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 17,
    "id": 1707
  },
  {
    "title": "Zing Pop Culture",
    "urlinform": "zing-pop-culture",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.zingpopculture.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuYd5E8W6EmsRzbrTSXCglFE",
    "lat": -33.8748622,
    "lng": 151.1072347,
    "placeId": "ChIJuYd5E8W6EmsRzbrTSXCglFE",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9745 6777",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 33,
    "id": 1708,
    "district": "Burwood"
  },
  {
    "title": "88 Games Arena",
    "urlinform": "88-games-arena",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "MTG",
      "One Piece"
    ],
    "storeWebsite": "http://88gamesarena.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnR74_1O7EmsRKW0wz4WL42E",
    "lat": -33.9149299,
    "lng": 151.1121434,
    "placeId": "ChIJnR74_1O7EmsRKW0wz4WL42E",
    "businessStatus": "OPERATIONAL",
    "phone": "0450 924 252",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 5:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 22,
    "id": 1709
  },
  {
    "title": "The Cardhub Greenacre",
    "urlinform": "the-cardhub-greenacre",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://thecardhubaustralia.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJe1hf-Ti7EmsRjLhFd-eytPs",
    "lat": -33.8875319,
    "lng": 151.0631134,
    "placeId": "ChIJe1hf-Ti7EmsRjLhFd-eytPs",
    "businessStatus": "OPERATIONAL",
    "phone": "0493 652 174",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 10:30 AM – 4:30 PM",
      "Sunday: 10:30 AM – 4:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 156,
    "id": 1710
  },
  {
    "title": "SWAP ITT. Cards and Collectables",
    "urlinform": "swap-itt-cards-and-collectables",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://swapitt.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5cnF6xC5EmsRMMkJtirhXwo",
    "lat": -33.9643852,
    "lng": 151.1037962,
    "placeId": "ChIJ5cnF6xC5EmsRMMkJtirhXwo",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9415 5156",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 195,
    "id": 1711
  },
  {
    "title": "Hobbyco",
    "urlinform": "hobbyco",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Gundam",
      "Pokémon"
    ],
    "storeWebsite": "https://www.hobbyco.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgyH_hjO7EmsR-n2kgiNyzRw",
    "lat": -33.8747093,
    "lng": 151.1059128,
    "placeId": "ChIJgyH_hjO7EmsR-n2kgiNyzRw",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 8332 1431",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 143,
    "id": 1712,
    "district": "Burwood"
  },
  {
    "title": "KPOP BAZAAR",
    "urlinform": "kpop-bazaar",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.kpopbazaar.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN839nxu_EmsRB-KUy5EliW8",
    "lat": -33.8720158,
    "lng": 151.1049621,
    "placeId": "ChIJN839nxu_EmsRB-KUy5EliW8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 237,
    "id": 1713,
    "district": "Burwood"
  },
  {
    "title": "Icons of Sport",
    "urlinform": "icons-of-sport",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://www.iconsofsport.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjWAVDkyjEmsRAoBLZKF8m0A",
    "lat": -33.8472925,
    "lng": 151.0695514,
    "placeId": "ChIJjWAVDkyjEmsRAoBLZKF8m0A",
    "businessStatus": "OPERATIONAL",
    "phone": "1800 200 476",
    "openingHours": [
      "Monday: 9:00 AM – 5:00 PM",
      "Tuesday: 9:00 AM – 5:00 PM",
      "Wednesday: 9:00 AM – 5:00 PM",
      "Thursday: 9:00 AM – 5:00 PM",
      "Friday: 9:00 AM – 5:00 PM",
      "Saturday: 9:00 AM – 5:00 PM",
      "Sunday: 10:00 AM – 4:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 74,
    "id": 1714
  },
  {
    "title": "Strawberry Bear",
    "urlinform": "strawberry-bear",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.strawberrybear.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEeH0NNe7EmsRSPB8FSIg_KY",
    "lat": -33.8767359,
    "lng": 151.1048966,
    "placeId": "ChIJEeH0NNe7EmsRSPB8FSIg_KY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 6:00 PM",
      "Wednesday: 12:00 – 6:00 PM",
      "Thursday: 12:00 – 6:00 PM",
      "Friday: 12:00 – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 5:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 349,
    "id": 1715,
    "district": "Burwood"
  },
  {
    "title": "The Lott",
    "urlinform": "the-lott",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://thelott.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJue3Tfdy6EmsRFkY3FK6_7aA",
    "lat": -33.8776566,
    "lng": 151.1022929,
    "placeId": "ChIJue3Tfdy6EmsRFkY3FK6_7aA",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9744 8197",
    "openingHours": [
      "Monday: 7:00 AM – 6:00 PM",
      "Tuesday: 7:00 AM – 6:00 PM",
      "Wednesday: 7:00 AM – 6:00 PM",
      "Thursday: 7:00 AM – 6:00 PM",
      "Friday: 7:00 AM – 6:00 PM",
      "Saturday: 7:00 AM – 6:00 PM",
      "Sunday: 7:00 AM – 6:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 10,
    "id": 1716,
    "district": "Burwood"
  },
  {
    "title": "Fav Akihabara",
    "urlinform": "fav",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/fav_akihabara",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJL9YhUgCNGGARmScggnxoYIw",
    "lat": 35.7023956,
    "lng": 139.7713991,
    "placeId": "ChIJL9YhUgCNGGARmScggnxoYIw",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6821-8692",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 109,
    "district": "Akihabara",
    "id": 1717
  },
  {
    "title": "PDG Collector's Shop 秋葉原2号店",
    "urlinform": "pdg-collectors-shop-2",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/pdgcollectors_3?s=21&t=HiILXCG3iqqhZEweBG5Kxw",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-SPHmU-NGGARlBc_cStHDpU",
    "lat": 35.7016348,
    "lng": 139.7713281,
    "placeId": "ChIJ-SPHmU-NGGARlBc_cStHDpU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: Open 24 hours",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 595,
    "district": "Akihabara",
    "id": 1718
  },
  {
    "title": "CardShop151",
    "urlinform": "cardshop151",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJz9df5SCNGGARDUem9He-e9w",
    "lat": 35.7023956,
    "lng": 139.7713991,
    "placeId": "ChIJz9df5SCNGGARDUem9He-e9w",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 69,
    "district": "Akihabara",
    "id": 1719
  },
  {
    "title": "amiami Akihabara Figure Tower",
    "urlinform": "amiami-akihabara-figure-tower",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://realstore.amiami.jp/shop/shop2.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPR3Mpx2MGGARl5yyxi5j97k",
    "lat": 35.6979497,
    "lng": 139.7714597,
    "placeId": "ChIJPR3Mpx2MGGARl5yyxi5j97k",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3253-5701",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 1031,
    "district": "Akihabara",
    "id": 1720
  },
  {
    "title": "HOBBY LOUNGE",
    "urlinform": "store-1947",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYRHNxfaNGGARuFH0T1ddL4w",
    "lat": 35.7020993,
    "lng": 139.7724737,
    "placeId": "ChIJYRHNxfaNGGARuFH0T1ddL4w",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6685-6280",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 212,
    "district": "Akihabara",
    "id": 1721
  },
  {
    "title": "Card Kingdom Akihabara 2nd",
    "urlinform": "card-kingdom-akihabara-2nd",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cardkingdom.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJj-xDJQCNGGAR8TqqSHgrw3k",
    "lat": 35.6985747,
    "lng": 139.7717163,
    "placeId": "ChIJj-xDJQCNGGAR8TqqSHgrw3k",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 84,
    "district": "Akihabara",
    "id": 1722
  },
  {
    "title": "おたちゅう。秋葉原2号店 トレカ館",
    "urlinform": "2-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://otachu-akiba.com/2go/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ06uNrO6NGGARpChdT8XrKN0",
    "lat": 35.7017458,
    "lng": 139.7714036,
    "placeId": "ChIJ06uNrO6NGGARpChdT8XrKN0",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5244-4371",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 711,
    "district": "Akihabara",
    "id": 1723
  },
  {
    "title": "TCG ROYAL SHINJUKU",
    "urlinform": "tcg-royal-shinjuku",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.tcg-royal.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrbl-Z6OLGGARYZs7tLTFcSs",
    "lat": 35.6887159,
    "lng": 139.6969899,
    "placeId": "ChIJrbl-Z6OLGGARYZs7tLTFcSs",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6900-4003",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 603,
    "district": "Shinjuku",
    "id": 1724
  },
  {
    "title": "一騎当選",
    "urlinform": "store-1955",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://lit.link/ikkitosen",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-YiDuo2NGGARZ01TopfeYcU",
    "lat": 35.6947753,
    "lng": 139.6979356,
    "placeId": "ChIJ-YiDuo2NGGARZ01TopfeYcU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6304-0272",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 99,
    "district": "Shinjuku",
    "id": 1725
  },
  {
    "title": "ごりまる Vintage Collection",
    "urlinform": "-vintage-collection",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://gorimaru.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvSxx6F2NGGARdQV6Uff0LQI",
    "lat": 35.6903491,
    "lng": 139.7065402,
    "placeId": "ChIJvSxx6F2NGGARdQV6Uff0LQI",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6824-6451",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 78,
    "district": "Shinjuku",
    "id": 1726
  },
  {
    "title": "Pokémon Center Mega Tokyo & Pikachu Sweets",
    "urlinform": "pokmon-center-mega-tokyo-pikachu-sweets",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/pokecen/megatokyo/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJWdNBG-NGGARVcT12Z5mXFw",
    "lat": 35.7289056,
    "lng": 139.7193245,
    "placeId": "ChIJJWdNBG-NGGARVcT12Z5mXFw",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5927-9290",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 7582,
    "district": "Ikebukuro",
    "id": 1727
  },
  {
    "title": "ファブハッピー",
    "urlinform": "tokyo-fab",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Flesh and Blood"
    ],
    "storeWebsite": "https://tokyofab.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsUdlIPWNGGARqHzTtB7v28k",
    "lat": 35.7139479,
    "lng": 139.7036024,
    "placeId": "ChIJsUdlIPWNGGARqHzTtB7v28k",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6908-7710",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 24,
    "id": 1728
  },
  {
    "title": "Sekaido Shinjuku",
    "urlinform": "sekaido-shinjuku",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.sekaido.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFWyKVtuMGGARA-Jcl8RKyAQ",
    "lat": 35.6900298,
    "lng": 139.7063963,
    "placeId": "ChIJFWyKVtuMGGARA-Jcl8RKyAQ",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5379-1111",
    "openingHours": [
      "Monday: 9:30 AM – 8:00 PM",
      "Tuesday: 9:30 AM – 8:00 PM",
      "Wednesday: 9:30 AM – 8:00 PM",
      "Thursday: 9:30 AM – 8:00 PM",
      "Friday: 9:30 AM – 8:00 PM",
      "Saturday: 9:30 AM – 8:00 PM",
      "Sunday: 9:30 AM – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 6991,
    "district": "Shinjuku",
    "id": 1729
  },
  {
    "title": "TOKIO MANIA - Trading Card Shop",
    "urlinform": "tokio-mania-trading-card-shop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://tokio-mania.square.site/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjej9PIONGGARWgVpw9jVri4",
    "lat": 35.684772,
    "lng": 139.7400352,
    "placeId": "ChIJjej9PIONGGARWgVpw9jVri4",
    "businessStatus": "CLOSED_TEMPORARILY",
    "phone": "",
    "openingHours": [],
    "rating": 4.9,
    "userRatingsTotal": 80,
    "id": 1730
  },
  {
    "title": "TCG ROYAL ROPPONGI",
    "urlinform": "tcg-royal-roppongi",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.tcg-royal.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgSs1iJaLGGARIAOaD7A7aAI",
    "lat": 35.6617245,
    "lng": 139.7356825,
    "placeId": "ChIJgSs1iJaLGGARIAOaD7A7aAI",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5797-8078",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 135,
    "id": 1731
  },
  {
    "title": "HMV&BOOKS SHIBUYA",
    "urlinform": "hmvbooks-shibuya",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hmv.co.jp/store/BTK/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcXlVZKiMGGARE1Xl4UbnuQE",
    "lat": 35.6615867,
    "lng": 139.7004778,
    "placeId": "ChIJcXlVZKiMGGARE1Xl4UbnuQE",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5784-3270",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 1750,
    "district": "Shibuya",
    "id": 1732
  },
  {
    "title": "tout le monde",
    "urlinform": "tout-le-monde",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.billboard-kj.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1cz_5qCMGGARQaaVDbS1VSI",
    "lat": 35.6645098,
    "lng": 139.7078941,
    "placeId": "ChIJ1cz_5qCMGGARQaaVDbS1VSI",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5469-1050",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: Closed",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 77,
    "id": 1733
  },
  {
    "title": "Pokémon GO Lab.",
    "urlinform": "pokmon-go-lab",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://voice.pokemon.co.jp/stv/pokemongolab/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJM56i_m6NGGARDCeHiYrQRN4",
    "lat": 35.7290995,
    "lng": 139.7186977,
    "placeId": "ChIJM56i_m6NGGARDCeHiYrQRN4",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5927-9290",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 106,
    "district": "Ikebukuro",
    "id": 1734
  },
  {
    "title": "カードラボ池袋店＆ゲーマーズ池袋Bookstore",
    "urlinform": "bookstore",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.c-labo.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ556YRuKNGGARfu5vYd22Rm0",
    "lat": 35.730971,
    "lng": 139.7155114,
    "placeId": "ChIJ556YRuKNGGARfu5vYd22Rm0",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5924-6675",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 2.5,
    "userRatingsTotal": 132,
    "district": "Ikebukuro",
    "id": 1735
  },
  {
    "title": "晴れる屋2 池袋店",
    "urlinform": "2-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.hareruya2.com/pages/store_ikebukuro",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJG2-nooiNGGARMfeO8lldp10",
    "lat": 35.7315492,
    "lng": 139.7127844,
    "placeId": "ChIJG2-nooiNGGARMfeO8lldp10",
    "businessStatus": "OPERATIONAL",
    "phone": "03-4500-5105",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 41,
    "district": "Ikebukuro",
    "id": 1736
  },
  {
    "title": "【推し活メガストア】Ossi/オッシー池袋店",
    "urlinform": "ossi",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://bomcafe.online/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2ZzWcziNGGAR-ydPHoh030E",
    "lat": 35.7300565,
    "lng": 139.71382,
    "placeId": "ChIJ2ZzWcziNGGAR-ydPHoh030E",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6914-0613",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 277,
    "district": "Ikebukuro",
    "id": 1737
  },
  {
    "title": "晴れる屋2 高田馬場店",
    "urlinform": "2-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hareruya2.com/pages/store_takadanobaba",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVTQOVeeNGGARz1rtRJ9CVpo",
    "lat": 35.7138979,
    "lng": 139.7027647,
    "placeId": "ChIJVTQOVeeNGGARz1rtRJ9CVpo",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6821-8608",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 19,
    "id": 1738
  },
  {
    "title": "Nakano Broadway",
    "urlinform": "nakano-broadway",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://nakano-broadway.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg-7dspDyGGARvvDv4E5-tuE",
    "lat": 35.7092475,
    "lng": 139.6656524,
    "placeId": "ChIJg-7dspDyGGARvvDv4E5-tuE",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3388-7004",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 13446,
    "district": "Nakano",
    "id": 1739
  },
  {
    "title": "TIME ZONE Nakano Broadway",
    "urlinform": "time-zone-nakano-broadway",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://galleryrare.jp/shop/kanto/timezone-nakano/?utm_source=google&utm_medium=organic&utm_campaign=gbp&utm_content=timezone_nakano_bw",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWcNgVJfyGGARn3zu9v3CLKE",
    "lat": 35.7089299,
    "lng": 139.6657768,
    "placeId": "ChIJWcNgVJfyGGARn3zu9v3CLKE",
    "businessStatus": "OPERATIONAL",
    "phone": "0120-972-516",
    "openingHours": [
      "Monday: 11:30 AM – 7:00 PM",
      "Tuesday: 11:30 AM – 7:00 PM",
      "Wednesday: 11:30 AM – 7:00 PM",
      "Thursday: 11:30 AM – 7:00 PM",
      "Friday: 11:30 AM – 7:00 PM",
      "Saturday: 11:30 AM – 7:00 PM",
      "Sunday: 11:30 AM – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 279,
    "district": "Nakano",
    "id": 1740
  },
  {
    "title": "minny",
    "urlinform": "minny",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.iranoan.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyYqMr2mNGGARPHxhgRJybao",
    "lat": 35.7023333,
    "lng": 139.771438,
    "placeId": "ChIJyYqMr2mNGGARPHxhgRJybao",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 40,
    "district": "Akihabara",
    "id": 1741
  },
  {
    "title": "Bee本舗 秋葉原店",
    "urlinform": "bee-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://llalf.hp.peraichi.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJe3DEGuKNGGAR2BKZpi54rgU",
    "lat": 35.7007483,
    "lng": 139.7697207,
    "placeId": "ChIJe3DEGuKNGGAR2BKZpi54rgU",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6260-7160",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 176,
    "district": "Akihabara",
    "id": 1742
  },
  {
    "title": "FullComp Akihabara",
    "urlinform": "fullcomp-akihabara",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "One Piece"
    ],
    "storeWebsite": "https://www.fullcomp.jp/akihabara/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJU8ef3B2MGGARZhKIscm4vPg",
    "lat": 35.7013487,
    "lng": 139.7713064,
    "placeId": "ChIJU8ef3B2MGGARZhKIscm4vPg",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5256-2652",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 298,
    "district": "Akihabara",
    "id": 1743
  },
  {
    "title": "WonderREX AsakusaROX･3G",
    "urlinform": "wonderrex-asakusarox3g",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.wonderrex.jp/shop/asakusa-rox-3g/?utm_source=ekiten&utm_medium=ekiten_link&utm_campaign=t_map_05",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn-bydHGPGGARZ3hvzYYk0sw",
    "lat": 35.7125077,
    "lng": 139.7934776,
    "placeId": "ChIJn-bydHGPGGARZ3hvzYYk0sw",
    "businessStatus": "OPERATIONAL",
    "phone": "0800-800-8585",
    "openingHours": [
      "Monday: 10:30 AM – 9:00 PM",
      "Tuesday: 10:30 AM – 9:00 PM",
      "Wednesday: 10:30 AM – 9:00 PM",
      "Thursday: 10:30 AM – 9:00 PM",
      "Friday: 10:30 AM – 9:00 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 61,
    "district": "Asakusa",
    "id": 1744
  },
  {
    "title": "Sumire",
    "urlinform": "sumire",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5R6D08aOGGARw7zQY-W-G2A",
    "lat": 35.7117236,
    "lng": 139.7964954,
    "placeId": "ChIJ5R6D08aOGGARw7zQY-W-G2A",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3841-5181",
    "openingHours": [
      "Monday: 11:00 AM – 5:00 PM",
      "Tuesday: 11:00 AM – 5:00 PM",
      "Wednesday: 11:00 AM – 2:00 PM",
      "Thursday: 11:00 AM – 5:00 PM",
      "Friday: 11:00 AM – 5:00 PM",
      "Saturday: 11:00 AM – 5:00 PM",
      "Sunday: 11:00 AM – 5:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 11,
    "district": "Asakusa",
    "id": 1745
  },
  {
    "title": "TSUTAYA Trading Card 北千住",
    "urlinform": "tsutaya-trading-card-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://store-tsutaya.tsite.jp/store/detail?storeId=2530",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZyolLLmPGGARDZ7Yon-AUJk",
    "lat": 35.75049,
    "lng": 139.8043866,
    "placeId": "ChIJZyolLLmPGGARDZ7Yon-AUJk",
    "businessStatus": "OPERATIONAL",
    "phone": "080-4100-9058",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 2.6,
    "userRatingsTotal": 50,
    "id": 1746
  },
  {
    "title": "The Chop Shop Kichijoji",
    "urlinform": "the-chop-shop-kichijoji",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.thechopshop.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn8QwzoHvGGARZblP7TcK6VY",
    "lat": 35.7009323,
    "lng": 139.5834101,
    "placeId": "ChIJn8QwzoHvGGARZblP7TcK6VY",
    "businessStatus": "OPERATIONAL",
    "phone": "0422-26-5595",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 332,
    "district": "Kichijoji",
    "id": 1747
  },
  {
    "title": "Pokémon Store Tokyo Station Shop",
    "urlinform": "pokmon-store-tokyo-station-shop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon.co.jp/shop/store/tokyo/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGeYlX_mLGGAR5X58S2PvaO8",
    "lat": 35.6824964,
    "lng": 139.7686833,
    "placeId": "ChIJGeYlX_mLGGAR5X58S2PvaO8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 8:30 PM",
      "Tuesday: 10:00 AM – 8:30 PM",
      "Wednesday: 10:00 AM – 8:30 PM",
      "Thursday: 10:00 AM – 8:30 PM",
      "Friday: 10:00 AM – 8:30 PM",
      "Saturday: 10:00 AM – 8:30 PM",
      "Sunday: 10:00 AM – 8:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 1574,
    "id": 1748
  },
  {
    "title": "Ginza Itoya",
    "urlinform": "ginza-itoya",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.ito-ya.co.jp/ginza/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKQAKAOSLGGARwGhpOXWgfYo",
    "lat": 35.6731273,
    "lng": 139.7672138,
    "placeId": "ChIJKQAKAOSLGGARwGhpOXWgfYo",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3561-8311",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 19779,
    "district": "Ginza",
    "id": 1749
  },
  {
    "title": "カードショップ トレカラフテル",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/card_raftel?s=21&t=giAq9wtTRIq_SA26LUoNkw",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJUbFhISNGGARmHob4Ha0qm0",
    "lat": 35.6973721,
    "lng": 139.7726161,
    "placeId": "ChIJJUbFhISNGGARmHob4Ha0qm0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 124,
    "district": "Akihabara",
    "id": 1750
  },
  {
    "title": "Kyukyodo",
    "urlinform": "kyukyodo",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.kyukyodo.co.jp/index.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_bJzcOaLGGARRuKxKriDhUs",
    "lat": 35.6710891,
    "lng": 139.7646112,
    "placeId": "ChIJ_bJzcOaLGGARRuKxKriDhUs",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3571-4429",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 1041,
    "district": "Ginza",
    "id": 1751
  },
  {
    "title": "Bandai Namco Cross Store Tokyo",
    "urlinform": "bandai-namco-cross-store-tokyo",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Gundam",
      "Pokémon"
    ],
    "storeWebsite": "https://bandainamco-am.co.jp/game_center/loc/crossstore_tokyo/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJj1N12LGNGGARGJ2BzuC9HI4",
    "lat": 35.7288716,
    "lng": 139.7196438,
    "placeId": "ChIJj1N12LGNGGARGJ2BzuC9HI4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 442,
    "district": "Ikebukuro",
    "id": 1752
  },
  {
    "title": "primaniacs銀座本店",
    "urlinform": "primaniacs",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://primaniacs.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJr6LOfeSLGGAREpQm2SZVRPY",
    "lat": 35.6750783,
    "lng": 139.7673945,
    "placeId": "ChIJr6LOfeSLGGAREpQm2SZVRPY",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6263-0418",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 209,
    "district": "Ginza",
    "id": 1753
  },
  {
    "title": "DRAGON BALL STORE TOKYO",
    "urlinform": "dragon-ball-store-tokyo",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball"
    ],
    "storeWebsite": "https://dragonball-store.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTbiOFQCLGGAR_m27GGhnpJc",
    "lat": 35.6823809,
    "lng": 139.7686662,
    "placeId": "ChIJTbiOFQCLGGAR_m27GGhnpJc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 8:30 PM",
      "Tuesday: 10:00 AM – 8:30 PM",
      "Wednesday: 10:00 AM – 8:30 PM",
      "Thursday: 10:00 AM – 8:30 PM",
      "Friday: 10:00 AM – 8:30 PM",
      "Saturday: 10:00 AM – 8:30 PM",
      "Sunday: 10:00 AM – 8:30 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 301,
    "id": 1754
  },
  {
    "title": "II ADO COMPANY Ginza",
    "urlinform": "ii-ado-company-ginza",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.iiado.co.jp",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFWJ1mOCLGGARg6IF07Lgg-w",
    "lat": 35.6692388,
    "lng": 139.7690868,
    "placeId": "ChIJFWJ1mOCLGGARg6IF07Lgg-w",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5148-1582",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 102,
    "district": "Ginza",
    "id": 1755
  },
  {
    "title": "Tenshodo Ginza",
    "urlinform": "tenshodo-ginza",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://models-store.tenshodo.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJawZK2-WLGGARjYLPxinxbr0",
    "lat": 35.6719962,
    "lng": 139.7644109,
    "placeId": "ChIJawZK2-WLGGARjYLPxinxbr0",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3562-0025",
    "openingHours": [
      "Monday: 11:00 AM – 7:30 PM",
      "Tuesday: 11:00 AM – 7:30 PM",
      "Wednesday: 11:00 AM – 7:30 PM",
      "Thursday: Closed",
      "Friday: 11:00 AM – 7:30 PM",
      "Saturday: 11:00 AM – 7:30 PM",
      "Sunday: 10:00 AM – 6:30 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 261,
    "district": "Ginza",
    "id": 1756
  },
  {
    "title": "Ticket Port Ginza",
    "urlinform": "ticket-port-ginza",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.ticketport.co.jp/shop/ginza/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJp-2OoO-LGGARtXnVoR43-kk",
    "lat": 35.672592,
    "lng": 139.761187,
    "placeId": "ChIJp-2OoO-LGGARtXnVoR43-kk",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6327-3711",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 3.7,
    "userRatingsTotal": 60,
    "district": "Ginza",
    "id": 1757
  },
  {
    "title": "G.C.PRESS Ginza",
    "urlinform": "gcpress-ginza",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://gc-press.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVVV5UO-LGGARWSoNvfmWEmA",
    "lat": 35.6712552,
    "lng": 139.7620956,
    "placeId": "ChIJVVV5UO-LGGARWSoNvfmWEmA",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6280-6720",
    "openingHours": [
      "Monday: 11:30 AM – 6:00 PM",
      "Tuesday: 11:30 AM – 6:00 PM",
      "Wednesday: 11:30 AM – 6:00 PM",
      "Thursday: 11:30 AM – 6:00 PM",
      "Friday: 11:30 AM – 6:00 PM",
      "Saturday: 11:30 AM – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.2,
    "userRatingsTotal": 32,
    "district": "Ginza",
    "id": 1758
  },
  {
    "title": "TCG専門店 ARCANA(アルカナ) 水道橋店",
    "urlinform": "tcg-arcana-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Flesh and Blood",
      "MTG"
    ],
    "storeWebsite": "https://shop.arcana-tcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR7rGeFeNGGARPJ-H0u9hDKQ",
    "lat": 35.6990297,
    "lng": 139.7523391,
    "placeId": "ChIJR7rGeFeNGGARPJ-H0u9hDKQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 6:30 – 10:00 PM",
      "Tuesday: 6:30 – 10:00 PM",
      "Wednesday: Closed",
      "Thursday: 6:30 – 10:00 PM",
      "Friday: 6:30 – 10:00 PM",
      "Saturday: 2:00 – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 2.5,
    "userRatingsTotal": 17,
    "id": 1759
  },
  {
    "title": "カードマックス秋葉原店",
    "urlinform": "store-2059",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Digimon",
      "Flesh and Blood",
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.cardmax.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9e1x3x2MGGARMo9FXR3RLZo",
    "lat": 35.7017801,
    "lng": 139.7713299,
    "placeId": "ChIJ9e1x3x2MGGARMo9FXR3RLZo",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3253-7070",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 2.7,
    "userRatingsTotal": 63,
    "district": "Akihabara",
    "id": 1760
  },
  {
    "title": "遊戯王専門店 カードショップヌメロドス(OCG/RD)",
    "urlinform": "-ocgrd",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://twitter.com/cs_numerodos",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLxpOLNGJGGAR0aG6ZUJ4C6w",
    "lat": 35.6862394,
    "lng": 139.8146864,
    "placeId": "ChIJLxpOLNGJGGAR0aG6ZUJ4C6w",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6284-0993",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:30 – 9:30 PM",
      "Wednesday: 2:30 – 9:30 PM",
      "Thursday: Closed",
      "Friday: 2:30 – 9:30 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 103,
    "id": 1761
  },
  {
    "title": "カードショップEDEN千葉2号店",
    "urlinform": "eden2",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "https://cardshop-eden.vercel.app/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0fnwOsGFImARwTKrUSf09Ec",
    "lat": 35.6077157,
    "lng": 140.11708,
    "placeId": "ChIJ0fnwOsGFImARwTKrUSf09Ec",
    "businessStatus": "OPERATIONAL",
    "phone": "070-5268-3973",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 48,
    "district": "Chiba",
    "id": 1762
  },
  {
    "title": "トレカ道楽 横浜西口店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://douraku.info/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcZHvxMJdGGARYX2zqQrZ2Aw",
    "lat": 35.4634333,
    "lng": 139.615229,
    "placeId": "ChIJcZHvxMJdGGARYX2zqQrZ2Aw",
    "businessStatus": "OPERATIONAL",
    "phone": "080-9712-0819",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 35,
    "district": "Yokohama",
    "id": 1763
  },
  {
    "title": "MTG Shop 信心亭",
    "urlinform": "mtg-shop-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "https://www.sinjintei.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB46FMgxcGGARBHR9wj8QA84",
    "lat": 35.4647627,
    "lng": 139.6170264,
    "placeId": "ChIJB46FMgxcGGARBHR9wj8QA84",
    "businessStatus": "OPERATIONAL",
    "phone": "045-322-6314",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 35,
    "district": "Yokohama",
    "id": 1764
  },
  {
    "title": "Card lab Namba second shop",
    "urlinform": "card-lab-namba-second-shop",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.c-labo.jp/shop/namba2nd/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9QZxdmnnAGARfNXA91zVBNw",
    "lat": 34.6623537,
    "lng": 135.5039393,
    "placeId": "ChIJ9QZxdmnnAGARfNXA91zVBNw",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6631-8071",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 2.9,
    "userRatingsTotal": 57,
    "district": "Namba",
    "id": 1765
  },
  {
    "title": "TCG shop Japan",
    "urlinform": "tcg-shop-japan",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://wa.me/14583432370",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKcdIXDnnAGAR6xCyFqNv4oc",
    "lat": 34.6987076,
    "lng": 135.4995633,
    "placeId": "ChIJKcdIXDnnAGAR6xCyFqNv4oc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 2,
    "district": "Umeda",
    "id": 1766
  },
  {
    "title": "ポケカ買取 高値屋",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQ1Ql87LnAGARsLzqPTjQnek",
    "lat": 34.7040838,
    "lng": 135.512885,
    "placeId": "ChIJQ1Ql87LnAGARsLzqPTjQnek",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9299-6161",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 51,
    "id": 1767
  },
  {
    "title": "トレカQUQU日本橋オタロード店",
    "urlinform": "ququ",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://torekaququ.base.shop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjcA-yS_nAGARNk957TnVg8A",
    "lat": 34.6611502,
    "lng": 135.5049906,
    "placeId": "ChIJjcA-yS_nAGARNk957TnVg8A",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 90,
    "district": "Namba",
    "id": 1768
  },
  {
    "title": "Kadorabo Otarodo Honten",
    "urlinform": "kadorabo-otarodo-honten",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "Battle Spirits",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.c-labo.jp/shop/otaro/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTd7mQWjnAGARX0OMPzzoFYA",
    "lat": 34.6603359,
    "lng": 135.5049297,
    "placeId": "ChIJTd7mQWjnAGARX0OMPzzoFYA",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6630-0260",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 2.2,
    "userRatingsTotal": 140,
    "district": "Namba",
    "id": 1769
  },
  {
    "title": "TCG shop by NastyDog",
    "urlinform": "tcg-shop-by-nastydog",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg-UKYibnAGARdxa1A8qi6WM",
    "lat": 34.6717041,
    "lng": 135.4987805,
    "placeId": "ChIJg-UKYibnAGARdxa1A8qi6WM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 59,
    "district": "Shinsaibashi",
    "id": 1770
  },
  {
    "title": "Jungle",
    "urlinform": "jungle",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://jungle-scs.co.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAQCEKWjnAGARAWlfae3xIxM",
    "lat": 34.661731,
    "lng": 135.506187,
    "placeId": "ChIJAQCEKWjnAGARAWlfae3xIxM",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6636-7444",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 1447,
    "district": "Namba",
    "id": 1771
  },
  {
    "title": "Duel stade Ganryu 名古屋大須店",
    "urlinform": "duel-stade-ganryu-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.wonder.co.jp/tcg/?utm_source=GoogleMAP",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR3fH3zVxA2ARZR6LXGJhl30",
    "lat": 35.1588714,
    "lng": 136.9054525,
    "placeId": "ChIJR3fH3zVxA2ARZR6LXGJhl30",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 15,
    "district": "Osu",
    "id": 1772
  },
  {
    "title": "プレイズ 大須店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://playze.jp/pages/playze_osu",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-aUemqtxA2ARDh5ObqNrOq0",
    "lat": 35.1583967,
    "lng": 136.9062863,
    "placeId": "ChIJ-aUemqtxA2ARDh5ObqNrOq0",
    "businessStatus": "OPERATIONAL",
    "phone": "052-212-9181",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 21,
    "district": "Osu",
    "id": 1773
  },
  {
    "title": "Kansai Card Supply",
    "urlinform": "kansai-card-supply",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/kansaicardsupplyjp",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC9iEaVdxA2ARUlwwVcQLwi0",
    "lat": 35.1597042,
    "lng": 136.9044636,
    "placeId": "ChIJC9iEaVdxA2ARUlwwVcQLwi0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 4.7,
    "userRatingsTotal": 3,
    "district": "Osu",
    "id": 1774
  },
  {
    "title": "Miracle Trading Card Buy&Sell",
    "urlinform": "miracle-trading-card-buysell",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyZt6tuJxA2ARM_tSlfwHGA4",
    "lat": 35.1598198,
    "lng": 136.9042109,
    "placeId": "ChIJyZt6tuJxA2ARM_tSlfwHGA4",
    "businessStatus": "OPERATIONAL",
    "phone": "090-3086-7204",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 6,
    "district": "Osu",
    "id": 1775
  },
  {
    "title": "TCG専門店 トレカSOUL名古屋店",
    "urlinform": "tcg-soul",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/TCG_SOUL_NGY",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY8j3HABxA2ARpXi4TZWzLjQ",
    "lat": 35.1617745,
    "lng": 136.9068685,
    "placeId": "ChIJY8j3HABxA2ARpXi4TZWzLjQ",
    "businessStatus": "OPERATIONAL",
    "phone": "070-8544-6792",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "district": "Osu",
    "id": 1776
  },
  {
    "title": "晴れる屋2 大須店",
    "urlinform": "2-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.hareruya2.com/pages/store_osu",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJSU0ryEJxA2AR_wjdPvRqy0c",
    "lat": 35.1583967,
    "lng": 136.9062863,
    "placeId": "ChIJSU0ryEJxA2AR_wjdPvRqy0c",
    "businessStatus": "OPERATIONAL",
    "phone": "052-990-6460",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 37,
    "district": "Osu",
    "id": 1777
  },
  {
    "title": "竜星の嵐 名古屋店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/card_arashi_n?s=21&t=VQzw5ewHJqHRmqn5okNR5A",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh612A9h3A2ARFW7yrpI9o4E",
    "lat": 35.1678974,
    "lng": 136.8793146,
    "placeId": "ChIJh612A9h3A2ARFW7yrpI9o4E",
    "businessStatus": "OPERATIONAL",
    "phone": "052-414-5664",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 2.2,
    "userRatingsTotal": 141,
    "district": "Nagoya Station",
    "id": 1778
  },
  {
    "title": "Super Potato - Nagoya Store",
    "urlinform": "super-potato-nagoya-store",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.superpotato.com/shop/nagoya/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjY95jcxwA2AREYLaEAb5mqc",
    "lat": 35.1604598,
    "lng": 136.9046866,
    "placeId": "ChIJjY95jcxwA2AREYLaEAb5mqc",
    "businessStatus": "OPERATIONAL",
    "phone": "052-261-3005",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 322,
    "district": "Osu",
    "id": 1779
  },
  {
    "title": "Furuichi",
    "urlinform": "furuichi",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Gundam",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.furu1.net/shop/shop0167.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHUqGWed7A2ARCtTgdfN4OOU",
    "lat": 35.13706550000001,
    "lng": 136.9091935,
    "placeId": "ChIJHUqGWed7A2ARCtTgdfN4OOU",
    "businessStatus": "OPERATIONAL",
    "phone": "052-825-8025",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 80,
    "id": 1780
  },
  {
    "title": "カードショップ買取＆販売トレカハブ福岡博多店",
    "urlinform": "store-2113",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/torekahub?s=11",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuaFfJF2RQTURBMToWGg1_Co",
    "lat": 33.5899863,
    "lng": 130.4161122,
    "placeId": "ChIJuaFfJF2RQTURBMToWGg1_Co",
    "businessStatus": "OPERATIONAL",
    "phone": "080-2758-1857",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 19,
    "district": "Hakata",
    "id": 1781
  },
  {
    "title": "Momotaro Greeting",
    "urlinform": "momotaro-greeting",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ming.or.jp/floorguide/shop83.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvzv028eRQTURttEzTpcqJDI",
    "lat": 33.5906086,
    "lng": 130.4206543,
    "placeId": "ChIJvzv028eRQTURttEzTpcqJDI",
    "businessStatus": "OPERATIONAL",
    "phone": "092-431-6576",
    "openingHours": [
      "Monday: 9:00 AM – 9:00 PM",
      "Tuesday: 9:00 AM – 9:00 PM",
      "Wednesday: 9:00 AM – 9:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 9:00 PM",
      "Saturday: 9:00 AM – 9:00 PM",
      "Sunday: 9:00 AM – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 33,
    "district": "Hakata",
    "id": 1782
  },
  {
    "title": "Bandai Namco Cross Store Hakata",
    "urlinform": "bandai-namco-cross-store-hakata",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "Gundam",
      "Pokémon"
    ],
    "storeWebsite": "https://bandainamco-am.co.jp/game_center/loc/hakata-canalcity/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrVNlkjuRQTURFzjhoiNcNow",
    "lat": 33.5886702,
    "lng": 130.4108171,
    "placeId": "ChIJrVNlkjuRQTURFzjhoiNcNow",
    "businessStatus": "OPERATIONAL",
    "phone": "0570-076-562",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 193,
    "district": "Nakasu",
    "id": 1783
  },
  {
    "title": "COLLECTOR'S SHOP LIT 北九州小倉店",
    "urlinform": "collectors-shop-lit-",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/lit_kokura?s=11&t=L8t6SqohUhMOKlpHD0aKKQ",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyzgOH6K_QzURUcI89raCqqQ",
    "lat": 33.8836978,
    "lng": 130.8793283,
    "placeId": "ChIJyzgOH6K_QzURUcI89raCqqQ",
    "businessStatus": "OPERATIONAL",
    "phone": "070-1501-6202",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 27,
    "district": "Kokura",
    "id": 1784
  },
  {
    "title": "Kadobokkusu Iontaunkurosakiten",
    "urlinform": "kadobokkusu-iontaunkurosakiten",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cardbox.online/shop/detail/5015/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQbDqqcXJQzURohrAEM8fEQA",
    "lat": 33.8598131,
    "lng": 130.760358,
    "placeId": "ChIJQbDqqcXJQzURohrAEM8fEQA",
    "businessStatus": "OPERATIONAL",
    "phone": "093-616-0324",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 9:00 AM – 9:00 PM",
      "Sunday: 9:00 AM – 9:00 PM"
    ],
    "rating": 2,
    "userRatingsTotal": 108,
    "id": 1785
  },
  {
    "title": "Geo (Kitakyushu Nakatsuguchi)",
    "urlinform": "geo-kitakyushu-nakatsuguchi",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://geo-online.co.jp/store/03075/?utm_source=google&utm_medium=map&utm_campaign=03075",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ1fIXklC_QzURtJsRG1wh11o",
    "lat": 33.877238,
    "lng": 130.8869106,
    "placeId": "ChIJ1fIXklC_QzURtJsRG1wh11o",
    "businessStatus": "OPERATIONAL",
    "phone": "093-512-7051",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3.4,
    "userRatingsTotal": 230,
    "district": "Kokura",
    "id": 1786
  },
  {
    "title": "Geo Kitakyushu Kuzuhara",
    "urlinform": "geo-kitakyushu-kuzuhara",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://geo-online.co.jp/store/03008/?utm_source=google&utm_medium=map&utm_campaign=03008",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3Zn51W7AQzURrG2dhbN4fzw",
    "lat": 33.8396387,
    "lng": 130.9308867,
    "placeId": "ChIJ3Zn51W7AQzURrG2dhbN4fzw",
    "businessStatus": "OPERATIONAL",
    "phone": "093-474-9111",
    "openingHours": [
      "Monday: 10:00 AM – 12:00 AM",
      "Tuesday: 10:00 AM – 12:00 AM",
      "Wednesday: 10:00 AM – 12:00 AM",
      "Thursday: 10:00 AM – 12:00 AM",
      "Friday: 10:00 AM – 12:00 AM",
      "Saturday: 10:00 AM – 12:00 AM",
      "Sunday: 10:00 AM – 12:00 AM"
    ],
    "rating": 3.6,
    "userRatingsTotal": 268,
    "id": 1787
  },
  {
    "title": "Geo Kitakyushu Tokuyoshi",
    "urlinform": "geo-kitakyushu-tokuyoshi",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://geo-online.co.jp/store/03425/?utm_source=google&utm_medium=map&utm_campaign=03425",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJH0t_YqLGQzURUAkxRVk0JxQ",
    "lat": 33.8149858,
    "lng": 130.8583633,
    "placeId": "ChIJH0t_YqLGQzURUAkxRVk0JxQ",
    "businessStatus": "OPERATIONAL",
    "phone": "093-453-3701",
    "openingHours": [
      "Monday: 9:00 AM – 10:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 10:00 PM",
      "Sunday: 9:00 AM – 10:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 176,
    "id": 1788
  },
  {
    "title": "POKEMON CARD SHOP ZAQZAQQ",
    "urlinform": "pokemon-card-shop-zaqzaqq",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.instagram.com/pokemon_card_shop_zaqzaqq?igsh=MTgwM3JudzNubW5xdA%3D%3D&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzQfd3kVp5TQRsiGsooMRuRk",
    "lat": 26.2182875,
    "lng": 127.6861601,
    "placeId": "ChIJzQfd3kVp5TQRsiGsooMRuRk",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9458-2027",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 83,
    "district": "Kokusai Street",
    "id": 1789
  },
  {
    "title": "Pokemon cardshop GODPACK",
    "urlinform": "pokemon-cardshop-godpack",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.instagram.com/godpack510?igsh=bzJmY2thYjY0ajln&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_xXXtvwT5TQRnzW6dvrONeM",
    "lat": 26.3370337,
    "lng": 127.8008651,
    "placeId": "ChIJ_xXXtvwT5TQRnzW6dvrONeM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 PM – 1:00 AM",
      "Tuesday: 3:00 PM – 1:00 AM",
      "Wednesday: 3:00 PM – 1:00 AM",
      "Thursday: 3:00 PM – 1:00 AM",
      "Friday: 3:00 PM – 1:00 AM",
      "Saturday: 3:00 PM – 1:00 AM",
      "Sunday: 3:00 PM – 1:00 AM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 12,
    "id": 1790
  },
  {
    "title": "TCG SHOP Mackie",
    "urlinform": "tcg-shop-mackie",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/tcgshop.mackie?igsi=eWJyMGIxbTZxZXk4&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF0J8vQJp5TQRBzj3mCdPi2E",
    "lat": 26.2138469,
    "lng": 127.6819227,
    "placeId": "ChIJF0J8vQJp5TQRBzj3mCdPi2E",
    "businessStatus": "OPERATIONAL",
    "phone": "050-8887-2126",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: 1:00 – 7:00 PM",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 16,
    "district": "Naha",
    "id": 1791
  },
  {
    "title": "Mr. Moon Vapes Chatan",
    "urlinform": "mr-moon-vapes-chatan",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.mrmoonvapes.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPwr6dyQT5TQRclj6cEOQCBQ",
    "lat": 26.3093524,
    "lng": 127.7634177,
    "placeId": "ChIJPwr6dyQT5TQRclj6cEOQCBQ",
    "businessStatus": "OPERATIONAL",
    "phone": "098-960-7861",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 795,
    "district": "American Village",
    "id": 1792
  },
  {
    "title": "GEO Okinawa Yamauchi",
    "urlinform": "geo-okinawa-yamauchi",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://geo-online.co.jp/store/03234/?utm_source=google&utm_medium=map&utm_campaign=03234",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJT0TOAEUS5TQRM1JUyvQpWhE",
    "lat": 26.330237,
    "lng": 127.779263,
    "placeId": "ChIJT0TOAEUS5TQRM1JUyvQpWhE",
    "businessStatus": "OPERATIONAL",
    "phone": "098-931-0277",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 121,
    "id": 1793
  },
  {
    "title": "トレカショップOceanうるま店",
    "urlinform": "ocean",
    "nation": "Japan",
    "prefecture": "Okinawa",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/OceanUruma",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhzsXaAAP5TQRmlP6TEtS9zw",
    "lat": 26.3546585,
    "lng": 127.8257459,
    "placeId": "ChIJhzsXaAAP5TQRmlP6TEtS9zw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1794
  },
  {
    "title": "Card Card Fruit",
    "urlinform": "card-card-fruit",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "One Piece",
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "https://cardcardfruit.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC1NCG5oBBDQREVeHEBI9UbI",
    "lat": 22.3160308,
    "lng": 114.170334,
    "placeId": "ChIJC1NCG5oBBDQREVeHEBI9UbI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 66,
    "district": "Mong Kok",
    "id": 1795
  },
  {
    "title": "808 Board Game",
    "urlinform": "808-board-game",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.808.games/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmyVk4sYABDQRr9BcKnCY-B8",
    "lat": 22.3162989,
    "lng": 114.1705112,
    "placeId": "ChIJmyVk4sYABDQRr9BcKnCY-B8",
    "businessStatus": "OPERATIONAL",
    "phone": "3791 2799",
    "openingHours": [
      "Monday: 2:30 – 11:00 PM",
      "Tuesday: 2:30 – 11:00 PM",
      "Wednesday: 2:30 – 11:00 PM",
      "Thursday: 2:30 – 11:00 PM",
      "Friday: 2:30 PM – 1:00 AM",
      "Saturday: 1:00 PM – 1:00 AM",
      "Sunday: 1:00 PM – 1:00 AM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 192,
    "district": "Mong Kok",
    "id": 1796
  },
  {
    "title": "May Toys 五月玩具店",
    "urlinform": "may-toys-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://facebook.com/Maytoys",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZcDUHscABDQRIGTLG4ckmz0",
    "lat": 22.316035,
    "lng": 114.1702645,
    "placeId": "ChIJZcDUHscABDQRIGTLG4ckmz0",
    "businessStatus": "OPERATIONAL",
    "phone": "9521 0708",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 68,
    "district": "Mong Kok",
    "id": 1797
  },
  {
    "title": "CardGET",
    "urlinform": "cardget",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://addpockco.wixsite.com/cardget",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8UzmPIYBBDQRn7OlTYndssM",
    "lat": 22.2788328,
    "lng": 114.1837563,
    "placeId": "ChIJ8UzmPIYBBDQRn7OlTYndssM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 138,
    "district": "Causeway Bay",
    "id": 1798
  },
  {
    "title": "KURA TCG",
    "urlinform": "kura-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJP7A5fAABBDQRpyxCSle_ceo",
    "lat": 22.2785362,
    "lng": 114.1835226,
    "placeId": "ChIJP7A5fAABBDQRpyxCSle_ceo",
    "businessStatus": "OPERATIONAL",
    "phone": "5213 7852",
    "openingHours": [
      "Monday: 1:00 – 10:30 PM",
      "Tuesday: 1:00 – 10:30 PM",
      "Wednesday: 1:00 – 10:30 PM",
      "Thursday: 1:00 – 10:30 PM",
      "Friday: 1:00 – 10:30 PM",
      "Saturday: 1:00 – 10:30 PM",
      "Sunday: 1:00 – 10:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 8,
    "district": "Causeway Bay",
    "id": 1799
  },
  {
    "title": "DUBAI TCG LIMITED 杜拜卡牌有限公司",
    "urlinform": "dubai-tcg-limited-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/dubaitcghk/?hl=en",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJw1uboN0HBDQRES_GOqKVIQo",
    "lat": 22.334593,
    "lng": 114.199215,
    "placeId": "ChIJw1uboN0HBDQRES_GOqKVIQo",
    "businessStatus": "OPERATIONAL",
    "phone": "9317 3139",
    "openingHours": [
      "Monday: 6:00 PM – 12:30 AM",
      "Tuesday: 5:00 PM – 12:30 AM",
      "Wednesday: 5:00 PM – 12:30 AM",
      "Thursday: Closed",
      "Friday: 5:00 PM – 2:00 AM",
      "Saturday: 5:00 PM – 2:00 AM",
      "Sunday: 5:00 PM – 12:30 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 41,
    "id": 1800
  },
  {
    "title": "Card Hobby HK (TST)",
    "urlinform": "card-hobby-hk-tst",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ41AWdAABBDQRsNMObsSWgQM",
    "lat": 22.2994296,
    "lng": 114.1724068,
    "placeId": "ChIJ41AWdAABBDQRsNMObsSWgQM",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 17,
    "district": "Tsim Sha Tsui",
    "id": 1801
  },
  {
    "title": "Legendary TCG",
    "urlinform": "legendary-tcg",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/legendarytcghk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyU8WrwsBBDQRpofSMVb5PLA",
    "lat": 22.2966874,
    "lng": 114.1718859,
    "placeId": "ChIJyU8WrwsBBDQRpofSMVb5PLA",
    "businessStatus": "OPERATIONAL",
    "phone": "9059 8693",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 6,
    "district": "Tsim Sha Tsui",
    "id": 1802
  },
  {
    "title": "卡野家 Card Noya TCG 集換式卡牌專門店",
    "urlinform": "-card-noya-tcg-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://cardnoya.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsTymPJYBBDQRdb1wxZpe2rc",
    "lat": 22.2998999,
    "lng": 114.1742102,
    "placeId": "ChIJsTymPJYBBDQRdb1wxZpe2rc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 15,
    "district": "Tsim Sha Tsui",
    "id": 1803
  },
  {
    "title": "Pocha Cards",
    "urlinform": "pocha-cards",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/pochacards",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs8JTDv0BBDQRE1oVPsSa-fA",
    "lat": 22.3001688,
    "lng": 114.1739528,
    "placeId": "ChIJs8JTDv0BBDQRE1oVPsSa-fA",
    "businessStatus": "OPERATIONAL",
    "phone": "9449 4002",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 83,
    "district": "Tsim Sha Tsui",
    "id": 1804
  },
  {
    "title": "Chalice Collectibles HK",
    "urlinform": "chalice-collectibles-hk",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://chalicecollectibleshk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJba5d2gwBBDQRfwbMJ7jRBS0",
    "lat": 22.2970811,
    "lng": 114.172163,
    "placeId": "ChIJba5d2gwBBDQRfwbMJ7jRBS0",
    "businessStatus": "OPERATIONAL",
    "phone": "9445 1179",
    "openingHours": [
      "Monday: 12:30 – 10:00 PM",
      "Tuesday: 12:30 – 10:00 PM",
      "Wednesday: 12:30 – 10:00 PM",
      "Thursday: 12:30 – 10:00 PM",
      "Friday: 12:30 – 10:00 PM",
      "Saturday: 12:30 – 10:00 PM",
      "Sunday: 12:30 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 29,
    "district": "Tsim Sha Tsui",
    "id": 1805
  },
  {
    "title": "Gabangel",
    "urlinform": "gabangel",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.gabangel.hk/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIR-2Ag8BBDQRU6c676tYt0g",
    "lat": 22.2974299,
    "lng": 114.1737537,
    "placeId": "ChIJIR-2Ag8BBDQRU6c676tYt0g",
    "businessStatus": "OPERATIONAL",
    "phone": "9485 1600",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 8,
    "district": "Tsim Sha Tsui",
    "id": 1806
  },
  {
    "title": "155CSW",
    "urlinform": "155csw",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwU78PEIHBDQRZtACDnyiCLA",
    "lat": 22.3351446,
    "lng": 114.1601917,
    "placeId": "ChIJwU78PEIHBDQRZtACDnyiCLA",
    "businessStatus": "OPERATIONAL",
    "phone": "5662 8896",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "district": "Sham Shui Po",
    "id": 1807
  },
  {
    "title": "Sham Shui Po Toy Street",
    "urlinform": "sham-shui-po-toy-street",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg6CPxrQABDQRV5M-zx_nbog",
    "lat": 22.3311375,
    "lng": 114.1639015,
    "placeId": "ChIJg6CPxrQABDQRV5M-zx_nbog",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM",
      "Friday: 12:00 – 7:00 PM",
      "Saturday: 12:00 – 7:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 11891,
    "district": "Sham Shui Po",
    "id": 1808
  },
  {
    "title": "Video Game Network",
    "urlinform": "video-game-network",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://www.directbuyhk.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_3yCUrMABDQR53ZvEWGCuV8",
    "lat": 22.3324963,
    "lng": 114.1609174,
    "placeId": "ChIJ_3yCUrMABDQR53ZvEWGCuV8",
    "businessStatus": "OPERATIONAL",
    "phone": "2307 6666",
    "openingHours": [
      "Monday: 10:30 AM – 7:30 PM",
      "Tuesday: 10:30 AM – 7:30 PM",
      "Wednesday: 10:30 AM – 7:30 PM",
      "Thursday: 10:30 AM – 7:30 PM",
      "Friday: 10:30 AM – 7:30 PM",
      "Saturday: 10:30 AM – 7:30 PM",
      "Sunday: Closed"
    ],
    "rating": 3.7,
    "userRatingsTotal": 149,
    "district": "Sham Shui Po",
    "id": 1809
  },
  {
    "title": "Omochya Minato.Toy",
    "urlinform": "omochya-minatotoy",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=100065197412224",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ2YKS-ksBBDQR-NfESutknNs",
    "lat": 22.3308612,
    "lng": 114.1639779,
    "placeId": "ChIJ2YKS-ksBBDQR-NfESutknNs",
    "businessStatus": "OPERATIONAL",
    "phone": "6582 6662",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 46,
    "district": "Sham Shui Po",
    "id": 1810
  },
  {
    "title": "Hung Hing Toys",
    "urlinform": "hung-hing-toys",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.hunghingtoys.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPQFVpFwABDQRYGnEOmJSD0Q",
    "lat": 22.2758834,
    "lng": 114.1731804,
    "placeId": "ChIJPQFVpFwABDQRYGnEOmJSD0Q",
    "businessStatus": "OPERATIONAL",
    "phone": "2891 4739",
    "openingHours": [
      "Monday: 9:30 AM – 8:00 PM",
      "Tuesday: 9:30 AM – 8:00 PM",
      "Wednesday: 9:30 AM – 8:00 PM",
      "Thursday: 9:30 AM – 8:00 PM",
      "Friday: 9:30 AM – 8:00 PM",
      "Saturday: 9:30 AM – 8:00 PM",
      "Sunday: 9:30 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 798,
    "district": "Wan Chai",
    "id": 1811
  },
  {
    "title": "TimeGether_TCG.25",
    "urlinform": "timegether_tcg25",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtYQlti0BBDQRyWH9n2gJUYM",
    "lat": 22.3104591,
    "lng": 114.2251647,
    "placeId": "ChIJtYQlti0BBDQRyWH9n2gJUYM",
    "businessStatus": "OPERATIONAL",
    "phone": "4493 2078",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3,
    "district": "Kwun Tong",
    "id": 1812
  },
  {
    "title": "GAME休閒館 台北三創店",
    "urlinform": "game-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZX-6Tj-pQjQRpMk1Qzm47lA",
    "lat": 25.0454897,
    "lng": 121.5311294,
    "placeId": "ChIJZX-6Tj-pQjQRpMk1Qzm47lA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2356 3639",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 415,
    "district": "Taipei Station",
    "id": 1813
  },
  {
    "title": "夯品集大直門市 PS5/SWITCH/XBOX主機&軟體販售預購.二手主機/遊戲買賣.主機檢測&送修.寶可夢卡牌",
    "urlinform": "-ps5switchxbox",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.fadmart.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfYuhZZutQjQRZEHntGi1I-I",
    "lat": 25.0822376,
    "lng": 121.5495356,
    "placeId": "ChIJfYuhZZutQjQRZEHntGi1I-I",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2532 6737",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 132,
    "id": 1814
  },
  {
    "title": "夯品集CITYLINK南港門市 PS5/SWITCH/XBOX主機&軟體販售預購.二手主機/遊戲買賣.主機檢測&送修.寶可夢卡牌",
    "urlinform": "citylink-ps5switchxbox",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.fadmart.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc0SLs-yrQjQRzS8F6pyYreA",
    "lat": 25.0524417,
    "lng": 121.6035521,
    "placeId": "ChIJc0SLs-yrQjQRzS8F6pyYreA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2652 9356",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 71,
    "id": 1815
  },
  {
    "title": "台北地下街 電玩遊戲區",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJaxVIeJGpQjQR2W8ldodJlCE",
    "lat": 25.0493476,
    "lng": 121.5135604,
    "placeId": "ChIJaxVIeJGpQjQR2W8ldodJlCE",
    "businessStatus": "OPERATIONAL",
    "phone": "0937 040 148",
    "openingHours": [
      "Monday: 1:30 – 9:00 PM",
      "Tuesday: 1:30 – 9:00 PM",
      "Wednesday: 1:30 – 9:00 PM",
      "Thursday: 1:30 – 9:00 PM",
      "Friday: 1:30 – 9:00 PM",
      "Saturday: 1:30 – 9:00 PM",
      "Sunday: 1:30 – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 32,
    "district": "Taipei Station",
    "id": 1816
  },
  {
    "title": "Donguri Republic",
    "urlinform": "donguri-republic",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.donguri-republic.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmxFEtLCrQjQR0MqOvhp_h7E",
    "lat": 25.0382241,
    "lng": 121.5667909,
    "placeId": "ChIJmxFEtLCrQjQR0MqOvhp_h7E",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2720 6618",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 1278,
    "id": 1817
  },
  {
    "title": "Kuang Nan Wholesale Taipei Xuchang Store",
    "urlinform": "kuang-nan-wholesale-taipei-xuchang-store",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.knn.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJe3atGHOpQjQRRltYVQwEwXc",
    "lat": 25.0453919,
    "lng": 121.5157276,
    "placeId": "ChIJe3atGHOpQjQRRltYVQwEwXc",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2311 0528",
    "openingHours": [
      "Monday: 10:30 AM – 10:30 PM",
      "Tuesday: 10:30 AM – 10:30 PM",
      "Wednesday: 10:30 AM – 10:30 PM",
      "Thursday: 10:30 AM – 10:30 PM",
      "Friday: 10:30 AM – 10:30 PM",
      "Saturday: 10:30 AM – 10:30 PM",
      "Sunday: 10:30 AM – 10:30 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 2246,
    "district": "Taipei Station",
    "id": 1818
  },
  {
    "title": "Taipei Station Wholesale Shopping District",
    "urlinform": "taipei-station-wholesale-shopping-district",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJA3SPzhKpQjQRacxcK41FnJw",
    "lat": 25.049996,
    "lng": 121.5136898,
    "placeId": "ChIJA3SPzhKpQjQRacxcK41FnJw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 210,
    "district": "Taipei Station",
    "id": 1819
  },
  {
    "title": "Taipei Main Station",
    "urlinform": "taipei-main-station",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.tymetro.com.tw/tymetro-new/tw/_pages/travel-guide/A1",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJlWImqHKpQjQREk5-6lec4-w",
    "lat": 25.04882,
    "lng": 121.51375,
    "placeId": "ChIJlWImqHKpQjQREk5-6lec4-w",
    "businessStatus": "OPERATIONAL",
    "phone": "03 286 8789",
    "openingHours": [],
    "rating": 4.3,
    "userRatingsTotal": 4890,
    "district": "Taipei Station",
    "id": 1820
  },
  {
    "title": "X50 Music Game Station 一店",
    "urlinform": "x50-music-game-station-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/x50mgs",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjci5l_GpQjQROhDzP5Jgn60",
    "lat": 25.0455526,
    "lng": 121.502806,
    "placeId": "ChIJjci5l_GpQjQROhDzP5Jgn60",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.5,
    "userRatingsTotal": 253,
    "district": "Ximending",
    "id": 1821
  },
  {
    "title": "女神這 EVA HERE TCG & TOY",
    "urlinform": "-eva-here-tcg-toy",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/eva.here_tcg_toy/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0b1lCeepQjQRkHmUinKfcA0",
    "lat": 25.044168,
    "lng": 121.506444,
    "placeId": "ChIJ0b1lCeepQjQRkHmUinKfcA0",
    "businessStatus": "OPERATIONAL",
    "phone": "0966 460 131",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 52,
    "district": "Ximending",
    "id": 1822
  },
  {
    "title": "KA Vault | TCG Shop",
    "urlinform": "ka-vault-tcg-shop",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJr9MWHDSpQjQRNBAofGpXc8M",
    "lat": 25.0432161,
    "lng": 121.5059657,
    "placeId": "ChIJr9MWHDSpQjQRNBAofGpXc8M",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 7:00 PM",
      "Thursday: 2:00 – 7:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 2:00 – 8:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 10,
    "district": "Ximending",
    "id": 1823
  },
  {
    "title": "原動力Game Power",
    "urlinform": "game-power",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsdJkEjypQjQRwcLAruiy4tI",
    "lat": 25.0463845,
    "lng": 121.5159026,
    "placeId": "ChIJsdJkEjypQjQRwcLAruiy4tI",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2331 3284",
    "openingHours": [
      "Monday: 3:30 – 10:00 PM",
      "Tuesday: 3:30 – 10:00 PM",
      "Wednesday: 3:30 – 10:00 PM",
      "Thursday: 3:30 – 10:00 PM",
      "Friday: 3:30 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 10,
    "district": "Taipei Station",
    "id": 1824
  },
  {
    "title": "頑聚a狗_TCG GK 一番賞 陀螺 盲盒",
    "urlinform": "a_tcg-gk-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lin.ee/S2Qrlbg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcyJqLEGpQjQR6xrID201Kx8",
    "lat": 25.0453915,
    "lng": 121.5063989,
    "placeId": "ChIJcyJqLEGpQjQR6xrID201Kx8",
    "businessStatus": "OPERATIONAL",
    "phone": "0970 150 102",
    "openingHours": [
      "Monday: 2:00 – 10:30 PM",
      "Tuesday: 2:00 – 10:30 PM",
      "Wednesday: 2:00 – 10:30 PM",
      "Thursday: 2:00 – 10:30 PM",
      "Friday: 2:00 – 11:00 PM",
      "Saturday: 12:30 – 11:00 PM",
      "Sunday: 12:30 – 10:30 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "district": "Ximending",
    "id": 1825
  },
  {
    "title": "Eslite Spectrum Ximen",
    "urlinform": "eslite-spectrum-ximen",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://meet.eslite.com/tw/tc/store/20180220015",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJv_XXHQmpQjQRteItj_pOUDA",
    "lat": 25.043599,
    "lng": 121.5053553,
    "placeId": "ChIJv_XXHQmpQjQRteItj_pOUDA",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2388 6588",
    "openingHours": [
      "Monday: 11:30 AM – 10:00 PM",
      "Tuesday: 11:30 AM – 10:00 PM",
      "Wednesday: 11:30 AM – 10:00 PM",
      "Thursday: 11:30 AM – 10:00 PM",
      "Friday: 11:30 AM – 10:00 PM",
      "Saturday: 11:30 AM – 10:00 PM",
      "Sunday: 11:30 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 16567,
    "district": "Ximending",
    "id": 1826
  },
  {
    "title": "Eslite Spectrum Wuchang",
    "urlinform": "eslite-spectrum-wuchang",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://meet.eslite.com/tw/tc/store/20180220005",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJX10H1gipQjQRabBucTpTekU",
    "lat": 25.0452596,
    "lng": 121.5057671,
    "placeId": "ChIJX10H1gipQjQRabBucTpTekU",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2381 3838",
    "openingHours": [
      "Monday: 11:30 AM – 10:00 PM",
      "Tuesday: 11:30 AM – 10:00 PM",
      "Wednesday: 11:30 AM – 10:00 PM",
      "Thursday: 11:30 AM – 10:00 PM",
      "Friday: 11:30 AM – 10:00 PM",
      "Saturday: 11:30 AM – 10:00 PM",
      "Sunday: 11:30 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 7847,
    "district": "Ximending",
    "id": 1827
  },
  {
    "title": "咪狗卡舖 MiDogTCG | 集換式卡牌專賣【寶可夢、遊戲王、航海王、GrandArchive】(一中豐仁冰巷子內)",
    "urlinform": "-midogtcg-grandarchive",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/MiDogTCG",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVWcI_Ro9aTQRWBq3VcVt3Wo",
    "lat": 24.148762,
    "lng": 120.686351,
    "placeId": "ChIJVWcI_Ro9aTQRWBq3VcVt3Wo",
    "businessStatus": "OPERATIONAL",
    "phone": "0986 484 622",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 286,
    "district": "Taichung Yizhong",
    "id": 1828
  },
  {
    "title": "ONE桌遊 台中站前店-西區24H自助桌遊|自助麻將館|麻將會館|麻將館首選|桌遊店推薦|電動麻將館|休閒棋牌社|娛樂會館",
    "urlinform": "one-24h",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/onegame6688?igsh=a2VjMTRvd2NzYTNn&utm_source=qr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJlwSfCGY9aTQRD897wWVJDik",
    "lat": 24.1475526,
    "lng": 120.6740037,
    "placeId": "ChIJlwSfCGY9aTQRD897wWVJDik",
    "businessStatus": "OPERATIONAL",
    "phone": "0916 699 771",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 176,
    "district": "Taichung",
    "id": 1829
  },
  {
    "title": "Decathlon Taipei Zhongshan Store",
    "urlinform": "decathlon-taipei-zhongshan-store",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.decathlon.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiTSaLZapQjQRzxm-_RsVS9Y",
    "lat": 25.0527874,
    "lng": 121.5190948,
    "placeId": "ChIJiTSaLZapQjQRzxm-_RsVS9Y",
    "businessStatus": "OPERATIONAL",
    "phone": "02 8979 5598",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:30 PM",
      "Saturday: 10:00 AM – 10:30 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 1467,
    "district": "Taipei Zhongshan Zhongzheng",
    "id": 1830
  },
  {
    "title": "Syntrend",
    "urlinform": "syntrend",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.syntrend.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc1otWHupQjQRYn2ASKtWHps",
    "lat": 25.0454978,
    "lng": 121.5313187,
    "placeId": "ChIJc1otWHupQjQRYn2ASKtWHps",
    "businessStatus": "OPERATIONAL",
    "phone": "080 909 3300",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 37420,
    "district": "Taipei Station",
    "id": 1831
  },
  {
    "title": "迪卡儂 新北 中和店 Decathlon New Taipei Zhonghe Store",
    "urlinform": "-decathlon-new-taipei-zhonghe-store",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.decathlon.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXWGY79apQjQRyLcUwGYALyk",
    "lat": 25.0027428,
    "lng": 121.4988479,
    "placeId": "ChIJXWGY79apQjQRyLcUwGYALyk",
    "businessStatus": "OPERATIONAL",
    "phone": "02 8245 1668",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 6371,
    "id": 1832
  },
  {
    "title": "攝癮集 三創生活園區",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/syntrendphoto?mibextid=LQQJ4d",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJkSUagbKpQjQRDIi0P67Oj_c",
    "lat": 25.0453755,
    "lng": 121.531194,
    "placeId": "ChIJkSUagbKpQjQRDIi0P67Oj_c",
    "businessStatus": "OPERATIONAL",
    "phone": "02 7701 0230",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 70,
    "district": "Taipei Station",
    "id": 1833
  },
  {
    "title": "參號倉庫",
    "urlinform": "store-2223",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/no3box/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJbZhwFCpQjQRyuKW6JR_C1A",
    "lat": 25.0676708,
    "lng": 121.5300364,
    "placeId": "ChIJJbZhwFCpQjQRyuKW6JR_C1A",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2594 9916",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 104,
    "id": 1834
  },
  {
    "title": "Wooderful life",
    "urlinform": "wooderful-life",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.wooderfullife.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJU1XlNnupQjQRlHwNqyLn8QY",
    "lat": 25.0445174,
    "lng": 121.5291712,
    "placeId": "ChIJU1XlNnupQjQRlHwNqyLn8QY",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2341 6905",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 1506,
    "district": "Taipei Station",
    "id": 1835
  },
  {
    "title": "家家美樂地",
    "urlinform": "store-2227",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/ccmelody.acg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJq5VdZbqpQjQRodq5w35BUkE",
    "lat": 25.0782158,
    "lng": 121.4836017,
    "placeId": "ChIJq5VdZbqpQjQRodq5w35BUkE",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2280 5474",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 11:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 151,
    "id": 1836
  },
  {
    "title": "Eslite R79 Store / Zhongshan Underground Book Street",
    "urlinform": "eslite-r79-store-zhongshan-underground-book-street",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://meet.eslite.com/tw/tc/store/20180220044",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjeInXWmpQjQRsLtw4gk2lMo",
    "lat": 25.0549857,
    "lng": 121.5205773,
    "placeId": "ChIJjeInXWmpQjQRsLtw4gk2lMo",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2563 9818",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 4046,
    "district": "Taipei Zhongshan Zhongzheng",
    "id": 1837
  },
  {
    "title": "王之賞 20號",
    "urlinform": "-20",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmwtzPNWpQjQRFfJYt9oDcgs",
    "lat": 25.0487071,
    "lng": 121.5142185,
    "placeId": "ChIJmwtzPNWpQjQRFfJYt9oDcgs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 81,
    "district": "Taipei Station",
    "id": 1838
  },
  {
    "title": "貳家桌遊景美店24H(優惠預約加line @218ajoas)",
    "urlinform": "24hline-218ajoas",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.oursecondhome12.com/product-category/%E8%B2%B3%E5%AE%B6%E6%96%87%E5%B1%B1%E6%99%AF%E7%BE%8E%E5%BA%97/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_9yzUempQjQRjaq-QeocnGg",
    "lat": 24.9912559,
    "lng": 121.5418366,
    "placeId": "ChIJ_9yzUempQjQRjaq-QeocnGg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.9,
    "userRatingsTotal": 80,
    "id": 1839
  },
  {
    "title": "精準模型",
    "urlinform": "store-2237",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.syhobby.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjyp9tA09aTQRzuAemcTTEvY",
    "lat": 24.1394289,
    "lng": 120.674821,
    "placeId": "ChIJjyp9tA09aTQRzuAemcTTEvY",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2224 8417",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 10:30 AM – 6:30 PM",
      "Wednesday: 10:30 AM – 6:30 PM",
      "Thursday: 10:30 AM – 6:30 PM",
      "Friday: 10:30 AM – 6:30 PM",
      "Saturday: 10:30 AM – 6:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.5,
    "userRatingsTotal": 918,
    "district": "Taichung",
    "id": 1840
  },
  {
    "title": "卡特島選品店 Carterisland Concept Store",
    "urlinform": "-carterisland-concept-store",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/cicstw2021/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOeySbX09aTQRmArG6aao8s0",
    "lat": 24.1488597,
    "lng": 120.6687823,
    "placeId": "ChIJOeySbX09aTQRmArG6aao8s0",
    "businessStatus": "OPERATIONAL",
    "phone": "0937 682 618",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 84,
    "district": "Taichung",
    "id": 1841
  },
  {
    "title": "Bugcat Capoo House",
    "urlinform": "bugcat-capoo-house",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.carterislandtw.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt_AEmBM9aTQRmcWk2XycZ0E",
    "lat": 24.1475895,
    "lng": 120.6674864,
    "placeId": "ChIJt_AEmBM9aTQRmcWk2XycZ0E",
    "businessStatus": "OPERATIONAL",
    "phone": "0926 047 399",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 3910,
    "district": "Taichung",
    "id": 1842
  },
  {
    "title": "九龍仔模型",
    "urlinform": "store-2243",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Gundam"
    ],
    "storeWebsite": "https://www.kowloonjaimodel.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx8XWae89aTQR2Ij8Hk57lGY",
    "lat": 24.1531809,
    "lng": 120.6867922,
    "placeId": "ChIJx8XWae89aTQR2Ij8Hk57lGY",
    "businessStatus": "OPERATIONAL",
    "phone": "0903 783 108",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 75,
    "district": "Taichung Yizhong",
    "id": 1843
  },
  {
    "title": "Funbox 台中中友店",
    "urlinform": "funbox-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://shop.funbox.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-9g0rCg9aTQRfEgsPtZF6-0",
    "lat": 24.1522437,
    "lng": 120.6848058,
    "placeId": "ChIJ-9g0rCg9aTQRfEgsPtZF6-0",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2225 9107",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 30,
    "district": "Taichung Yizhong",
    "id": 1844
  },
  {
    "title": "青蘋果3C/台中二手手機相機專賣店",
    "urlinform": "3c",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://gapple3c.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc4cnD2c9aTQRGr_kmpuUjzI",
    "lat": 24.1542452,
    "lng": 120.6870737,
    "placeId": "ChIJc4cnD2c9aTQRGr_kmpuUjzI",
    "businessStatus": "OPERATIONAL",
    "phone": "0981 800 925",
    "openingHours": [
      "Monday: 12:00 – 9:50 PM",
      "Tuesday: 12:00 – 9:50 PM",
      "Wednesday: 12:00 – 9:50 PM",
      "Thursday: 12:00 – 9:50 PM",
      "Friday: 12:00 – 9:50 PM",
      "Saturday: 12:00 – 9:50 PM",
      "Sunday: 12:00 – 9:50 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 4173,
    "district": "Taichung Yizhong",
    "id": 1845
  },
  {
    "title": "Games Pro 遊戲巨蛋 新店裕隆城店",
    "urlinform": "games-pro-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61584569511033",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc1trMAABaDQRfQWWwDySTN8",
    "lat": 24.978061,
    "lng": 121.546478,
    "placeId": "ChIJc1trMAABaDQRfQWWwDySTN8",
    "businessStatus": "OPERATIONAL",
    "phone": "02 8914 7207",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 341,
    "id": 1846
  },
  {
    "title": "MagFreak Taichung Store",
    "urlinform": "magfreak-taichung-store",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Dragon Ball",
      "Gundam",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.magfreak.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4xOUuWc9aTQRqcgJlSFp34Y",
    "lat": 24.1524404,
    "lng": 120.6866525,
    "placeId": "ChIJ4xOUuWc9aTQRqcgJlSFp34Y",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2225 0908",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 9:30 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 489,
    "district": "Taichung Yizhong",
    "id": 1847
  },
  {
    "title": "Her Games",
    "urlinform": "her-games",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnfZvK8arQjQRFyRtcXA7LSA",
    "lat": 25.0242043,
    "lng": 121.5421664,
    "placeId": "ChIJnfZvK8arQjQRFyRtcXA7LSA",
    "businessStatus": "OPERATIONAL",
    "phone": "0952 600 259",
    "openingHours": [
      "Monday: 3:00 PM – 12:00 AM",
      "Tuesday: 3:00 PM – 12:00 AM",
      "Wednesday: 2:30 PM – 12:00 AM",
      "Thursday: 3:00 PM – 12:00 AM",
      "Friday: 2:00 PM – 12:00 AM",
      "Saturday: 1:00 PM – 12:00 AM",
      "Sunday: 1:00 PM – 12:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 346,
    "id": 1848
  },
  {
    "title": "JINART 台中一中店",
    "urlinform": "jinart-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.jinmart.co/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFVxy0H09aTQRNtQAFIUK2fg",
    "lat": 24.1465884,
    "lng": 120.6837979,
    "placeId": "ChIJFVxy0H09aTQRNtQAFIUK2fg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:30 – 9:30 PM",
      "Tuesday: 1:30 – 9:30 PM",
      "Wednesday: 1:30 – 9:30 PM",
      "Thursday: 1:30 – 9:30 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 54,
    "district": "Taichung Yizhong",
    "id": 1849
  },
  {
    "title": "Eslite Spectrum Chungyo Store",
    "urlinform": "eslite-spectrum-chungyo-store",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://meet.eslite.com/tw/tc/store/20180220026",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzThsImY9aTQRGbowpXZD52M",
    "lat": 24.1522173,
    "lng": 120.6847829,
    "placeId": "ChIJzThsImY9aTQRGbowpXZD52M",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2221 1287",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 2829,
    "district": "Taichung Yizhong",
    "id": 1850
  },
  {
    "title": "Kuangnan Fashion Shop",
    "urlinform": "kuangnan-fashion-shop",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://knn.com.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3VZALGk9aTQRYmc8yDHaO6Q",
    "lat": 24.1484548,
    "lng": 120.6833538,
    "placeId": "ChIJ3VZALGk9aTQRYmc8yDHaO6Q",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2225 2020",
    "openingHours": [
      "Monday: 10:30 AM – 10:30 PM",
      "Tuesday: 10:30 AM – 10:30 PM",
      "Wednesday: 10:30 AM – 10:30 PM",
      "Thursday: 10:30 AM – 10:30 PM",
      "Friday: 10:30 AM – 10:30 PM",
      "Saturday: 10:30 AM – 10:30 PM",
      "Sunday: 10:30 AM – 10:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 5201,
    "district": "Taichung Yizhong",
    "id": 1851
  },
  {
    "title": "Antidote解藥糖果屋 一中店",
    "urlinform": "antidote-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.antidotecandy.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuR0v9nQ9aTQR-mqcBC1Mo3Q",
    "lat": 24.1476666,
    "lng": 120.6838988,
    "placeId": "ChIJuR0v9nQ9aTQR-mqcBC1Mo3Q",
    "businessStatus": "OPERATIONAL",
    "phone": "0911 055 560",
    "openingHours": [
      "Monday: 2:00 – 10:30 PM",
      "Tuesday: 2:00 – 10:30 PM",
      "Wednesday: 2:00 – 10:30 PM",
      "Thursday: 2:00 – 10:30 PM",
      "Friday: 2:00 – 10:30 PM",
      "Saturday: 1:00 – 11:00 PM",
      "Sunday: 1:00 – 11:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 769,
    "district": "Taichung Yizhong",
    "id": 1852
  },
  {
    "title": "布布刺刺韓式燙布貼-台中一中店（台中好玩室內親子景點／台中DIY情侶手作行程推薦／台中一日親子遊／台中燙布貼／客製化韓國刺繡專賣店／客製化行李飄帶／台中燙布貼紙）",
    "urlinform": "-diy",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/boobthorn_art/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAdpbTQA9aTQR1lYoi86DXm0",
    "lat": 24.1493791,
    "lng": 120.6843957,
    "placeId": "ChIJAdpbTQA9aTQR1lYoi86DXm0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 10:00 PM",
      "Tuesday: 1:00 – 10:00 PM",
      "Wednesday: 1:00 – 10:00 PM",
      "Thursday: 1:00 – 10:00 PM",
      "Friday: 1:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 1181,
    "district": "Taichung Yizhong",
    "id": 1853
  },
  {
    "title": "樂士Luxe3C台中一中手機殼配件旗艦店中友店",
    "urlinform": "luxe3c",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.luxe3c.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOYxicaw9aTQRvmy6uTIZtIE",
    "lat": 24.1524669,
    "lng": 120.686604,
    "placeId": "ChIJOYxicaw9aTQRvmy6uTIZtIE",
    "businessStatus": "OPERATIONAL",
    "phone": "0976 888 975",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1673,
    "district": "Taichung Yizhong",
    "id": 1854
  },
  {
    "title": "捷比漫畫便利屋",
    "urlinform": "store-2267",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/tcjb22277668/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_7XlP2k9aTQRJVDwF1KpH_8",
    "lat": 24.1477803,
    "lng": 120.684628,
    "placeId": "ChIJ_7XlP2k9aTQRJVDwF1KpH_8",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2227 7668",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 1102,
    "district": "Taichung Yizhong",
    "id": 1855
  },
  {
    "title": "GY 3C配件-一中店",
    "urlinform": "gy-3c-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHZBxMWk9aTQRXXJTND4t2uk",
    "lat": 24.1481881,
    "lng": 120.6842212,
    "placeId": "ChIJHZBxMWk9aTQRXXJTND4t2uk",
    "businessStatus": "OPERATIONAL",
    "phone": "0968 912 817",
    "openingHours": [
      "Monday: 11:00 AM – 11:00 PM",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 309,
    "district": "Taichung Yizhong",
    "id": 1856
  },
  {
    "title": "一刮入魂",
    "urlinform": "store-2271",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4y19HMs9aTQR8WqbwBOqV-U",
    "lat": 24.1471053,
    "lng": 120.6840575,
    "placeId": "ChIJ4y19HMs9aTQR8WqbwBOqV-U",
    "businessStatus": "OPERATIONAL",
    "phone": "0968 666 438",
    "openingHours": [
      "Monday: 1:00 – 10:30 PM",
      "Tuesday: 1:00 – 10:30 PM",
      "Wednesday: 1:00 – 10:30 PM",
      "Thursday: 1:00 – 10:30 PM",
      "Friday: 1:00 – 10:30 PM",
      "Saturday: 1:00 – 10:30 PM",
      "Sunday: 1:00 – 10:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 296,
    "district": "Taichung Yizhong",
    "id": 1857
  },
  {
    "title": "小種子玩具/公仔吊飾（一中門市）",
    "urlinform": "store-2273",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://instagram.com/oneseed123?igshid=YmMyMTA2M2Y=",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzYWLy_09aTQRmF_h6Cl9wlM",
    "lat": 24.1526781,
    "lng": 120.6838731,
    "placeId": "ChIJzYWLy_09aTQRmF_h6Cl9wlM",
    "businessStatus": "OPERATIONAL",
    "phone": "0966 678 300",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1456,
    "district": "Taichung Yizhong",
    "id": 1858
  },
  {
    "title": "台中卡通漫畫屋",
    "urlinform": "store-2275",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9f1-qxQ9aTQRDjt87GCk66k",
    "lat": 24.1413247,
    "lng": 120.6835889,
    "placeId": "ChIJ9f1-qxQ9aTQRDjt87GCk66k",
    "businessStatus": "OPERATIONAL",
    "phone": "04 2223 9091",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 292,
    "district": "Taichung Yizhong",
    "id": 1859
  },
  {
    "title": "One桌遊麻將民權店",
    "urlinform": "one",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmXjhD389aTQRLJqUOGGYkgQ",
    "lat": 24.1422149,
    "lng": 120.674596,
    "placeId": "ChIJmXjhD389aTQRLJqUOGGYkgQ",
    "businessStatus": "OPERATIONAL",
    "phone": "04 3701 2968",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3.8,
    "userRatingsTotal": 4,
    "district": "Taichung",
    "id": 1860
  },
  {
    "title": "松梅桌遊舖",
    "urlinform": "store-2279",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/sungmay0955830300",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRdOFdqgEbjQRBQYcAKa-3GE",
    "lat": 22.61125,
    "lng": 120.3321891,
    "placeId": "ChIJRdOFdqgEbjQRBQYcAKa-3GE",
    "businessStatus": "OPERATIONAL",
    "phone": "07 716 2220",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 9:30 PM",
      "Wednesday: 3:00 – 9:30 PM",
      "Thursday: 3:00 – 9:30 PM",
      "Friday: 3:00 – 10:30 PM",
      "Saturday: 1:00 – 10:30 PM",
      "Sunday: 1:00 – 9:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 181,
    "id": 1861
  },
  {
    "title": "BAW VAULT",
    "urlinform": "baw-vault",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://bawvault.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQTG50j4FbjQRByuh8yB6Tn0",
    "lat": 22.6575356,
    "lng": 120.2982139,
    "placeId": "ChIJQTG50j4FbjQRByuh8yB6Tn0",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 5:00 PM",
      "Tuesday: 9:00 AM – 5:00 PM",
      "Wednesday: 9:00 AM – 5:00 PM",
      "Thursday: 9:00 AM – 5:00 PM",
      "Friday: 9:00 AM – 5:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 9,
    "id": 1862
  },
  {
    "title": "Bruce桌遊空間(三多店)",
    "urlinform": "bruce",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/Bruce%E6%A1%8C%E9%81%8A%E7%A9%BA%E9%96%93-%E4%B8%89%E5%A4%9A%E5%BA%97-105703269058979/?ref=page_internal",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKSvXSJ8DbjQRgK21yBa0gI0",
    "lat": 22.6143845,
    "lng": 120.3067471,
    "placeId": "ChIJKSvXSJ8DbjQRgK21yBa0gI0",
    "businessStatus": "OPERATIONAL",
    "phone": "0905 821 053",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 12:00 – 9:30 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1294,
    "id": 1863
  },
  {
    "title": "遊戲達人-日本橋電玩部",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "Gundam"
    ],
    "storeWebsite": "https://www.rakuten.com.tw/shop/gamepro-asia/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3SQybO0EbjQR3W-3xkgZI7s",
    "lat": 22.637808,
    "lng": 120.309884,
    "placeId": "ChIJ3SQybO0EbjQR3W-3xkgZI7s",
    "businessStatus": "OPERATIONAL",
    "phone": "07 235 8803",
    "openingHours": [
      "Monday: 10:00 AM – 9:30 PM",
      "Tuesday: 10:00 AM – 9:30 PM",
      "Wednesday: 10:00 AM – 9:30 PM",
      "Thursday: 10:00 AM – 9:30 PM",
      "Friday: 10:00 AM – 9:30 PM",
      "Saturday: 10:00 AM – 9:30 PM",
      "Sunday: 10:00 AM – 9:30 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 477,
    "district": "Kaohsiung Sanmin Station",
    "id": 1864
  },
  {
    "title": "PROSPERiTY PLAZA Dingshan Store",
    "urlinform": "prosperity-plaza-dingshan-store",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.uni-prosperity.com.tw/store-info/?store=%E9%BC%8E%E5%B1%B1%E5%BA%97#tab=info",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJTvAQuAEbjQRj-9PvX6htlI",
    "lat": 22.6531625,
    "lng": 120.3189481,
    "placeId": "ChIJJTvAQuAEbjQRj-9PvX6htlI",
    "businessStatus": "OPERATIONAL",
    "phone": "07 394 5588",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.4,
    "userRatingsTotal": 14138,
    "id": 1865
  },
  {
    "title": "貓腳印遊樂園 高雄店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/CatFootPrintKaohSiung.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJcrYT-gFbjQRjrfzCaFrkvU",
    "lat": 22.6643361,
    "lng": 120.304414,
    "placeId": "ChIJJcrYT-gFbjQRjrfzCaFrkvU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: 3:00 – 11:00 PM",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 11:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 168,
    "id": 1866
  },
  {
    "title": "Cat footprints Amusement Park (Card & Board Games)",
    "urlinform": "cat-footprints-amusement-park-card-board-games",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/CatFootPrintTaoyuan.tw?mibextid=LQQJ4d",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCdUR-_EeaDQR5UzGxKhXVy8",
    "lat": 24.9911358,
    "lng": 121.3119534,
    "placeId": "ChIJCdUR-_EeaDQR5UzGxKhXVy8",
    "businessStatus": "OPERATIONAL",
    "phone": "03 337 0706",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 PM – 12:00 AM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 340,
    "id": 1867
  },
  {
    "title": "貓腳印-雄二店",
    "urlinform": "-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/CatFootPrintKaohSiung2.tw/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPxfibh4FbjQRvF7s2H0RjFA",
    "lat": 22.6243005,
    "lng": 120.2955615,
    "placeId": "ChIJPxfibh4FbjQRvF7s2H0RjFA",
    "businessStatus": "OPERATIONAL",
    "phone": "07 241 0155",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 11:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 51,
    "id": 1868
  },
  {
    "title": "決鬥學院卡片專賣店",
    "urlinform": "store-2295",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.facebook.com/profile.php?id=100092255355796",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHb-cDro3aDQRHlS1TPlPDA0",
    "lat": 24.776098,
    "lng": 121.017562,
    "placeId": "ChIJHb-cDro3aDQRHlS1TPlPDA0",
    "businessStatus": "OPERATIONAL",
    "phone": "0978 291 547",
    "openingHours": [
      "Monday: 6:00 – 10:00 PM",
      "Tuesday: 6:00 – 10:00 PM",
      "Wednesday: 6:00 – 10:00 PM",
      "Thursday: 6:00 – 10:00 PM",
      "Friday: 6:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 41,
    "id": 1869
  },
  {
    "title": "桌覓桌遊休閒空間│1400款桌遊暢玩 高雄最多│販售租借│活動包場│包廂",
    "urlinform": "1400-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61590676741985",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTY2tNQQFbjQRvc0W_IH5C80",
    "lat": 22.6233869,
    "lng": 120.317921,
    "placeId": "ChIJTY2tNQQFbjQRvc0W_IH5C80",
    "businessStatus": "OPERATIONAL",
    "phone": "07 751 5077",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 3:00 – 10:30 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 389,
    "id": 1870
  },
  {
    "title": "ONE桌遊 高雄苓雅店",
    "urlinform": "one-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linktr.ee/oneboardgame_khh",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_TI4p2wDbjQRzbsnpCRub6o",
    "lat": 22.6127737,
    "lng": 120.3017155,
    "placeId": "ChIJ_TI4p2wDbjQRzbsnpCRub6o",
    "businessStatus": "OPERATIONAL",
    "phone": "0909 141 991",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 4.7,
    "userRatingsTotal": 199,
    "id": 1871
  },
  {
    "title": "Thecardroom TCG Hongdae",
    "urlinform": "thecardroom-tcg-hongdae",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://smartstore.naver.com/fogandsunset",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgY2-kd6ZfDURjFvE-R0NqyI",
    "lat": 37.56062050000001,
    "lng": 126.9205522,
    "placeId": "ChIJgY2-kd6ZfDURjFvE-R0NqyI",
    "businessStatus": "OPERATIONAL",
    "phone": "070-7164-0900",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 75,
    "district": "Hongdae",
    "id": 1872
  },
  {
    "title": "하비게임몰 종로점 (Hobby GameMall Jongno)",
    "urlinform": "-hobby-gamemall-jongno",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJJf46b5CjfDUR22JJjM9Y8Jc",
    "lat": 37.5756207,
    "lng": 127.0013612,
    "placeId": "ChIJJf46b5CjfDUR22JJjM9Y8Jc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 11:00 PM",
      "Tuesday: 2:00 – 11:00 PM",
      "Wednesday: 1:00 – 11:00 PM",
      "Thursday: 1:00 – 11:00 PM",
      "Friday: 1:00 – 11:00 PM",
      "Saturday: 12:00 – 11:00 PM",
      "Sunday: 12:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3,
    "id": 1873
  },
  {
    "title": "TCG카드노바",
    "urlinform": "tcg",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmfbLSwChfDURx1od9EW-W7A",
    "lat": 37.499438,
    "lng": 127.0279387,
    "placeId": "ChIJmfbLSwChfDURx1od9EW-W7A",
    "businessStatus": "OPERATIONAL",
    "phone": "010-6403-1020",
    "openingHours": [],
    "rating": 0,
    "userRatingsTotal": 0,
    "district": "Gangnam",
    "id": 1874
  },
  {
    "title": "모아카드샵",
    "urlinform": "store-2311",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://linktr.ee/moacardshop",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW1H_u6alfDURIGmM7s2Kb90",
    "lat": 37.5597661,
    "lng": 127.0406771,
    "placeId": "ChIJW1H_u6alfDURIGmM7s2Kb90",
    "businessStatus": "OPERATIONAL",
    "phone": "010-2135-0147",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1875
  },
  {
    "title": "Daiso Gangnam Station No. 2",
    "urlinform": "daiso-gangnam-station-no-2",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.daisomall.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZfbz2VmhfDUR2nvBYZwmRX4",
    "lat": 37.4988108,
    "lng": 127.0289974,
    "placeId": "ChIJZfbz2VmhfDUR2nvBYZwmRX4",
    "businessStatus": "OPERATIONAL",
    "phone": "1522-4400",
    "openingHours": [
      "Monday: 9:30 AM – 10:00 PM",
      "Tuesday: 9:30 AM – 10:00 PM",
      "Wednesday: 9:30 AM – 10:00 PM",
      "Thursday: 9:30 AM – 10:00 PM",
      "Friday: 9:30 AM – 10:00 PM",
      "Saturday: 9:30 AM – 10:00 PM",
      "Sunday: 9:30 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 997,
    "district": "Gangnam",
    "id": 1876
  },
  {
    "title": "제로연회비",
    "urlinform": "store-2315",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ9M76Ty5fDURYcbLY7Qt1Lo",
    "lat": 37.506203,
    "lng": 127.0638274,
    "placeId": "ChIJZ9M76Ty5fDURYcbLY7Qt1Lo",
    "businessStatus": "OPERATIONAL",
    "phone": "010-5723-3337",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1877
  },
  {
    "title": "Ready Go Active Game Park Gangnam",
    "urlinform": "ready-go-active-game-park-gangnam",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://activegamepark.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ28wXawChfDURoofJATcnCZ0",
    "lat": 37.5021087,
    "lng": 127.0271821,
    "placeId": "ChIJ28wXawChfDURoofJATcnCZ0",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71487-2433",
    "openingHours": [
      "Monday: 11:00 AM – 11:00 PM",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 3,
    "district": "Gangnam",
    "id": 1878
  },
  {
    "title": "COLLECT ON",
    "urlinform": "collect-on",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ16kS2rqffDURpfvcK0-GuKg",
    "lat": 37.4953431,
    "lng": 126.9011291,
    "placeId": "ChIJ16kS2rqffDURpfvcK0-GuKg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 18,
    "id": 1879
  },
  {
    "title": "The Conran Shop",
    "urlinform": "the-conran-shop",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.conranshop.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs4FB-V2lfDURjL8Pa2W08Mk",
    "lat": 37.4971729,
    "lng": 127.0540884,
    "placeId": "ChIJs4FB-V2lfDURjL8Pa2W08Mk",
    "businessStatus": "OPERATIONAL",
    "phone": "02-531-2591",
    "openingHours": [
      "Monday: 10:30 AM – 8:00 PM",
      "Tuesday: 10:30 AM – 8:00 PM",
      "Wednesday: 10:30 AM – 8:00 PM",
      "Thursday: 10:30 AM – 8:00 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 224,
    "id": 1880
  },
  {
    "title": "KADO TCG SEOUL",
    "urlinform": "kado-tcg-seoul",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://kado.trade/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJibUaaYuZfDUR16-L62w7gG8",
    "lat": 37.5540275,
    "lng": 126.923423,
    "placeId": "ChIJibUaaYuZfDUR16-L62w7gG8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 1,
    "userRatingsTotal": 1,
    "district": "Hongdae",
    "id": 1881
  },
  {
    "title": "Pacific TCG Shop",
    "urlinform": "pacipic-tcg-shop",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5XEtqcSYfDUR6WoBXKcOAyM",
    "lat": 37.5540799,
    "lng": 126.9223241,
    "placeId": "ChIJ5XEtqcSYfDUR6WoBXKcOAyM",
    "businessStatus": "OPERATIONAL",
    "phone": "010-2697-5916",
    "openingHours": [
      "Monday: 11:00 AM – 11:00 PM",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 103,
    "district": "Hongdae",
    "id": 1882
  },
  {
    "title": "오모차랜드 홍대점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/omochaland2",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx8Y12ZqZfDURfmQ7c4iSUso",
    "lat": 37.5535968,
    "lng": 126.9204365,
    "placeId": "ChIJx8Y12ZqZfDURfmQ7c4iSUso",
    "businessStatus": "OPERATIONAL",
    "phone": "010-5775-6552",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 97,
    "district": "Hongdae",
    "id": 1883
  },
  {
    "title": "오모차랜드 홍대2호점",
    "urlinform": "-2",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjf_iluGZfDURw7vuVOSkZXU",
    "lat": 37.5560787,
    "lng": 126.9234503,
    "placeId": "ChIJjf_iluGZfDURw7vuVOSkZXU",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 3.5,
    "userRatingsTotal": 10,
    "district": "Hongdae",
    "id": 1884
  },
  {
    "title": "Emart Yongsan",
    "urlinform": "emart-yongsan",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://emart.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ84cCWBuifDURt7G_jK4Sbj8",
    "lat": 37.5294444,
    "lng": 126.9655556,
    "placeId": "ChIJ84cCWBuifDURt7G_jK4Sbj8",
    "businessStatus": "OPERATIONAL",
    "phone": "02-6363-2200",
    "openingHours": [
      "Monday: 10:00 AM – 11:00 PM",
      "Tuesday: 10:00 AM – 11:00 PM",
      "Wednesday: 10:00 AM – 11:00 PM",
      "Thursday: 10:00 AM – 11:00 PM",
      "Friday: 10:00 AM – 11:00 PM",
      "Saturday: 10:00 AM – 11:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.1,
    "userRatingsTotal": 5991,
    "district": "Kukje Electronics Center",
    "id": 1885
  },
  {
    "title": "Vinyl & Plastic",
    "urlinform": "vinyl-plastic",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://dive.hyundaicard.com/web/vinylandplastic/spaceMain.hdc",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8_Vft7OjfDURJgVJQL7fKU0",
    "lat": 37.5367741,
    "lng": 127.0008549,
    "placeId": "ChIJ8_Vft7OjfDURJgVJQL7fKU0",
    "businessStatus": "OPERATIONAL",
    "phone": "02-2014-7800",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 876,
    "id": 1886
  },
  {
    "title": "ET Land Electronics Yongsan",
    "urlinform": "et-land-electronics-yongsan",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.i-etland.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc-kCoAaifDUR3neDvwX0PZU",
    "lat": 37.5328188,
    "lng": 126.959711,
    "placeId": "ChIJc-kCoAaifDUR3neDvwX0PZU",
    "businessStatus": "OPERATIONAL",
    "phone": "02-707-4700",
    "openingHours": [
      "Monday: 10:00 AM – 7:30 PM",
      "Tuesday: 10:00 AM – 7:30 PM",
      "Wednesday: 10:00 AM – 7:30 PM",
      "Thursday: 10:00 AM – 7:30 PM",
      "Friday: 10:00 AM – 7:30 PM",
      "Saturday: 10:00 AM – 7:30 PM",
      "Sunday: 10:00 AM – 7:30 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 1732,
    "district": "Yongsan",
    "id": 1887
  },
  {
    "title": "Youngpoong Bookstore Yongsan I'Park Mall",
    "urlinform": "youngpoong-bookstore-yongsan-ipark-mall",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.ypbooks.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPZpZcrKjfDURfkW6XyZ2zxA",
    "lat": 37.5287599,
    "lng": 126.9643077,
    "placeId": "ChIJPZpZcrKjfDURfkW6XyZ2zxA",
    "businessStatus": "OPERATIONAL",
    "phone": "02-2012-0828",
    "openingHours": [
      "Monday: 10:30 AM – 10:00 PM",
      "Tuesday: 10:30 AM – 10:00 PM",
      "Wednesday: 10:30 AM – 10:00 PM",
      "Thursday: 10:30 AM – 10:00 PM",
      "Friday: 10:30 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 1716,
    "district": "Kukje Electronics Center",
    "id": 1888
  },
  {
    "title": "Dream depot Yongsan",
    "urlinform": "dream-depot-yongsan",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.dreamdepot.co.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtTAf_hmifDURRYvsF3kLYI8",
    "lat": 37.5345295,
    "lng": 126.9746341,
    "placeId": "ChIJtTAf_hmifDURRYvsF3kLYI8",
    "businessStatus": "OPERATIONAL",
    "phone": "02-790-1533",
    "openingHours": [
      "Monday: 9:00 AM – 7:30 PM",
      "Tuesday: 9:00 AM – 7:30 PM",
      "Wednesday: 9:00 AM – 7:30 PM",
      "Thursday: 9:00 AM – 7:30 PM",
      "Friday: 9:00 AM – 7:30 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 3.3,
    "userRatingsTotal": 8,
    "id": 1889
  },
  {
    "title": "NINI MYEONGDONG",
    "urlinform": "nini-myeongdong",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJBXk_JQCjfDURjpMxhu5C_as",
    "lat": 37.5647586,
    "lng": 126.9834172,
    "placeId": "ChIJBXk_JQCjfDURjpMxhu5C_as",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 12:00 AM",
      "Tuesday: 9:00 AM – 12:00 AM",
      "Wednesday: 9:00 AM – 12:00 AM",
      "Thursday: 9:00 AM – 12:00 AM",
      "Friday: 9:00 AM – 12:00 AM",
      "Saturday: 9:00 AM – 12:00 AM",
      "Sunday: 9:00 AM – 12:00 AM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 57,
    "district": "Myeongdong",
    "id": 1890
  },
  {
    "title": "Lotte shopping center",
    "urlinform": "lotte-shopping-center",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZZgm-PGifDURqymNsjCCatA",
    "lat": 37.564674,
    "lng": 126.9817192,
    "placeId": "ChIJZZgm-PGifDURqymNsjCCatA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 8:00 PM",
      "Tuesday: 10:30 AM – 8:00 PM",
      "Wednesday: 10:30 AM – 8:00 PM",
      "Thursday: 10:30 AM – 8:00 PM",
      "Friday: 10:30 AM – 8:00 PM",
      "Saturday: 10:30 AM – 9:00 PM",
      "Sunday: 10:30 AM – 9:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 35,
    "district": "Myeongdong",
    "id": 1891
  },
  {
    "title": "Hanwoori Sindorim",
    "urlinform": "hanwoori-sindorim",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://gamewoori.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJL86JZ12efDURtunGSLzJx-I",
    "lat": 37.507132,
    "lng": 126.8901541,
    "placeId": "ChIJL86JZ12efDURtunGSLzJx-I",
    "businessStatus": "OPERATIONAL",
    "phone": "02-2111-7144",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 1383,
    "id": 1892
  },
  {
    "title": "Sony Center Namdaemun",
    "urlinform": "sony-center-namdaemun",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgZTYefSifDURgFQTa6bI2E4",
    "lat": 37.5611504,
    "lng": 126.9773284,
    "placeId": "ChIJgZTYefSifDURgFQTa6bI2E4",
    "businessStatus": "OPERATIONAL",
    "phone": "02-779-2015",
    "openingHours": [
      "Monday: 9:30 AM – 7:00 PM",
      "Tuesday: 9:30 AM – 7:00 PM",
      "Wednesday: 9:30 AM – 7:00 PM",
      "Thursday: 9:30 AM – 7:00 PM",
      "Friday: 9:30 AM – 7:00 PM",
      "Saturday: 9:30 AM – 7:00 PM",
      "Sunday: 9:30 AM – 7:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 138,
    "district": "Myeongdong",
    "id": 1893
  },
  {
    "title": "Beauty Play Myeongdong",
    "urlinform": "beauty-play-myeongdong",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://beautyplay.kr/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoYrFaNijfDURcF6nlP0F8oM",
    "lat": 37.5642938,
    "lng": 126.9861857,
    "placeId": "ChIJoYrFaNijfDURcF6nlP0F8oM",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71360-9675",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4,
    "userRatingsTotal": 93,
    "district": "Myeongdong",
    "id": 1894
  },
  {
    "title": "Apple 명동",
    "urlinform": "apple-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.apple.com/kr/retail/myeongdong?cid=aos-kr-seo-maps",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVfKD7TCjfDUR7cFL6hpHmlw",
    "lat": 37.5645528,
    "lng": 126.9828972,
    "placeId": "ChIJVfKD7TCjfDUR7cFL6hpHmlw",
    "businessStatus": "OPERATIONAL",
    "phone": "080-500-1007",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 527,
    "district": "Myeongdong",
    "id": 1895
  },
  {
    "title": "Olive Young Myeongdong Town",
    "urlinform": "olive-young-myeongdong-town",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.oliveyoung.co.kr/store/store/store-detail.do?strNm=%EC%98%AC%EB%A6%AC%EB%B8%8C%EC%98%81%EB%AA%85%EB%8F%99%ED%83%80%EC%9A%B4&utm_source=google_map&utm_medium=sharing&utm_campaign=o2op_google_map&searchType=strNm",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ9XDV4O-ifDURKjI94KEc1h4",
    "lat": 37.563946,
    "lng": 126.9851624,
    "placeId": "ChIJ9XDV4O-ifDURKjI94KEc1h4",
    "businessStatus": "OPERATIONAL",
    "phone": "1577-4887",
    "openingHours": [
      "Monday: 10:00 AM – 10:30 PM",
      "Tuesday: 10:00 AM – 10:30 PM",
      "Wednesday: 10:00 AM – 10:30 PM",
      "Thursday: 10:00 AM – 10:30 PM",
      "Friday: 10:00 AM – 10:30 PM",
      "Saturday: 10:00 AM – 10:30 PM",
      "Sunday: 10:00 AM – 10:30 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 3597,
    "district": "Myeongdong",
    "id": 1896
  },
  {
    "title": "YG Place Myeongdong",
    "urlinform": "yg-place-myeongdong",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJObVLSo6jfDURbgmZE9lBuPo",
    "lat": 37.5637609,
    "lng": 126.9856816,
    "placeId": "ChIJObVLSo6jfDURbgmZE9lBuPo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 8:30 PM",
      "Tuesday: 10:30 AM – 8:30 PM",
      "Wednesday: 10:30 AM – 8:30 PM",
      "Thursday: 10:30 AM – 8:30 PM",
      "Friday: 10:30 AM – 8:30 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 16,
    "district": "Myeongdong",
    "id": 1897
  },
  {
    "title": "Money Box Myeongdong Main Branch",
    "urlinform": "money-box-myeongdong-main-branch",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://link.m-box.com/myeongdong-main-google-branch",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJO-P7dmKjfDURm3durGx_8aU",
    "lat": 37.5620525,
    "lng": 126.9816353,
    "placeId": "ChIJO-P7dmKjfDURm3durGx_8aU",
    "businessStatus": "OPERATIONAL",
    "phone": "02-3789-0888",
    "openingHours": [
      "Monday: 9:00 AM – 9:00 PM",
      "Tuesday: 9:00 AM – 9:00 PM",
      "Wednesday: 9:00 AM – 9:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 9:00 PM",
      "Saturday: 9:00 AM – 9:00 PM",
      "Sunday: 9:00 AM – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1288,
    "district": "Myeongdong",
    "id": 1898
  },
  {
    "title": "CU",
    "urlinform": "cu",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsxUQIfGifDUR3EHOnYG3Kdo",
    "lat": 37.5608659,
    "lng": 126.9834647,
    "placeId": "ChIJsxUQIfGifDUR3EHOnYG3Kdo",
    "businessStatus": "OPERATIONAL",
    "phone": "02-779-1797",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 3.6,
    "userRatingsTotal": 31,
    "district": "Myeongdong",
    "id": 1899
  },
  {
    "title": "Syab",
    "urlinform": "syab",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://namu.wiki/w/S%23ARP",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHSIKGPGifDUR0ATCo1J3XSc",
    "lat": 37.5611501,
    "lng": 126.9830432,
    "placeId": "ChIJHSIKGPGifDUR0ATCo1J3XSc",
    "businessStatus": "OPERATIONAL",
    "phone": "02-776-1378",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 5,
    "district": "Myeongdong",
    "id": 1900
  },
  {
    "title": "리얼카드샵 realcardshop",
    "urlinform": "-realcardshop",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/realcardshop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo6ZcViaZfDUR8nn9NQCLbHc",
    "lat": 37.5584401,
    "lng": 126.9358527,
    "placeId": "ChIJo6ZcViaZfDUR8nn9NQCLbHc",
    "businessStatus": "OPERATIONAL",
    "phone": "010-8411-2173",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 4:00 – 11:00 PM",
      "Wednesday: 4:00 – 11:00 PM",
      "Thursday: 4:00 – 11:00 PM",
      "Friday: 4:00 – 11:00 PM",
      "Saturday: 2:00 – 11:00 PM",
      "Sunday: 2:00 – 11:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "district": "Sinchon",
    "id": 1901
  },
  {
    "title": "MIRACLE KUJI - Kukje Electronics Center 미라클쿠지 국제전자센터",
    "urlinform": "miracle-kuji-kukje-electronics-center-",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/miracle_kuji/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJl8OnQ-ChfDURofgzs-k9YxM",
    "lat": 37.484742,
    "lng": 127.0177676,
    "placeId": "ChIJl8OnQ-ChfDURofgzs-k9YxM",
    "businessStatus": "OPERATIONAL",
    "phone": "02-2135-5595",
    "openingHours": [
      "Monday: 12:30 – 7:30 PM",
      "Tuesday: 12:30 – 7:30 PM",
      "Wednesday: 12:30 – 7:30 PM",
      "Thursday: 12:30 – 7:30 PM",
      "Friday: 12:30 – 7:30 PM",
      "Saturday: 12:00 – 7:30 PM",
      "Sunday: 12:30 – 7:30 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 2,
    "id": 1902
  },
  {
    "title": "포켓몬 카드샵 카드베이스 부산",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.smartstore.naver.com/card-base",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJw7GRTwCTaDURdttQv1OGK4w",
    "lat": 35.2054333,
    "lng": 129.0793674,
    "placeId": "ChIJw7GRTwCTaDURdttQv1OGK4w",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71491-9697",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1903
  },
  {
    "title": "KT Plaza Haeundae Jangsan Station",
    "urlinform": "kt-plaza-haeundae-jangsan-station",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ktmns.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ0TeyiQyNaDURzsOcrQiujUg",
    "lat": 35.1696223,
    "lng": 129.1768802,
    "placeId": "ChIJ0TeyiQyNaDURzsOcrQiujUg",
    "businessStatus": "OPERATIONAL",
    "phone": "051-703-8010",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 17,
    "id": 1904
  },
  {
    "title": "롤로타바코 해운대점",
    "urlinform": "-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://m.blog.naver.com/goldcigar",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZZFm3OeNaDURXRgI4U1ShOc",
    "lat": 35.1738511,
    "lng": 129.1748291,
    "placeId": "ChIJZZFm3OeNaDURXRgI4U1ShOc",
    "businessStatus": "OPERATIONAL",
    "phone": "010-2649-5005",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 1905
  },
  {
    "title": "KT플라자 우동 해운대역점",
    "urlinform": "kt-",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ktmns.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMTEU3WqNaDURENut6qdVkT8",
    "lat": 35.1630405,
    "lng": 129.1573719,
    "placeId": "ChIJMTEU3WqNaDURENut6qdVkT8",
    "businessStatus": "OPERATIONAL",
    "phone": "051-747-7650",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 29,
    "district": "Haeundae",
    "id": 1906
  },
  {
    "title": "RIPPLETOWN MIPO,BUSAN",
    "urlinform": "rippletown-mipobusan",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/rippletown_coffee/?igsh=MXZoNnFmNm91c3R5MQ%3D%3D&utm_source=qr#",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6d2ybgCNaDUR-GIuD-HN4gQ",
    "lat": 35.158063,
    "lng": 129.1726086,
    "placeId": "ChIJ6d2ybgCNaDUR-GIuD-HN4gQ",
    "businessStatus": "OPERATIONAL",
    "phone": "050-71338-9910",
    "openingHours": [
      "Monday: 9:00 AM – 10:00 PM",
      "Tuesday: 9:00 AM – 10:00 PM",
      "Wednesday: 9:00 AM – 10:00 PM",
      "Thursday: 9:00 AM – 10:00 PM",
      "Friday: 9:00 AM – 10:00 PM",
      "Saturday: 9:00 AM – 10:00 PM",
      "Sunday: 9:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 143,
    "district": "Haeundae",
    "id": 1907
  },
  {
    "title": "젤라또조이 해운대미포점(Gelato Joy Haeundae)",
    "urlinform": "-gelato-joy-haeundae",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/gelatojoy_busan/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCVFf1vSNaDURjNQyuj_5B3Y",
    "lat": 35.1597579,
    "lng": 129.1705706,
    "placeId": "ChIJCVFf1vSNaDURjNQyuj_5B3Y",
    "businessStatus": "OPERATIONAL",
    "phone": "010-4636-5465",
    "openingHours": [
      "Monday: 9:30 AM – 12:00 AM",
      "Tuesday: 9:30 AM – 12:00 AM",
      "Wednesday: 9:30 AM – 12:00 AM",
      "Thursday: 9:30 AM – 12:00 AM",
      "Friday: 9:30 AM – 12:00 AM",
      "Saturday: 9:00 AM – 1:00 AM",
      "Sunday: 9:00 AM – 1:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 917,
    "district": "Haeundae",
    "id": 1908
  },
  {
    "title": "MAISON GOYARD BUSAN CENTUM CITY",
    "urlinform": "maison-goyard-busan-centum-city",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.goyard.com/kr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx0QIjaSTaDUR1AfoRT5gR6k",
    "lat": 35.1687032,
    "lng": 129.1297466,
    "placeId": "ChIJx0QIjaSTaDUR1AfoRT5gR6k",
    "businessStatus": "OPERATIONAL",
    "phone": "051-745-2265",
    "openingHours": [
      "Monday: 10:30 AM – 8:00 PM",
      "Tuesday: 10:30 AM – 8:00 PM",
      "Wednesday: 10:30 AM – 8:00 PM",
      "Thursday: 10:30 AM – 8:00 PM",
      "Friday: 10:30 AM – 8:00 PM",
      "Saturday: 10:30 AM – 8:30 PM",
      "Sunday: 10:30 AM – 8:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 407,
    "id": 1909
  },
  {
    "title": "제이클로버",
    "urlinform": "store-2385",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/busanjoker",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5c7Psk7raDURKZ43QLqAL4A",
    "lat": 35.1713009,
    "lng": 129.0694907,
    "placeId": "ChIJ5c7Psk7raDURKZ43QLqAL4A",
    "businessStatus": "OPERATIONAL",
    "phone": "010-4937-6318",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 10,
    "id": 1910
  },
  {
    "title": "Daiso",
    "urlinform": "daiso",
    "nation": "South Korea",
    "prefecture": "Busan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6-w7KEjpaDURSifLIJXzj8M",
    "lat": 35.0989833,
    "lng": 129.0274423,
    "placeId": "ChIJ6-w7KEjpaDURSifLIJXzj8M",
    "businessStatus": "OPERATIONAL",
    "phone": "1522-4400",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 511,
    "district": "Nampo",
    "id": 1911
  },
  {
    "title": "Elite Collectors",
    "urlinform": "elite-collectors",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDdhqYACd4jARQlDO0u45NmA",
    "lat": 13.8552759,
    "lng": 100.542084,
    "placeId": "ChIJDdhqYACd4jARQlDO0u45NmA",
    "businessStatus": "OPERATIONAL",
    "phone": "099 616 7795",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 14,
    "id": 1912
  },
  {
    "title": "Vip Card and Toys",
    "urlinform": "vip-card-and-toys",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJdbSWNblfHTERjML_ChWhyUA",
    "lat": 13.6693132,
    "lng": 100.6291279,
    "placeId": "ChIJdbSWNblfHTERjML_ChWhyUA",
    "businessStatus": "OPERATIONAL",
    "phone": "061 049 8980",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 166,
    "id": 1913
  },
  {
    "title": "Monchu Card Game",
    "urlinform": "monchu-card-game",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXSH7ODqf4jARbGlROeTgyUU",
    "lat": 13.7379219,
    "lng": 100.5604662,
    "placeId": "ChIJXSH7ODqf4jARbGlROeTgyUU",
    "businessStatus": "OPERATIONAL",
    "phone": "094 080 6037",
    "openingHours": [
      "Monday: 10:30 AM – 9:30 PM",
      "Tuesday: 10:30 AM – 9:30 PM",
      "Wednesday: 10:30 AM – 9:30 PM",
      "Thursday: 10:30 AM – 9:30 PM",
      "Friday: 10:30 AM – 9:30 PM",
      "Saturday: 10:30 AM – 9:30 PM",
      "Sunday: 10:30 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 109,
    "district": "Sukhumvit",
    "id": 1914
  },
  {
    "title": "The One Card Shop",
    "urlinform": "the-one-card-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ84IzTwCf4jARlYdO3jObQMI",
    "lat": 13.7604497,
    "lng": 100.5654995,
    "placeId": "ChIJ84IzTwCf4jARlYdO3jObQMI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 5,
    "id": 1915
  },
  {
    "title": "ActionCity @ Siam Square One",
    "urlinform": "actioncity-siam-square-one",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://actioncity.co.th/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnxAwCgif4jARAq5TgFuacPQ",
    "lat": 13.7450471,
    "lng": 100.5337162,
    "placeId": "ChIJnxAwCgif4jARAq5TgFuacPQ",
    "businessStatus": "OPERATIONAL",
    "phone": "065 508 4624",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 311,
    "district": "Siam",
    "id": 1916
  },
  {
    "title": "Delta TCG Store",
    "urlinform": "delta-tcg-store",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.d9bkk.com/tcg",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJS16iNwCf4jARvnz0snszRxE",
    "lat": 13.7150996,
    "lng": 100.5943977,
    "placeId": "ChIJS16iNwCf4jARvnz0snszRxE",
    "businessStatus": "OPERATIONAL",
    "phone": "094 465 9959",
    "openingHours": [
      "Monday: 2:00 PM – 12:00 AM",
      "Tuesday: 2:00 PM – 12:00 AM",
      "Wednesday: 2:00 PM – 12:00 AM",
      "Thursday: 2:00 PM – 12:00 AM",
      "Friday: 2:00 PM – 12:00 AM",
      "Saturday: 2:00 PM – 12:00 AM",
      "Sunday: 2:00 PM – 12:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 7,
    "id": 1917
  },
  {
    "title": "Shining Draw TCG",
    "urlinform": "shining-draw-tcg",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB4cMOACZ4jARRS-knVgY73s",
    "lat": 13.7070102,
    "lng": 100.4913528,
    "placeId": "ChIJB4cMOACZ4jARRS-knVgY73s",
    "businessStatus": "OPERATIONAL",
    "phone": "084 254 0392",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 1918
  },
  {
    "title": "Nova TCG Thailand (โนวา ทีซีจี ไทยแลนด์)",
    "urlinform": "nova-tcg-thailand-",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMUWNKgBjHTERfehWC8c5b4w",
    "lat": 13.8525134,
    "lng": 100.6298294,
    "placeId": "ChIJMUWNKgBjHTERfehWC8c5b4w",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 53,
    "id": 1919
  },
  {
    "title": "TOP TOY Bangkok Siam Center",
    "urlinform": "top-toy-bangkok-siam-center",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://page.line.me/toptoythailand",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJbdRTgvif4jARUIhCbuIfV5k",
    "lat": 13.7461804,
    "lng": 100.5320957,
    "placeId": "ChIJbdRTgvif4jARUIhCbuIfV5k",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 72,
    "district": "Siam",
    "id": 1920
  },
  {
    "title": "The CardZ Shop",
    "urlinform": "the-cardz-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.thecardzshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNT0D5XCf4jAR7iIQkdH-d9o",
    "lat": 13.7567949,
    "lng": 100.564766,
    "placeId": "ChIJNT0D5XCf4jAR7iIQkdH-d9o",
    "businessStatus": "OPERATIONAL",
    "phone": "065 456 4749",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 7:00 PM",
      "Wednesday: 10:00 AM – 7:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 7:00 PM",
      "Saturday: 10:00 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4,
    "userRatingsTotal": 1,
    "id": 1921
  },
  {
    "title": "The CardZ Shop Cabinet",
    "urlinform": "the-cardz-shop-cabinet",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.thecardz.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiTfJQqif4jARVoQY3sojXXo",
    "lat": 13.7470766,
    "lng": 100.5394642,
    "placeId": "ChIJiTfJQqif4jARVoQY3sojXXo",
    "businessStatus": "OPERATIONAL",
    "phone": "065 456 4749",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "district": "Siam",
    "id": 1922
  },
  {
    "title": "BeTrend Siam Paragon Fl.3",
    "urlinform": "betrend-siam-paragon-fl3",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.montblanc.com/en-th",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNzPZyBKf4jARg-YSel3vRW4",
    "lat": 13.7462504,
    "lng": 100.534734,
    "placeId": "ChIJNzPZyBKf4jARg-YSel3vRW4",
    "businessStatus": "OPERATIONAL",
    "phone": "02 690 1000",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 83,
    "district": "Siam",
    "id": 1923
  },
  {
    "title": "Q-ซัง Card",
    "urlinform": "q-card",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/QsanCard/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHwqYUaiX4jARXGIFh2MuCe8",
    "lat": 13.7136925,
    "lng": 100.4277504,
    "placeId": "ChIJHwqYUaiX4jARXGIFh2MuCe8",
    "businessStatus": "OPERATIONAL",
    "phone": "093 645 6915",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 6,
    "id": 1924
  },
  {
    "title": "gachabox",
    "urlinform": "gachabox",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.facebook.com/gachabox",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXcV7EdKe4jARWe1aNtNrLPc",
    "lat": 13.7449838,
    "lng": 100.534267,
    "placeId": "ChIJXcV7EdKe4jARWe1aNtNrLPc",
    "businessStatus": "OPERATIONAL",
    "phone": "081 440 8888",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 28,
    "district": "Siam",
    "id": 1925
  },
  {
    "title": "Grape",
    "urlinform": "grape",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJqWUVEdKe4jARFucWfOjIQ_g",
    "lat": 13.7450056,
    "lng": 100.5334435,
    "placeId": "ChIJqWUVEdKe4jARFucWfOjIQ_g",
    "businessStatus": "OPERATIONAL",
    "phone": "02 252 3119",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 39,
    "district": "Siam",
    "id": 1926
  },
  {
    "title": "CardsVIP SHOP",
    "urlinform": "cardsvip-shop",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJleRUSWmd4jARLQr7owvDEz4",
    "lat": 13.8016974,
    "lng": 100.5507434,
    "placeId": "ChIJleRUSWmd4jARLQr7owvDEz4",
    "businessStatus": "OPERATIONAL",
    "phone": "090 909 6198",
    "openingHours": [
      "Monday: 10:00 AM – 7:30 PM",
      "Tuesday: 10:00 AM – 7:30 PM",
      "Wednesday: 10:00 AM – 7:30 PM",
      "Thursday: 10:00 AM – 7:30 PM",
      "Friday: 10:00 AM – 8:30 PM",
      "Saturday: 10:00 AM – 8:30 PM",
      "Sunday: 10:00 AM – 8:30 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "district": "Chatuchak",
    "id": 1927
  },
  {
    "title": "Robinson Sukhumvit",
    "urlinform": "robinson-sukhumvit",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.central.co.th/th/store",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJq1n-keOe4jAR9NeIU0Bt6Fk",
    "lat": 13.738152,
    "lng": 100.5592162,
    "placeId": "ChIJq1n-keOe4jAR9NeIU0Bt6Fk",
    "businessStatus": "OPERATIONAL",
    "phone": "02 651 1533",
    "openingHours": [
      "Monday: 10:30 AM – 10:00 PM",
      "Tuesday: 10:30 AM – 10:00 PM",
      "Wednesday: 10:30 AM – 10:00 PM",
      "Thursday: 10:30 AM – 10:00 PM",
      "Friday: 10:30 AM – 10:00 PM",
      "Saturday: 10:30 AM – 10:00 PM",
      "Sunday: 10:30 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 5702,
    "district": "Sukhumvit",
    "id": 1928
  },
  {
    "title": "CrossGuild (คลอสกิลด์)",
    "urlinform": "crossguild-",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJm9U10mqZ4jAR_VX_aZTQLxE",
    "lat": 13.745432,
    "lng": 100.5021836,
    "placeId": "ChIJm9U10mqZ4jAR_VX_aZTQLxE",
    "businessStatus": "OPERATIONAL",
    "phone": "062 424 1516",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 6:00 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 22,
    "district": "Mega Plaza Wang Burapa",
    "id": 1929
  },
  {
    "title": "Pull Club Bkk",
    "urlinform": "pull-club-bkk",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJq356NxaZ4jAROjobn21Jyx8",
    "lat": 13.745432,
    "lng": 100.5021836,
    "placeId": "ChIJq356NxaZ4jAROjobn21Jyx8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 6:00 PM",
      "Tuesday: 11:00 AM – 6:00 PM",
      "Wednesday: 11:00 AM – 6:00 PM",
      "Thursday: 11:00 AM – 6:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 9,
    "district": "Mega Plaza Wang Burapa",
    "id": 1930
  },
  {
    "title": "Pokehub",
    "urlinform": "pokehub",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://lin.ee/qfIYsUK",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJd45f6saZ4jARxCq0keERPOk",
    "lat": 13.745432,
    "lng": 100.5021836,
    "placeId": "ChIJd45f6saZ4jARxCq0keERPOk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 6:30 PM",
      "Tuesday: 10:00 AM – 6:30 PM",
      "Wednesday: 10:00 AM – 6:30 PM",
      "Thursday: 10:00 AM – 6:30 PM",
      "Friday: 10:00 AM – 6:30 PM",
      "Saturday: 10:00 AM – 6:30 PM",
      "Sunday: 10:00 AM – 6:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 123,
    "district": "Mega Plaza Wang Burapa",
    "id": 1931
  },
  {
    "title": "Devcard.TCG Chiang Mai",
    "urlinform": "devcardtcg-chiang-mai",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://app.ma-bid.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ4uje1Yl2jARrNf4XYj1JDg",
    "lat": 18.8417086,
    "lng": 99.02324899999999,
    "placeId": "ChIJZ4uje1Yl2jARrNf4XYj1JDg",
    "businessStatus": "OPERATIONAL",
    "phone": "093 624 2543",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 11:00 AM – 7:30 PM",
      "Wednesday: 11:00 AM – 7:30 PM",
      "Thursday: 11:00 AM – 7:30 PM",
      "Friday: 11:00 AM – 7:30 PM",
      "Saturday: 10:30 AM – 7:30 PM",
      "Sunday: 10:30 AM – 7:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 9,
    "id": 1932
  },
  {
    "title": "Card Gotcha! CNX",
    "urlinform": "card-gotcha-cnx",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/share/1DjfyTWDHC/?mibextid=wwXIfr",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMc6TWgA72jAR_aQVEb8kOc4",
    "lat": 18.789253,
    "lng": 98.9943174,
    "placeId": "ChIJMc6TWgA72jAR_aQVEb8kOc4",
    "businessStatus": "OPERATIONAL",
    "phone": "081 894 6368",
    "openingHours": [
      "Monday: 8:00 AM – 7:30 PM",
      "Tuesday: 8:00 AM – 7:30 PM",
      "Wednesday: 8:00 AM – 7:30 PM",
      "Thursday: 8:00 AM – 7:30 PM",
      "Friday: 8:00 AM – 7:30 PM",
      "Saturday: 8:00 AM – 8:00 PM",
      "Sunday: 8:00 AM – 7:30 PM"
    ],
    "rating": 3,
    "userRatingsTotal": 2,
    "district": "Night Bazaar",
    "id": 1933
  },
  {
    "title": "Nakamol One Nimman",
    "urlinform": "nakamol-one-nimman",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.nakamolthailand.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEclaogg72jARvR5l4NT5_zo",
    "lat": 18.7999102,
    "lng": 98.96778499999999,
    "placeId": "ChIJEclaogg72jARvR5l4NT5_zo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 61,
    "district": "Nimman",
    "id": 1934
  },
  {
    "title": "The wooden Factory",
    "urlinform": "the-wooden-factory",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB498SgA72jARZF214UnbAw4",
    "lat": 18.7883999,
    "lng": 98.9985071,
    "placeId": "ChIJB498SgA72jARZF214UnbAw4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 5,
    "userRatingsTotal": 1,
    "district": "Night Bazaar",
    "id": 1935
  },
  {
    "title": "Big C Market Pantip Chiang Mai",
    "urlinform": "big-c-market-pantip-chiang-mai",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.bigc.co.th/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3X0LhTE72jARH80_k5oNIj4",
    "lat": 18.781963,
    "lng": 98.999712,
    "placeId": "ChIJ3X0LhTE72jARH80_k5oNIj4",
    "businessStatus": "OPERATIONAL",
    "phone": "053 288 156",
    "openingHours": [
      "Monday: 9:00 AM – 12:00 AM",
      "Tuesday: 9:00 AM – 12:00 AM",
      "Wednesday: 9:00 AM – 12:00 AM",
      "Thursday: 9:00 AM – 12:00 AM",
      "Friday: 9:00 AM – 12:00 AM",
      "Saturday: 9:00 AM – 12:00 AM",
      "Sunday: 9:00 AM – 12:00 AM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 2341,
    "district": "Night Bazaar",
    "id": 1936
  },
  {
    "title": "The Pantip Lifestyle Hub",
    "urlinform": "the-pantip-lifestyle-hub",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/pantipchiangmai/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb5y8mKc62jARx_210KjVcMg",
    "lat": 18.7818592,
    "lng": 98.99981439999999,
    "placeId": "ChIJb5y8mKc62jARx_210KjVcMg",
    "businessStatus": "OPERATIONAL",
    "phone": "053 288 383",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 3079,
    "district": "Night Bazaar",
    "id": 1937
  },
  {
    "title": "TCG LAB CNX",
    "urlinform": "tcg-lab-cnx",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJQWPKOSg72jAREYUxzDqUBuU",
    "lat": 18.7944862,
    "lng": 98.9648438,
    "placeId": "ChIJQWPKOSg72jAREYUxzDqUBuU",
    "businessStatus": "OPERATIONAL",
    "phone": "064 446 9624",
    "openingHours": [
      "Monday: 1:00 PM – 12:00 AM",
      "Tuesday: 1:00 PM – 12:00 AM",
      "Wednesday: 1:00 PM – 12:00 AM",
      "Thursday: 1:00 PM – 12:00 AM",
      "Friday: 1:00 PM – 12:00 AM",
      "Saturday: 1:00 PM – 12:00 AM",
      "Sunday: 1:00 PM – 12:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 9,
    "district": "Nimman",
    "id": 1938
  },
  {
    "title": "KADOSHI",
    "urlinform": "kadoshi",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ8Tbk3i0Z2jER8dHp6duWsbk",
    "lat": 1.3006242,
    "lng": 103.8398658,
    "placeId": "ChIJ8Tbk3i0Z2jER8dHp6duWsbk",
    "businessStatus": "OPERATIONAL",
    "phone": "8722 2665",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 29,
    "district": "Plaza Singapura Dhoby Ghaut",
    "id": 1939
  },
  {
    "title": "Kingsroad Vault",
    "urlinform": "kingsroad-vault",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJu1-0cXgZ2jERWfRZTwpyoIw",
    "lat": 1.3037148,
    "lng": 103.8332642,
    "placeId": "ChIJu1-0cXgZ2jERWfRZTwpyoIw",
    "businessStatus": "OPERATIONAL",
    "phone": "6222 4205",
    "openingHours": [
      "Monday: 11:00 AM – 9:30 PM",
      "Tuesday: 11:00 AM – 9:30 PM",
      "Wednesday: 11:00 AM – 9:30 PM",
      "Thursday: 11:00 AM – 9:30 PM",
      "Friday: 11:00 AM – 9:30 PM",
      "Saturday: 11:00 AM – 9:30 PM",
      "Sunday: 11:00 AM – 9:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 15,
    "district": "Orchard",
    "id": 1940
  },
  {
    "title": "Cards Central",
    "urlinform": "cards-central",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.cardscentral.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN3Agk8EZ2jER_iHPtgvIsA0",
    "lat": 1.2828996,
    "lng": 103.8433786,
    "placeId": "ChIJN3Agk8EZ2jER_iHPtgvIsA0",
    "businessStatus": "OPERATIONAL",
    "phone": "8040 3056",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 856,
    "id": 1941
  },
  {
    "title": "Grey Ogre Games",
    "urlinform": "grey-ogre-games",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "http://www.greyogregames.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ23ArJA0Z2jER2p7BOyyTW5Y",
    "lat": 1.2817521,
    "lng": 103.8457289,
    "placeId": "ChIJ23ArJA0Z2jER2p7BOyyTW5Y",
    "businessStatus": "OPERATIONAL",
    "phone": "9106 1793",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 177,
    "id": 1942
  },
  {
    "title": "Hobika Card Shop",
    "urlinform": "hobika-card-shop",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ64Mc6IAZ2jERuvYeoyzV5Cs",
    "lat": 1.3020899,
    "lng": 103.8577814,
    "placeId": "ChIJ64Mc6IAZ2jERuvYeoyzV5Cs",
    "businessStatus": "OPERATIONAL",
    "phone": "8418 7525",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 33,
    "district": "Bugis",
    "id": 1943
  },
  {
    "title": "Game Academia (Singapore)",
    "urlinform": "game-academia-singapore",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS"
    ],
    "storeWebsite": "http://www.game-academia.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ__8vbY0Z2jERj76rm69oQKc",
    "lat": 1.2918776,
    "lng": 103.8500267,
    "placeId": "ChIJ__8vbY0Z2jERj76rm69oQKc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 3.9,
    "userRatingsTotal": 83,
    "id": 1944
  },
  {
    "title": "games n chips",
    "urlinform": "games-n-chips",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://gamesnchips.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR2LaxfYZ2jERHftYZuVH4Q4",
    "lat": 1.3019085,
    "lng": 103.8578808,
    "placeId": "ChIJR2LaxfYZ2jERHftYZuVH4Q4",
    "businessStatus": "OPERATIONAL",
    "phone": "9380 0196",
    "openingHours": [
      "Monday: 1:00 – 6:00 PM",
      "Tuesday: 1:00 – 6:00 PM",
      "Wednesday: 1:00 – 6:00 PM",
      "Thursday: 1:00 – 6:00 PM",
      "Friday: 1:00 – 6:00 PM",
      "Saturday: 1:00 – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 971,
    "district": "Bugis",
    "id": 1945
  },
  {
    "title": "Cards & Chatter",
    "urlinform": "cards-chatter",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://cardsandchatter.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJGYQD0e8Z2jER83BQAVNzwWg",
    "lat": 1.3016961,
    "lng": 103.8637289,
    "placeId": "ChIJGYQD0e8Z2jER83BQAVNzwWg",
    "businessStatus": "OPERATIONAL",
    "phone": "8138 8856",
    "openingHours": [
      "Monday: 3:00 – 7:30 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 1:00 – 2:30 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 12,
    "district": "Bugis",
    "id": 1946
  },
  {
    "title": "Play United",
    "urlinform": "play-united",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJgWc0EAAP2jERi_qZ35mo1tw",
    "lat": 1.33934,
    "lng": 103.7064331,
    "placeId": "ChIJgWc0EAAP2jERi_qZ35mo1tw",
    "businessStatus": "OPERATIONAL",
    "phone": "9082 5039",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 78,
    "id": 1947
  },
  {
    "title": "Chuarizards Crate TCG",
    "urlinform": "chuarizards-crate-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://t.me/chuarizardscrate",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmV_vaeEb2jER_c0BJD73g4g",
    "lat": 1.3218768,
    "lng": 103.7698766,
    "placeId": "ChIJmV_vaeEb2jER_c0BJD73g4g",
    "businessStatus": "OPERATIONAL",
    "phone": "9792 8198",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 PM – 2:00 AM",
      "Wednesday: 4:00 PM – 2:00 AM",
      "Thursday: 4:00 PM – 2:00 AM",
      "Friday: 4:00 PM – 2:00 AM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 98,
    "id": 1948
  },
  {
    "title": "Kardelax TCG",
    "urlinform": "kardelax-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.tiktok.com/@kardelax",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsTVDz8UR2jERdg0-Yb8yXIY",
    "lat": 1.328296,
    "lng": 103.7531194,
    "placeId": "ChIJsTVDz8UR2jERdg0-Yb8yXIY",
    "businessStatus": "OPERATIONAL",
    "phone": "9740 0142",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 41,
    "district": "Jurong",
    "id": 1949
  },
  {
    "title": "Sawadeekard",
    "urlinform": "sawadeekard",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.sawadeekard.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLwDWI3sR2jERA1aXSQmEFqY",
    "lat": 1.342561,
    "lng": 103.7530311,
    "placeId": "ChIJLwDWI3sR2jERA1aXSQmEFqY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 2:00 PM",
      "Tuesday: 11:00 AM – 2:00 PM",
      "Wednesday: 11:00 AM – 2:00 PM",
      "Thursday: 11:00 AM – 2:00 PM",
      "Friday: 11:00 AM – 2:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 70,
    "id": 1950
  },
  {
    "title": "Plus & Minus TCG",
    "urlinform": "plus-minus-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ23Uc1CcR2jERXNwesa4pt_o",
    "lat": 1.3441874,
    "lng": 103.7311334,
    "placeId": "ChIJ23Uc1CcR2jERXNwesa4pt_o",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 5:00 – 11:00 PM",
      "Thursday: 5:00 – 11:00 PM",
      "Friday: 5:00 – 11:00 PM",
      "Saturday: 3:00 – 11:00 PM",
      "Sunday: 3:00 – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 10,
    "id": 1951
  },
  {
    "title": "Terastal Labs",
    "urlinform": "terastal-labs",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://terastallabs.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJIyv_HgAb2jERzCSaFEuwCe0",
    "lat": 1.2875231,
    "lng": 103.8031063,
    "placeId": "ChIJIyv_HgAb2jERzCSaFEuwCe0",
    "businessStatus": "OPERATIONAL",
    "phone": "8044 3011",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 8:30 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 343,
    "id": 1952
  },
  {
    "title": "Pokémon Center SINGAPORE",
    "urlinform": "pokmon-center-singapore",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://sg.portal-pokemon.com/shop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcURkgp492jERS4A65dNZuts",
    "lat": 1.3603912,
    "lng": 103.989642,
    "placeId": "ChIJcURkgp492jERS4A65dNZuts",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 1034,
    "id": 1953
  },
  {
    "title": "POP MART Plaza Singapura",
    "urlinform": "pop-mart-plaza-singapura",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://popmart.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiapmGMIZ2jERk1r42bGLauQ",
    "lat": 1.299379,
    "lng": 103.8453225,
    "placeId": "ChIJiapmGMIZ2jERk1r42bGLauQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 238,
    "district": "Plaza Singapura Dhoby Ghaut",
    "id": 1954
  },
  {
    "title": "MUJI Plaza Singapura",
    "urlinform": "muji-plaza-singapura",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.muji.com/sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJn6_Xer0Z2jERi72GbcnERlk",
    "lat": 1.3003739,
    "lng": 103.8450773,
    "placeId": "ChIJn6_Xer0Z2jERi72GbcnERlk",
    "businessStatus": "OPERATIONAL",
    "phone": "6264 5838",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 941,
    "district": "Plaza Singapura Dhoby Ghaut",
    "id": 1955
  },
  {
    "title": "Momo Gadgets",
    "urlinform": "momo-gadgets",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://momogadgets.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJX54u7SUX2jERkjmCvKz5JEA",
    "lat": 1.3149989,
    "lng": 103.8935606,
    "placeId": "ChIJX54u7SUX2jERkjmCvKz5JEA",
    "businessStatus": "OPERATIONAL",
    "phone": "9683 8053",
    "openingHours": [
      "Monday: 10:30 AM – 7:00 PM",
      "Tuesday: 10:30 AM – 7:00 PM",
      "Wednesday: 10:30 AM – 7:00 PM",
      "Thursday: 10:30 AM – 7:00 PM",
      "Friday: 10:30 AM – 7:00 PM",
      "Saturday: 10:30 AM – 3:00 PM",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 169,
    "id": 1956
  },
  {
    "title": "Spotlight Plaza Singapura",
    "urlinform": "spotlight-plaza-singapura",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.spotlightstores.com/en-sg/store/central-singapore/plaza-singapura/s059?utm_source=google&utm_medium=organic&utm_campaign=Google%20My%20Business&utm_content=Spotlight%20Plaza%20Singapura",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJoyM62ZcZ2jERPyX_4YCMBRI",
    "lat": 1.3007111,
    "lng": 103.844904,
    "placeId": "ChIJoyM62ZcZ2jERPyX_4YCMBRI",
    "businessStatus": "OPERATIONAL",
    "phone": "6733 9808",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 2148,
    "district": "Plaza Singapura Dhoby Ghaut",
    "id": 1957
  },
  {
    "title": "House of Kpop (Plaza Singapura)",
    "urlinform": "house-of-kpop-plaza-singapura",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://houseofkpop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJF1DMOM4Z2jERKnkiDm-6Sw8",
    "lat": 1.3007111,
    "lng": 103.844904,
    "placeId": "ChIJF1DMOM4Z2jERKnkiDm-6Sw8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 117,
    "district": "Plaza Singapura Dhoby Ghaut",
    "id": 1958
  },
  {
    "title": "DAISO & THREEPPY @ Plaza Singapura",
    "urlinform": "daiso-threeppy-plaza-singapura",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://daisosingapore.com.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWw4PRBMZ2jER3Tbehb4Jiyo",
    "lat": 1.3005679,
    "lng": 103.8452317,
    "placeId": "ChIJWw4PRBMZ2jER3Tbehb4Jiyo",
    "businessStatus": "OPERATIONAL",
    "phone": "6884 9210",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 1168,
    "district": "Plaza Singapura Dhoby Ghaut",
    "id": 1959
  },
  {
    "title": "Humble TCG",
    "urlinform": "humble-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://humbletcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJB_IHlwUX2jERyYSHzUZM30k",
    "lat": 1.3324692,
    "lng": 103.8903276,
    "placeId": "ChIJB_IHlwUX2jERyYSHzUZM30k",
    "businessStatus": "OPERATIONAL",
    "phone": "9756 1802",
    "openingHours": [
      "Monday: 2:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 8:30 PM",
      "Friday: 12:00 – 8:30 PM",
      "Saturday: 12:00 – 8:30 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 106,
    "id": 1960
  },
  {
    "title": "TCG Junction",
    "urlinform": "tcg-junction",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3XYLbMYX2jERlKY-ssPAY4w",
    "lat": 1.337857,
    "lng": 103.856446,
    "placeId": "ChIJ3XYLbMYX2jERlKY-ssPAY4w",
    "businessStatus": "OPERATIONAL",
    "phone": "9231 4449",
    "openingHours": [
      "Monday: 1:00 PM – 12:00 AM",
      "Tuesday: 1:00 PM – 12:00 AM",
      "Wednesday: 1:00 PM – 12:00 AM",
      "Thursday: 1:00 PM – 12:00 AM",
      "Friday: 1:00 PM – 12:00 AM",
      "Saturday: 1:00 PM – 12:00 AM",
      "Sunday: 1:00 PM – 12:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 34,
    "id": 1961
  },
  {
    "title": "Huattoru",
    "urlinform": "huattoru",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.huattoru.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJs_5zLUAX2jER5Fn7iy3m2vw",
    "lat": 1.33258,
    "lng": 103.889892,
    "placeId": "ChIJs_5zLUAX2jER5Fn7iy3m2vw",
    "businessStatus": "OPERATIONAL",
    "phone": "8899 2869",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 2:00 – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 77,
    "district": "Tai Seng MacPherson",
    "id": 1962
  },
  {
    "title": "Play Inn (Toa Payoh)",
    "urlinform": "play-inn-toa-payoh",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://playinn.sg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtYIbe1YX2jERKsd4n8KJcNw",
    "lat": 1.3345854,
    "lng": 103.8491097,
    "placeId": "ChIJtYIbe1YX2jERKsd4n8KJcNw",
    "businessStatus": "OPERATIONAL",
    "phone": "8020 5811",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 176,
    "id": 1963
  },
  {
    "title": "Kodomo Collectibles",
    "urlinform": "kodomo-collectibles",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJwSweKWIX2jERL5vXzXzc4X0",
    "lat": 1.3337035,
    "lng": 103.879825,
    "placeId": "ChIJwSweKWIX2jERL5vXzXzc4X0",
    "businessStatus": "OPERATIONAL",
    "phone": "8953 5200",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 PM – 12:00 AM",
      "Saturday: 12:00 PM – 12:00 AM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 6,
    "district": "Tai Seng MacPherson",
    "id": 1964
  },
  {
    "title": "Team Card Game",
    "urlinform": "team-card-game",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.teamcardgame.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJUQ8uEqAZ2jERxH-7CKtC7sA",
    "lat": 1.3253541,
    "lng": 103.8915161,
    "placeId": "ChIJUQ8uEqAZ2jERxH-7CKtC7sA",
    "businessStatus": "OPERATIONAL",
    "phone": "9340 6130",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "district": "Tai Seng MacPherson",
    "id": 1965
  },
  {
    "title": "TCG Malaysia - Berjaya Times Square",
    "urlinform": "tcg-malaysia-berjaya-times-square",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "One Piece",
      "Pokémon",
      "Union Arena",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://tcgmalaysia.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPSw3G7Q3zDERB8gJ-HODeTw",
    "lat": 3.1421984,
    "lng": 101.7105512,
    "placeId": "ChIJPSw3G7Q3zDERB8gJ-HODeTw",
    "businessStatus": "OPERATIONAL",
    "phone": "016-700 6200",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 22,
    "district": "Bukit Bintang",
    "id": 1966
  },
  {
    "title": "TCA x ZBL Lot 10 (Team Connect Asia)",
    "urlinform": "tca-x-zbl-lot-10-team-connect-asia",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linktr.ee/teamconnectasia",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJkwjL_NE3zDER-YUvcN7g58M",
    "lat": 3.1463746,
    "lng": 101.711872,
    "placeId": "ChIJkwjL_NE3zDER-YUvcN7g58M",
    "businessStatus": "OPERATIONAL",
    "phone": "012-369 6235",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.8,
    "userRatingsTotal": 21,
    "district": "Bukit Bintang",
    "id": 1967
  },
  {
    "title": "A Piece Of Malaysia",
    "urlinform": "a-piece-of-malaysia",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.apieceofmalaysia.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx2PxKo1JzDER1v4oEGcrfRk",
    "lat": 3.1476896,
    "lng": 101.6941133,
    "placeId": "ChIJx2PxKo1JzDER1v4oEGcrfRk",
    "businessStatus": "OPERATIONAL",
    "phone": "017-312 3266",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 165,
    "district": "Petaling Street",
    "id": 1968
  },
  {
    "title": "Galaxy Cards",
    "urlinform": "galaxy-cards",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJidmcUWxJzDERT2S-PFUxG6I",
    "lat": 3.133685,
    "lng": 101.6914718,
    "placeId": "ChIJidmcUWxJzDERT2S-PFUxG6I",
    "businessStatus": "OPERATIONAL",
    "phone": "013-302 5657",
    "openingHours": [
      "Monday: 9:00 AM – 8:00 PM",
      "Tuesday: 9:00 AM – 8:00 PM",
      "Wednesday: 9:00 AM – 8:00 PM",
      "Thursday: 9:00 AM – 8:00 PM",
      "Friday: 9:00 AM – 8:00 PM",
      "Saturday: 9:00 AM – 8:00 PM",
      "Sunday: 9:00 AM – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 144,
    "id": 1969
  },
  {
    "title": "STP Hobbies Collectibles Sdn. Bhd.",
    "urlinform": "stp-hobbies-collectibles-sdn-bhd",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-6ktGABLzDER0yJ06QvPMsw",
    "lat": 3.0905646,
    "lng": 101.690531,
    "placeId": "ChIJ-6ktGABLzDER0yJ06QvPMsw",
    "businessStatus": "OPERATIONAL",
    "phone": "014-637 0288",
    "openingHours": [
      "Monday: 1:00 – 11:00 PM",
      "Tuesday: 1:00 – 11:00 PM",
      "Wednesday: Closed",
      "Thursday: 1:00 – 11:00 PM",
      "Friday: 1:00 PM – 12:00 AM",
      "Saturday: 12:30 PM – 12:00 AM",
      "Sunday: 12:30 – 11:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 57,
    "id": 1970
  },
  {
    "title": "RS Trading Card Game",
    "urlinform": "rs-trading-card-game",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJhcsiqyFJzDERCC4WB0uHJuA",
    "lat": 3.1181728,
    "lng": 101.6783391,
    "placeId": "ChIJhcsiqyFJzDERCC4WB0uHJuA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "district": "Mid Valley",
    "id": 1971
  },
  {
    "title": "MeTime Art @ Mid Valley Megamall - Painting by Numbers",
    "urlinform": "metime-art-mid-valley-megamall-painting-by-numbers",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.metimeart.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJrc3k-4lJzDERFCm1B34jHvs",
    "lat": 3.1167164,
    "lng": 101.6769911,
    "placeId": "ChIJrc3k-4lJzDERFCm1B34jHvs",
    "businessStatus": "OPERATIONAL",
    "phone": "011-5891 0852",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 40,
    "district": "Mid Valley",
    "id": 1972
  },
  {
    "title": "Elaira Pop Mid Valley",
    "urlinform": "elaira-pop-mid-valley",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://elairapiercing.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJo18q8JVJzDERrBzmAD5mzbA",
    "lat": 3.1186389,
    "lng": 101.6775463,
    "placeId": "ChIJo18q8JVJzDERrBzmAD5mzbA",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:30 AM – 9:30 PM",
      "Tuesday: 10:30 AM – 9:30 PM",
      "Wednesday: 10:30 AM – 9:30 PM",
      "Thursday: 10:30 AM – 9:30 PM",
      "Friday: 10:30 AM – 9:30 PM",
      "Saturday: 10:30 AM – 9:30 PM",
      "Sunday: 10:30 AM – 9:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 51,
    "district": "Mid Valley",
    "id": 1973
  },
  {
    "title": "POPULAR Bookstore | Mid Valley Megamall",
    "urlinform": "popular-bookstore-mid-valley-megamall",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.popular.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJh20rwypJzDERrBx0dDPtdyA",
    "lat": 3.1163024,
    "lng": 101.676653,
    "placeId": "ChIJh20rwypJzDERrBx0dDPtdyA",
    "businessStatus": "OPERATIONAL",
    "phone": "03-2201 3249",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 1491,
    "district": "Mid Valley",
    "id": 1974
  },
  {
    "title": "ÆON | Mid Valley Megamall",
    "urlinform": "on-mid-valley-megamall",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJK2GIro5JzDERVVBLFSfaPFI",
    "lat": 3.1183981,
    "lng": 101.6778945,
    "placeId": "ChIJK2GIro5JzDERVVBLFSfaPFI",
    "businessStatus": "OPERATIONAL",
    "phone": "1-300-80-2366",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:30 PM",
      "Saturday: 9:00 AM – 10:30 PM",
      "Sunday: 9:00 AM – 10:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 4667,
    "district": "Mid Valley",
    "id": 1975
  },
  {
    "title": "CARD CREW HQ COLLECTIBLES & HOBBIES",
    "urlinform": "card-crew-hq-collectibles-hobbies",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvw9HVwBHzDERgCpmiNrf1tM",
    "lat": 3.1936038,
    "lng": 101.6250358,
    "placeId": "ChIJvw9HVwBHzDERgCpmiNrf1tM",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6261 4431",
    "openingHours": [
      "Monday: 12:00 – 5:00 PM, 7:30 PM – 12:00 AM",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 5:00 PM, 7:30 PM – 12:00 AM",
      "Thursday: 12:00 – 5:00 PM, 8:00 PM – 12:00 AM",
      "Friday: 12:00 – 5:00 PM, 7:30 PM – 12:00 AM",
      "Saturday: 12:00 – 5:00 PM, 7:30 PM – 12:00 AM",
      "Sunday: 12:00 – 5:00 PM, 7:30 PM – 12:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 66,
    "id": 1976
  },
  {
    "title": "异世界剧本杀与桌游馆 Isekai Game Houz",
    "urlinform": "-isekai-game-houz",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.isekaigamehouz.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiWN_Hk01zDERJIsU07BANx8",
    "lat": 3.0362404,
    "lng": 101.7655289,
    "placeId": "ChIJiWN_Hk01zDERJIsU07BANx8",
    "businessStatus": "OPERATIONAL",
    "phone": "019-915 5812",
    "openingHours": [
      "Monday: 12:00 PM – 12:00 AM",
      "Tuesday: 12:00 PM – 12:00 AM",
      "Wednesday: 12:00 PM – 12:00 AM",
      "Thursday: 12:00 PM – 12:00 AM",
      "Friday: 12:00 PM – 12:00 AM",
      "Saturday: 12:00 PM – 12:00 AM",
      "Sunday: 12:00 PM – 12:00 AM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 277,
    "id": 1977
  },
  {
    "title": "Gitcho Cards",
    "urlinform": "gitcho-cards",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61590768117136",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpwHPPuA3zDERtVFYwh__X3I",
    "lat": 3.1287543,
    "lng": 101.7143975,
    "placeId": "ChIJpwHPPuA3zDERtVFYwh__X3I",
    "businessStatus": "OPERATIONAL",
    "phone": "010-311 8168",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3,
    "id": 1978
  },
  {
    "title": "CeX",
    "urlinform": "cex",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://my.webuy.com/site/storeDetail/?branchId=25012",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJw_hwLTY5zDERY2eis9Bllpg",
    "lat": 3.2033851,
    "lng": 101.7211684,
    "placeId": "ChIJw_hwLTY5zDERY2eis9Bllpg",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 86,
    "id": 1979
  },
  {
    "title": "Masta Tan Retro World",
    "urlinform": "masta-tan-retro-world",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ57OJGvU5zDERkefjysIb2mo",
    "lat": 3.2071618,
    "lng": 101.718772,
    "placeId": "ChIJ57OJGvU5zDERkefjysIb2mo",
    "businessStatus": "OPERATIONAL",
    "phone": "017-367 8196",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 3:00 – 8:00 PM",
      "Sunday: 3:00 – 8:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 90,
    "id": 1980
  },
  {
    "title": "Cards Dojo (SS15)",
    "urlinform": "cards-dojo-ss15",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJVyd4UX9NzDERT0xK7yMH7Aw",
    "lat": 3.0764889,
    "lng": 101.5879405,
    "placeId": "ChIJVyd4UX9NzDERT0xK7yMH7Aw",
    "businessStatus": "OPERATIONAL",
    "phone": "012-515 8248",
    "openingHours": [
      "Monday: 12:00 PM – 12:00 AM",
      "Tuesday: 12:00 PM – 12:00 AM",
      "Wednesday: 12:00 PM – 12:00 AM",
      "Thursday: 12:00 PM – 12:00 AM",
      "Friday: 12:00 PM – 12:00 AM",
      "Saturday: 12:00 PM – 12:00 AM",
      "Sunday: 12:00 PM – 12:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 103,
    "id": 1981
  },
  {
    "title": "Ninety Three Custom Stickers",
    "urlinform": "ninety-three-custom-stickers",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.mycustomstickers.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRQ_i0YpHzDERdj93KM1aBpk",
    "lat": 3.1955422,
    "lng": 101.7062512,
    "placeId": "ChIJRQ_i0YpHzDERdj93KM1aBpk",
    "businessStatus": "OPERATIONAL",
    "phone": "012-953 0313",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 267,
    "id": 1982
  },
  {
    "title": "COURTS Setapak",
    "urlinform": "courts-setapak",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.courts.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJA8c8FhE4zDERKq2flA5A8Eg",
    "lat": 3.1908181,
    "lng": 101.7069934,
    "placeId": "ChIJA8c8FhE4zDERKq2flA5A8Eg",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3000 8998",
    "openingHours": [
      "Monday: 10:00 AM – 9:00 PM",
      "Tuesday: 10:00 AM – 9:00 PM",
      "Wednesday: 10:00 AM – 9:00 PM",
      "Thursday: 10:00 AM – 9:00 PM",
      "Friday: 10:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 3095,
    "id": 1983
  },
  {
    "title": "Unifi Store Setapak",
    "urlinform": "unifi-store-setapak",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://unifi.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCbP2cwJIzDERTMOF2J1hc-I",
    "lat": 3.1837695,
    "lng": 101.706418,
    "placeId": "ChIJCbP2cwJIzDERTMOF2J1hc-I",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 5:30 PM",
      "Tuesday: 9:00 AM – 5:30 PM",
      "Wednesday: 9:00 AM – 5:30 PM",
      "Thursday: 9:00 AM – 5:30 PM",
      "Friday: 9:00 AM – 5:30 PM",
      "Saturday: 9:00 AM – 5:30 PM",
      "Sunday: Closed"
    ],
    "rating": 3.8,
    "userRatingsTotal": 1366,
    "id": 1984
  },
  {
    "title": "BSGIFTS Sdn Bhd",
    "urlinform": "bsgifts-sdn-bhd",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://bsgifts.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOV9Coh1JzDERH77Z5RUEts8",
    "lat": 3.1956394,
    "lng": 101.705895,
    "placeId": "ChIJOV9Coh1JzDERH77Z5RUEts8",
    "businessStatus": "OPERATIONAL",
    "phone": "03-4821 4703",
    "openingHours": [
      "Monday: 8:30 AM – 5:30 PM",
      "Tuesday: 8:30 AM – 5:30 PM",
      "Wednesday: 8:30 AM – 5:30 PM",
      "Thursday: 8:30 AM – 5:30 PM",
      "Friday: 8:30 AM – 5:30 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 4.9,
    "userRatingsTotal": 493,
    "id": 1985
  },
  {
    "title": "HONOR GURNEY PLAZA PENANG",
    "urlinform": "honor-gurney-plaza-penang",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJy8IzCgbDSjARlLaq8NDHTsI",
    "lat": 5.438064499999999,
    "lng": 100.3100295,
    "placeId": "ChIJy8IzCgbDSjARlLaq8NDHTsI",
    "businessStatus": "OPERATIONAL",
    "phone": "017-714 9018",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 713,
    "district": "Gurney",
    "id": 1986
  },
  {
    "title": "TMT Megastore Gurney Plaza",
    "urlinform": "tmt-megastore-gurney-plaza",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://tmt.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE11ghQPDSjARMJ9fKMv_814",
    "lat": 5.4369451,
    "lng": 100.3095338,
    "placeId": "ChIJE11ghQPDSjARMJ9fKMv_814",
    "businessStatus": "OPERATIONAL",
    "phone": "04-604 6906",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 554,
    "district": "Gurney",
    "id": 1987
  },
  {
    "title": "Jaya Grocer @ Gurney Paragon",
    "urlinform": "jaya-grocer-gurney-paragon",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.jayagrocer.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC_-7X3fDSjARYaxtnKOVIdU",
    "lat": 5.4356179,
    "lng": 100.3111075,
    "placeId": "ChIJC_-7X3fDSjARYaxtnKOVIdU",
    "businessStatus": "OPERATIONAL",
    "phone": "04-291 9883",
    "openingHours": [
      "Monday: 8:30 AM – 10:00 PM",
      "Tuesday: 8:30 AM – 10:00 PM",
      "Wednesday: 8:30 AM – 10:00 PM",
      "Thursday: 8:30 AM – 10:00 PM",
      "Friday: 8:30 AM – 10:00 PM",
      "Saturday: 8:30 AM – 10:00 PM",
      "Sunday: 8:30 AM – 10:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 1363,
    "district": "Gurney",
    "id": 1988
  },
  {
    "title": "cams card heaven",
    "urlinform": "cams-card-heaven",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvaSNKwDBSjARTV063chDWfY",
    "lat": 5.326186499999999,
    "lng": 100.2820294,
    "placeId": "ChIJvaSNKwDBSjARTV063chDWfY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 7:00 PM",
      "Tuesday: 12:00 – 7:00 PM, 8:00 – 11:00 PM",
      "Wednesday: 12:00 – 7:00 PM",
      "Thursday: 12:00 – 7:00 PM, 8:00 – 11:00 PM",
      "Friday: 12:00 – 7:00 PM, 8:00 – 11:00 PM",
      "Saturday: 12:00 – 7:00 PM, 8:00 – 11:00 PM",
      "Sunday: 12:00 – 7:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 1989
  },
  {
    "title": "Critical Hit TCG",
    "urlinform": "critical-hit-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/criticalhits_tcg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJL1jpx8PBSjAR47yOLpnDauU",
    "lat": 5.333203,
    "lng": 100.291647,
    "placeId": "ChIJL1jpx8PBSjAR47yOLpnDauU",
    "businessStatus": "OPERATIONAL",
    "phone": "016-406 8763",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 3,
    "id": 1990
  },
  {
    "title": "JJ TCG GAME AND HOBBY SHOP",
    "urlinform": "jj-tcg-game-and-hobby-shop",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://www.jjtcg.com.my/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJC2BXgyBLzDERg6aFMitaGaw",
    "lat": 3.0437039,
    "lng": 101.6210992,
    "placeId": "ChIJC2BXgyBLzDERg6aFMitaGaw",
    "businessStatus": "OPERATIONAL",
    "phone": "011-2682 9728",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 5:00 PM – 1:00 AM",
      "Wednesday: 5:00 PM – 1:00 AM",
      "Thursday: 5:00 PM – 1:00 AM",
      "Friday: 5:00 PM – 1:00 AM",
      "Saturday: 1:00 – 10:00 PM",
      "Sunday: 1:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 29,
    "id": 1991
  },
  {
    "title": "Regalia TCG",
    "urlinform": "regalia-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJicEV2Y1LzDER5R-g31TxEy4",
    "lat": 3.1053108,
    "lng": 101.6352325,
    "placeId": "ChIJicEV2Y1LzDER5R-g31TxEy4",
    "businessStatus": "OPERATIONAL",
    "phone": "011-6166 3690",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 11:00 AM – 4:00 PM",
      "Thursday: 11:00 AM – 4:00 PM",
      "Friday: 11:00 AM – 4:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 2:30 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 8,
    "id": 1992
  },
  {
    "title": "Collectors Qube",
    "urlinform": "collectors-qube",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://www.colqube.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJr2RZRatLzDERY_i0M6vSS-I",
    "lat": 3.1048378,
    "lng": 101.6471245,
    "placeId": "ChIJr2RZRatLzDERY_i0M6vSS-I",
    "businessStatus": "OPERATIONAL",
    "phone": "016-359 3581",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 12:00 – 6:45 PM",
      "Wednesday: 12:00 – 6:45 PM",
      "Thursday: 12:00 – 6:45 PM",
      "Friday: 12:00 – 6:45 PM",
      "Saturday: 11:00 AM – 6:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 264,
    "id": 1993
  },
  {
    "title": "Mewmon Kota damansara",
    "urlinform": "mewmon-kota-damansara",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/share/16GvaNGd9v/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJNbEl7c1PzDER1GQxX677_Rc",
    "lat": 3.153347,
    "lng": 101.591929,
    "placeId": "ChIJNbEl7c1PzDER1GQxX677_Rc",
    "businessStatus": "OPERATIONAL",
    "phone": "016-708 6768",
    "openingHours": [
      "Monday: 2:00 – 10:00 PM",
      "Tuesday: 2:00 – 10:00 PM",
      "Wednesday: 2:00 – 10:00 PM",
      "Thursday: 2:00 – 10:00 PM",
      "Friday: 2:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 14,
    "id": 1994
  },
  {
    "title": "GUILDHALL Card Game & Board Game",
    "urlinform": "guildhall-card-game-board-game",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJc8tCq2NNzDERdOFrf3dnWRs",
    "lat": 3.111065,
    "lng": 101.5843486,
    "placeId": "ChIJc8tCq2NNzDERdOFrf3dnWRs",
    "businessStatus": "OPERATIONAL",
    "phone": "012-535 3703",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: Closed",
      "Friday: Closed",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 11,
    "id": 1995
  },
  {
    "title": "90s Card SDN BHD",
    "urlinform": "90s-card-sdn-bhd",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://90scard.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiyYuA5Fz2jEREY2dcOZEg7Q",
    "lat": 1.516239,
    "lng": 103.6851193,
    "placeId": "ChIJiyYuA5Fz2jEREY2dcOZEg7Q",
    "businessStatus": "OPERATIONAL",
    "phone": "012-973 8890",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 96,
    "id": 1996
  },
  {
    "title": "Good Games Chatswood",
    "urlinform": "good-games-chatswood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.goodgames.com.au/venue/good-games-chatswood",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxSinIdSoEmsR7qtKDHyrye4",
    "lat": -33.7957755,
    "lng": 151.1827585,
    "placeId": "ChIJxSinIdSoEmsR7qtKDHyrye4",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9410 0837",
    "openingHours": [
      "Monday: 11:00 AM – 10:00 PM",
      "Tuesday: 11:00 AM – 10:00 PM",
      "Wednesday: 11:00 AM – 10:00 PM",
      "Thursday: 11:00 AM – 10:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 7:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 230,
    "district": "Chatswood",
    "id": 1997
  },
  {
    "title": "Anime Kaika",
    "urlinform": "anime-kaika",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Digimon",
      "Dragon Ball",
      "Flesh and Blood",
      "Gundam",
      "MTG",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.kaika.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJOZzVpz2uEmsR9bfF1Zn4VSU",
    "lat": -33.8719182,
    "lng": 151.2057436,
    "placeId": "ChIJOZzVpz2uEmsR9bfF1Zn4VSU",
    "businessStatus": "OPERATIONAL",
    "phone": "0468 736 082",
    "openingHours": [
      "Monday: 11:00 AM – 7:00 PM",
      "Tuesday: 11:00 AM – 7:00 PM",
      "Wednesday: 11:00 AM – 7:00 PM",
      "Thursday: 11:00 AM – 7:00 PM",
      "Friday: 11:00 AM – 7:00 PM",
      "Saturday: 11:00 AM – 7:00 PM",
      "Sunday: 11:00 AM – 6:00 PM"
    ],
    "rating": 4.4,
    "userRatingsTotal": 390,
    "district": "CBD",
    "id": 1998
  },
  {
    "title": "Trading cards",
    "urlinform": "trading-cards",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://wa.link/-undermaintainance",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ4duhx1ivEmsRm4NxDSV2RtY",
    "lat": -33.8722462,
    "lng": 151.2052128,
    "placeId": "ChIJ4duhx1ivEmsRm4NxDSV2RtY",
    "businessStatus": "OPERATIONAL",
    "phone": "0480 852 097",
    "openingHours": [
      "Monday: 9:00 AM – 5:00 PM",
      "Tuesday: 9:00 AM – 5:00 PM",
      "Wednesday: 9:00 AM – 5:00 PM",
      "Thursday: 9:00 AM – 5:00 PM",
      "Friday: 9:00 AM – 5:00 PM",
      "Saturday: 9:00 AM – 5:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "district": "CBD",
    "id": 1999
  },
  {
    "title": "Zing Pop Culture Sydney",
    "urlinform": "zing-pop-culture-sydney",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://zingpopculture.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJxd-pBz-uEmsRvSutc-utcqw",
    "lat": -33.8703924,
    "lng": 151.2072443,
    "placeId": "ChIJxd-pBz-uEmsRvSutc-utcqw",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9223 7285",
    "openingHours": [
      "Monday: 9:30 AM – 7:00 PM",
      "Tuesday: 9:30 AM – 7:00 PM",
      "Wednesday: 9:30 AM – 7:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 7:00 PM",
      "Saturday: 9:30 AM – 7:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 56,
    "district": "CBD",
    "id": 2000
  },
  {
    "title": "Brandon’s Collectables",
    "urlinform": "brandons-collectables",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://brandonsbreaks.square.site/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDw5YLpOjEmsRZfylzvccPzw",
    "lat": -33.8172503,
    "lng": 150.9992653,
    "placeId": "ChIJDw5YLpOjEmsRZfylzvccPzw",
    "businessStatus": "OPERATIONAL",
    "phone": "0451 183 534",
    "openingHours": [
      "Monday: 12:30 – 7:30 PM",
      "Tuesday: 12:30 – 7:30 PM",
      "Wednesday: 3:00 – 7:30 PM",
      "Thursday: 2:00 – 9:30 PM",
      "Friday: 12:30 – 7:30 PM",
      "Saturday: 12:30 – 6:00 PM",
      "Sunday: 1:00 – 5:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 22,
    "district": "Parramatta",
    "id": 2001
  },
  {
    "title": "Lion's Den Collectibles Castle Towers",
    "urlinform": "lions-den-collectibles-castle-towers",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.lionsdencollectibles.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJm81GzTChEmsRJyHfXU06RPk",
    "lat": -33.7306087,
    "lng": 151.0057363,
    "placeId": "ChIJm81GzTChEmsRJyHfXU06RPk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 9:00 AM – 7:00 PM",
      "Wednesday: 9:00 AM – 7:00 PM",
      "Thursday: 9:00 AM – 9:00 PM",
      "Friday: 9:00 AM – 7:00 PM",
      "Saturday: 9:00 AM – 7:00 PM",
      "Sunday: 9:00 AM – 7:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 49,
    "id": 2002
  },
  {
    "title": "Makers TCG",
    "urlinform": "makers-tcg",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJdZD_KcavEmsRi16LaPDEW0A",
    "lat": -33.8783813,
    "lng": 151.2053362,
    "placeId": "ChIJdZD_KcavEmsRi16LaPDEW0A",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 9:00 AM – 7:00 PM",
      "Tuesday: 3:00 – 7:00 PM",
      "Wednesday: 3:00 – 7:00 PM",
      "Thursday: 3:00 – 7:00 PM",
      "Friday: 3:00 – 7:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "district": "Haymarket",
    "id": 2003
  },
  {
    "title": "Sydney Souvenirs",
    "urlinform": "sydney-souvenirs",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://sydneysouvenirs.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCaIdTTivEmsRceZeEapwwZM",
    "lat": -33.8799402,
    "lng": 151.2035539,
    "placeId": "ChIJCaIdTTivEmsRceZeEapwwZM",
    "businessStatus": "OPERATIONAL",
    "phone": "0405 171 420",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 9:00 AM – 6:00 PM",
      "Thursday: 9:00 AM – 6:00 PM",
      "Friday: 9:00 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 9:00 AM – 6:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1018,
    "district": "Haymarket",
    "id": 2004
  },
  {
    "title": "Card Care",
    "urlinform": "card-care",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Dragon Ball",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.cardcare.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJnxcx2ma7EmsRKU5pP4kcPuQ",
    "lat": -33.8745339,
    "lng": 151.1040049,
    "placeId": "ChIJnxcx2ma7EmsRKU5pP4kcPuQ",
    "businessStatus": "OPERATIONAL",
    "phone": "1300 065 163",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 47,
    "district": "Burwood",
    "id": 2005
  },
  {
    "title": "EB Games / ZiNG Pop Culture - Burwood",
    "urlinform": "eb-games-zing-pop-culture-burwood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.ebgames.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJuePVMMW6EmsRn4yi2NWtr6k",
    "lat": -33.8748951,
    "lng": 151.1072575,
    "placeId": "ChIJuePVMMW6EmsRn4yi2NWtr6k",
    "businessStatus": "OPERATIONAL",
    "phone": "(02) 9745 6777",
    "openingHours": [
      "Monday: 9:30 AM – 6:00 PM",
      "Tuesday: 9:30 AM – 6:00 PM",
      "Wednesday: 9:30 AM – 6:00 PM",
      "Thursday: 9:30 AM – 9:00 PM",
      "Friday: 9:30 AM – 6:00 PM",
      "Saturday: 9:00 AM – 6:00 PM",
      "Sunday: 10:00 AM – 6:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 569,
    "district": "Burwood",
    "id": 2006
  },
  {
    "title": "Leo Games Narellan",
    "urlinform": "leo-games-narellan",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "Dragon Ball",
      "MTG",
      "One Piece",
      "Pokémon",
      "Union Arena",
      "WS"
    ],
    "storeWebsite": "https://www.leogames.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJTTQDh2zxEmsRMpeRz6YMqUk",
    "lat": -34.0422967,
    "lng": 150.7357906,
    "placeId": "ChIJTTQDh2zxEmsRMpeRz6YMqUk",
    "businessStatus": "CLOSED_TEMPORARILY",
    "phone": "",
    "openingHours": [],
    "rating": 4.5,
    "userRatingsTotal": 69,
    "id": 2007
  },
  {
    "title": "Westfield Gift Card Burwood",
    "urlinform": "westfield-gift-card-burwood",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.westfieldgiftcards.com.au/Online/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJzQ9mi5C7EmsR8GO70z3-9wM",
    "lat": -33.8740044,
    "lng": 151.1045062,
    "placeId": "ChIJzQ9mi5C7EmsR8GO70z3-9wM",
    "businessStatus": "OPERATIONAL",
    "phone": "1300 790 292",
    "openingHours": [
      "Monday: 9:00 AM – 5:00 PM",
      "Tuesday: 9:00 AM – 5:00 PM",
      "Wednesday: 9:00 AM – 5:00 PM",
      "Thursday: 9:00 AM – 5:00 PM",
      "Friday: 9:00 AM – 5:00 PM",
      "Saturday: Closed",
      "Sunday: Closed"
    ],
    "rating": 1,
    "userRatingsTotal": 1,
    "district": "Burwood",
    "id": 2008
  },
  {
    "title": "トレカ満満 秋葉原店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJpUJ36I6NGGARlT-3cL0pZIs",
    "lat": 35.6981581,
    "lng": 139.7708442,
    "placeId": "ChIJpUJ36I6NGGARlT-3cL0pZIs",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 6:00 PM",
      "Tuesday: 12:00 – 6:00 PM",
      "Wednesday: 12:00 – 6:00 PM",
      "Thursday: 12:00 – 6:00 PM",
      "Friday: 12:00 – 6:00 PM",
      "Saturday: 12:00 – 6:00 PM",
      "Sunday: 12:00 – 6:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 7,
    "district": "Akihabara",
    "id": 2009
  },
  {
    "title": "トレカステラー 秋葉原 Trading card shop",
    "urlinform": "-trading-card-shop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://linktr.ee/Toreca_Stellar",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJt2atAauNGGARySw29APUKXQ",
    "lat": 35.7024331,
    "lng": 139.7714721,
    "placeId": "ChIJt2atAauNGGARySw29APUKXQ",
    "businessStatus": "OPERATIONAL",
    "phone": "03-3525-7233",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 32,
    "district": "Akihabara",
    "id": 2010
  },
  {
    "title": "トレカ専門店 極 新宿店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/KIWAMI__GROUP",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJse6v3CqNGGARE_lSa7SrjNM",
    "lat": 35.6885733,
    "lng": 139.6983249,
    "placeId": "ChIJse6v3CqNGGARE_lSa7SrjNM",
    "businessStatus": "OPERATIONAL",
    "phone": "050-5264-6113",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 118,
    "district": "Shinjuku",
    "id": 2011
  },
  {
    "title": "Pokémon Card Station Mega Tokyo",
    "urlinform": "pokmon-card-station-mega-tokyo",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.pokemon-card.com/info/2000/20000101_001097.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5wtGuSmNGGARITNx8nFSH48",
    "lat": 35.7291754,
    "lng": 139.7187667,
    "placeId": "ChIJ5wtGuSmNGGARITNx8nFSH48",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5927-9290",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 28,
    "district": "Ikebukuro",
    "id": 2012
  },
  {
    "title": "TRADING CARD GAME BOXES VENDING MACHINE — BRAVE HARAJUKU (TCG SHOP)",
    "urlinform": "trading-card-game-boxes-vending-machine-brave-harajuku-tcg-shop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://brave-tcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJN9vs7pGNGGAR61ljl0NWL0k",
    "lat": 35.6683935,
    "lng": 139.7047092,
    "placeId": "ChIJN9vs7pGNGGAR61ljl0NWL0k",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6386-5357",
    "openingHours": [
      "Monday: 11:00 AM – 11:00 PM",
      "Tuesday: 11:00 AM – 11:00 PM",
      "Wednesday: 11:00 AM – 11:00 PM",
      "Thursday: 11:00 AM – 11:00 PM",
      "Friday: 11:00 AM – 11:00 PM",
      "Saturday: 11:00 AM – 11:00 PM",
      "Sunday: 11:00 AM – 11:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 199,
    "id": 2013
  },
  {
    "title": "Pokemon Japan TCG wholesale",
    "urlinform": "pokemon-japan-tcg-wholesale",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJHwRZGMONGGARpVjHYO8SH60",
    "lat": 35.6639193,
    "lng": 139.6980258,
    "placeId": "ChIJHwRZGMONGGARpVjHYO8SH60",
    "businessStatus": "OPERATIONAL",
    "phone": "080-2684-4428",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "district": "Shibuya",
    "id": 2014
  },
  {
    "title": "AKIHABARA TCG SUPPLY",
    "urlinform": "akihabara-tcg-supply",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://wa.me/817094707705",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfbK60AmLGGARnWAZZEmVz94",
    "lat": 35.6597574,
    "lng": 139.7009471,
    "placeId": "ChIJfbK60AmLGGARnWAZZEmVz94",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "district": "Shibuya",
    "id": 2015
  },
  {
    "title": "トレカショップラム渋谷店",
    "urlinform": "store-2023",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Lorcana",
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://www.lamb-pokemon.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJsS9M-0GNGGARVoQCuLn6E-w",
    "lat": 35.6625095,
    "lng": 139.6987497,
    "placeId": "ChIJsS9M-0GNGGARVoQCuLn6E-w",
    "businessStatus": "OPERATIONAL",
    "phone": "03-4400-4487",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 5,
    "district": "Shibuya",
    "id": 2016
  },
  {
    "title": "Sheiseko TCG Supply",
    "urlinform": "sheiseko-tcg-supply",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://pokehubsupplies.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ3xGGZomNGGAR-5TIOYnGy5w",
    "lat": 35.7296555,
    "lng": 139.7129416,
    "placeId": "ChIJ3xGGZomNGGAR-5TIOYnGy5w",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9372-2222",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "district": "Ikebukuro",
    "id": 2017
  },
  {
    "title": "TRADING CARD GAME BOXES VENDING MACHINE — BRAVE UENO OKACHIMACHI (TCG SHOP)",
    "urlinform": "trading-card-game-boxes-vending-machine-brave-ueno-okachimachi-tcg-shop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://brave-tcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjzZFbeWPGGARMOYNB2GuWXc",
    "lat": 35.7089088,
    "lng": 139.7743853,
    "placeId": "ChIJjzZFbeWPGGARMOYNB2GuWXc",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6386-5357",
    "openingHours": [
      "Monday: 10:00 AM – 11:30 PM",
      "Tuesday: 10:00 AM – 11:30 PM",
      "Wednesday: 10:00 AM – 11:30 PM",
      "Thursday: 10:00 AM – 11:30 PM",
      "Friday: 10:00 AM – 11:30 PM",
      "Saturday: 10:00 AM – 11:30 PM",
      "Sunday: 10:00 AM – 11:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 49,
    "id": 2018
  },
  {
    "title": "TRADING CARD GAME BOXES VENDING MACHINE — BRAVE BAKUROCHO (TCG SHOP)",
    "urlinform": "trading-card-game-boxes-vending-machine-brave-bakurocho-tcg-shop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://brave-tcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJEbk2Mq2PGGAR-yJYfEYB3LI",
    "lat": 35.6944345,
    "lng": 139.7827023,
    "placeId": "ChIJEbk2Mq2PGGAR-yJYfEYB3LI",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6386-5357",
    "openingHours": [
      "Monday: 9:30 AM – 6:30 PM",
      "Tuesday: 9:30 AM – 6:30 PM",
      "Wednesday: 9:30 AM – 6:30 PM",
      "Thursday: 9:30 AM – 6:30 PM",
      "Friday: 9:30 AM – 6:30 PM",
      "Saturday: 9:30 AM – 6:30 PM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 22,
    "district": "Nakasu",
    "id": 2019
  },
  {
    "title": "トレカバンク",
    "urlinform": "store-2031",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.torecabank.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJcS_GqJSNGGAR7gGJ5s6cW1E",
    "lat": 35.7023957,
    "lng": 139.7713991,
    "placeId": "ChIJcS_GqJSNGGAR7gGJ5s6cW1E",
    "businessStatus": "OPERATIONAL",
    "phone": "050-1725-4874",
    "openingHours": [
      "Monday: 11:00 AM – 5:00 PM",
      "Tuesday: 11:00 AM – 5:00 PM",
      "Wednesday: 11:00 AM – 5:00 PM",
      "Thursday: 11:00 AM – 5:00 PM",
      "Friday: 11:00 AM – 5:00 PM",
      "Saturday: 11:00 AM – 5:00 PM",
      "Sunday: 11:00 AM – 5:00 PM"
    ],
    "rating": 4.3,
    "userRatingsTotal": 131,
    "district": "Akihabara",
    "id": 2020
  },
  {
    "title": "エルドラード 遊戯王・デュエマ館",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://x.com/eldorado_card",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfyzywM2NGGARvi51G0FE_Dc",
    "lat": 35.7017683,
    "lng": 139.7713481,
    "placeId": "ChIJfyzywM2NGGARvi51G0FE_Dc",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 1:00 – 8:00 PM",
      "Sunday: 1:00 – 8:00 PM"
    ],
    "rating": 3.7,
    "userRatingsTotal": 102,
    "district": "Akihabara",
    "id": 2021
  },
  {
    "title": "カードショップ 遊亜王",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://www.yuaoh.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJx3FW5YuPGGARjtoj3aBZNJE",
    "lat": 35.7003631,
    "lng": 139.7758029,
    "placeId": "ChIJx3FW5YuPGGARjtoj3aBZNJE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: Closed",
      "Wednesday: Closed",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 12,
    "district": "Akihabara",
    "id": 2022
  },
  {
    "title": "デッキラボ ぽい トレカ専門店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJU6PuSACPGGARZaJJKbcUlPI",
    "lat": 35.7211701,
    "lng": 139.7904156,
    "placeId": "ChIJU6PuSACPGGARZaJJKbcUlPI",
    "businessStatus": "OPERATIONAL",
    "phone": "080-2241-8914",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 2023
  },
  {
    "title": "コーギーアール本店(トレーディングカードショップ) Corgi Earl Main Store (Trading Card Shop)",
    "urlinform": "-corgi-earl-main-store-trading-card-shop",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.corgi-r-holdings.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPaaafWXFGGARBGGyU5EGYEc",
    "lat": 35.9185943,
    "lng": 139.6084609,
    "placeId": "ChIJPaaafWXFGGARBGGyU5EGYEc",
    "businessStatus": "OPERATIONAL",
    "phone": "048-400-3124",
    "openingHours": [
      "Monday: 1:00 – 10:30 PM",
      "Tuesday: 1:00 – 10:30 PM",
      "Wednesday: 1:00 – 10:30 PM",
      "Thursday: 1:00 – 10:30 PM",
      "Friday: 1:00 – 10:30 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 110,
    "id": 2024
  },
  {
    "title": "トレカキングダム 秋葉原店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Dragon Ball",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://shop.japan-toreca.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJFze4RACPGGARhWlJoO7TM7Y",
    "lat": 35.6994776,
    "lng": 139.7747064,
    "placeId": "ChIJFze4RACPGGARhWlJoO7TM7Y",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 2.6,
    "userRatingsTotal": 31,
    "district": "Akihabara",
    "id": 2025
  },
  {
    "title": "Full Comp",
    "urlinform": "full-comp",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "MTG",
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://inspire-jp.net/fc-hachioji/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJDQi06XceGWARvmczK7QNAMQ",
    "lat": 35.65705579999999,
    "lng": 139.3379447,
    "placeId": "ChIJDQi06XceGWARvmczK7QNAMQ",
    "businessStatus": "OPERATIONAL",
    "phone": "042-649-2663",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 11:00 AM – 9:00 PM",
      "Sunday: 11:00 AM – 9:00 PM"
    ],
    "rating": 2.8,
    "userRatingsTotal": 95,
    "id": 2026
  },
  {
    "title": "【ポケモンカード専門店】CARDIQUE （カーディーク）",
    "urlinform": "cardique-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://x.com/cardique_pokeca",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJk8EQLdFXGGARY6QW2ZD59GA",
    "lat": 35.4697349,
    "lng": 139.4603436,
    "placeId": "ChIJk8EQLdFXGGARY6QW2ZD59GA",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9092-7323",
    "openingHours": [
      "Monday: 3:00 – 8:00 PM",
      "Tuesday: 3:00 – 8:00 PM",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 3:00 – 8:00 PM",
      "Sunday: 3:00 – 8:00 PM"
    ],
    "rating": 4.2,
    "userRatingsTotal": 17,
    "id": 2027
  },
  {
    "title": "トレカのバンコク",
    "urlinform": "store-2047",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/torekanobankoku",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAQAAAGeNGGARbpYUnKSiEbg",
    "lat": 35.7015071,
    "lng": 139.7718406,
    "placeId": "ChIJAQAAAGeNGGARbpYUnKSiEbg",
    "businessStatus": "OPERATIONAL",
    "phone": "03-6903-1927",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 23,
    "district": "Akihabara",
    "id": 2028
  },
  {
    "title": "カードショップmagi秋葉原店",
    "urlinform": "magi",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Gundam",
      "Lorcana",
      "MTG",
      "One Piece",
      "Pokémon",
      "WS",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://cardshopmagi.com/shop/magi-akiba/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJj3o-SqmNGGARGge3JuYWP_g",
    "lat": 35.7010594,
    "lng": 139.7712722,
    "placeId": "ChIJj3o-SqmNGGARGge3JuYWP_g",
    "businessStatus": "OPERATIONAL",
    "phone": "03-5930-2200",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 2:00 – 8:00 PM",
      "Sunday: 2:00 – 8:00 PM"
    ],
    "rating": 2.1,
    "userRatingsTotal": 208,
    "district": "Akihabara",
    "id": 2029
  },
  {
    "title": "【ドンドン！】カードショップ ドン！ドン！",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "Pokémon",
      "Union Arena"
    ],
    "storeWebsite": "https://www.dondoncard-shop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb17x6piNGGARpxnVETY3vAQ",
    "lat": 35.7004837,
    "lng": 139.7720596,
    "placeId": "ChIJb17x6piNGGARpxnVETY3vAQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 34,
    "district": "Akihabara",
    "id": 2030
  },
  {
    "title": "ニンニン 秋葉原店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "One Piece",
      "Pokémon",
      "Yu-Gi-Oh!"
    ],
    "storeWebsite": "https://nin-nin-pokeka.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJMzAqN26NGGAR_Z-u_sm1Ltg",
    "lat": 35.7028461,
    "lng": 139.7707163,
    "placeId": "ChIJMzAqN26NGGAR_Z-u_sm1Ltg",
    "businessStatus": "OPERATIONAL",
    "phone": "03-4363-7710",
    "openingHours": [
      "Monday: 1:00 – 8:00 PM",
      "Tuesday: 1:00 – 8:00 PM",
      "Wednesday: 1:00 – 8:00 PM",
      "Thursday: 1:00 – 8:00 PM",
      "Friday: 1:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 98,
    "district": "Akihabara",
    "id": 2031
  },
  {
    "title": "トレカドリーム ららぽーと横浜店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ-ZFU225ZGGARP8hb6cmM6OE",
    "lat": 35.5166432,
    "lng": 139.5678497,
    "placeId": "ChIJ-ZFU225ZGGARP8hb6cmM6OE",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 8:00 PM",
      "Tuesday: 10:00 AM – 8:00 PM",
      "Wednesday: 10:00 AM – 8:00 PM",
      "Thursday: 10:00 AM – 8:00 PM",
      "Friday: 10:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 5,
    "id": 2032
  },
  {
    "title": "MINT 横浜ビブレ店 スポーツカード&カードゲーム",
    "urlinform": "mint-",
    "nation": "Japan",
    "prefecture": "Tokyo",
    "tags": [
      "MTG"
    ],
    "storeWebsite": "http://mint-web.jp/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCbJsIV5dGGARd-ZQjn0kP8A",
    "lat": 35.4648674,
    "lng": 139.6182749,
    "placeId": "ChIJCbJsIV5dGGARd-ZQjn0kP8A",
    "businessStatus": "OPERATIONAL",
    "phone": "045-620-7680",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 4.5,
    "userRatingsTotal": 11,
    "district": "Yokohama",
    "id": 2033
  },
  {
    "title": "magi大阪なんば駅前店",
    "urlinform": "magi",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/magi_namba_st",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYaD0eQPnAGARbxbJM2IccGI",
    "lat": 34.6632908,
    "lng": 135.5043961,
    "placeId": "ChIJYaD0eQPnAGARbxbJM2IccGI",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 7:30 PM",
      "Tuesday: 1:00 – 7:30 PM",
      "Wednesday: 1:00 – 7:30 PM",
      "Thursday: 1:00 – 7:30 PM",
      "Friday: 1:00 – 7:30 PM",
      "Saturday: 1:00 – 7:30 PM",
      "Sunday: 1:00 – 7:30 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 15,
    "district": "Namba",
    "id": 2034
  },
  {
    "title": "カードショップあまくだり",
    "urlinform": "store-2061",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://twitter.com/Amakudari_cards",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ49lRaW7nAGARbSjFPwiz13w",
    "lat": 34.6623433,
    "lng": 135.5038889,
    "placeId": "ChIJ49lRaW7nAGARbSjFPwiz13w",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.8,
    "userRatingsTotal": 90,
    "district": "Namba",
    "id": 2035
  },
  {
    "title": "スタートレカ(天神橋店)",
    "urlinform": "store-2063",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/Stella_cards",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJZ1rxRwDnAGARdWQL7QmbODI",
    "lat": 34.7007081,
    "lng": 135.5118872,
    "placeId": "ChIJZ1rxRwDnAGARdWQL7QmbODI",
    "businessStatus": "OPERATIONAL",
    "phone": "070-9217-4687",
    "openingHours": [
      "Monday: 2:00 – 8:00 PM",
      "Tuesday: 2:00 – 8:00 PM",
      "Wednesday: 2:00 – 8:00 PM",
      "Thursday: 2:00 – 8:00 PM",
      "Friday: 2:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 29,
    "id": 2036
  },
  {
    "title": "GIRAFULL大阪日本橋 トレカ専門店",
    "urlinform": "girafull-",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/honmomodani_t?s=09",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJLUPSGwDnAGARN6yFx4GtkIw",
    "lat": 34.660383,
    "lng": 135.5052688,
    "placeId": "ChIJLUPSGwDnAGARN6yFx4GtkIw",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 7:00 PM"
    ],
    "rating": 3.2,
    "userRatingsTotal": 27,
    "district": "Namba",
    "id": 2037
  },
  {
    "title": "Dragon star Nippombashi-nigo",
    "urlinform": "dragon-star-nippombashi-nigo",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://dorasuta.jp/?utm_source=GBP&utm_medium=GBP&utm_term=GBP&utm_content=GBP&utm_campaign=GBP006",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJi89ihGnnAGAR0xoiCBs5B9c",
    "lat": 34.6629412,
    "lng": 135.5043318,
    "placeId": "ChIJi89ihGnnAGAR0xoiCBs5B9c",
    "businessStatus": "OPERATIONAL",
    "phone": "06-6630-7115",
    "openingHours": [
      "Monday: 12:00 – 9:00 PM",
      "Tuesday: 12:00 – 9:00 PM",
      "Wednesday: 12:00 – 9:00 PM",
      "Thursday: 12:00 – 9:00 PM",
      "Friday: 12:00 – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.4,
    "userRatingsTotal": 273,
    "district": "Namba",
    "id": 2038
  },
  {
    "title": "トレカメゾン",
    "urlinform": "store-2069",
    "nation": "Japan",
    "prefecture": "Osaka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/torecamaison",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJAWnTzAHnAGAR8LTEXU6QI18",
    "lat": 34.6611302,
    "lng": 135.5050779,
    "placeId": "ChIJAWnTzAHnAGAR8LTEXU6QI18",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 2:00 – 6:30 PM",
      "Tuesday: Closed",
      "Wednesday: 2:00 – 6:30 PM",
      "Thursday: 2:00 – 6:30 PM",
      "Friday: 2:00 – 6:30 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 2,
    "district": "Namba",
    "id": 2039
  },
  {
    "title": "TCG Rendezvous",
    "urlinform": "tcg-rendezvous",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ7dnTtORxA2AR7GnK2XSoT4M",
    "lat": 35.1591501,
    "lng": 136.9029198,
    "placeId": "ChIJ7dnTtORxA2AR7GnK2XSoT4M",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: Closed",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 12:00 – 8:00 PM",
      "Sunday: 12:00 – 8:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 31,
    "district": "Osu",
    "id": 2040
  },
  {
    "title": "トレカリミテッド",
    "urlinform": "store-2073",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/torecalimited",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ6QElv_JxA2ARGm9fs001s5w",
    "lat": 35.1600619,
    "lng": 136.9053601,
    "placeId": "ChIJ6QElv_JxA2ARGm9fs001s5w",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 12:30 – 8:30 PM",
      "Tuesday: 12:30 – 8:30 PM",
      "Wednesday: 12:30 – 8:30 PM",
      "Thursday: 12:30 – 8:30 PM",
      "Friday: 12:30 – 8:30 PM",
      "Saturday: 11:30 AM – 8:30 PM",
      "Sunday: 11:30 AM – 8:30 PM"
    ],
    "rating": 2.4,
    "userRatingsTotal": 26,
    "district": "Osu",
    "id": 2041
  },
  {
    "title": "トレカダンジョンLite 大須店",
    "urlinform": "lite-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Battle Spirits",
      "Digimon",
      "Dragon Ball",
      "Gundam",
      "Lorcana",
      "One Piece",
      "Pokémon",
      "Shadowverse",
      "Union Arena",
      "Vanguard",
      "WS"
    ],
    "storeWebsite": "https://cardbox.online/shop/detail/5058/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJyzCU1QpxA2ARnnVd_QITCKQ",
    "lat": 35.1582744,
    "lng": 136.9039432,
    "placeId": "ChIJyzCU1QpxA2ARnnVd_QITCKQ",
    "businessStatus": "OPERATIONAL",
    "phone": "052-241-3039",
    "openingHours": [
      "Monday: 3:00 – 8:00 PM",
      "Tuesday: Closed",
      "Wednesday: 3:00 – 8:00 PM",
      "Thursday: 3:00 – 8:00 PM",
      "Friday: 3:00 – 8:00 PM",
      "Saturday: 3:00 – 8:00 PM",
      "Sunday: 3:00 – 8:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 55,
    "district": "Osu",
    "id": 2042
  },
  {
    "title": "トレカっち",
    "urlinform": "store-2077",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "Gundam",
      "Union Arena"
    ],
    "storeWebsite": "https://torecatchi.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJY8fbrm93A2ARJ_Tf4w6YWUI",
    "lat": 35.1678388,
    "lng": 136.879594,
    "placeId": "ChIJY8fbrm93A2ARJ_Tf4w6YWUI",
    "businessStatus": "OPERATIONAL",
    "phone": "052-433-2665",
    "openingHours": [
      "Monday: 3:00 – 9:00 PM",
      "Tuesday: 3:00 – 9:00 PM",
      "Wednesday: 3:00 – 9:00 PM",
      "Thursday: 3:00 – 9:00 PM",
      "Friday: 3:00 – 9:00 PM",
      "Saturday: 12:00 – 9:00 PM",
      "Sunday: 12:00 – 9:00 PM"
    ],
    "rating": 4.1,
    "userRatingsTotal": 13,
    "district": "Nagoya Station",
    "id": 2043
  },
  {
    "title": "トレカチャンピオン 大須店",
    "urlinform": "-",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.trading-card-champion.com/concept.html",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJiW0fhWZxA2ARr4mTv1XcrMs",
    "lat": 35.1604355,
    "lng": 136.9048553,
    "placeId": "ChIJiW0fhWZxA2ARr4mTv1XcrMs",
    "businessStatus": "OPERATIONAL",
    "phone": "052-253-8741",
    "openingHours": [
      "Monday: 11:00 AM – 9:00 PM",
      "Tuesday: 11:00 AM – 9:00 PM",
      "Wednesday: 11:00 AM – 9:00 PM",
      "Thursday: 11:00 AM – 9:00 PM",
      "Friday: 11:00 AM – 9:00 PM",
      "Saturday: 10:00 AM – 9:00 PM",
      "Sunday: 10:00 AM – 9:00 PM"
    ],
    "rating": 2.3,
    "userRatingsTotal": 64,
    "district": "Osu",
    "id": 2044
  },
  {
    "title": "トレカマスター大須万松寺通店",
    "urlinform": "store-2081",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/tcg_master_osu",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJl38ESwBxA2ARJZty9xwWR7c",
    "lat": 35.1591408,
    "lng": 136.9030175,
    "placeId": "ChIJl38ESwBxA2ARJZty9xwWR7c",
    "businessStatus": "OPERATIONAL",
    "phone": "052-228-8651",
    "openingHours": [
      "Monday: 11:00 AM – 8:00 PM",
      "Tuesday: 11:00 AM – 8:00 PM",
      "Wednesday: 11:00 AM – 8:00 PM",
      "Thursday: 11:00 AM – 8:00 PM",
      "Friday: 11:00 AM – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 3.3,
    "userRatingsTotal": 38,
    "district": "Osu",
    "id": 2045
  },
  {
    "title": "トレカ専門店リプレイ大須",
    "urlinform": "store-2083",
    "nation": "Japan",
    "prefecture": "Nagoya",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://replay052.base.shop/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJvbVdXgBxA2ARPj0Hlm__ZA8",
    "lat": 35.1603104,
    "lng": 136.9053149,
    "placeId": "ChIJvbVdXgBxA2ARPj0Hlm__ZA8",
    "businessStatus": "OPERATIONAL",
    "phone": "052-228-3665",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 11:00 AM – 8:00 PM",
      "Sunday: 11:00 AM – 8:00 PM"
    ],
    "rating": 1.7,
    "userRatingsTotal": 49,
    "district": "Osu",
    "id": 2046
  },
  {
    "title": "トレカマスター天神サザン通り店",
    "urlinform": "store-2085",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://x.com/TCG_Mst_Tenjin",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJYbm8NACRQTURatfIyCue0mY",
    "lat": 33.5895027,
    "lng": 130.3962996,
    "placeId": "ChIJYbm8NACRQTURatfIyCue0mY",
    "businessStatus": "OPERATIONAL",
    "phone": "092-753-3877",
    "openingHours": [
      "Monday: 12:00 – 8:00 PM",
      "Tuesday: 12:00 – 8:00 PM",
      "Wednesday: 12:00 – 8:00 PM",
      "Thursday: 12:00 – 8:00 PM",
      "Friday: 12:00 – 8:00 PM",
      "Saturday: 10:00 AM – 8:00 PM",
      "Sunday: 10:00 AM – 8:00 PM"
    ],
    "rating": 2.7,
    "userRatingsTotal": 3,
    "district": "Tenjin",
    "id": 2047
  },
  {
    "title": "トレカキャプテン福岡店",
    "urlinform": "store-2087",
    "nation": "Japan",
    "prefecture": "Fukuoka",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJg_D6uimRQTUR8vnxrInzILo",
    "lat": 33.5796779,
    "lng": 130.420045,
    "placeId": "ChIJg_D6uimRQTUR8vnxrInzILo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 7:00 PM",
      "Tuesday: Closed",
      "Wednesday: 1:00 – 7:00 PM",
      "Thursday: 1:00 – 7:00 PM",
      "Friday: 1:00 – 7:00 PM",
      "Saturday: 1:00 – 7:00 PM",
      "Sunday: 1:00 – 7:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 4,
    "id": 2048
  },
  {
    "title": "138Arena Trading Card Shop 謝斐道銅鑼灣店",
    "urlinform": "138arena-trading-card-shop-",
    "nation": "Hong Kong",
    "prefecture": "Hong Kong",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ_ckTQAABBDQR9xdXuHAL-rk",
    "lat": 22.2810672,
    "lng": 114.1839087,
    "placeId": "ChIJ_ckTQAABBDQR9xdXuHAL-rk",
    "businessStatus": "OPERATIONAL",
    "phone": "5588 4180",
    "openingHours": [
      "Monday: 12:30 AM – 11:00 PM",
      "Tuesday: 12:30 AM – 11:00 PM",
      "Wednesday: 12:30 AM – 11:00 PM",
      "Thursday: 12:30 AM – 11:00 PM",
      "Friday: 12:30 AM – 11:00 PM",
      "Saturday: 12:30 AM – 11:00 PM",
      "Sunday: 12:30 AM – 11:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 28,
    "district": "Causeway Bay",
    "id": 2049
  },
  {
    "title": "卡賣啦TCG卡牌遊戲專賣店 富邦銀行右邊電梯5F",
    "urlinform": "tcg-5f",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/profile.php?id=61584106091483",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ33DZ_0CpQjQRuTwjkAF7G4A",
    "lat": 25.0019066,
    "lng": 121.4969909,
    "placeId": "ChIJ33DZ_0CpQjQRuTwjkAF7G4A",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2242 1221",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 3:00 – 10:30 PM",
      "Wednesday: 3:00 – 10:30 PM",
      "Thursday: 3:00 – 10:30 PM",
      "Friday: 3:00 – 10:30 PM",
      "Saturday: 12:00 – 10:30 PM",
      "Sunday: 12:00 – 10:30 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 70,
    "id": 2050
  },
  {
    "title": "溫刀卡殿台北店 WENDAO CARDS｜TCG SHOP",
    "urlinform": "-wendao-cardstcg-shop",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/wendao.cards/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJtzGALYCrQjQRz4Jb1UEDRVg",
    "lat": 25.0380651,
    "lng": 121.5568205,
    "placeId": "ChIJtzGALYCrQjQRz4Jb1UEDRVg",
    "businessStatus": "OPERATIONAL",
    "phone": "02 2777 3737",
    "openingHours": [
      "Monday: 4:00 – 10:00 PM",
      "Tuesday: 4:00 – 10:00 PM",
      "Wednesday: 4:00 – 10:00 PM",
      "Thursday: 4:00 – 10:00 PM",
      "Friday: 4:00 – 10:00 PM",
      "Saturday: 2:00 – 10:00 PM",
      "Sunday: 2:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 90,
    "id": 2051
  },
  {
    "title": "Moist Taipei TCG 西門",
    "urlinform": "moist-taipei-tcg-",
    "nation": "Taiwan",
    "prefecture": "Taiwan",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJO08GmPSpQjQRTjZ9KLkYrkk",
    "lat": 25.045624,
    "lng": 121.506567,
    "placeId": "ChIJO08GmPSpQjQRTjZ9KLkYrkk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 AM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 50,
    "district": "Ximending",
    "id": 2052
  },
  {
    "title": "REDLABEL seongsu TCG store",
    "urlinform": "redlabel-seongsu-tcg-store",
    "nation": "South Korea",
    "prefecture": "Seoul",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJRa51irOlfDUR3_3DMfZKMt4",
    "lat": 37.5423527,
    "lng": 127.0553452,
    "placeId": "ChIJRa51irOlfDUR3_3DMfZKMt4",
    "businessStatus": "OPERATIONAL",
    "phone": "010-2709-5271",
    "openingHours": [
      "Monday: 12:00 – 10:00 PM",
      "Tuesday: 12:00 – 10:00 PM",
      "Wednesday: 12:00 – 10:00 PM",
      "Thursday: 12:00 – 10:00 PM",
      "Friday: 12:00 – 10:00 PM",
      "Saturday: 11:00 AM – 10:00 PM",
      "Sunday: 11:00 AM – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 1,
    "id": 2053
  },
  {
    "title": "Full house cardgame & Boardgame",
    "urlinform": "full-house-cardgame-boardgame",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.facebook.com/fullhousesummon/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJfRehwUeF4jARtuep9LQ0TE0",
    "lat": 13.8695074,
    "lng": 100.4674985,
    "placeId": "ChIJfRehwUeF4jARtuep9LQ0TE0",
    "businessStatus": "OPERATIONAL",
    "phone": "094 482 9472",
    "openingHours": [
      "Monday: 3:30 – 11:30 PM",
      "Tuesday: 3:30 – 11:30 PM",
      "Wednesday: 3:30 – 11:30 PM",
      "Thursday: 3:30 – 11:30 PM",
      "Friday: 3:30 – 11:30 PM",
      "Saturday: 12:30 – 11:30 PM",
      "Sunday: 12:30 – 11:30 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 86,
    "id": 2054
  },
  {
    "title": "PassAlways - Trading Card Game & Board Games",
    "urlinform": "passalways-trading-card-game-board-games",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJjX0fPx6d4jARHCT4wVn7Muk",
    "lat": 13.7961801,
    "lng": 100.5980013,
    "placeId": "ChIJjX0fPx6d4jARHCT4wVn7Muk",
    "businessStatus": "OPERATIONAL",
    "phone": "061 195 9055",
    "openingHours": [
      "Monday: 3:00 – 11:00 PM",
      "Tuesday: 3:00 – 11:00 PM",
      "Wednesday: Closed",
      "Thursday: 3:00 – 11:00 PM",
      "Friday: 3:00 – 11:00 PM",
      "Saturday: 3:00 – 11:00 PM",
      "Sunday: Closed"
    ],
    "rating": 5,
    "userRatingsTotal": 6,
    "id": 2055
  },
  {
    "title": "POKODEX Card game",
    "urlinform": "pokodex-card-game",
    "nation": "Tailand",
    "prefecture": "Bangkok",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJE1E86i5hHTER632VI5kqb2w",
    "lat": 13.7373139,
    "lng": 100.6208967,
    "placeId": "ChIJE1E86i5hHTER632VI5kqb2w",
    "businessStatus": "OPERATIONAL",
    "phone": "083 602 6662",
    "openingHours": [
      "Monday: 1:00 – 5:00 PM",
      "Tuesday: 1:00 PM – 1:00 AM",
      "Wednesday: 1:00 PM – 1:00 AM",
      "Thursday: 1:00 PM – 1:00 AM",
      "Friday: 2:00 PM – 4:00 AM",
      "Saturday: 2:00 PM – 4:00 AM",
      "Sunday: 2:00 PM – 2:00 AM"
    ],
    "rating": 5,
    "userRatingsTotal": 10,
    "id": 2056
  },
  {
    "title": "ร้าน Oil Card Game",
    "urlinform": "-oil-card-game",
    "nation": "Tailand",
    "prefecture": "Chiang Mai",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJT1PhNgkv2jARcYgICQeB_C4",
    "lat": 18.7657367,
    "lng": 99.0212569,
    "placeId": "ChIJT1PhNgkv2jARcYgICQeB_C4",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [],
    "rating": 0,
    "userRatingsTotal": 0,
    "id": 2057
  },
  {
    "title": "Gold Nugget Gang - Pokemon Card Shop - Seal Raw Slabs Comics Toys Collectible",
    "urlinform": "gold-nugget-gang-pokemon-card-shop-seal-raw-slabs-comics-toys-collectible",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "https://www.instagram.com/goldnuggetgang/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJR1v9K5AX2jERrQcFTzefPws",
    "lat": 1.3009453,
    "lng": 103.8493371,
    "placeId": "ChIJR1v9K5AX2jERrQcFTzefPws",
    "businessStatus": "OPERATIONAL",
    "phone": "8160 7672",
    "openingHours": [
      "Monday: 1:00 – 9:00 PM",
      "Tuesday: 1:00 – 9:00 PM",
      "Wednesday: 1:00 – 9:00 PM",
      "Thursday: 1:00 – 9:00 PM",
      "Friday: 1:00 – 9:00 PM",
      "Saturday: 1:00 – 9:00 PM",
      "Sunday: 1:00 – 9:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 304,
    "district": "Plaza Singapura Dhoby Ghaut",
    "id": 2058
  },
  {
    "title": "Mugiwara Store Singapore",
    "urlinform": "mugiwara-store-singapore",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJCw29drs92jERaWggvPHcQvY",
    "lat": 1.3603912,
    "lng": 103.989642,
    "placeId": "ChIJCw29drs92jERaWggvPHcQvY",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.5,
    "userRatingsTotal": 39,
    "id": 2059
  },
  {
    "title": "The Trading Card Shop",
    "urlinform": "the-trading-card-shop",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "http://www.thetradingcardshop.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJH4O6boEU2jERyYBKjuaDAEg",
    "lat": 1.4351696,
    "lng": 103.8048721,
    "placeId": "ChIJH4O6boEU2jERyYBKjuaDAEg",
    "businessStatus": "OPERATIONAL",
    "phone": "9138 5578",
    "openingHours": [
      "Monday: 8:30 PM – 12:00 AM",
      "Tuesday: 8:30 PM – 12:00 AM",
      "Wednesday: 8:30 PM – 12:00 AM",
      "Thursday: 8:30 PM – 12:00 AM",
      "Friday: 8:30 PM – 12:00 AM",
      "Saturday: 5:30 PM – 12:00 AM",
      "Sunday: Closed"
    ],
    "rating": 4.8,
    "userRatingsTotal": 25,
    "id": 2060
  },
  {
    "title": "1Collectibles - TCG",
    "urlinform": "1collectibles-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "Flesh and Blood",
      "Lorcana",
      "Pokémon"
    ],
    "storeWebsite": "https://www.1collectiblesfab.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJS7u35o4Z2jERb7R8zzlyd9A",
    "lat": 1.3143063,
    "lng": 103.8913348,
    "placeId": "ChIJS7u35o4Z2jERb7R8zzlyd9A",
    "businessStatus": "OPERATIONAL",
    "phone": "9022 2301",
    "openingHours": [
      "Monday: 3:00 – 10:00 PM",
      "Tuesday: 3:00 – 10:00 PM",
      "Wednesday: 3:00 – 10:00 PM",
      "Thursday: 3:00 – 10:00 PM",
      "Friday: 3:00 – 10:00 PM",
      "Saturday: 3:00 – 10:00 PM",
      "Sunday: 3:00 – 10:00 PM"
    ],
    "rating": 4.9,
    "userRatingsTotal": 41,
    "id": 2061
  },
  {
    "title": "The Forge TCG",
    "urlinform": "the-forge-tcg",
    "nation": "Singapore",
    "prefecture": "Singapore",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.instagram.com/theforge.tcg/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJKZ3bp_MZ2jERckNTZH4OJb8",
    "lat": 1.325096,
    "lng": 103.898223,
    "placeId": "ChIJKZ3bp_MZ2jERckNTZH4OJb8",
    "businessStatus": "OPERATIONAL",
    "phone": "8817 1067",
    "openingHours": [
      "Monday: 6:00 – 10:00 PM",
      "Tuesday: 6:00 – 10:00 PM",
      "Wednesday: 6:00 – 10:00 PM",
      "Thursday: 6:00 – 10:00 PM",
      "Friday: 6:00 – 10:00 PM",
      "Saturday: 12:00 – 10:00 PM",
      "Sunday: 12:00 – 10:00 PM"
    ],
    "rating": 4.6,
    "userRatingsTotal": 9,
    "id": 2062
  },
  {
    "title": "Pokémon Center Pop Up Store - Ombak KLCC",
    "urlinform": "pokmon-center-pop-up-store-ombak-klcc",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJmx5_GgA3zDERK02K08D-nGk",
    "lat": 3.1570116,
    "lng": 101.7177659,
    "placeId": "ChIJmx5_GgA3zDERK02K08D-nGk",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM"
    ],
    "rating": 3.1,
    "userRatingsTotal": 10,
    "district": "KLCC",
    "id": 2063
  },
  {
    "title": "One piece & Pokemon",
    "urlinform": "one-piece-pokemon",
    "nation": "Malaysia",
    "prefecture": "Kuala Lumpur",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJb8roZAA3zDERiBp4y5mN-fo",
    "lat": 3.1489607,
    "lng": 101.7134125,
    "placeId": "ChIJb8roZAA3zDERiBp4y5mN-fo",
    "businessStatus": "OPERATIONAL",
    "phone": "(505) 645-7233",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "district": "Bukit Bintang",
    "id": 2064
  },
  {
    "title": "RAREVAULT CARD SHOP",
    "urlinform": "rarevault-card-shop",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJ5-tTPcfBSjAReJLE7MypuwE",
    "lat": 5.3363872,
    "lng": 100.2982004,
    "placeId": "ChIJ5-tTPcfBSjAReJLE7MypuwE",
    "businessStatus": "OPERATIONAL",
    "phone": "016-251 6668",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: 2:00 – 9:00 PM",
      "Wednesday: 2:00 – 9:00 PM",
      "Thursday: 2:00 – 9:00 PM",
      "Friday: 2:00 – 9:00 PM",
      "Saturday: 2:00 – 9:00 PM",
      "Sunday: 2:00 – 9:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 16,
    "id": 2065
  },
  {
    "title": "Cards Consign TCG",
    "urlinform": "cards-consign-tcg",
    "nation": "Malaysia",
    "prefecture": "Malaysia",
    "tags": [
      "Pokémon"
    ],
    "storeWebsite": "http://www.cardsconsign.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJPYhXeQJNzDER0IVWrluSGZ4",
    "lat": 3.0458028,
    "lng": 101.5862684,
    "placeId": "ChIJPYhXeQJNzDER0IVWrluSGZ4",
    "businessStatus": "OPERATIONAL",
    "phone": "019-397 9213",
    "openingHours": [
      "Monday: Closed",
      "Tuesday: Closed",
      "Wednesday: 5:00 – 10:00 PM",
      "Thursday: 5:00 – 10:00 PM",
      "Friday: 5:00 – 10:00 PM",
      "Saturday: 5:00 – 10:00 PM",
      "Sunday: 5:00 – 10:00 PM"
    ],
    "rating": 5,
    "userRatingsTotal": 58,
    "id": 2066
  },
  {
    "title": "Pokebox TCG",
    "urlinform": "pokebox-tcg",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "One Piece",
      "Pokémon"
    ],
    "storeWebsite": "https://pokeboxtcg.com/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJW7fwPTqpEmsRiw75fWMhDl8",
    "lat": -33.7953414,
    "lng": 151.1858042,
    "placeId": "ChIJW7fwPTqpEmsRiw75fWMhDl8",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 1,
    "userRatingsTotal": 1,
    "district": "Chatswood",
    "id": 2067
  },
  {
    "title": "Poke Balls Tcg",
    "urlinform": "poke-balls-tcg",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJXcZiXKOvEmsRbp5vwOVhGwo",
    "lat": -33.8767793,
    "lng": 151.1982329,
    "placeId": "ChIJXcZiXKOvEmsRbp5vwOVhGwo",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours",
      "Sunday: Open 24 hours"
    ],
    "rating": 0,
    "userRatingsTotal": 0,
    "district": "Haymarket",
    "id": 2068
  },
  {
    "title": "Diggaz Trading Cards",
    "urlinform": "diggaz-trading-cards",
    "nation": "Australia",
    "prefecture": "Sydney",
    "tags": [
      "TCG"
    ],
    "storeWebsite": "https://www.diggaztradingcards.com.au/",
    "location": "https://www.google.com/maps/place/?q=place_id:ChIJWZq1nE6PEmsRw8wlrMRTfMQ",
    "lat": -33.7668664,
    "lng": 150.6811838,
    "placeId": "ChIJWZq1nE6PEmsRw8wlrMRTfMQ",
    "businessStatus": "OPERATIONAL",
    "phone": "",
    "openingHours": [
      "Monday: 10:00 AM – 7:00 PM",
      "Tuesday: 10:00 AM – 5:00 PM",
      "Wednesday: 10:00 AM – 5:00 PM",
      "Thursday: 10:00 AM – 7:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 4:00 PM",
      "Sunday: 11:00 AM – 3:00 PM"
    ],
    "rating": 4.7,
    "userRatingsTotal": 91,
    "id": 2069
  }
];
